import { Injectable } from "@angular/core";
import { BaseApiService } from '../../../shared/services/api';
import { Observable } from 'rxjs';

export const vendor_products = [
    {
        'vendor': '1 EDI Source, Inc.',
        'product': '1 EDI Source'
    },
    {
        'vendor': '1&1 IONOS, Inc.',
        'product': '1&1'
    },
    {
        'vendor': '1010data, Inc.',
        'product': '1010data'
    },
    {
        'vendor': '123FormBuilder S.R.L.',
        'product': '123FormBuilder'
    },
    {
        'vendor': '123Signup AMS, Inc.',
        'product': '123Signup'
    },
    {
        'vendor': '140 Proof, Inc.',
        'product': '140 Proof'
    },
    {
        'vendor': '15Five, Inc.',
        'product': '15Five'
    },
    {
        'vendor': '17hats',
        'product': '17hats'
    },
    {
        'vendor': '1C Company',
        'product': '1C Enterprise'
    },
    {
        'vendor': '1CRM Systems Corporation',
        'product': '1CRM'
    },
    {
        'vendor': 'Amelia US, LLC',
        'product': '1Desk'
    },
    {
        'vendor': 'AgileBits, Inc.',
        'product': '1Password'
    },
    {
        'vendor': 'Web.com Group, Inc.',
        'product': '1ShoppingCart'
    },
    {
        'vendor': '24liveblog, Inc.',
        'product': '24liveblog'
    },
    {
        'vendor': '2CSI SAS',
        'product': '2CSI SanoCOM'
    },
    {
        'vendor': '2Checkout.com, Inc.',
        'product': '2Checkout'
    },
    {
        'vendor': '3-Gis, LLC',
        'product': '3-GIS'
    },
    {
        'vendor': '33Across, Inc.',
        'product': '33Across'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': '360Facility'
    },
    {
        'vendor': '360Learning S.A.',
        'product': '360Learning LMS'
    },
    {
        'vendor': '360i, LLC',
        'product': '360i'
    },
    {
        'vendor': '3CLogic, Inc.',
        'product': '3CLogic'
    },
    {
        'vendor': '3CX',
        'product': '3CX'
    },
    {
        'vendor': '3D Systems, Inc.',
        'product': '3D Systems'
    },
    {
        'vendor': '3D-Coat',
        'product': '3D-Coat'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': '3DEXPERIENCE Platform'
    },
    {
        'vendor': 'Science-D-Visions GmbH',
        'product': '3DEqualizer'
    },
    {
        'vendor': 'DataSense Company',
        'product': '3DStats'
    },
    {
        'vendor': 'Shift4Shop, LLC',
        'product': '3Dcart'
    },
    {
        'vendor': 'Taarna Studios, Inc.',
        'product': '3Delight'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': '3E MatterSphere'
    },
    {
        'vendor': '3GTMS, Inc.',
        'product': '3GTMS'
    },
    {
        'vendor': '3M Company',
        'product': '3M 360 Encompass'
    },
    {
        'vendor': '3M Company',
        'product': '3M 360 Encompass System'
    },
    {
        'vendor': '3M Company',
        'product': '3M APC Grouper'
    },
    {
        'vendor': '3M Company',
        'product': '3M Advanced Analyzer'
    },
    {
        'vendor': '3M Company',
        'product': '3M Ambulatory Revenue Management Software'
    },
    {
        'vendor': '3M Company',
        'product': '3M Audit Expert'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartFact'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartLocator'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartRelease'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartScan'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartScript'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartStat'
    },
    {
        'vendor': '3M Company',
        'product': '3M ChartView'
    },
    {
        'vendor': '3M Company',
        'product': '3M ClinTrac'
    },
    {
        'vendor': '3M Company',
        'product': '3M Clinical Claims Editor'
    },
    {
        'vendor': '3M Company',
        'product': '3M Clinical Documentation Improvement'
    },
    {
        'vendor': '3M Company',
        'product': '3M CodeRyte'
    },
    {
        'vendor': '3M Company',
        'product': '3M Codefinder'
    },
    {
        'vendor': '3M Company',
        'product': '3M DRG Assurance'
    },
    {
        'vendor': '3M Company',
        'product': '3M DRGfinder'
    },
    {
        'vendor': '3M Company',
        'product': '3M Health Data Management System'
    },
    {
        'vendor': '3M Company',
        'product': '3M Informed Analytics'
    },
    {
        'vendor': '3M Company',
        'product': '3M KODIP'
    },
    {
        'vendor': '3M Company',
        'product': '3M Medical Necessity'
    },
    {
        'vendor': '3M Company',
        'product': '3M VoiceScript'
    },
    {
        'vendor': '3PL Central, LLC',
        'product': '3PL Central'
    },
    {
        'vendor': '3Play Media, Inc.',
        'product': '3Play Media'
    },
    {
        'vendor': 'Identiv, Inc.',
        'product': '3VR NVR'
    },
    {
        'vendor': '3cinteractive Corporation',
        'product': '3cinteractive'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': '41st Parameter'
    },
    {
        'vendor': 'Mediaocean, LLC',
        'product': '4C Insights'
    },
    {
        'vendor': '4PatientCare, Inc.',
        'product': '4PatientCare'
    },
    {
        'vendor': '4S DAWN Clinical Software',
        'product': '4S DAWN'
    },
    {
        'vendor': '4medica, Inc.',
        'product': '4medica'
    },
    {
        'vendor': '4project GmbH',
        'product': '4project'
    },
    {
        'vendor': '6Connex, Inc.',
        'product': '6Connex'
    },
    {
        'vendor': '6WIND',
        'product': '6WIND'
    },
    {
        'vendor': '6connect, Inc.',
        'product': '6connect'
    },
    {
        'vendor': '6Sense Insights, Inc.',
        'product': '6sense'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': '7210 Service Access Switch (SAS)'
    },
    {
        'vendor': '7search, Inc.',
        'product': '7search'
    },
    {
        'vendor': '8x8, Inc.',
        'product': '8x8 (Unspecified Product)'
    },
    {
        'vendor': '8x8, Inc.',
        'product': '8x8 ContactNow'
    },
    {
        'vendor': '8x8, Inc.',
        'product': '8x8 Virtual Office'
    },
    {
        'vendor': 'A-1 Enterprise, Inc.',
        'product': 'A1 Tracker'
    },
    {
        'vendor': 'A10 Networks, Inc.',
        'product': 'A10 Networks'
    },
    {
        'vendor': 'AB Tasty',
        'product': 'AB Tasty'
    },
    {
        'vendor': 'SAP SE',
        'product': 'ABAP'
    },
    {
        'vendor': 'Abas Software AG',
        'product': 'ABAS Software'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'ABB Ability'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'ABB Automation Builder'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'ABB Robotics'
    },
    {
        'vendor': 'ABBYY Solutions, Ltd.',
        'product': 'ABBYY FineReader'
    },
    {
        'vendor': 'ABBYY Solutions, Ltd.',
        'product': 'ABBYY Flexicapture'
    },
    {
        'vendor': 'ABELSoft, Inc.',
        'product': 'ABELDent'
    },
    {
        'vendor': 'ABELSoft, Inc.',
        'product': 'ABELMed'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'AC500 PLC'
    },
    {
        'vendor': 'ACCELQ, Inc.',
        'product': 'ACCELQ'
    },
    {
        'vendor': 'Two Points Conversions, Inc.',
        'product': 'ACERT'
    },
    {
        'vendor': 'ACI Worldwide, Inc.',
        'product': 'ACI Worldwide'
    },
    {
        'vendor': 'Galvanize',
        'product': 'ACL GRC'
    },
    {
        'vendor': 'ACOM Health',
        'product': 'ACOM Health'
    },
    {
        'vendor': 'ACT, Inc.',
        'product': 'ACT WorkKeys'
    },
    {
        'vendor': 'AccessData Group, Inc.',
        'product': 'AD Enterprise'
    },
    {
        'vendor': 'AccessData Group, Inc.',
        'product': 'AD eDiscovery'
    },
    {
        'vendor': 'RISA Tech, Inc.',
        'product': 'ADAPT'
    },
    {
        'vendor': '3Five8 Technologies Pvt Ltd',
        'product': 'ADDA'
    },
    {
        'vendor': 'ADFITECH, Inc.',
        'product': 'ADFITECH'
    },
    {
        'vendor': 'ADInstruments Pty Ltd',
        'product': 'ADInstruments'
    },
    {
        'vendor': 'BOC Products & Services AG',
        'product': 'ADOIT'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP (Unspecified Product)'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Benefits Administration'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP CSS HRizon'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Celergo'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Compass'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP DataCloud'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Employease'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Enterprise HR'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP GlobalView HCM'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP HR Anytime'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP HR/Perspective'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Learning Management'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Mobile'
    },
    {
        'vendor': 'WorkMarket, Inc.',
        'product': 'ADP OnForce'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Paisy'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Payroll'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP SmartCompliance'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Streamline'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP TotalSource'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Vantage HCM'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP Workforce Now'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP ezLaborManager'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP iPay'
    },
    {
        'vendor': 'Logistyx Technologies',
        'product': 'ADSI Shipping'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'ADTRAN'
    },
    {
        'vendor': 'ADVA Optical Networking SE',
        'product': 'ADVA Optical'
    },
    {
        'vendor': 'AFAS Software B.V.',
        'product': 'AFAS ERP'
    },
    {
        'vendor': 'Alaska Native Tribal Health Consortium',
        'product': 'AFHCAN'
    },
    {
        'vendor': 'DataSense Company',
        'product': 'AFS Analytics'
    },
    {
        'vendor': 'AForge.NET',
        'product': 'AForge.NET'
    },
    {
        'vendor': 'AForge.NET',
        'product': 'AForge.Video'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA Enterprise Imaging for Cardiology'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA HYDMedia'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA Hexagone'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA Hexalis'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA ICIS'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA Impax'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA ORBIS'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA Qdoc'
    },
    {
        'vendor': 'Vermeg N.V.',
        'product': 'AGILEReporter'
    },
    {
        'vendor': 'AGTEK Development Company, Inc.',
        'product': 'AGTEK'
    },
    {
        'vendor': 'Open Source',
        'product': 'AIDAweb'
    },
    {
        'vendor': 'ALERT Life Sciences Computing S.A.',
        'product': 'ALERT Life Sciences Computing'
    },
    {
        'vendor': 'ALLDATA, LLC',
        'product': 'ALLDATA'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'ALM Octane'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'ALPHACAM'
    },
    {
        'vendor': 'AMBER Molecular Dynamics',
        'product': 'AMBER'
    },
    {
        'vendor': 'Advanced Micro Devices, Inc.',
        'product': 'AMD Radeon'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'AMICAS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'AMICAS HeartSuite'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'AMICAS RadSuite'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'AMP'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'AMPLIFY B2B Integration'
    },
    {
        'vendor': 'Roche Germany Holding GmbH',
        'product': 'AMPLILINK'
    },
    {
        'vendor': 'Advanced Media Services',
        'product': 'AMS Storage'
    },
    {
        'vendor': 'Security Management Resources, Inc.',
        'product': 'AMSI'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'ANSOS'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS CFX'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS EnSight'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS Fluent'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS HFSS'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS Icepak'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS Mechanical'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS RedHawk'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS SPEOS'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS SpaceClaim'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS Workbench'
    },
    {
        'vendor': 'Anzer It Healthcare',
        'product': 'ANZER IT'
    },
    {
        'vendor': 'Altirnao, Inc.',
        'product': 'AODocs'
    },
    {
        'vendor': 'APEX Analytix, LLC',
        'product': 'APEX Analytix (Unspecified Product)'
    },
    {
        'vendor': 'symplr',
        'product': 'API Healthcare'
    },
    {
        'vendor': 'APICEM SARL',
        'product': 'APICRYPT'
    },
    {
        'vendor': 'Automatic Payroll Systems, Inc.',
        'product': 'APS Payroll'
    },
    {
        'vendor': 'APSIS International AB',
        'product': 'APSIS'
    },
    {
        'vendor': 'APSIS International AB',
        'product': 'APSIS One'
    },
    {
        'vendor': 'ARCHIBUS, Inc.',
        'product': 'ARCHIBUS'
    },
    {
        'vendor': 'ARCOS, LLC',
        'product': 'ARCOS (Unspecified Product)'
    },
    {
        'vendor': 'ARES Corporation',
        'product': 'ARES PRISM'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Architect & ARIS Designer'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Aware'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Cloud'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Connect'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Enterprise Architecture'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Process Governance'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Process Performance Manager'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Risk & Compliance Manager'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS Simulation'
    },
    {
        'vendor': 'Software AG',
        'product': 'ARIS for SAP Solutions'
    },
    {
        'vendor': 'Arondor',
        'product': 'ARender'
    },
    {
        'vendor': 'ARxIUM, Inc.',
        'product': 'ARxIUM'
    },
    {
        'vendor': 'ASAPP, Inc.',
        'product': 'ASAPP'
    },
    {
        'vendor': 'Vanco Payment Solutions, Inc.',
        'product': 'ASAPconnected'
    },
    {
        'vendor': 'Associated Software Consultants, Inc.',
        'product': 'ASC PowerLender'
    },
    {
        'vendor': 'ASC Technologies AG',
        'product': 'ASC‘s neo Suite'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Cypress'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Data Intelligence'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG JCLPREP'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Mobius'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG PRO/JCL'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG PerfMan'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Report.Web'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Safari'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG SmartEdit'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Software'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG TMON'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG ViewDirect'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Zara'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Zebb'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG Zeke'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG becubic'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG metaGlossary'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'ASG-Zena'
    },
    {
        'vendor': 'Anand Systems, Inc.',
        'product': 'ASI FrontDesk'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'ASP.NET'
    },
    {
        'vendor': 'AT Internet, Ltd.',
        'product': 'AT Internet'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T (Unspecified Product)'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T ANIRA'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Centrex'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Collaborate'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Conferencing'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Connect'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Cybersecurity'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T DNS'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T FlexWare'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T IoT Platform'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T NetBond for Cloud'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Synaptic'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AT&T Web Hosting'
    },
    {
        'vendor': 'Outer Limits Technology, Inc.',
        'product': 'ATS OnDemand'
    },
    {
        'vendor': 'Open Source',
        'product': 'AVA'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA Asset Performance Management'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA Bocad'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA Contract Risk Management'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA MES'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA NET'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA System Platform'
    },
    {
        'vendor': 'AVG Technologies N.V.',
        'product': 'AVG'
    },
    {
        'vendor': 'AVI Networks, Inc.',
        'product': 'AVI Networks'
    },
    {
        'vendor': 'Covetrus, Inc.',
        'product': 'AVImark'
    },
    {
        'vendor': 'AVL List GmbH',
        'product': 'AVL EXCITE'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'AWD'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Amplify'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS App Mesh'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS AppSync'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Application Discovery Service'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS AppySync'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Artifact'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Auto Scaling'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Backup'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Batch'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Budgets'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Certificate Manager'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Chatbot'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cloud Data Migration'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cloud Development Kit'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cloud Map'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cloud9'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CloudFormation'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CloudHSM'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CloudTrail'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CodeBuild'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CodeCommit'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CodeDeploy'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CodePipeline'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS CodeStar'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Command Line Interface'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Config'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Control Tower'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cost & Usage Report'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cost Explorer'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Data Lake Storage'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Data Pipeline'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS DataSync'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Database Migration Service'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Deep Learning AMIs'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS DeepLens'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS DeepRacer'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Device Farm'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Direct Connect'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Directory Service'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS DocumentDB'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elastic Beanstalk'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental Conductor'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental Delta'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental Live'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental MediaConvert'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental MediaLive'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental MediaPackage'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental MediaTailor'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Elemental Server'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Fargate'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Firewall Manager'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Global Accelerator'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Glue'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS GovCloud'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Identity and Access Management (IAM)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Import/Export Snowball'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Inferentia'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT 1-Click'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Analytics'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Button'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Core'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Device Defender'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Device Management'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Events'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS IoT Greengrass'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Key Management Service (KMS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Lake Formation'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Lambda'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Lambda@Edge'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Managed Services'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Management Console'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Migration Hub'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Mobile Services'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Multi-Factor Authentication'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS OpsWorks'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Organizations'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Outposts'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS PrivateLink'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS RoboMaker'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Schema Conversion Tool'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Secrets Manager'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Security Hub'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Server Migration Service'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Service Catalog'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Shield'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Single Sign-On'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Snowball'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Snowball Edge'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Snowmobile'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Step Functions'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Storage Gateway'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Systems Manager'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Transfer for SFTP'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Transit Gateway'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Trusted Advisor'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS WAF'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS X-Ray'
    },
    {
        'vendor': 'Open Source',
        'product': 'AWStats'
    },
    {
        'vendor': 'AWeber Systems, Inc.',
        'product': 'AWeber'
    },
    {
        'vendor': 'Greenwave Reality, Inc.',
        'product': 'AXON Predict'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'AXOS E5'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'AXOS E7-2'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'AXOS E7-20'
    },
    {
        'vendor': 'Axxess Technology Solutions, Inc.',
        'product': 'AXXESS Technology EVV'
    },
    {
        'vendor': 'Aarki, Inc.',
        'product': 'Aarki'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Ab Initio'
    },
    {
        'vendor': 'BearingPoint B.V.',
        'product': 'Abacus'
    },
    {
        'vendor': 'AbacusRx, Inc.',
        'product': 'Abacus Pharmacy'
    },
    {
        'vendor': 'AbacusNext',
        'product': 'AbacusLaw'
    },
    {
        'vendor': 'Belavier Commerce, LLC',
        'product': 'AbanteCart'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Abaqus'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Abaqus Unified FEA'
    },
    {
        'vendor': 'AbbaDox',
        'product': 'AbbaDox'
    },
    {
        'vendor': 'Aberdeen Group, LLC',
        'product': 'Aberdeen'
    },
    {
        'vendor': 'Abila, Inc.',
        'product': 'Abila'
    },
    {
        'vendor': 'Abiquo Europe, Ltd.',
        'product': 'Abiquo'
    },
    {
        'vendor': 'Able Solutions Corporation',
        'product': 'Able Commerce Gold'
    },
    {
        'vendor': 'Able Solutions Corporation',
        'product': 'AbleCommerce'
    },
    {
        'vendor': 'Absolute Software Corporation',
        'product': 'Absolute Software'
    },
    {
        'vendor': 'Absorb Software, Inc.',
        'product': 'Absorb LMS'
    },
    {
        'vendor': 'Abstract',
        'product': 'Abstract'
    },
    {
        'vendor': 'Acadaca, LLC',
        'product': 'Acadaca'
    },
    {
        'vendor': 'Acarda Sales Technologies, Ltd.',
        'product': 'Acarda'
    },
    {
        'vendor': 'Accela, Inc.',
        'product': 'Accela'
    },
    {
        'vendor': 'Accelerite',
        'product': 'Accelerite CloudPortal Business Manager'
    },
    {
        'vendor': 'Iatric Systems, Inc.',
        'product': 'Accelero Connect'
    },
    {
        'vendor': 'Acceleware, Ltd.',
        'product': 'Acceleware'
    },
    {
        'vendor': 'Acceliant',
        'product': 'Acceliant'
    },
    {
        'vendor': 'Accellion, Inc.',
        'product': 'Accellion'
    },
    {
        'vendor': 'Accelo, Inc.',
        'product': 'Accelo CRM'
    },
    {
        'vendor': 'Accengage S.A.',
        'product': 'Accengage'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Accenture ALIP'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Accenture Alnova'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Accenture Duck Creek'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Accenture Mortgage Cadence'
    },
    {
        'vendor': 'Accertify, Inc.',
        'product': 'Accertify'
    },
    {
        'vendor': 'AccessData Group, Inc.',
        'product': 'AccessData (Unspecified Product)'
    },
    {
        'vendor': 'AccessData Group, Inc.',
        'product': 'AccessData Summation'
    },
    {
        'vendor': 'Acclaim Software, Ltd.',
        'product': 'Acclaim Software'
    },
    {
        'vendor': 'Accord LMS',
        'product': 'Accord LMS'
    },
    {
        'vendor': 'Accord.NET Framework',
        'product': 'Accord.NET Framework'
    },
    {
        'vendor': 'AccountMate Software Corporation',
        'product': 'AccountMate'
    },
    {
        'vendor': 'ACCEO Solutions, Inc.',
        'product': 'Accountant’s Drill'
    },
    {
        'vendor': 'Acclivity Group, LLC',
        'product': 'Accountedge'
    },
    {
        'vendor': 'Accounting Seed, Inc.',
        'product': 'Accounting Seed'
    },
    {
        'vendor': 'Accrisoft Corporation',
        'product': 'Accrisoft'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Accruent (Unspecified Product)'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Accruent Energy & Sustainability Management'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Accruent Expesite'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Accruent TMS'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Accruent vx Field'
    },
    {
        'vendor': 'Beckware, LLC',
        'product': 'AcctVantage'
    },
    {
        'vendor': 'Alterity, Inc.',
        'product': 'Acctivate'
    },
    {
        'vendor': 'AccuBuild IT, LLC',
        'product': 'AccuBuild'
    },
    {
        'vendor': 'Orion Healthcare Technology, Inc.',
        'product': 'AccuCare'
    },
    {
        'vendor': 'AccuPOS Point of Sale',
        'product': 'AccuPOS'
    },
    {
        'vendor': 'AccuStore, Inc.',
        'product': 'AccuStore'
    },
    {
        'vendor': 'ExactLogix, Inc.',
        'product': 'Acculynx'
    },
    {
        'vendor': 'Accumedic Computer Systems, Inc.',
        'product': 'Accumedic'
    },
    {
        'vendor': 'Ace Metrix, Inc.',
        'product': 'Ace Metrix'
    },
    {
        'vendor': 'Websystems, Inc.',
        'product': 'AceProject'
    },
    {
        'vendor': 'Acer, Inc.',
        'product': 'Acer Aspire'
    },
    {
        'vendor': 'Acer, Inc.',
        'product': 'Acer Desktops'
    },
    {
        'vendor': 'Acer, Inc.',
        'product': 'Acer Laptops'
    },
    {
        'vendor': 'Acer, Inc.',
        'product': 'Acer Tablets'
    },
    {
        'vendor': 'Acer, Inc.',
        'product': 'Acer Veriton'
    },
    {
        'vendor': 'Aceyus, Inc.',
        'product': 'Aceyus'
    },
    {
        'vendor': 'Achievers Solutions, Inc.',
        'product': 'Achievers'
    },
    {
        'vendor': 'Achilles Information, Ltd.',
        'product': 'Achilles'
    },
    {
        'vendor': 'Aclara Technologies, LLC',
        'product': 'Aclara'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Acme Packet'
    },
    {
        'vendor': 'Acmeware, Inc.',
        'product': 'Acmeware'
    },
    {
        'vendor': 'ACCEO Solutions, Inc.',
        'product': 'Acomba'
    },
    {
        'vendor': 'Acorn Industrial Components, Ltd.',
        'product': 'Acorn ERP'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'Acoustic (Unspecified Product)'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'Acoustic Analytics'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'Acoustic Campaign'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'Acoustic Experience Analytics'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'Acoustic Lifecycle'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'Acoustic Personalization'
    },
    {
        'vendor': 'Acqueon Technologies, Inc.',
        'product': 'Acqueon'
    },
    {
        'vendor': 'Acquia, Inc.',
        'product': 'Acquia'
    },
    {
        'vendor': 'Acquia, Inc.',
        'product': 'Acquia AgilOne'
    },
    {
        'vendor': 'Acquia, Inc.',
        'product': 'Acquia Open Digital Experience Platform'
    },
    {
        'vendor': 'Acquire',
        'product': 'Acquire'
    },
    {
        'vendor': 'EON Applications, Inc.',
        'product': 'AcquireTM'
    },
    {
        'vendor': 'Acquisio, Inc.',
        'product': 'Acquisio'
    },
    {
        'vendor': 'Acrolinx GmbH',
        'product': 'Acrolinx'
    },
    {
        'vendor': 'Acronis International GmbH',
        'product': 'Acronis'
    },
    {
        'vendor': 'Acronis International GmbH',
        'product': 'Acronis Disaster Recovery Service'
    },
    {
        'vendor': 'Acronis International GmbH',
        'product': 'Acronis Disk Director'
    },
    {
        'vendor': 'Acronis International GmbH',
        'product': 'Acronis Snap Deploy'
    },
    {
        'vendor': 'Acronis International GmbH',
        'product': 'Acronis True Image'
    },
    {
        'vendor': 'ECi Software Solutions, Inc.',
        'product': 'Acsellerate'
    },
    {
        'vendor': 'Act-On Software, Inc.',
        'product': 'Act-On'
    },
    {
        'vendor': 'Act-On Software, Inc.',
        'product': 'Act-On Software'
    },
    {
        'vendor': 'Acteva',
        'product': 'Acteva'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian Avalanche'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian Business Xchange'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian DataCloud'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian DataConnect'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian NoSQL'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian OpenRoad'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian Vector'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'Actian X'
    },
    {
        'vendor': 'Smarsh, Inc.',
        'product': 'Actiance'
    },
    {
        'vendor': 'Actifio, Inc.',
        'product': 'Actifio'
    },
    {
        'vendor': 'ActionIQ, Inc.',
        'product': 'ActionIQ'
    },
    {
        'vendor': 'Actionstep, Inc.',
        'product': 'Actionstep'
    },
    {
        'vendor': 'Actipro Software, LLC',
        'product': 'Actipro'
    },
    {
        'vendor': 'ACTITO',
        'product': 'Actito'
    },
    {
        'vendor': 'ActivEngage, Inc.',
        'product': 'ActivEngage'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'ActivIdentity'
    },
    {
        'vendor': 'ActivTrak',
        'product': 'ActivTrak'
    },
    {
        'vendor': 'Active Collab, LLC',
        'product': 'Active Collab'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'Active IQ Unified Manager'
    },
    {
        'vendor': 'Active Risk Group PLC',
        'product': 'Active Risk'
    },
    {
        'vendor': 'Quoter Software, Inc.',
        'product': 'Active Takeoff'
    },
    {
        'vendor': 'Advanced Systems Concepts, Inc.',
        'product': 'ActiveBatch'
    },
    {
        'vendor': 'ActiveCampaign, Inc.',
        'product': 'ActiveCampaign'
    },
    {
        'vendor': 'ActiveConversion',
        'product': 'ActiveConversion'
    },
    {
        'vendor': 'ActiveState Software, Inc.',
        'product': 'ActiveState'
    },
    {
        'vendor': 'The Advisory Board Company',
        'product': 'ActiveStrategy'
    },
    {
        'vendor': 'Activu Corporation',
        'product': 'Activu'
    },
    {
        'vendor': 'Actsoft, Inc.',
        'product': 'Actsoft (Unspecified Product)'
    },
    {
        'vendor': 'Actsoft, Inc.',
        'product': 'Actsoft Comet'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Actuate BIRT Spreadsheet'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Actuate Xenos'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'ActuateOne'
    },
    {
        'vendor': 'Acustaf Development Corporation',
        'product': 'AcuStaf'
    },
    {
        'vendor': 'Acuity Scheduling, Inc.',
        'product': 'Acuity Scheduling'
    },
    {
        'vendor': 'Acumatica, Inc.',
        'product': 'Acumatica'
    },
    {
        'vendor': 'Acumen Physician Solutions, LLC',
        'product': 'Acumen EHR'
    },
    {
        'vendor': 'Acunetix, Ltd.',
        'product': 'Acunetix'
    },
    {
        'vendor': 'Lexmark International, Inc.',
        'product': 'Acuo VNA'
    },
    {
        'vendor': 'Acusis, LLC',
        'product': 'Acusis'
    },
    {
        'vendor': 'Acxiom, LLC',
        'product': 'Acxiom (Unspecified Product)'
    },
    {
        'vendor': 'Ad Astra Information Systems, LLC',
        'product': 'Ad Astra'
    },
    {
        'vendor': 'YRGLM, Inc.',
        'product': 'Ad Ebis'
    },
    {
        'vendor': 'AdBasis',
        'product': 'AdBasis'
    },
    {
        'vendor': 'eyeo GmbH',
        'product': 'AdBlock Plus'
    },
    {
        'vendor': 'AdClarity',
        'product': 'AdClarity'
    },
    {
        'vendor': 'AdColony, Inc.',
        'product': 'AdColony'
    },
    {
        'vendor': 'AdEspresso, LLC',
        'product': 'AdEspresso'
    },
    {
        'vendor': 'AdGear Technologies, Inc.',
        'product': 'AdGear'
    },
    {
        'vendor': 'Kantar Media UK, Ltd.',
        'product': 'AdGooroo'
    },
    {
        'vendor': 'Opera Software',
        'product': 'AdMarvel'
    },
    {
        'vendor': 'WideOrbit, Inc.',
        'product': 'AdMeta'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'AdMob'
    },
    {
        'vendor': 'Gemius S.A.',
        'product': 'AdOcean'
    },
    {
        'vendor': 'AdParlor, LLC',
        'product': 'AdParlor'
    },
    {
        'vendor': 'AdPerfect Dynamic Advertising Solutions, Ltd.',
        'product': 'AdPerfect'
    },
    {
        'vendor': 'AdPlan Marketing Pty Ltd',
        'product': 'AdPlan'
    },
    {
        'vendor': 'Digital Remedy',
        'product': 'AdReady'
    },
    {
        'vendor': 'AdRise, Inc.',
        'product': 'AdRise'
    },
    {
        'vendor': 'NextRoll, Inc.',
        'product': 'AdRoll'
    },
    {
        'vendor': 'Open Source',
        'product': 'AdSafe'
    },
    {
        'vendor': 'AdShuffle',
        'product': 'AdShuffle'
    },
    {
        'vendor': 'AdSpeed.com',
        'product': 'AdSpeed'
    },
    {
        'vendor': 'Ada Support, Inc.',
        'product': 'Ada AI Chatbot'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas Cluster Services'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas Delta Save'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas Fastpath'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas Online System'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas SAF Security'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas SQL Gateway'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas Vista'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas for Mainframe'
    },
    {
        'vendor': 'Software AG',
        'product': 'Adabas for zIIP'
    },
    {
        'vendor': 'Adadyn Technologies Pvt Ltd',
        'product': 'Adadyn'
    },
    {
        'vendor': 'Microsemi Corporation',
        'product': 'Adaptec'
    },
    {
        'vendor': 'Adaptive Insights, Inc.',
        'product': 'Adaptive Insights'
    },
    {
        'vendor': 'Adaptly, Inc.',
        'product': 'Adaptly'
    },
    {
        'vendor': 'Adaptris',
        'product': 'Adaptris'
    },
    {
        'vendor': 'Adbeat, Inc.',
        'product': 'Adbeat'
    },
    {
        'vendor': 'Adblade, LLC',
        'product': 'Adblade'
    },
    {
        'vendor': 'SparkLIT Networks, Inc.',
        'product': 'Adbutler'
    },
    {
        'vendor': 'AddEvent, Inc.',
        'product': 'AddEvent'
    },
    {
        'vendor': 'AddShoppers, Inc.',
        'product': 'AddShoppers'
    },
    {
        'vendor': 'AddressTwo',
        'product': 'AddressTwo'
    },
    {
        'vendor': 'Adelphic, LLC',
        'product': 'Adelphic'
    },
    {
        'vendor': 'Adeptia, Inc.',
        'product': 'Adeptia'
    },
    {
        'vendor': 'Aderant',
        'product': 'Aderant'
    },
    {
        'vendor': 'Adestra, Ltd.',
        'product': 'Adestra'
    },
    {
        'vendor': 'Adexa, Inc.',
        'product': 'Adexa'
    },
    {
        'vendor': 'Adform A/S',
        'product': 'Adform'
    },
    {
        'vendor': 'Adgistics, Ltd.',
        'product': 'Adgistics'
    },
    {
        'vendor': 'Adhesion Wealth Advisor Solutions, Inc.',
        'product': 'Adhesion Wealth'
    },
    {
        'vendor': 'Adion Systems, Inc.',
        'product': 'Adion ProShop'
    },
    {
        'vendor': 'Adirondack Solutions, Inc.',
        'product': 'Adirondack'
    },
    {
        'vendor': 'Aditro Group',
        'product': 'Aditro HR'
    },
    {
        'vendor': 'Adjust GmbH',
        'product': 'Adjust'
    },
    {
        'vendor': 'V2 Ventures Group, LLC',
        'product': 'Adknowledge'
    },
    {
        'vendor': 'Adlucent, LLC',
        'product': 'Adlucent'
    },
    {
        'vendor': 'Integral Ad Science, Inc.',
        'product': 'Admantx'
    },
    {
        'vendor': 'Admedo, Ltd.',
        'product': 'Admedo'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Admeld'
    },
    {
        'vendor': 'Administrate, Ltd.',
        'product': 'Administrate LMS'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe (Unspecified Product)'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe AIR'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Adobe Acrobat DC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Acrobat Pro'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Acrobat Standard DC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe AdLens'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Advertising Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe After Effects CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Analytics'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Analytics Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Analytics Data Connector'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Animate CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Audience Manager'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Audition'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Behance'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Bridge'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Business Catalyst'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Adobe CQ'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Campaign'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Captivate'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Capture CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Character Animator CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Coldfusion'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Commerce Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Comp CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Connect'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Context Optional'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Creative Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Creative Suite'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe DTM'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Digital Marketing Suite'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Dimension CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Discover'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Document Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Dreamweaver'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Edge'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Edge Animate CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Enterprise'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Experience Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Experience Manager'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Experience Manager Forms'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Experience Platform'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Fireworks'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Adobe Flex'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe FrameMaker'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Fuse CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Illustrator'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe InCopy'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Adobe InDesign'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe InDesign CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe LiveCycle'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Marketing Cloud'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Media Encoder'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Media Optimizer'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Output Designer'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe PhoneGap'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Adobe Photoshop'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Photoshop CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Photoshop Lightroom CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Pixel Bender'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Prelude'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Premiere Elements'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Premiere Pro CC'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Presenter'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Primetime'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe RoboHelp'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Scene7'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Search&Promote'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe SearchCenter+'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Sensei'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Shockwave Player'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Sign'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe SocialAnalytics'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Spark'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Target'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Adobe Typekit'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe XD'
    },
    {
        'vendor': 'Open Source',
        'product': 'AdoptOpenJDK'
    },
    {
        'vendor': 'Adoric Technologies, Ltd.',
        'product': 'Adoric'
    },
    {
        'vendor': 'Adrenalin eSystems, Ltd.',
        'product': 'Adrenalin'
    },
    {
        'vendor': 'Qualcomm Technologies, Inc.',
        'product': 'Adreno'
    },
    {
        'vendor': 'AdsWizz, Inc.',
        'product': 'Adswizz'
    },
    {
        'vendor': 'Media Place Partners, LLC',
        'product': 'Adtegrity'
    },
    {
        'vendor': 'Adthena, Ltd.',
        'product': 'Adthena'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'Adtran Passive Optical Networks'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'Adtran Total Access'
    },
    {
        'vendor': 'AdvancePro Technologies',
        'product': 'AdvancePro'
    },
    {
        'vendor': 'Advanced Data Systems Corporation',
        'product': 'Advanced Data Systems (Unspecified Product)'
    },
    {
        'vendor': 'AdvancedMD, Inc.',
        'product': 'AdvancedEHR'
    },
    {
        'vendor': 'AdvancedMD, Inc.',
        'product': 'AdvancedMD'
    },
    {
        'vendor': 'Surgical Information Systems, LLC',
        'product': 'AdvantX'
    },
    {
        'vendor': 'Advantage Software, Inc.',
        'product': 'Advantage Software'
    },
    {
        'vendor': 'Advantech Co, Ltd.',
        'product': 'Advantech'
    },
    {
        'vendor': 'SS&C Advent',
        'product': 'Advent Moxy'
    },
    {
        'vendor': 'SS&C Advent',
        'product': 'Advent Software'
    },
    {
        'vendor': 'Adverity GmbH',
        'product': 'Adverity'
    },
    {
        'vendor': 'Renegade Internet, Inc.',
        'product': 'AdvertPro'
    },
    {
        'vendor': 'Renegade Internet, Inc.',
        'product': 'AdvertServe'
    },
    {
        'vendor': 'Advicent Solutions LP',
        'product': 'Advicent'
    },
    {
        'vendor': 'The Advisory Board Company',
        'product': 'Advisory Board iRound for Patient Experience'
    },
    {
        'vendor': 'Malwarebytes, Inc.',
        'product': 'AdwCleaner'
    },
    {
        'vendor': 'MordComm, Inc.',
        'product': 'Adwatcher'
    },
    {
        'vendor': 'Adyen B.V.',
        'product': 'Adyen'
    },
    {
        'vendor': 'Kevel',
        'product': 'Adzerk'
    },
    {
        'vendor': 'Aegify, Inc.',
        'product': 'Aegify'
    },
    {
        'vendor': 'Aeon Global Health Corporation',
        'product': 'Aeon Global Health'
    },
    {
        'vendor': 'InMobi Pte Ltd',
        'product': 'AerServ'
    },
    {
        'vendor': 'Aeries Software, Inc.',
        'product': 'Aeries SIS'
    },
    {
        'vendor': 'Aeris Communications, Inc.',
        'product': 'Aeris Fusion IoT Network'
    },
    {
        'vendor': 'Stanley Healthcare',
        'product': 'AeroScout'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Aerohive HiveManager'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Aerohive Networks'
    },
    {
        'vendor': 'Aerohive Networks, Inc.',
        'product': 'Aerohive Networks (Unspecified Product)'
    },
    {
        'vendor': 'Aerospike, Inc.',
        'product': 'Aerospike'
    },
    {
        'vendor': 'Aestiva Software, Inc.',
        'product': 'Aestiva'
    },
    {
        'vendor': 'Omnicell, Inc.',
        'product': 'Aesynt'
    },
    {
        'vendor': 'Omnicell, Inc.',
        'product': 'Aesynt Robot-Rx'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'AetherPal'
    },
    {
        'vendor': 'Aethon, Inc.',
        'product': 'Aethon'
    },
    {
        'vendor': 'Affinio, Inc.',
        'product': 'Affinio'
    },
    {
        'vendor': 'Affirm, Inc.',
        'product': 'Affirm'
    },
    {
        'vendor': 'Affirmed Networks',
        'product': 'Affirmed Networks'
    },
    {
        'vendor': 'Afiniti International Holdings, Ltd.',
        'product': 'Afiniti Enterprise Behavioral Pairing'
    },
    {
        'vendor': 'Afterpay Pty Ltd',
        'product': 'AfterPay'
    },
    {
        'vendor': 'AfterShip, Ltd.',
        'product': 'AfterShip'
    },
    {
        'vendor': 'Agari Data, Inc.',
        'product': 'Agari'
    },
    {
        'vendor': 'Agastha, Inc.',
        'product': 'Agastha'
    },
    {
        'vendor': 'AgencyAnalytics, Inc.',
        'product': 'AgencyAnalytics'
    },
    {
        'vendor': 'AgencyBloc, Inc.',
        'product': 'AgencyBloc'
    },
    {
        'vendor': 'Aivo',
        'product': 'AgentBot'
    },
    {
        'vendor': 'Neustar, Inc.',
        'product': 'Aggregate Knowledge'
    },
    {
        'vendor': 'AgilOne, Inc.',
        'product': 'AgilOne'
    },
    {
        'vendor': 'AgilQuest Corporation',
        'product': 'AgilQuest'
    },
    {
        'vendor': 'Agile CRM, Inc.',
        'product': 'Agile CRM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Agile Requirements Designer'
    },
    {
        'vendor': 'AgileOne',
        'product': 'AgileOne'
    },
    {
        'vendor': 'AgileOne',
        'product': 'AgileOne Acceleration'
    },
    {
        'vendor': 'AgilePoint, Inc.',
        'product': 'AgilePoint NX'
    },
    {
        'vendor': 'Agilefant, Ltd.',
        'product': 'Agilefant'
    },
    {
        'vendor': 'Agilent Technologies, Inc.',
        'product': 'Agilent Dako'
    },
    {
        'vendor': 'Agilent Technologies, Inc.',
        'product': 'Agilent Technologies'
    },
    {
        'vendor': 'Agiline, LLC',
        'product': 'Agiline'
    },
    {
        'vendor': 'Netronome Systems, Inc.',
        'product': 'Agilio'
    },
    {
        'vendor': 'Agiliron, Inc.',
        'product': 'Agiliron'
    },
    {
        'vendor': 'Agility, Inc.',
        'product': 'Agility CMS'
    },
    {
        'vendor': 'Agility Multichannel, Ltd.',
        'product': 'Agility PIM'
    },
    {
        'vendor': 'Agility PR Solutions, LLC',
        'product': 'Agility PR Solutions'
    },
    {
        'vendor': 'Agility Recovery Solutions, Inc.',
        'product': 'Agility Recovery'
    },
    {
        'vendor': 'Agilix Labs, Inc.',
        'product': 'Agilix'
    },
    {
        'vendor': 'Agilix Labs, Inc.',
        'product': 'Agilix Buzz'
    },
    {
        'vendor': 'Agillic A/S',
        'product': 'Agillic'
    },
    {
        'vendor': 'Agiloft, Inc.',
        'product': 'Agiloft'
    },
    {
        'vendor': 'Agilysys, Inc.',
        'product': 'Agilysys'
    },
    {
        'vendor': 'Agilysys, Inc.',
        'product': 'Agilysys Eatec'
    },
    {
        'vendor': 'Agilysys, Inc.',
        'product': 'Agilysys InfoGenesis'
    },
    {
        'vendor': 'Agilysys, Inc.',
        'product': 'Agilysys Visual One'
    },
    {
        'vendor': 'Agnisys, Inc.',
        'product': 'Agnisys'
    },
    {
        'vendor': 'Agora, Inc.',
        'product': 'Agora'
    },
    {
        'vendor': 'Agorapulse SAS',
        'product': 'Agorapulse'
    },
    {
        'vendor': 'Aha! Labs, Inc.',
        'product': 'Aha!'
    },
    {
        'vendor': 'Ahalogy',
        'product': 'Ahalogy'
    },
    {
        'vendor': 'Aheeva Technology, Inc.',
        'product': 'Aheeva'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Ahi QA'
    },
    {
        'vendor': 'Ahrefs Pte Ltd',
        'product': 'Ahrefs'
    },
    {
        'vendor': 'Aible, Inc.',
        'product': 'Aible'
    },
    {
        'vendor': 'Aimetis Corporation',
        'product': 'Aimetis'
    },
    {
        'vendor': 'Aionex, Inc.',
        'product': 'Aionex'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'AirWatch'
    },
    {
        'vendor': 'Airbase, Inc.',
        'product': 'Airbase'
    },
    {
        'vendor': 'Airbiquity, Inc.',
        'product': 'Airbiquity'
    },
    {
        'vendor': 'Airbrake Technologies, Inc.',
        'product': 'Airbrake'
    },
    {
        'vendor': 'Aircall.io, Inc.',
        'product': 'Aircall'
    },
    {
        'vendor': 'Ergon Informatik AG',
        'product': 'Airlock'
    },
    {
        'vendor': 'Airpush, Inc.',
        'product': 'Airpush'
    },
    {
        'vendor': 'Airship Group, Inc.',
        'product': 'Airship'
    },
    {
        'vendor': 'AirStrip Technologies, Inc.',
        'product': 'Airstrip'
    },
    {
        'vendor': 'Airtable',
        'product': 'Airtable'
    },
    {
        'vendor': 'Aiven, Ltd.',
        'product': 'Aiven'
    },
    {
        'vendor': 'AJA Video Systems, Inc.',
        'product': 'Aja Video Systems'
    },
    {
        'vendor': 'General Technology',
        'product': 'Ajax'
    },
    {
        'vendor': 'Open Source',
        'product': 'Ajax.NET Professional'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai (Unspecified Product)'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Acerno'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Bloxx'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Bot Manager'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai CDN'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai CloudTest'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Cloudlet Applications'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Dynamic Site Accelerator'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai EAA'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Edge'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Edge DNS'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Global Host'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Hosting'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai IP Application Accelerator (IPA)'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Identity Cloud'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Image Manager'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Intelligent Edge Platform'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Ion'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Kona Site Defender'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Kona WAF'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Prolexic Routed'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai SSL'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Terra Alta'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai mPulse'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Akana'
    },
    {
        'vendor': 'Akeneo SAS',
        'product': 'Akeneo'
    },
    {
        'vendor': 'Lightbend, Inc.',
        'product': 'Akka'
    },
    {
        'vendor': 'Akumina, Inc.',
        'product': 'Akumina'
    },
    {
        'vendor': 'Alacra, Inc.',
        'product': 'Alacra'
    },
    {
        'vendor': 'Alacritech, Inc.',
        'product': 'Alacritech'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'Alaris EtCO2'
    },
    {
        'vendor': 'Alation, Inc.',
        'product': 'Alation'
    },
    {
        'vendor': 'Albert Technologies, Inc.',
        'product': 'Albert.ai'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent 1665 DMX'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OXO Connect'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OmniAccess'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OmniPCX'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OmniSwitch'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OmniTouch'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OmniVista 8770 Network Management System'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent OpenTouch'
    },
    {
        'vendor': 'Alcatel-Lucent Enterprise',
        'product': 'Alcatel-Lucent Rainbow'
    },
    {
        'vendor': 'Alcea Technologies, Inc.',
        'product': 'Alcea Tracking Solutions'
    },
    {
        'vendor': 'Alcide.IO, Ltd.',
        'product': 'Alcide'
    },
    {
        'vendor': 'Aldec, Inc.',
        'product': 'Aldec'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Aldon'
    },
    {
        'vendor': 'Alemba, Ltd.',
        'product': 'Alemba Service Manager'
    },
    {
        'vendor': 'Alert Logic, Inc.',
        'product': 'Alert Logic'
    },
    {
        'vendor': 'Alert Logic, Inc.',
        'product': 'Alert Logic Cybersecurity Monitoring'
    },
    {
        'vendor': 'AlertEnterprise, Inc.',
        'product': 'AlertEnterprise'
    },
    {
        'vendor': 'Alert Media, Inc.',
        'product': 'AlertMedia'
    },
    {
        'vendor': 'AlertOps',
        'product': 'AlertOps'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'Alertsite'
    },
    {
        'vendor': 'Alertus Technologies, LLC',
        'product': 'Alertus'
    },
    {
        'vendor': 'Alex Solutions Pty Ltd',
        'product': 'Alex Solutions'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Alexa Web Information Service'
    },
    {
        'vendor': 'Alexsys Corporation',
        'product': 'Alexsys'
    },
    {
        'vendor': 'Aleyant Systems, LLC',
        'product': 'Aleyant Pressero'
    },
    {
        'vendor': 'Software AG',
        'product': 'Alfabet'
    },
    {
        'vendor': 'Alfresco Software, Inc.',
        'product': 'Alfresco'
    },
    {
        'vendor': 'Algolia, Inc.',
        'product': 'Algolia'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Algorithmics'
    },
    {
        'vendor': 'AlgoSec, Inc.',
        'product': 'Algosec'
    },
    {
        'vendor': 'Alibaba Group Holding, Ltd.',
        'product': 'Ali WangWang'
    },
    {
        'vendor': 'Alibaba Group Holding, Ltd.',
        'product': 'AliPay'
    },
    {
        'vendor': 'Alibaba Group Holding, Ltd.',
        'product': 'Alibaba'
    },
    {
        'vendor': 'Alibaba Group Holding, Ltd.',
        'product': 'Alibaba Cloud'
    },
    {
        'vendor': 'Alibaba Group Holding, Ltd.',
        'product': 'Alibaba Container Service for Kubernetes'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AlienVault'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'AlienVault Unified Security Management'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'Alienvault OSSIM'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Alienware'
    },
    {
        'vendor': 'Alight Solutions, LLC',
        'product': 'Alight (Unspecified Product)'
    },
    {
        'vendor': 'Alight Solutions, LLC',
        'product': 'Alight UPoint'
    },
    {
        'vendor': 'AlignAlytics, Inc.',
        'product': 'AlignAlytics'
    },
    {
        'vendor': 'Alimama',
        'product': 'Alimama'
    },
    {
        'vendor': 'Alkami Technology, Inc.',
        'product': 'Alkami'
    },
    {
        'vendor': 'Alkemics SAS',
        'product': 'Alkemics'
    },
    {
        'vendor': 'iSalus Healthcare, LLC',
        'product': 'AllMeds'
    },
    {
        'vendor': 'AllegianceMD Software, Inc.',
        'product': 'AllegianceMD'
    },
    {
        'vendor': 'Allego, Inc.',
        'product': 'Allego'
    },
    {
        'vendor': 'Forte Research Systems, Inc.',
        'product': 'Allegro CTMS'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Allegro PCB Designer'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Allegro PCB Librarian'
    },
    {
        'vendor': 'Allgress, Inc.',
        'product': 'Allgress'
    },
    {
        'vendor': 'IFS AB',
        'product': 'Alliance'
    },
    {
        'vendor': 'Alliance Storage Technologies, Inc.',
        'product': 'Alliance Storage Technologies'
    },
    {
        'vendor': 'Allied Telesis, Inc.',
        'product': 'Allied Telesis'
    },
    {
        'vendor': 'Allied Universal',
        'product': 'Allied Universal Security'
    },
    {
        'vendor': 'Allocadia Software, Inc.',
        'product': 'Allocadia'
    },
    {
        'vendor': 'Alloy Software, Inc.',
        'product': 'Alloy Navigator'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts (Unspecified Product)'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Blood Bank'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Canopy'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Eclipsys'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Eclipsys SDK'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts EmSTAT'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts FollowMyHealth'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Jardogs'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Misys'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts MyWay'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Paragon'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Patient Flow'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Payerpath'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Professional'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts STAR'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts Sunrise'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts TouchWorks'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts dbMotion'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Allscripts ePrescribe'
    },
    {
        'vendor': 'Alluxio, Inc.',
        'product': 'Alluxio'
    },
    {
        'vendor': 'Allvue Systems, LLC',
        'product': 'Allvue'
    },
    {
        'vendor': 'HireVue, Inc.',
        'product': 'AllyO'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'Aloha POS'
    },
    {
        'vendor': 'Alooma, Inc.',
        'product': 'Alooma'
    },
    {
        'vendor': 'Alpega N.V.',
        'product': 'Alpega TMS'
    },
    {
        'vendor': 'AlphaSSL',
        'product': 'AlphaSSL'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'Alpine Data Labs'
    },
    {
        'vendor': 'Knewton, Inc.',
        'product': 'Alta'
    },
    {
        'vendor': 'AltaPoint Data Systems, LLC',
        'product': 'AltaPoint'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair AcuSolve'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair FEKO'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperCrash'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperForm'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperGraph'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperMesh'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperStudy'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperView'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair HyperXtrude'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair Hyperworks'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair Knowledge Studio'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair Monarch'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair MotionSolve'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair MotionView'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair OptiStruct'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair RADIOSS'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair SimLab'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair SmartSight'
    },
    {
        'vendor': 'Altaro, Ltd.',
        'product': 'Altaro'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'AlterPoint'
    },
    {
        'vendor': 'Alterian Software Holdings, LLC',
        'product': 'Alterian'
    },
    {
        'vendor': 'Alteryx, Inc.',
        'product': 'Alteryx'
    },
    {
        'vendor': 'Alteryx, Inc.',
        'product': 'Alteryx Connect'
    },
    {
        'vendor': 'Alteryx, Inc.',
        'product': 'Alteryx Designer'
    },
    {
        'vendor': 'Alteryx, Inc.',
        'product': 'Alteryx Server'
    },
    {
        'vendor': 'Altezza',
        'product': 'Altezza'
    },
    {
        'vendor': 'AltiGen Communications, Inc.',
        'product': 'AltiGen Communications'
    },
    {
        'vendor': 'AltiGen Communications, Inc.',
        'product': 'AltiGen Enterprise Cloud PBX'
    },
    {
        'vendor': 'Altibase Corporation',
        'product': 'Altibase'
    },
    {
        'vendor': 'Altify',
        'product': 'Altify'
    },
    {
        'vendor': 'Altiostar Networks, Inc.',
        'product': 'Altiostar (Unspecified Product)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Altiris Deployment Solution'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Altiris IT Management Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Altiris Inventory Solution'
    },
    {
        'vendor': 'Altium, LLC',
        'product': 'Altium (Unspecified Product)'
    },
    {
        'vendor': 'Altium, LLC',
        'product': 'Altium Designer'
    },
    {
        'vendor': 'Altizon, Inc.',
        'product': 'Altizon'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Altosoft'
    },
    {
        'vendor': 'Altova, Inc.',
        'product': 'Altova MapForce'
    },
    {
        'vendor': 'Altova, Inc.',
        'product': 'Altova MetaTeam'
    },
    {
        'vendor': 'Altova, Inc.',
        'product': 'Altova XMLSpy'
    },
    {
        'vendor': 'Alyce, Inc.',
        'product': 'Alyce'
    },
    {
        'vendor': 'Amadeus IT Group S.A.',
        'product': 'Amadeus (Unspecified Product)'
    },
    {
        'vendor': 'Amadeus IT Group S.A.',
        'product': 'Amadeus Agency Manager'
    },
    {
        'vendor': 'Amadeus IT Group S.A.',
        'product': 'Amadeus Central Reservation System'
    },
    {
        'vendor': 'Amadeus Hospitality Americas, Inc.',
        'product': 'Amadeus Hospitality'
    },
    {
        'vendor': 'Amadeus IT Group S.A.',
        'product': 'Amadeus Selling Platform Connect'
    },
    {
        'vendor': 'Amadeus IT Group S.A.',
        'product': 'Amadeus Ticket Changer (ATC)'
    },
    {
        'vendor': 'Amadeus IT Group S.A.',
        'product': 'Amadeus cytric Travel & Expense'
    },
    {
        'vendor': 'Amano USA Holdings, Inc.',
        'product': 'Amano TruTime'
    },
    {
        'vendor': 'Amazing Charts, LLC',
        'product': 'Amazing Charts'
    },
    {
        'vendor': 'Amazing Charts, LLC',
        'product': 'Amazing Charts EHR OB/GYN'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon API Gateway'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Alexa for Business'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon AppStream'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Athena'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Augmented AI (Amazon A2I)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Aurora'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Aurora Serverless'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Amazon Business'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Chime'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Cloud Directory'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon CloudEndure Migration'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon CloudFront'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon CloudSearch'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Cloudwatch'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon CodeGuru'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Cognito'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Comprehend'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Connect'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Amazon DSSTNE'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon DocumentDB'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon DynamoDB'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon EC2'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon EC2 Auto Scaling'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon EC2 Container Service'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon EC2 Reserved Instances'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon EMR'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon ElastiCache'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Block Store (Amazon EBS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Container Registry (ECR)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Container Service (ECS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Container Service for Kubernetes (EKS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic File System'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Kubernetes Service (Amazon EKS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Load Balancing'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elastic Transcoder'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Elasticsearch Service'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon EventBridge'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon FSx for Lustre'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon FSx for Windows File Server'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Forecast'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon FreeRTOS'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon GameLift'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Glacier'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon GuardDuty'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Inspector'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Kendra'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Kinesis'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Kinesis Data Analytics'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Kinesis Data Firehose'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Kinesis Data Streams (KDS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Kinesis Video Streams'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Lex'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Lightsail'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Lumberyard'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon MQ'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Machine Learning'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Macie'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Managed Blockchain'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Managed Streaming for Apache Kafka (Amazon MSK)'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Amazon Mechanical Turk'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Neptune'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Amazon Pay'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Amazon Payments'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Personalize'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Pinpoint'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Polly'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Product Advertising API'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Quantum Ledger Database (QLDB)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon QuickSight'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon RDS for MariaDB'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon RDS for MySQL'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon RDS for PostgreSQL'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon RDS for SQL Server'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Redshift'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Rekognition'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Relational Database Service (RDS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Reserved Instance (RI) Reporting'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Route 53'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon S3'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon S3 Glacier'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon SES'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon SageMaker'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Simple Notification Service (SNS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Simple Queue Service (SQS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Simple Workflow Service (SWF)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon SimpleDB'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Sumerian'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Textract'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Timestream'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Transcribe'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Translate'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon VPC'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Web Hosting'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Web Services (AWS)'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Webstore'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon WorkDocs'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon WorkMail'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon WorkSpaces'
    },
    {
        'vendor': 'Ambassador',
        'product': 'Ambassador'
    },
    {
        'vendor': 'Pacific Amber Technologies, Inc.',
        'product': 'AmberPOS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Amberpoint'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'Ambit Asset Finance'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Amdahl Omniflex'
    },
    {
        'vendor': 'Amdocs Management, Ltd.',
        'product': 'Amdocs (Unspecified Product)'
    },
    {
        'vendor': 'Amdocs Management, Ltd.',
        'product': 'Amdocs Optima'
    },
    {
        'vendor': 'Amdocs Management, Ltd.',
        'product': 'Amdocs RevenueONE'
    },
    {
        'vendor': 'Amdocs Management, Ltd.',
        'product': 'Amdocs Security'
    },
    {
        'vendor': 'Amdocs Management, Ltd.',
        'product': 'Amdocs Smart Client'
    },
    {
        'vendor': 'IPsoft, Inc.',
        'product': 'Amelia'
    },
    {
        'vendor': 'American Express Company',
        'product': 'American Express'
    },
    {
        'vendor': 'American Utility Management',
        'product': 'American Utility Management'
    },
    {
        'vendor': 'American Well Corporation',
        'product': 'American Well'
    },
    {
        'vendor': 'AmeriCommerce, LLC',
        'product': 'Americommerce'
    },
    {
        'vendor': 'AmerisourceBergen Corporation',
        'product': 'AmerisourceBergen'
    },
    {
        'vendor': 'American Express Global Business Travel',
        'product': 'Amex GBT'
    },
    {
        'vendor': 'Ameyo',
        'product': 'Ameyo'
    },
    {
        'vendor': 'AbacusNext',
        'product': 'Amicus Attorney'
    },
    {
        'vendor': 'Amkai Solutions',
        'product': 'Amkai Solutions'
    },
    {
        'vendor': 'Surgical Information Systems, LLC',
        'product': 'AmkaiCharts'
    },
    {
        'vendor': 'Surgical Information Systems, LLC',
        'product': 'AmkaiOffice'
    },
    {
        'vendor': 'Ammyy, Inc.',
        'product': 'Ammyy'
    },
    {
        'vendor': 'Ammyy, Inc.',
        'product': 'Ammyy Admin'
    },
    {
        'vendor': 'Amobee, Inc.',
        'product': 'Amobee'
    },
    {
        'vendor': 'Amobee, Inc.',
        'product': 'Amobee DMP'
    },
    {
        'vendor': 'Amobee, Inc.',
        'product': 'Amobee DSP'
    },
    {
        'vendor': 'Amperity, Inc.',
        'product': 'Amperity'
    },
    {
        'vendor': 'Illumina, Inc.',
        'product': 'AmpliSeq'
    },
    {
        'vendor': 'Amplience (UK), Ltd.',
        'product': 'Amplience'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Amplify Business Partner Engagement'
    },
    {
        'vendor': 'Amplion Clinical Communications, Inc.',
        'product': 'Amplion'
    },
    {
        'vendor': 'Amplitude, Inc.',
        'product': 'Amplitude'
    },
    {
        'vendor': 'Scientific Computing & Modelling N.V.',
        'product': 'Amsterdam Density Functional'
    },
    {
        'vendor': 'American Well Corporation',
        'product': 'Amwell'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'AnNoText'
    },
    {
        'vendor': 'Anaconda, Inc.',
        'product': 'Anaconda'
    },
    {
        'vendor': 'Analogic Corporation',
        'product': 'Analogic'
    },
    {
        'vendor': 'Anaplan, Inc.',
        'product': 'Anaplan'
    },
    {
        'vendor': 'Anaplan, Inc.',
        'product': 'Anaplan (Unspecified Product)'
    },
    {
        'vendor': 'Anaplan, Inc.',
        'product': 'Anaplan Supply Chain'
    },
    {
        'vendor': 'Anaplan, Inc.',
        'product': 'Anaplan for Sales'
    },
    {
        'vendor': 'Anaqua, Inc.',
        'product': 'Anaqua'
    },
    {
        'vendor': 'Anchore, Inc.',
        'product': 'Anchore'
    },
    {
        'vendor': 'Ancile Solutions',
        'product': 'Ancile'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Android OS'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Android Studio'
    },
    {
        'vendor': 'Angoss Software Corporation',
        'product': 'Angoss KnowledgeSTUDIO'
    },
    {
        'vendor': 'Angular',
        'product': 'AngularJS'
    },
    {
        'vendor': 'Angus Systems Group, Ltd.',
        'product': 'Angus Anywhere'
    },
    {
        'vendor': 'Annex Cloud',
        'product': 'Annex Cloud'
    },
    {
        'vendor': 'Anomali, Inc.',
        'product': 'Anomali'
    },
    {
        'vendor': 'Ansira Partners, Inc.',
        'product': 'Ansira'
    },
    {
        'vendor': 'Antavo',
        'product': 'Antavo Loyalty'
    },
    {
        'vendor': 'CompuGroup Medical SE',
        'product': 'Antek HealthWare'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Antenna Software'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'AnthillPro'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Anthos'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Anthos GKE on-prem'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Anthos Service Mesh'
    },
    {
        'vendor': 'Anvil Group, Ltd.',
        'product': 'Anvil'
    },
    {
        'vendor': 'AnyLogic North America, LLC',
        'product': 'AnyLogic'
    },
    {
        'vendor': 'Intermedia.net, Inc.',
        'product': 'AnyMeeting'
    },
    {
        'vendor': 'AnyVision Interactive Technologies, Ltd.',
        'product': 'AnyVision'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Anypoint API Manager'
    },
    {
        'vendor': 'Telestream, LLC',
        'product': 'Anystream'
    },
    {
        'vendor': 'Capillary Technologies',
        'product': 'Anywhere Commerce'
    },
    {
        'vendor': 'Cambridge Semantics, Inc.',
        'product': 'Anzo'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache (Unspecified Product)'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache ActiveMQ'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Airavata'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Airflow'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Ant'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache AntUnit'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Any23'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache AsterixDB'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Avro'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Axiom'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Bahir'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Bigtop'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Bloodhound'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache BookKeeper'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Buildr'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Calcite'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Cassandra'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Chainsaw'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Chukwa'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache CloudStack'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Commons'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Derby'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Drill'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Druid'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Eagle'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Edgent'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Flink'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Forrest'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache FreeMarker'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache FtpServer'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Gearpump'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Giraph'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Gobblin'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Griffin'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Groovy'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Guacamole'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Gump'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache HAWQ'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Apache HCatalog'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache HTTP Server'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache HTrace'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache HUDI'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Hadoop'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Hadoop HDFS'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Hbase'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Heron'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Hive'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Hivemall'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Ignite'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Impala'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Isis'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache IvyDE'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache JMeter'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache James'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Joshua'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Juneau'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Kafka'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Lens'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Libcloud'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Livy'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Lucene'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Lucy'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache MXNet'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Mahout'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Marmotta'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Marvin-AI'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Maven'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Maven Doxia'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Mesos'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache MetaModel'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Metron'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Milagro'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Mynewt'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache NetBeans'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache NiFi'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache OFBiz'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Oozie'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache OpenMeetings'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache OpenNLP'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache POI'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Phoenix'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Pig'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache PredictionIO'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Qpid'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Ranger'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache RocketMQ'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache SAMOA'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache SINGA'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Samza'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Solr'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Spark'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Spark MLlib'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Spark SQL'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Spark Streaming'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Sqoop'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Storm'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Syncope'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache SystemML'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Tika'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Tomcat'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Traffic Server'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache VCL'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Wicket'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Zookeeper'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache cTAKES'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache iota'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache jclouds'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache log4cxx'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache log4php'
    },
    {
        'vendor': 'Software AG',
        'product': 'Apama'
    },
    {
        'vendor': 'Apartments247.com, Inc.',
        'product': 'Apartments247'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Apcera'
    },
    {
        'vendor': 'APCON, Inc.',
        'product': 'Apcon'
    },
    {
        'vendor': 'Premier, Inc.',
        'product': 'Aperek'
    },
    {
        'vendor': 'Apex Clearing Corporation',
        'product': 'Apex Clearing'
    },
    {
        'vendor': 'Apex EDI, Inc.',
        'product': 'Apex EDI'
    },
    {
        'vendor': 'ApexChat',
        'product': 'ApexChat'
    },
    {
        'vendor': 'ApexSQL, LLC',
        'product': 'ApexSQL Backup'
    },
    {
        'vendor': 'ApexSQL, LLC',
        'product': 'ApexSQL Diff'
    },
    {
        'vendor': 'ApexSQL, LLC',
        'product': 'ApexSQL Source Control'
    },
    {
        'vendor': 'Apixio, Inc.',
        'product': 'Apixio HCC Profiler'
    },
    {
        'vendor': 'Aplazame S.L.',
        'product': 'Aplazame'
    },
    {
        'vendor': 'Aplicor',
        'product': 'Aplicor'
    },
    {
        'vendor': 'Aplos Software, LLC',
        'product': 'Aplos Accounting'
    },
    {
        'vendor': 'Meteor Development Group, Inc.',
        'product': 'Apollo'
    },
    {
        'vendor': 'App Annie, Inc.',
        'product': 'App Annie'
    },
    {
        'vendor': 'AppBlade Corporation',
        'product': 'AppBlade'
    },
    {
        'vendor': 'AppDirect, Inc.',
        'product': 'AppDirect'
    },
    {
        'vendor': 'AppDynamics, Inc.',
        'product': 'AppDynamics'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'AppFog'
    },
    {
        'vendor': 'AppFolio, Inc.',
        'product': 'AppFolio'
    },
    {
        'vendor': 'AppFolio, Inc.',
        'product': 'AppFolio Investment Management'
    },
    {
        'vendor': 'AppFolio, Inc.',
        'product': 'AppFolio Lisa'
    },
    {
        'vendor': 'AppFolio, Inc.',
        'product': 'AppFolio MyCase'
    },
    {
        'vendor': 'AppGate',
        'product': 'AppGate'
    },
    {
        'vendor': 'AppHarbor, Inc.',
        'product': 'AppHarbor'
    },
    {
        'vendor': 'AppDirect, Inc.',
        'product': 'AppInsights'
    },
    {
        'vendor': 'AppLift GmbH',
        'product': 'AppLift'
    },
    {
        'vendor': 'AppLovin Corporation',
        'product': 'AppLovin'
    },
    {
        'vendor': 'AppNeta, Inc.',
        'product': 'AppNeta'
    },
    {
        'vendor': 'Xandr, Inc.',
        'product': 'AppNexus'
    },
    {
        'vendor': 'AppOnboard, Inc.',
        'product': 'AppOnboard'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'AppOptics'
    },
    {
        'vendor': 'AppRiver, LLC',
        'product': 'AppRiver'
    },
    {
        'vendor': 'AppVeyor Systems, Inc.',
        'product': 'AppVeyor'
    },
    {
        'vendor': 'AppViewX, Inc.',
        'product': 'AppViewX'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'AppWorx'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Appcelerator'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Appcore Onsite'
    },
    {
        'vendor': 'Appcues, Inc.',
        'product': 'Appcues'
    },
    {
        'vendor': 'Appdome, Inc.',
        'product': 'Appdome Platform'
    },
    {
        'vendor': 'Appen, Ltd.',
        'product': 'Appen'
    },
    {
        'vendor': 'Exadel, Inc.',
        'product': 'Appery.io'
    },
    {
        'vendor': 'Appian Corporation',
        'product': 'Appian'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'Appium'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple (Unspecified Product)'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Aperture'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Desktop'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Final Cut Pro'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Final Cut Pro X'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple ITunes App Meta'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Keynote'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Laptop'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Mac Mini'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Mac Pro'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple MacBook Air'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple MacBook Pro'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Mobile Tags'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Music'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Numbers'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple OS X'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple OS X Mountain Lion'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple OS X Server'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Pages'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Pay'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple TestFlight'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Xsan'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Xserve RAID'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iBooks Author'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iCloud'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iLife'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iOS SDK'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iPad'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iPhone'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple iPod'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple macOS'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple macOS Server'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple xCode'
    },
    {
        'vendor': 'Jobmatch, LLC',
        'product': 'ApplicantPRO'
    },
    {
        'vendor': 'SwipeClock, LLC',
        'product': 'ApplicantStack'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Application Delivery Analysis'
    },
    {
        'vendor': 'Thermo Fisher Scientific, Inc.',
        'product': 'Applied Biosystems SeqStudio Genetic Analyzer'
    },
    {
        'vendor': 'Applied Systems, Inc.',
        'product': 'Applied Systems'
    },
    {
        'vendor': 'Appligent, Inc.',
        'product': 'Appligent'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Applimation'
    },
    {
        'vendor': 'Applitools, Inc.',
        'product': 'Applitools'
    },
    {
        'vendor': 'AppointmentPlus',
        'product': 'AppointmentPlus'
    },
    {
        'vendor': 'Appointy Software, Inc.',
        'product': 'Appointy'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Appoxee'
    },
    {
        'vendor': 'Atos SE',
        'product': 'Apprenda'
    },
    {
        'vendor': 'Apprise',
        'product': 'Apprise ERP'
    },
    {
        'vendor': 'AppsFlyer, Inc.',
        'product': 'Appsflyer'
    },
    {
        'vendor': 'Apptentive, Inc.',
        'product': 'Apptentive'
    },
    {
        'vendor': 'Apptimize, Inc.',
        'product': 'Apptimize'
    },
    {
        'vendor': 'Apptio, Inc.',
        'product': 'Apptio'
    },
    {
        'vendor': 'Apptio, Inc.',
        'product': 'Apptio Cost Transparency'
    },
    {
        'vendor': 'Apptivo, Inc.',
        'product': 'Apptivo'
    },
    {
        'vendor': 'Apptix, Inc.',
        'product': 'Apptix'
    },
    {
        'vendor': 'Apptricity Corporation',
        'product': 'Apptricity'
    },
    {
        'vendor': 'Apptus Technologies AB',
        'product': 'Apptus'
    },
    {
        'vendor': 'Appy Pie, LLC',
        'product': 'Appy Pie AppMakr'
    },
    {
        'vendor': 'AppZen, Inc.',
        'product': 'Appzen'
    },
    {
        'vendor': 'i-exceed Technology Solutions Pvt Ltd',
        'product': 'Appzillon'
    },
    {
        'vendor': 'Social Solutions Global, Inc.',
        'product': 'Apricot Software'
    },
    {
        'vendor': 'eMDs, Inc.',
        'product': 'Aprima EHR'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Aprimo (Unspecified Product)'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Aprimo Campaign'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Aprimo Digital Asset Management'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Aprimo Marketing Studio'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Aprimo Relationship Manager'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Aprimo Revenew'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Apriso FlexNet'
    },
    {
        'vendor': 'Apriva, LLC',
        'product': 'Apriva'
    },
    {
        'vendor': 'Singular Labs, Inc.',
        'product': 'Apsalar'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Aptana'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'Aptean (Unspecified Product)'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'Aptean Pivotal CRM'
    },
    {
        'vendor': 'Aptech Computer Systems, Inc.',
        'product': 'Aptech Computer Systems'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Apteligent'
    },
    {
        'vendor': 'Aptiv PLC',
        'product': 'Aptiv'
    },
    {
        'vendor': 'Aptos, Inc.',
        'product': 'Aptos CRM'
    },
    {
        'vendor': 'Aptos, Inc.',
        'product': 'Aptos Merchandising'
    },
    {
        'vendor': 'Aptos, Inc.',
        'product': 'Aptos OMS'
    },
    {
        'vendor': 'Aptos, Inc.',
        'product': 'Aptos POS'
    },
    {
        'vendor': 'Apttus Corporation',
        'product': 'Apttus'
    },
    {
        'vendor': 'Apttus Corporation',
        'product': 'Apttus CLM'
    },
    {
        'vendor': 'Apttus Corporation',
        'product': 'Apttus CPQ'
    },
    {
        'vendor': 'Apttus Corporation',
        'product': 'Apttus E-Commerce'
    },
    {
        'vendor': 'Apttus Corporation',
        'product': 'Apttus X-Author'
    },
    {
        'vendor': 'Aptum Technologies',
        'product': 'Aptum'
    },
    {
        'vendor': 'Aqua Security Software, Ltd.',
        'product': 'Aqua'
    },
    {
        'vendor': 'arago GmbH',
        'product': 'Arago HIRO'
    },
    {
        'vendor': 'Araize, Inc.',
        'product': 'Araize'
    },
    {
        'vendor': 'Aralco Point of Sale Systems, Ltd.',
        'product': 'Aralco'
    },
    {
        'vendor': 'Aramark Corporation',
        'product': 'Aramark ISIS Pro'
    },
    {
        'vendor': 'ArangoDB, Inc.',
        'product': 'ArangoDB'
    },
    {
        'vendor': 'Aras Corporation',
        'product': 'Aras (Unspecified Product)'
    },
    {
        'vendor': 'Aravo Solutions, Inc.',
        'product': 'Aravo'
    },
    {
        'vendor': 'ArbiterSports, LLC',
        'product': 'ArbiterSports'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'Arbor Cloud DDoS'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'Arbor DDoS'
    },
    {
        'vendor': 'Arbor Networks',
        'product': 'Arbor Peakflow'
    },
    {
        'vendor': 'Arbutus Software, Inc.',
        'product': 'Arbutus Software'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS 3D Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS AppStudio'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Bathymetry'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Business Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Collector'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Dashboards'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Data Interoperability'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Data Reviewer'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Defense Mapping'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Desktop'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Desktop Basic'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Earth'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Enterprise'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Explorer'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS GeoAnalytics Server'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS GeoEvent Server'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Geostatistical Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Hub'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Image Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Image Server'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Indoors'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Insights'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Maps for Office'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Maritime'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Monitor'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Network Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Notebooks'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Online'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Open Data'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Pipeline Referencing'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Platform'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Production Mapping'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Publisher'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Schematics'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Server'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Spatial Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS StoryMaps'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Tracking Analyst'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Urban'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Web AppBuilder'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Workflow Manager'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcIMS'
    },
    {
        'vendor': 'Data443 Risk Mitigation, Inc.',
        'product': 'ArcMail'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcReader'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Arca EVOLUTION'
    },
    {
        'vendor': 'Arcadia Data, Inc.',
        'product': 'Arcadia Enterprise'
    },
    {
        'vendor': 'BQE Software, Inc.',
        'product': 'ArchiOffice'
    },
    {
        'vendor': 'Archive360, Inc.',
        'product': 'Archive360'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'ArchiveOne'
    },
    {
        'vendor': 'ARCON',
        'product': 'Arcon'
    },
    {
        'vendor': 'Arcserve, LLC',
        'product': 'Arcserve UDP'
    },
    {
        'vendor': 'Arcserve, LLC',
        'product': 'Arcserve UDP Cloud Direct'
    },
    {
        'vendor': 'Arctic Wolf Networks, Inc.',
        'product': 'Arctic Wolf'
    },
    {
        'vendor': 'Ardexus, Inc.',
        'product': 'Ardexus'
    },
    {
        'vendor': 'Ardoq AS',
        'product': 'Ardoq'
    },
    {
        'vendor': 'Area 1 Security, Inc.',
        'product': 'Area 1'
    },
    {
        'vendor': 'Arena Solutions, Inc.',
        'product': 'Arena PLM'
    },
    {
        'vendor': 'Rockwell Automation, Inc.',
        'product': 'Arena Simulation'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Argo CD'
    },
    {
        'vendor': 'Aria Systems, Inc.',
        'product': 'Aria Systems'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'Ariba (Unspecified Product)'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'Ariba Payables'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'Ariba Spend Visibility'
    },
    {
        'vendor': 'ArisGlobal, LLC',
        'product': 'ArisGlobal'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7010 Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7020R Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7050X3 Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7060X Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7150 Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7160 Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7260X Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7300 Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista 7500R3 Series'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista Extensible Operating System'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Arista Networks'
    },
    {
        'vendor': 'Arkadin Cloud Communications',
        'product': 'Arkadin'
    },
    {
        'vendor': 'Arlo Software, Ltd.',
        'product': 'Arlo'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Arm Mbed OS'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Arm NN'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Arm Pelion IoT Platform'
    },
    {
        'vendor': 'Treasure Data, Inc.',
        'product': 'Arm Treasure Data'
    },
    {
        'vendor': 'Armis, Inc.',
        'product': 'Armis'
    },
    {
        'vendor': 'Armis, Inc.',
        'product': 'Armis See Every Thing'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Arnold Renderer'
    },
    {
        'vendor': 'AroFlo Pty Ltd',
        'product': 'AroFlo'
    },
    {
        'vendor': 'Array Networks, Inc.',
        'product': 'Array Networks'
    },
    {
        'vendor': 'Arreva, LLC',
        'product': 'Arreva'
    },
    {
        'vendor': 'Arria NLG, Ltd.',
        'product': 'Arria NLG'
    },
    {
        'vendor': 'CommScope, Inc.',
        'product': 'Arris'
    },
    {
        'vendor': 'ART19, Inc.',
        'product': 'Art19'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Artemis'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Artemis International'
    },
    {
        'vendor': 'Articulate Global, Inc.',
        'product': 'Articulate Storyline'
    },
    {
        'vendor': 'Articulate Global, Inc.',
        'product': 'Articulate Storyline 360'
    },
    {
        'vendor': 'Artificial Solutions Holding ASH AB',
        'product': 'Artificial Solutions'
    },
    {
        'vendor': 'Artisteer, Ltd.',
        'product': 'Artisteer'
    },
    {
        'vendor': 'Artsai, Inc.',
        'product': 'Artsai'
    },
    {
        'vendor': 'Aruba S.p.A.',
        'product': 'Aruba'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba AirWave Network Management'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba CX 6200 Switch Series'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba CX 6400 Switch Series'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba CX 8320 Switch Series'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba CX 8400 Switch Series'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba CX Switches'
    },
    {
        'vendor': 'HPE',
        'product': 'Aruba Clearpass'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba Mobility Controller'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'Aruba Networks (Unspecified Product)'
    },
    {
        'vendor': 'Aruba Networks',
        'product': 'ArubaOS'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Arxan Application Protection'
    },
    {
        'vendor': 'Arxspan, LLC',
        'product': 'Arxspan ArxLab'
    },
    {
        'vendor': 'Aryaka Networks, Inc.',
        'product': 'Aryaka'
    },
    {
        'vendor': 'Asana, Inc.',
        'product': 'Asana'
    },
    {
        'vendor': 'Asana, Inc.',
        'product': 'Asana Business'
    },
    {
        'vendor': 'InMotion Global, Inc.',
        'product': 'AscendTMS'
    },
    {
        'vendor': 'Ascender Group',
        'product': 'Ascender'
    },
    {
        'vendor': 'Ascendix Technologies, Inc.',
        'product': 'Ascendix'
    },
    {
        'vendor': 'CSG Systems International, Inc.',
        'product': 'Ascendon'
    },
    {
        'vendor': 'Ascent Business Systems, Inc.',
        'product': 'Ascent Business Systems (Unspecified Product)'
    },
    {
        'vendor': 'AscentERP',
        'product': 'AscentERP'
    },
    {
        'vendor': 'Ascentis Corporation',
        'product': 'Ascentis'
    },
    {
        'vendor': 'Ascom, Inc.',
        'product': 'Ascom US'
    },
    {
        'vendor': 'Asigra, Inc.',
        'product': 'Asigra'
    },
    {
        'vendor': 'Asite Solutions, Ltd.',
        'product': 'Asite Adoddle'
    },
    {
        'vendor': 'Asite Solutions, Ltd.',
        'product': 'Asite Common Data Environment'
    },
    {
        'vendor': 'Asite Solutions, Ltd.',
        'product': 'Asite PPM'
    },
    {
        'vendor': 'Ask Nicely, Ltd.',
        'product': 'AskNicely'
    },
    {
        'vendor': 'Askesis Development Group, Inc.',
        'product': 'Askesis PsychConsult Provider'
    },
    {
        'vendor': 'Vortx, Inc.',
        'product': 'AspDotNetStorefront'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect CXP'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Quality Monitoring'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Software (Unspecified Product)'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Unified IP'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Via'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Voxeo'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Zipwire'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Adsorption'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Basic Engineering'
    },
    {
        'vendor': 'Aspen Systems, Inc.',
        'product': 'Aspen Beowulf'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Capital Cost Estimator'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Custom Modeler'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Energy Analyzer'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Exchanger Design & Rating'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Flare System Analyzer'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen HYSYS'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen In-Plant Cost Estimator'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen InfoPlus.21'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen PIMS'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Petroleum Scheduler'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Plus'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Process Economic Analyzer'
    },
    {
        'vendor': 'Follett Corporation',
        'product': 'Aspen SIS'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'Aspen Utilities'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'AspenTech'
    },
    {
        'vendor': 'Aspera Technologies, Inc.',
        'product': 'Aspera'
    },
    {
        'vendor': 'AspireIQ, Inc.',
        'product': 'AspireIQ'
    },
    {
        'vendor': 'Aspose Pty Ltd',
        'product': 'Aspose'
    },
    {
        'vendor': 'Aspyra, Inc.',
        'product': 'Aspyra'
    },
    {
        'vendor': 'Assembla, Inc.',
        'product': 'Assembla'
    },
    {
        'vendor': 'Open Source',
        'product': 'Assembly'
    },
    {
        'vendor': 'Assentis Technologies AG',
        'product': 'Assentis'
    },
    {
        'vendor': 'Assertible, Inc.',
        'product': 'Assertible'
    },
    {
        'vendor': 'Asset Panda, LLC',
        'product': 'Asset Panda'
    },
    {
        'vendor': 'Real Asset Management',
        'product': 'Asset4000'
    },
    {
        'vendor': 'AssetBook, Inc.',
        'product': 'AssetBook'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'AssetPoint TabWare'
    },
    {
        'vendor': 'AssetWorks, LLC',
        'product': 'AssetWorks'
    },
    {
        'vendor': 'Assignar Pty Ltd',
        'product': 'Assignar'
    },
    {
        'vendor': 'EdgeVerve Systems, Ltd.',
        'product': 'AssistEdge RPA'
    },
    {
        'vendor': 'ACGI Software',
        'product': 'Association Anywhere'
    },
    {
        'vendor': 'AssurX, Inc.',
        'product': 'AssurX'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Assurance Reimbursement Management'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'Assure MIMIX'
    },
    {
        'vendor': 'Trintech, Inc.',
        'product': 'AssureNET'
    },
    {
        'vendor': 'Astea International, Inc.',
        'product': 'Astea'
    },
    {
        'vendor': 'Astera Software, Inc.',
        'product': 'Astera Centerprise'
    },
    {
        'vendor': 'Sangoma Technologies Corporation',
        'product': 'Asterisk'
    },
    {
        'vendor': 'Astound',
        'product': 'Astound'
    },
    {
        'vendor': 'Astraia Software GmbH',
        'product': 'Astraia'
    },
    {
        'vendor': 'Astronomer, Inc.',
        'product': 'Astronomer'
    },
    {
        'vendor': 'Astute Medical, Inc.',
        'product': 'Astute Medical'
    },
    {
        'vendor': 'Astute, Inc.',
        'product': 'Astute Solutions'
    },
    {
        'vendor': 'Asure Software, Inc.',
        'product': 'Asure ADI Time'
    },
    {
        'vendor': 'Asure Software, Inc.',
        'product': 'Asure Legiant'
    },
    {
        'vendor': 'Asure Software, Inc.',
        'product': 'Asure Software (Unspecified Product)'
    },
    {
        'vendor': 'Asure Software, Inc.',
        'product': 'Asure Software Full Service Room Scheduling'
    },
    {
        'vendor': 'ASUSTeK Computer, Inc.',
        'product': 'Asus Motherboards'
    },
    {
        'vendor': 'ASUSTeK Computer, Inc.',
        'product': 'Asus Tablet'
    },
    {
        'vendor': 'AtScale, Inc.',
        'product': 'AtScale'
    },
    {
        'vendor': 'Workfront, Inc.',
        'product': 'AtTask'
    },
    {
        'vendor': 'Ataccama Corporation',
        'product': 'Ataccama'
    },
    {
        'vendor': 'Ataccama Corporation',
        'product': 'Ataccama Master & Reference Data Management'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Atellica Diagnostics IT'
    },
    {
        'vendor': 'Atempo SAS',
        'product': 'Atempo (Unspecified Product)'
    },
    {
        'vendor': 'ATENTO SPAIN HOLDCO S.L.U',
        'product': 'Atento'
    },
    {
        'vendor': 'Aternity, LLC',
        'product': 'Aternity (Unspecified Product)'
    },
    {
        'vendor': 'Aternity, LLC',
        'product': 'Aternity Application Performance Monitoring (APM)'
    },
    {
        'vendor': 'Aternity, LLC',
        'product': 'Aternity Digital Experience Management'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Aternity End User Experience Monitoring'
    },
    {
        'vendor': 'Atex Media, Ltd.',
        'product': 'Atex'
    },
    {
        'vendor': 'athenahealth, Inc.',
        'product': 'Athenahealth (Unspecified Product)'
    },
    {
        'vendor': 'Athonet S.rl',
        'product': 'Athonet'
    },
    {
        'vendor': 'Open Source',
        'product': 'Atlantis'
    },
    {
        'vendor': 'HiveIO, Inc.',
        'product': 'Atlantis HyperScale'
    },
    {
        'vendor': 'Atlas Solutions',
        'product': 'Atlas'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian (Unspecified Product)'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Bamboo'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Bitbucket'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Clover'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Confluence'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Crowd'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Crucible'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian FishEye'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian JIRA'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian JIRA Core'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian JIRA Service Desk'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian JIRA Software'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Opsgenie'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Statuspage'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Atlassian Trello'
    },
    {
        'vendor': 'Atmail Pty Ltd',
        'product': 'Atmail'
    },
    {
        'vendor': 'Atos SE',
        'product': 'Atos Digital Health Solutions'
    },
    {
        'vendor': 'ATOSS Software AG',
        'product': 'Atoss'
    },
    {
        'vendor': 'Atrium LLP',
        'product': 'Atrium'
    },
    {
        'vendor': 'AttackIQ, Inc.',
        'product': 'AttackIQ'
    },
    {
        'vendor': 'Attainia, Inc.',
        'product': 'Attainia'
    },
    {
        'vendor': 'Attendify, Inc.',
        'product': 'Attendify'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Attensity'
    },
    {
        'vendor': 'Attentive Mobile, Inc.',
        'product': 'Attentive Mobile'
    },
    {
        'vendor': 'Attivio, Inc.',
        'product': 'Attivio'
    },
    {
        'vendor': 'Attivo Networks, Inc.',
        'product': 'Attivo Networks'
    },
    {
        'vendor': 'Attraqt Group PLC',
        'product': 'Attraqt'
    },
    {
        'vendor': 'Audatex North America, Inc.',
        'product': 'Audatex'
    },
    {
        'vendor': 'AudienceScience, Inc.',
        'product': 'AudienceScience'
    },
    {
        'vendor': 'AudioCodes, Ltd.',
        'product': 'AudioCodes'
    },
    {
        'vendor': 'AuditBoard, Inc.',
        'product': 'AuditBoard'
    },
    {
        'vendor': 'Aumentum Technologies',
        'product': 'Aumentum Tax'
    },
    {
        'vendor': 'Aumentum Technologies',
        'product': 'Aumentum Valuation'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Aura Managed CDN'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Aurea CX Platform'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Aurea DataXtend SI'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Aurea Email Marketing'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Aurea Messenger'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Aurea Monitor'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Aurea Process'
    },
    {
        'vendor': 'Aurigo Software Technologies, Inc.',
        'product': 'Aurigo'
    },
    {
        'vendor': 'Austco Communication Systems Pty Ltd',
        'product': 'Austco'
    },
    {
        'vendor': 'Auth0, Inc.',
        'product': 'Auth0'
    },
    {
        'vendor': 'First Data Corporation',
        'product': 'AuthentiCare'
    },
    {
        'vendor': 'Authoritas',
        'product': 'Authoritas'
    },
    {
        'vendor': 'Authorize.Net, LLC',
        'product': 'Authorize.Net'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'AutoCAD'
    },
    {
        'vendor': 'AutoClerk, Inc.',
        'product': 'AutoClerk'
    },
    {
        'vendor': 'AutoDesSys, Inc.',
        'product': 'AutoDesSys (Unspecified Product)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'AutoSys Workload Automation'
    },
    {
        'vendor': 'Transoft Solutions, Inc.',
        'product': 'AutoTURN'
    },
    {
        'vendor': 'AutoVitals, Inc.',
        'product': 'AutoVitals'
    },
    {
        'vendor': 'J.D. Power',
        'product': 'Autodata'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk (Unspecified Product)'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk 3ds Max'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk A360'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Alias'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Assemble'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk AutoCAD'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk AutoSketch'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk BIM 360'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk BIM 360 Docs'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk BIM Collaborate'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk BIM360 Plan'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Build'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Buzzsaw'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk CFD'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Constructware'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Eagle'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk FeatureCAM'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Flame'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Fusion 360'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Fusion Lifecycle'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Inventor'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk MatchMover'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Maya'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Moldflow'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk MotionBuilder'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Mudbox'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Navisworks'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk PartMaker'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk PowerInspect'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk PowerMill'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk PowerShape'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Revit'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Showcase'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Sketchbook'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Smoke'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Softimage'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Vault'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Volo View'
    },
    {
        'vendor': 'Autoklose',
        'product': 'Autoklose'
    },
    {
        'vendor': 'Autom8 Group',
        'product': 'Autom8'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'AutomatedQA'
    },
    {
        'vendor': 'Automation Anywhere, Inc.',
        'product': 'Automation Anywhere'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'Automic'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Automic Automation'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Automic Continuous Delivery Automation'
    },
    {
        'vendor': 'Automox, Inc.',
        'product': 'Automox'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Autonomy CAMM'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Autonomy Consolidated Archive'
    },
    {
        'vendor': 'VerQu, LLC',
        'product': 'Autonomy Enterprise Archive Solution (EAS)'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Autonomy LiveSite'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Autonomy NearPoint'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Autonomy Open Deploy'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Autonomy Records Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Autonomy Virage'
    },
    {
        'vendor': 'iManage',
        'product': 'Autonomy WorkSite'
    },
    {
        'vendor': 'AutopilotHQ, Inc.',
        'product': 'Autopilot'
    },
    {
        'vendor': 'Autotask Corporation',
        'product': 'Autotask'
    },
    {
        'vendor': 'Datto, Inc.',
        'product': 'Autotask PSA'
    },
    {
        'vendor': 'TGI Software',
        'product': 'Autumn8'
    },
    {
        'vendor': 'Auvik Networks, Inc.',
        'product': 'Auvik'
    },
    {
        'vendor': 'Avaamo, Inc.',
        'product': 'Avaamo'
    },
    {
        'vendor': 'ThemeFusion, Inc.',
        'product': 'Avada'
    },
    {
        'vendor': 'Avadyne Health',
        'product': 'Avadyne Health'
    },
    {
        'vendor': 'Availity, LLC',
        'product': 'Availity (Unspecified Product)'
    },
    {
        'vendor': 'Availity, LLC',
        'product': 'Availity Advanced Clearinghouse'
    },
    {
        'vendor': 'Availpro',
        'product': 'Availpro'
    },
    {
        'vendor': 'Avalara, Inc.',
        'product': 'Avalara'
    },
    {
        'vendor': 'Avaloq Evolution AG',
        'product': 'Avaloq'
    },
    {
        'vendor': 'Avanan, Inc.',
        'product': 'Avanan'
    },
    {
        'vendor': '2Checkout.com, Inc.',
        'product': 'Avangate Monetization Platform'
    },
    {
        'vendor': 'Dynamic Web Source, Inc.',
        'product': 'AvantLink'
    },
    {
        'vendor': 'ACCEO Solutions, Inc.',
        'product': 'Avantage PRO'
    },
    {
        'vendor': 'Avantas, LLC',
        'product': 'Avantas Smart Square'
    },
    {
        'vendor': 'Avanti Computer Systems, Ltd.',
        'product': 'Avanti Slingshot'
    },
    {
        'vendor': 'Internet Tourism Solutions S.L.',
        'product': 'Avantio'
    },
    {
        'vendor': 'Avast Software s.r.o.',
        'product': 'Avast Managed Workplace'
    },
    {
        'vendor': 'Avast Software s.r.o.',
        'product': 'Avast Software'
    },
    {
        'vendor': 'Avatier Corporation',
        'product': 'Avatier'
    },
    {
        'vendor': 'Avature, LLC',
        'product': 'Avature'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya (Unspecified Product)'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya 8300'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya 8600'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Agile Communication Environment (ACE)'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Aura'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Aura Call Center Elite'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Aura Contact Center'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Aura Experience Portal'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Ava'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya BCM'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Business Advocate'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Business Communications Manager'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya CS1000'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Call Management System'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Callback Assist'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Communications Server'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Contact Analyzer'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Contact Center'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Contact Center Control Manager'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Contact Center Performance Management'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya DECT Handsets'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya DEFINITY Prologix Solutions'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Desktop Phones'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Digital Deskphone'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Equinox'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Flare Experience'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Gateways'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya IP Deskphones'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya IP Office'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya IQ'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya IVR'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Identity Engines'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Interaction Center'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Intuity'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Meeting Exchange'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Officelinx'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya One-X Applications'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Operational Analyst'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Proactive Contact'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Routers'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Secure Router 3120'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Session Border Controller'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Unified Messaging'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya VPN Gateway'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya VSP 4000'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya VSP 7000'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya VSP 9000'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Voice Portal'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'AvayaLive Engage'
    },
    {
        'vendor': 'Avaza Software Pty Ltd',
        'product': 'Avaza'
    },
    {
        'vendor': 'AvePoint, Inc.',
        'product': 'AvePoint'
    },
    {
        'vendor': 'Avecto, Ltd.',
        'product': 'Avecto'
    },
    {
        'vendor': 'Avensoft, Inc.',
        'product': 'Avensoft'
    },
    {
        'vendor': 'Aventri, Inc.',
        'product': 'Aventri'
    },
    {
        'vendor': 'Avera Health',
        'product': 'Avera eCARE Telemedicine'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Avere vFXT for Azure'
    },
    {
        'vendor': 'Averetek, Inc.',
        'product': 'Averetek'
    },
    {
        'vendor': 'Avetta, LLC',
        'product': 'Avetta'
    },
    {
        'vendor': 'Avetti Commerce Corporation',
        'product': 'Avetti Commerce'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Avi Vantage'
    },
    {
        'vendor': 'Aviatrix Systems, Inc.',
        'product': 'Aviatrix'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid ISIS'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid Interplay'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid Media Composer'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid NewsCutter'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid Pro Tools'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid Sibelius'
    },
    {
        'vendor': 'Avid Technology, Inc.',
        'product': 'Avid VENUE'
    },
    {
        'vendor': 'AvidXchange, Inc.',
        'product': 'AvidXchange'
    },
    {
        'vendor': 'Avidian Technologies, Inc.',
        'product': 'Avidian Prophet'
    },
    {
        'vendor': 'Avigilon Corporation',
        'product': 'Avigilon'
    },
    {
        'vendor': 'Avigilon Corporation',
        'product': 'Avigilon Control Center'
    },
    {
        'vendor': 'Avionte, LLC',
        'product': 'Avionte'
    },
    {
        'vendor': 'Avira Operations GmbH & Company KG',
        'product': 'Avira'
    },
    {
        'vendor': 'Vertiv Group Corporation',
        'product': 'Avocent'
    },
    {
        'vendor': 'Avochato, Inc.',
        'product': 'Avochato'
    },
    {
        'vendor': 'Avolution Pty Ltd',
        'product': 'Avolution'
    },
    {
        'vendor': 'Avotus Corporation',
        'product': 'Avotus'
    },
    {
        'vendor': 'Avreo, Inc.',
        'product': 'Avreo'
    },
    {
        'vendor': 'Avreo, Inc.',
        'product': 'Avreo interWORKS'
    },
    {
        'vendor': 'AVTECH Software, Inc.',
        'product': 'Avtech'
    },
    {
        'vendor': 'CenTrak, Inc.',
        'product': 'Awarepoint'
    },
    {
        'vendor': 'Awario',
        'product': 'Awario'
    },
    {
        'vendor': 'AWIN, Inc.',
        'product': 'Awin'
    },
    {
        'vendor': 'Awingu N.V.',
        'product': 'Awingu'
    },
    {
        'vendor': 'Axcient, Inc.',
        'product': 'Axcient'
    },
    {
        'vendor': 'Axence, Inc.',
        'product': 'Axence'
    },
    {
        'vendor': 'Matrox Electronic Systems, Ltd.',
        'product': 'Axio LE'
    },
    {
        'vendor': 'Kaufman Hall & Associates, LLC',
        'product': 'Axiom Software'
    },
    {
        'vendor': 'Qontigo GmbH',
        'product': 'Axioma'
    },
    {
        'vendor': 'Axiomatics AB',
        'product': 'Axiomatics'
    },
    {
        'vendor': 'Deister Software S.A.',
        'product': 'Axional ERP'
    },
    {
        'vendor': 'Axios Systems PLC',
        'product': 'Axios Systems'
    },
    {
        'vendor': 'Axis Communications AB',
        'product': 'Axis Communications'
    },
    {
        'vendor': 'Atrixware, LLC',
        'product': 'Axis LMS'
    },
    {
        'vendor': 'Axonius, Inc.',
        'product': 'Axonius'
    },
    {
        'vendor': 'Axtria, Inc.',
        'product': 'Axtria'
    },
    {
        'vendor': 'Axure Software Solutions, Inc.',
        'product': 'Axure'
    },
    {
        'vendor': 'Axure Software Solutions, Inc.',
        'product': 'Axure RP'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway Activator'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway SecureTransport'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway Sentinel'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway Syncplicity'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway TradeSync Integration Manager (TSIM)'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Axway Transfer CFT'
    },
    {
        'vendor': 'Axxerion B.V.',
        'product': 'Axxerion IWMS'
    },
    {
        'vendor': 'Ground Zero Tech-Works, Inc.',
        'product': 'AyaNova'
    },
    {
        'vendor': 'Ayasdi, Inc.',
        'product': 'Ayasdi'
    },
    {
        'vendor': 'Ayla Networks, Inc.',
        'product': 'Ayla Platform'
    },
    {
        'vendor': 'Azalea Health',
        'product': 'Azalea EHR'
    },
    {
        'vendor': 'Azalea Health',
        'product': 'Azalea Health'
    },
    {
        'vendor': 'Azendoo SAS',
        'product': 'Azendoo'
    },
    {
        'vendor': 'Open Source',
        'product': 'Azkaban'
    },
    {
        'vendor': 'Azteca Systems, LLC',
        'product': 'Azteca Cityworks'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure API Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Active Directory'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Active Directory Domain Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Analysis Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure App Configuration'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Application Gateway'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Application Insights'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Arc'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Archive Storage'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Artifacts'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Bastion'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Batch'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Blob Storage'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Blockchain Workbench'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Blueprints'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Boards'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure CDN'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Cache for Redis'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Cloud Shell'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Cognitive Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Computer Vision'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Cosmos DB'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Cost Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Custom Vision'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure CycleCloud'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure DDoS Protection'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure DNS'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Data Explorer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Data Factory'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Data Lake Analytics'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Data Lake Storage'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Data Science Virtual Machines'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Database for MySQL'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Database for PostgreSQL'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Databricks'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Dedicated HSM'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Defender'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure DevTest Labs'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Disk Storage'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Event Hubs'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure ExpressRoute'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Face'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Files'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure HDInsight'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Hosting'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Information Protection'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Key Vault'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Kubernetes Service (AKS)'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Language Understanding'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Lighthouse'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Linux Virtual Machines'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Load Balancer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Log Analytics'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Machine Learning'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Media Player'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Migrate'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Monitor'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Pipelines'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure PlayFab'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Policy'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure QnA Maker'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Repos'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Resource Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure SQL Data Warehouse'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Security Centre'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Sentinel'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Service Fabric'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Service Health'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Site Recovery'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Stack'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Stack HCI'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Storage Explorer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Stream Analytics'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Synapse'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Test Plans'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Text Analytics'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Traffic Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Translator'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure VPN Gateway'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Video Indexer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Virtual WAN'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Visual Studio Code'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Web App for Containers'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Web Application Firewall (WAF)'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Web Apps'
    },
    {
        'vendor': 'AzureDesk, Inc.',
        'product': 'AzureDesk'
    },
    {
        'vendor': 'Tero Consulting, Ltd.',
        'product': 'Azzier CMMS'
    },
    {
        'vendor': 'Azzly, Inc.',
        'product': 'Azzly'
    },
    {
        'vendor': 'B2W Software, Inc.',
        'product': 'B2W Estimate'
    },
    {
        'vendor': 'B2W Software, Inc.',
        'product': 'B2W Track'
    },
    {
        'vendor': 'BA Insight',
        'product': 'BA Insight'
    },
    {
        'vendor': 'BAE Systems PLC',
        'product': 'BAE NetReveal'
    },
    {
        'vendor': 'BAE Systems PLC',
        'product': 'BAE Norkom'
    },
    {
        'vendor': 'BAE Systems PLC',
        'product': 'BAE Systems Applied Intelligence'
    },
    {
        'vendor': 'Base, Inc.',
        'product': 'BASE'
    },
    {
        'vendor': 'Council of Better Business Bureaus, Inc.',
        'product': 'BBB Dynamic Seal'
    },
    {
        'vendor': 'BCD Travel Services B.V.',
        'product': 'BCD Travel'
    },
    {
        'vendor': 'BCGSoft Co, Ltd.',
        'product': 'BCGSoft'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'BD Alaris'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'BD MedMined'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'BD Pyxis'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'BD Pyxis IV Prep'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'BD Pyxis PARx'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'BEA Systems'
    },
    {
        'vendor': 'BEC Legal Systems',
        'product': 'BEC Legal Systems'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'BELLIN'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 10000s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 10050s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 10200v'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 10250v'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 4000s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 4200v'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 5000s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 5050s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 5200v'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 5250v'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 7000s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 7050s'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 7200v'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'BIG-IP 7250v'
    },
    {
        'vendor': 'Virtual Construction and Technology BIM One, Inc.',
        'product': 'BIM Track'
    },
    {
        'vendor': 'CSi International',
        'product': 'BIM-EDIT'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'BIOVIA Assay Explorer'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'BIOVIA Pipeline Pilot'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'BIOVIA Workbook'
    },
    {
        'vendor': 'BIPO Service, Ltd.',
        'product': 'BIPO'
    },
    {
        'vendor': 'BIS Training Solutions',
        'product': 'BIStrainer'
    },
    {
        'vendor': 'BITWORKS EDV-Dienstleistungs GmbH',
        'product': 'BITqms'
    },
    {
        'vendor': 'Blue Software, LLC',
        'product': 'BLUE'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Application Performance Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Apptune for DB2'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Atrium CMDB'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Capacity Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Client Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Cloud Lifecycle Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Control-D'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Control-M'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Control-O'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Control-SA'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC DASD Manager'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC FootPrints'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Helix Digital Workplace'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Helix Discovery'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Helix ITSM'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Helix Remedyforce'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC MainView Systems Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Marimba'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Middleware Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Performance for DB2'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Recovery for DB2'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Remedy ARS'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Remedy Encryption'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Remedy Service Desk'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Service Desk Express'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Service Impact Manager'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Software'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Track-It!'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight Automation for Servers'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight Operations Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight Server Automation'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight Transaction Monitor'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight Vulnerability Management'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC ULTRAOPT'
    },
    {
        'vendor': 'BMT Micro, Inc.',
        'product': 'BMT Micro'
    },
    {
        'vendor': 'BOARD International S.A.',
        'product': 'BOARD'
    },
    {
        'vendor': 'Business Oriented Software Solutions, Inc.',
        'product': 'BOSS Support Central'
    },
    {
        'vendor': 'BP Logix, Inc.',
        'product': 'BP Logix'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'BRIO'
    },
    {
        'vendor': 'BRIT Systems',
        'product': 'BRIT Systems'
    },
    {
        'vendor': 'BROWZ, LLC',
        'product': 'BROWZ'
    },
    {
        'vendor': 'Building Systems Design, Inc.',
        'product': 'BSD SpecLink'
    },
    {
        'vendor': 'Bsquare Corporation',
        'product': 'BSQUARE'
    },
    {
        'vendor': 'BST Global',
        'product': 'BST Global'
    },
    {
        'vendor': 'BT Global Services',
        'product': 'BT Cloud Compute'
    },
    {
        'vendor': 'Calleva Networks',
        'product': 'BT Diamond IP'
    },
    {
        'vendor': 'Aptos, Inc.',
        'product': 'BT Fresca'
    },
    {
        'vendor': 'Develisys Corporation',
        'product': 'BV Commerce'
    },
    {
        'vendor': 'Bureau van Dijk Electronic Publishing B.V.',
        'product': 'BVD Mint Global'
    },
    {
        'vendor': 'Bureau van Dijk Electronic Publishing B.V.',
        'product': 'BVD Orbis'
    },
    {
        'vendor': 'BWise',
        'product': 'BWise'
    },
    {
        'vendor': 'Babelway S.A.',
        'product': 'Babelway'
    },
    {
        'vendor': 'Bablic, Ltd.',
        'product': 'Bablic'
    },
    {
        'vendor': 'Babtec Informationssysteme GmbH',
        'product': 'Babtec Q'
    },
    {
        'vendor': 'BackChart, LLC',
        'product': 'BackChart'
    },
    {
        'vendor': 'Backbase B.V.',
        'product': 'Backbase'
    },
    {
        'vendor': 'Backblaze, Inc.',
        'product': 'Backblaze'
    },
    {
        'vendor': 'Open Source',
        'product': 'BackstopJS'
    },
    {
        'vendor': 'S.C. Softland S.R.L.',
        'product': 'Backup4all'
    },
    {
        'vendor': 'Backupify, Inc.',
        'product': 'Backupify'
    },
    {
        'vendor': 'Clevermed, Ltd.',
        'product': 'BadgerNet Maternity'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Badgeville'
    },
    {
        'vendor': 'Baidu, Inc.',
        'product': 'Baidu'
    },
    {
        'vendor': 'Baidu, Inc.',
        'product': 'Baidu Cloud'
    },
    {
        'vendor': 'Baidu, Inc.',
        'product': 'Baidu Core'
    },
    {
        'vendor': 'Baidu, Inc.',
        'product': 'Baidu Maps'
    },
    {
        'vendor': 'Baidu, Inc.',
        'product': 'Baidu Search'
    },
    {
        'vendor': 'Baker Company',
        'product': 'Baker EdgeGARD'
    },
    {
        'vendor': 'Balena',
        'product': 'Balena'
    },
    {
        'vendor': 'EMX Digital, LLC',
        'product': 'Balihoo'
    },
    {
        'vendor': 'Balsamiq Studios, LLC',
        'product': 'Balsamiq'
    },
    {
        'vendor': 'Bamboo Rose, LLC',
        'product': 'Bamboo Rose'
    },
    {
        'vendor': 'Bamboo HR, LLC',
        'product': 'BambooHR'
    },
    {
        'vendor': 'Bancontact Payconiq Company',
        'product': 'Bancontact'
    },
    {
        'vendor': 'Python Software Foundation',
        'product': 'Bandit'
    },
    {
        'vendor': 'Bandsintown, LLC',
        'product': 'Bandsintown'
    },
    {
        'vendor': 'Creatopy',
        'product': 'Bannersnack'
    },
    {
        'vendor': 'Baozun, Inc.',
        'product': 'Baozun'
    },
    {
        'vendor': 'BarScan, Inc.',
        'product': 'BarScan'
    },
    {
        'vendor': 'Barclays Bank PLC',
        'product': 'Barclaycard Smartpay'
    },
    {
        'vendor': 'Barilliance, Ltd.',
        'product': 'Barilliance'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Backup'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda CloudGen Firewall'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Email Security Service'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Essentials'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Link Balancer'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Load Balancer'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Load Balancer ADC'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Message Archiver'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda NG Firewall'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Networks (Unspecified Product)'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda SSL VPN'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Spam & Virus Firewall'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Spam Firewall'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Web Application Firewall'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Web Security Gateway'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'Base SAS'
    },
    {
        'vendor': 'BaseX GmbH',
        'product': 'BaseX'
    },
    {
        'vendor': 'Basecamp, LLC',
        'product': 'Basecamp'
    },
    {
        'vendor': 'Baseplan Software Group',
        'product': 'Baseplan'
    },
    {
        'vendor': 'Basho Technologies',
        'product': 'Basho Riak'
    },
    {
        'vendor': 'Jellyware Corporation',
        'product': 'BasicFunder'
    },
    {
        'vendor': 'Centro, Inc.',
        'product': 'Basis DSP'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware AP Automation'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Accounts Receivable'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Analytics'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Business Consulting'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Financing Services'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Network'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Source to Pay'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Travel & Expense Management'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware Verian'
    },
    {
        'vendor': 'Basware Corporation',
        'product': 'Basware e-Procurement'
    },
    {
        'vendor': 'BatchMaster Software',
        'product': 'BatchMaster'
    },
    {
        'vendor': 'BatchBlue Software, LLC',
        'product': 'Batchbook'
    },
    {
        'vendor': 'Baxter International, Inc.',
        'product': 'Baxter Baxa'
    },
    {
        'vendor': 'Baxter International, Inc.',
        'product': 'Baxter Colleague CX'
    },
    {
        'vendor': 'Baxter International, Inc.',
        'product': 'Baxter DoseEdge'
    },
    {
        'vendor': 'Baxter International, Inc.',
        'product': 'Baxter Healthcare'
    },
    {
        'vendor': 'Baxter Planning Systems, Inc.',
        'product': 'Baxter Planning'
    },
    {
        'vendor': 'Baxter International, Inc.',
        'product': 'Baxter Sigma Spectrum'
    },
    {
        'vendor': 'RecordsOne, LLC',
        'product': 'BayScribe'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'BayStack'
    },
    {
        'vendor': 'Bay Technical Associates, Inc.',
        'product': 'BayTech'
    },
    {
        'vendor': 'Canonical, Ltd.',
        'product': 'Bazaar'
    },
    {
        'vendor': 'Bazaarvoice, Inc.',
        'product': 'Bazaarvoice'
    },
    {
        'vendor': 'Beamery, Ltd.',
        'product': 'Beamery'
    },
    {
        'vendor': 'Beanworks Solutions, Inc.',
        'product': 'Beanworks'
    },
    {
        'vendor': 'BearingPoint B.V.',
        'product': 'BearingPoint'
    },
    {
        'vendor': 'BearingPoint B.V.',
        'product': 'BearingPoint Infonova'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Beats'
    },
    {
        'vendor': 'Beautiful Slides, Inc.',
        'product': 'Beautiful.ai'
    },
    {
        'vendor': 'Beckman Coulter, Inc.',
        'product': 'Beckman Coulter MicroScan'
    },
    {
        'vendor': 'Beckwith Electric Company, Inc.',
        'product': 'Beckwith Electric'
    },
    {
        'vendor': 'Excel Medical Electronics, LLC',
        'product': 'BedMasterEx'
    },
    {
        'vendor': 'ThinkParQ GmbH',
        'product': 'BeeGFS'
    },
    {
        'vendor': 'Beekeeper AG',
        'product': 'Beekeeper'
    },
    {
        'vendor': 'Beeketing, Inc.',
        'product': 'Beeketing'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline Contingent Staffing'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline Report Builder'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline Resource Tracking'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline Services Procurement'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline SmartView Data Analytics'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline Talent Acquisition'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline VMS'
    },
    {
        'vendor': 'Beeline.com, Inc.',
        'product': 'Beeline Workforce Management'
    },
    {
        'vendor': 'Behavox, Ltd.',
        'product': 'Behavox'
    },
    {
        'vendor': 'Beijing Beisen Cloud Computing Company, Ltd.',
        'product': 'Beisen'
    },
    {
        'vendor': 'Benchling, Inc.',
        'product': 'Benchling'
    },
    {
        'vendor': 'Benchmark Internet Group',
        'product': 'Benchmark Email'
    },
    {
        'vendor': 'BenefitMall, Inc.',
        'product': 'BenefitMall (Unspecified Product)'
    },
    {
        'vendor': 'BenefitMall, Inc.',
        'product': 'BenefitMall PayFocus'
    },
    {
        'vendor': 'Benefitfocus, Inc.',
        'product': 'Benefitfocus'
    },
    {
        'vendor': 'Benelogic, LLC',
        'product': 'Benelogic'
    },
    {
        'vendor': 'Benevity, Inc.',
        'product': 'Benevity'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley (Unspecified Product)'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley AECOsim'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley Architecture'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley AssetWise'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley AutoPIPE'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley AutoPLANT'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley CivilStorm'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley ConstructSim'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley CulvertMaster'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley Descartes'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley FlowMaster'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley GEOPAK'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley Hevacomp'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley InRoads'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley InspectTech'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley MAXSURF'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley MicroStation'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley Navigator'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenBuildings Designer'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenBuildings Speedikon'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenFlows'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenFlows SewerCAD'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenFlows StormCAD'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenPlant'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenRoads'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenRoads Designer'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley OpenSite'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley PondPack'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley PowerCivil'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley ProSteel'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley ProStructures'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley ProjectWise'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley ProjectWise Construction Management'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley RAM'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley RAM Concept'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley RAM Connection'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley Rail Network Design'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley SITEOPS'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley STAAD'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley SUPERLOAD'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley SewerGEMS'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley WaterCAD'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley WaterGEMS'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'Bentley gINT'
    },
    {
        'vendor': 'Grab Holdings, Inc.',
        'product': 'Bento'
    },
    {
        'vendor': 'Capsule Technologies, Inc.',
        'product': 'Bernoulli One'
    },
    {
        'vendor': 'Bersoft Software & Technology',
        'product': 'Bersoft'
    },
    {
        'vendor': 'BestNotes, LLC',
        'product': 'BestNotes'
    },
    {
        'vendor': 'BetterCloud, Inc.',
        'product': 'BetterCloud'
    },
    {
        'vendor': 'BetterUp, Inc.',
        'product': 'BetterUp'
    },
    {
        'vendor': 'BetterWorks Systems, Inc.',
        'product': 'BetterWorks'
    },
    {
        'vendor': 'Betty Blocks B.V.',
        'product': 'Betty Blocks'
    },
    {
        'vendor': 'Bevi',
        'product': 'Bevi'
    },
    {
        'vendor': 'Bevy Labs, Inc.',
        'product': 'Bevy'
    },
    {
        'vendor': 'Beyond Limits, Inc.',
        'product': 'Beyond Limits'
    },
    {
        'vendor': 'BeyondTrust Corporation',
        'product': 'BeyondTrust'
    },
    {
        'vendor': 'BeyondTrust Corporation',
        'product': 'BeyondTrust Remote Support'
    },
    {
        'vendor': 'BiZZdesign B.V.',
        'product': 'BiZZdesign'
    },
    {
        'vendor': 'OneCause, Inc.',
        'product': 'BidPal'
    },
    {
        'vendor': 'Eleco PLC',
        'product': 'Bidcon'
    },
    {
        'vendor': 'Top Echelon',
        'product': 'Big Biller'
    },
    {
        'vendor': 'Big Cartel, LLC',
        'product': 'Big Cartel'
    },
    {
        'vendor': 'Big Switch Networks, Inc.',
        'product': 'Big Switch Networks'
    },
    {
        'vendor': 'BigCommerce Pty Ltd',
        'product': 'BigCommerce'
    },
    {
        'vendor': 'BigContacts, LLC',
        'product': 'BigContacts'
    },
    {
        'vendor': 'BigHand, Ltd.',
        'product': 'BigHand'
    },
    {
        'vendor': 'BigID, Inc.',
        'product': 'BigID'
    },
    {
        'vendor': 'BigML, Inc.',
        'product': 'BigML'
    },
    {
        'vendor': 'BigPanda, Inc.',
        'product': 'BigPanda'
    },
    {
        'vendor': 'Newfold Digital, Inc.',
        'product': 'BigRock'
    },
    {
        'vendor': 'BigTime Software, Inc.',
        'product': 'BigTime'
    },
    {
        'vendor': 'Dude Solutions, Inc.',
        'product': 'Bigfoot CMMS'
    },
    {
        'vendor': 'BigTinCan Mobile Pty Ltd',
        'product': 'Bigtincan'
    },
    {
        'vendor': 'Bill.com, LLC',
        'product': 'Bill.com'
    },
    {
        'vendor': 'Bill4Time, LLC',
        'product': 'Bill4Time'
    },
    {
        'vendor': 'BQE Software, Inc.',
        'product': 'BillQuick'
    },
    {
        'vendor': 'Billtrust',
        'product': 'BillTrust'
    },
    {
        'vendor': 'BillingPlatform, LLC',
        'product': 'BillingPlatform'
    },
    {
        'vendor': 'Binary Defense Systems, LLC',
        'product': 'Binary Defense'
    },
    {
        'vendor': 'Internet Systems Consortium, Inc.',
        'product': 'Bind 9'
    },
    {
        'vendor': 'Binero AB',
        'product': 'Binero'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Bing Maps'
    },
    {
        'vendor': 'Bio-Optronics, Inc.',
        'product': 'Bio-Optronics Clinical Conductor'
    },
    {
        'vendor': 'BioCatch, Ltd.',
        'product': 'BioCatch'
    },
    {
        'vendor': 'BioClinica, Inc.',
        'product': 'BioClinica'
    },
    {
        'vendor': 'BioClinica, Inc.',
        'product': 'Bioclinica CTMS'
    },
    {
        'vendor': 'BioClinica, Inc.',
        'product': 'Bioclinica EDC'
    },
    {
        'vendor': 'BirchStreet Systems, Inc.',
        'product': 'BirchStreet'
    },
    {
        'vendor': 'BirdDogHR, Inc.',
        'product': 'BirdDogHR'
    },
    {
        'vendor': 'BirdEye, Inc.',
        'product': 'BirdEye'
    },
    {
        'vendor': 'Birst, Inc.',
        'product': 'Birst'
    },
    {
        'vendor': 'Biscom, Inc.',
        'product': 'Biscom'
    },
    {
        'vendor': 'Bissantz & Company GmbH',
        'product': 'Bissantz'
    },
    {
        'vendor': 'BitGravity',
        'product': 'BitGravity'
    },
    {
        'vendor': 'BitPay, Inc.',
        'product': 'BitPay'
    },
    {
        'vendor': 'BitTitan, Inc.',
        'product': 'BitTitan'
    },
    {
        'vendor': 'BITAM de Mexico, S.A. de C.V.',
        'product': 'Bitam'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'Bitbar'
    },
    {
        'vendor': 'S.C. BITDEFENDER S.R.L.',
        'product': 'Bitdefender'
    },
    {
        'vendor': 'Bitglass, Inc.',
        'product': 'Bitglass'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Bitium'
    },
    {
        'vendor': 'Bitmovin, Inc.',
        'product': 'Bitmovin'
    },
    {
        'vendor': 'BitRock, Inc.',
        'product': 'Bitnami'
    },
    {
        'vendor': 'Bitrix, Inc.',
        'product': 'Bitrix24'
    },
    {
        'vendor': 'BitSight Technologies, Inc.',
        'product': 'Bitsight'
    },
    {
        'vendor': 'Bitwarden, Inc.',
        'product': 'Bitwarden'
    },
    {
        'vendor': 'BizFlow Corporation',
        'product': 'BizFlow'
    },
    {
        'vendor': 'Business Training Library',
        'product': 'BizLibrary'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server 2009'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server 2010'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server 2013'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server 2013 R2'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server 2016'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BizTalk Server 2020'
    },
    {
        'vendor': 'Bizagi, Ltd.',
        'product': 'Bizagi'
    },
    {
        'vendor': 'Bizible, Inc.',
        'product': 'Bizible'
    },
    {
        'vendor': 'Bizimply, Ltd.',
        'product': 'Bizimply'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'Bizo'
    },
    {
        'vendor': 'Bizzabo, Inc.',
        'product': 'Bizzabo'
    },
    {
        'vendor': 'Black Duck Software, Inc.',
        'product': 'Black Duck'
    },
    {
        'vendor': 'Black Knight, Inc.',
        'product': 'Black Knight'
    },
    {
        'vendor': 'Blackbag Technologies, Inc.',
        'product': 'BlackBag'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BlackBerry'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BlackBerry AtHoc'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BlackBerry Enterprise Mobility Suite'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BlackBerry Unified Endpoint Management (UEM)'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BlackBerry Unified Endpoint Manager'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BlackBerry Workspaces'
    },
    {
        'vendor': 'Email Industries',
        'product': 'BlackBox'
    },
    {
        'vendor': 'BlackLine, Inc.',
        'product': 'BlackLine'
    },
    {
        'vendor': 'Blackstratus, Inc.',
        'product': 'BlackStratus'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud Award Management'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud Education Edge'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud Financial Edge'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud NetCommunity'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud Raiser\'s Edge NXT'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud eTapestry'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'Blackberry 10'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'Blackberry 5'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'Blackberry 6'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'Blackberry 7'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard (Unspecified Product)'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Analytics'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Angel LMS'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Collaborate'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Connect'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard CourseSites'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Engage'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Learn'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Managed Hosting'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Blackboard Mobile'
    },
    {
        'vendor': 'Blackmagic Design Pty Ltd',
        'product': 'Blackmagic Davinci Resolve'
    },
    {
        'vendor': 'Blackmagic Design Pty Ltd',
        'product': 'Blackmagic Design'
    },
    {
        'vendor': 'BlackRock, Inc.',
        'product': 'Blackrock Aladdin'
    },
    {
        'vendor': 'Blackthorn.io, Inc.',
        'product': 'Blackthorn'
    },
    {
        'vendor': 'Blameless, Inc.',
        'product': 'Blameless'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'BlazeMeter'
    },
    {
        'vendor': 'Blender Foundation',
        'product': 'Blender'
    },
    {
        'vendor': 'Phillips Data, Inc.',
        'product': 'Blesta'
    },
    {
        'vendor': 'Blinger, Ltd., LLC',
        'product': 'Blinger'
    },
    {
        'vendor': 'Disney Advertising Sales',
        'product': 'Blip'
    },
    {
        'vendor': 'BlipTV',
        'product': 'BlipTV'
    },
    {
        'vendor': 'Double A Solutions, LLC',
        'product': 'Blitz Lead Manager'
    },
    {
        'vendor': 'Conduent, Inc.',
        'product': 'BlitzDocs'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Blogger'
    },
    {
        'vendor': 'Blood Bank Computer Systems, Inc.',
        'product': 'Blood Bank Computer Systems'
    },
    {
        'vendor': 'BloomReach, Inc.',
        'product': 'BloomReach'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg AIM'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg BNA'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg Law'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg Professional Services'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg Tradebook'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg Vault'
    },
    {
        'vendor': 'Bloomerang, LLC',
        'product': 'Bloomerang'
    },
    {
        'vendor': 'Bloomfire, Inc.',
        'product': 'Bloomfire'
    },
    {
        'vendor': 'BloomReach, Inc.',
        'product': 'Bloomreach Experience Cloud'
    },
    {
        'vendor': 'BluJay Solutions, Ltd.',
        'product': 'BluJay (Unspecified Product)'
    },
    {
        'vendor': 'Blubrry Podcasting',
        'product': 'Blubrry'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Blue Coat'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Blue Coat NetCache'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Blue Coat PacketShaper'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Blue Coat PacketShaper 3500'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Blue Coat ProxyAV'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Blue Coat ProxySG'
    },
    {
        'vendor': 'Blue Link Associates, Ltd.',
        'product': 'Blue Link ERP'
    },
    {
        'vendor': 'Blue Marble Geographics, Inc.',
        'product': 'Blue Marble Global Mapper'
    },
    {
        'vendor': 'Blue Moon Software, Inc.',
        'product': 'Blue Moon'
    },
    {
        'vendor': 'Blue Pillar, Inc.',
        'product': 'Blue Pillar'
    },
    {
        'vendor': 'Blue Prism, Ltd.',
        'product': 'Blue Prism'
    },
    {
        'vendor': 'Blue Prism, Ltd.',
        'product': 'Blue Prism Cloud'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'Blue Yonder (Unspecified Product)'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'Blue Yonder Transportation'
    },
    {
        'vendor': 'BlueCat Networks, Inc.',
        'product': 'BlueCat Networks'
    },
    {
        'vendor': 'ALC, Inc.',
        'product': 'BlueCava'
    },
    {
        'vendor': 'Computer Generated Solutions, Inc.',
        'product': 'BlueCherry Enterprise Suite'
    },
    {
        'vendor': 'Bluecore, Inc.',
        'product': 'BlueCore'
    },
    {
        'vendor': 'BlueData Software, Inc.',
        'product': 'BlueData EPIC'
    },
    {
        'vendor': 'ValueBlue B.V.',
        'product': 'BlueDolphin'
    },
    {
        'vendor': 'BlueFolder Software, Inc.',
        'product': 'BlueFolder'
    },
    {
        'vendor': 'Digital River, Inc.',
        'product': 'BlueHornet'
    },
    {
        'vendor': 'Bluehost, Inc.',
        'product': 'BlueHost DNS'
    },
    {
        'vendor': 'Bluehost, Inc.',
        'product': 'BlueHost Hosting'
    },
    {
        'vendor': 'BlueJeans Network, Inc.',
        'product': 'BlueJeans'
    },
    {
        'vendor': 'BlueJeans Network, Inc.',
        'product': 'BlueJeans Command Center'
    },
    {
        'vendor': 'BlueJeans Network, Inc.',
        'product': 'BlueJeans Events'
    },
    {
        'vendor': 'BlueJeans Network, Inc.',
        'product': 'BlueJeans Meetings'
    },
    {
        'vendor': 'BlueJeans Network, Inc.',
        'product': 'BlueJeans Rooms'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'BlueKai'
    },
    {
        'vendor': 'BlueKanGo SAS',
        'product': 'BlueKanGo'
    },
    {
        'vendor': 'BlueSnap, Inc.',
        'product': 'BlueSnap'
    },
    {
        'vendor': 'BlueStep Systems',
        'product': 'BlueStep'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'BlueStripe'
    },
    {
        'vendor': 'BlueTie, Inc.',
        'product': 'BlueTie'
    },
    {
        'vendor': 'BlueVolt',
        'product': 'BlueVolt'
    },
    {
        'vendor': 'BlueVoyant',
        'product': 'BlueVoyant'
    },
    {
        'vendor': 'Nemetschek SE',
        'product': 'Bluebeam Revu'
    },
    {
        'vendor': 'Bluebird, Inc.',
        'product': 'Bluebird'
    },
    {
        'vendor': 'Bluefin Payment Systems, LLC',
        'product': 'Bluefin'
    },
    {
        'vendor': 'Bluefish',
        'product': 'Bluefish'
    },
    {
        'vendor': 'Bluehost, Inc.',
        'product': 'Bluehost'
    },
    {
        'vendor': 'BLUEKNOW S.L.',
        'product': 'Blueknow'
    },
    {
        'vendor': 'InterVision Systems, LLC',
        'product': 'Bluelock'
    },
    {
        'vendor': 'Blueprint Software Systems, Inc.',
        'product': 'Blueprint (Unspecified product)'
    },
    {
        'vendor': 'Blueprint Software Systems, Inc.',
        'product': 'Blueprint Storyteller'
    },
    {
        'vendor': 'Bluescape',
        'product': 'Bluescape'
    },
    {
        'vendor': 'Blueshift Labs, Inc.',
        'product': 'Blueshift'
    },
    {
        'vendor': 'Blynk, Inc.',
        'product': 'Blynk'
    },
    {
        'vendor': 'Digital Packager Corporation',
        'product': 'BoardPackager'
    },
    {
        'vendor': 'Nasdaq, Inc.',
        'product': 'Boardvantage'
    },
    {
        'vendor': 'Boardwalktech, Inc.',
        'product': 'Boardwalktech'
    },
    {
        'vendor': 'BobCAD-CAM, Inc.',
        'product': 'BobCAD-CAM'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'Bold360'
    },
    {
        'vendor': 'Bold Innovation Group, Ltd.',
        'product': 'BoldCommerce'
    },
    {
        'vendor': 'Bolt Financial, Inc.',
        'product': 'Bolt'
    },
    {
        'vendor': 'Bonitasoft S.A.',
        'product': 'Bonita BPM'
    },
    {
        'vendor': 'Bonusly',
        'product': 'Bonusly'
    },
    {
        'vendor': 'Bonzai Digital Pte Ltd',
        'product': 'Bonzai'
    },
    {
        'vendor': 'Boo-box',
        'product': 'Boo-box'
    },
    {
        'vendor': 'Book4Time, Inc.',
        'product': 'Book4Time'
    },
    {
        'vendor': 'BookaTable',
        'product': 'BookaTable'
    },
    {
        'vendor': 'Bookassist',
        'product': 'Bookassist'
    },
    {
        'vendor': 'Bookenda, Inc.',
        'product': 'Bookenda'
    },
    {
        'vendor': 'Bookeo Pty Ltd',
        'product': 'Bookeo'
    },
    {
        'vendor': 'BOOKER SOFTWARE, Inc.',
        'product': 'Booker'
    },
    {
        'vendor': 'Boomerang Commerce, Inc.',
        'product': 'Boomerang Commerce'
    },
    {
        'vendor': 'Boomset, Inc.',
        'product': 'Boomset'
    },
    {
        'vendor': 'BootstrapCDN',
        'product': 'BootstrapCDN'
    },
    {
        'vendor': 'Booz Allen Hamilton, Inc.',
        'product': 'Booz Allen Hamilton'
    },
    {
        'vendor': 'Borderfree, Inc.',
        'product': 'BorderFree'
    },
    {
        'vendor': 'Bosch.IO GmbH',
        'product': 'Bosch IoT Suite'
    },
    {
        'vendor': 'Boston Software Systems, Inc.',
        'product': 'Boston WorkStation'
    },
    {
        'vendor': 'MRI Software, LLC',
        'product': 'Bostonpost'
    },
    {
        'vendor': 'Imperva, Inc.',
        'product': 'Bot Management'
    },
    {
        'vendor': 'Botkeeper, Inc.',
        'product': 'Botkeeper'
    },
    {
        'vendor': 'Open Source',
        'product': 'Bottle'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline (Unspecified Product)'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Accounts Payable Automation'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Cyber Fraud and Risk Management'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Financial Document Automation'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Fraud and Financial Crime Management'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Optio'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Payments and Cash Management'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Paymode-X'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline TreasuryXpress'
    },
    {
        'vendor': 'BounceHelp, LLC',
        'product': 'BounceHelp'
    },
    {
        'vendor': 'Bourque Data Systems, Inc.',
        'product': 'Bourque Logistics'
    },
    {
        'vendor': 'Mtame, Inc.',
        'product': 'BowNow'
    },
    {
        'vendor': 'Box, Inc.',
        'product': 'Box'
    },
    {
        'vendor': 'Box, Inc.',
        'product': 'Box Drive'
    },
    {
        'vendor': 'Box, Inc.',
        'product': 'Box Sync'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'BoxTone'
    },
    {
        'vendor': 'Boxever, Ltd.',
        'product': 'Boxever'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Bradford Networks'
    },
    {
        'vendor': 'Bradoc Data Management, Inc.',
        'product': 'Bradoc'
    },
    {
        'vendor': 'BrainCert, Inc.',
        'product': 'BrainCert'
    },
    {
        'vendor': 'BrainStorm, Inc.',
        'product': 'BrainStorm'
    },
    {
        'vendor': 'Brainlab AG',
        'product': 'Brainlab'
    },
    {
        'vendor': 'Brainloop AG',
        'product': 'Brainloop'
    },
    {
        'vendor': 'Brainshark, Inc.',
        'product': 'Brainshark'
    },
    {
        'vendor': 'Reveal Data Corporation',
        'product': 'Brainspace'
    },
    {
        'vendor': 'Braintree',
        'product': 'Braintree'
    },
    {
        'vendor': 'Brainwave GRC, Inc.',
        'product': 'Brainwave Identity GRC'
    },
    {
        'vendor': 'Open Source',
        'product': 'Brakeman'
    },
    {
        'vendor': 'Branch Metrics, Inc.',
        'product': 'Branch'
    },
    {
        'vendor': 'Brand24 Global, Inc.',
        'product': 'Brand24'
    },
    {
        'vendor': 'Brandwizard Technologies, LLC',
        'product': 'BrandWizard'
    },
    {
        'vendor': 'Tinval Sistemes S.L.',
        'product': 'Brandchats'
    },
    {
        'vendor': 'Brandfolder, Inc.',
        'product': 'Brandfolder'
    },
    {
        'vendor': 'Brandify',
        'product': 'Brandify'
    },
    {
        'vendor': 'BrandMaker GmbH',
        'product': 'Brandmaker'
    },
    {
        'vendor': 'BrandMuscle, Inc.',
        'product': 'Brandmuscle'
    },
    {
        'vendor': 'Brandscopic',
        'product': 'Brandscopic'
    },
    {
        'vendor': 'Brandwatch',
        'product': 'Brandwatch'
    },
    {
        'vendor': 'Brandworkz, Ltd.',
        'product': 'Brandworkz'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'BravoSolution'
    },
    {
        'vendor': 'Braze, Inc.',
        'product': 'Braze'
    },
    {
        'vendor': 'Bread and Bread Operations',
        'product': 'Bread'
    },
    {
        'vendor': 'Medical Graphics Corporation',
        'product': 'BreezeSuite'
    },
    {
        'vendor': 'Breezeworks Corporation',
        'product': 'Breezeworks'
    },
    {
        'vendor': 'Breezy HR, Inc.',
        'product': 'Breezy HR'
    },
    {
        'vendor': 'Brekeke Software, Inc.',
        'product': 'Brekeke PBX'
    },
    {
        'vendor': 'Brex, Inc.',
        'product': 'Brex'
    },
    {
        'vendor': 'SO Technologies, Inc.',
        'product': 'Brick'
    },
    {
        'vendor': 'Brick Street Software, Inc.',
        'product': 'Brick Street Software'
    },
    {
        'vendor': 'Bricsys N.V.',
        'product': 'Bricsys Bricscad'
    },
    {
        'vendor': 'Instructure, Inc.',
        'product': 'Bridge LMS'
    },
    {
        'vendor': 'BridgeHead Software, Ltd.',
        'product': 'BridgeHead MEDITECH Backup'
    },
    {
        'vendor': 'BridgeHead Software, Ltd.',
        'product': 'BridgeHead Software'
    },
    {
        'vendor': 'BridgeHead Software, Ltd.',
        'product': 'BridgeHead Unified Clinical Archive'
    },
    {
        'vendor': 'Bridgeline Digital, Inc.',
        'product': 'Bridgeline'
    },
    {
        'vendor': 'Amdocs Management, Ltd.',
        'product': 'Bridgewater Systems'
    },
    {
        'vendor': 'BriefCam, Ltd.',
        'product': 'BriefCam'
    },
    {
        'vendor': 'Bright Pattern, Inc.',
        'product': 'Bright Pattern'
    },
    {
        'vendor': 'BrightEdge Technologies, Inc.',
        'product': 'BrightEdge'
    },
    {
        'vendor': 'BrightGauge Software, Inc.',
        'product': 'BrightGauge'
    },
    {
        'vendor': 'BrightInfo',
        'product': 'BrightInfo'
    },
    {
        'vendor': 'Thesaurus Software, Ltd.',
        'product': 'BrightPay'
    },
    {
        'vendor': 'Verizon Media',
        'product': 'BrightRoll'
    },
    {
        'vendor': 'Bright Stores, Inc.',
        'product': 'BrightStores'
    },
    {
        'vendor': 'BrightTALK, Inc.',
        'product': 'BrightTALK'
    },
    {
        'vendor': 'BrightWork',
        'product': 'BrightWork'
    },
    {
        'vendor': 'Brightcove, Inc.',
        'product': 'Brightcove'
    },
    {
        'vendor': 'Brightcove, Inc.',
        'product': 'Brightcove Zencoder'
    },
    {
        'vendor': 'Brightidea, Inc.',
        'product': 'Brightidea'
    },
    {
        'vendor': 'Brightlocal, Ltd.',
        'product': 'Brightlocal'
    },
    {
        'vendor': 'BrightMove, Inc.',
        'product': 'Brightmove Recruiting'
    },
    {
        'vendor': 'Brightpearl, Ltd.',
        'product': 'Brightpearl'
    },
    {
        'vendor': 'Synage Software Pvt, Ltd.',
        'product': 'Brightpod'
    },
    {
        'vendor': 'Brightree, LLC',
        'product': 'Brightree HME'
    },
    {
        'vendor': 'D2L Corporation',
        'product': 'Brightspace'
    },
    {
        'vendor': 'Bringg Delivery Technologies, Ltd.',
        'product': 'Bringg'
    },
    {
        'vendor': 'PAR Technology Corporation',
        'product': 'Brink POS'
    },
    {
        'vendor': 'Brinqa, LLC',
        'product': 'Brinqa'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'BroadSoft'
    },
    {
        'vendor': 'Broadvoice, LLC',
        'product': 'BroadVoice'
    },
    {
        'vendor': 'BroadSoft, Inc.',
        'product': 'BroadWorks'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Broadcom (Unspecified Product)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Broadcom Advanced Authentication'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Broadcom CA'
    },
    {
        'vendor': 'Broadleaf Commerce, LLC',
        'product': 'Broadleaf Commerce'
    },
    {
        'vendor': 'Broadridge Financial Solutions, Inc.',
        'product': 'Broadridge'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade BigIron'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade BigIron RX Series'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade DCFM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade DCX Backbone Family'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade Fabric OS'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade FastIron Switches'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade ICX'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade IronView Network Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade MLX Series Routers'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade NetIron Switches'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade Network Advisor'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade Routers'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade ServerIron ADX Series'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade Switches'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade TurboIron 24X Switch'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Brocade X6 Director'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'Bromium'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'Bromium vSentry'
    },
    {
        'vendor': 'Brother International Corporation',
        'product': 'Brother MFC'
    },
    {
        'vendor': 'Brother International Corporation',
        'product': 'Brother OmniJoin'
    },
    {
        'vendor': 'Brown Paper Tickets, LLC',
        'product': 'Brown Paper Tickets'
    },
    {
        'vendor': 'TDG Corporation',
        'product': 'BrowseEmAll'
    },
    {
        'vendor': 'BrowserStack, Inc.',
        'product': 'BrowserStack'
    },
    {
        'vendor': 'Browserling, Inc.',
        'product': 'Browserling'
    },
    {
        'vendor': 'Open Source',
        'product': 'Browsershots'
    },
    {
        'vendor': 'BryterCX',
        'product': 'BryterCX'
    },
    {
        'vendor': 'Bubble Group, Inc.',
        'product': 'Bubble'
    },
    {
        'vendor': 'Ghostery, Inc.',
        'product': 'Bubblestat'
    },
    {
        'vendor': 'BDY Sp. z o.o. Sp. k.',
        'product': 'Buddy'
    },
    {
        'vendor': 'Automattic, Inc.',
        'product': 'BuddyPress'
    },
    {
        'vendor': 'XLerant, Inc.',
        'product': 'BudgetPak'
    },
    {
        'vendor': 'Budgetrac, LLC',
        'product': 'Budgetrac'
    },
    {
        'vendor': 'Buffalo Americas, Inc.',
        'product': 'Buffalo Technology'
    },
    {
        'vendor': 'Buffer, Inc.',
        'product': 'Buffer'
    },
    {
        'vendor': 'Macropod Software Pty Ltd',
        'product': 'BugHerd'
    },
    {
        'vendor': 'Bugsnag, Inc.',
        'product': 'Bugsnag'
    },
    {
        'vendor': 'WEBsina, Inc.',
        'product': 'Bugzero'
    },
    {
        'vendor': 'Mozilla Corporation',
        'product': 'Bugzilla'
    },
    {
        'vendor': 'Buildkite Pty Ltd',
        'product': 'BuildKite'
    },
    {
        'vendor': 'Buildtools, Inc.',
        'product': 'BuildTools'
    },
    {
        'vendor': 'Constellation HomeBuilder Systems, Inc.',
        'product': 'BuildTopia'
    },
    {
        'vendor': 'Open Source',
        'product': 'Buildbot'
    },
    {
        'vendor': 'BuilderMT, Inc.',
        'product': 'BuilderMT'
    },
    {
        'vendor': 'BuilderStorm, Ltd.',
        'product': 'BuilderStorm'
    },
    {
        'vendor': 'Buildertrend Solutions, Inc.',
        'product': 'BuilderTREND'
    },
    {
        'vendor': 'Building Engines, Inc.',
        'product': 'Building Engines Prism'
    },
    {
        'vendor': 'BuildingBlok Solutions',
        'product': 'BuildingBlok'
    },
    {
        'vendor': 'BuildingConnected, Inc.',
        'product': 'BuildingConnected'
    },
    {
        'vendor': 'BuildingLinkcom, LLC',
        'product': 'BuildingLink'
    },
    {
        'vendor': 'Buildium, LLC',
        'product': 'Buildium'
    },
    {
        'vendor': 'Buildium, LLC',
        'product': 'Buildium (Unspecified Product)'
    },
    {
        'vendor': 'Buildium, LLC',
        'product': 'Buildium Residential Properties'
    },
    {
        'vendor': 'Bullhorn, Inc.',
        'product': 'Bullhorn ATS'
    },
    {
        'vendor': 'Bullhorn, Inc.',
        'product': 'Bullhorn CRM'
    },
    {
        'vendor': 'Bunchball, Inc.',
        'product': 'Bunchball'
    },
    {
        'vendor': 'Bunnell, Inc.',
        'product': 'Bunnell'
    },
    {
        'vendor': 'Burrelle\'s Information Service, LLC',
        'product': 'Burrelles'
    },
    {
        'vendor': 'Burrelle\'s Information Service, LLC',
        'product': 'BurrellesLuce'
    },
    {
        'vendor': 'Business Wire, Inc.',
        'product': 'Business Wire'
    },
    {
        'vendor': 'Businessolver, Inc.',
        'product': 'Businessolver'
    },
    {
        'vendor': 'Open Source',
        'product': 'BusterJS'
    },
    {
        'vendor': 'Buurst, Inc.',
        'product': 'Buurst SoftNAS'
    },
    {
        'vendor': 'buySAFE, Inc.',
        'product': 'BuySafe'
    },
    {
        'vendor': 'BuySellAds.com, Inc.',
        'product': 'BuySellAds'
    },
    {
        'vendor': 'Buyapowa, Ltd.',
        'product': 'Buyapowa'
    },
    {
        'vendor': 'BuyerDeck, Ltd.',
        'product': 'BuyerDeck'
    },
    {
        'vendor': 'BuzzFeed, Inc.',
        'product': 'BuzzFeed'
    },
    {
        'vendor': 'Rel Equals, Inc.',
        'product': 'BuzzStream'
    },
    {
        'vendor': 'BuzzSumo, Ltd.',
        'product': 'BuzzSumo'
    },
    {
        'vendor': 'BuzzBoard, Inc.',
        'product': 'Buzzboard'
    },
    {
        'vendor': 'Aw-Tek, Ltd.',
        'product': 'Buzzdeck'
    },
    {
        'vendor': 'Buzzilla, Ltd.',
        'product': 'Buzzilla'
    },
    {
        'vendor': 'BySide S.A.',
        'product': 'BySide'
    },
    {
        'vendor': 'Bynder B.V.',
        'product': 'Bynder'
    },
    {
        'vendor': 'Byte Software, LLC',
        'product': 'Byte Software'
    },
    {
        'vendor': 'Beijing ByteDance Technology Company, Ltd.',
        'product': 'ByteDance'
    },
    {
        'vendor': 'Byteworx, Inc.',
        'product': 'Byteworx'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'Bytware'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'C++'
    },
    {
        'vendor': 'C2 Enterprise, Inc.',
        'product': 'C2 ATOM'
    },
    {
        'vendor': 'Clear C2, Inc.',
        'product': 'C2CRM'
    },
    {
        'vendor': 'C2FO, Ltd.',
        'product': 'C2FO'
    },
    {
        'vendor': 'Advanced Technology Group, Inc.',
        'product': 'C3'
    },
    {
        'vendor': 'C3, Inc.',
        'product': 'C3 Energy'
    },
    {
        'vendor': 'C3, Inc.',
        'product': 'C3 Platform'
    },
    {
        'vendor': 'C3, Inc.',
        'product': 'C3.ai'
    },
    {
        'vendor': 'C3i Solutions',
        'product': 'C3i Solutions'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA 1 Tape Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA 2E'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA 7'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA ACF2'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA ADS'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA API Gateway'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA API Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA ASM2'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA ASTEX'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Advanced Authentication'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Advantage VISION:Report'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Agile Central'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Agile Vision'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Aion Business Rules Expert'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA AppLogic'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Application Delivery Analysis'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Application Performance Management (APM)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Application Test'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Auditor'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Automation Point'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Automic One Automation Platform'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Bind Analyzer'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Bundl'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Business Service Insight'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA CMDB Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Capacity Manager'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Change Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Chorus Software Manager'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Clarity'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Cleanup'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Client Automation'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Compliance Event Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Compress'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Continuous Application Insight'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Culprit'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Customer Experience Manager (CEM)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA DADS'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Data Center Infrastructure Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Data Protection'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Database Performance Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Datacom'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Deliver'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Detector'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Directory'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Disk Backup and Restore'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Dispatch'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Dynam/D'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Dynam/T'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA EPIC'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Earl'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Easytrieve'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Endevor'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA FAQS Automated System Operation'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA FAVER VSAM Data Protection'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Fast Unload'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA File Master Plus'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Flowdock'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Gen'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Gener/OL'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA GigaStor'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Harvest SCM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Harvest Software Change Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Hyper-Buf'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA IDMS'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Ideal'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Identity Governance'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Identity Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Identity Portal'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA InfoRefiner'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Insight'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA InterTest'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA IntroScope'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA JARS'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA JCLCheck'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Jobtrac'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA LISA'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Librarian'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Log Analyzer'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA MICS Resource Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA MIM Resource Sharing'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA MLINK'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Mainframe Operational Intelligence'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA MasterCat VSAM Catalog Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA NSM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA NetMaster'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA NetQoS'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA NetQoS NetVoyant'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA NetQoS ReporterAnalyzer'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA NetQoS SuperAgent'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA NetSpy Network Performance'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Netman'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA PDSMAN'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA PanAPT'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA PanAudit Plus'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Panexec'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Panvalet'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Performance Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Plex'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Privileged Identity Manager'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Project Portfolio Management (PPM)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA RC/Compare'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA RC/Extract'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA RC/Migrator'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA RC/Query'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA RC/Secure'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA RC/Update'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Ramis'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Raps'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Release Automation'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Remote Console'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Repository'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Risk Authentication'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Roscoe'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA SOLVE:Access'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA SYSVIEW'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Scheduler'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Secure Cloud'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Server Automation'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Service Desk Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Service Management'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Service Virtualization'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Spectrum'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Strong Authentication'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA SymDump'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA TCPaccess'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA TLMS Tape Management'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA TPX'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA TPX Session Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA TSO/MON Performance Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Teleview'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Telon'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Top Secret'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA UFO'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Ucandu'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Unified Communications Monitor'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Unified Infrastructure Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA VISION:Builder'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA VM:Manager Suite'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Vantage'
    },
    {
        'vendor': 'CA Veracode, Inc.',
        'product': 'CA Veracode'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA View'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Virtual Assurance'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Virtual Assurance for Infrastructure Managers'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Vollie'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Wily (Assurance Suite)'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Wily APM'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'CA Workload Automation'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA XCOM Data Transport'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA eHealth'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA eTrust Admin'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA ecoSoftware'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'CABINET VISION'
    },
    {
        'vendor': 'Orange Technologies, Inc.',
        'product': 'CADPIPE'
    },
    {
        'vendor': 'Aurel Systems, Inc.',
        'product': 'CADSIM Plus'
    },
    {
        'vendor': 'Zuken UK, Ltd.',
        'product': 'CADSTAR'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'CAESAR II'
    },
    {
        'vendor': 'Idox PLC',
        'product': 'CAFM Explorer'
    },
    {
        'vendor': 'CALUMO, Inc.',
        'product': 'CALUMO'
    },
    {
        'vendor': 'Geometric Americas, Inc.',
        'product': 'CAMWorks'
    },
    {
        'vendor': 'CartoDB, Inc.',
        'product': 'CARTO'
    },
    {
        'vendor': 'Altus Assessments, Inc.',
        'product': 'CASPer'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'CATIA'
    },
    {
        'vendor': 'CATS Software, Inc.',
        'product': 'CATS ATS'
    },
    {
        'vendor': 'AssurX, Inc.',
        'product': 'CATSWeb'
    },
    {
        'vendor': 'CB Information Services, Inc.',
        'product': 'CB Insights'
    },
    {
        'vendor': 'The CBORD Group, Inc.',
        'product': 'CBORD'
    },
    {
        'vendor': 'CBRE Group, Inc.',
        'product': 'CBRE Facilities Management'
    },
    {
        'vendor': 'CCBill, LLC',
        'product': 'CCBill'
    },
    {
        'vendor': 'CCC Information Services, Inc.',
        'product': 'CCC ONE'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'CCH Axcess'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'CCH SureTax Calc'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'CCH SureTax Platform'
    },
    {
        'vendor': 'Tagetik Software S.R.L.',
        'product': 'CCH Tagetik'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'CDC'
    },
    {
        'vendor': 'CDK Global, LLC',
        'product': 'CDK Desking'
    },
    {
        'vendor': 'CDK Global, LLC',
        'product': 'CDK Global Payroll Plus'
    },
    {
        'vendor': 'CDN77',
        'product': 'CDN77'
    },
    {
        'vendor': 'CDNetworks, Inc.',
        'product': 'CDNetworks'
    },
    {
        'vendor': 'CDNetworks, Inc.',
        'product': 'CDNetworks Cloud DNS+'
    },
    {
        'vendor': 'CDNify, Ltd.',
        'product': 'CDNify'
    },
    {
        'vendor': 'Thinkproject Deutschland GmbH',
        'product': 'CEMAR'
    },
    {
        'vendor': 'Northern.tech AS',
        'product': 'CFEngine'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI ACAPS'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI ACLS'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI Advantage'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI CACS Enterprise'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI MPower'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI MVest'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI MView'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI Momentum'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI PragmaCAD'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI Ratabase'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI Sovera'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI Strata'
    },
    {
        'vendor': 'CGI, Inc.',
        'product': 'CGI Tapestry'
    },
    {
        'vendor': 'CompuGroup Medical SE',
        'product': 'CGM Clinical'
    },
    {
        'vendor': 'CompuGroup Medical SE',
        'product': 'CGM DAQbilling'
    },
    {
        'vendor': 'CompuGroup Medical SE',
        'product': 'CGM eMEDIX'
    },
    {
        'vendor': 'CompuGroup Medical SE',
        'product': 'CGM webEHR'
    },
    {
        'vendor': 'C.H. Robinson Worldwide, Inc.',
        'product': 'CH Robinson Supply Chain'
    },
    {
        'vendor': 'CHAMPS Software, Inc.',
        'product': 'CHAMPS CMMS'
    },
    {
        'vendor': 'CHARMM',
        'product': 'CHARMM'
    },
    {
        'vendor': 'Nexus-Chili GmbH',
        'product': 'CHILI PACS'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'CIF 20/20'
    },
    {
        'vendor': 'Ramaker & Associates, Inc.',
        'product': 'CIMS Light'
    },
    {
        'vendor': 'Ramaker & Associates, Inc.',
        'product': 'CIMS Light Cloud'
    },
    {
        'vendor': 'CINC Systems, LLC',
        'product': 'CINC'
    },
    {
        'vendor': 'CIPHR, Ltd.',
        'product': 'CIPHR'
    },
    {
        'vendor': 'CM Commerce',
        'product': 'CM Commerce'
    },
    {
        'vendor': 'Professional Systems Associates, Inc.',
        'product': 'CMPRO'
    },
    {
        'vendor': 'Computer Methods International Corporation',
        'product': 'CMiC'
    },
    {
        'vendor': 'Computer Methods International Corporation',
        'product': 'CMiC Enterprise Planning'
    },
    {
        'vendor': 'Computer Methods International Corporation',
        'product': 'CMiC FIELD'
    },
    {
        'vendor': 'Computer Methods International Corporation',
        'product': 'CMiC Project Controls'
    },
    {
        'vendor': 'CNC Software, Inc.',
        'product': 'CNC Software'
    },
    {
        'vendor': 'Cobis Systems Corporation',
        'product': 'COBIS'
    },
    {
        'vendor': 'General Technology',
        'product': 'COBOL'
    },
    {
        'vendor': 'COGZ Systems, LLC',
        'product': 'COGZ'
    },
    {
        'vendor': 'Construction Industry Solutions, Ltd.',
        'product': 'COINS'
    },
    {
        'vendor': 'Comcash, Inc.',
        'product': 'COMCASH ERP'
    },
    {
        'vendor': 'Avionte, LLC',
        'product': 'COMPAS'
    },
    {
        'vendor': 'COMSOL, Inc.',
        'product': 'COMSOL'
    },
    {
        'vendor': 'COOP Systems, Inc.',
        'product': 'COOP Systems'
    },
    {
        'vendor': 'COPRA System GmbH',
        'product': 'COPRA PDMS'
    },
    {
        'vendor': 'CORESense, Inc.',
        'product': 'CORESense'
    },
    {
        'vendor': 'Constellation Software, Inc.',
        'product': 'CORESense Connect'
    },
    {
        'vendor': 'CP2K',
        'product': 'CP2K'
    },
    {
        'vendor': 'CPA Global, Ltd.',
        'product': 'CPA IP Management System'
    },
    {
        'vendor': 'CPMStar',
        'product': 'CPMStar'
    },
    {
        'vendor': 'CPSI',
        'product': 'CPSI (Unspecified Product)'
    },
    {
        'vendor': 'CQ-Roll Call, Inc.',
        'product': 'CQ'
    },
    {
        'vendor': 'Zuken UK, Ltd.',
        'product': 'CR-8000'
    },
    {
        'vendor': 'CR2',
        'product': 'CR2'
    },
    {
        'vendor': 'CREALOGIX AG',
        'product': 'CREALOGIX'
    },
    {
        'vendor': 'CRMnext',
        'product': 'CRMnext'
    },
    {
        'vendor': 'CRU Data Security Group, LLC',
        'product': 'CRU'
    },
    {
        'vendor': 'Crytek GmbH',
        'product': 'CRYENGINE'
    },
    {
        'vendor': 'Marsh Clearsight, LLC',
        'product': 'CS STARS'
    },
    {
        'vendor': 'Carestream Dental, LLC',
        'product': 'CS SoftDent'
    },
    {
        'vendor': 'CS-Cart',
        'product': 'CS-Cart'
    },
    {
        'vendor': 'CSAM Health AS',
        'product': 'CSAM ProSang'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'CSC (Unspecified Product)'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'CSC Corptax'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'CSC DNS'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'CSC Riskmaster'
    },
    {
        'vendor': 'CSG Systems International, Inc.',
        'product': 'CSG (Unspecified Product)'
    },
    {
        'vendor': 'CSG Systems International, Inc.',
        'product': 'CSG Assure'
    },
    {
        'vendor': 'CSG Systems International, Inc.',
        'product': 'CSG Interconnect'
    },
    {
        'vendor': 'Contractors Software Group, Inc.',
        'product': 'CSG Plus'
    },
    {
        'vendor': 'CSG Systems International, Inc.',
        'product': 'CSG Singleview'
    },
    {
        'vendor': 'Corporate Travel Management, Ltd.',
        'product': 'CTM'
    },
    {
        'vendor': 'Comcast Technology Solutions',
        'product': 'CTSuite'
    },
    {
        'vendor': 'CU Direct Corporation',
        'product': 'CU Direct Lending 360'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'CUnify'
    },
    {
        'vendor': 'CVISION Technologies, Inc.',
        'product': 'CVISION'
    },
    {
        'vendor': 'CVX Medical',
        'product': 'CVX CardioReport'
    },
    {
        'vendor': 'CYMA Systems, Inc.',
        'product': 'CYMA Systems'
    },
    {
        'vendor': 'Eaton Corporation',
        'product': 'CYME'
    },
    {
        'vendor': 'CaaStle, Inc.',
        'product': 'CaaStle'
    },
    {
        'vendor': 'CacheFly',
        'product': 'Cachefly'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence (Unspecified Product)'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence AWR AXIEM'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence Conformal Low Power'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence Innovus'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence JasperGold Formal Verification Platform'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence Modus DFT Software'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence Spectre Simulation Platform'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence Tempus Timing Signoff Solution'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'Cadence Virtuoso'
    },
    {
        'vendor': 'Cadent, LLC',
        'product': 'Cadent'
    },
    {
        'vendor': 'CadmiumCD, LLC',
        'product': 'CadmiumCD'
    },
    {
        'vendor': 'Cadsoft Corporation',
        'product': 'Cadsoft'
    },
    {
        'vendor': 'Cafe24 Corporation',
        'product': 'Cafe24 Nameserver'
    },
    {
        'vendor': 'Berkeley Artificial Intelligence Research (BAIR)',
        'product': 'Caffe'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Caffe2'
    },
    {
        'vendor': 'Cake',
        'product': 'Cake Marketing'
    },
    {
        'vendor': 'Cakewalk, Inc.',
        'product': 'Cakewalk'
    },
    {
        'vendor': 'Calabrio, Inc.',
        'product': 'Calabrio'
    },
    {
        'vendor': 'Calabrio, Inc.',
        'product': 'Calabrio Workforce Management'
    },
    {
        'vendor': 'Calameo SAS',
        'product': 'Calameo'
    },
    {
        'vendor': 'General Technology',
        'product': 'CalculiX'
    },
    {
        'vendor': 'Calendly, LLC',
        'product': 'Calendly'
    },
    {
        'vendor': 'Calero Software, LLC',
        'product': 'Calero Software'
    },
    {
        'vendor': 'Harris Computer Systems',
        'product': 'Caliber Public Safety'
    },
    {
        'vendor': 'Calibrus Call Center Services, LLC',
        'product': 'Calibrus'
    },
    {
        'vendor': 'Tigera, Inc.',
        'product': 'Calico'
    },
    {
        'vendor': 'Caliper Corporation',
        'product': 'Caliper'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'Calix'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'Calix AXOS E-Series'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'Calix C7'
    },
    {
        'vendor': 'Calix, Inc.',
        'product': 'Calix Gigabit Passive Optical Network'
    },
    {
        'vendor': 'Gaglers, Inc.',
        'product': 'CallHub'
    },
    {
        'vendor': 'CallMiner, Inc.',
        'product': 'CallMiner'
    },
    {
        'vendor': 'CallProof, LLC',
        'product': 'CallProof'
    },
    {
        'vendor': 'CallRail, Inc.',
        'product': 'CallRail'
    },
    {
        'vendor': 'CallSource, Inc.',
        'product': 'CallSource'
    },
    {
        'vendor': 'CallTools.com, Inc.',
        'product': 'CallTools'
    },
    {
        'vendor': 'CallTrackingMetrics, LLC',
        'product': 'CallTrackingMetrics'
    },
    {
        'vendor': 'Callidus Software, Inc.',
        'product': 'CallidusCloud'
    },
    {
        'vendor': 'Callsign, Inc.',
        'product': 'Callsign'
    },
    {
        'vendor': 'Calypso Technology, Inc.',
        'product': 'Calypso Technology'
    },
    {
        'vendor': 'Calyx Technology, Inc.',
        'product': 'Calyx'
    },
    {
        'vendor': 'Cambio Healthcare Systems AB',
        'product': 'Cambio Cosmic'
    },
    {
        'vendor': 'BrainRunner, Inc.',
        'product': 'CampBrain'
    },
    {
        'vendor': 'CampMinder, LLC',
        'product': 'CampMinder'
    },
    {
        'vendor': 'Pica9, Inc.',
        'product': 'CampaignDrive'
    },
    {
        'vendor': 'Campaign Monitor Pty Ltd',
        'product': 'CampaignMonitor'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'CampaignerCRM'
    },
    {
        'vendor': 'Campana Systems, Inc.',
        'product': 'Campana Goldcare'
    },
    {
        'vendor': 'Campayn',
        'product': 'Campayn'
    },
    {
        'vendor': 'Cottonwood Software, LLC',
        'product': 'Campground Master'
    },
    {
        'vendor': 'Anthology, Inc.',
        'product': 'Campus Management'
    },
    {
        'vendor': 'Camunda Services GmbH',
        'product': 'Camunda'
    },
    {
        'vendor': 'Candelis, Inc.',
        'product': 'Candelis'
    },
    {
        'vendor': 'Candelis, Inc.',
        'product': 'Candelis ImageGrid'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Aquilion'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Aquilion 16'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Aquilion 32'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Aquilion 4'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Aquilion 64'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Aquilion 8'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Asteion'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon CT'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Canofile'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon IRIS'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon ImagePress'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon ImagePress C1'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon ImagePress C7010VP'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon ImageRunner'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon MRI'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Multifunction Copiers'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Multifunction Devices'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Oce ColorStream'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Oce JetStream'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Oce PRISMAprepare'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Oce VarioPrint Production Equipment'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Oce VarioStream'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Oce Varioprint 120'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon PACS'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Pixma'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Printers'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Vantage Atlas'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Vantage Elan'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Vantage Titan'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Varioprint 110'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Vitrea'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon Voxar 3D'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon imageCLASS'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon imagePROGRAF'
    },
    {
        'vendor': 'Canon, Inc.',
        'product': 'Canon imageWARE'
    },
    {
        'vendor': 'Canonical, Ltd.',
        'product': 'Canonical Ubuntu'
    },
    {
        'vendor': 'Canopy Tax, Inc.',
        'product': 'Canopy Tax'
    },
    {
        'vendor': 'Cantata Health, LLC',
        'product': 'Cantata Health EHR'
    },
    {
        'vendor': 'Canto, Inc.',
        'product': 'Canto Cumulus'
    },
    {
        'vendor': 'Canva Pty Ltd',
        'product': 'Canva'
    },
    {
        'vendor': 'Instructure, Inc.',
        'product': 'Canvas Catalog'
    },
    {
        'vendor': 'Instructure, Inc.',
        'product': 'Canvas LMS'
    },
    {
        'vendor': 'Caphyon S.R.L.',
        'product': 'Caphyon'
    },
    {
        'vendor': 'Capita PLC',
        'product': 'Capita'
    },
    {
        'vendor': 'Capsule Technologies, Inc.',
        'product': 'Capsule Medical Device Information Platform'
    },
    {
        'vendor': 'Capsule8, Inc.',
        'product': 'Capsule8'
    },
    {
        'vendor': 'Zestia, Ltd.',
        'product': 'CapsuleCRM'
    },
    {
        'vendor': 'The Long Term Stock Exchange, Inc.',
        'product': 'Captable.io'
    },
    {
        'vendor': 'Captiv8, Inc.',
        'product': 'Captiv8'
    },
    {
        'vendor': 'CaptivateIQ, Inc.',
        'product': 'CaptivateIQ'
    },
    {
        'vendor': 'Captools Company',
        'product': 'Captools/net'
    },
    {
        'vendor': 'Captora, Inc.',
        'product': 'Captora'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'Capture'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Capybara'
    },
    {
        'vendor': 'Carbon Black, Inc.',
        'product': 'Carbon Black'
    },
    {
        'vendor': 'Carbonite, Inc.',
        'product': 'Carbonite'
    },
    {
        'vendor': 'Carbonite, Inc.',
        'product': 'Carbonite Double-Take'
    },
    {
        'vendor': 'ChatLead.com, Inc.',
        'product': 'Carchat24'
    },
    {
        'vendor': 'CardinalCommerce Corporation',
        'product': 'CardinalCommerce'
    },
    {
        'vendor': 'Lumedx Corporation',
        'product': 'CardioPACS'
    },
    {
        'vendor': 'Welch Allyn, Inc.',
        'product': 'CardioPerfect WorkStation'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Cardiology ECG Management'
    },
    {
        'vendor': 'Informatics Corporation of America',
        'product': 'CareAlign'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'CareAware VitalsLink'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'CareAware iBus'
    },
    {
        'vendor': 'CareCloud Corporation',
        'product': 'CareCloud'
    },
    {
        'vendor': 'CareEvolution, Inc.',
        'product': 'CareEvolution'
    },
    {
        'vendor': 'Becton, Dickinson and Company',
        'product': 'CareFusion'
    },
    {
        'vendor': 'Qualifacts Systems, Inc.',
        'product': 'CareLogic EHR'
    },
    {
        'vendor': 'CarePaths, Inc.',
        'product': 'CarePaths EHR'
    },
    {
        'vendor': 'ExlService Holdings, Inc.',
        'product': 'CareRadius'
    },
    {
        'vendor': 'Med Management Technologies, Inc.',
        'product': 'CareSuite'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'CareTend'
    },
    {
        'vendor': 'Care Systems, Inc.',
        'product': 'CareWare'
    },
    {
        'vendor': 'MCG Health, LLC',
        'product': 'CareWebQI'
    },
    {
        'vendor': 'CareerBuilder, LLC',
        'product': 'CareerBuilder (Unspecified Product)'
    },
    {
        'vendor': 'CareerPlug, LLC',
        'product': 'CareerPlug'
    },
    {
        'vendor': 'Carestream Dental, LLC',
        'product': 'Carestream'
    },
    {
        'vendor': 'Carestream Dental, LLC',
        'product': 'Carestream Directview'
    },
    {
        'vendor': 'Carestream Health, Inc.',
        'product': 'Carestream Vue PACS'
    },
    {
        'vendor': 'WiseTech Global, Ltd.',
        'product': 'CargoWise'
    },
    {
        'vendor': 'WiseTech Global, Ltd.',
        'product': 'CargoWise Enterprise'
    },
    {
        'vendor': 'WiseTech Global, Ltd.',
        'product': 'CargoWise Global Data'
    },
    {
        'vendor': 'WiseTech Global, Ltd.',
        'product': 'CargoWise Optimisation'
    },
    {
        'vendor': 'WiseTech Global, Ltd.',
        'product': 'CargoWise Transport'
    },
    {
        'vendor': 'WiseTech Global, Ltd.',
        'product': 'CargoWise Warehouse'
    },
    {
        'vendor': 'Caringo, Inc.',
        'product': 'Caringo Swarm'
    },
    {
        'vendor': 'Carlson Software',
        'product': 'Carlson Software (Unspecified Product)'
    },
    {
        'vendor': 'National Aeronautics and Space Administration (NASA)',
        'product': 'Cart3D'
    },
    {
        'vendor': 'CartStack, LLC',
        'product': 'CartStack'
    },
    {
        'vendor': 'Carta, Inc.',
        'product': 'Carta'
    },
    {
        'vendor': 'Cartasite, Inc.',
        'product': 'Cartasite'
    },
    {
        'vendor': 'AppDynamics, Inc.',
        'product': 'Cartweaver'
    },
    {
        'vendor': 'Casamba, Inc.',
        'product': 'Casamba'
    },
    {
        'vendor': 'Cascade Asset Management, LLC',
        'product': 'Cascade Asset Management'
    },
    {
        'vendor': 'Hannon Hill Corporation',
        'product': 'Cascade CMS'
    },
    {
        'vendor': 'Hannon Hill Corporation',
        'product': 'Cascade Server'
    },
    {
        'vendor': 'IRIS Software Group, Ltd.',
        'product': 'CascadeHR'
    },
    {
        'vendor': 'Casengo B.V.',
        'product': 'Casengo'
    },
    {
        'vendor': 'erwin, Inc.',
        'product': 'Casewise'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'CasperJS'
    },
    {
        'vendor': 'Caspio, Inc.',
        'product': 'Caspio'
    },
    {
        'vendor': 'Castle Intelligence, Inc.',
        'product': 'Castle'
    },
    {
        'vendor': 'Catalogic Software, Inc.',
        'product': 'Catalogic'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Catalyst Repository Systems'
    },
    {
        'vendor': 'Catchpoint Systems, Inc.',
        'product': 'Catchpoint'
    },
    {
        'vendor': 'Cato Networks, Ltd.',
        'product': 'Cato Networks'
    },
    {
        'vendor': 'Marshfield Clinic Health System',
        'product': 'CattailsMD'
    },
    {
        'vendor': 'CheeseCat Sp. z o.o.',
        'product': 'Catvertiser'
    },
    {
        'vendor': 'Cavirin Systems, Inc.',
        'product': 'Cavirin'
    },
    {
        'vendor': 'Cayenta',
        'product': 'Cayenta'
    },
    {
        'vendor': 'Cayzu, Inc.',
        'product': 'Cayzu'
    },
    {
        'vendor': 'Cazena, Inc.',
        'product': 'Cazena'
    },
    {
        'vendor': 'Cazoomi Technology Corporation',
        'product': 'Cazoomi'
    },
    {
        'vendor': 'Cbox',
        'product': 'Cbox'
    },
    {
        'vendor': 'Cedaron Medical, Inc.',
        'product': 'Cedaron'
    },
    {
        'vendor': 'Cedexis, Inc.',
        'product': 'Cedexis'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Cedexis Radar'
    },
    {
        'vendor': 'Cegid Group',
        'product': 'Cegid Payroll & Talent Management'
    },
    {
        'vendor': 'Cegid Group',
        'product': 'Cegid Talent Management'
    },
    {
        'vendor': 'Cegid Group',
        'product': 'Cegid XRP'
    },
    {
        'vendor': 'Celaton, Ltd.',
        'product': 'Celaton'
    },
    {
        'vendor': 'Celebros, Inc.',
        'product': 'Celebros'
    },
    {
        'vendor': 'D4t4 Solutions PLC',
        'product': 'Celebrus'
    },
    {
        'vendor': 'Celerant Technology Corporation',
        'product': 'Celerant'
    },
    {
        'vendor': 'Omni Computer Consulting',
        'product': 'CeleriTime'
    },
    {
        'vendor': 'Celeros, Inc.',
        'product': 'Celeros'
    },
    {
        'vendor': 'Celigo, Inc.',
        'product': 'Celigo'
    },
    {
        'vendor': 'CellTrak Technologies, Inc.',
        'product': 'CellTrak'
    },
    {
        'vendor': 'Cellebrite Mobile Synchronization, Ltd.',
        'product': 'Cellebrite'
    },
    {
        'vendor': 'Celltick Technologies, Inc.',
        'product': 'Celltick (Unspecified Product)'
    },
    {
        'vendor': 'FUJIFILM Corporation',
        'product': 'Cellular Dynamics International'
    },
    {
        'vendor': 'Celonis SE',
        'product': 'Celonis'
    },
    {
        'vendor': 'Celoxis Technologies Pvt Ltd',
        'product': 'Celoxis'
    },
    {
        'vendor': 'Celtra, Inc.',
        'product': 'Celtra'
    },
    {
        'vendor': 'CenTrak, Inc.',
        'product': 'CenTrak'
    },
    {
        'vendor': 'Cendyn Group, LLC',
        'product': 'Cendyn Hospitality Cloud'
    },
    {
        'vendor': 'CensorNet, Ltd.',
        'product': 'CensorNet'
    },
    {
        'vendor': 'Census',
        'product': 'Census'
    },
    {
        'vendor': 'Censys, Inc.',
        'product': 'Censys'
    },
    {
        'vendor': 'Open Source',
        'product': 'CentOS'
    },
    {
        'vendor': 'Centercode, Inc.',
        'product': 'Centercode'
    },
    {
        'vendor': 'Centerfield Technology, Inc.',
        'product': 'Centerfield Technology'
    },
    {
        'vendor': 'CentralReach, LLC',
        'product': 'CentralReach'
    },
    {
        'vendor': 'CentralSquare Technologies',
        'product': 'CentralSquare'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'Centricity Perioperative'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'Centricity RIS'
    },
    {
        'vendor': 'Centrify Corporation',
        'product': 'Centrify'
    },
    {
        'vendor': 'Centro, Inc.',
        'product': 'Centro'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'CenturyLink DNS'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'CenturyLink Hosting'
    },
    {
        'vendor': 'The Ceph Foundation',
        'product': 'Ceph'
    },
    {
        'vendor': 'Cepheid',
        'product': 'Cepheid GeneXpert'
    },
    {
        'vendor': 'Cequence Security, Inc.',
        'product': 'Cequence Security'
    },
    {
        'vendor': 'Ceragon Networks, Ltd.',
        'product': 'Ceragon Networks'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian Dayforce'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian Dayforce HR'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian Dayforce Payroll'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian HR/Payroll'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian Powerpay'
    },
    {
        'vendor': 'Ceridian HCM, Inc.',
        'product': 'Ceridian eSource'
    },
    {
        'vendor': 'Cerkl',
        'product': 'Cerkl'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner (Unspecified Product)'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Apache'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Capstone'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner CareAware'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner CareAware Capacity Management'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner CareAware Connect'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner CareAware MultiMedia'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Clairvia'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Clinical Exchange Platform'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner CoPathPlus'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Direct'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Disaster Recovery'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Discern nCode'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Dynamic Documentation'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner EMPI'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Etreby Pharmacy Management System'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Fetalink'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner FirstNet'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner HDX'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner HealthSentry'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner HealtheAnalytics'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner HealtheEDW'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner HealtheIntent'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner INET Virtual'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner IQHealth'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner ITWorks'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Interoperability'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Invision'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Learning Framework'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Lights On Network'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner MSMeds'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Millennium'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Multum'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner OPENLink'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Open Engine'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner P2Sentinel'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PathNet'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PharmNet'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PowerChart'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PowerChart Ambulatory'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PowerChart Oncology'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PowerInsight Explorer'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner PowerWorks'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Practice Management'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner ProVision'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner QuadRIS'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner RadNet'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Registration Management'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner RevWorks'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Revenue Cycle Management'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner RxStation'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Scheduling Management'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Soarian EHR'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner SurgiNet'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner UNITY'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner VitalWorks'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner i.s.h.med'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner medico'
    },
    {
        'vendor': 'Ceros, Inc.',
        'product': 'Ceros'
    },
    {
        'vendor': 'Vertikal, Inc.',
        'product': 'CertFocus'
    },
    {
        'vendor': 'Certain, Inc.',
        'product': 'Certain'
    },
    {
        'vendor': 'CertainCert, LLC',
        'product': 'CertainCert'
    },
    {
        'vendor': 'Certent, Inc.',
        'product': 'Certent Disclosure Management'
    },
    {
        'vendor': 'Certero, Ltd.',
        'product': 'Certero (Unspecified Product)'
    },
    {
        'vendor': 'Certify, Inc.',
        'product': 'Certify'
    },
    {
        'vendor': 'Certisign Certificadora Digital S.A.',
        'product': 'Certisign'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Certitude'
    },
    {
        'vendor': 'Certona Corporation',
        'product': 'Certona'
    },
    {
        'vendor': 'Cetec ERP, LLC',
        'product': 'Cetec ERP'
    },
    {
        'vendor': 'Cezanne HR, Ltd.',
        'product': 'Cezanne'
    },
    {
        'vendor': 'Cforia Software, Inc.',
        'product': 'Cforia'
    },
    {
        'vendor': 'MedicalMine, Inc.',
        'product': 'ChARM EHR'
    },
    {
        'vendor': 'Chainalysis, Inc.',
        'product': 'Chainalysis'
    },
    {
        'vendor': 'Preferred Networks, Inc.',
        'product': 'Chainer'
    },
    {
        'vendor': 'GrowthPlay, LLC',
        'product': 'Chally'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Change Healthcare'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Change Healthcare (Unspecified Product)'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Change Healthcare Cardiology'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Change Healthcare Image Repository'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Change Patient Billing & Statements'
    },
    {
        'vendor': 'ChangeGear',
        'product': 'ChangeGear'
    },
    {
        'vendor': 'Changepoint Corporation',
        'product': 'Changepoint'
    },
    {
        'vendor': 'Changepoint Corporation',
        'product': 'Changepoint Services Automation'
    },
    {
        'vendor': 'The Rubicon Project, Inc.',
        'product': 'Chango'
    },
    {
        'vendor': 'Channel Fusion',
        'product': 'Channel Fusion'
    },
    {
        'vendor': 'ChannelAdvisor Corporation',
        'product': 'ChannelAdvisor'
    },
    {
        'vendor': 'Channeltivity, LLC',
        'product': 'Channeltivity'
    },
    {
        'vendor': 'Chaos Software Group, Inc.',
        'product': 'Chaos Intellect'
    },
    {
        'vendor': 'Chaos Software Group, Inc.',
        'product': 'Chaos Software'
    },
    {
        'vendor': 'ChargeOver',
        'product': 'ChargeOver'
    },
    {
        'vendor': 'ChargeBee, Inc.',
        'product': 'Chargebee'
    },
    {
        'vendor': 'Chargify, LLC',
        'product': 'Chargify'
    },
    {
        'vendor': 'Charles River Systems, Inc.',
        'product': 'Charles River Development'
    },
    {
        'vendor': 'ChartHop, Inc.',
        'product': 'ChartHop'
    },
    {
        'vendor': 'CPSI',
        'product': 'ChartLink'
    },
    {
        'vendor': 'ChartLogic, Inc.',
        'product': 'ChartLogic'
    },
    {
        'vendor': 'ChartLogic, Inc.',
        'product': 'ChartLogic EHR'
    },
    {
        'vendor': 'STI Computer Services',
        'product': 'ChartMaker'
    },
    {
        'vendor': 'Quest Diagnostics, Inc.',
        'product': 'ChartMaxx'
    },
    {
        'vendor': 'ChartMogul, Ltd.',
        'product': 'ChartMogul'
    },
    {
        'vendor': 'ChartNet Technologies, Inc.',
        'product': 'ChartNet'
    },
    {
        'vendor': 'ChartPerfect, Inc.',
        'product': 'ChartPerfect PM'
    },
    {
        'vendor': 'Chartwise Medical Systems, Inc.',
        'product': 'ChartWise CDI'
    },
    {
        'vendor': 'Chartbeat, Inc.',
        'product': 'Chartbeat'
    },
    {
        'vendor': 'Charter Communications',
        'product': 'Charter Hosting'
    },
    {
        'vendor': 'Chart.io, Inc.',
        'product': 'Chartio'
    },
    {
        'vendor': 'ChaseData Corporation',
        'product': 'ChaseData'
    },
    {
        'vendor': 'Chatlio, LLC',
        'product': 'Chatlio'
    },
    {
        'vendor': 'Chatmeter, Inc.',
        'product': 'Chatmeter'
    },
    {
        'vendor': 'Roger Wilco, LLC',
        'product': 'Chatra'
    },
    {
        'vendor': 'Chatwork Company, Ltd.',
        'product': 'Chatwork'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point (Unspecified Product)'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Capsule Docs'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point CloudGuard SaaS'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point DDoS Protector'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Endpoint Policy Management Software Blade'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point IPS'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Maestro'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Mobile Access Software Blade'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Next Generation Firewall'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Pointsec'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Pointsec PC'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point SandBlast'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Smart-1'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point SmartEvent'
    },
    {
        'vendor': 'PeopleStrategy, Inc.',
        'product': 'CheckPoint HR'
    },
    {
        'vendor': 'Checkmarx.com, Ltd.',
        'product': 'Checkmarx (Unspecified Product)'
    },
    {
        'vendor': 'Checkmarx.com, Ltd.',
        'product': 'Checkmarx Codebashing'
    },
    {
        'vendor': 'Checkmarx.com, Ltd.',
        'product': 'Checkmarx IAST'
    },
    {
        'vendor': 'Checkmarx.com, Ltd.',
        'product': 'Checkmarx SAST'
    },
    {
        'vendor': 'Checkmarx.com, Ltd.',
        'product': 'Checkmarx SCA'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Checkout by Amazon'
    },
    {
        'vendor': 'Checkout.com Group',
        'product': 'Checkout.com'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Checkov'
    },
    {
        'vendor': 'Checkr, Inc.',
        'product': 'Checkr'
    },
    {
        'vendor': 'Cheetah Digital, Inc.',
        'product': 'Cheetah Digital (Unspecified Product)'
    },
    {
        'vendor': 'Cheetah Digital, Inc.',
        'product': 'Cheetah Experiences'
    },
    {
        'vendor': 'Chef Software, Inc.',
        'product': 'Chef'
    },
    {
        'vendor': 'Chef Software, Inc.',
        'product': 'Chef Automate'
    },
    {
        'vendor': 'Chef Software, Inc.',
        'product': 'Chef Habitat'
    },
    {
        'vendor': 'Chef Software, Inc.',
        'product': 'Chef InSpec'
    },
    {
        'vendor': 'Chef Software, Inc.',
        'product': 'Chef Infra'
    },
    {
        'vendor': 'ChemAxon, Ltd.',
        'product': 'ChemAxon JChem'
    },
    {
        'vendor': 'ChemAxon, Ltd.',
        'product': 'ChemAxon Marvin'
    },
    {
        'vendor': 'PerkinElmer, Inc.',
        'product': 'ChemBioOffice'
    },
    {
        'vendor': 'PerkinElmer, Inc.',
        'product': 'ChemDraw'
    },
    {
        'vendor': 'CSSP Pty Ltd',
        'product': 'Cheops'
    },
    {
        'vendor': 'Cherwell Software, LLC',
        'product': 'Cherwell Software'
    },
    {
        'vendor': 'Chetu, Inc.',
        'product': 'Chetu'
    },
    {
        'vendor': 'Chief Architect, Inc.',
        'product': 'Chief Architect'
    },
    {
        'vendor': 'Chili Piper, Inc.',
        'product': 'Chili Piper'
    },
    {
        'vendor': 'ChinaCache North America, Inc.',
        'product': 'ChinaCache'
    },
    {
        'vendor': 'ChipSoft B.V.',
        'product': 'ChipSoft'
    },
    {
        'vendor': 'QuickCharts, Inc.',
        'product': 'Chiro QuickCharts'
    },
    {
        'vendor': 'Forte Holdings',
        'product': 'Chiro8000'
    },
    {
        'vendor': 'Chiro Cloud, LLC',
        'product': 'ChiroCloud'
    },
    {
        'vendor': 'ChiroTouch',
        'product': 'ChiroTouch'
    },
    {
        'vendor': 'Softworx Solutions, Inc.',
        'product': 'ChiroWrite'
    },
    {
        'vendor': 'Chitika, Inc.',
        'product': 'Chitika'
    },
    {
        'vendor': 'Chocolate',
        'product': 'Chocolate'
    },
    {
        'vendor': 'Chocolatey Software, Inc.',
        'product': 'Chocolatey'
    },
    {
        'vendor': 'Choozle, Inc.',
        'product': 'Choozle'
    },
    {
        'vendor': 'Chorus.ai',
        'product': 'Chorus'
    },
    {
        'vendor': 'Chrome River Technologies, Inc.',
        'product': 'Chrome River'
    },
    {
        'vendor': 'Chronicle, LLC',
        'product': 'Chronicle'
    },
    {
        'vendor': 'InfluxData, Inc.',
        'product': 'Chronograf'
    },
    {
        'vendor': 'ChurnZero, Inc.',
        'product': 'ChurnZero'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'Chute'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Ciboodle'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Ciena 6500'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Ciena 8700 Packetwave'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Ciena CN'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Ciena Optical Metro 3500'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Ciena Waveserver'
    },
    {
        'vendor': 'CIIRUS, Inc.',
        'product': 'CiiRUS'
    },
    {
        'vendor': 'Isovalent, Inc.',
        'product': 'Cilium'
    },
    {
        'vendor': 'Cimatron, Ltd.',
        'product': 'Cimatron'
    },
    {
        'vendor': '3D Systems, Inc.',
        'product': 'CimatronE'
    },
    {
        'vendor': 'Cin7, Ltd.',
        'product': 'Cin7'
    },
    {
        'vendor': 'Cincom Systems, Inc.',
        'product': 'Cincom'
    },
    {
        'vendor': 'Cincom Systems, Inc.',
        'product': 'Cincom CPQ'
    },
    {
        'vendor': 'Cincom Systems, Inc.',
        'product': 'Cincom Eloquence'
    },
    {
        'vendor': 'Cincom Systems, Inc.',
        'product': 'Cincom MANTIS'
    },
    {
        'vendor': 'Cincom Systems, Inc.',
        'product': 'Cincom SUPRA'
    },
    {
        'vendor': 'Cincom Systems, Inc.',
        'product': 'Cincom Synchrony'
    },
    {
        'vendor': 'Cincopa, Ltd.',
        'product': 'Cincopa'
    },
    {
        'vendor': 'MAXON Computer GmbH',
        'product': 'Cinebench'
    },
    {
        'vendor': 'Ciox Health',
        'product': 'Ciox Health'
    },
    {
        'vendor': 'Ciox Health',
        'product': 'Ciox Smart Chart'
    },
    {
        'vendor': 'CipherCloud, Inc.',
        'product': 'CipherCloud'
    },
    {
        'vendor': 'CipherHealth, Inc.',
        'product': 'CipherRounds'
    },
    {
        'vendor': 'Thales Group',
        'product': 'CipherTrust Cloud Key Manager'
    },
    {
        'vendor': 'Circle Internet Services, Inc.',
        'product': 'CircleCI'
    },
    {
        'vendor': 'Cirius Group, Inc.',
        'product': 'Cirius Group'
    },
    {
        'vendor': 'Cirruspath, Inc.',
        'product': 'Cirrus Insight'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 10700 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 12000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 1600 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 1700 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 1800 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 1811'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 1841'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 1900 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2504'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2600 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2800 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2801'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2811'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2821'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2851'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2900 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2940'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2950'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2960'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2960C'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2960G'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 2960S'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3200 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3560C'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3560V2'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3560X Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3600 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3700 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3750-X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3750E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3750G'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3750V2'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3800 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3825'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3845'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3850'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3925'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3945'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4400 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4402'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4404'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4503'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4506'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4507'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4510'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4900M'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 4948'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 5000 Series Enterprise Network Compute System'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 5500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 5508'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 5700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 5760'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 6400'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7100 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7200 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7300 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7400 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7510'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7600 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7603'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7604'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7606'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7609'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7613'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 7900 Series IP Phones'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 800 Series Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 8500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 8510'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ACE 4700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ACE 4710'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ACE10'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ACE20'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ACE30'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ACI'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AMP for Email'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AMP for Endpoints'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AMP for Networks'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AS5400XM'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5505'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5506'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5508'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5510'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5512-X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5515-X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5516'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5520'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5525'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5525-X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5540'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5545'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5550'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5555'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5580'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5585'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA 5585-X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASA Software'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASR 1000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASR 1001'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASR 1002'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASR 5000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASR 900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ASR 9000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AVS 3100'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Adaptive Security Appliance Software'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Adaptive Security Device Manager'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aggregation Services Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 1140'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 1142'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 1260'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 1600'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 1700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 2600'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 2602'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 2700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 350'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 3500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 3600'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 3700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Aironet 3702'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AnyConnect'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco AppDynamics'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Application Policy Infrastructure Controller'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Blade Servers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco BroadWorks'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Business Edition 6000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CGR 2000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CGS 2500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CRS-1'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CSS 11500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CTMS'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CX'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 2900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 3560'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 3560-C'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 3560E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 3650'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 3850'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4003'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4006'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4503-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4506-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4507R'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4510R'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 4900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6503'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6503-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6504-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6506'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6506-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6509'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6509-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6513'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6513-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 6800'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 9200'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 9300'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 9400'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst 9500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Catalyst Switches'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Cloud Web Security'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco CloudCenter'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Cloudlock'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Codian'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Collaboration'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Collaboration Room Endpoints'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Contact Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Context-Aware'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Core Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco DNA Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco DNA Spaces'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco DWDM'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Defense Orchestrator'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Digital Media Suite'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ESW 500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Edge Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Email Security'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco EnergyWise'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Expressway'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Finesse'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower 2100'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower 4100'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower 7000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower 8000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower 9300'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower NGFW'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firewalls'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Flex 7500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco FlexPod'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco HealthPresence'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Hosted Collaboration Solution (HCS)'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco HyperFlex'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco IGX 8400'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco IP Phones'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Identity Services Engine'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Integrated Services Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Intercloud'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco IoT'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco IoT Cloud Connect'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco IronPort'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Jabber'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Jasper'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Local Director'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MCU 4500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MDS 9000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MDS 9100'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MDS 9200'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MDS 9500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MDS 9700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ME 3400 Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ME 3600X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ME 3800X'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MGX 8800'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MX200'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MX300'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MXE 3500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MXE 5600'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco MediaSense'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Meeting Server'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Meraki'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Metacloud'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Mobile Wireless Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco NCS 1000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco NCS 2000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco NCS 4000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco NCS 5500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco NCS 6000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco NGIPS'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Next-Generation Firewalls (NGFWs)'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 1000V'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 2000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 3000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 3550'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 4000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 5000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 5010'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 5020'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 5548'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 5596UP Switch'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 6000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 7000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 7700'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 9000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 9300'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 9332'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 9500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 9504'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus 9508'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Nexus Switches'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ONS 15216'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ONS 15327'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ONS 15454'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ONS 15530'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ONS 15540'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ONS 15600'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Outbound Option'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco PIX 500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Packaged Contact Center Enterprise'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Prime Access Registrar'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Prime Collaboration'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Prime Infrastructure'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Prime Network Control System'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Prime Security Manager'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Rack Servers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Registered Envelope Service'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Routers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco SCE 8000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco SD-WAN'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco SPA9000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco SRP 500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco ScanSafe Web Security'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Secure Access Control'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco SecureX'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Security Manager'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Show and Share'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Smart Net Total Care'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco SocialMiner'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Spark'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Stealthwatch'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Switches'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Tandberg'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence Conductor'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence MX Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence Recording Server'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence SX10'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence VCS'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TelePresence VCS Expressway'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Tetration'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Threat Grid'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Tidal Enterprise Scheduler'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco TrustSec'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UC500'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UCS B200 M4'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UCS Invicta'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UCS Manager'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UCS Servers'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UcaaS (Hosted Service)'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Umbrella'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Communications Manager (CallManager)'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Contact Center Enterprise'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Contact Center Express'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Customer Voice Portal'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified IP Interactive Voice Response'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified IP Phones 6900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified IP Phones 7900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified IP Phones 8900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified IP Phones 9900'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Intelligence Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Web Interaction Manager'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unified Workforce Optimization'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unity'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Unity Connection'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco VCS-E'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco VM-FEX'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco VPN 5000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Validated Designs'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco VoIP'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco VoIP PBX'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WAAS'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Web Security Appliance'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx DX Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Event Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Meetings'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Messenger'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Room Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Support Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Teams'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Training Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco WebEx Weboffice'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Webex Connect'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Webex Contact Center'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco XR 12000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco newScale'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco uOne'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco vEdge'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco vEdge 100'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco vEdge 1000'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'CiscoView'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'CiscoWorks Network Compliance Manager'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'Cision'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'Cision Analytics'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'Cision Communications Cloud'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'Cision Social Media Monitoring'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'Cision iContact'
    },
    {
        'vendor': 'MCG Health, LLC',
        'product': 'Cite CareWebQI'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix (Unspecified Product)'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix ADC'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Access Gateway'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix App Layering'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix AppDNA'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Application Delivery Management'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Branch Repeater'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix CloudBridge'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Endpoint Management'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Framehawk'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Gateway'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Hypervisor'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Intelligent Traffic Management'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix NetScaler'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Podio'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Profile Management'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Provisioning'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Provisioning Services'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix SD-WAN'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Secure Web Gateway'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix ShareFile'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix StoreFront'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix VDI-in-a-Box'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Virtual Apps'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Virtual Desktops'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Web App Firewall'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Work Space'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Workspace'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix Workspace App'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix XenApp'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix XenClient'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Citrix XenServer'
    },
    {
        'vendor': 'Harris Computer Systems',
        'product': 'CityView'
    },
    {
        'vendor': 'CIVICRM, LLC',
        'product': 'CiviCRM'
    },
    {
        'vendor': 'Civica UK, Ltd.',
        'product': 'Civica'
    },
    {
        'vendor': 'Civitas Learning, Inc.',
        'product': 'Civitas Learning'
    },
    {
        'vendor': 'Claim.MD, Inc.',
        'product': 'Claim.MD'
    },
    {
        'vendor': 'Waystar, Inc.',
        'product': 'ClaimRemedi'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'ClamAV'
    },
    {
        'vendor': 'Clarabridge, Inc.',
        'product': 'Clarabridge (Unspecified Product)'
    },
    {
        'vendor': 'Clarabridge, Inc.',
        'product': 'Clarabridge CX Analytics'
    },
    {
        'vendor': 'Clarabridge, Inc.',
        'product': 'Clarabridge CX Social'
    },
    {
        'vendor': 'Clari, Inc.',
        'product': 'Clari'
    },
    {
        'vendor': 'Clarifai, Inc.',
        'product': 'Clarifai'
    },
    {
        'vendor': 'Claris International, Inc.',
        'product': 'Claris FileMaker Server'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Clarity APM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Clarity BSI'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Clarity CCA'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Clarity PPM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Clarity SC'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Clarity SDM'
    },
    {
        'vendor': 'Clarity',
        'product': 'Clarity Travel Management'
    },
    {
        'vendor': 'Claritysoft, Inc.',
        'product': 'ClaritySoft'
    },
    {
        'vendor': 'Clarivate Analytics, LLC',
        'product': 'Clarivate CompuMark'
    },
    {
        'vendor': 'Clarivate Analytics, LLC',
        'product': 'Clarivate MarkMonitor'
    },
    {
        'vendor': 'Clarivate Analytics, LLC',
        'product': 'Clarivate Techstreet'
    },
    {
        'vendor': 'Clarizen, Inc.',
        'product': 'Clarizen'
    },
    {
        'vendor': 'Claroty, Ltd.',
        'product': 'Claroty'
    },
    {
        'vendor': 'Classe365',
        'product': 'Classe365'
    },
    {
        'vendor': 'Classy, Inc.',
        'product': 'Classy'
    },
    {
        'vendor': 'CleanPix Corporation',
        'product': 'CleanPix'
    },
    {
        'vendor': 'Clear Books PLC',
        'product': 'Clear Books'
    },
    {
        'vendor': 'Clear Spider, Inc.',
        'product': 'Clear Spider'
    },
    {
        'vendor': 'ClearCare, Inc.',
        'product': 'ClearCare'
    },
    {
        'vendor': 'ClearCompany, Inc.',
        'product': 'ClearCompany'
    },
    {
        'vendor': 'ClearCube Technology, Inc.',
        'product': 'ClearCube'
    },
    {
        'vendor': 'ClearFit, Inc.',
        'product': 'ClearFit'
    },
    {
        'vendor': 'ClearSlide, Inc.',
        'product': 'ClearSlide'
    },
    {
        'vendor': 'Alteryx, Inc.',
        'product': 'ClearStory'
    },
    {
        'vendor': 'Doubleknot, LLC',
        'product': 'ClearView CRM'
    },
    {
        'vendor': 'Clearbit',
        'product': 'Clearbit'
    },
    {
        'vendor': 'Clearion Software, LLC',
        'product': 'Clearion Software'
    },
    {
        'vendor': 'Clearswift Group, Ltd.',
        'product': 'Clearswift'
    },
    {
        'vendor': 'Unanet Technologies, Inc.',
        'product': 'Clearview InFocus'
    },
    {
        'vendor': 'Unanet Technologies, Inc.',
        'product': 'Clearview Software'
    },
    {
        'vendor': 'Cleatech, LLC',
        'product': 'Cleatech'
    },
    {
        'vendor': 'Cleo Communications, LLC',
        'product': 'Cleo Communications (Unspecified Product)'
    },
    {
        'vendor': 'Cleo Communications, LLC',
        'product': 'Cleo Integration Cloud'
    },
    {
        'vendor': 'CleverReach GmbH & Company KG',
        'product': 'CleverReach'
    },
    {
        'vendor': 'CleverStaff, LLC',
        'product': 'CleverStaff'
    },
    {
        'vendor': 'WizRocket, Inc.',
        'product': 'CleverTap'
    },
    {
        'vendor': 'Cleverbridge AG',
        'product': 'Cleverbridge'
    },
    {
        'vendor': 'Clevest Solutions, Inc.',
        'product': 'Clevest'
    },
    {
        'vendor': 'ClicData, LLC',
        'product': 'ClicData'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Click Field Service Edge'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Click Software'
    },
    {
        'vendor': 'ClickSoftware Technologies, Ltd.',
        'product': 'Click Software (Unspecified Product)'
    },
    {
        'vendor': 'ClickBase Corporation',
        'product': 'ClickBase'
    },
    {
        'vendor': 'ClickDesk, Inc.',
        'product': 'ClickDesk'
    },
    {
        'vendor': 'ClickDimensions, LLC',
        'product': 'ClickDimensions'
    },
    {
        'vendor': 'ClickFunnels',
        'product': 'ClickFunnels'
    },
    {
        'vendor': 'ClickInc.com',
        'product': 'ClickInc'
    },
    {
        'vendor': 'ClickPay',
        'product': 'ClickPay'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'ClickSchedule'
    },
    {
        'vendor': 'ClickSend Pty Ltd',
        'product': 'ClickSend'
    },
    {
        'vendor': 'Zeta Interactive Corporation',
        'product': 'ClickSquared'
    },
    {
        'vendor': 'Mango Technologies, Inc.',
        'product': 'ClickUp'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Clickability'
    },
    {
        'vendor': 'Clickbooth.com, LLC',
        'product': 'Clickbooth'
    },
    {
        'vendor': 'Clickdensity',
        'product': 'Clickdensity'
    },
    {
        'vendor': 'Cerberus Healthcare, LLC',
        'product': 'Clicktale'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Clicktools'
    },
    {
        'vendor': 'Roxr Software, Ltd.',
        'product': 'Clicky'
    },
    {
        'vendor': 'Client ConneXion, LLC',
        'product': 'Client ConneXion'
    },
    {
        'vendor': 'Clientexec, Inc.',
        'product': 'Clientexec'
    },
    {
        'vendor': 'Anju Software, Inc.',
        'product': 'ClinPlus'
    },
    {
        'vendor': 'CliniComp International, Inc.',
        'product': 'CliniComp'
    },
    {
        'vendor': 'ClinicSource',
        'product': 'ClinicSource Therapy Practice Management'
    },
    {
        'vendor': 'JAG Products, LLC',
        'product': 'ClinicTracker'
    },
    {
        'vendor': 'Bio-Optronics, Inc.',
        'product': 'Clinical Conductor CTMS'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'Clinical Exchange Patient Portal'
    },
    {
        'vendor': 'Clinical Ink, Inc.',
        'product': 'Clinical Ink'
    },
    {
        'vendor': 'PRA Health Sciences, Inc.',
        'product': 'Clinical6'
    },
    {
        'vendor': 'Themis Solutions, Inc.',
        'product': 'Clio'
    },
    {
        'vendor': 'Themis Solutions, Inc.',
        'product': 'Clio Grow'
    },
    {
        'vendor': 'Themis Solutions, Inc.',
        'product': 'Clio Manage'
    },
    {
        'vendor': 'Clock Software, Ltd.',
        'product': 'Clock PMS'
    },
    {
        'vendor': 'Cognitect, Inc.',
        'product': 'Clojure'
    },
    {
        'vendor': 'Open Source',
        'product': 'Clojush'
    },
    {
        'vendor': 'Elastic, Inc.',
        'product': 'Close CRM'
    },
    {
        'vendor': 'Elastic, Inc.',
        'product': 'Close.io'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Cloud Dataprep'
    },
    {
        'vendor': 'Cloud Elements, Inc.',
        'product': 'Cloud Elements'
    },
    {
        'vendor': 'Tervela, Inc.',
        'product': 'Cloud FastPath'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Cloud Foundry'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Cloud Identity & Access Management (IAM)'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Cloud Identity-Aware Proxy (Cloud IAP)'
    },
    {
        'vendor': 'Cloud9 Business Analytics, Ltd.',
        'product': 'Cloud9'
    },
    {
        'vendor': 'CloudPlus, Inc.',
        'product': 'CloudApp'
    },
    {
        'vendor': 'CloudAware',
        'product': 'CloudAware'
    },
    {
        'vendor': 'CloudBees, Inc.',
        'product': 'CloudBees'
    },
    {
        'vendor': 'CloudBees, Inc.',
        'product': 'CloudBees CD'
    },
    {
        'vendor': 'CloudBees, Inc.',
        'product': 'CloudBees CI'
    },
    {
        'vendor': 'CloudBees, Inc.',
        'product': 'CloudBees Jenkins'
    },
    {
        'vendor': 'CloudBolt Software, Inc.',
        'product': 'CloudBolt'
    },
    {
        'vendor': 'CloudCheckr, Inc.',
        'product': 'CloudCheckr'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'CloudEndure Disaster Recovery'
    },
    {
        'vendor': 'Cloudflare, Inc.',
        'product': 'CloudFlare SSL'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'CloudGenix Autonomous SD-WAN'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'CloudGuard Dome9'
    },
    {
        'vendor': 'CloudJumper Corporation',
        'product': 'CloudJumper'
    },
    {
        'vendor': 'CloudMade, Ltd.',
        'product': 'CloudMade'
    },
    {
        'vendor': 'CloudNine',
        'product': 'CloudNine Concordance'
    },
    {
        'vendor': 'CloudNine',
        'product': 'CloudNine LAW'
    },
    {
        'vendor': 'CloudPassage, Inc.',
        'product': 'CloudPassage Halo'
    },
    {
        'vendor': 'CloudPay, Inc.',
        'product': 'CloudPay'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CloudSOC CASB'
    },
    {
        'vendor': 'CloudSigma Holding AG',
        'product': 'CloudSigma'
    },
    {
        'vendor': 'Aqua Security Software, Ltd.',
        'product': 'CloudSploit'
    },
    {
        'vendor': 'Virtana',
        'product': 'CloudWisdom'
    },
    {
        'vendor': 'Cloudability, Inc.',
        'product': 'Cloudability'
    },
    {
        'vendor': 'Cloudamize, Inc.',
        'product': 'Cloudamize'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Altus'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera CDH'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Data Platform (CDP)'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Enterprise BDR'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Gazzang'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Impala'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Manager'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera Navigator'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera SDX'
    },
    {
        'vendor': 'Cloudflare, Inc.',
        'product': 'Cloudflare'
    },
    {
        'vendor': 'Cloudflare, Inc.',
        'product': 'Cloudflare CDN'
    },
    {
        'vendor': 'Cloudflare, Inc.',
        'product': 'Cloudflare DNS'
    },
    {
        'vendor': 'Cloudflare, Inc.',
        'product': 'Cloudflare Rocket Loader'
    },
    {
        'vendor': 'Cloudflare, Inc.',
        'product': 'Cloudflare WAF'
    },
    {
        'vendor': 'Cloudian, Inc.',
        'product': 'Cloudian Hyperstore'
    },
    {
        'vendor': 'Cloudinary, Ltd.',
        'product': 'Cloudinary'
    },
    {
        'vendor': 'Cloudistics, Inc.',
        'product': 'Cloudistics'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Cloudmark'
    },
    {
        'vendor': 'Clover Network, Inc.',
        'product': 'Clover POS'
    },
    {
        'vendor': 'ClubReady, LLC',
        'product': 'ClubReady'
    },
    {
        'vendor': 'Clubhouse Software, Inc.',
        'product': 'Clubhouse'
    },
    {
        'vendor': 'The Cluen Corporation',
        'product': 'Cluen'
    },
    {
        'vendor': 'ClustrMaps.com',
        'product': 'ClustrMaps'
    },
    {
        'vendor': 'MariaDB',
        'product': 'ClustrixDB'
    },
    {
        'vendor': 'CoConstruct, LLC',
        'product': 'CoConstruct'
    },
    {
        'vendor': 'ownerIQ, Inc.',
        'product': 'CoEx'
    },
    {
        'vendor': 'CoLinear Systems, Inc.',
        'product': 'CoLinear'
    },
    {
        'vendor': 'CoSchedule, LLC',
        'product': 'CoSchedule'
    },
    {
        'vendor': 'CoSoSys, Ltd.',
        'product': 'CoSoSys'
    },
    {
        'vendor': 'CoStar Realty Information, Inc.',
        'product': 'CoStar'
    },
    {
        'vendor': 'Dynamic Graphics, Inc.',
        'product': 'CoViz 4D'
    },
    {
        'vendor': 'Coalfire Systems, Inc.',
        'product': 'Coalfire'
    },
    {
        'vendor': 'The Cobalt Company, Inc.',
        'product': 'Cobalt'
    },
    {
        'vendor': 'CobbleStone Systems Corporation',
        'product': 'Cobblestone'
    },
    {
        'vendor': 'Cockroach Labs, Inc.',
        'product': 'CockroachDB'
    },
    {
        'vendor': 'Coda Project, Inc.',
        'product': 'Coda'
    },
    {
        'vendor': 'Codat, Ltd.',
        'product': 'Codat'
    },
    {
        'vendor': 'Digital Guardian, Inc.',
        'product': 'Code Green Networks'
    },
    {
        'vendor': 'Code42 Software, Inc.',
        'product': 'Code42'
    },
    {
        'vendor': 'Nfinity Avatars',
        'product': 'CodeBaby'
    },
    {
        'vendor': 'Sequiter, Inc.',
        'product': 'CodeBase'
    },
    {
        'vendor': 'AgilData',
        'product': 'CodeFutures'
    },
    {
        'vendor': 'CodeIgniter Foundation',
        'product': 'CodeIgniter'
    },
    {
        'vendor': 'Open Source',
        'product': 'CodeMirror'
    },
    {
        'vendor': 'Onapsis, Inc.',
        'product': 'CodeProfiler'
    },
    {
        'vendor': 'Semmle, Inc.',
        'product': 'CodeQL'
    },
    {
        'vendor': 'OnSolve, LLC',
        'product': 'CodeRED'
    },
    {
        'vendor': 'CodeSandbox B.V.',
        'product': 'CodeSandbox'
    },
    {
        'vendor': 'CodeSignal, Inc.',
        'product': 'CodeSignal'
    },
    {
        'vendor': 'General Technology',
        'product': 'Code_Aster'
    },
    {
        'vendor': 'Codecov, LLC',
        'product': 'Codecov'
    },
    {
        'vendor': 'Docker, Inc.',
        'product': 'Codefresh'
    },
    {
        'vendor': 'CloudBees, Inc.',
        'product': 'Codeship'
    },
    {
        'vendor': 'CodoniX, Inc.',
        'product': 'CodoniX'
    },
    {
        'vendor': 'Cofense, Inc.',
        'product': 'Cofense'
    },
    {
        'vendor': 'Cofense, Inc.',
        'product': 'Cofense PhishMe'
    },
    {
        'vendor': 'Open Source',
        'product': 'Coffeescript'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Cofio'
    },
    {
        'vendor': 'Cogent QC Systems',
        'product': 'Cogent QC'
    },
    {
        'vendor': 'Cogito Corporation',
        'product': 'Cogito'
    },
    {
        'vendor': 'Cognex Corporation',
        'product': 'Cognex (Unspecified Product)'
    },
    {
        'vendor': 'Cognism, Ltd.',
        'product': 'Cognism'
    },
    {
        'vendor': 'Cognitec Systems GmbH',
        'product': 'Cognitec'
    },
    {
        'vendor': 'Cognitive TPG',
        'product': 'Cognitive TPG Advantage LX'
    },
    {
        'vendor': 'cognitive SEO Internet Marketing Tools',
        'product': 'CognitiveSEO'
    },
    {
        'vendor': 'CognitiveScale, Inc',
        'product': 'CognitiveScale'
    },
    {
        'vendor': 'BlockScore, Inc.',
        'product': 'Cognito'
    },
    {
        'vendor': 'Cognizant Technology Solutions Corporation',
        'product': 'Cognizant (Unspecified Product)'
    },
    {
        'vendor': 'Cognizant Technology Solutions Corporation',
        'product': 'Cognizant AI'
    },
    {
        'vendor': 'Softvision, LLC',
        'product': 'Cognizant Softvision'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos 10'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos 8'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Controller'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Enterprise'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Express'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Impromptu'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Insight'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Planning Analytics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Planning Contributor'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Series 7'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos TM1'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Cognos Visualizer'
    },
    {
        'vendor': 'Cogsdale Corporation',
        'product': 'Cogsdale'
    },
    {
        'vendor': 'Cohesity, Inc.',
        'product': 'Cohesity (Unspecified Product)'
    },
    {
        'vendor': 'Cohesity, Inc.',
        'product': 'Cohesity DataProtect'
    },
    {
        'vendor': 'Cohesity, Inc.',
        'product': 'Cohesity Helios'
    },
    {
        'vendor': 'CoinDesk, Inc.',
        'product': 'CoinDesk'
    },
    {
        'vendor': 'Coinbase, Inc.',
        'product': 'Coinbase'
    },
    {
        'vendor': 'Cointec Consultores Informatica',
        'product': 'Cointec GestLab'
    },
    {
        'vendor': 'CollabNet, Inc.',
        'product': 'CollabNet (Unspecified Product)'
    },
    {
        'vendor': 'CollabNet, Inc.',
        'product': 'CollabNet CloudForge'
    },
    {
        'vendor': 'CollabNet, Inc.',
        'product': 'CollabNet ScrumWorksPro'
    },
    {
        'vendor': 'CollabNet, Inc.',
        'product': 'CollabNet Subversion'
    },
    {
        'vendor': 'CollabNet, Inc.',
        'product': 'CollabNet TeamForge'
    },
    {
        'vendor': 'CollaborateMD, Inc.',
        'product': 'CollaborateMD'
    },
    {
        'vendor': 'Collective Medical Technologies, Inc.',
        'product': 'Collective'
    },
    {
        'vendor': 'Collective Health, Inc.',
        'product': 'Collective Health'
    },
    {
        'vendor': 'Collective, Inc.',
        'product': 'Collective Media'
    },
    {
        'vendor': 'Collibra, Inc.',
        'product': 'Collibra'
    },
    {
        'vendor': 'Collibra, Inc.',
        'product': 'Collibra Catalog'
    },
    {
        'vendor': 'Colligo Networks, Inc.',
        'product': 'Colligo'
    },
    {
        'vendor': 'Colt Technology Services Group, Ltd.',
        'product': 'Colt'
    },
    {
        'vendor': 'Ontario Systems, LLC',
        'product': 'Columbia Ultimate'
    },
    {
        'vendor': 'Comarch S.A.',
        'product': 'Comarch'
    },
    {
        'vendor': 'Comdata Network, Inc.',
        'product': 'Comdata'
    },
    {
        'vendor': 'Comeet Technologies, Inc.',
        'product': 'Comeet'
    },
    {
        'vendor': 'Comindware, Inc.',
        'product': 'Comindware'
    },
    {
        'vendor': 'Comindwork',
        'product': 'Comindwork'
    },
    {
        'vendor': 'Comm100 Network Corporation',
        'product': 'Comm100'
    },
    {
        'vendor': 'CommScope, Inc.',
        'product': 'CommScope iTRACS'
    },
    {
        'vendor': 'Commence Corporation',
        'product': 'Commence CRM'
    },
    {
        'vendor': 'Civitas Marketing, Ltd.',
        'product': 'CommentLuv'
    },
    {
        'vendor': 'Yahoo! CV, LLC',
        'product': 'Commerce Central'
    },
    {
        'vendor': 'Sitecore Corporation',
        'product': 'Commerce Server'
    },
    {
        'vendor': 'Commerce Technologies, LLC',
        'product': 'CommerceHub'
    },
    {
        'vendor': 'Commerce Technologies, LLC',
        'product': 'CommerceHub ProductStream'
    },
    {
        'vendor': 'PaperThin, Inc.',
        'product': 'CommonSpot'
    },
    {
        'vendor': 'The Communicator Corporation, Ltd.',
        'product': 'Communicator'
    },
    {
        'vendor': 'Commusoft, Ltd.',
        'product': 'Commusoft'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Commvault (Unspecified Product)'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Commvault Hyperscale'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Commvault IntelliSnap'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Commvault Simpana'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Commvault VNA'
    },
    {
        'vendor': 'Comodo Group, Inc.',
        'product': 'Comodo UserTrust'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'Compaq Elite 8300'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'Compaq Pro 6300'
    },
    {
        'vendor': 'Compeat, Inc.',
        'product': 'Compeat'
    },
    {
        'vendor': 'Compete',
        'product': 'Compete'
    },
    {
        'vendor': 'Market Track, LLC',
        'product': 'Competitrack'
    },
    {
        'vendor': 'Compliance 360',
        'product': 'Compliance 360'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Compliance Accelerator'
    },
    {
        'vendor': 'CM Systems, LLC',
        'product': 'ComplianceMate'
    },
    {
        'vendor': 'CompliancePro Solutions',
        'product': 'CompliancePro'
    },
    {
        'vendor': 'UL EHS Sustainability',
        'product': 'ComplianceWire'
    },
    {
        'vendor': 'ComplyAdvantage, Ltd.',
        'product': 'ComplyAdvantage'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Complytrack'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Comptel'
    },
    {
        'vendor': 'Compulink Healthcare Solutions',
        'product': 'Compulink'
    },
    {
        'vendor': 'Compusense, Inc.',
        'product': 'Compusense'
    },
    {
        'vendor': 'Computer Guidance Corporation',
        'product': 'Computer Guidance Corporation'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'ComputerEase'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware (Unspecified Product)'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware APM'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware Abend-AID'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware ApplicationVantage'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware ClientVantage'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware DBA-Xpert'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware File-AID'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware Hiperstation'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware ISPW'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware Strobe'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware Vantage'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'Compuware Xpediter'
    },
    {
        'vendor': 'Comrad Medical Systems, Ltd.',
        'product': 'Comrad RIS'
    },
    {
        'vendor': 'Comscore, Inc.',
        'product': 'Comscore'
    },
    {
        'vendor': 'Comverse Technology, Inc.',
        'product': 'Comverse'
    },
    {
        'vendor': 'ConEst Software',
        'product': 'ConEst'
    },
    {
        'vendor': 'ConEst Software',
        'product': 'ConEst IntelliBid'
    },
    {
        'vendor': 'Conarc, Inc.',
        'product': 'Conarc iChannel'
    },
    {
        'vendor': 'Concentrix Corporation',
        'product': 'Concentrix'
    },
    {
        'vendor': 'Digital Republic Media Group GmbH',
        'product': 'Conceptboard'
    },
    {
        'vendor': 'Concierge Plus, Inc.',
        'product': 'Concierge Plus'
    },
    {
        'vendor': 'Concord Worldwide, Inc.',
        'product': 'Concord'
    },
    {
        'vendor': 'Concord Technologies Corporation',
        'product': 'Concord Cloud Fax'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur (Unspecified Product)'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Budget'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Detect'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Drive'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Expense'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur ExpenseIt'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Gelco'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Intelligence'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Invoice'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Invoice Capture'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Payment'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Purchase Request'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Request'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Three-Way Match'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Travel'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur TripIt'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur TripLink'
    },
    {
        'vendor': 'Anaconda, Inc.',
        'product': 'Conda'
    },
    {
        'vendor': 'Condo Control Central',
        'product': 'Condo Control Central'
    },
    {
        'vendor': 'Condo Manager',
        'product': 'Condo Manager'
    },
    {
        'vendor': 'Conductor, Inc.',
        'product': 'Conductor Searchlight'
    },
    {
        'vendor': 'Conduent, Inc.',
        'product': 'Conduent Midas Statit PPR'
    },
    {
        'vendor': 'Tail-f Systems',
        'product': 'ConfD'
    },
    {
        'vendor': 'Conferize A/S',
        'product': 'Conferize'
    },
    {
        'vendor': 'Configio',
        'product': 'Configio'
    },
    {
        'vendor': 'Configure One, Inc.',
        'product': 'Configure One'
    },
    {
        'vendor': 'Confirmit A/S',
        'product': 'Confirmit'
    },
    {
        'vendor': 'Confluent, Inc.',
        'product': 'Confluent Open Source'
    },
    {
        'vendor': 'Conga',
        'product': 'Conga Collaborate'
    },
    {
        'vendor': 'Conga',
        'product': 'Conga Contracts'
    },
    {
        'vendor': 'Conifer Health Solutions, LLC',
        'product': 'Conifer Health'
    },
    {
        'vendor': 'ConnectALL, LLC',
        'product': 'ConnectALL'
    },
    {
        'vendor': 'ConnectAndSell, Inc.',
        'product': 'ConnectAndSell'
    },
    {
        'vendor': 'Connect First, Inc.',
        'product': 'ConnectFirst'
    },
    {
        'vendor': 'ConnectLeader, LLC',
        'product': 'ConnectLeader'
    },
    {
        'vendor': 'ConnectWise, LLC',
        'product': 'ConnectWise'
    },
    {
        'vendor': 'ConnectWise, LLC',
        'product': 'ConnectWise Automate'
    },
    {
        'vendor': 'ConnectWise, LLC',
        'product': 'ConnectWise Control'
    },
    {
        'vendor': 'Connectria, LLC',
        'product': 'Connectria'
    },
    {
        'vendor': 'Connexall',
        'product': 'Connexall'
    },
    {
        'vendor': 'Connexity, Inc.',
        'product': 'Connexity'
    },
    {
        'vendor': 'Connext Communication GmbH',
        'product': 'Connext Vivendi'
    },
    {
        'vendor': 'Bullhorn, Inc.',
        'product': 'Connexys Applicant Tracking System'
    },
    {
        'vendor': 'Conservice, LLC',
        'product': 'Conservice'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'Consona'
    },
    {
        'vendor': 'Constant Contact, Inc.',
        'product': 'Constant Contact'
    },
    {
        'vendor': 'ConstructBuy',
        'product': 'ConstructBuy'
    },
    {
        'vendor': 'ConstructConnect',
        'product': 'ConstructConnect'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'Consul'
    },
    {
        'vendor': 'ContaAzul Software Ltda.',
        'product': 'ContaAzul'
    },
    {
        'vendor': 'CCT Solutions, LLC',
        'product': 'ContactPro'
    },
    {
        'vendor': 'Contactatonce',
        'product': 'Contactatonce'
    },
    {
        'vendor': 'Contactually, Inc.',
        'product': 'Contactually'
    },
    {
        'vendor': 'Nelson SoftNet S.L.',
        'product': 'Contanet'
    },
    {
        'vendor': 'Contegix, LLC',
        'product': 'Contegix'
    },
    {
        'vendor': 'SmartOcto B.V.',
        'product': 'Content Insights'
    },
    {
        'vendor': 'Revcontent, LLC',
        'product': 'ContentClick'
    },
    {
        'vendor': 'ContentMX, LLC',
        'product': 'ContentMX'
    },
    {
        'vendor': 'ContentWatch Holdings, Inc.',
        'product': 'ContentProtect'
    },
    {
        'vendor': 'Contentful GmbH',
        'product': 'Contentful'
    },
    {
        'vendor': 'Contently, Inc.',
        'product': 'Contently'
    },
    {
        'vendor': 'Contentserv Group AG',
        'product': 'Contentserv'
    },
    {
        'vendor': 'Contify, Inc.',
        'product': 'Contify'
    },
    {
        'vendor': 'Continuent, Ltd.',
        'product': 'Continuent'
    },
    {
        'vendor': 'Computacion en Accion S.A. de C.V.',
        'product': 'Contpaqi'
    },
    {
        'vendor': 'Global Healthcare Exchange, LLC',
        'product': 'Contract Manager Xpert'
    },
    {
        'vendor': 'ThinkUp Technologies, Inc.',
        'product': 'Contractors Cloud'
    },
    {
        'vendor': 'Contrast Security, Inc.',
        'product': 'Contrast Assess'
    },
    {
        'vendor': 'Contrast Security, Inc.',
        'product': 'Contrast Security'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Control Compliance Suite'
    },
    {
        'vendor': 'Symmetry Corporation',
        'product': 'ControlPanelGRC'
    },
    {
        'vendor': 'ControlUp Technologies, Ltd.',
        'product': 'ControlUp'
    },
    {
        'vendor': 'AxiomSL, Inc.',
        'product': 'ControllerView'
    },
    {
        'vendor': 'Contronics, Ltd.',
        'product': 'Contronics'
    },
    {
        'vendor': 'Convercent, Inc.',
        'product': 'Convercent Ethics Cloud Platform'
    },
    {
        'vendor': 'ConvergeOne, Inc.',
        'product': 'ConvergeOne'
    },
    {
        'vendor': 'Convergence Training',
        'product': 'Convergence LMS'
    },
    {
        'vendor': 'Concentrix Corporation',
        'product': 'Convergys'
    },
    {
        'vendor': 'Conversant, LLC',
        'product': 'Conversant'
    },
    {
        'vendor': 'Epsilon Data Management, LLC',
        'product': 'Conversant CORE'
    },
    {
        'vendor': 'Converseon, Inc.',
        'product': 'Converseon'
    },
    {
        'vendor': 'Conversica, Inc.',
        'product': 'Conversica'
    },
    {
        'vendor': 'ConversionMonk',
        'product': 'ConversionMonk'
    },
    {
        'vendor': 'Market Ruler, LLC',
        'product': 'ConversionRuler'
    },
    {
        'vendor': 'Conversocial, Inc.',
        'product': 'Conversocial'
    },
    {
        'vendor': 'Convertize, Ltd.',
        'product': 'Convertize'
    },
    {
        'vendor': 'ConvertKit, LLC',
        'product': 'Convertkit'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Convio'
    },
    {
        'vendor': 'Convirza',
        'product': 'Convirza'
    },
    {
        'vendor': 'Convoso, Inc.',
        'product': 'Convoso'
    },
    {
        'vendor': 'Baycloud Systems, Ltd.',
        'product': 'CookieQ'
    },
    {
        'vendor': 'CoolaData, Ltd.',
        'product': 'CoolaData'
    },
    {
        'vendor': 'Profit Strategies, Inc.',
        'product': 'Coolfront'
    },
    {
        'vendor': 'Harris Computer Systems',
        'product': 'Copernic'
    },
    {
        'vendor': 'Copper, Inc.',
        'product': 'Copper'
    },
    {
        'vendor': 'Element Software, Inc.',
        'product': 'Copper Project'
    },
    {
        'vendor': 'Genpact, Ltd.',
        'product': 'Cora SeQuence'
    },
    {
        'vendor': 'SouthSuite, Inc.',
        'product': 'Coraid'
    },
    {
        'vendor': 'Coralogix, Inc.',
        'product': 'Coralogix'
    },
    {
        'vendor': 'Corcentric, Inc.',
        'product': 'Corcentric'
    },
    {
        'vendor': 'R3 HoldCo, LLC',
        'product': 'Corda'
    },
    {
        'vendor': 'R3 HoldCo, LLC',
        'product': 'Corda Enterprise'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Cordova'
    },
    {
        'vendor': 'Thermo Fisher Scientific, Inc.',
        'product': 'Core LIMS'
    },
    {
        'vendor': 'Core Security',
        'product': 'Core Security (Unspecified Product)'
    },
    {
        'vendor': 'CoreHR, Ltd.',
        'product': 'CoreHR'
    },
    {
        'vendor': 'CorePartners, Inc.',
        'product': 'CoreIMS'
    },
    {
        'vendor': 'CoreLogic, Inc.',
        'product': 'CoreLogic Jenark'
    },
    {
        'vendor': 'CoreLogic, Inc.',
        'product': 'CoreLogic Rental Property Solutions'
    },
    {
        'vendor': 'CoreMedia Corporation',
        'product': 'CoreMedia'
    },
    {
        'vendor': 'CoreOS, Inc.',
        'product': 'CoreOS'
    },
    {
        'vendor': 'CoreOS, Inc.',
        'product': 'CoreOS Clair'
    },
    {
        'vendor': 'CoreOS, Inc.',
        'product': 'CoreOS Ignition'
    },
    {
        'vendor': 'CoreOS, Inc.',
        'product': 'CoreOS flannel'
    },
    {
        'vendor': 'CoreOS, Inc.',
        'product': 'CoreOS rkt'
    },
    {
        'vendor': 'CoreSite Realty Corporation',
        'product': 'CoreSite'
    },
    {
        'vendor': 'Corecon Technologies, Inc.',
        'product': 'Corecon'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'Corel'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'Corel PaintShop Pro'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'Corel Ventura'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'Corel Wordperfect Office'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'CorelCAD'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'CorelDRAW'
    },
    {
        'vendor': 'Corelight, Inc.',
        'product': 'Corelight'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Corente Cloud Services Exchange'
    },
    {
        'vendor': 'Lyniate',
        'product': 'Corepoint'
    },
    {
        'vendor': 'Corero Network Security, Inc.',
        'product': 'Corero'
    },
    {
        'vendor': 'Coreworx, Inc.',
        'product': 'Coreworx'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Coriant 8600'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Coriant hiT 7300'
    },
    {
        'vendor': 'Cority Software, Inc.',
        'product': 'Cority'
    },
    {
        'vendor': 'Corix Infrastructure, Inc.',
        'product': 'Corix'
    },
    {
        'vendor': 'Cormant, Inc.',
        'product': 'Cormant-CS'
    },
    {
        'vendor': 'Cornell Communications, Inc.',
        'product': 'Cornell Nurse Call'
    },
    {
        'vendor': 'Cornerstone OnDemand, Inc.',
        'product': 'Cornerstone LMS'
    },
    {
        'vendor': 'Cornerstone OnDemand, Inc.',
        'product': 'Cornerstone OnDemand'
    },
    {
        'vendor': 'Cornerstone OnDemand, Inc.',
        'product': 'Cornerstone Performance Suite'
    },
    {
        'vendor': 'Cornerstone OnDemand, Inc.',
        'product': 'Cornerstone Recruiting Suite'
    },
    {
        'vendor': 'Chaos Czech A/S',
        'product': 'Corona Renderer'
    },
    {
        'vendor': 'CorpAxe',
        'product': 'CorpAxe'
    },
    {
        'vendor': 'Corpro S.A.',
        'product': 'Corpro E-Learning'
    },
    {
        'vendor': 'CorreLog, Inc.',
        'product': 'CorreLog'
    },
    {
        'vendor': 'Correlsense, Inc.',
        'product': 'Correlsense'
    },
    {
        'vendor': 'Jones Lang LaSalle IP, Inc.',
        'product': 'Corrigo'
    },
    {
        'vendor': 'Clarivate Analytics, LLC',
        'product': 'Cortellis'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A-Series'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A15'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A17'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A32'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A35'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A5'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A53'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A55'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A57'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A7'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A72'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A75'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A76'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex A9'
    },
    {
        'vendor': 'Cortex EDI, Inc.',
        'product': 'Cortex EDI'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M-Series'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M0'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M1'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M23'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M3'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M33'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M4'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex M7'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex R-Series'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex R4'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex R5'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex R52'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex R7'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Cortex XSOAR'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Cortex-R8'
    },
    {
        'vendor': 'Pico Quantitative Trading, LLC',
        'product': 'Corvil Classic'
    },
    {
        'vendor': 'Cosential, Inc.',
        'product': 'Cosential'
    },
    {
        'vendor': 'CosmoLex Cloud, LLC',
        'product': 'CosmoLex'
    },
    {
        'vendor': 'CosmoShop GmbH',
        'product': 'CosmoShop'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'CouchDB'
    },
    {
        'vendor': 'Couchbase, Inc.',
        'product': 'Couchbase'
    },
    {
        'vendor': 'Cougar Mountain Software Network',
        'product': 'Cougar Mountain Denali'
    },
    {
        'vendor': 'Coull, Ltd.',
        'product': 'Coull'
    },
    {
        'vendor': 'GoSecure, Inc.',
        'product': 'CounterTack'
    },
    {
        'vendor': 'Countly, Ltd.',
        'product': 'Countly'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa (Unspecified Product)'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa AI Classification'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Advantage'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Budgets'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Business Spend Management Platform'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Contract Management'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Expense'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Inventory'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Invoice'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Open Business Network'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Pay'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Procurement'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Risk Aware'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Sourcing'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Sourcing Optimization'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Spend Analysis'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Spend360'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Storefront'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Strategic Sourcing'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Supplier Information Management'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Travel and Expense Management'
    },
    {
        'vendor': 'Leepfrog Technologies, Inc.',
        'product': 'Courseleaf'
    },
    {
        'vendor': 'Coursera, Inc.',
        'product': 'Coursera'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'CourtLink'
    },
    {
        'vendor': 'COVANCE, Inc.',
        'product': 'Covance'
    },
    {
        'vendor': 'Coveo Solutions, Inc.',
        'product': 'Coveo'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Coverity'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Covisint'
    },
    {
        'vendor': 'Cox Communications, Inc.',
        'product': 'Cox Web Hosting'
    },
    {
        'vendor': 'Cradlepoint, Inc.',
        'product': 'Cradlepoint NetCloud'
    },
    {
        'vendor': 'Cradlepoint, Inc.',
        'product': 'Cradlepoint Routers'
    },
    {
        'vendor': 'Pixel & Tonic, Inc.',
        'product': 'Craft CMS'
    },
    {
        'vendor': 'Pixel & Tonic, Inc.',
        'product': 'Craft Commerce'
    },
    {
        'vendor': 'Crafter Software Corporation',
        'product': 'Crafter Software'
    },
    {
        'vendor': 'Craneware, Inc.',
        'product': 'Craneware'
    },
    {
        'vendor': 'Code42 Software, Inc.',
        'product': 'CrashPlan'
    },
    {
        'vendor': 'Crate.io, Inc.',
        'product': 'CrateDB'
    },
    {
        'vendor': 'HPE',
        'product': 'Cray CS-Storm'
    },
    {
        'vendor': 'Crazy Egg, Inc.',
        'product': 'Crazy Egg'
    },
    {
        'vendor': 'CrazyBump',
        'product': 'CrazyBump'
    },
    {
        'vendor': 'Creatio, Ltd.',
        'product': 'Creatio'
    },
    {
        'vendor': 'CreatorIQ, Ltd.',
        'product': 'CreatorIQ'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'Creo Elements/Pro'
    },
    {
        'vendor': 'Crestron Electronics, Inc.',
        'product': 'Crestron'
    },
    {
        'vendor': 'Crestron Electronics, Inc.',
        'product': 'Crestron Fusion'
    },
    {
        'vendor': 'Cribl, Inc.',
        'product': 'Cribl'
    },
    {
        'vendor': 'Brandwatch',
        'product': 'Crimson Hexagon'
    },
    {
        'vendor': 'CrisisGo, Inc.',
        'product': 'CrisisGo'
    },
    {
        'vendor': 'Crisp IM SARL',
        'product': 'Crisp'
    },
    {
        'vendor': 'CritSend',
        'product': 'CritSend'
    },
    {
        'vendor': 'Criteo S.A.',
        'product': 'Criteo Direct Bidder'
    },
    {
        'vendor': 'Criteo S.A.',
        'product': 'Criteo for Advertisers'
    },
    {
        'vendor': 'Criterions',
        'product': 'Criterions EHR'
    },
    {
        'vendor': 'Critical Impact Software, Inc.',
        'product': 'Critical Impact'
    },
    {
        'vendor': 'Criticare Technologies, Inc.',
        'product': 'Criticare'
    },
    {
        'vendor': 'Box, Inc.',
        'product': 'Crocodoc'
    },
    {
        'vendor': 'Open Source',
        'product': 'Croogo'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'CrossBrowserTesting'
    },
    {
        'vendor': 'Kathrein Solutions GmbH',
        'product': 'CrossTalk IoT Suite'
    },
    {
        'vendor': 'Crossbeam, Inc.',
        'product': 'Crossbeam'
    },
    {
        'vendor': 'Crosschq, Inc.',
        'product': 'Crosschq'
    },
    {
        'vendor': 'Crowd Science',
        'product': 'Crowd.Science'
    },
    {
        'vendor': 'Cvent, Inc.',
        'product': 'CrowdCompass'
    },
    {
        'vendor': 'CrowdStreet, Inc.',
        'product': 'CrowdStreet CS Connect'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike Falcon'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike Falcon OverWatch'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike Falcon X'
    },
    {
        'vendor': 'CrowdTwist, Inc.',
        'product': 'CrowdTwist'
    },
    {
        'vendor': 'Automattic, Inc.',
        'product': 'Crowdsignal'
    },
    {
        'vendor': 'Crown Computing, Ltd.',
        'product': 'Crown'
    },
    {
        'vendor': 'Crownpeak Technology, Inc.',
        'product': 'CrownPeak'
    },
    {
        'vendor': 'Open Source',
        'product': 'CruiseControl'
    },
    {
        'vendor': 'Crunch, Ltd.',
        'product': 'Crunch Accounting'
    },
    {
        'vendor': 'Cryptzone',
        'product': 'Cryptzone'
    },
    {
        'vendor': 'Abeo Solutions, Inc.',
        'product': 'Crystal PM'
    },
    {
        'vendor': 'CubeCart, Ltd.',
        'product': 'CubeCart'
    },
    {
        'vendor': 'Cubeware GmbH',
        'product': 'Cubeware'
    },
    {
        'vendor': 'RuleQuest Research Pty Ltd',
        'product': 'Cubist'
    },
    {
        'vendor': 'Cucumber, Ltd.',
        'product': 'Cucumber'
    },
    {
        'vendor': 'Culture Amp Pty Ltd',
        'product': 'Culture Amp'
    },
    {
        'vendor': 'CultureIQ, Inc.',
        'product': 'CultureIQ'
    },
    {
        'vendor': 'Software AG',
        'product': 'Cumulocity IoT'
    },
    {
        'vendor': 'Cura Global GRC Solutions Pte Ltd',
        'product': 'Cura Software'
    },
    {
        'vendor': 'Bazaarvoice, Inc.',
        'product': 'Curalate'
    },
    {
        'vendor': 'CureMD Corporation',
        'product': 'CureMD'
    },
    {
        'vendor': 'Sprint Corporation',
        'product': 'Curiosity IoT'
    },
    {
        'vendor': 'CurveBeam, LLC',
        'product': 'CurveBeam pedCAT'
    },
    {
        'vendor': 'CustomShow, Inc.',
        'product': 'CustomShow'
    },
    {
        'vendor': 'Customer.io',
        'product': 'Customer.io'
    },
    {
        'vendor': 'Demandforce, Inc.',
        'product': 'CustomerLink'
    },
    {
        'vendor': 'CustomerThink Corporation',
        'product': 'CustomerThink'
    },
    {
        'vendor': 'Custora, Inc.',
        'product': 'Custora'
    },
    {
        'vendor': 'Cvent, Inc.',
        'product': 'Cvent'
    },
    {
        'vendor': 'Cvent, Inc.',
        'product': 'Cvent Event Management'
    },
    {
        'vendor': 'Cvent, Inc.',
        'product': 'Cvent Meeting Management'
    },
    {
        'vendor': 'Cxense ASA',
        'product': 'Cxense Content'
    },
    {
        'vendor': 'Cxense ASA',
        'product': 'Cxense DMP'
    },
    {
        'vendor': 'CyCognito, Ltd.',
        'product': 'CyCognito'
    },
    {
        'vendor': 'CyFIR, LLC',
        'product': 'CyFIR'
    },
    {
        'vendor': 'Cyara, Inc.',
        'product': 'Cyara Automated CX Assurance Platform'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'CyberArk (Unspecified Product)'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'CyberArk Application Identity Manager'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'CyberArk Conjur'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'CyberArk Core Privileged Access Security Solution'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'CyberArk Endpoint Privilege Manager'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'CyberArk Enterprise Password Vault'
    },
    {
        'vendor': 'CyberDB, Ltd.',
        'product': 'CyberDB'
    },
    {
        'vendor': 'Cyber Global Risk Exchange, Inc.',
        'product': 'CyberGRX'
    },
    {
        'vendor': 'Accuray, Inc.',
        'product': 'CyberKnife'
    },
    {
        'vendor': 'CyberPower Systems, Inc.',
        'product': 'CyberPower'
    },
    {
        'vendor': 'CyberSource Corporation',
        'product': 'CyberSource'
    },
    {
        'vendor': 'Cyberbit, Ltd.',
        'product': 'Cyberbit'
    },
    {
        'vendor': 'Cybereason, Inc.',
        'product': 'Cybereason'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Cyberoam'
    },
    {
        'vendor': 'Cyberscience Corporation',
        'product': 'Cyberquery'
    },
    {
        'vendor': 'Cybex Systems',
        'product': 'Cybex POS'
    },
    {
        'vendor': 'Cybozu, Inc.',
        'product': 'Cybozu'
    },
    {
        'vendor': 'Cyfe, Inc.',
        'product': 'Cyfe'
    },
    {
        'vendor': 'Cyfluent, Inc.',
        'product': 'Cyfluent'
    },
    {
        'vendor': 'Weatherford International PLC',
        'product': 'CygNet'
    },
    {
        'vendor': 'Cygilant, Inc.',
        'product': 'Cygilant'
    },
    {
        'vendor': 'Cygilant, Inc.',
        'product': 'Cygilant SOCVue'
    },
    {
        'vendor': 'Cylance, Inc.',
        'product': 'Cylance'
    },
    {
        'vendor': 'Cymulate, Ltd.',
        'product': 'Cymulate'
    },
    {
        'vendor': 'CynergisTek, Inc.',
        'product': 'CynergisTek'
    },
    {
        'vendor': 'Epazz, Inc.',
        'product': 'Cynergy'
    },
    {
        'vendor': 'Cypress.io, Inc.',
        'product': 'Cypress.io'
    },
    {
        'vendor': 'Cyren, Ltd.',
        'product': 'Cyren'
    },
    {
        'vendor': 'Cyrious Software, Inc.',
        'product': 'Cyrious'
    },
    {
        'vendor': 'CyrusOne, LLC',
        'product': 'CyrusOne'
    },
    {
        'vendor': 'Dun & Bradstreet, Inc.',
        'product': 'D&B Credit'
    },
    {
        'vendor': 'Dun & Bradstreet, Inc.',
        'product': 'D&B Hoovers'
    },
    {
        'vendor': 'Dun & Bradstreet, Inc.',
        'product': 'D&B Optimizer'
    },
    {
        'vendor': 'D-EDGE SAS',
        'product': 'D-EDGE'
    },
    {
        'vendor': 'D-Link Corporation',
        'product': 'D-Link Switches'
    },
    {
        'vendor': 'D-Wave Systems, Inc.',
        'product': 'D-Wave (Unspecified Product)'
    },
    {
        'vendor': 'D2iQ, Inc.',
        'product': 'D2iQ'
    },
    {
        'vendor': 'Open Source',
        'product': 'D3.js'
    },
    {
        'vendor': 'DataTrak International, Inc.',
        'product': 'DATATRAK'
    },
    {
        'vendor': 'DATEV eG',
        'product': 'DATEV Accounting'
    },
    {
        'vendor': 'DATIS HR Cloud, Inc.',
        'product': 'DATIS'
    },
    {
        'vendor': 'Datometry, Inc.',
        'product': 'DATOMETRY'
    },
    {
        'vendor': 'Infogix, Inc.',
        'product': 'DATUM Information Value Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'DB2'
    },
    {
        'vendor': 'Avankia, LLC',
        'product': 'DBSync'
    },
    {
        'vendor': 'DBMaestro, Inc.',
        'product': 'DBmaestro'
    },
    {
        'vendor': 'DBxtra',
        'product': 'DBxtra'
    },
    {
        'vendor': 'Rakuten Advertising',
        'product': 'DC Storm'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'DC Ultra'
    },
    {
        'vendor': 'D2iQ, Inc.',
        'product': 'DC/OS'
    },
    {
        'vendor': 'DataDirect Networks, Inc.',
        'product': 'DDN WOS'
    },
    {
        'vendor': 'DDOTS, Inc.',
        'product': 'DDOTS'
    },
    {
        'vendor': 'Data Design System GmbH',
        'product': 'DDS-CAD'
    },
    {
        'vendor': 'DEAR Systems, Ltd.',
        'product': 'DEAR Inventory'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'DELMIA Quintiq'
    },
    {
        'vendor': 'Thinkproject Deutschland GmbH',
        'product': 'DESITE BIM'
    },
    {
        'vendor': 'DGIT Systems',
        'product': 'DGIT'
    },
    {
        'vendor': 'CS Disco, Inc.',
        'product': 'DISCO'
    },
    {
        'vendor': 'Open Source',
        'product': 'DITA Open Toolkit'
    },
    {
        'vendor': 'Saaranya Hospitality Technologies Pvt Ltd',
        'product': 'DJUBO'
    },
    {
        'vendor': 'DISTRIBUTION MANAGEMENT SYSTEMS, INC.',
        'product': 'DMSi Agility'
    },
    {
        'vendor': 'DNASTAR, Inc.',
        'product': 'DNASTAR'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'DNAapps'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'DNAappstore'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'DNAcreator'
    },
    {
        'vendor': 'DNAnexus, Inc.',
        'product': 'DNAnexus'
    },
    {
        'vendor': 'DNN Corporation',
        'product': 'DNN'
    },
    {
        'vendor': 'DNS Made Easy',
        'product': 'DNS Made Easy'
    },
    {
        'vendor': 'DNSFilter, Inc.',
        'product': 'DNSFilter'
    },
    {
        'vendor': 'DNSPod, Inc.',
        'product': 'DNSPod'
    },
    {
        'vendor': 'DNSimple Corporation',
        'product': 'DNSimple'
    },
    {
        'vendor': 'DSC Software AG',
        'product': 'DSC'
    },
    {
        'vendor': 'DSC Logistics, Inc.',
        'product': 'DSC Logistics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'DSI dcLINK'
    },
    {
        'vendor': 'DTEN, Inc.',
        'product': 'DTEN'
    },
    {
        'vendor': 'Dtex Systems Pty Ltd',
        'product': 'DTEX'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'DX App Synthetic Monitor'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'DX Application Performance Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'DX Infrastructure Manager'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'DX NetOps'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'DX Spectrum'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'DXC Business Process Services'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'DXC Hogan Systems'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'DXC Lorenzo'
    },
    {
        'vendor': 'Decibel Insight, Ltd.',
        'product': 'DXS'
    },
    {
        'vendor': 'DaCast, Inc.',
        'product': 'DaCast Online Video Platform'
    },
    {
        'vendor': 'TietoEVRY Oyj',
        'product': 'DaWinci'
    },
    {
        'vendor': 'DaCast, Inc.',
        'product': 'Dacast'
    },
    {
        'vendor': 'Milsoft Utility Solutions, Inc.',
        'product': 'Daffron'
    },
    {
        'vendor': 'Zhejiang Dahua Technology Company, Ltd.',
        'product': 'Dahua'
    },
    {
        'vendor': 'Dailymotion S.A.',
        'product': 'DailyMotion Cloud'
    },
    {
        'vendor': 'Dailymotion S.A.',
        'product': 'Dailymotion'
    },
    {
        'vendor': 'Daisycon B.V.',
        'product': 'Daisycon'
    },
    {
        'vendor': 'Open Source',
        'product': 'DalekJS'
    },
    {
        'vendor': 'Dalet S.A.',
        'product': 'Dalet'
    },
    {
        'vendor': 'Core Security',
        'product': 'Damballa'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'DameWare'
    },
    {
        'vendor': 'Daminion Software',
        'product': 'Daminion'
    },
    {
        'vendor': 'Kerridge Commercial Systems, Ltd.',
        'product': 'Dancik Navigator'
    },
    {
        'vendor': 'Danea Soft S.R.L.',
        'product': 'Danea Easyfatt'
    },
    {
        'vendor': 'Dapresy North America, Inc.',
        'product': 'Dapresy'
    },
    {
        'vendor': 'Changepoint Corporation',
        'product': 'Daptiv'
    },
    {
        'vendor': 'Open Source',
        'product': 'Darknet'
    },
    {
        'vendor': 'Darktrace, Ltd.',
        'product': 'Darktrace'
    },
    {
        'vendor': 'Darwinbox Digital Solutions Pvt Ltd',
        'product': 'Darwinbox'
    },
    {
        'vendor': 'Moment Zero, Inc.',
        'product': 'DashThis'
    },
    {
        'vendor': 'Dashboard Advantage, LLC',
        'product': 'Dashboard Advantage'
    },
    {
        'vendor': 'Dasheroo, Inc.',
        'product': 'Dasheroo'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'Dask'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault 3DSwYm'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault 3DVIA'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault BIOVIA'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault DELMIA'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault DraftSight'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault Dymola'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault ENOVIA'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault EXALEAD'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault EXALEAD Cloudview'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault GEOVIA'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault ICEM Surf'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault SIMULIA'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault SOLIDWORKS'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'Dassault Systemes (Unspecified Product)'
    },
    {
        'vendor': 'Varonis Systems, Inc.',
        'product': 'DatAdvantage'
    },
    {
        'vendor': 'Data Deposit Box, Inc.',
        'product': 'Data Deposit Box'
    },
    {
        'vendor': 'Data Dynamics, Inc.',
        'product': 'Data Dynamics (Unspecified Product)'
    },
    {
        'vendor': 'Data Foundry, Inc.',
        'product': 'Data Foundry'
    },
    {
        'vendor': 'Data Masons Software',
        'product': 'Data Masons'
    },
    {
        'vendor': 'DataCad, LLC',
        'product': 'DataCAD'
    },
    {
        'vendor': 'Human Inference B.V.',
        'product': 'DataCleaner'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'DataDirect'
    },
    {
        'vendor': 'DataDirect Networks, Inc.',
        'product': 'DataDirect Networks'
    },
    {
        'vendor': 'DataDome S.A.',
        'product': 'DataDome'
    },
    {
        'vendor': 'DataEase, Ltd.',
        'product': 'DataEase'
    },
    {
        'vendor': 'DataGrail, Inc.',
        'product': 'DataGrail'
    },
    {
        'vendor': 'DataMotion, Inc.',
        'product': 'DataMotion Direct'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'DataPipe Hosting'
    },
    {
        'vendor': 'DataRobot, Inc.',
        'product': 'DataRobot'
    },
    {
        'vendor': 'DataStax, Inc.',
        'product': 'DataStax'
    },
    {
        'vendor': 'DataSunrise, Inc.',
        'product': 'DataSunrise'
    },
    {
        'vendor': 'DataTorrent, Inc.',
        'product': 'DataTorrent'
    },
    {
        'vendor': 'Alibaba Group Holding, Ltd.',
        'product': 'DataV'
    },
    {
        'vendor': 'Roku, Inc.',
        'product': 'DataXu'
    },
    {
        'vendor': 'Datical, Inc.',
        'product': 'Database Change Management Simulator'
    },
    {
        'vendor': 'Datical, Inc.',
        'product': 'Database Code Packager'
    },
    {
        'vendor': 'Databricks, Inc.',
        'product': 'Databricks Unified Analytics Platform'
    },
    {
        'vendor': 'Datacor, Inc.',
        'product': 'Datacor Chempax'
    },
    {
        'vendor': 'DataCore Software Corporation',
        'product': 'Datacore'
    },
    {
        'vendor': 'Datacrushers',
        'product': 'Datacrushers'
    },
    {
        'vendor': 'Datadog, Inc.',
        'product': 'Datadog'
    },
    {
        'vendor': 'Dataforma, Inc.',
        'product': 'Dataforma'
    },
    {
        'vendor': 'Dataguise, Inc.',
        'product': 'Dataguise'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Datahug'
    },
    {
        'vendor': 'Dataiku, Inc.',
        'product': 'Dataiku'
    },
    {
        'vendor': 'IHS Markit, Ltd.',
        'product': 'Dataium'
    },
    {
        'vendor': 'Datalicious Pty Ltd',
        'product': 'Datalicious'
    },
    {
        'vendor': 'Datalogic S.p.A.',
        'product': 'Datalogic Falcon'
    },
    {
        'vendor': 'Datalogic S.p.A.',
        'product': 'Datalogic Gryphon'
    },
    {
        'vendor': 'Datameer, Inc.',
        'product': 'Datameer'
    },
    {
        'vendor': 'Datamine Australia Pty Ltd',
        'product': 'Datamine'
    },
    {
        'vendor': 'Dataminr, Inc.',
        'product': 'Dataminr'
    },
    {
        'vendor': 'Datanyze, Inc.',
        'product': 'Datanyze'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Datapipe'
    },
    {
        'vendor': 'Datasift, Inc.',
        'product': 'Datasift'
    },
    {
        'vendor': 'Datasite, LLC',
        'product': 'Datasite'
    },
    {
        'vendor': 'Datavant, Inc.',
        'product': 'Datavant'
    },
    {
        'vendor': 'Datawatch Corporation',
        'product': 'Datawatch'
    },
    {
        'vendor': 'VIQ Solutions, Inc.',
        'product': 'Dataworxs'
    },
    {
        'vendor': 'Datera, Inc.',
        'product': 'Datera'
    },
    {
        'vendor': 'Datical, Inc.',
        'product': 'Datical'
    },
    {
        'vendor': 'Datorama, Inc.',
        'product': 'Datorama'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Datrium'
    },
    {
        'vendor': 'Datto, Inc.',
        'product': 'Datto'
    },
    {
        'vendor': 'Datto, Inc.',
        'product': 'Datto RMM'
    },
    {
        'vendor': 'Datto, Inc.',
        'product': 'Datto SIRIS'
    },
    {
        'vendor': 'Davra Networks, Ltd.',
        'product': 'Davra'
    },
    {
        'vendor': 'Daxko, LLC',
        'product': 'Daxko'
    },
    {
        'vendor': 'DealCloud, Inc.',
        'product': 'DealCloud'
    },
    {
        'vendor': 'DealHub, Ltd.',
        'product': 'DealHub'
    },
    {
        'vendor': 'DealerSafeGuardSolutionS, LLC',
        'product': 'Dealer Safeguard'
    },
    {
        'vendor': 'Dealer.com, Inc.',
        'product': 'Dealer.com'
    },
    {
        'vendor': 'Nowcom Corporation',
        'product': 'DealerCenter'
    },
    {
        'vendor': 'DealerSocket, Inc.',
        'product': 'DealerSocket'
    },
    {
        'vendor': 'Open Source',
        'product': 'Debian'
    },
    {
        'vendor': 'NCH Software, Inc.',
        'product': 'Debut Video Capture'
    },
    {
        'vendor': 'Decibel Insight, Ltd.',
        'product': 'Decibel Insight'
    },
    {
        'vendor': 'Decision Systems, Inc.',
        'product': 'Decision Systems'
    },
    {
        'vendor': 'Blackmagic Design Pty Ltd',
        'product': 'DeckLink'
    },
    {
        'vendor': 'Declaree B.V.',
        'product': 'Declaree'
    },
    {
        'vendor': 'Dedalus HealthCare GmbH',
        'product': 'Dedalus'
    },
    {
        'vendor': 'Deem, Inc.',
        'product': 'Deem'
    },
    {
        'vendor': 'Deep Instinct, Ltd.',
        'product': 'Deep Instinct'
    },
    {
        'vendor': 'Deep Vision, Inc.',
        'product': 'Deep Vision'
    },
    {
        'vendor': 'Deep Vision AI, Inc.',
        'product': 'Deep Vision AI'
    },
    {
        'vendor': 'DeepCode AG',
        'product': 'DeepCode'
    },
    {
        'vendor': 'DeepCrawl',
        'product': 'DeepCrawl'
    },
    {
        'vendor': 'DeepL GmbH',
        'product': 'DeepL Translator'
    },
    {
        'vendor': 'Baidu Research',
        'product': 'DeepSpeech'
    },
    {
        'vendor': 'Baidu Research',
        'product': 'DeepSpeech 2'
    },
    {
        'vendor': 'Deepgram, Inc.',
        'product': 'Deepgram'
    },
    {
        'vendor': 'Konduit K.K.',
        'product': 'Deeplearning4j'
    },
    {
        'vendor': 'DefendX Software',
        'product': 'DefendX'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Defensics Fuzz'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Delcam'
    },
    {
        'vendor': 'Delego Software, Inc.',
        'product': 'Delego'
    },
    {
        'vendor': 'Delighted, LLC',
        'product': 'Delighted'
    },
    {
        'vendor': 'Delivr Corporation',
        'product': 'Delivr'
    },
    {
        'vendor': 'Delivra, Inc.',
        'product': 'Delivra'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell (Unspecified Product)'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'Dell BSAFE'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Boomi'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Boomi AtomSphere'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Clerity'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Cloud'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Credant'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell DR4000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Desktop Authority'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC AX-series'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC AppSync'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Atmos'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Avamar'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC CLARiiON CX'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Captiva'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Celerra'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Centera'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC ClaimPack'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Clariion'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Dell EMC Configuresoft'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Connectrix'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Control Center'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Data Domain'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Data Protection Advisor'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Data Protection Suite'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Disaster Recovery'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Disk Library for Mainframe'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC DiskXtender'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Dell EMC Document Sciences'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC ECM'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Elastic Cloud Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC FormWare'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Hardware'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC HomeBase'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC InfoMover'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Invista'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Isilon'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Isilon OneFS'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Kazeon'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC MirrorView'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Navisphere'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC NetWorker'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Open Migrator'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Open Migrator/LM'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC PowerPath'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC PowerProtect DD'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC ProSphere'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC RecoverPoint'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC SAN (Storage Area Network)'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC SC9000 Array Controller'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Smarts Network Configuration Manager'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC SnapView'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC SourceOne'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Symmetrix'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Symmetrix VMAX'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC TimeFinder'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Unisphere'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Unity'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Unity XT'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC UnityVSA'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VCE'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VMAX All Flash'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VNX'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VNXe'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VPLEX'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC Vblock'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC ViPR SRM'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VxBlock'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VxFlex'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VxFlex Ready Nodes'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC VxRail'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC XC'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC XtremCache'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC XtremIO'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC vSAN Ready Nodes'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic Compellent Storage Center'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic FS7500'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS4100 Series Arrays'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS4100E'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS4100X'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS4110 Series Arrays'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6100 Series Arrays'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6100E Networked Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6100X Networked Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6100XV'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6110 Series Arrays'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6210'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6500 Series SAN Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS6500E'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Fluid File System'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Force10'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Inspiron'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Laptop'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Latitude'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell N2000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell N3000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell N4000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Network Attached Storage (NAS)'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell OpenManage Essentials'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell OptiPlex'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerConnect'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 1800 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 1850 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 1900 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 1950 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 1955 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 2800'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 2850 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 2900 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 2950 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 2970 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 6800 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 6850 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 6950 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 800 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 830 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 840 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 850 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge 860 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge C6100 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge C6220 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge FX Series'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M600 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M605 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M610 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M620 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M640 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M710 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge M910 Blade Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge MX Series'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R200 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R210 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R300 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R310 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R410 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R440 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R510 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R515 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R540 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R610 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R620 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R630 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R640 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R710 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R715 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R720 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R720XD Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R730 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R740 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R805 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R810 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R815 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R830 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R900 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R905 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge R910 Rack Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge Servers'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T100 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T105 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T110 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T300 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T310 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T410 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T440 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T610 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T620 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge T710 Tower Server'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerEdge VRTX'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerMax 2000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerMax 8000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerMax Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerProtect DD3300'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault 124T Tape Autoloader'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault DL Backup'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault FC SAN'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault LTO'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault MD1200 Direct Attached Storage Array'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault MD1220 Direct Attached Storage Array'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault MD3200 SAS Storage Array'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault MD3220 SAS Storage Array'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault ME4012'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault ME4024'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault ML6000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault RD1000 Removable Disk Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault Storage Arrays'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault TL2000 Tape Library'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault TL4000 Tape Library'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell PowerVault iSCSI'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Precision'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell S6000'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell SC5020 All Flash Storage'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell SCv3000 Storage Array'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell SecureWorks'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Tablet'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell VNA'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Wyse'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell XPS'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Z9100'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Z9500'
    },
    {
        'vendor': 'Delphix Corporation',
        'product': 'Delphix'
    },
    {
        'vendor': 'Delta Health Technologies, LLC',
        'product': 'Delta Health Encore'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Delta Lake'
    },
    {
        'vendor': 'Emerson Electric Company',
        'product': 'DeltaV'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek (Unspecified Product)'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Acumen'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Advantage'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Ajera'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Cobra'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Costpoint'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek FMS'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek First'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek GCS Premier'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek GovWin IQ'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek IPM'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Maconomy'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Open Plan'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek PM Compass'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Sema4'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Talent Management'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Vision'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Vision CRM'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek wInsight Analytics'
    },
    {
        'vendor': 'LLamasoft, Inc.',
        'product': 'Demand Guru'
    },
    {
        'vendor': 'Acoustic LP',
        'product': 'DemandTec'
    },
    {
        'vendor': 'Demandbase, Inc.',
        'product': 'Demandbase'
    },
    {
        'vendor': 'Demandforce, Inc.',
        'product': 'Demandforce'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Demisto'
    },
    {
        'vendor': 'Demodesk, Inc.',
        'product': 'Demodesk'
    },
    {
        'vendor': 'Denodo Technologies, Inc.',
        'product': 'Denodo'
    },
    {
        'vendor': 'Densify, Inc.',
        'product': 'Densify'
    },
    {
        'vendor': 'EDI-Health Group, Inc.',
        'product': 'DentalXChange'
    },
    {
        'vendor': 'DentiMax, LLC',
        'product': 'DentiMax'
    },
    {
        'vendor': 'Dentisoft Technologies',
        'product': 'Dentisoft'
    },
    {
        'vendor': 'Henry Schein, Inc.',
        'product': 'Dentrix'
    },
    {
        'vendor': 'Rohde & Schwarz GmbH & Company KG',
        'product': 'DenyAll'
    },
    {
        'vendor': 'Liquibase',
        'product': 'Deployment Monitoring Console'
    },
    {
        'vendor': 'Deposco, Inc.',
        'product': 'Deposco'
    },
    {
        'vendor': 'Deputechnologies Pty Ltd',
        'product': 'Deputy'
    },
    {
        'vendor': 'Derdack GmbH',
        'product': 'Derdack Enterprise Alert'
    },
    {
        'vendor': 'Clarivate Analytics, LLC',
        'product': 'Derwent'
    },
    {
        'vendor': 'Clarivate Analytics, LLC',
        'product': 'Derwent Innovation'
    },
    {
        'vendor': 'Descartes Labs, Inc.',
        'product': 'Descartes Labs'
    },
    {
        'vendor': 'The Descartes Systems Group, Inc.',
        'product': 'Descartes Systems'
    },
    {
        'vendor': 'Descript, Inc.',
        'product': 'Descript'
    },
    {
        'vendor': 'IMSI Design, LLC',
        'product': 'DesignCAD'
    },
    {
        'vendor': 'Wipro, Ltd.',
        'product': 'Designit'
    },
    {
        'vendor': 'D2L Corporation',
        'product': 'Desire2Learn'
    },
    {
        'vendor': 'ToolBarStudio, Inc.',
        'product': 'DeskAlerts'
    },
    {
        'vendor': 'Deskera US, Inc.',
        'product': 'Deskera'
    },
    {
        'vendor': 'Nabra, Ltd.',
        'product': 'Deskero'
    },
    {
        'vendor': 'Deskpro, Ltd.',
        'product': 'Deskpro'
    },
    {
        'vendor': 'Destiny Solutions, Inc.',
        'product': 'Destiny One'
    },
    {
        'vendor': 'Determine, Inc.',
        'product': 'Determine Software'
    },
    {
        'vendor': 'Determined AI',
        'product': 'Determined AI'
    },
    {
        'vendor': 'Developer Express, Inc.',
        'product': 'DevExpress'
    },
    {
        'vendor': 'Devart, Ltd.',
        'product': 'Devart dbForge SQL Complete'
    },
    {
        'vendor': 'Devart, Ltd.',
        'product': 'Devart dbForge Schema Compare'
    },
    {
        'vendor': 'Development Dimensions International, Inc.',
        'product': 'Development Dimensions International Pinpoint Platform'
    },
    {
        'vendor': 'Device42, Inc.',
        'product': 'Device42'
    },
    {
        'vendor': 'Afilias Technologies, Ltd.',
        'product': 'DeviceAtlas'
    },
    {
        'vendor': 'NantHealth, Inc.',
        'product': 'DeviceConX'
    },
    {
        'vendor': 'DataArt Solutions, Inc.',
        'product': 'DeviceHive'
    },
    {
        'vendor': 'Acronis International GmbH',
        'product': 'DeviceLock'
    },
    {
        'vendor': 'Dexcom, Inc.',
        'product': 'Dexcom'
    },
    {
        'vendor': 'Dgraph Labs, Inc.',
        'product': 'Dgraph'
    },
    {
        'vendor': 'DiCentral Corporation',
        'product': 'DiCentral'
    },
    {
        'vendor': 'DialSource, Inc.',
        'product': 'DialSource Denali'
    },
    {
        'vendor': 'DialogTech, Inc.',
        'product': 'DialogTech'
    },
    {
        'vendor': 'Dialpad, Inc.',
        'product': 'Dialpad'
    },
    {
        'vendor': 'Diamanti, Inc.',
        'product': 'Diamanti'
    },
    {
        'vendor': 'Diamond Student Information Systems',
        'product': 'Diamond SIS'
    },
    {
        'vendor': 'Dianomi, Ltd.',
        'product': 'Dianomi'
    },
    {
        'vendor': 'Diebold Nixdorf, Inc.',
        'product': 'Diebold Nixdorf (Unspecified Product)'
    },
    {
        'vendor': 'Dieselpoint, Inc.',
        'product': 'Dieselpoint'
    },
    {
        'vendor': 'Digital Architecture Group, Inc.',
        'product': 'Digarc'
    },
    {
        'vendor': 'DigiCert, Inc.',
        'product': 'DigiCert'
    },
    {
        'vendor': 'DigiDMS, Inc.',
        'product': 'DigiDMS EHR'
    },
    {
        'vendor': 'Digimind',
        'product': 'Digimind Intelligence'
    },
    {
        'vendor': 'Digirad Corporation',
        'product': 'Digirad'
    },
    {
        'vendor': 'Digirad Corporation',
        'product': 'Digirad Cardius'
    },
    {
        'vendor': 'Digisonics, Inc.',
        'product': 'Digisonics'
    },
    {
        'vendor': 'Digital Guardian, Inc.',
        'product': 'Digital Guardian'
    },
    {
        'vendor': 'Digital Innovation, Inc.',
        'product': 'Digital Innovation NTRACS'
    },
    {
        'vendor': 'DigitalOcean, LLC',
        'product': 'Digital Ocean Hosting'
    },
    {
        'vendor': 'Digital Reasoning Systems, Inc.',
        'product': 'Digital Reasoning'
    },
    {
        'vendor': 'Digital Reef, Inc.',
        'product': 'Digital Reef'
    },
    {
        'vendor': 'Digital River, Inc.',
        'product': 'Digital River'
    },
    {
        'vendor': 'Digital Shadows, Ltd.',
        'product': 'Digital Shadows'
    },
    {
        'vendor': 'Digital Turbine, Inc.',
        'product': 'Digital Turbine'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Digital.ai (Unspecified Product)'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Digital.ai App Management'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Digital.ai Change Risk Prediction'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Digital.ai Deploy'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Digital.ai Release'
    },
    {
        'vendor': 'DigitalChalk',
        'product': 'DigitalChalk'
    },
    {
        'vendor': 'DigitalOcean, LLC',
        'product': 'DigitalOcean'
    },
    {
        'vendor': 'Digitech Systems, LLC',
        'product': 'Digitech PaperVision'
    },
    {
        'vendor': 'Sangoma Technologies Corporation',
        'product': 'Digium'
    },
    {
        'vendor': 'Digium, Inc.',
        'product': 'Digium (Unspecified Product)'
    },
    {
        'vendor': 'Digizuite A/S',
        'product': 'Digizuite'
    },
    {
        'vendor': 'Diligent Corporation',
        'product': 'Diligent'
    },
    {
        'vendor': 'Insite Innovations and Properties B.V.',
        'product': 'DimML'
    },
    {
        'vendor': 'Dimensional Insight, Inc.',
        'product': 'Dimensional Insight'
    },
    {
        'vendor': 'Koyo Electronics Corporation, Ltd.',
        'product': 'DirectLOGIC'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Directworks'
    },
    {
        'vendor': 'Broadridge Financial Solutions, Inc.',
        'product': 'Direxxis'
    },
    {
        'vendor': 'Callibra, Inc.',
        'product': 'Discharge 1-2-3'
    },
    {
        'vendor': 'Open Source',
        'product': 'Disco Project'
    },
    {
        'vendor': 'Civilized Discourse Construction Kit, Inc.',
        'product': 'Discourse'
    },
    {
        'vendor': 'Discoverlink, Inc.',
        'product': 'DiscoverLink Talent'
    },
    {
        'vendor': 'DiscoverOrg, LLC',
        'product': 'DiscoverOrg'
    },
    {
        'vendor': 'Discovery Data',
        'product': 'Discovery Data'
    },
    {
        'vendor': '508 Software, LLC',
        'product': 'Disk Drill'
    },
    {
        'vendor': 'Synology, Inc.',
        'product': 'DiskStation Manager'
    },
    {
        'vendor': 'Diskriter, Inc.',
        'product': 'Diskriter'
    },
    {
        'vendor': 'Disqus, Inc.',
        'product': 'Disqus'
    },
    {
        'vendor': 'Distribion, Inc.',
        'product': 'Distribion'
    },
    {
        'vendor': 'NC Squared, Inc.',
        'product': 'Distribution Engine'
    },
    {
        'vendor': 'DivvyPay, Inc.',
        'product': 'Divvy'
    },
    {
        'vendor': 'DivvyCloud Corporation',
        'product': 'DivvyCloud'
    },
    {
        'vendor': 'Alluresoft, LLC',
        'product': 'DivvyHQ'
    },
    {
        'vendor': 'Dixa ApS',
        'product': 'Dixa'
    },
    {
        'vendor': 'Django Software Foundation',
        'product': 'Django'
    },
    {
        'vendor': 'Open Source',
        'product': 'Dlib'
    },
    {
        'vendor': 'DoJiggy, LLC',
        'product': 'DoJiggy'
    },
    {
        'vendor': 'DocLinks',
        'product': 'DocLinks'
    },
    {
        'vendor': 'Expected Behavior, LLC',
        'product': 'DocRaptor'
    },
    {
        'vendor': 'Bytescribe, Inc.',
        'product': 'DocShuttle'
    },
    {
        'vendor': 'AKDHC Doc-Talk, LLC',
        'product': 'DocTalk'
    },
    {
        'vendor': 'Docebo S.p.A.',
        'product': 'Docebo'
    },
    {
        'vendor': 'SP Controls, Inc.',
        'product': 'Doceri'
    },
    {
        'vendor': 'Docker, Inc.',
        'product': 'Docker'
    },
    {
        'vendor': 'Docker, Inc.',
        'product': 'Docker EE'
    },
    {
        'vendor': 'Docker, Inc.',
        'product': 'Docker Hub'
    },
    {
        'vendor': 'Docker, Inc.',
        'product': 'Docker Swarm'
    },
    {
        'vendor': 'Doctor on Demand, Inc.',
        'product': 'Doctor On Demand'
    },
    {
        'vendor': 'Doctorsoft Corporation',
        'product': 'Doctorsoft'
    },
    {
        'vendor': 'DocuPhase',
        'product': 'DocuPhase'
    },
    {
        'vendor': 'DocuSign, Inc.',
        'product': 'DocuSign'
    },
    {
        'vendor': 'DocuSign, Inc.',
        'product': 'DocuSign CLM'
    },
    {
        'vendor': 'DocuTAP, Inc.',
        'product': 'DocuTAP'
    },
    {
        'vendor': 'DocuWare GmbH',
        'product': 'DocuWare'
    },
    {
        'vendor': 'Archive Power Systems, Inc.',
        'product': 'DocuXplorer'
    },
    {
        'vendor': 'DocStar, Inc.',
        'product': 'Doculex'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Document AI'
    },
    {
        'vendor': 'Docupace Technologies, Inc.',
        'product': 'Docupace'
    },
    {
        'vendor': 'Quark Software, Inc.',
        'product': 'Docurated'
    },
    {
        'vendor': 'Dokku',
        'product': 'Dokku'
    },
    {
        'vendor': 'Dolbey Systems, Inc.',
        'product': 'Dolbey'
    },
    {
        'vendor': 'Dolibarr Foundation',
        'product': 'Dolibarr ERP CRM'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Dollar Universe Workload Automation'
    },
    {
        'vendor': 'DomainTools, LLC',
        'product': 'DomainTools'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'Domino 5'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'Domino 6'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'Domino 7'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'Domino 8'
    },
    {
        'vendor': 'Domino Data Lab, Inc.',
        'product': 'Domino Data Science Platform'
    },
    {
        'vendor': 'Domino Printing Sciences PLC',
        'product': 'Domino Printing Services'
    },
    {
        'vendor': 'Domo, Inc.',
        'product': 'Domo'
    },
    {
        'vendor': 'Domuso, Inc.',
        'product': 'Domuso'
    },
    {
        'vendor': 'Donately Corporation',
        'product': 'Donately'
    },
    {
        'vendor': 'Donesafe Pty Ltd',
        'product': 'Donesafe'
    },
    {
        'vendor': 'Higher Pixels, LLC',
        'product': 'Donor Tools'
    },
    {
        'vendor': 'SofterWare, Inc.',
        'product': 'DonorPerfect'
    },
    {
        'vendor': 'DonorSnap',
        'product': 'DonorSnap'
    },
    {
        'vendor': 'DonorDirect',
        'product': 'DonorStudio'
    },
    {
        'vendor': 'ConnectedView, LLC',
        'product': 'DonorView'
    },
    {
        'vendor': 'Donut Technologies, Inc.',
        'product': 'Donut'
    },
    {
        'vendor': 'Doodle AG',
        'product': 'Doodle'
    },
    {
        'vendor': 'Doppler, LLC',
        'product': 'Doppler'
    },
    {
        'vendor': 'Seagate Technology, LLC',
        'product': 'Dot Hill'
    },
    {
        'vendor': 'DNN Corporation',
        'product': 'DotNetNuke'
    },
    {
        'vendor': 'Conversant, LLC',
        'product': 'Dotomi'
    },
    {
        'vendor': 'DoubleDutch, Inc.',
        'product': 'DoubleDutch'
    },
    {
        'vendor': 'DoubleVerify, Inc.',
        'product': 'DoubleVerify'
    },
    {
        'vendor': 'Doubleknot, LLC',
        'product': 'Doubleknot'
    },
    {
        'vendor': 'Dovetail Software, Inc.',
        'product': 'Dovetail EES'
    },
    {
        'vendor': 'Dovico Software, Inc.',
        'product': 'Dovico'
    },
    {
        'vendor': 'Dow Jones',
        'product': 'Dow Jones Risk & Compliance'
    },
    {
        'vendor': 'Dow Jones',
        'product': 'Dow Jones Watchlist'
    },
    {
        'vendor': 'SERgroup Holding International GmbH',
        'product': 'Doxis4'
    },
    {
        'vendor': 'SERgroup Holding International GmbH',
        'product': 'Doxis4 iECM'
    },
    {
        'vendor': 'EnSoftek, Inc.',
        'product': 'Dr. Cloud EMR'
    },
    {
        'vendor': 'DrFirst.com, Inc.',
        'product': 'DrFirst (Unspecified Product)'
    },
    {
        'vendor': 'Dragerwerk AG & Company KgaA',
        'product': 'Draeger Babylog'
    },
    {
        'vendor': 'Dragerwerk AG & Company KgaA',
        'product': 'Draeger Evita'
    },
    {
        'vendor': 'Dragerwerk AG & Company KgaA',
        'product': 'Draeger Fabius'
    },
    {
        'vendor': 'Dragerwerk AG & Company KgaA',
        'product': 'Draeger Infinity'
    },
    {
        'vendor': 'Dragerwerk AG & Company KgaA',
        'product': 'Draeger Innovian'
    },
    {
        'vendor': 'Dragerwerk AG & Company KgaA',
        'product': 'Draeger Isolette'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Dragon Medical 360'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Dragon NaturallySpeaking'
    },
    {
        'vendor': 'DragonWave-X Canada, Inc.',
        'product': 'DragonWave-X'
    },
    {
        'vendor': 'Dragos, Inc.',
        'product': 'Dragos'
    },
    {
        'vendor': 'Drake Enterprises, Ltd.',
        'product': 'Drake Tax'
    },
    {
        'vendor': 'DrayTek Corporation',
        'product': 'DrayTek (Unspecified Product)'
    },
    {
        'vendor': 'DrayTek Corporation',
        'product': 'DrayTek Access Points'
    },
    {
        'vendor': 'DreamHost, LLC',
        'product': 'DreamHost'
    },
    {
        'vendor': 'DreamHost, LLC',
        'product': 'DreamHost Hosting'
    },
    {
        'vendor': 'Dremio Corporation',
        'product': 'Dremio'
    },
    {
        'vendor': 'Drift.com, Inc.',
        'product': 'Drift'
    },
    {
        'vendor': 'Drip Global, Inc.',
        'product': 'Drip'
    },
    {
        'vendor': 'DriveCentric, Inc.',
        'product': 'DriveCentric'
    },
    {
        'vendor': 'DriveWealth, LLC',
        'product': 'DriveWealth'
    },
    {
        'vendor': 'Drobo, Inc.',
        'product': 'Drobo'
    },
    {
        'vendor': 'Dropbox, Inc.',
        'product': 'Dropbox'
    },
    {
        'vendor': 'Dropbox, Inc.',
        'product': 'Dropbox Paper'
    },
    {
        'vendor': 'Keiser Computers, Inc.',
        'product': 'Drs Enterprise'
    },
    {
        'vendor': 'IQVIA Holdings, Inc.',
        'product': 'DrugDev'
    },
    {
        'vendor': 'Open Source',
        'product': 'Drupal'
    },
    {
        'vendor': 'Open Source',
        'product': 'Drupal Commerce'
    },
    {
        'vendor': 'Druva, Inc.',
        'product': 'Druva'
    },
    {
        'vendor': 'Druva, Inc.',
        'product': 'Druva Cloud Platform'
    },
    {
        'vendor': 'Druva, Inc.',
        'product': 'Druva CloudRanger'
    },
    {
        'vendor': 'Druva, Inc.',
        'product': 'Druva Phoenix'
    },
    {
        'vendor': 'Druva, Inc.',
        'product': 'Druva inSync'
    },
    {
        'vendor': 'Dstillery, Inc.',
        'product': 'Dstillery'
    },
    {
        'vendor': 'DtDNS',
        'product': 'DtDNS'
    },
    {
        'vendor': 'DuPont Sustainable Solutions',
        'product': 'DuPont STOP'
    },
    {
        'vendor': 'Duda, Inc.',
        'product': 'Duda'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Duet Enterprise'
    },
    {
        'vendor': 'Dundas Data Visualization, Inc.',
        'product': 'Dundas BI'
    },
    {
        'vendor': 'Duo Security, Inc.',
        'product': 'Duo Security'
    },
    {
        'vendor': 'Duuzra Event Software, Ltd.',
        'product': 'Duuzra'
    },
    {
        'vendor': 'Duzon Bizon Company, Ltd.',
        'product': 'Duzon'
    },
    {
        'vendor': 'Duzon Bizon Company, Ltd.',
        'product': 'Duzon ERP'
    },
    {
        'vendor': 'Dwolla, Inc.',
        'product': 'Dwolla'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'DynDNS'
    },
    {
        'vendor': 'Dynabook Americas, Inc.',
        'product': 'Dynabook'
    },
    {
        'vendor': 'Dynamic Signal, Inc.',
        'product': 'Dynamic Signal'
    },
    {
        'vendor': 'Dynamic Yield, Ltd.',
        'product': 'Dynamic Yield'
    },
    {
        'vendor': 'Dynamicweb Software A/S',
        'product': 'Dynamicweb'
    },
    {
        'vendor': 'Dynamo Software, Inc.',
        'product': 'Dynamo Software'
    },
    {
        'vendor': 'Dynamsoft Corporation',
        'product': 'Dynamsoft SourceAnywhere'
    },
    {
        'vendor': 'Dynatrace, LLC',
        'product': 'Dynatrace (Unspecified Product)'
    },
    {
        'vendor': 'Dynatrace, LLC',
        'product': 'Dynatrace Application Monitoring'
    },
    {
        'vendor': 'Dynatrace, LLC',
        'product': 'Dynatrace Application Performance Monitoring'
    },
    {
        'vendor': 'Dynatrace, LLC',
        'product': 'Dynatrace Gomez'
    },
    {
        'vendor': 'Dynatrace, LLC',
        'product': 'Dynatrace Real User Monitoring'
    },
    {
        'vendor': 'Dynatrace, LLC',
        'product': 'Dynatrace User Experience Management'
    },
    {
        'vendor': 'Dynisco',
        'product': 'Dynisco Cloud Connect'
    },
    {
        'vendor': 'Dynistics, Ltd.',
        'product': 'Dynistics'
    },
    {
        'vendor': 'Sine Info Ventures Pvt Ltd',
        'product': 'E-junkie'
    },
    {
        'vendor': 'Shoptech',
        'product': 'E2 Shop System'
    },
    {
        'vendor': 'E2open, LLC',
        'product': 'E2open (Unspecified Product)'
    },
    {
        'vendor': 'E2open, LLC',
        'product': 'E2open Demand Planning & Sensing'
    },
    {
        'vendor': 'E2open, LLC',
        'product': 'E2open Partner Performance Incentives'
    },
    {
        'vendor': 'E2open, LLC',
        'product': 'E2open Procurement & Supply Management'
    },
    {
        'vendor': 'Unified Global Archiving',
        'product': 'EAS 9.0'
    },
    {
        'vendor': 'EBANX',
        'product': 'EBANX'
    },
    {
        'vendor': 'Century Business Solutions',
        'product': 'EBizCharge'
    },
    {
        'vendor': 'EC-CUBE Company, Ltd.',
        'product': 'EC-CUBE'
    },
    {
        'vendor': 'ECi Software Solutions, Inc.',
        'product': 'ECi E-automate'
    },
    {
        'vendor': 'ECi Software Solutions, Inc.',
        'product': 'ECi M1'
    },
    {
        'vendor': 'EDCO Health Information Solutions',
        'product': 'EDCO Solarity'
    },
    {
        'vendor': 'Jagged Peak, Inc.',
        'product': 'EDGE'
    },
    {
        'vendor': 'Estimating Edge, LLC',
        'product': 'EDGE Estimator'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'EDGECAM'
    },
    {
        'vendor': 'Lantronix, Inc.',
        'product': 'EDS-MD'
    },
    {
        'vendor': 'Electronics For Imaging, Inc.',
        'product': 'EFI (Unspecified Product)'
    },
    {
        'vendor': 'Electronics For Imaging, Inc.',
        'product': 'EFI Fiery'
    },
    {
        'vendor': 'Electronics For Imaging, Inc.',
        'product': 'EFI MarketDirect StoreFront'
    },
    {
        'vendor': 'EHI Retail Institute GmbH',
        'product': 'EHI'
    },
    {
        'vendor': 'Office Ally, Inc.',
        'product': 'EHR 24/7'
    },
    {
        'vendor': 'Adaptamed, LLC',
        'product': 'EHR Your Way'
    },
    {
        'vendor': 'StarTex Software, LLC',
        'product': 'EHS Insight'
    },
    {
        'vendor': 'EIS Group Software, Ltd.',
        'product': 'EIS (Unspecified Product)'
    },
    {
        'vendor': 'EKM Systems, Ltd.',
        'product': 'EKM'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'ELK Stack'
    },
    {
        'vendor': 'ELO Digital Office GmbH',
        'product': 'ELOoffice'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC Legato EmailXtender'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNX5100'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNX5300'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNX5500'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNX5700'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNX7500'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNXe3150'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'EMC VNXe3300'
    },
    {
        'vendor': 'EMIS Health PLC',
        'product': 'EMIS Web'
    },
    {
        'vendor': 'EMR-Bear, LLC',
        'product': 'EMR-Bear'
    },
    {
        'vendor': 'EMRlogic Systems, Inc.',
        'product': 'EMRlogic'
    },
    {
        'vendor': 'eMaint Enterprises, LLC',
        'product': 'EMaint'
    },
    {
        'vendor': 'Artificial Medical Intelligence, Inc.',
        'product': 'EMscribe'
    },
    {
        'vendor': 'ENGIE Insight Services, Inc.',
        'product': 'ENGIE Insight'
    },
    {
        'vendor': 'EOS imaging S.A.',
        'product': 'EOS imaging'
    },
    {
        'vendor': 'EPAY Systems, Inc.',
        'product': 'EPAY Blueforce'
    },
    {
        'vendor': 'EPLAN Software & Service GmbH & Company KG',
        'product': 'EPLAN'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'EPM Live'
    },
    {
        'vendor': 'Enterprise Print Management Solutions Corporation',
        'product': 'EPMS'
    },
    {
        'vendor': 'EPOWERdoc, Inc.',
        'product': 'EPOWERDoc'
    },
    {
        'vendor': 'Embarcadero Technologies, Inc.',
        'product': 'ER/Studio'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'ERDAS APOLLO'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'ERDAS IMAGINE'
    },
    {
        'vendor': 'Gruppo Formula S.p.A.',
        'product': 'ERP Diapason'
    },
    {
        'vendor': 'ABC71',
        'product': 'ERP Omega'
    },
    {
        'vendor': 'Procenge Ltda.',
        'product': 'ERP PIRAMIDE'
    },
    {
        'vendor': 'Distribution One, Inc.',
        'product': 'ERP-ONE'
    },
    {
        'vendor': 'ERPAG, Inc.',
        'product': 'ERPAG'
    },
    {
        'vendor': 'ERPNext',
        'product': 'ERPNext'
    },
    {
        'vendor': 'ERPScan B.V.',
        'product': 'ERPScan'
    },
    {
        'vendor': 'eResearchTechnology, Inc.',
        'product': 'ERT eCOA'
    },
    {
        'vendor': 'ESET spol. s r. o.',
        'product': 'ESET'
    },
    {
        'vendor': 'ESM Software Group, Inc.',
        'product': 'ESM Software'
    },
    {
        'vendor': 'ESO Solutions, Inc.',
        'product': 'ESO EHR'
    },
    {
        'vendor': 'DP Technology Corporation',
        'product': 'ESPRIT CAM'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ESRI (Unspecified Product)'
    },
    {
        'vendor': 'Operation Technology, Inc.',
        'product': 'ETAP'
    },
    {
        'vendor': 'Theta Systems, Ltd.',
        'product': 'EVA Receptionist'
    },
    {
        'vendor': 'Carbonite, Inc.',
        'product': 'EVault'
    },
    {
        'vendor': 'EXIGIS, LLC',
        'product': 'EXIGIS'
    },
    {
        'vendor': 'SofterWare, Inc.',
        'product': 'EZ-CAMP2'
    },
    {
        'vendor': 'EZBIS, Inc.',
        'product': 'EZBIS Office'
    },
    {
        'vendor': 'EZLynx',
        'product': 'EZLynx'
    },
    {
        'vendor': 'EZOfficeInventory',
        'product': 'EZOfficeInventory'
    },
    {
        'vendor': 'EZ Web Enterprises, Inc.',
        'product': 'EZRentOut'
    },
    {
        'vendor': 'HarmoniSoft, Inc.',
        'product': 'EZinspections'
    },
    {
        'vendor': 'EZnotes, Inc.',
        'product': 'EZnotes'
    },
    {
        'vendor': 'Eagle Investment Systems, LLC',
        'product': 'Eagle Data Management'
    },
    {
        'vendor': 'Eagle Investment Systems, LLC',
        'product': 'Eagle Investment Systems'
    },
    {
        'vendor': 'Eagle Investment Systems, LLC',
        'product': 'Eagle STAR'
    },
    {
        'vendor': 'Patterson Dental Supply, Inc.',
        'product': 'Eaglesoft'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'EarlGrey'
    },
    {
        'vendor': 'Dynamic Graphics, Inc.',
        'product': 'EarthVision'
    },
    {
        'vendor': 'EarthLink, LLC',
        'product': 'Earthlink'
    },
    {
        'vendor': 'Sandhills Development, LLC',
        'product': 'Easy Digital Downloads'
    },
    {
        'vendor': 'Quizworks B.V.',
        'product': 'Easy LMS'
    },
    {
        'vendor': 'EasyAsk Technologies, Inc.',
        'product': 'EasyAsk'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'EasyLobby'
    },
    {
        'vendor': 'EasyMock',
        'product': 'EasyMock'
    },
    {
        'vendor': 'EasyMorph, Inc.',
        'product': 'EasyMorph'
    },
    {
        'vendor': 'EasyVista S.A.',
        'product': 'EasyVista'
    },
    {
        'vendor': 'EASYPROMOS S.L.',
        'product': 'Easypromos'
    },
    {
        'vendor': 'Eaton Corporation',
        'product': 'Eaton'
    },
    {
        'vendor': 'Ebix, Inc.',
        'product': 'Ebix CertsOnline'
    },
    {
        'vendor': 'Ebix, Inc.',
        'product': 'EbixExchange'
    },
    {
        'vendor': 'Echo Global Logistics, Inc.',
        'product': 'Echo'
    },
    {
        'vendor': 'Echo360, Inc.',
        'product': 'Echo360'
    },
    {
        'vendor': 'EchoSpan, Inc.',
        'product': 'EchoSpan'
    },
    {
        'vendor': 'Echo Global Logistics, Inc.',
        'product': 'EchoTrak'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Echopass'
    },
    {
        'vendor': 'Echoworx Corporation',
        'product': 'Echoworx'
    },
    {
        'vendor': 'EclecticIQ B.V.',
        'product': 'EclecticIQ'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse Che'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse IDE'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse IoT'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse Jetty'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse RAP'
    },
    {
        'vendor': 'Schneider Electric SE',
        'product': 'EcoStruxure'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'EcoSys'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'EcoSys PPM'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'EcoSys Project'
    },
    {
        'vendor': 'econda GmbH',
        'product': 'Econda'
    },
    {
        'vendor': 'Versata Enterprises, Inc.',
        'product': 'Ecora'
    },
    {
        'vendor': 'Ecotrak, LLC',
        'product': 'Ecotrak'
    },
    {
        'vendor': 'Ecount, Inc.',
        'product': 'Ecount ERP'
    },
    {
        'vendor': 'Ecreativeworks, Inc.',
        'product': 'Ecreativeworks'
    },
    {
        'vendor': 'Ecritel Corporation',
        'product': 'Ecritel'
    },
    {
        'vendor': 'Ecteon, Inc.',
        'product': 'Ecteon Contraxx'
    },
    {
        'vendor': 'Ecwid, Inc.',
        'product': 'Ecwid'
    },
    {
        'vendor': 'Edaris Health',
        'product': 'Edaris Health'
    },
    {
        'vendor': 'Eden Technologies, Inc.',
        'product': 'Eden Workplace'
    },
    {
        'vendor': 'Verizon Digital Media Services, Inc.',
        'product': 'EdgeCast CDN'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'EdgeFrontier'
    },
    {
        'vendor': 'DataMills, Ltd.',
        'product': 'EdgeSafe'
    },
    {
        'vendor': 'EdgeWave, Inc.',
        'product': 'EdgeWave'
    },
    {
        'vendor': 'Weld North Education, LLC',
        'product': 'Edgenuity'
    },
    {
        'vendor': 'Edgewall Software',
        'product': 'Edgewall Trac'
    },
    {
        'vendor': 'Edifecs, Inc.',
        'product': 'Edifecs'
    },
    {
        'vendor': 'Tiny Technologies, Inc.',
        'product': 'EditLive!'
    },
    {
        'vendor': 'Edmodo, Inc.',
        'product': 'Edmodo'
    },
    {
        'vendor': 'CoreFour, Inc.',
        'product': 'Edsby'
    },
    {
        'vendor': 'EduBrite Systems, Inc.',
        'product': 'EduBrite'
    },
    {
        'vendor': 'Education Galaxy, LLC',
        'product': 'Education Galaxy'
    },
    {
        'vendor': 'Education Management Solutions, LLC',
        'product': 'Education Management Solutions'
    },
    {
        'vendor': 'Edupoint Educational Systems, LLC',
        'product': 'Edupoint Synergy'
    },
    {
        'vendor': 'Edvance360',
        'product': 'Edvance360'
    },
    {
        'vendor': 'EfficientIP SAS',
        'product': 'EfficientIP'
    },
    {
        'vendor': 'Efficy S.A.',
        'product': 'Efficy CRM'
    },
    {
        'vendor': 'Egencia, LLC',
        'product': 'Egencia'
    },
    {
        'vendor': 'Egenera, Inc.',
        'product': 'Egenera'
    },
    {
        'vendor': 'Eggplant, Ltd.',
        'product': 'Eggplant'
    },
    {
        'vendor': 'Egnyte, Inc.',
        'product': 'Egnyte'
    },
    {
        'vendor': 'Egress Software Technologies, Ltd.',
        'product': 'Egress'
    },
    {
        'vendor': 'Eis Technologies, Inc.',
        'product': 'EiS Technologies'
    },
    {
        'vendor': 'Eightfold AI, Inc.',
        'product': 'Eightfold.ai'
    },
    {
        'vendor': 'Ekahau, Inc.',
        'product': 'Ekahau'
    },
    {
        'vendor': 'Ekata, Inc.',
        'product': 'Ekata'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Ekon ERP'
    },
    {
        'vendor': 'Episerver, Inc.',
        'product': 'Ektron'
    },
    {
        'vendor': 'Brainier Solutions, Inc.',
        'product': 'Elan LMS'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Elastic Cloud'
    },
    {
        'vendor': 'Elastic Path Software, Inc.',
        'product': 'Elastic Path'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Elastic Security'
    },
    {
        'vendor': 'Elastic Email, Inc.',
        'product': 'ElasticEmail'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Elasticsearch'
    },
    {
        'vendor': 'Elateral, Inc.',
        'product': 'Elateral'
    },
    {
        'vendor': 'Elavon, Inc.',
        'product': 'Elavon Fusebox'
    },
    {
        'vendor': 'Electric AI, Inc.',
        'product': 'Electric'
    },
    {
        'vendor': 'Electric Cloud, Inc.',
        'product': 'Electric Cloud'
    },
    {
        'vendor': 'Elekta AB',
        'product': 'Elekta MOSAIQ'
    },
    {
        'vendor': 'Elekta AB',
        'product': 'Elekta Oncentra'
    },
    {
        'vendor': 'Elementool, Inc.',
        'product': 'Elementool'
    },
    {
        'vendor': 'Elementor, Ltd.',
        'product': 'Elementor'
    },
    {
        'vendor': 'Elementum SCM, Inc.',
        'product': 'Elementum'
    },
    {
        'vendor': 'Elemica, Inc.',
        'product': 'Elemica'
    },
    {
        'vendor': 'Elemica, Inc.',
        'product': 'Elemica Eyefreight'
    },
    {
        'vendor': 'Telefonica Digital Espana S.L.U.',
        'product': 'ElevenPaths'
    },
    {
        'vendor': 'Elevio Pty Ltd',
        'product': 'Elevio'
    },
    {
        'vendor': 'Elite Software Development, Inc.',
        'product': 'Elite Software HVAC Solution'
    },
    {
        'vendor': 'ICE Mortgage Technology',
        'product': 'Ellie Mae'
    },
    {
        'vendor': 'Ellucian Company LP',
        'product': 'Ellucian'
    },
    {
        'vendor': 'Ellucian Company LP',
        'product': 'Ellucian (Unspecified Product)'
    },
    {
        'vendor': 'Ellucian Company LP',
        'product': 'Ellucian Banner'
    },
    {
        'vendor': 'Ellucian Company LP',
        'product': 'Ellucian CRM Advance'
    },
    {
        'vendor': 'Ellucian Company LP',
        'product': 'Ellucian Colleague'
    },
    {
        'vendor': 'Ellucian Company LP',
        'product': 'Ellucian PowerCampus'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Elluminate'
    },
    {
        'vendor': 'Elo Touch Solutions, Inc.',
        'product': 'Elo Touch'
    },
    {
        'vendor': 'Elucidat, Ltd.',
        'product': 'Elucidat'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Emageon'
    },
    {
        'vendor': 'Palo Alto Software, Inc.',
        'product': 'Email Center Pro'
    },
    {
        'vendor': 'Email on Acid, Inc.',
        'product': 'Email on Acid'
    },
    {
        'vendor': 'Emarsys eMarketing Systems AG',
        'product': 'Emarsys'
    },
    {
        'vendor': 'Embarcadero Technologies, Inc.',
        'product': 'Embarcadero Delphi'
    },
    {
        'vendor': 'Embark Corporation',
        'product': 'Embark'
    },
    {
        'vendor': 'Embotics Corporation',
        'product': 'Embotics Commander'
    },
    {
        'vendor': 'Embue, Inc.',
        'product': 'Embue'
    },
    {
        'vendor': 'Apollo Systems Contracts, Ltd.',
        'product': 'Embunit'
    },
    {
        'vendor': 'Envision Physician Services',
        'product': 'Emergency Medicine Services'
    },
    {
        'vendor': 'Emissary, Inc.',
        'product': 'Emissary'
    },
    {
        'vendor': 'Emma, Inc.',
        'product': 'Emma'
    },
    {
        'vendor': 'EMOLYTICS',
        'product': 'Emolytics'
    },
    {
        'vendor': 'Empirix, Inc.',
        'product': 'Empirix Contact Center Assurance'
    },
    {
        'vendor': 'Employment Hero Pty Ltd',
        'product': 'Employment Hero'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Emulex'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'EnCase'
    },
    {
        'vendor': 'EnGenius Technologies, Inc.',
        'product': 'EnGenius'
    },
    {
        'vendor': 'Enterprise Guardian, Inc.',
        'product': 'EnGuard'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Enablon'
    },
    {
        'vendor': 'Encite, Inc.',
        'product': 'Encite'
    },
    {
        'vendor': 'ICE Mortgage Technology',
        'product': 'Encompass'
    },
    {
        'vendor': 'EncounterPRO Foundation',
        'product': 'EncounterPRO'
    },
    {
        'vendor': 'Endeavor Streaming, LLC',
        'product': 'Endeavor Streaming'
    },
    {
        'vendor': 'Endpoint Clinical, Inc.',
        'product': 'Endpoint Pulse'
    },
    {
        'vendor': 'Endurance International Group, Inc.',
        'product': 'Endurance'
    },
    {
        'vendor': 'Endurance International Group, Inc.',
        'product': 'Endurance International Group (Unspecified Product)'
    },
    {
        'vendor': 'Enecto AB',
        'product': 'Enecto'
    },
    {
        'vendor': 'Enevo, Inc.',
        'product': 'Enevo'
    },
    {
        'vendor': 'Syncsort, Inc.',
        'product': 'Enforcive'
    },
    {
        'vendor': 'Enfusion, LLC',
        'product': 'Enfusion'
    },
    {
        'vendor': 'Engage Hub',
        'product': 'Engage Hub'
    },
    {
        'vendor': 'Engage121, Inc.',
        'product': 'Engage121'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'EngageOne'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'EngageOne Enrichment'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'EngageOne Video'
    },
    {
        'vendor': 'Engaging Networks, Ltd.',
        'product': 'Engaging Networks'
    },
    {
        'vendor': 'Demandbase, Inc.',
        'product': 'Engagio'
    },
    {
        'vendor': 'Engecompany Engenharia de Sistemas',
        'product': 'Engeman'
    },
    {
        'vendor': 'Enghouse Interactive, Inc.',
        'product': 'Enghouse Interactive'
    },
    {
        'vendor': 'Engine Yard, Inc.',
        'product': 'Engine Yard'
    },
    {
        'vendor': 'Engrain, Inc.',
        'product': 'Engrain TouchTour'
    },
    {
        'vendor': 'Enli Health Intelligence',
        'product': 'Enli'
    },
    {
        'vendor': 'Enmark Systems, Inc.',
        'product': 'Enmark Eniteo'
    },
    {
        'vendor': 'Ennov, Inc.',
        'product': 'Ennov'
    },
    {
        'vendor': 'Enom',
        'product': 'Enom'
    },
    {
        'vendor': 'Enonic AS',
        'product': 'Enonic'
    },
    {
        'vendor': 'Enonic AS',
        'product': 'Enonic XP'
    },
    {
        'vendor': 'Enovacom Group',
        'product': 'Enovacom'
    },
    {
        'vendor': 'Enquisite, Inc.',
        'product': 'Enquisite'
    },
    {
        'vendor': 'Enscape GmbH',
        'product': 'Enscape'
    },
    {
        'vendor': 'Ensighten, Inc.',
        'product': 'Ensighten (Unspecified Product)'
    },
    {
        'vendor': 'Ensighten, Inc.',
        'product': 'Ensighten MarSec'
    },
    {
        'vendor': 'EnterMedia, Inc.',
        'product': 'EnterMedia'
    },
    {
        'vendor': 'Winshuttle, LLC',
        'product': 'EnterWorks Enable Multi-Domain MDM'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Enterasys'
    },
    {
        'vendor': 'Technology Group International, Ltd.',
        'product': 'Enterprise 21 ERP'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Enterprise JavaBeans (EJB)'
    },
    {
        'vendor': 'Ground Labs Pte Ltd',
        'product': 'Enterprise Recon'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Enterprise Vault'
    },
    {
        'vendor': 'EnterpriseDB Corporation',
        'product': 'EnterpriseDB'
    },
    {
        'vendor': 'Winshuttle, LLC',
        'product': 'Enterworks'
    },
    {
        'vendor': 'Entrata, Inc.',
        'product': 'Entrata (Unspecified Product)'
    },
    {
        'vendor': 'Entrata, Inc.',
        'product': 'Entrata Accounting'
    },
    {
        'vendor': 'Entrata, Inc.',
        'product': 'Entrata Core'
    },
    {
        'vendor': 'Entrata, Inc.',
        'product': 'Entrata ILS Portal'
    },
    {
        'vendor': 'Entrata, Inc.',
        'product': 'Entrata ResidentPortal'
    },
    {
        'vendor': 'Entrinsik, Inc.',
        'product': 'Entrinsik'
    },
    {
        'vendor': 'Entrinsik, Inc.',
        'product': 'Entrinsik Informer'
    },
    {
        'vendor': 'Entrinsik, Inc.',
        'product': 'Entrinsik Semtek'
    },
    {
        'vendor': 'Entrust Corporation',
        'product': 'Entrust'
    },
    {
        'vendor': 'Entrust Datacard Corporation',
        'product': 'Entrust Datacard'
    },
    {
        'vendor': 'Entuity, Ltd.',
        'product': 'Entuity'
    },
    {
        'vendor': 'Consolidated Communications Holdings, Inc.',
        'product': 'Enventis'
    },
    {
        'vendor': 'Envestnet Asset Management, Inc.',
        'product': 'Envestnet'
    },
    {
        'vendor': 'Enviance, Inc.',
        'product': 'Enviance'
    },
    {
        'vendor': 'Lyft, Inc.',
        'product': 'Envoy'
    },
    {
        'vendor': 'Envoy, Inc.',
        'product': 'Envoy (Unspecified Product)'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Enzyme'
    },
    {
        'vendor': 'Ephesoft, Inc.',
        'product': 'Ephesoft'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic ASAP'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Anesthesia'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Beacon'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Beaker'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Bridges'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Caboodle'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Cadence'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Care Everywhere'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Clarity'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic ClinDoc'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Cupid'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic EHR'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Health Information Management'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Healthy Planet'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Identity'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic MyChart'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic MyChart Bedside'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic NoteReader CDI'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Nurse Triage'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Optime'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Prelude'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Radiant'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Resolute'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Stork'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Systems'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Tapestry'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'Epic Willow'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'EpicCare'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'EpicCare Ambulatory'
    },
    {
        'vendor': 'Epic Systems Corporation',
        'product': 'EpicCare Inpatient'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor (Unspecified Product)'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Avante'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor DataFlo'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor ERP'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Eclipse'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor HCM'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor ITSM'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor ManFact'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Manage 2000'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor PPM'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Prelude ERP'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Prophet 21'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Retail'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor SCM'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor Vista'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'Epicor iScala'
    },
    {
        'vendor': 'Epignosis, LLC',
        'product': 'Epignosis'
    },
    {
        'vendor': 'Epimed Solutions International',
        'product': 'Epimed Monitor'
    },
    {
        'vendor': 'Epiphany Healthcare',
        'product': 'Epiphany Healthcare'
    },
    {
        'vendor': 'Epiq Systems, Inc.',
        'product': 'Epiq Systems'
    },
    {
        'vendor': 'Episerver, Inc.',
        'product': 'Episerver'
    },
    {
        'vendor': 'Episerver, Inc.',
        'product': 'Episerver Commerce Cloud​'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'Episys'
    },
    {
        'vendor': 'Harris Coordinated Care Solutions',
        'product': 'Epitomax EHR'
    },
    {
        'vendor': 'Epos Now, Ltd.',
        'product': 'Epos Now'
    },
    {
        'vendor': 'Epsagon, Inc.',
        'product': 'Epsagon'
    },
    {
        'vendor': 'Epsilon Data Management, LLC',
        'product': 'Epsilon'
    },
    {
        'vendor': 'Seiko Epson Corporation',
        'product': 'Epson'
    },
    {
        'vendor': 'Seiko Epson Corporation',
        'product': 'Epson Workforce'
    },
    {
        'vendor': 'Eptica UK, Ltd.',
        'product': 'Eptica'
    },
    {
        'vendor': 'Equinix, Inc.',
        'product': 'Equinix'
    },
    {
        'vendor': 'Equinix, Inc.',
        'product': 'Equinix International Business Exchange (IBX) data centers'
    },
    {
        'vendor': 'Equisoft, Inc.',
        'product': 'Equisoft'
    },
    {
        'vendor': 'Erecruit, Inc.',
        'product': 'Erecruit (Unspecified Product)'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson BSCS iX'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson Billing'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson IoT Platform'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson MHL 3000'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson Marconi OMS'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson OMS 1200'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson OMS 1400'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson OMS 1600'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson PPX'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson SPO 1400'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson SPO 1410'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson SPO 1460'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson SSR 8000'
    },
    {
        'vendor': 'Erply OU',
        'product': 'Erply'
    },
    {
        'vendor': 'Errorception',
        'product': 'Errorception'
    },
    {
        'vendor': 'Esaote S.p.A.',
        'product': 'Esaote MyLab'
    },
    {
        'vendor': 'Esaote S.p.A.',
        'product': 'Esaote RIS PACS'
    },
    {
        'vendor': 'Esker, Inc.',
        'product': 'Esker'
    },
    {
        'vendor': 'Esko-Graphics B.V.',
        'product': 'Esko WebCenter'
    },
    {
        'vendor': 'Espressive, Inc.',
        'product': 'Espressive Barista'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Espresso'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'Esri Location Analytics'
    },
    {
        'vendor': 'EssentialSkillz',
        'product': 'EssentialSkillz'
    },
    {
        'vendor': 'EtQ, Inc.',
        'product': 'EtQ Reliance'
    },
    {
        'vendor': 'GP Strategies Corporation',
        'product': 'EtaPRO'
    },
    {
        'vendor': 'Ethereum Foundation',
        'product': 'Ethereum'
    },
    {
        'vendor': 'Ethnio, Inc.',
        'product': 'Ethnio'
    },
    {
        'vendor': 'DLC Solutions, LLC',
        'product': 'EthosCE'
    },
    {
        'vendor': 'Etix, Inc.',
        'product': 'Etix'
    },
    {
        'vendor': 'etracker GmbH',
        'product': 'Etracker'
    },
    {
        'vendor': 'Etsy, Inc.',
        'product': 'Etsy'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'Eucalyptus Systems'
    },
    {
        'vendor': 'Eulerian Technologies',
        'product': 'Eulerian'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Eurekify Sage Enterprise Role Manager'
    },
    {
        'vendor': 'Eurotech S.p.A',
        'product': 'Eurotech Everyware'
    },
    {
        'vendor': 'Electric Paper, Ltd.',
        'product': 'EvaSys'
    },
    {
        'vendor': 'Evenium, Inc.',
        'product': 'Evenium'
    },
    {
        'vendor': 'Event Farm, Inc.',
        'product': 'Event Farm'
    },
    {
        'vendor': 'EventMobi',
        'product': 'EventMobi'
    },
    {
        'vendor': 'EventPro Software',
        'product': 'EventPro'
    },
    {
        'vendor': 'Netsurion, LLC',
        'product': 'EventTracker Security Center'
    },
    {
        'vendor': 'Eventbase Technology, Inc.',
        'product': 'Eventbase'
    },
    {
        'vendor': 'Eventbee, Inc.',
        'product': 'Eventbee'
    },
    {
        'vendor': 'Eventbrite, Inc.',
        'product': 'Eventbrite'
    },
    {
        'vendor': 'Centium Software, Ltd.',
        'product': 'EventsAir'
    },
    {
        'vendor': 'Eventzilla Corporation',
        'product': 'Eventzilla'
    },
    {
        'vendor': 'EverString Technology',
        'product': 'EverString'
    },
    {
        'vendor': 'Everbridge, Inc.',
        'product': 'Everbridge'
    },
    {
        'vendor': 'Everflow Technologies, Inc.',
        'product': 'Everflow'
    },
    {
        'vendor': 'Evergage, Inc.',
        'product': 'Evergage'
    },
    {
        'vendor': 'Pure Storage, Inc.',
        'product': 'Evergreen Storage (ES2)'
    },
    {
        'vendor': 'Everlaw, Inc.',
        'product': 'Everlaw'
    },
    {
        'vendor': 'Prefix Technologies Pty Ltd',
        'product': 'Everlytic'
    },
    {
        'vendor': 'Evernote Corporation',
        'product': 'Evernote'
    },
    {
        'vendor': 'Everteam SAS',
        'product': 'Everteam'
    },
    {
        'vendor': 'Every Angle B.V.',
        'product': 'Every Angle'
    },
    {
        'vendor': 'EveryAction',
        'product': 'EveryAction'
    },
    {
        'vendor': 'Evident ID, Inc.',
        'product': 'Evident ID'
    },
    {
        'vendor': 'Evident.io, Inc.',
        'product': 'Evident.io'
    },
    {
        'vendor': 'Evidian S.A.',
        'product': 'Evidian'
    },
    {
        'vendor': 'Evidon, Inc.',
        'product': 'Evidon'
    },
    {
        'vendor': 'Evolve IP, LLC',
        'product': 'Evolve IP'
    },
    {
        'vendor': 'Evolve Media, LLC',
        'product': 'Evolve Media'
    },
    {
        'vendor': 'Konica Minolta, Inc.',
        'product': 'Exa PACS'
    },
    {
        'vendor': 'Konica Minolta, Inc.',
        'product': 'Exa RIS'
    },
    {
        'vendor': 'ExaGrid Systems, Inc.',
        'product': 'ExaGrid'
    },
    {
        'vendor': 'Exabeam, Inc.',
        'product': 'Exabeam'
    },
    {
        'vendor': 'Exact Holding B.V.',
        'product': 'Exact'
    },
    {
        'vendor': 'Exact Holding B.V.',
        'product': 'Exact Dimoni'
    },
    {
        'vendor': 'Exact Holding B.V.',
        'product': 'Exact Macola'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'ExactTarget CoTweet'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Exactor'
    },
    {
        'vendor': 'Exago, Inc.',
        'product': 'Exago'
    },
    {
        'vendor': 'Examity, Inc.',
        'product': 'Examity'
    },
    {
        'vendor': 'Exasol AG',
        'product': 'Exasol'
    },
    {
        'vendor': 'Insightsoftware, Inc.',
        'product': 'Excel4Apps'
    },
    {
        'vendor': 'Excelergy',
        'product': 'Excelergy'
    },
    {
        'vendor': 'Executone Systems Company',
        'product': 'Executone Systems'
    },
    {
        'vendor': 'cBizSoft, Inc.',
        'product': 'Exelare'
    },
    {
        'vendor': 'Exide Technologies',
        'product': 'Exide'
    },
    {
        'vendor': 'EIS Group Properties, Ltd.',
        'product': 'Exigen Insurance Solutions'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'Exinda Network Orchestrator'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'Exinda SD-WAN'
    },
    {
        'vendor': 'Elsevier, Inc.',
        'product': 'ExitCare'
    },
    {
        'vendor': 'Exostar, LLC',
        'product': 'Exostar'
    },
    {
        'vendor': 'Expandable Software, Inc.',
        'product': 'Expandable ERP'
    },
    {
        'vendor': 'Expedia Group, Inc.',
        'product': 'Expedia'
    },
    {
        'vendor': 'Expel, Inc.',
        'product': 'Expel'
    },
    {
        'vendor': 'GlobalPoint Technologies, Inc.',
        'product': 'ExpensePoint'
    },
    {
        'vendor': 'Expensify, Inc.',
        'product': 'Expensify'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Expere'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'Experian CheetahMail'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'Experian FraudNet'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'Experian Pandora'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'Experian Tallyman'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'Experian eCare NEXT'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'Experitest'
    },
    {
        'vendor': 'Experity, Inc.',
        'product': 'Experity'
    },
    {
        'vendor': 'Experlogix, LLC',
        'product': 'Experlogix'
    },
    {
        'vendor': 'Mansystems B.V.',
        'product': 'ExpertDesk'
    },
    {
        'vendor': 'ExpertusONE',
        'product': 'Expertus'
    },
    {
        'vendor': 'Explain Everything, Inc.',
        'product': 'Explain Everything'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Explorys'
    },
    {
        'vendor': 'Exponea s.r.o.',
        'product': 'Exponea'
    },
    {
        'vendor': 'Exponent Technologies, Inc.',
        'product': 'ExponentHR'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'Express'
    },
    {
        'vendor': 'NCH Software, Inc.',
        'product': 'Express Scribe'
    },
    {
        'vendor': 'EllisLab, Inc.',
        'product': 'ExpressionEngine'
    },
    {
        'vendor': 'Exscribe, Inc.',
        'product': 'Exscribe'
    },
    {
        'vendor': 'Imagine That, Inc.',
        'product': 'ExtendSim'
    },
    {
        'vendor': 'Extensis',
        'product': 'Extensis'
    },
    {
        'vendor': 'Exterro, Inc.',
        'product': 'Exterro'
    },
    {
        'vendor': 'Exterro, Inc.',
        'product': 'Exterro E-Discovery'
    },
    {
        'vendor': 'Exterro, Inc.',
        'product': 'Exterro Legal Hold'
    },
    {
        'vendor': 'Extole, Inc.',
        'product': 'Extole'
    },
    {
        'vendor': 'ExtraHop Networks, Inc.',
        'product': 'ExtraHop Reveal(x)'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme ERS 5000'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme Networks (Unspecified Product)'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme Networks Management Center'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme VDX Series'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme X440'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme X450'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'Extreme X460'
    },
    {
        'vendor': 'Extreme Networks, Inc.',
        'product': 'ExtremeSwitching'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'EyeDoc EHR'
    },
    {
        'vendor': 'EyeMD EMR Healthcare Systems, Inc.',
        'product': 'EyeMD EMR'
    },
    {
        'vendor': 'Eyefinity, Inc.',
        'product': 'Eyefinity'
    },
    {
        'vendor': 'Eyeota Pte Ltd',
        'product': 'Eyeota'
    },
    {
        'vendor': 'Ez-Runner Systems, Ltd.',
        'product': 'Ez-Runner'
    },
    {
        'vendor': 'VATECH',
        'product': 'EzDent-i'
    },
    {
        'vendor': 'Eze Castle Integration, Inc.',
        'product': 'Eze Castle'
    },
    {
        'vendor': 'Eze Castle Integration, Inc.',
        'product': 'Eze Castle Integration (Unspecified Product)'
    },
    {
        'vendor': 'Eze Castle Software, LLC',
        'product': 'Eze Investment Suite'
    },
    {
        'vendor': 'F-Secure Corporation',
        'product': 'F-Secure'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 APM'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 ARX'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 ASM'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 Advanced WAF'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 BIG-IP'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 DNS'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 LTM'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 Networks'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 Silverline'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 VIPRION'
    },
    {
        'vendor': 'Omikron Data Quality GmbH',
        'product': 'FACT-Finder'
    },
    {
        'vendor': 'F24 AG',
        'product': 'FACT24'
    },
    {
        'vendor': 'First Databank, Inc.',
        'product': 'FDB MedKnowledge'
    },
    {
        'vendor': 'FDM4 America, Inc.',
        'product': 'FDM4 ERP'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO Blaze Advisor'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO Debt Manager'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO Model Builder'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO Origination Manager'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO Score'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO Siron'
    },
    {
        'vendor': 'Fair Isaac Corporation',
        'product': 'FICO TRIAD'
    },
    {
        'vendor': 'Financial Industry Computer Systems, Inc.',
        'product': 'FICS Loan Producer'
    },
    {
        'vendor': 'Financial Industry Computer Systems, Inc.',
        'product': 'FICS Mortgage Servicer'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS APT'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Adaptiv'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS AddVantage'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Aligne'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS BancWare'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Data Integrity Manager'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Data Restore'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Front Arena'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global BancLine'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global Bankway'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global Metavante'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global Plus'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global Systematics'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Global UniFi PRO'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Integrity'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS InvesTier'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS InvestOne'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Investran'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Lending'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Quantum'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Relius'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS SunGard'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS Trax'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS ZaiNet'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS iWorks'
    },
    {
        'vendor': 'SCB Consulting',
        'product': 'FLEETMATE'
    },
    {
        'vendor': 'FLIR Systems, Inc.',
        'product': 'FLIR (Unspecified Product)'
    },
    {
        'vendor': 'FNT GmbH',
        'product': 'FNT Command'
    },
    {
        'vendor': 'FOSSA, Inc.',
        'product': 'FOSSA'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'FOX515'
    },
    {
        'vendor': 'FPX, LLC',
        'product': 'FPX CPQ'
    },
    {
        'vendor': 'FSI (FM Solutions), Ltd.',
        'product': 'FSI'
    },
    {
        'vendor': 'FTI Technology, LLC',
        'product': 'FTI Technology'
    },
    {
        'vendor': 'FasTrak SoftWorks, Inc.',
        'product': 'FTMaintenance'
    },
    {
        'vendor': 'FUND E-Z Development Corporation',
        'product': 'FUND E-Z'
    },
    {
        'vendor': 'NatWest Markets PLC',
        'product': 'FXmicropay'
    },
    {
        'vendor': 'Fabasoft International Services GmbH',
        'product': 'Fabasoft'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook (Unspecified Product)'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Audience Network'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Domain Insights'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook FacePile'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Graph API'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Login'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Pixel'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook SDK'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Signal'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Tag API'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Web Custom Audiences'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook Widget'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook-CDN'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook-Domain-Insights'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook-Like'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook-SDK'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook-Tag-API'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Facebook-for-Websites'
    },
    {
        'vendor': 'CyberMetrics Corporation',
        'product': 'FaciliWorks'
    },
    {
        'vendor': 'Facilis Technology, Inc.',
        'product': 'Facilis'
    },
    {
        'vendor': 'Facilities Management eXpress, LLC',
        'product': 'Facilities Management eXpress'
    },
    {
        'vendor': 'Wizard Software Solutions, Inc.',
        'product': 'Facility Wizard'
    },
    {
        'vendor': 'CBRE Group, Inc.',
        'product': 'FacilitySource'
    },
    {
        'vendor': 'FactSet Research Systems, Inc.',
        'product': 'FactSet'
    },
    {
        'vendor': 'Dow Jones',
        'product': 'Factiva'
    },
    {
        'vendor': 'Siemens Industry Software, Inc.',
        'product': 'FactoryCAD'
    },
    {
        'vendor': 'Rockwell Automation, Inc.',
        'product': 'FactoryTalk'
    },
    {
        'vendor': 'Rockwell Automation, Inc.',
        'product': 'FactoryTalk PharmaSuite'
    },
    {
        'vendor': 'Factual, Inc.',
        'product': 'Factual'
    },
    {
        'vendor': 'FairCom Corporation',
        'product': 'FairCom'
    },
    {
        'vendor': 'FairWarning, Inc.',
        'product': 'FairWarning'
    },
    {
        'vendor': 'Fairmarkit, Inc.',
        'product': 'Fairmarkit'
    },
    {
        'vendor': 'Sysdig, Inc.',
        'product': 'Falco'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'Falcon Insight'
    },
    {
        'vendor': 'DaVita, Inc.',
        'product': 'Falcon Silver'
    },
    {
        'vendor': 'Falcon.io ApS',
        'product': 'Falcon.io'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor CDP'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor DiskSafe'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor FDS'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor HyperTrac'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor NSS'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor RecoverTrac'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor Software'
    },
    {
        'vendor': 'FalconStor Software, Inc.',
        'product': 'FalconStor VTL'
    },
    {
        'vendor': 'Falkonry, Inc.',
        'product': 'Falkonry'
    },
    {
        'vendor': 'FamilyID, Inc.',
        'product': 'FamilyID'
    },
    {
        'vendor': 'FanBridge, Inc.',
        'product': 'FanBridge'
    },
    {
        'vendor': 'Fanplayr, Inc.',
        'product': 'Fanplayr'
    },
    {
        'vendor': 'FareHarbor B.V.',
        'product': 'FareHarbor'
    },
    {
        'vendor': 'Dominion Global S.A.',
        'product': 'FarmaTools'
    },
    {
        'vendor': 'Faronics Corporation',
        'product': 'Faronics Deep Freeze'
    },
    {
        'vendor': 'FastBooking',
        'product': 'FastBooking'
    },
    {
        'vendor': 'FastEMC',
        'product': 'FastEMC'
    },
    {
        'vendor': 'SMGlobal',
        'product': 'FastMaint CMMS'
    },
    {
        'vendor': 'FastEST, Inc.',
        'product': 'FastPIPE'
    },
    {
        'vendor': 'FastSpring, Ltd.',
        'product': 'FastSpring'
    },
    {
        'vendor': 'Fasthosts Internet, Ltd.',
        'product': 'Fasthosts'
    },
    {
        'vendor': 'Fasthosts Internet, Ltd.',
        'product': 'Fasthosts Hosting'
    },
    {
        'vendor': 'Fastly, Inc.',
        'product': 'Fastly CDN'
    },
    {
        'vendor': 'Fastpath, Inc.',
        'product': 'Fastpath Assure'
    },
    {
        'vendor': 'FatPipe Networks, Inc.',
        'product': 'FatPipe Networks'
    },
    {
        'vendor': 'FatPipe Networks, Inc.',
        'product': 'FatPipe WARP'
    },
    {
        'vendor': 'FatTail, Inc.',
        'product': 'FatTail'
    },
    {
        'vendor': 'Fathom Digital Marketing',
        'product': 'Fathom'
    },
    {
        'vendor': 'Favro AB',
        'product': 'Favro'
    },
    {
        'vendor': 'FedEx Corporation',
        'product': 'FedEx Supply Chain'
    },
    {
        'vendor': 'Nexstar Digital, LLC',
        'product': 'Federated Media'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Fedora'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'FeedBurner'
    },
    {
        'vendor': 'FeedPress',
        'product': 'FeedPress'
    },
    {
        'vendor': 'Feedbackify, Ltd.',
        'product': 'Feedbackify'
    },
    {
        'vendor': 'Feedzai, Inc.',
        'product': 'Feedzai'
    },
    {
        'vendor': 'Feefo Holdings, Ltd.',
        'product': 'Feefo'
    },
    {
        'vendor': 'Feith Systems & Software, Inc.',
        'product': 'Feith Systems'
    },
    {
        'vendor': 'Fenergo, Ltd.',
        'product': 'Fenergo'
    },
    {
        'vendor': 'Fetch Robotics, Inc.',
        'product': 'Fetch Robotics'
    },
    {
        'vendor': 'Zamo Technologies, LLC',
        'product': 'Fexa'
    },
    {
        'vendor': 'Fexco Financial Services',
        'product': 'Fexco Currency Conversion Solutions'
    },
    {
        'vendor': 'BearingPoint B.V.',
        'product': 'FiTAX'
    },
    {
        'vendor': 'FiberHome Telecommunication Technologies Company, Ltd.',
        'product': 'FiberHome'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Fiberlink'
    },
    {
        'vendor': 'Fidelis Cybersecurity, Inc.',
        'product': 'Fidelis Cybersecurity'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'Fidelity TouchPoint'
    },
    {
        'vendor': 'Fidessa Group PLC',
        'product': 'Fidessa'
    },
    {
        'vendor': 'Field Nation, LLC',
        'product': 'Field Nation'
    },
    {
        'vendor': 'FieldAware US, Inc.',
        'product': 'FieldAware'
    },
    {
        'vendor': 'FieldConnect, Inc.',
        'product': 'FieldConnect'
    },
    {
        'vendor': 'FieldEdge, LLC',
        'product': 'FieldEdge'
    },
    {
        'vendor': 'FieldPoint Service Applications, Inc.',
        'product': 'FieldPoint'
    },
    {
        'vendor': 'Fieldbook, Inc.',
        'product': 'Fieldbook CRM'
    },
    {
        'vendor': 'Fieldlens, LLC',
        'product': 'Fieldlens'
    },
    {
        'vendor': 'FieldWireLabs, Inc.',
        'product': 'Fieldwire'
    },
    {
        'vendor': 'Figma, Inc.',
        'product': 'Figma'
    },
    {
        'vendor': 'Maintenance Assistant, Inc.',
        'product': 'Fiix CMMS'
    },
    {
        'vendor': 'FiksuDSP',
        'product': 'Fiksu'
    },
    {
        'vendor': 'TeleFile',
        'product': 'FileCD'
    },
    {
        'vendor': 'Claris International, Inc.',
        'product': 'FileMaker'
    },
    {
        'vendor': 'Claris International, Inc.',
        'product': 'FileMaker Bento'
    },
    {
        'vendor': 'Claris International, Inc.',
        'product': 'FileMaker Go'
    },
    {
        'vendor': 'Claris International, Inc.',
        'product': 'FileMaker Pro Advanced'
    },
    {
        'vendor': 'FileTrail, Inc.',
        'product': 'FileTrail'
    },
    {
        'vendor': 'FileWave (USA), Inc.',
        'product': 'FileWave'
    },
    {
        'vendor': 'Open Source',
        'product': 'FileZilla'
    },
    {
        'vendor': 'Filevine, Inc.',
        'product': 'Filevine'
    },
    {
        'vendor': 'VSoft Corporation',
        'product': 'Finalbuilder'
    },
    {
        'vendor': 'Finale, Inc.',
        'product': 'Finale Inventory'
    },
    {
        'vendor': 'FinancialForce.com, Inc.',
        'product': 'FinancialForce'
    },
    {
        'vendor': 'FinancialForce.com, Inc.',
        'product': 'FinancialForce Accounting'
    },
    {
        'vendor': 'FinancialForce.com, Inc.',
        'product': 'FinancialForce PSA'
    },
    {
        'vendor': 'Finantix Holding SARL',
        'product': 'Finantix'
    },
    {
        'vendor': 'Finastra',
        'product': 'Finastra (Unspecified Product)'
    },
    {
        'vendor': 'Finastra',
        'product': 'Finastra Transaction Banking'
    },
    {
        'vendor': 'FINDOLOGIC GmbH',
        'product': 'FindoLogic'
    },
    {
        'vendor': 'Fingercheck, LLC',
        'product': 'Fingercheck'
    },
    {
        'vendor': 'Finicity Corporation',
        'product': 'Finicity'
    },
    {
        'vendor': 'Fintech OS S.R.L.',
        'product': 'FintechOS'
    },
    {
        'vendor': 'Fiorano Software, Inc.',
        'product': 'Fiorano'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye AX'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye CM'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye EDR'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye EX'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye Endpoint Security'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye HX'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye Helix'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye NX'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye PX'
    },
    {
        'vendor': 'FireMon, LLC',
        'product': 'FireMon'
    },
    {
        'vendor': 'FireMon, LLC',
        'product': 'FireMon Security Manager'
    },
    {
        'vendor': 'FireScope, Inc.',
        'product': 'FireScope'
    },
    {
        'vendor': 'Firebird Foundation, Inc.',
        'product': 'Firebird'
    },
    {
        'vendor': 'Firefly Learning, Ltd.',
        'product': 'Firefly LMS'
    },
    {
        'vendor': 'Armor Defense, Inc.',
        'product': 'Firehost'
    },
    {
        'vendor': 'Armor Defense, Inc.',
        'product': 'Firehost Hosting'
    },
    {
        'vendor': 'Firespring, Inc.',
        'product': 'Firespring'
    },
    {
        'vendor': 'Firmex, Inc.',
        'product': 'Firmex'
    },
    {
        'vendor': 'First Advantage Corporation',
        'product': 'First Advantage'
    },
    {
        'vendor': 'First Data Corporation',
        'product': 'First Data FD130'
    },
    {
        'vendor': 'FrontStream Holdings, LLC',
        'product': 'FirstGiving'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'FirstRain'
    },
    {
        'vendor': 'e-Spirit AG',
        'product': 'FirstSpirit'
    },
    {
        'vendor': 'APEX Analytix, LLC',
        'product': 'FirstStrike'
    },
    {
        'vendor': 'FiscalNote, Inc.',
        'product': 'FiscalNote'
    },
    {
        'vendor': 'Fischer International Identity, LLC',
        'product': 'Fischer Identity'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv AML'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Cleartouch'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv DNA'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv DataSafe'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv FinKit'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Open Solutions'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Precision Bank Platform'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Premier'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Prologue'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Sentry Cybersecurity'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Signature'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Spectrum'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv Weiland Account Analysis'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Fiserv XP2'
    },
    {
        'vendor': 'Fishbowl, Inc.',
        'product': 'Fishbowl Inventory'
    },
    {
        'vendor': 'FISION Corporation',
        'product': 'Fision'
    },
    {
        'vendor': 'Fit Analytics GmbH',
        'product': 'Fit Analytics'
    },
    {
        'vendor': 'Fitzii, Inc.',
        'product': 'Fitzii'
    },
    {
        'vendor': 'Five Star Call Centers',
        'product': 'Five Star Call Centers'
    },
    {
        'vendor': 'Five9, Inc.',
        'product': 'Five9'
    },
    {
        'vendor': 'FiveStars Loyalty, Inc.',
        'product': 'FiveStars'
    },
    {
        'vendor': 'Fivetran, Inc.',
        'product': 'Fivetran'
    },
    {
        'vendor': 'BlackBerry, Ltd.',
        'product': 'Fixmo'
    },
    {
        'vendor': 'Pure Storage, Inc.',
        'product': 'FlashStack'
    },
    {
        'vendor': 'Flashpoint',
        'product': 'Flashpoint'
    },
    {
        'vendor': 'simplicity marketing, Ltd.',
        'product': 'Flashtalking'
    },
    {
        'vendor': 'Open Source',
        'product': 'Flask'
    },
    {
        'vendor': 'Flattr',
        'product': 'Flattr'
    },
    {
        'vendor': 'Innovative Maintenance Systems',
        'product': 'Fleet Maintenance Pro'
    },
    {
        'vendor': 'Flexagon, LLC',
        'product': 'FlexDeploy'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'FlexNet Code Insight'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'FlexNet Connect'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'FlexNet Licensing'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'FlexNet Manager'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'FlexNet Operations'
    },
    {
        'vendor': 'FlexSim Software Products, Inc.',
        'product': 'FlexSim'
    },
    {
        'vendor': 'WooCommerce',
        'product': 'FlexSlider'
    },
    {
        'vendor': 'Flexential Corporation',
        'product': 'Flexential'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera (Unspecified Product)'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera AdminStudio'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera Cloud Management Platform'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera Data Platform'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera Optima'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera Software Vulnerability Management'
    },
    {
        'vendor': 'Flexmail N.V.',
        'product': 'Flexmail'
    },
    {
        'vendor': 'Flexport International, LLC',
        'product': 'Flexport'
    },
    {
        'vendor': 'Flickr, Inc.',
        'product': 'Flickr'
    },
    {
        'vendor': 'Flipcause, Inc.',
        'product': 'Flipcause'
    },
    {
        'vendor': 'Flipp Corporation',
        'product': 'Flipp'
    },
    {
        'vendor': 'Snap, Inc.',
        'product': 'Flite'
    },
    {
        'vendor': 'Mentor Graphics Corporation',
        'product': 'FloEFD'
    },
    {
        'vendor': 'FloQast, Inc.',
        'product': 'FloQast'
    },
    {
        'vendor': 'Mentor Graphics Corporation',
        'product': 'FloTHERM'
    },
    {
        'vendor': 'Flock FZ, LLC',
        'product': 'Flock'
    },
    {
        'vendor': 'Breezetree Software, LLC',
        'product': 'FlowBreeze'
    },
    {
        'vendor': 'Distribution Management Company, Inc.',
        'product': 'FlowTrac'
    },
    {
        'vendor': 'Flowable AG',
        'product': 'Flowable (Unspecified Product)'
    },
    {
        'vendor': 'Flowable AG',
        'product': 'Flowable Work'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Flowdock'
    },
    {
        'vendor': 'Flowplayer AB',
        'product': 'Flowplayer'
    },
    {
        'vendor': '3M Company',
        'product': 'Fluency Direct'
    },
    {
        'vendor': 'FluentStream Technologies',
        'product': 'FluentStream'
    },
    {
        'vendor': 'Open Source',
        'product': 'Fluentd'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Fluidmesh'
    },
    {
        'vendor': 'Fluke Corporation',
        'product': 'Fluke Networks'
    },
    {
        'vendor': 'Verizon Media',
        'product': 'Flurry'
    },
    {
        'vendor': 'Flux Corporation',
        'product': 'Flux'
    },
    {
        'vendor': 'Flybits, Inc.',
        'product': 'Flybits'
    },
    {
        'vendor': 'Focus School Software, LLC',
        'product': 'Focus SIS'
    },
    {
        'vendor': 'DevFactory FZ-LLC',
        'product': 'FogBugz'
    },
    {
        'vendor': 'Followup CRM',
        'product': 'Followup CRM'
    },
    {
        'vendor': 'Fond Technologies, Inc.',
        'product': 'Fond'
    },
    {
        'vendor': 'Fonecta Oy',
        'product': 'Fonecta'
    },
    {
        'vendor': 'FontDeck',
        'product': 'FontDeck'
    },
    {
        'vendor': 'Fonts.com',
        'product': 'Fonts.com'
    },
    {
        'vendor': 'Opentracker',
        'product': 'Footprint'
    },
    {
        'vendor': 'Forage Pty Ltd',
        'product': 'Forage'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint CASB'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint DLP'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint NGFW'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint Web Security'
    },
    {
        'vendor': 'ForeScout Technologies, Inc.',
        'product': 'ForeScout'
    },
    {
        'vendor': 'ForeSee Results, Inc.',
        'product': 'ForeSee CX Suite'
    },
    {
        'vendor': 'AccessData Group, Inc.',
        'product': 'Forensic Toolkit (FTK)'
    },
    {
        'vendor': 'ForgeRock, Inc.',
        'product': 'ForgeRock Identity Platform'
    },
    {
        'vendor': 'ForgeRock, Inc.',
        'product': 'ForgeRock OpenDJ'
    },
    {
        'vendor': 'Worldapp, Inc.',
        'product': 'Form.com'
    },
    {
        'vendor': 'FormAssembly, Inc.',
        'product': 'FormAssembly'
    },
    {
        'vendor': 'FormDocs, LLC',
        'product': 'FormDocs'
    },
    {
        'vendor': 'Formsite',
        'product': 'Formsite'
    },
    {
        'vendor': 'Formspree, Inc.',
        'product': 'Formspree'
    },
    {
        'vendor': 'Formstack, LLC',
        'product': 'Formstack'
    },
    {
        'vendor': 'Forrester Research, Inc.',
        'product': 'Forrester'
    },
    {
        'vendor': 'Forter, Inc.',
        'product': 'Forter'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'FortiEDR'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'FortiGate Cloud'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'FortiGate NGFW'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'FortiNAC'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'FortiSIEM'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Fortify WebInspect'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiADC'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiAP'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiAnalyzer'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiAuthenticator'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiCache'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiClient'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiCloud'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiDB'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiDDoS'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 100'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 1000D'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 200'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 300'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 3000D'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 3600'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 400E'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 5000'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 500E'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 600E'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 7000E'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 800D'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 90'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate 900D'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate Secure Web Gateway'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiGate-VM'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiMail'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiManager'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiPortal'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiSandbox'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiSwitch'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiWAN'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Fortinet FortiWeb'
    },
    {
        'vendor': 'General Technology',
        'product': 'Fortran'
    },
    {
        'vendor': 'FortressIQ, Inc.',
        'product': 'FortressIQ'
    },
    {
        'vendor': 'Forward Advantage, Inc.',
        'product': 'Forward Advantage'
    },
    {
        'vendor': 'Forward Networks, Inc.',
        'product': 'Forward Enterprise'
    },
    {
        'vendor': 'ForwardPMX',
        'product': 'ForwardPMX'
    },
    {
        'vendor': 'Fospha, Ltd.',
        'product': 'Fospha'
    },
    {
        'vendor': 'FotoWare AS',
        'product': 'FotoWare'
    },
    {
        'vendor': 'Softrend Systems, Inc.',
        'product': 'Foundation 3000'
    },
    {
        'vendor': 'Foundation Medicine, Inc.',
        'product': 'Foundation Medicine'
    },
    {
        'vendor': 'Foundation Software, Inc.',
        'product': 'Foundation Software'
    },
    {
        'vendor': 'FourKites, Inc.',
        'product': 'FourKites'
    },
    {
        'vendor': 'Foursixty, Inc.',
        'product': 'Foursixty'
    },
    {
        'vendor': 'Foursquare Labs, Inc.',
        'product': 'Foursquare'
    },
    {
        'vendor': 'Fourth Enterprises, LLC',
        'product': 'Fourth'
    },
    {
        'vendor': 'Triyam Healthcare IT',
        'product': 'Fovea'
    },
    {
        'vendor': 'Foxit Software, Inc.',
        'product': 'Foxit Software'
    },
    {
        'vendor': 'FoxyCartcom, LLC',
        'product': 'FoxyCart'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'Fractals'
    },
    {
        'vendor': 'Frame.io, Inc.',
        'product': 'Frame.io'
    },
    {
        'vendor': 'Framer B.V.',
        'product': 'Framer X'
    },
    {
        'vendor': 'iDangero.us',
        'product': 'Framework7'
    },
    {
        'vendor': 'SoftWriters, Inc.',
        'product': 'FrameworkLTC'
    },
    {
        'vendor': 'LavaBlast Software, Inc.',
        'product': 'FranchiseBlast'
    },
    {
        'vendor': 'Renaissance Learning, Inc.',
        'product': 'Freckle'
    },
    {
        'vendor': 'Fred IT Group Pty Ltd',
        'product': 'Fred Dispense'
    },
    {
        'vendor': 'Photon Engineering, LLC',
        'product': 'Fred Optical Engineering Software'
    },
    {
        'vendor': 'FreeAgent Central, Ltd.',
        'product': 'FreeAgent'
    },
    {
        'vendor': 'The Freebsd Foundation',
        'product': 'FreeBSD'
    },
    {
        'vendor': 'FreeWave Technologies, Inc.',
        'product': 'FreeWave Technologies'
    },
    {
        'vendor': 'FreeWheel Media, Inc.',
        'product': 'FreeWheel'
    },
    {
        'vendor': 'TDC Group, Inc.',
        'product': 'Freeance'
    },
    {
        'vendor': 'Freedcamp, Inc.',
        'product': 'Freedcamp'
    },
    {
        'vendor': 'Freeland Systems, LLC',
        'product': 'Freeland Systems'
    },
    {
        'vendor': 'Freespee AB',
        'product': 'Freespee'
    },
    {
        'vendor': 'Freestyle Solutions, Inc.',
        'product': 'Freestyle Multichannel Order Management'
    },
    {
        'vendor': 'Freightos, Ltd.',
        'product': 'Freightos'
    },
    {
        'vendor': 'Freightquote.com, Inc.',
        'product': 'Freightquote'
    },
    {
        'vendor': 'FreshBooks',
        'product': 'FreshBooks'
    },
    {
        'vendor': 'Fresha.com SV, Ltd.',
        'product': 'Fresha'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshcaller'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshchat'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshdesk'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshping'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshservice'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshsuccess'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshteam'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshworks CRM'
    },
    {
        'vendor': 'Friedman Corporation',
        'product': 'Friedman'
    },
    {
        'vendor': 'Friendbuy, Inc.',
        'product': 'Friendbuy'
    },
    {
        'vendor': 'Pike13, Inc.',
        'product': 'Front Desk'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Front Porch Digital'
    },
    {
        'vendor': 'FrontApp, Inc.',
        'product': 'FrontApp'
    },
    {
        'vendor': 'FrontBase, Inc.',
        'product': 'FrontBase'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'FrontRange Voice'
    },
    {
        'vendor': 'FrontStream Holdings, LLC',
        'product': 'FrontStream GiftWorks'
    },
    {
        'vendor': 'Frontdesk Anywhere, Inc.',
        'product': 'Frontdesk Anywhere'
    },
    {
        'vendor': 'Frontier Software PLC',
        'product': 'Frontier Software'
    },
    {
        'vendor': 'Frontify AG',
        'product': 'Frontify'
    },
    {
        'vendor': 'Digital Defense, Inc.',
        'product': 'Frontline VM'
    },
    {
        'vendor': 'Frosmo, Ltd.',
        'product': 'Frosmo'
    },
    {
        'vendor': 'Fugue, Inc.',
        'product': 'Fugue'
    },
    {
        'vendor': 'FUJIFILM Corporation',
        'product': 'Fujifilm Prosolv'
    },
    {
        'vendor': 'FUJIFILM Corporation',
        'product': 'Fujifilm Synapse'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu (Unspecified Product)'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu BS2000'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu BS2000/OSD'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu ETERNUS'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu FlexFrame'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu GlobalSTORE'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu Lifebook'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu PRIMEFLEX'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu PRIMEQUEST'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu PRIMERGY'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu RunMyProcess'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu SPARC Servers'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu ScanSnap'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu Server PRIMEQUEST'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu ServerView'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu Servers'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu Tablet'
    },
    {
        'vendor': 'Fukuda Denshi Co, Ltd.',
        'product': 'Fukuda Denshi'
    },
    {
        'vendor': 'FullContact, Inc.',
        'product': 'FullContact'
    },
    {
        'vendor': 'FullStory, Inc.',
        'product': 'FullStory'
    },
    {
        'vendor': 'Sitni Sati d.o.o.',
        'product': 'FumeFX'
    },
    {
        'vendor': 'Function Point Productivity Software, Inc.',
        'product': 'Function Point'
    },
    {
        'vendor': 'FunctionFox Systems, Inc.',
        'product': 'FunctionFox'
    },
    {
        'vendor': 'FundCount, LLC',
        'product': 'FundCount'
    },
    {
        'vendor': 'Fundbox, Inc.',
        'product': 'Fundbox'
    },
    {
        'vendor': 'Finastra',
        'product': 'Fundtech'
    },
    {
        'vendor': 'Funnel Operations AB',
        'product': 'Funnel'
    },
    {
        'vendor': 'FunnelSource, Inc.',
        'product': 'FunnelSource'
    },
    {
        'vendor': 'New Vision Information Systems, Inc.',
        'product': 'Furniture Wizard'
    },
    {
        'vendor': 'FurstPerson, Inc.',
        'product': 'FurstPerson'
    },
    {
        'vendor': 'Asandia Corporation',
        'product': 'FuseDesk'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'FuseMail'
    },
    {
        'vendor': 'Fusebill, Inc.',
        'product': 'Fusebill'
    },
    {
        'vendor': 'Fusion Connect, Inc.',
        'product': 'Fusion Connect'
    },
    {
        'vendor': 'Fusion Risk Management, Inc.',
        'product': 'Fusion Framework System'
    },
    {
        'vendor': 'Finastra',
        'product': 'Fusion Invest'
    },
    {
        'vendor': 'Finastra',
        'product': 'Fusion UltraData'
    },
    {
        'vendor': 'NantHealth, Inc.',
        'product': 'FusionFx'
    },
    {
        'vendor': 'Innosoft Canada, Inc.',
        'product': 'FusionIM'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'FusionServer Pro E9000'
    },
    {
        'vendor': 'Futrli, Ltd.',
        'product': 'Futrli'
    },
    {
        'vendor': 'FuturMaster SAS',
        'product': 'FuturMaster (Unspecified Product)'
    },
    {
        'vendor': 'Futura Systems, Inc.',
        'product': 'Futura Systems'
    },
    {
        'vendor': 'Future POS, Inc.',
        'product': 'Future POS'
    },
    {
        'vendor': 'Futurex LP',
        'product': 'FutureX'
    },
    {
        'vendor': 'Fuze, Inc.',
        'product': 'Fuze'
    },
    {
        'vendor': 'G2.com, Inc.',
        'product': 'G2'
    },
    {
        'vendor': 'G5, Inc.',
        'product': 'G5'
    },
    {
        'vendor': 'GAINSystems, Inc.',
        'product': 'GAINSystems (Unspecified Product)'
    },
    {
        'vendor': 'GB Group PLC',
        'product': 'GBG ID3global'
    },
    {
        'vendor': 'GBS Solutions NA, LLC',
        'product': 'GBS Permessa'
    },
    {
        'vendor': 'Artwork Conversion Software, Inc.',
        'product': 'GDSVU'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Advantage Workstation'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE AgileTrac'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE ApexPro'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE AssetPlus'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE BrightSpeed'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE BrightSpeed 16'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE CardioSoft'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Carecast'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Carescape'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity Cardio Enterprise'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity Clinical Archive'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity Perinatal'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity Perioperative'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity Perioperative Anesthesia'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity RIS-IC'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Centricity Universal Viewer'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Corometrics'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Critikon'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Dash'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Datex Ohmeda'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Discovery'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE EchoPAC'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Edison Datalogue'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Flowcast'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Giraffe'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Healthcare CT'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Healthcare MRI'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE HiSpeed'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Historian'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE IDX'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Image Vault'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Imagecast'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE LightSpeed'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE LightSpeed 16'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE LightSpeed 32'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE LightSpeed 4'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE LightSpeed 8'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE LightSpeed VCT 64'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE MAC'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE MUSE'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Meridium'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Optima'
    },
    {
        'vendor': 'GE Power',
        'product': 'GE PowerOn Advantage'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Predictivity'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Predix'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Predix Platform'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Proficy'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Radworks'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Revolution'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE SenoClaire'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Senographe Pristina'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Signa'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Signa Excite'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE Signa HDxt'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Smallworld'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE ViewPoint 6'
    },
    {
        'vendor': 'GE Healthcare',
        'product': 'GE iPath'
    },
    {
        'vendor': 'Gateway Electronic Medical Management Systems, Inc.',
        'product': 'GEMMS ONE'
    },
    {
        'vendor': 'Geodis FF Belgium',
        'product': 'GEODIS'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'GFI (Unspecified Product)'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'GFI Archiver'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'GFI FaxMaker'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'GFI LanGuard'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'GFI MailEssentials'
    },
    {
        'vendor': 'GMC Software',
        'product': 'GMC Inspire'
    },
    {
        'vendor': 'GOMO Learning, Ltd.',
        'product': 'GOMO'
    },
    {
        'vendor': 'Global Payments Direct, Inc.',
        'product': 'GPS'
    },
    {
        'vendor': 'GPS Insight, LLC',
        'product': 'GPS Insight'
    },
    {
        'vendor': 'GRM Information Management, Inc.',
        'product': 'GRM Document Management'
    },
    {
        'vendor': 'GROMACS',
        'product': 'GROMACS'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'GT STRUDL'
    },
    {
        'vendor': 'Gamma Technologies, LLC',
        'product': 'GT-SUITE'
    },
    {
        'vendor': 'GTreasury SS, LLC',
        'product': 'GTreasury'
    },
    {
        'vendor': 'GAFFEY Healthcare',
        'product': 'Gaffey Healthcare'
    },
    {
        'vendor': 'Gainsight, Inc.',
        'product': 'Gainsight'
    },
    {
        'vendor': 'Galileo Financial Technologies, Inc.',
        'product': 'Galileo'
    },
    {
        'vendor': 'Gambio GmbH',
        'product': 'Gambio'
    },
    {
        'vendor': 'Game Sparks Technologies, Ltd.',
        'product': 'GameSparks'
    },
    {
        'vendor': 'Gamma Telecom, Ltd.',
        'product': 'Gamma Telecom'
    },
    {
        'vendor': 'Ganglia',
        'product': 'Ganglia'
    },
    {
        'vendor': 'GANTTIC, LLC',
        'product': 'Ganttic'
    },
    {
        'vendor': 'Beta Systems Software AG',
        'product': 'Garancy IAM Suite'
    },
    {
        'vendor': 'Garda World Security Corporation',
        'product': 'GardaWorld'
    },
    {
        'vendor': 'Garmin, Ltd.',
        'product': 'Garmin'
    },
    {
        'vendor': 'Gartner, Inc.',
        'product': 'Gartner'
    },
    {
        'vendor': 'TriZetto Group, Inc.',
        'product': 'Gateway EDI'
    },
    {
        'vendor': 'Gatsby, Inc.',
        'product': 'Gatsby'
    },
    {
        'vendor': 'ReportGarden, Inc.',
        'product': 'Gaug.es'
    },
    {
        'vendor': 'Tianjin Nanda General Data Technology Company, Ltd.',
        'product': 'Gbase'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'GeForce Now'
    },
    {
        'vendor': 'CERN',
        'product': 'Geant4'
    },
    {
        'vendor': 'Open Source',
        'product': 'Gearman'
    },
    {
        'vendor': 'GeckoBoard',
        'product': 'GeckoBoard'
    },
    {
        'vendor': 'Vertiv Group Corporation',
        'product': 'Geist'
    },
    {
        'vendor': 'Gem Software, Inc.',
        'product': 'Gem'
    },
    {
        'vendor': 'GemTalk Systems, LLC',
        'product': 'GemTalk Systems'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Gemalto'
    },
    {
        'vendor': 'Gemius S.A.',
        'product': 'Gemius'
    },
    {
        'vendor': 'The GenSight Group, Ltd.',
        'product': 'GenSight'
    },
    {
        'vendor': 'Genbook, Inc.',
        'product': 'Genbook'
    },
    {
        'vendor': 'ITRS Group, Ltd.',
        'product': 'Geneos'
    },
    {
        'vendor': 'Genesis Media, LLC',
        'product': 'GenesisMedia'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys (Unspecified Product)'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys CIM Platform'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Cloud'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Contact Center'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Gplus Adapter'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Inbound'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Outbound'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Outbound Voice'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys PureCloud'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys PureConnect'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys PureEngage'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys SIP'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Genesys Workforce Management'
    },
    {
        'vendor': 'Genetec, Inc.',
        'product': 'Genetec'
    },
    {
        'vendor': 'Genetec, Inc.',
        'product': 'Genetec Security Center'
    },
    {
        'vendor': 'Genius Media Group, Inc.',
        'product': 'Genius'
    },
    {
        'vendor': 'Genius Inside',
        'product': 'Genius Project'
    },
    {
        'vendor': 'Genius SIS, Inc.',
        'product': 'Genius SIS'
    },
    {
        'vendor': 'GeniusDoc, Inc.',
        'product': 'GeniusDoc EHR'
    },
    {
        'vendor': 'Genomoncology, LLC',
        'product': 'GenomOncology'
    },
    {
        'vendor': 'Genomind, Inc.',
        'product': 'Genomind'
    },
    {
        'vendor': 'Genoo, LLC',
        'product': 'Genoo'
    },
    {
        'vendor': 'Novartis',
        'product': 'Genoptix'
    },
    {
        'vendor': 'GenoSpace, LLC',
        'product': 'Genospace'
    },
    {
        'vendor': 'Genpact, Ltd.',
        'product': 'Genpact'
    },
    {
        'vendor': 'RaRe Technologies, Ltd.',
        'product': 'Gensim'
    },
    {
        'vendor': 'Gensuite, LLC',
        'product': 'Gensuite'
    },
    {
        'vendor': 'Gentrack, Ltd.',
        'product': 'Gentrack Junifer'
    },
    {
        'vendor': 'Schlumberger, Ltd.',
        'product': 'GeoFrame'
    },
    {
        'vendor': 'GeoGebra GmbH',
        'product': 'GeoGebra'
    },
    {
        'vendor': 'Halliburton Landmark',
        'product': 'GeoProbe'
    },
    {
        'vendor': 'DigiCert, Inc.',
        'product': 'GeoTrust'
    },
    {
        'vendor': 'GeoVision, Inc.',
        'product': 'GeoVision'
    },
    {
        'vendor': 'GEOCONCEPT Group',
        'product': 'Geoconcept'
    },
    {
        'vendor': 'VertiGIS, Ltd.',
        'product': 'Geocortex'
    },
    {
        'vendor': 'Geofeedia, Inc.',
        'product': 'Geofeedia'
    },
    {
        'vendor': 'Geoforce, Inc.',
        'product': 'Geoforce'
    },
    {
        'vendor': 'Geomant UK, Ltd.',
        'product': 'Geomant (Unspecified Product)'
    },
    {
        'vendor': 'Geonetric, Inc.',
        'product': 'Geonetric'
    },
    {
        'vendor': 'Seequent, Ltd.',
        'product': 'Geosoft'
    },
    {
        'vendor': 'Geotab, Inc.',
        'product': 'Geotab'
    },
    {
        'vendor': 'Gephi',
        'product': 'Gephi'
    },
    {
        'vendor': 'GetAccept, Inc.',
        'product': 'GetAccept'
    },
    {
        'vendor': 'Campaign Monitor Pty Ltd',
        'product': 'GetFeedback'
    },
    {
        'vendor': 'GetResponse Sp. z o.o.',
        'product': 'GetResponse'
    },
    {
        'vendor': 'Sprinklr, Inc.',
        'product': 'GetSatisfaction'
    },
    {
        'vendor': 'GetSocial S.A.',
        'product': 'GetSocial'
    },
    {
        'vendor': 'GetWellNetwork, Inc.',
        'product': 'GetWellNetwork'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Ghost Solution Suite'
    },
    {
        'vendor': 'GibbsCAM',
        'product': 'GibbsCAM'
    },
    {
        'vendor': 'GiftRocket, Inc.',
        'product': 'GiftRocket'
    },
    {
        'vendor': 'Mobile Labs, Inc.',
        'product': 'GigaFox'
    },
    {
        'vendor': 'GigaSpaces Technologies, Inc.',
        'product': 'GigaSpaces'
    },
    {
        'vendor': 'Gigamon, Inc.',
        'product': 'Gigamon'
    },
    {
        'vendor': 'Gigya, Inc.',
        'product': 'Gigya'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Gigya Share Bar'
    },
    {
        'vendor': 'Gigya, Inc.',
        'product': 'Gigya ShareBar'
    },
    {
        'vendor': 'Gimmal, LLC',
        'product': 'Gimmal'
    },
    {
        'vendor': 'Ginger.io, Inc.',
        'product': 'Ginger'
    },
    {
        'vendor': 'Open Source',
        'product': 'Git'
    },
    {
        'vendor': 'GitHub, Inc.',
        'product': 'GitHub'
    },
    {
        'vendor': 'GitHub, Inc.',
        'product': 'GitHub Actions'
    },
    {
        'vendor': 'GitHub, Inc.',
        'product': 'GitHub Gist'
    },
    {
        'vendor': 'GitLab, Inc.',
        'product': 'GitLab'
    },
    {
        'vendor': 'Pluralsight, LLC',
        'product': 'GitPrime'
    },
    {
        'vendor': 'GiveGab, Inc.',
        'product': 'GiveGab'
    },
    {
        'vendor': 'Giveffect, Inc.',
        'product': 'Giveffect'
    },
    {
        'vendor': 'Givex Corporation',
        'product': 'Givex'
    },
    {
        'vendor': 'Glenwood Systems, LLC',
        'product': 'GlaceEMR'
    },
    {
        'vendor': 'Gladly Software, Inc.',
        'product': 'Gladly'
    },
    {
        'vendor': 'Glam Media',
        'product': 'Glam Media'
    },
    {
        'vendor': 'Glasscubes, Ltd.',
        'product': 'Glasscubes'
    },
    {
        'vendor': 'Glassdoor, Inc.',
        'product': 'Glassdoor for Employers'
    },
    {
        'vendor': 'Glia Technologies, Inc.',
        'product': 'Glia'
    },
    {
        'vendor': 'Glint, Inc.',
        'product': 'Glint'
    },
    {
        'vendor': 'Glitch, Inc.',
        'product': 'Glitch'
    },
    {
        'vendor': 'Global Healthcare Exchange, LLC',
        'product': 'Global Healthcare Exchange (GHX)'
    },
    {
        'vendor': 'Global IDs',
        'product': 'Global IDs'
    },
    {
        'vendor': 'Global Relay Communications, Inc.',
        'product': 'Global Relay'
    },
    {
        'vendor': 'Global Relay Communications, Inc.',
        'product': 'Global Relay Archive'
    },
    {
        'vendor': 'Global Shop Solutions, Inc.',
        'product': 'Global Shop'
    },
    {
        'vendor': 'GlobalCerts, LLC',
        'product': 'GlobalCerts'
    },
    {
        'vendor': 'GlobalData PLC',
        'product': 'GlobalData'
    },
    {
        'vendor': 'Premiere Global Services, Inc.',
        'product': 'GlobalMeet Webcast'
    },
    {
        'vendor': 'GMO GlobalSign, Ltd.',
        'product': 'GlobalSign'
    },
    {
        'vendor': 'GlobalTranz Enterprises, Inc.',
        'product': 'GlobalTranz'
    },
    {
        'vendor': 'GlobalSCAPE, Inc.',
        'product': 'Globalscape'
    },
    {
        'vendor': 'GlobeNewswire, Inc.',
        'product': 'GlobeNewswire'
    },
    {
        'vendor': 'Globys, Inc.',
        'product': 'Globys'
    },
    {
        'vendor': 'GLOFOX',
        'product': 'Glofox (Unspecified Product)'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Glovia'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'GlusterFS'
    },
    {
        'vendor': 'Gluu, Inc.',
        'product': 'Gluu'
    },
    {
        'vendor': 'Go2Mobi',
        'product': 'Go2Mobi'
    },
    {
        'vendor': 'ThoughtWorks, Inc.',
        'product': 'GoCD'
    },
    {
        'vendor': 'GoCardless, Ltd.',
        'product': 'GoCardless'
    },
    {
        'vendor': 'GoCodes',
        'product': 'GoCodes'
    },
    {
        'vendor': 'ExamTime',
        'product': 'GoConqr'
    },
    {
        'vendor': 'GoDaddy.com, LLC',
        'product': 'GoDaddy Hosting'
    },
    {
        'vendor': 'GoDataFeed',
        'product': 'GoDataFeed'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'GoGrid'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'GoGrid Hosting'
    },
    {
        'vendor': 'GoPro, Inc.',
        'product': 'GoPro'
    },
    {
        'vendor': 'GoPro, Inc.',
        'product': 'GoPro CineForm'
    },
    {
        'vendor': 'GoSecure, Inc.',
        'product': 'GoSecure (Unspecified Product)'
    },
    {
        'vendor': 'GoSpotCheck, Inc.',
        'product': 'GoSpotCheck'
    },
    {
        'vendor': 'Go Squared, Ltd.',
        'product': 'GoSquared'
    },
    {
        'vendor': 'GoStats',
        'product': 'GoStats'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'GoToAssist'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'GoToMeeting'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'GoToMyPC'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'GoToTraining'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'GoToWebinar'
    },
    {
        'vendor': 'Gotransverse, LLC',
        'product': 'GoTransverse'
    },
    {
        'vendor': 'Creationshop, Ltd.',
        'product': 'GoingUp!'
    },
    {
        'vendor': 'Elsevier, Inc.',
        'product': 'Gold Standard Drug Database'
    },
    {
        'vendor': 'Esteiro Business Solutions, Ltd.',
        'product': 'Gold-Vision CRM'
    },
    {
        'vendor': 'DPD International',
        'product': 'GoldFax'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'GoldMine'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'GoldMine Premium'
    },
    {
        'vendor': 'GoldSim Technology Group, LLC',
        'product': 'GoldSim'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'GoldenGate'
    },
    {
        'vendor': 'Goliath Technologies LP',
        'product': 'Goliath'
    },
    {
        'vendor': 'Gong I.O, Ltd.',
        'product': 'Gong'
    },
    {
        'vendor': 'GoodBarber',
        'product': 'GoodBarber'
    },
    {
        'vendor': 'GoodData Corporation',
        'product': 'GoodData'
    },
    {
        'vendor': 'Etch Mobile, Inc.',
        'product': 'GoodTime'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google API'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Ad Manager'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google AdSense'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google AdWords'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google AdWords Conversion'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Adometry'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Ads'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Ads Conversion'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Analytics'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Analytics 360'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Analytics Premium'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Anvato'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google App Engine'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google App Maker'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Audience Center 360'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google BigQuery'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Calendar'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Channel Intelligence'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Charts'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Checkout'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Chromebook'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Classroom'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud AI Building Blocks'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud AI Hub'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud AI Platform'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud APIs'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Apigee'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Apigee Sense'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Application Security'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Armor'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud AutoML'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud AutoML Vision'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Bigtable'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Build'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud CDN'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Composer'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Cloud Connect'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Console'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud DNS'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud DataLab'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Dataflow'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Dataproc'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Datastore'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Deployment Manager'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Endpoints'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Firestore'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Functions'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Inference API'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Interconnect'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud IoT'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Key Management Service'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Load Balancing'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Machine Learning Engine'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Monitoring'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Natural Language API'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Platform'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Pub/Sub'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Run'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud SDK'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud SQL'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Search'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Security Command Center'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Security Scanner'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Serverless'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Shell'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Spanner'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Speech-to-Text'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Storage'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Tasks'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Text-to-Speech'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Translation API'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud VPN'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Video Intelligence API'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Cloud Vision API'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Compute Engine'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Contact Center AI'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Container Registry'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Crashlytics'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Custom Search'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Data Studio'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Dialogflow'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Docs'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google DoubleClick'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Drive'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Filestore'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Firebase'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Font API'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google G Suite'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Gmail'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Go Language'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Groups'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Hangouts'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Hire'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Hosted Libraries'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Hosted jQuery'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Knative'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Kubernetes Engine'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Maps'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Maps Platform'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Marketing Platform'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Meebo'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Opinion Rewards'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Optimize'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Orbitera'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Panoramio'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Plus One'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google PowerMeter'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Remarketing'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Search Appliance'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Sheets'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Sites'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Speech API'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Tag Manager'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google Translate API'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Translate Widget'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Trusted Stores'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Google VPC'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Vault'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Web Toolkit (GWT)'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google WebRTC'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Website Optimizer'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Wildfire'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Workspace'
    },
    {
        'vendor': 'Gorgias, Inc.',
        'product': 'Gorgias'
    },
    {
        'vendor': 'Gorilla Nation Media, LLC',
        'product': 'Gorilla Nation'
    },
    {
        'vendor': 'Gorkana Group, Ltd.',
        'product': 'Gorkana'
    },
    {
        'vendor': 'Gorrie-Regan, Inc.',
        'product': 'Gorrie-Regan'
    },
    {
        'vendor': 'Goverlan, Inc.',
        'product': 'Goverlan Reach'
    },
    {
        'vendor': 'Gpayroll',
        'product': 'Gpayroll'
    },
    {
        'vendor': 'Grace Hill, LLC',
        'product': 'Grace Hill'
    },
    {
        'vendor': 'Grace Software, Inc.',
        'product': 'Gracesoft Easy InnKeeping'
    },
    {
        'vendor': 'Gradle, Inc.',
        'product': 'Gradle'
    },
    {
        'vendor': 'Grafana Labs',
        'product': 'Grafana'
    },
    {
        'vendor': 'Grafana Labs',
        'product': 'Grafana Cloud'
    },
    {
        'vendor': 'Grafana Labs',
        'product': 'Grafana Loki'
    },
    {
        'vendor': 'Grammarly, Inc.',
        'product': 'Grammarly'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'Granta Design'
    },
    {
        'vendor': 'Grapevine Village',
        'product': 'Grapevine'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'GraphQL'
    },
    {
        'vendor': 'Graphisoft SE',
        'product': 'Graphisoft'
    },
    {
        'vendor': 'Graphisoft SE',
        'product': 'Graphisoft ArchiCAD'
    },
    {
        'vendor': 'Open Source',
        'product': 'Graphite'
    },
    {
        'vendor': 'Graphnet, Inc.',
        'product': 'Graphnet'
    },
    {
        'vendor': 'Grass Valley Canada',
        'product': 'Grass Valley'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'Grasshopper'
    },
    {
        'vendor': 'Gravatar',
        'product': 'Gravatar'
    },
    {
        'vendor': 'Gravitational, Inc.',
        'product': 'Gravitational'
    },
    {
        'vendor': 'Gravity Forms',
        'product': 'Gravity Forms'
    },
    {
        'vendor': 'Gravity Insights',
        'product': 'Gravity Insights'
    },
    {
        'vendor': 'Graylog, Inc.',
        'product': 'Graylog'
    },
    {
        'vendor': 'Global Payments Direct, Inc.',
        'product': 'Greater Giving'
    },
    {
        'vendor': 'Green Dot Corporation',
        'product': 'Green Dot'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'GreenBytes'
    },
    {
        'vendor': 'GreenRope, LLC',
        'product': 'GreenRope CRM'
    },
    {
        'vendor': 'ISDG, Ltd.',
        'product': 'GreenSQL'
    },
    {
        'vendor': 'Greenbone Networks GmbH',
        'product': 'Greenbone'
    },
    {
        'vendor': 'Greenhouse Software, Inc.',
        'product': 'Greenhouse'
    },
    {
        'vendor': 'Greenlight Innovation, Ltd.',
        'product': 'Greenlight CRM'
    },
    {
        'vendor': 'Greenlight Technologies, Inc.',
        'product': 'Greenlight Technologies'
    },
    {
        'vendor': 'Greenphire, Inc.',
        'product': 'Greenphire'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Greenplum Database'
    },
    {
        'vendor': 'GreenRope, LLC',
        'product': 'Greenrope Marketing Suite'
    },
    {
        'vendor': 'Greenvelope, LLC',
        'product': 'Greenvelope'
    },
    {
        'vendor': 'Greenway Health, LLC',
        'product': 'Greenway Health (Unspecified Product)'
    },
    {
        'vendor': 'Greenway Health, LLC',
        'product': 'Greenway Vitera'
    },
    {
        'vendor': 'Gremlin, Inc.',
        'product': 'Gremlin'
    },
    {
        'vendor': 'Greycon, Ltd.',
        'product': 'Greycon'
    },
    {
        'vendor': 'Fixstars Corporation',
        'product': 'GridDB'
    },
    {
        'vendor': 'GridGain Systems, Inc.',
        'product': 'GridGain'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'GridTools'
    },
    {
        'vendor': 'Gridium, Inc.',
        'product': 'Gridium Tikkit'
    },
    {
        'vendor': 'GridPoint, Inc.',
        'product': 'Gridpoint'
    },
    {
        'vendor': 'Groove Networks, LLC',
        'product': 'Groove Help Desk'
    },
    {
        'vendor': 'GroupBy, Inc.',
        'product': 'GroupBy'
    },
    {
        'vendor': 'Grove Technologies, LLC',
        'product': 'GroveSite'
    },
    {
        'vendor': 'Grovo Learning, Inc.',
        'product': 'Grovo'
    },
    {
        'vendor': 'Grow, Inc.',
        'product': 'Grow BI'
    },
    {
        'vendor': 'Gtmhub, Ltd.',
        'product': 'Gtmhub'
    },
    {
        'vendor': 'GuardiCore, Ltd.',
        'product': 'GuardiCore Centra'
    },
    {
        'vendor': 'Guardian Analytics, Inc.',
        'product': 'Guardian Analytics'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'GuardianEdge'
    },
    {
        'vendor': 'Guavus, Inc.',
        'product': 'Guavus'
    },
    {
        'vendor': 'Gubagoo, Inc.',
        'product': 'Gubagoo'
    },
    {
        'vendor': 'Centium Software, Ltd.',
        'product': 'GuestPoint'
    },
    {
        'vendor': 'GuestVision',
        'product': 'GuestVision'
    },
    {
        'vendor': 'Guestware',
        'product': 'Guestware'
    },
    {
        'vendor': 'Guesty, Inc.',
        'product': 'Guesty'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'Guidance Software'
    },
    {
        'vendor': 'Guidewire Software, Inc.',
        'product': 'Guidewire'
    },
    {
        'vendor': 'Guidewire Software, Inc.',
        'product': 'Guidewire InsuranceNow'
    },
    {
        'vendor': 'Guidewire Software, Inc.',
        'product': 'Guidewire InsuranceSuite'
    },
    {
        'vendor': 'Guild Education, Inc.',
        'product': 'Guild Education'
    },
    {
        'vendor': 'GuildQuality, Inc.',
        'product': 'GuildQuality'
    },
    {
        'vendor': 'Gumbo Software, Inc.',
        'product': 'Gumbo'
    },
    {
        'vendor': 'GumGum, Inc.',
        'product': 'Gumgum'
    },
    {
        'vendor': 'Gumroad, Inc.',
        'product': 'Gumroad'
    },
    {
        'vendor': 'Gumtree.com, Ltd.',
        'product': 'Gumtree'
    },
    {
        'vendor': 'Open Source',
        'product': 'Gunicorn'
    },
    {
        'vendor': 'Gurobi Optimization, Inc.',
        'product': 'Gurobi'
    },
    {
        'vendor': 'Guru Technologies, Inc.',
        'product': 'Guru'
    },
    {
        'vendor': 'Gurucul',
        'product': 'Gurucul'
    },
    {
        'vendor': 'Gusto, Inc.',
        'product': 'Gusto'
    },
    {
        'vendor': 'Open Source',
        'product': 'H2 Database'
    },
    {
        'vendor': 'H2O.ai, Inc.',
        'product': 'H2O.ai'
    },
    {
        'vendor': 'HAProxy Technologies, LLC',
        'product': 'HAProxy'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'HARO'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL AppScan'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL BigFix'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Cloud Native Services'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Commerce'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Connections'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Digital Experience'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Domino'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Notes'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Sametime'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Unica'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Unica Campaign'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Unica Interact'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Unica Marketing Operations'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Unica NetInsight'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Verse'
    },
    {
        'vendor': 'Health Care Systems, Inc.',
        'product': 'HCS eMR'
    },
    {
        'vendor': 'Heavy Construction System Specialist, Inc.',
        'product': 'HCSS'
    },
    {
        'vendor': 'Heavy Construction System Specialist, Inc.',
        'product': 'HCSS Dispatcher'
    },
    {
        'vendor': 'Heavy Construction System Specialist, Inc.',
        'product': 'HCSS Equipment360'
    },
    {
        'vendor': 'Heavy Construction System Specialist, Inc.',
        'product': 'HCSS HeavyBid'
    },
    {
        'vendor': 'Heavy Construction System Specialist, Inc.',
        'product': 'HCSS HeavyJob'
    },
    {
        'vendor': 'The HDF Group',
        'product': 'HDF5'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'HEAT Service Management'
    },
    {
        'vendor': 'U.S. Army Corps of Engineers',
        'product': 'HEC-PACK'
    },
    {
        'vendor': 'HERO PM',
        'product': 'HERO PM'
    },
    {
        'vendor': 'HICX Solutions, Ltd.',
        'product': 'HICX'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'HID Biometric Readers and Modules'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'HID DigitalPersona'
    },
    {
        'vendor': 'HOASpace.com',
        'product': 'HOASpace.com'
    },
    {
        'vendor': 'Regents of the University of Michigan',
        'product': 'HOOMD-blue'
    },
    {
        'vendor': 'HOSTING',
        'product': 'HOSTING (Unspecified Product)'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HP BTO (Business Technology Optimization)'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Designjet'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Desktop'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP EliteOne'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HP Internet Services'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Laptop'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP LaserJet'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Latex'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Managed Print Services'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Neoware'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Officejet'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Omni'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HP OpenView TeMIP'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP PA-RISC'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Pavilion'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HP Performance Insight'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Photosmart'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HP Route Analytics Management'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Scanjet'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Scitex'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Serial ATA (SATA)'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HP SiteSeer'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Tablet'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Thin Client Hardware'
    },
    {
        'vendor': 'HPE',
        'product': 'HP Web Jetadmin'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Z420'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Z620'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP Z820'
    },
    {
        'vendor': 'HP, Inc.',
        'product': 'HP ZBook'
    },
    {
        'vendor': 'HPE',
        'product': 'HP-UX'
    },
    {
        'vendor': 'LexisNexis Risk Solutions, Inc.',
        'product': 'HPCC Systems'
    },
    {
        'vendor': 'LexisNexis Risk Solutions, Inc.',
        'product': 'HPCC Thor'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE 3000'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE 3PAR'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE 3PAR StoreServ'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE 9000'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE AlphaServer'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Aperture VISTA'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Apollo 2000'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Apollo 4000'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Blade Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Command View EVA Software'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Composable Fabric'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Consumption Analytics'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ConvergedSystems'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Cray'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Disk Array Storage Systems'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE EVA'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE EVA P6000 Storage'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Edgeline Converged Edge Systems'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Ezmeral Data Fabric'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE FlexFabric'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE FlexFabric 12500'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE FlexFabric 5900'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE FlexNetwork Architecture'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE GreenLake'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE HCIS'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE HSR6800'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Helion'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Helion CloudSystem Enterprise'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Hyper Converged 380'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE IBRIX'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Infosight'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Insight Control'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Integrated Lights Out (ILO)'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Integrity Nonstop'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Integrity Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Integrity Superdome'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Integrity Virtual Machines'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE IoT'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Itanium'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE LeftHand P4000'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE MDS600'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE MSA'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Medical Archive Solution (MAS)'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Moonshot'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE NBX'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE NBX 100'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE NBX V3000'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE NetServer'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Nimble Storage'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE OneSphere'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE OneView'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE OpenVMS'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE PolyServe'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Primera'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProCurve'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProCurve Manager Plus'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant BL Blade Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant BL460c'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant DL Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant DL160'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant DL180'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant DL20'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant DL360'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant DL380'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant ML Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant ML110'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant ML30'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant ML350'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE ProLiant Tower Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE RMC'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Rackmount Carrier Grade Server'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Router'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Serial Attached SCSI (SAS) Drives'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'HPE Server Automation'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Servers'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Serviceguard'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE SimpliVity'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Storage Essentials'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Storage Systems'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StorageWorks Enterprise Virtual Array'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StorageWorks MSL2024'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StorageWorks MSL4048'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StorageWorks XP12000 Disk Array'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StorageWorks XP128 Disk Array'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StoreEasy'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StoreEver Management Software'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StoreOnce'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE StoreVirtual'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE SuperStack 3'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Synergy'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Tape Drives'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Tape Libraries'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Transaction Vision'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Tru64 UNIX Operating System'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE Virtual Connect'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE WinRunner'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE XP P9500'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE XP1024 Disk Array'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE XP20000 Disk Array'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE XP24000 Disk Array'
    },
    {
        'vendor': 'HPE',
        'product': 'HPE XP7 Storage'
    },
    {
        'vendor': 'Sopra HR Software',
        'product': 'HR Access'
    },
    {
        'vendor': 'HR 2000 Sdn. Bhd.',
        'product': 'HR2000'
    },
    {
        'vendor': 'Orblogic, Inc.',
        'product': 'HRMatrix'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'HRsmart'
    },
    {
        'vendor': 'HRweb Software, LLC',
        'product': 'HRweb'
    },
    {
        'vendor': 'University of Wisconsin-Madison',
        'product': 'HTCondor'
    },
    {
        'vendor': 'World Wide Web Consortium',
        'product': 'HTML'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'HUE'
    },
    {
        'vendor': 'Open Source',
        'product': 'HUGO'
    },
    {
        'vendor': 'HVR Software, Inc.',
        'product': 'HVR'
    },
    {
        'vendor': 'HYCU, Inc.',
        'product': 'HYCU'
    },
    {
        'vendor': 'HackerEarth, Inc.',
        'product': 'HackerEarth'
    },
    {
        'vendor': 'HackerOne, Inc.',
        'product': 'HackerOne'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Hadapt'
    },
    {
        'vendor': 'Haemonetics Corporation',
        'product': 'Haemonetics'
    },
    {
        'vendor': 'Haivision Systems, Inc.',
        'product': 'Haivision (Unspecified Product)'
    },
    {
        'vendor': 'Halo Health, Inc.',
        'product': 'Halo'
    },
    {
        'vendor': 'Halo Business Intelligence, Inc.',
        'product': 'Halo BI'
    },
    {
        'vendor': 'Saba Software, Inc.',
        'product': 'Halogen Software'
    },
    {
        'vendor': 'Hamilton Medical AG',
        'product': 'Hamilton Medical'
    },
    {
        'vendor': 'HandiFox',
        'product': 'HandiFox'
    },
    {
        'vendor': 'HandsOn Connect Cloud Solutions',
        'product': 'HandsOn Connect'
    },
    {
        'vendor': 'Handshake',
        'product': 'Handshake'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Hansoft'
    },
    {
        'vendor': 'HapYak Interactive Video',
        'product': 'HapYak'
    },
    {
        'vendor': 'HappyCo',
        'product': 'Happy Inspector'
    },
    {
        'vendor': 'HappyFox, Inc.',
        'product': 'HappyFox'
    },
    {
        'vendor': 'Jio Haptik Technologies, Ltd.',
        'product': 'Haptik'
    },
    {
        'vendor': 'Haravan',
        'product': 'Haravan'
    },
    {
        'vendor': 'InEight, Inc.',
        'product': 'Hard Dollar'
    },
    {
        'vendor': 'Hardcat Pty Ltd',
        'product': 'Hardcat'
    },
    {
        'vendor': 'Hariken Tecnologia da Informacao S.A.',
        'product': 'Hariken'
    },
    {
        'vendor': 'Finastra',
        'product': 'Harland Servicing Director'
    },
    {
        'vendor': 'Harmon.ie Corporation',
        'product': 'Harmon.ie'
    },
    {
        'vendor': 'Harmonic, Inc.',
        'product': 'Harmonic'
    },
    {
        'vendor': 'Harness, Inc.',
        'product': 'Harness'
    },
    {
        'vendor': 'Harris Local Government',
        'product': 'Harris Accounting +Plus'
    },
    {
        'vendor': 'Harris Enterprise Resource Planning',
        'product': 'Harris Enterprise Resource Planning'
    },
    {
        'vendor': 'Harris Govern',
        'product': 'Harris Govern'
    },
    {
        'vendor': 'Harris Business Group, Inc.',
        'product': 'HarrisData (Unspecified Product)'
    },
    {
        'vendor': 'Harris Business Group, Inc.',
        'product': 'HarrisData ERP'
    },
    {
        'vendor': 'Harvard Business Publishing',
        'product': 'Harvard ManageMentor'
    },
    {
        'vendor': 'Harvest',
        'product': 'Harvest'
    },
    {
        'vendor': 'nThrive, Inc.',
        'product': 'Harvest Contract Management'
    },
    {
        'vendor': 'Tune, Inc.',
        'product': 'HasOffers'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'HashiCorp'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'HashiCorp Packer'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'HashiCorp Terraform'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'HashiCorp Vault'
    },
    {
        'vendor': 'Hasura, Inc.',
        'product': 'Hasura'
    },
    {
        'vendor': 'BenchmarkONE',
        'product': 'Hatchbuck'
    },
    {
        'vendor': 'Hatena Company, Ltd.',
        'product': 'Hatena Bookmark'
    },
    {
        'vendor': 'Haufe-Lexware GmbH & Company KG',
        'product': 'Haufe Umantis'
    },
    {
        'vendor': 'HPE',
        'product': 'Haven OnDemand'
    },
    {
        'vendor': 'Havenstar MMS, Ltd.',
        'product': 'Havenstar'
    },
    {
        'vendor': 'Hawk Search, Inc.',
        'product': 'HawkSearch'
    },
    {
        'vendor': 'HawkSoft, Inc.',
        'product': 'HawkSoft'
    },
    {
        'vendor': 'Hazelcast, Inc.',
        'product': 'Hazelcast'
    },
    {
        'vendor': 'HeadSpin, Inc.',
        'product': 'HeadSpin'
    },
    {
        'vendor': 'Headway',
        'product': 'Headway'
    },
    {
        'vendor': 'Health Catalyst, Inc.',
        'product': 'Health Catalyst'
    },
    {
        'vendor': 'Harmony Health IT',
        'product': 'HealthData Archiver'
    },
    {
        'vendor': 'Stryker Corporation',
        'product': 'HealthEMS'
    },
    {
        'vendor': 'HealthInfoNet',
        'product': 'HealthInfoNet'
    },
    {
        'vendor': 'Allocate Software, Ltd.',
        'product': 'HealthRoster'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'HealthShare'
    },
    {
        'vendor': 'HealthStream, Inc.',
        'product': 'HealthStream'
    },
    {
        'vendor': 'HealthTap, Inc.',
        'product': 'HealthTap'
    },
    {
        'vendor': 'HealthcareSource HR, Inc.',
        'product': 'HealthcareSource'
    },
    {
        'vendor': 'Healthgrades Operating Company, Inc.',
        'product': 'Healthgrades'
    },
    {
        'vendor': 'Healthix, Inc.',
        'product': 'Healthix'
    },
    {
        'vendor': 'Heap, Inc.',
        'product': 'HeapAnalytics'
    },
    {
        'vendor': 'Hearsay Systems, Inc.',
        'product': 'Hearsay Social'
    },
    {
        'vendor': 'Heart Imaging Technologies, LLC',
        'product': 'Heart IT'
    },
    {
        'vendor': 'HeartWare',
        'product': 'HeartWare'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'HeartWare HVAD System'
    },
    {
        'vendor': 'Heartland Payment Systems, Inc.',
        'product': 'Heartland Payment Systems'
    },
    {
        'vendor': 'Heartland Payment Systems, Inc.',
        'product': 'Heartland Payroll'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Hedvig Distributed Storage'
    },
    {
        'vendor': 'HelioCampus, Inc.',
        'product': 'HelioCampus'
    },
    {
        'vendor': 'Hello Health, Inc.',
        'product': 'Hello Health'
    },
    {
        'vendor': 'HelloSign',
        'product': 'HelloSign'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Helm'
    },
    {
        'vendor': 'Help Scout PBC',
        'product': 'Help Scout'
    },
    {
        'vendor': 'HelpCrunch Corporation',
        'product': 'HelpCrunch'
    },
    {
        'vendor': 'ServicePRO',
        'product': 'HelpSTAR'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'HelpSystems (Unspecified Product)'
    },
    {
        'vendor': 'Helpjuice, Inc.',
        'product': 'Helpjuice'
    },
    {
        'vendor': 'Helpshift, Inc.',
        'product': 'Helpshift'
    },
    {
        'vendor': 'Herfert Software',
        'product': 'Herfert Software'
    },
    {
        'vendor': 'Hermes Medical Solutions AB',
        'product': 'Hermes Medical'
    },
    {
        'vendor': 'Heroix Corporation',
        'product': 'Heroix'
    },
    {
        'vendor': 'Hertzler Systems, Inc.',
        'product': 'Hertzler Systems'
    },
    {
        'vendor': 'Hetzner Online GmbH',
        'product': 'Hetzner'
    },
    {
        'vendor': 'Hetzner Online GmbH',
        'product': 'Hetzner Hosting'
    },
    {
        'vendor': 'Heureka Software, LLC',
        'product': 'Heureka Software'
    },
    {
        'vendor': 'Hevo Data, Inc.',
        'product': 'Hevo'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'Hexagon GeoMedia'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'Hexagon Geospatial'
    },
    {
        'vendor': 'Hexagon Mining',
        'product': 'Hexagon Mining'
    },
    {
        'vendor': 'Hexawise, Inc.',
        'product': 'Hexawise'
    },
    {
        'vendor': 'Mitsogo, Inc.',
        'product': 'Hexnode MDM'
    },
    {
        'vendor': 'HiConversion, Inc.',
        'product': 'HiConversion'
    },
    {
        'vendor': 'Illumina, Inc.',
        'product': 'HiSeq'
    },
    {
        'vendor': 'AppGate',
        'product': 'HiSoftware'
    },
    {
        'vendor': 'Syniti',
        'product': 'HiT Software'
    },
    {
        'vendor': 'HighRadius Corporation',
        'product': 'High Radius'
    },
    {
        'vendor': 'Galvanize',
        'product': 'HighBond'
    },
    {
        'vendor': 'HighJump Software, Inc.',
        'product': 'Highjump'
    },
    {
        'vendor': 'Highrise HQ, LLC',
        'product': 'Highrise CRM'
    },
    {
        'vendor': 'Highspot, Inc.',
        'product': 'Highspot'
    },
    {
        'vendor': 'Hikari Software, LLC',
        'product': 'HikaMarket'
    },
    {
        'vendor': 'Hikari Software, LLC',
        'product': 'HikaShop'
    },
    {
        'vendor': 'Hangzhou Hikvision Digital Technology Company, Ltd.',
        'product': 'Hikvision (Unspecified Product)'
    },
    {
        'vendor': 'Hill-Rom Holdings, Inc.',
        'product': 'Hillrom'
    },
    {
        'vendor': 'HindSite Software',
        'product': 'HindSite Software'
    },
    {
        'vendor': 'Slack Technologies, Inc.',
        'product': 'HipChat'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'HipTest'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Hiperos'
    },
    {
        'vendor': 'Hippo Facilities Management Technologies, Inc.',
        'product': 'Hippo CMMS'
    },
    {
        'vendor': 'ExactHire',
        'product': 'HireCentric'
    },
    {
        'vendor': 'HireHive, Ltd.',
        'product': 'HireHive'
    },
    {
        'vendor': 'HireMojo, Inc.',
        'product': 'HireMojo'
    },
    {
        'vendor': 'HireVue, Inc.',
        'product': 'HireVue'
    },
    {
        'vendor': 'Hireology, Inc.',
        'product': 'Hireology'
    },
    {
        'vendor': 'Hiretual',
        'product': 'Hiretual'
    },
    {
        'vendor': 'HiringThing, LLC',
        'product': 'HiringThing'
    },
    {
        'vendor': 'Belden, Inc.',
        'product': 'Hirschmann'
    },
    {
        'vendor': 'Histats',
        'product': 'Histats'
    },
    {
        'vendor': 'HitTail, Inc.',
        'product': 'HitTail'
    },
    {
        'vendor': 'Hitachi ABB Power Grids, Ltd.',
        'product': 'Hitachi ABB PowerGrids'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi AIRIS'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi AIRIS Elite'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi AMS 2000 Series'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi AMS 2100'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi AMS 2300'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi AMS 2500'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Adaptable Modular Storage'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Basic Operating System (BOS)'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Bluearc Storage'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi CT'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Command Suite'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Compute Blade 2000'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Content Platform'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Data Discovery'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Data Ingestor'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Data Instance Director'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi Echelon'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi HUS 110'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi HUS 130'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi HUS 150'
    },
    {
        'vendor': 'Hitachi, Ltd.',
        'product': 'Hitachi HiRDB'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Hyper Scale Out'
    },
    {
        'vendor': 'Hitachi ID Systems, Inc.',
        'product': 'Hitachi ID Systems'
    },
    {
        'vendor': 'Hitachi, Ltd.',
        'product': 'Hitachi JP1'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Lightning'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi MRI'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Mainframe'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi NAS Storage System'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi Oasis'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi SAN Storage System'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi SMS100'
    },
    {
        'vendor': 'Hitachi Healthcare Americas Corporation',
        'product': 'Hitachi Scenaria'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Software'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Unified Compute Platform'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Unified Storage 100'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Unified Storage 100 Series'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Universal Storage Platform V'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Universal Storage Platform VM'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi VSP G Series'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi VSP G1000'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi VSP G1500'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi VSP G200'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi VSP G400'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi VSP G800'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Vantara (Unspecified Product)'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Virtual Storage Platform (VSP)'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi Virtual Storage Platform F Series'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Hitachi iSCSI Storage'
    },
    {
        'vendor': 'Net Applications, Inc.',
        'product': 'Hitslink'
    },
    {
        'vendor': 'Hobsons, Inc.',
        'product': 'Hobsons'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'HockeyApp'
    },
    {
        'vendor': 'Hogan Assessments Systems, Inc.',
        'product': 'Hogan Assessments'
    },
    {
        'vendor': 'HoloBuilder, Inc.',
        'product': 'HoloBuilder'
    },
    {
        'vendor': 'Hologic, Inc.',
        'product': 'Hologic'
    },
    {
        'vendor': 'Home.pl S.A.',
        'product': 'Home.pl'
    },
    {
        'vendor': 'HomBase, LLC',
        'product': 'Homebase'
    },
    {
        'vendor': 'Homecare Homebase, LLC',
        'product': 'Homecare Homebase'
    },
    {
        'vendor': 'Homestead Technologies, Inc.',
        'product': 'Homestead'
    },
    {
        'vendor': 'Procore Technologies, Inc.',
        'product': 'Honest Buildings'
    },
    {
        'vendor': 'Honeybadger Industries, LLC',
        'product': 'HoneyBadger.io'
    },
    {
        'vendor': 'Hound Technology, Inc.',
        'product': 'Honeycomb'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Honeywell Dolphin'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Honeywell Enterprise Buildings Integrator'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Honeywell MAXPRO'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Honeywell Pro-Watch'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Honeywell Xenon'
    },
    {
        'vendor': 'Honorlock, Inc.',
        'product': 'Honorlock'
    },
    {
        'vendor': 'Hoopla Software, Inc.',
        'product': 'Hoopla'
    },
    {
        'vendor': 'Hootsuite Media, Inc.',
        'product': 'Hootsuite'
    },
    {
        'vendor': 'Hopin, Ltd.',
        'product': 'Hopin'
    },
    {
        'vendor': 'Horizon Software International, LLC',
        'product': 'Horizon'
    },
    {
        'vendor': 'Hornbill Corporate, Ltd.',
        'product': 'Hornbill'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Hornetq'
    },
    {
        'vendor': 'Hornetsecurity GmbH',
        'product': 'Hornetsecurity'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Hortonworks'
    },
    {
        'vendor': 'Host Analytics, Inc.',
        'product': 'Host Analytics'
    },
    {
        'vendor': 'HostBill Krzysztof Pajak',
        'product': 'HostBill'
    },
    {
        'vendor': 'HostBridge Technology',
        'product': 'HostBridge'
    },
    {
        'vendor': 'HostDime.com, Inc.',
        'product': 'HostDime'
    },
    {
        'vendor': 'HostMonster, Inc.',
        'product': 'HostMonster'
    },
    {
        'vendor': 'HostMonster, Inc.',
        'product': 'HostMonster Hosting'
    },
    {
        'vendor': 'HostPapa, Inc.',
        'product': 'HostPapa'
    },
    {
        'vendor': 'HostPapa, Inc.',
        'product': 'HostPapa Web Hosting'
    },
    {
        'vendor': 'Acens Technologies S.L.U.',
        'product': 'Hostalia'
    },
    {
        'vendor': 'HostGator.com, LLC',
        'product': 'Hostgator'
    },
    {
        'vendor': 'HostGator.com, LLC',
        'product': 'Hostgator Hosting'
    },
    {
        'vendor': 'Hostway Services, Inc.',
        'product': 'Hostway'
    },
    {
        'vendor': 'PalitrumLab, LLC',
        'product': 'HotLog'
    },
    {
        'vendor': 'Fourth Enterprises, LLC',
        'product': 'HotSchedules'
    },
    {
        'vendor': 'Open Source',
        'product': 'Hotcakes Commerce'
    },
    {
        'vendor': 'Hotel Engine, LLC',
        'product': 'Hotel Engine'
    },
    {
        'vendor': 'Mingus Software, Inc.',
        'product': 'Hotello'
    },
    {
        'vendor': 'HMS Infotech Pvt, Ltd.',
        'product': 'Hotelogix'
    },
    {
        'vendor': 'Hotjar, Ltd.',
        'product': 'Hotjar'
    },
    {
        'vendor': 'Side Effects Software, Inc',
        'product': 'Houdini'
    },
    {
        'vendor': 'HoudiniESQ',
        'product': 'HoudiniESQ'
    },
    {
        'vendor': 'Codefied, Inc.',
        'product': 'Housecall Pro'
    },
    {
        'vendor': 'Hoverowl, LLC',
        'product': 'HoverOwl'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei AC6005'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei AC6605'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei AR1200'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei AR2200'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei AR3200'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei BSS'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei CE12800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei CE6800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei FusionCube'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei FusionSphere'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei FusionStorage'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei NE5000E'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei OSN 1800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei OSN 8800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei OSN 9800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei OceanStor'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei OptiX OSN 6800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S12700'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S2700'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S3700'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S5700'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S6700'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S7700'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei Server'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei USG'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei WDM'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei eSpace Unified Communications'
    },
    {
        'vendor': 'HubSoft, LLC',
        'product': 'HubSoft'
    },
    {
        'vendor': 'HubSpot, Inc.',
        'product': 'HubSpot'
    },
    {
        'vendor': 'HubSpot, Inc.',
        'product': 'HubSpot Marketing Hub'
    },
    {
        'vendor': 'HubSpot, Inc.',
        'product': 'HubSpot Operations Hub'
    },
    {
        'vendor': 'HubSpot, Inc.',
        'product': 'HubSpot Sales Hub'
    },
    {
        'vendor': 'HubSpot, Inc.',
        'product': 'HubSpot Service Hub'
    },
    {
        'vendor': 'Insightsoftware, Inc.',
        'product': 'Hubble'
    },
    {
        'vendor': 'Hubstaff',
        'product': 'Hubstaff'
    },
    {
        'vendor': 'Huddle, Inc.',
        'product': 'Huddle'
    },
    {
        'vendor': 'Agile Sports Technologies, Inc.',
        'product': 'Hudl Sportscode'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Hudson'
    },
    {
        'vendor': 'Human Interest, Inc.',
        'product': 'Human Interest'
    },
    {
        'vendor': 'Humanic, Inc.',
        'product': 'Humanic'
    },
    {
        'vendor': 'Humanity.com, Inc.',
        'product': 'Humanity.com'
    },
    {
        'vendor': 'OptumInsight',
        'product': 'Humedica'
    },
    {
        'vendor': 'Humio, Ltd.',
        'product': 'Humio'
    },
    {
        'vendor': 'Huntsman Security',
        'product': 'Huntsman'
    },
    {
        'vendor': 'Hupso',
        'product': 'Hupso'
    },
    {
        'vendor': 'Husky Intelligence',
        'product': 'Husky Field Service Management'
    },
    {
        'vendor': 'Hy.ly, Inc.',
        'product': 'Hy.ly'
    },
    {
        'vendor': 'HyTrust, Inc.',
        'product': 'HyTrust'
    },
    {
        'vendor': 'HyTrust, Inc.',
        'product': 'HyTrust CloudControl'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Hybris'
    },
    {
        'vendor': 'HydroCAD Software Solutions, LLC',
        'product': 'HydroCAD'
    },
    {
        'vendor': 'Capital One Financial Corporation',
        'product': 'Hygieia'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'Hyland Perceptive Software'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'Hyland Software OnBase'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'Hyland Valco'
    },
    {
        'vendor': 'CloudSphere, Inc.',
        'product': 'HyperCloud'
    },
    {
        'vendor': 'HyperGrid, Inc.',
        'product': 'HyperGrid'
    },
    {
        'vendor': 'MicroStrategy, Inc.',
        'product': 'HyperIntelligence'
    },
    {
        'vendor': 'Mentor Graphics Corporation',
        'product': 'HyperLynx'
    },
    {
        'vendor': 'HyperOffice, Inc.',
        'product': 'HyperOffice'
    },
    {
        'vendor': 'The HSQL Development Group',
        'product': 'HyperSQL Database (HSQLDB)'
    },
    {
        'vendor': 'Hyper Labs, Inc.',
        'product': 'HyperScience'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Hyperion'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Hyperledger'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Hyperledger Fabric'
    },
    {
        'vendor': 'Hypersoft Informationssysteme GmbH',
        'product': 'Hypersoft OmniAnalyser'
    },
    {
        'vendor': 'Hyperwallet Systems, Inc.',
        'product': 'Hyperwallet'
    },
    {
        'vendor': 'Hyrell Online Hiring Systems',
        'product': 'Hyrell'
    },
    {
        'vendor': 'Hytera Communications Corporation, Ltd.',
        'product': 'Hytera'
    },
    {
        'vendor': 'IQVIA Holdings, Inc.',
        'product': 'IAmetrics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM 3084'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM 3090'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM 3490'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM 3592 Tape Cartridge'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM AIX'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM API Connect'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM AS/400'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM App Connect'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Aspera'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Atlas eDiscovery'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM BDAM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Blockchain Platform'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Bluemix'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Blueworks Live'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Business Automation Workflow'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Business Process Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM CICS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Case Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Clinical Development'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Application Performance Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Brokerage Managed Services'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud IAM Services'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Kubernetes Service'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Object Storage'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Orchestrator'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Paks'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Platform'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Private'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Services'
    },
    {
        'vendor': 'IBM Watson Media',
        'product': 'IBM Cloud Video'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloudant'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos 10'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos 8 Business Intelligence'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos 9'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Analytics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Controller'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Express'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos FSR'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Impromptu'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Insight'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Integration Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cognos Series 7'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Comergent'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Commerce on Cloud'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Configure, Price, Quote'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Content Collector'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Content Foundation'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Content Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Content Manager OnDemand'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Content Manager for iSeries'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Control Desk'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Counter Fraud Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM CustomerInsight'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DFHSM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DFSMS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS3400'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS3500'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS4300'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS4800'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS5000'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS5020'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DS8000'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Data Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Data Warehouse'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DataMirror'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DataPower Gateway'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM DataStage'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Datacap'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 Analytics Accelerator'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 Big SQL'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 Connect'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 Content Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 Database'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 Hosted'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Db2 for z/OS Operating System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ES/9000'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ESS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Emptoris Contract Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Emptoris Program Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Emptoris Sourcing'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Emptoris Spend Analysis'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Emptoris Supplier Lifecycle Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Enterprise Business Servers'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ExperienceOne'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM FileNet Business Process Framework'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM FileNet Content Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM FileNet Image Services'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM FileNet P8'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM FlashSystem'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Gentran'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Global Process Services'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM HACP'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM HR solutions'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM HTTP Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Hybrid Cloud'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM IEBCOPY'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ILOG'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM IMS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ISPF'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ISS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Impact Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Incentive Compensation Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere BigInsights'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Change Data Capture'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Federation Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Identity Insight'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Information Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Master Data Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Optim'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Patient Hub'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Platform'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere QualityStage'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Streams'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM InfoSphere Warehouse'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Information Governance Catalog (IGC)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Informix'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Informix Genero'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Initiate Master Data Service'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Integrated Analytics System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM JES2'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Kenexa Talent Acquisition Suite'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM LTO Ultrium Data Cartridges'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'IBM Laptop'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM LinuxONE'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Lotus Notes'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Lotus Symphony'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM MQ'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM MaaS360'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Mainframe'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM MarketScan Research Databases'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'IBM Marketing Operations OnDemand'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Maximo'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Mobile Foundation'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM MobileFirst'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM N Series Arrays'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Netcool Network Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Netcool/Portal'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Netezza'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Netezza 100'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Netezza 1000'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Netezza Replication Services'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Network Attached Storage (NAS)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM OpenPages'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Operational Decision Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Order Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PC'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM POWER Systems'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM POWER5'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM POWER6'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM POWER7 Systems'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM POWER8 Systems'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM POWER9 Systems'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Phytel'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Planning Analytics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Power System AC922'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PowerAI Enterprise'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PowerHA'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PowerVC'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PowerVM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM ProtecTIER'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Proventia'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PureApplication System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PureData System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM PureFlex System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM QRadar'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM QRadar SIEM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM QRadar Vulnerability Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM QSAM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM RACF'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Application Developer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Asset Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Build Forge'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Change'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational ClearCase'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational ClearQuest'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational DOORS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Developer for i'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Functional Tester'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Method Composer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Performance Tester'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Publishing Engine'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Quality Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational RequisitePro'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Robot'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Rose'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Software Architect'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Software Architect Designer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Software Modeler'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Synergy'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Team Concert'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Test RealTime'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Test Workbench'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Rational Unified Process'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Red Brick'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Resilient'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SAN Volume Controller'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SMP/E'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SPSS Advanced Statistics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SPSS Modeler'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SPSS Statistics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Scale Out Network Attach Storage (SONAS)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Access Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Directory Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Guardium'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Identity Governance and Intelligence'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Identity Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Key Lifecycle Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security Privileged Identity Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Security zSecure'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Service Delivery Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Smart Analytics System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Smarter Workforce'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SoftLayer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM SoftLayer Hosting'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Archive'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Computing'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Conductor'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Control'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum LSF'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Protect'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Scale'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Symphony'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Always In Stock'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling B2B Integrator'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling CPQ'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Commerce'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Control Center'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling File Gateway'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Gentran'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Managed File Transfer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Order Management'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Secure File Transfer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Secure Proxy'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Sterling Selling and Fulfillment Suite'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Storage Area Network (SAN)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM StoredIQ'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Storwize'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM StrongLoop'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage DCS3200'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage DCS3700'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage DS4700 Express'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage Disk Systems'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage SAN Volume Controller (SVC)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage Tape Drives'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System Storage Tape Libraries'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System i'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System i Midrange Computing Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System p Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System z Mainframe'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM System z13'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM TRIRIGA'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM TS1140'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM TS4500 Tape Library'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM TS7760 Virtual Tape Library'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tape Systems'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tape Systems TS3500'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tealeaf'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Telelogic System Architect'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli AF/OPERATOR on z/OS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Access Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Application Dependency Discovery Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Asset Management for IT'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Compliance Insight Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Composite Application Manager (ITCAM)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Configuration Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Directory Integrator (TDI)'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Enterprise Console'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Federated Identity Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Identity Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli License Compliance Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Management Framework'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Monitoring'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Netcool Configuration Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Netcool Performance Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Netcool/Impact'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Netcool/Reporter'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Netcool/Webtop'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli OMEGAMON'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Output Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Performance Analyzer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Provisioning Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Remote Control'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Security Operations Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Service Automation Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Service Level Advisor'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM TotalStorage'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM UrbanCode Deploy'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM VSAM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM VTAM'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Varicent'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Analytics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Assistant'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Campaign Automation'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Content Analytics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Customer Experience Analytics'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Discovery'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Explorer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Health'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson IoT'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Knowledge Studio'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Machine Learning'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Marketing'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Marketing Insights'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Personality Insights'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Speech-to-Text'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Studio'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Supply Chain'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Tone Analyzer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Watson Visual Recognition'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Application Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Business Integration'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Business Modeler'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Cast Iron Cloud'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Data Interchange'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere ILOG JRules'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Message Broker'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Presence Server'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Transformation Extender'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Virtual Enterprise'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM WebSphere Voice Response for AIX'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Websphere Extreme Scale'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Websphere MQ'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Worklight'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Workload Deployer'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM XIV'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Z Workload Scheduler'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM dashDB'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM i'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM i2 Analyze'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM iX'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM z/OS Data Set Mobility Facility'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM z/OS Operating System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM z/TPF Operating System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM z/VM Operating System'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM z/VSE Operating System'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'IBS Core Platform'
    },
    {
        'vendor': 'ICANotes, LLC',
        'product': 'ICANotes'
    },
    {
        'vendor': 'ICONICS, Inc.',
        'product': 'ICONICS'
    },
    {
        'vendor': 'ID GmbH & Company KGaA',
        'product': 'ID DIACOS'
    },
    {
        'vendor': 'ID Dataweb, Inc.',
        'product': 'ID DataWeb'
    },
    {
        'vendor': 'ID Logistics',
        'product': 'ID Logistics'
    },
    {
        'vendor': 'ID Business Solutions, Ltd.',
        'product': 'IDBS ActivityBase'
    },
    {
        'vendor': 'ID Business Solutions, Ltd.',
        'product': 'IDBS E-Workbook'
    },
    {
        'vendor': 'IDC Research, Inc.',
        'product': 'IDC'
    },
    {
        'vendor': 'GeoComply Solutions, Inc.',
        'product': 'IDComply'
    },
    {
        'vendor': 'IDEMIA',
        'product': 'IDEMIA Identity & Security'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'IDaptive'
    },
    {
        'vendor': 'Integrated Decisions and Systems, Inc.',
        'product': 'IDeaS'
    },
    {
        'vendor': 'IELO Group',
        'product': 'IELO-LIAZO'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS (Unspecified Product)'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Applications'
    },
    {
        'vendor': 'IFS Enterprises, LLC',
        'product': 'IFS Core'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Engineering'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Field Service Management'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Financials'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Maintenance'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Manufacturing'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Projects'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Sales & Service'
    },
    {
        'vendor': 'IFS AB',
        'product': 'IFS Supply Chain'
    },
    {
        'vendor': 'IFTTT, Inc.',
        'product': 'IFTTT'
    },
    {
        'vendor': 'IGEL Technology GmbH',
        'product': 'IGEL (Unspecified Product)'
    },
    {
        'vendor': 'IGEL Technology GmbH',
        'product': 'IGEL Endpoints'
    },
    {
        'vendor': 'IGEL Technology GmbH',
        'product': 'IGEL OS'
    },
    {
        'vendor': 'IGEL Technology GmbH',
        'product': 'IGEL UD3'
    },
    {
        'vendor': 'IGEL Technology GmbH',
        'product': 'IGEL Universal Management Suite'
    },
    {
        'vendor': 'IHS Markit, Ltd.',
        'product': 'IHS Markit (Unspecified Product)'
    },
    {
        'vendor': 'IHS Markit, Ltd.',
        'product': 'IHS MarkitSERV FX'
    },
    {
        'vendor': 'ILIAS open source e-Learning e.V.',
        'product': 'ILIAS'
    },
    {
        'vendor': 'IMAGINiT Technologies',
        'product': 'IMAGINiT Clarity'
    },
    {
        'vendor': 'IMS MAXIMS',
        'product': 'IMS MAXIMS'
    },
    {
        'vendor': 'Internap Corporation',
        'product': 'INAP'
    },
    {
        'vendor': 'Internap Corporation',
        'product': 'INAP CDN'
    },
    {
        'vendor': 'Internap Corporation',
        'product': 'INAP DNS'
    },
    {
        'vendor': 'Internap Corporation',
        'product': 'INAP Hosting'
    },
    {
        'vendor': 'INAZ S.R.L.',
        'product': 'INAZ Paghe'
    },
    {
        'vendor': 'Infinitt Healthcare Company, Ltd.',
        'product': 'INFINITT'
    },
    {
        'vendor': 'INTUO N.V.',
        'product': 'INTUO Learn'
    },
    {
        'vendor': 'INXPO, Inc.',
        'product': 'INXPO'
    },
    {
        'vendor': 'Ciox Health',
        'product': 'IOD PRISM'
    },
    {
        'vendor': 'IP Infusion',
        'product': 'IP Infusion'
    },
    {
        'vendor': 'Ipro Tech, LLC',
        'product': 'IPRO ADD'
    },
    {
        'vendor': 'IPsoft, Inc.',
        'product': 'IPcenter'
    },
    {
        'vendor': 'IQMS',
        'product': 'IQMS'
    },
    {
        'vendor': 'swipx ApS',
        'product': 'IQN Compass VMS'
    },
    {
        'vendor': 'IQVIA Holdings, Inc.',
        'product': 'IQVIA CORE'
    },
    {
        'vendor': 'Media Cybernetics, Inc.',
        'product': 'IQbase'
    },
    {
        'vendor': 'Innovative Routines International, Inc.',
        'product': 'IRI CoSort'
    },
    {
        'vendor': 'TechGenix, Ltd.',
        'product': 'ISA Web Publishing Load Balancer'
    },
    {
        'vendor': 'Isebox, Ltd.',
        'product': 'ISEBOX'
    },
    {
        'vendor': 'ISGN Corporation',
        'product': 'ISGN LoanDynamix'
    },
    {
        'vendor': 'ISGN Corporation',
        'product': 'ISGN MORvision'
    },
    {
        'vendor': 'ISGUS America, LLC',
        'product': 'ISGUS Zeus'
    },
    {
        'vendor': 'ISN Software Corporation',
        'product': 'ISNetworld'
    },
    {
        'vendor': 'ISPRIME, LLC',
        'product': 'ISPRIME'
    },
    {
        'vendor': 'IT Glue',
        'product': 'IT Glue'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'IT Process Automation Manager'
    },
    {
        'vendor': 'ION Investment Group, Ltd.',
        'product': 'IT2'
    },
    {
        'vendor': 'Global Portfolio Solutions, s.l.',
        'product': 'ITM Platform'
    },
    {
        'vendor': '4me, Inc.',
        'product': 'ITRP'
    },
    {
        'vendor': 'ITarian, LLC',
        'product': 'ITarian'
    },
    {
        'vendor': 'Determine, Inc.',
        'product': 'Iasta'
    },
    {
        'vendor': 'Iatric Systems, Inc.',
        'product': 'Iatric Security Audit Manager'
    },
    {
        'vendor': 'Meltwater News US, Inc.',
        'product': 'IceRocket'
    },
    {
        'vendor': 'IceWarp, Inc.',
        'product': 'IceWarp'
    },
    {
        'vendor': 'ICEFLO, Ltd.',
        'product': 'Iceflo'
    },
    {
        'vendor': 'Icertis, Inc.',
        'product': 'Icertis'
    },
    {
        'vendor': 'Icinga GmbH',
        'product': 'Icinga'
    },
    {
        'vendor': 'Iconixx Software Corporation',
        'product': 'Iconixx'
    },
    {
        'vendor': 'Iconosquare',
        'product': 'Iconosquare'
    },
    {
        'vendor': 'IdeaScale',
        'product': 'IdeaScale'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'IdenTrust'
    },
    {
        'vendor': 'Identify3D, Inc.',
        'product': 'Identify3D'
    },
    {
        'vendor': 'IdentityMind Global, Inc.',
        'product': 'IdentityMind'
    },
    {
        'vendor': 'Daon, Inc.',
        'product': 'IdentityX'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'Idera DB Change Manager'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'Idera SQL Comparison Toolset'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'Idera SQL Diagnostic Manager'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'Idera SQL Safe Backup'
    },
    {
        'vendor': 'IGLOO, Inc.',
        'product': 'Igloo Software'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'Ignite ObjectStore'
    },
    {
        'vendor': 'IgnitionOne, Inc.',
        'product': 'IgnitionOne'
    },
    {
        'vendor': 'Iguazio, Ltd.',
        'product': 'Iguazio'
    },
    {
        'vendor': 'Illumio, Inc.',
        'product': 'Illumio'
    },
    {
        'vendor': 'Illusive Networks, Ltd.',
        'product': 'Illusive'
    },
    {
        'vendor': 'Image Relay, LLC',
        'product': 'Image Relay'
    },
    {
        'vendor': 'SecureDAM, Inc.',
        'product': 'ImageFolio'
    },
    {
        'vendor': 'Media Cybernetics, Inc.',
        'product': 'ImagePro'
    },
    {
        'vendor': 'Weld North Education, LLC',
        'product': 'Imagine Learning'
    },
    {
        'vendor': 'Model N, Inc.',
        'product': 'Imany'
    },
    {
        'vendor': 'Immuta, Inc.',
        'product': 'Immuta'
    },
    {
        'vendor': 'PAREXEL International Corporation',
        'product': 'Impact CTMS'
    },
    {
        'vendor': 'Impact Tech, Inc.',
        'product': 'Impact Radius'
    },
    {
        'vendor': 'Impartner, Inc.',
        'product': 'Impartner PRM'
    },
    {
        'vendor': 'Imperva, Inc.',
        'product': 'Imperva'
    },
    {
        'vendor': 'Imperva, Inc.',
        'product': 'Imperva Web Application Firewall'
    },
    {
        'vendor': 'Imply Data, Inc.',
        'product': 'Imply Data'
    },
    {
        'vendor': 'Impos',
        'product': 'Impos'
    },
    {
        'vendor': 'Imprivata, Inc.',
        'product': 'Imprivata (Unspecified Product)'
    },
    {
        'vendor': 'Imprivata, Inc.',
        'product': 'Imprivata Cortext'
    },
    {
        'vendor': 'Covetrus, Inc.',
        'product': 'Impromed'
    },
    {
        'vendor': 'Awio Web Services, LLC',
        'product': 'Improvely'
    },
    {
        'vendor': 'OPSWAT, Inc.',
        'product': 'Impulse Point'
    },
    {
        'vendor': 'Cognex Corporation',
        'product': 'In-Sight Vision'
    },
    {
        'vendor': 'InDemand Interpreting',
        'product': 'InDemand Interpreting'
    },
    {
        'vendor': 'InEight, Inc.',
        'product': 'InEight Control'
    },
    {
        'vendor': 'InEight, Inc.',
        'product': 'InEight DOC'
    },
    {
        'vendor': 'InEight, Inc.',
        'product': 'InEight Estimate'
    },
    {
        'vendor': 'InEight, Inc.',
        'product': 'InEight SCH'
    },
    {
        'vendor': 'InLoox, Inc.',
        'product': 'InLoox'
    },
    {
        'vendor': 'InMobi Pte Ltd',
        'product': 'InMobi'
    },
    {
        'vendor': 'InMoment, Inc.',
        'product': 'InMoment'
    },
    {
        'vendor': 'InMotion Hosting, Inc.',
        'product': 'InMotion Hosting'
    },
    {
        'vendor': 'Morse Data Corporation',
        'product': 'InOrder ERP'
    },
    {
        'vendor': 'InPracSys',
        'product': 'InPracSys'
    },
    {
        'vendor': 'InStar Systems',
        'product': 'InStar RIS'
    },
    {
        'vendor': 'Insync Healthcare Solutions, LLC',
        'product': 'InSync Healthcare'
    },
    {
        'vendor': 'InTouch Technologies, Inc.',
        'product': 'InTouch Health'
    },
    {
        'vendor': 'Intouch Insight, Inc.',
        'product': 'InTouch Insight'
    },
    {
        'vendor': 'InVisionApp, Inc.',
        'product': 'InVision'
    },
    {
        'vendor': 'Inbox25',
        'product': 'Inbox25'
    },
    {
        'vendor': 'Imperva, Inc.',
        'product': 'Incapsula'
    },
    {
        'vendor': 'Incorta, Inc.',
        'product': 'Incorta'
    },
    {
        'vendor': 'Indeed, Inc.',
        'product': 'Indeed for Employers'
    },
    {
        'vendor': 'Indeni, Ltd.',
        'product': 'Indeni'
    },
    {
        'vendor': 'IndigoVision Group PLC',
        'product': 'IndigoVision'
    },
    {
        'vendor': 'Inductive Automation, LLC',
        'product': 'Inductive Automation'
    },
    {
        'vendor': 'Inductive Automation, LLC',
        'product': 'Inductive Automation Ignition'
    },
    {
        'vendor': 'IndustrySafe, Inc.',
        'product': 'IndustrySafe'
    },
    {
        'vendor': 'Inedo, LLC',
        'product': 'Inedo BuildMaster'
    },
    {
        'vendor': 'InetSoft Technology Corporation',
        'product': 'InetSoft'
    },
    {
        'vendor': 'InetSoft Technology Corporation',
        'product': 'InetSoft Style Intelligence'
    },
    {
        'vendor': 'Infinedi, LLC',
        'product': 'Infinedi'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Infinera'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Infinera 7100 Nano'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Infinera DTN'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Infinera DTN-X Family'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Infinera XTC-10'
    },
    {
        'vendor': 'Infinera Corporation',
        'product': 'Infinera XTC-4'
    },
    {
        'vendor': 'Infinidat, Inc.',
        'product': 'InfiniBox'
    },
    {
        'vendor': 'Cal Pont',
        'product': 'InfiniDB'
    },
    {
        'vendor': 'Infinidat, Inc.',
        'product': 'Infinidat'
    },
    {
        'vendor': 'Infinisource, Inc.',
        'product': 'Infinisource'
    },
    {
        'vendor': 'Infinite Blue Platform, LLC',
        'product': 'Infinite Blue'
    },
    {
        'vendor': 'Infinite Campus, Inc.',
        'product': 'Infinite Campus'
    },
    {
        'vendor': 'Infinity Tracking, Ltd.',
        'product': 'Infinity Tracking'
    },
    {
        'vendor': 'InfinityQS International, Inc.',
        'product': 'InfinityQS'
    },
    {
        'vendor': 'Inflectra Corporation',
        'product': 'Inflectra'
    },
    {
        'vendor': 'Influenster, Inc.',
        'product': 'Influenster'
    },
    {
        'vendor': 'Influitive Corporation',
        'product': 'Influitive'
    },
    {
        'vendor': 'InfluxData, Inc.',
        'product': 'InfluxDB'
    },
    {
        'vendor': 'Info-Tech Systems Integrators Pte Ltd',
        'product': 'Info-Tech Systems Integrators'
    },
    {
        'vendor': 'InfoExpress, Inc.',
        'product': 'InfoExpress'
    },
    {
        'vendor': 'Carmel Vision Canada, Inc.',
        'product': 'InfoFlo'
    },
    {
        'vendor': 'InfoGlue',
        'product': 'InfoGlue'
    },
    {
        'vendor': 'InfoMedix Pty Ltd',
        'product': 'InfoMedix'
    },
    {
        'vendor': 'EPAM Systems, Inc.',
        'product': 'InfoNgen'
    },
    {
        'vendor': 'InfoTronics, Inc.',
        'product': 'InfoTronics'
    },
    {
        'vendor': 'InfoVista SAS',
        'product': 'InfoVista'
    },
    {
        'vendor': 'InfoWatch Group',
        'product': 'InfoWatch'
    },
    {
        'vendor': 'Infobip, Ltd.',
        'product': 'Infobip'
    },
    {
        'vendor': 'Infoblox, Inc.',
        'product': 'Infoblox (Unspecified Product)'
    },
    {
        'vendor': 'Infoblox, Inc.',
        'product': 'Infoblox BloxOne'
    },
    {
        'vendor': 'Infoblox, Inc.',
        'product': 'Infoblox DDI'
    },
    {
        'vendor': 'Infoblox, Inc.',
        'product': 'Infoblox DHCP'
    },
    {
        'vendor': 'Infoblox, Inc.',
        'product': 'Infoblox DNS'
    },
    {
        'vendor': 'Infoblox, Inc.',
        'product': 'Infoblox DTC'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'Infobright DB'
    },
    {
        'vendor': 'Infogix, Inc.',
        'product': 'Infogix'
    },
    {
        'vendor': 'Infohos Services CVBA',
        'product': 'Infohos Apotheek'
    },
    {
        'vendor': 'Infoland B.V.',
        'product': 'Infoland iProva'
    },
    {
        'vendor': 'Infolinks, Inc.',
        'product': 'Infolinks'
    },
    {
        'vendor': 'INFOMEDIKA, Inc.',
        'product': 'Infomedika Evolution EHR'
    },
    {
        'vendor': 'Infoodle, Ltd.',
        'product': 'Infoodle'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Birst'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite CRM'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Configure Price Quote'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Distribution'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Enterprise Asset Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Enterprise Asset Management (EAM)'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Expense Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Field Service'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Financials'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite HCM'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite HCM Payroll'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Industrial'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite PLM'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Public Sector'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite SCM'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite WMS'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor CloudSuite Workforce Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Cloverleaf Integration Suite'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Construction'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Customer Experience Suite'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Demand Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Distribution'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Distribution SX.e'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Dynamic Enterprise Performance Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor ERP A+'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor ERP LN'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Expense Management Travel Plans'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor EzRMS'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Global Human Resources'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor HR Service Delivery'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Hospitality Management Solution (HMS)'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Intelligent Open Network (ION)'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor LMS'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor LX'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor M3'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor MP2'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Marketing Resource Management (MRM)'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Ming.le'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Nexus'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Nexus Transportation Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor OS'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Omni-Channel Campaign Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor POS'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor PeopleAnswers'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Product Lifecycle Management (PLM)'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Risk & Compliance'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor SalesLogix'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor SmartStream'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor SunSystems'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Supply Chain Finance'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Supply Chain Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Supply Chain Visibility'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Supply Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Talent Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Talent Science'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor VISUAL'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Workforce Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor XA'
    },
    {
        'vendor': 'ID Business Solutions, Ltd.',
        'product': 'InforSense'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Axon Data Governance'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica B2B Data Exchange'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Business Process Management'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Cloud'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Cloud API and Application Integration'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Cloud Data Integration'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Cloud Data Quality'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Cloud Integration Hub'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Archive'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Masking'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Privacy Management'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Quality'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Replication'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Services'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Subset'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data Warehouse Advisor'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Data as a Service'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Enterprise Data Catalog'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica ILM Nearline'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Intelligent Cloud Services (IICS)'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Master Data Management'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica PowerCenter'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica PowerExchange'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica RulePoint'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Ultra Messaging'
    },
    {
        'vendor': 'Information Builders, Inc.',
        'product': 'Information Builders (Unspecified Product)'
    },
    {
        'vendor': 'Information Builders, Inc.',
        'product': 'Information Builders WebFOCUS'
    },
    {
        'vendor': 'Infortrend Technology, Inc.',
        'product': 'Infortrend'
    },
    {
        'vendor': 'Infortrend Technology, Inc.',
        'product': 'Infortrend EonStor'
    },
    {
        'vendor': 'IQVIA Holdings, Inc.',
        'product': 'Infosario'
    },
    {
        'vendor': 'EdgeVerve Systems, Ltd.',
        'product': 'Infosys Finacle'
    },
    {
        'vendor': 'EdgeVerve Systems, Ltd.',
        'product': 'Infosys Nia'
    },
    {
        'vendor': 'Infoworks.io, Inc.',
        'product': 'Infoworks'
    },
    {
        'vendor': 'Infragistics, Inc.',
        'product': 'Infragistics'
    },
    {
        'vendor': 'Inframark, LLC',
        'product': 'Inframark'
    },
    {
        'vendor': 'Infrascale, Inc.',
        'product': 'Infrascale'
    },
    {
        'vendor': 'Keap',
        'product': 'Infusionsoft'
    },
    {
        'vendor': 'Ingenico Group S.A.',
        'product': 'Ingenico'
    },
    {
        'vendor': 'Ingenico Group S.A.',
        'product': 'Ingenico iCT 220'
    },
    {
        'vendor': 'Ingenious Med, Inc.',
        'product': 'Ingenious Med'
    },
    {
        'vendor': 'Ingeniux Corporation',
        'product': 'Ingeniux'
    },
    {
        'vendor': 'Forth Metrics, Ltd.',
        'product': 'Inkybee'
    },
    {
        'vendor': 'Lucidea Corporation',
        'product': 'Inmagic'
    },
    {
        'vendor': 'Inmar, Inc.',
        'product': 'Inmar Supply Chain'
    },
    {
        'vendor': 'InnQuest Software Corporation',
        'product': 'InnQuest RoomMaster'
    },
    {
        'vendor': 'Innosoft Canada, Inc.',
        'product': 'InnoSoft Fusion'
    },
    {
        'vendor': 'CPA Global, Ltd.',
        'product': 'Innography'
    },
    {
        'vendor': 'Innovartis, Ltd.',
        'product': 'Innovartis DB Ghost'
    },
    {
        'vendor': 'Innovid, Inc.',
        'product': 'Innovid'
    },
    {
        'vendor': 'Innovyze, Inc.',
        'product': 'Innovyze'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Innowera Process Runner'
    },
    {
        'vendor': 'Inovonics Wireless Corporation',
        'product': 'Inovonics'
    },
    {
        'vendor': 'ICS Learning Group, Inc.',
        'product': 'Inquisiq LMS'
    },
    {
        'vendor': 'InsideView, Inc.',
        'product': 'InsideView'
    },
    {
        'vendor': 'Clinicient, Inc.',
        'product': 'Insight EMR'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'InsightIDR'
    },
    {
        'vendor': 'InsightSquared, Inc.',
        'product': 'InsightSquared'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'InsightVM'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Insightera'
    },
    {
        'vendor': 'Insightly, Inc.',
        'product': 'Insightly'
    },
    {
        'vendor': 'Insite Software Solutions, Inc.',
        'product': 'InsiteCommerce'
    },
    {
        'vendor': 'Kong, Inc.',
        'product': 'Insomnia'
    },
    {
        'vendor': 'inspHire, Ltd.',
        'product': 'InspHire'
    },
    {
        'vendor': 'Inspectlet',
        'product': 'Inspectlet'
    },
    {
        'vendor': 'Insperity, Inc.',
        'product': 'Insperity'
    },
    {
        'vendor': 'Inspirata, Inc.',
        'product': 'Inspirata (Unspecified Product)'
    },
    {
        'vendor': 'Inspirata, Inc.',
        'product': 'Inspirata Data Aggregation Platform'
    },
    {
        'vendor': 'Inspur Group',
        'product': 'Inspur'
    },
    {
        'vendor': 'InstaMed Communications, LLC',
        'product': 'InstaMed'
    },
    {
        'vendor': 'Instabase, Inc.',
        'product': 'Instabase'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Instagram'
    },
    {
        'vendor': 'Instagress',
        'product': 'Instagress'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'InstallAnywhere'
    },
    {
        'vendor': 'Revenera',
        'product': 'InstallShield'
    },
    {
        'vendor': 'Instana, Inc.',
        'product': 'Instana'
    },
    {
        'vendor': 'Instapage, Inc.',
        'product': 'Instapage'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Instart Logic'
    },
    {
        'vendor': 'Insurance Information Technologies Inc.',
        'product': 'Instec'
    },
    {
        'vendor': 'Instructure, Inc.',
        'product': 'Instructure'
    },
    {
        'vendor': 'Insurity, Inc.',
        'product': 'Insurity'
    },
    {
        'vendor': 'Sage Intacct, Inc.',
        'product': 'Intacct'
    },
    {
        'vendor': 'Everteam SAS',
        'product': 'Intalio BPMS'
    },
    {
        'vendor': 'Intapp, Inc.',
        'product': 'Intapp'
    },
    {
        'vendor': 'Intapp, Inc.',
        'product': 'Intapp Pricing'
    },
    {
        'vendor': 'Intapp, Inc.',
        'product': 'Intapp Time'
    },
    {
        'vendor': 'Integra Software Systems',
        'product': 'Integra Destiny'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Integration Point'
    },
    {
        'vendor': 'Green Hills Software, Inc.',
        'product': 'Integrity Multivisor'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel (Unspecified Product)'
    },
    {
        'vendor': 'Intel471, Inc.',
        'product': 'Intel 471'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Arria'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Cyclone'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel DCM'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Data Analytics Acceleration Library'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel HyperFlex'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Lustre'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel MAX'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Math Kernel Library'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Media SDK'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Nios'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Quark'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Quartus Prime'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Stratix'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Xeon'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'Intel Xeon Phi'
    },
    {
        'vendor': 'Intelerad Medical Systems, Inc.',
        'product': 'Intelerad'
    },
    {
        'vendor': 'Intelex Technologies, Inc.',
        'product': 'Intelex'
    },
    {
        'vendor': 'InteliChart, LLC',
        'product': 'InteliChart'
    },
    {
        'vendor': 'Businet, LLC',
        'product': 'InteliDOX'
    },
    {
        'vendor': 'Vound Software, LLC',
        'product': 'Intella'
    },
    {
        'vendor': 'Nextech Systems, LLC',
        'product': 'IntelleChartPRO'
    },
    {
        'vendor': 'Intellect, Inc.',
        'product': 'Intellect'
    },
    {
        'vendor': 'Intellect Design Arena, Ltd.',
        'product': 'Intellect Design Arena'
    },
    {
        'vendor': 'intelliAd Media GmbH',
        'product': 'IntelliAd'
    },
    {
        'vendor': 'IntelliChief, LLC',
        'product': 'IntelliChief'
    },
    {
        'vendor': 'IntelliSoft Group, LLC',
        'product': 'IntelliContract'
    },
    {
        'vendor': 'AmerisourceBergen Corporation',
        'product': 'IntelliDoseTxM'
    },
    {
        'vendor': 'Baxter International, Inc.',
        'product': 'IntelliFill I.V.'
    },
    {
        'vendor': 'Western Digital Corporation',
        'product': 'IntelliFlash'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'IntelliJ'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'IntelliJ IDEA'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'IntelliLink'
    },
    {
        'vendor': 'IntelliMagic',
        'product': 'IntelliMagic Vision for z/OS'
    },
    {
        'vendor': 'AmerisourceBergen Corporation',
        'product': 'IntelliOrder'
    },
    {
        'vendor': '24/7 Customer, Inc.',
        'product': 'IntelliResponse'
    },
    {
        'vendor': 'IntelliTrack, Inc.',
        'product': 'IntelliTrack'
    },
    {
        'vendor': 'IntelliTrans, LLC',
        'product': 'IntelliTrans'
    },
    {
        'vendor': 'Intellibot',
        'product': 'Intellibot'
    },
    {
        'vendor': 'Intellicure, Inc.',
        'product': 'Intellicure'
    },
    {
        'vendor': 'KeyPeople AG',
        'product': 'IntelligentBoardroom'
    },
    {
        'vendor': 'Intellimize, Inc.',
        'product': 'Intellimize'
    },
    {
        'vendor': 'Intelliquip, LLC',
        'product': 'Intelliquip'
    },
    {
        'vendor': 'Intense Debate',
        'product': 'Intense Debate'
    },
    {
        'vendor': 'Embarcadero Technologies, Inc.',
        'product': 'InterBase'
    },
    {
        'vendor': 'Intrado Corporation',
        'product': 'InterCall'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'InterMapper'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'InterQual'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'InterSystems'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'InterSystems Cache'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'InterSystems Ensemble'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'InterSystems HealthShare'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'InterSystems IRIS'
    },
    {
        'vendor': 'InterSystems Corporation',
        'product': 'InterSystems TrakCare'
    },
    {
        'vendor': 'Interact Software, Inc.',
        'product': 'Interact'
    },
    {
        'vendor': 'Interactive Brokers, LLC',
        'product': 'Interactive Brokers'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Interactive Intelligence'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Interactive Intelligence Customer Interaction Center (CIC)'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Interactive Intelligence Interaction Dialer'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Interactive Intelligence Interaction Recorder'
    },
    {
        'vendor': 'Interactyx, Ltd.',
        'product': 'Interactyx Topyx'
    },
    {
        'vendor': 'Interbit Data, Inc.',
        'product': 'Interbit Data'
    },
    {
        'vendor': 'Yahoo!',
        'product': 'Interclick'
    },
    {
        'vendor': 'Intercom, Inc.',
        'product': 'Intercom'
    },
    {
        'vendor': 'Interflex Datensysteme GmbH',
        'product': 'Interflex SP-Expert'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'Intergraph'
    },
    {
        'vendor': 'Greenway Health, LLC',
        'product': 'Intergy'
    },
    {
        'vendor': 'Interlace Health',
        'product': 'Interlace Health'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Intermec'
    },
    {
        'vendor': 'Intermedia.net, Inc.',
        'product': 'Intermedia Contact Center'
    },
    {
        'vendor': 'Interroll AG',
        'product': 'Interroll'
    },
    {
        'vendor': 'Intershop Communications AG',
        'product': 'Intershop Commerce Suite'
    },
    {
        'vendor': 'BigCommerce Pty Ltd',
        'product': 'Interspire'
    },
    {
        'vendor': 'Interviewstream, Inc.',
        'product': 'InterviewStream'
    },
    {
        'vendor': 'Intervolve, Inc.',
        'product': 'Intervolve'
    },
    {
        'vendor': 'Interworks S.A.',
        'product': 'Interworks.cloud'
    },
    {
        'vendor': 'Interxion Holding N.V.',
        'product': 'Interxion'
    },
    {
        'vendor': 'Intice, Inc.',
        'product': 'Intice'
    },
    {
        'vendor': 'Intralinks, Inc.',
        'product': 'IntraLinks'
    },
    {
        'vendor': 'IntraNexus',
        'product': 'IntraNexus'
    },
    {
        'vendor': 'IntraNexus',
        'product': 'IntraNexus Allegra'
    },
    {
        'vendor': 'Intradiem, Inc.',
        'product': 'Intradiem'
    },
    {
        'vendor': 'Intrado Corporation',
        'product': 'Intrado (Unspecified Product)'
    },
    {
        'vendor': 'Intricately, Inc.',
        'product': 'Intricately'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Intronis Backup'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Intrusion Detection and Prevention System Management'
    },
    {
        'vendor': 'INTTRA, Inc.',
        'product': 'Inttra'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Intuit Mint'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Intuit Payroll'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Intuit ProSeries'
    },
    {
        'vendor': 'InvGate',
        'product': 'InvGate'
    },
    {
        'vendor': 'TDK Corporation',
        'product': 'InvenSense'
    },
    {
        'vendor': 'NCH Software, Inc.',
        'product': 'Inventoria'
    },
    {
        'vendor': 'Invera, Inc.',
        'product': 'Invera'
    },
    {
        'vendor': 'InvestCloud, Inc.',
        'product': 'InvestCloud'
    },
    {
        'vendor': 'Investor Management Services, LLC',
        'product': 'Investor Management Services'
    },
    {
        'vendor': 'Invoca, Inc.',
        'product': 'Invoca'
    },
    {
        'vendor': 'CoCreativ',
        'product': 'Invodo'
    },
    {
        'vendor': 'Iodine, LLC',
        'product': 'Iodine'
    },
    {
        'vendor': 'ION Investment Group, Ltd.',
        'product': 'Ion City Financials'
    },
    {
        'vendor': 'Thermo Fisher Scientific, Inc.',
        'product': 'Ion GeneStudio S5 Series'
    },
    {
        'vendor': 'ION Investment Group, Ltd.',
        'product': 'Ion ITS'
    },
    {
        'vendor': 'Thermo Fisher Scientific, Inc.',
        'product': 'Ion PGM System'
    },
    {
        'vendor': 'Thermo Fisher Scientific, Inc.',
        'product': 'Ion Proton System'
    },
    {
        'vendor': 'Thermo Fisher Scientific, Inc.',
        'product': 'Ion Torrent'
    },
    {
        'vendor': 'ION Investment Group, Ltd.',
        'product': 'Ion Treasura'
    },
    {
        'vendor': 'Ionic',
        'product': 'Ionic'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Ionix'
    },
    {
        'vendor': '1&1 IONOS, Inc.',
        'product': 'Ionos'
    },
    {
        'vendor': 'iovation, Inc.',
        'product': 'Iovation'
    },
    {
        'vendor': 'Ipro Tech, LLC',
        'product': 'Ipro Eclipse'
    },
    {
        'vendor': 'Ipswitch, Inc.',
        'product': 'Ipswitch WhatsUp Gold'
    },
    {
        'vendor': 'Iptor Supply Chain Systems AB',
        'product': 'Iptor ERP'
    },
    {
        'vendor': 'Iress, Ltd.',
        'product': 'Iress'
    },
    {
        'vendor': 'Iris ID, Inc.',
        'product': 'Iris ID'
    },
    {
        'vendor': 'Iris PR Software',
        'product': 'IrisPR'
    },
    {
        'vendor': 'Iron Bow Technologies, LLC',
        'product': 'Iron Bow Healthcare CLINiC'
    },
    {
        'vendor': 'Iron Mountain, Inc.',
        'product': 'Iron Mountain'
    },
    {
        'vendor': 'Iron Mountain, Inc.',
        'product': 'Iron Mountain SecureSync'
    },
    {
        'vendor': 'Iron Speed, Inc.',
        'product': 'Iron Speed Designer'
    },
    {
        'vendor': 'Ironclad, Inc.',
        'product': 'Ironclad'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'Ironstream'
    },
    {
        'vendor': 'Island Pacific, Inc.',
        'product': 'Island Pacific (Unspecified Product)'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'Isogen'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'Isogen Publisher'
    },
    {
        'vendor': 'Issuetrak, Inc.',
        'product': 'IssueTrak'
    },
    {
        'vendor': 'Issuu, Inc.',
        'product': 'Issuu'
    },
    {
        'vendor': 'Istio Authors',
        'product': 'Istio'
    },
    {
        'vendor': 'Iterable, Inc.',
        'product': 'Iterable'
    },
    {
        'vendor': 'Itineris N.V.',
        'product': 'Itineris UMAX 365'
    },
    {
        'vendor': 'Itron, Inc.',
        'product': 'Itron (Unspecified Product)'
    },
    {
        'vendor': 'Checkmate.com, Inc.',
        'product': 'ItsaCheckmate'
    },
    {
        'vendor': 'IUGU',
        'product': 'Iugu'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Auctions'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Contract Management'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Direct Materials Sourcing'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Invoicing'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Payables'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Procure-to-Pay'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Procurement'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Purchase Orders'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Purchase Requisitions'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Sourcing'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Spend Analysis'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Strategic Sourcing'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Strategy & Analytics'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Supplier Management'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua Travel and Expense'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti (Unspecified Product)'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Asset Manager'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Avalanche'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Environment Manager'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Mobile Security'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Service Desk'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Service Manager'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Unified Endpoint Manager'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti User Workspace Manager'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Workspace Control'
    },
    {
        'vendor': 'Ivinex, LLC',
        'product': 'Ivinex'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Ivona'
    },
    {
        'vendor': 'Ixaris Systems, Ltd.',
        'product': 'Ixaris'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'Ixia'
    },
    {
        'vendor': 'Izenda, Inc.',
        'product': 'Izenda'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'J2EE'
    },
    {
        'vendor': 'Cartrabbit International Pvt Ltd',
        'product': 'J2Store'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Accounts Payable'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Advantage'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Contracts+'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Data Intelligence'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Direct'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Direct eSourcing'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Indirect'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER ONE'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Project Management'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Research Material Management'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Sourcing'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Spend Analytics'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER Supplier Management'
    },
    {
        'vendor': 'JAGGAER, LLC',
        'product': 'JAGGAER eProcurement'
    },
    {
        'vendor': 'JAMF Software, LLC',
        'product': 'JAMF Pro'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'JAMS'
    },
    {
        'vendor': 'JB Developers, Inc.',
        'product': 'JBDev'
    },
    {
        'vendor': 'Open Source',
        'product': 'JBehave'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'JBoss'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'JBoss Enterprise Application Platform'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'JBoss Enterprise BRMS'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'JBoss Enterprise Web Server (EWS)'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'JBoss Seam Framework'
    },
    {
        'vendor': 'Xinox Software',
        'product': 'JCreator'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards (Unspecified Product)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards EnterpriseOne'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards EnterpriseOne Fixed Asset Accounting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards EnterpriseOne One View'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards EnterpriseOne V9'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards Sales Order Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Accounts Payable'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Accounts Receivable'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Advanced Pricing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Expense Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Fixed Asset Accounting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World General Ledger Accounting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Human Resource Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Inventory Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Plant and Equipment Maintenance Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Product Costing/Manufacturing Accounting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Product Data Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Project Costing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Quality Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Real Estate Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Real Homebuilder and Repetitive Builder Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Requirements Planning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Sales Order Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Shop Floor Control'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World US Payroll'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JD Edwards World Warehouse Management'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'JDA'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'JDA Fulfillment'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'JDA Supply Chain Planning'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'JDA Warehouse Management'
    },
    {
        'vendor': 'JFrog, Ltd.',
        'product': 'JFrog'
    },
    {
        'vendor': 'JFrog, Ltd.',
        'product': 'JFrog Artifactory'
    },
    {
        'vendor': 'JFrog, Ltd.',
        'product': 'JFrog Bintray'
    },
    {
        'vendor': 'JFrog, Ltd.',
        'product': 'JFrog Mission Control'
    },
    {
        'vendor': 'JFrog, Ltd.',
        'product': 'JFrog Xray'
    },
    {
        'vendor': 'JGSullivan Interactive, Inc.',
        'product': 'JGSullivan'
    },
    {
        'vendor': 'JIDE Software, Inc.',
        'product': 'JIDE'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'JIRA Agile'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'JMP'
    },
    {
        'vendor': 'Open Source',
        'product': 'JMockit'
    },
    {
        'vendor': 'JNetDirect, Inc.',
        'product': 'JNetDirect'
    },
    {
        'vendor': 'Applied Computer Systems, Inc.',
        'product': 'JOBPOWER'
    },
    {
        'vendor': 'JOBPROGRESS, LLC',
        'product': 'JOBPROGRESS'
    },
    {
        'vendor': 'Open Source',
        'product': 'JORAM'
    },
    {
        'vendor': 'JRNI, Ltd.',
        'product': 'JRNI'
    },
    {
        'vendor': 'Logi Analytics, Inc.',
        'product': 'JReport'
    },
    {
        'vendor': 'JavaScript Kit',
        'product': 'JS-Kit'
    },
    {
        'vendor': 'JSCAPE, LLC',
        'product': 'JSCAPE'
    },
    {
        'vendor': 'JTB World, Inc.',
        'product': 'JTB FlexReport'
    },
    {
        'vendor': 'JTL Software GmbH',
        'product': 'JTL-Shop'
    },
    {
        'vendor': 'JW Player',
        'product': 'JW Player'
    },
    {
        'vendor': 'Jabmo, Inc.',
        'product': 'Jabmo'
    },
    {
        'vendor': 'Jabra Corporation',
        'product': 'Jabra Headsets'
    },
    {
        'vendor': 'Jacada, Inc.',
        'product': 'Jacada'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'Jack Henry & Associates'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'Jack Henry & Associates Silverlake'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'Jack Henry Yellow Hammer'
    },
    {
        'vendor': 'Software AG',
        'product': 'JackBe'
    },
    {
        'vendor': 'Jackrabbit Technologies, Inc.',
        'product': 'Jackrabbit'
    },
    {
        'vendor': 'JacqCAD International',
        'product': 'JacqCAD'
    },
    {
        'vendor': 'Jadu, Ltd.',
        'product': 'Jadu'
    },
    {
        'vendor': 'Uber Technologies, Inc.',
        'product': 'Jaeger'
    },
    {
        'vendor': 'ID Logistics',
        'product': 'Jagged Peak EDGE'
    },
    {
        'vendor': 'Jahia Solutions Group S.A.',
        'product': 'Jahia'
    },
    {
        'vendor': 'Global Public Safety',
        'product': 'JailTracker'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Jakarta EE'
    },
    {
        'vendor': 'Jama Software, Inc.',
        'product': 'Jama Contour'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Jamboard'
    },
    {
        'vendor': 'JAMIS Software Corporation',
        'product': 'Jamis'
    },
    {
        'vendor': 'JangoMail, LLC',
        'product': 'JangoMail'
    },
    {
        'vendor': 'Janrain, Inc.',
        'product': 'Janrain'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Jasmine'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Java'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Java SE'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'JavaScript'
    },
    {
        'vendor': 'Hireku, Inc.',
        'product': 'Jazz HR'
    },
    {
        'vendor': 'JazzHR',
        'product': 'JazzHR'
    },
    {
        'vendor': 'Jedox AG',
        'product': 'Jedox'
    },
    {
        'vendor': 'Jeeves Information Systems AB',
        'product': 'Jeeves ERP'
    },
    {
        'vendor': 'Jelastic, Inc.',
        'product': 'Jelastic'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Jenkins'
    },
    {
        'vendor': 'Jenzabar, Inc.',
        'product': 'Jenzabar'
    },
    {
        'vendor': 'Jeron Electronic Systems, Inc.',
        'product': 'Jeron Electronic'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Jest'
    },
    {
        'vendor': 'Jet-Stream Services B.V.',
        'product': 'Jet-Stream'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'JetBrains'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'JetBrains PhpStorm'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'JetBrains PyCharm'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'JetBrains ReSharper'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'JetBrains RubyMine'
    },
    {
        'vendor': 'Jetpack',
        'product': 'Jetpack'
    },
    {
        'vendor': 'Open Source',
        'product': 'Jetty'
    },
    {
        'vendor': 'Jibestream, Inc.',
        'product': 'Jibestream'
    },
    {
        'vendor': 'Jifflenow',
        'product': 'Jifflenow'
    },
    {
        'vendor': 'Happen Business Pty Ltd',
        'product': 'Jim2'
    },
    {
        'vendor': 'Jimdo GmbH',
        'product': 'Jimdo'
    },
    {
        'vendor': 'Jimdo GmbH',
        'product': 'Jimdo Hosting'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'Jira Align'
    },
    {
        'vendor': 'Jitbit Software',
        'product': 'Jitbit'
    },
    {
        'vendor': 'Jitterbit, Inc.',
        'product': 'Jitterbit'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'Jive Communications'
    },
    {
        'vendor': 'Aurea, Inc.',
        'product': 'Jive Software'
    },
    {
        'vendor': 'VISUS Health IT GmbH',
        'product': 'JiveX Enterprise PACS'
    },
    {
        'vendor': 'JivoSite, Inc.',
        'product': 'JivoChat'
    },
    {
        'vendor': 'Jivox Corporation',
        'product': 'Jivox'
    },
    {
        'vendor': 'Job Adder Operations Pty Ltd',
        'product': 'JobAdder'
    },
    {
        'vendor': 'ECi Software Solutions, Inc.',
        'product': 'JobBOSS'
    },
    {
        'vendor': 'JobDiva, Inc.',
        'product': 'JobDiva'
    },
    {
        'vendor': 'JobNimbus, LLC',
        'product': 'JobNimbus'
    },
    {
        'vendor': 'Jobber Software',
        'product': 'Jobber'
    },
    {
        'vendor': 'Tracer Management Systems, Ltd.',
        'product': 'Joblogic'
    },
    {
        'vendor': 'Bullhorn, Inc.',
        'product': 'Jobscience'
    },
    {
        'vendor': 'Jobscope',
        'product': 'Jobscope ERP'
    },
    {
        'vendor': 'JobScore, Inc.',
        'product': 'Jobscore'
    },
    {
        'vendor': 'Jobvite, Inc.',
        'product': 'Jobvite'
    },
    {
        'vendor': 'Johnson Controls PLC',
        'product': 'Johnson Controls Metasys'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'Join.Me'
    },
    {
        'vendor': 'Jolly Giant Software, Inc.',
        'product': 'Jolly Giant'
    },
    {
        'vendor': 'Intuiplan, LLC',
        'product': 'Jolt'
    },
    {
        'vendor': 'Jonas Construction Software, Inc.',
        'product': 'Jonas Construction'
    },
    {
        'vendor': 'JONOVA, Inc.',
        'product': 'Jonova'
    },
    {
        'vendor': 'Joomag, Inc.',
        'product': 'Joomag'
    },
    {
        'vendor': 'Open Source Matters, Inc.',
        'product': 'Joomla!'
    },
    {
        'vendor': 'JotForm, Inc.',
        'product': 'Jotform'
    },
    {
        'vendor': 'Journal Technologies',
        'product': 'Journal Technologies'
    },
    {
        'vendor': 'Journyx, Inc.',
        'product': 'Journyx'
    },
    {
        'vendor': 'Joyent, Inc.',
        'product': 'Joyent'
    },
    {
        'vendor': 'Joyent, Inc.',
        'product': 'Joyent Hosting'
    },
    {
        'vendor': 'JROX Technologies, Inc.',
        'product': 'Jrox'
    },
    {
        'vendor': 'Canonical, Ltd.',
        'product': 'Juju'
    },
    {
        'vendor': 'Jumio Corporation',
        'product': 'Jumio'
    },
    {
        'vendor': 'JumpCloud, Inc.',
        'product': 'JumpCloud'
    },
    {
        'vendor': 'Widetail Lda.',
        'product': 'Jumpseller'
    },
    {
        'vendor': 'Jungle Disk, LLC',
        'product': 'Jungle Disk'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks (Unspecified Product)'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks ACX-Series Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks Contrail'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks E-Series Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks EX-Series Switches'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks EX2300 Ethernet Switch'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks EX3400 Ethernet Switch'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks EX4300 Ethernet Switch'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks EX4600 Ethernet Switch'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks EX9200'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks IDP-Series'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks ISG 1000'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks ISG 2000'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks ISG-Series'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks J-Series Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks M-Series Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks MX-Series Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks MetaFabric'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks NFX250'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks NSMXpress'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks NetScreen Series'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks QFX-Series Switches'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks QFabric'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX-Series Gateways'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX110'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX1500'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX220'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX300'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX320'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX340'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX345'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX5400'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX550'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX5600'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SRX5800'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks SSG 500'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Networks T-Series Routers'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper PTX'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Secure Analytics (JSA) Series'
    },
    {
        'vendor': 'Juniper Square, Inc.',
        'product': 'Juniper Square'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper Trapeze'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Juniper vSRX Virtual Firewall'
    },
    {
        'vendor': 'Open Source',
        'product': 'Junit'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Junos OS'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Junos Pulse'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Junos Space Security Director'
    },
    {
        'vendor': 'CRM Software, Inc.',
        'product': 'Junxure'
    },
    {
        'vendor': 'LifeOmic Health, LLC',
        'product': 'JupiterOne'
    },
    {
        'vendor': 'JustFoodERP',
        'product': 'JustFood ERP'
    },
    {
        'vendor': 'Just Host',
        'product': 'JustHost'
    },
    {
        'vendor': 'Linode, LLC',
        'product': 'JustHost DNS'
    },
    {
        'vendor': 'Just Host',
        'product': 'JustHost Hosting'
    },
    {
        'vendor': 'JustLogin Pte Ltd',
        'product': 'JustLogin'
    },
    {
        'vendor': 'JustOn GmbH',
        'product': 'JustOn'
    },
    {
        'vendor': 'Justuno, Inc.',
        'product': 'JustUno'
    },
    {
        'vendor': 'Justworks, Inc.',
        'product': 'Justworks'
    },
    {
        'vendor': 'Python Software Foundation',
        'product': 'Jython'
    },
    {
        'vendor': 'Jyve Corporation',
        'product': 'Jyve'
    },
    {
        'vendor': 'Codec Guide',
        'product': 'K-Lite Codec Pack'
    },
    {
        'vendor': 'Younglimwon Softlab Company, Ltd.',
        'product': 'K-System (Unspecified Product)'
    },
    {
        'vendor': 'SourceCode Technology Holdings, Inc.',
        'product': 'K2 Cloud'
    },
    {
        'vendor': 'SourceCode Technology Holdings, Inc.',
        'product': 'K2 Five'
    },
    {
        'vendor': 'SourceCode Technology Holdings, Inc.',
        'product': 'K2 blackpearl'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'KANA Software'
    },
    {
        'vendor': 'Double Jade, LLC',
        'product': 'KBPublisher'
    },
    {
        'vendor': 'KCI, Inc.',
        'product': 'KCI CONTROL'
    },
    {
        'vendor': 'Klee Data System SAS',
        'product': 'KDS Neo'
    },
    {
        'vendor': 'KEYMILE GmbH',
        'product': 'KEYMILE'
    },
    {
        'vendor': 'Gesellschaft fur Individuelle Personalwirtschaftsysteme mbh',
        'product': 'KIDICAP'
    },
    {
        'vendor': 'KISSmetrics',
        'product': 'KISSmetrics'
    },
    {
        'vendor': 'KNIME AG',
        'product': 'KNIME (Unspecified Product)'
    },
    {
        'vendor': 'KNIME AG',
        'product': 'KNIME Analytics Platform'
    },
    {
        'vendor': 'KLDiscovery, LLC',
        'product': 'KRLDiscovery'
    },
    {
        'vendor': 'KUBRA Data Transfer, Ltd.',
        'product': 'KUBRA'
    },
    {
        'vendor': 'Open Source',
        'product': 'KVM'
    },
    {
        'vendor': 'KajWare',
        'product': 'KWHotel'
    },
    {
        'vendor': 'SAP SE',
        'product': 'KXEN'
    },
    {
        'vendor': 'NEWSCYCLE Solutions',
        'product': 'Kaango'
    },
    {
        'vendor': 'Kaavo, Inc.',
        'product': 'Kaavo'
    },
    {
        'vendor': 'Kabbage, Inc.',
        'product': 'Kabbage'
    },
    {
        'vendor': 'Kaggle, Inc.',
        'product': 'Kaggle'
    },
    {
        'vendor': 'Kahoot! A/S',
        'product': 'Kahoot!'
    },
    {
        'vendor': 'Kahua, Inc.',
        'product': 'Kahua'
    },
    {
        'vendor': 'Kahua, Inc.',
        'product': 'Kahua Document Management'
    },
    {
        'vendor': 'Kaizen Platform Company, Ltd.',
        'product': 'Kaizen Platform'
    },
    {
        'vendor': 'Kaldi',
        'product': 'Kaldi'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Kalido Business Information Modeler (BIM)'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Kalido DIW'
    },
    {
        'vendor': 'Kalio, Inc.',
        'product': 'Kalio'
    },
    {
        'vendor': 'Kallidus, Ltd.',
        'product': 'Kallidus'
    },
    {
        'vendor': 'Kaltura, Inc.',
        'product': 'Kaltura'
    },
    {
        'vendor': 'Kamakura Corporation',
        'product': 'Kamakura Risk Manager (KRM)'
    },
    {
        'vendor': 'Kameleoon',
        'product': 'Kameleoon'
    },
    {
        'vendor': 'Kaminario, Inc.',
        'product': 'Kaminario'
    },
    {
        'vendor': 'Medallia, Inc.',
        'product': 'Kampyle'
    },
    {
        'vendor': 'Kamstrup A/S',
        'product': 'Kamstrup'
    },
    {
        'vendor': 'Shore Labs',
        'product': 'Kanban Tool'
    },
    {
        'vendor': 'CodeKick AB',
        'product': 'KanbanFlow'
    },
    {
        'vendor': 'Kanbanchi, Ltd.',
        'product': 'Kanbanchi'
    },
    {
        'vendor': 'Kanbanery Sp. z o.o.',
        'product': 'Kanbanery'
    },
    {
        'vendor': 'Kanbanize',
        'product': 'Kanbanize'
    },
    {
        'vendor': 'Kandji, Inc.',
        'product': 'Kandji'
    },
    {
        'vendor': 'Kadenze, Inc.',
        'product': 'Kannu'
    },
    {
        'vendor': 'The Kantar Group, Ltd.',
        'product': 'Kantar'
    },
    {
        'vendor': 'InfluxData, Inc.',
        'product': 'Kapacitor'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kapow Software'
    },
    {
        'vendor': 'Kareo, Inc.',
        'product': 'Kareo'
    },
    {
        'vendor': 'Karmak, Inc.',
        'product': 'Karmak'
    },
    {
        'vendor': 'Plaid',
        'product': 'Karte'
    },
    {
        'vendor': 'Kaseya, Ltd.',
        'product': 'Kaseya'
    },
    {
        'vendor': 'Kaseya, Ltd.',
        'product': 'Kaseya AuthAnvil'
    },
    {
        'vendor': 'Kaseya, Ltd.',
        'product': 'Kaseya VSA'
    },
    {
        'vendor': 'KashFlow Software, Ltd.',
        'product': 'KashFlow'
    },
    {
        'vendor': 'Kashoo Cloud Accounting, Inc.',
        'product': 'Kashoo'
    },
    {
        'vendor': 'AO Kaspersky Lab',
        'product': 'Kaspersky (Unspecified Product)'
    },
    {
        'vendor': 'AO Kaspersky Lab',
        'product': 'Kaspersky Anti-Virus'
    },
    {
        'vendor': 'AO Kaspersky Lab',
        'product': 'Kaspersky Endpoint Security'
    },
    {
        'vendor': 'AO Kaspersky Lab',
        'product': 'Kaspersky Endpoint Security Cloud'
    },
    {
        'vendor': 'AO Kaspersky Lab',
        'product': 'Kaspersky Endpoint Security for Business'
    },
    {
        'vendor': 'AO Kaspersky Lab',
        'product': 'Kaspersky Industrial Cybersecurity'
    },
    {
        'vendor': 'Katalon, Inc.',
        'product': 'Katalon Studio'
    },
    {
        'vendor': 'Foundry Visionmongers, Ltd.',
        'product': 'Katana'
    },
    {
        'vendor': 'KaVo Dental GmbH',
        'product': 'Kavo Gendex'
    },
    {
        'vendor': 'Kayako, Ltd.',
        'product': 'Kayako'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Kbox'
    },
    {
        'vendor': 'Kx Systems, Inc.',
        'product': 'Kdb+'
    },
    {
        'vendor': 'NTT Data Corporation',
        'product': 'Keane'
    },
    {
        'vendor': 'Keen.io, LLC',
        'product': 'Keen'
    },
    {
        'vendor': 'Keen Labs, Inc.',
        'product': 'Keen.io'
    },
    {
        'vendor': 'Keeptrak Corporation',
        'product': 'KeepTrak'
    },
    {
        'vendor': 'Keepit A/S',
        'product': 'Keepit'
    },
    {
        'vendor': 'KEMP Technologies, Inc.',
        'product': 'Kemp Technologies'
    },
    {
        'vendor': 'Kenandy, Inc.',
        'product': 'Kenandy Cloud ERP'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Kenexa 2x BrassRing'
    },
    {
        'vendor': 'Kenna Security, Inc.',
        'product': 'Kenna Security'
    },
    {
        'vendor': 'Kenshoo, Ltd.',
        'product': 'Kenshoo'
    },
    {
        'vendor': 'Kentico Software',
        'product': 'Kentico'
    },
    {
        'vendor': 'Kentico Software',
        'product': 'Kentico CMS'
    },
    {
        'vendor': 'Kentik, Inc.',
        'product': 'Kentik'
    },
    {
        'vendor': 'Open Source',
        'product': 'Keras'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'Kerio'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'Kerio Connect'
    },
    {
        'vendor': 'GFI Software S.A.',
        'product': 'Kerio Control'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Kerkythea'
    },
    {
        'vendor': 'Kestral Computing Pty Ltd',
        'product': 'Kestral Karisma'
    },
    {
        'vendor': 'Piksel, Inc.',
        'product': 'Kewego'
    },
    {
        'vendor': 'BluJay Solutions, Ltd.',
        'product': 'Kewill Clippership'
    },
    {
        'vendor': 'Key2Act',
        'product': 'Key2Act'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'KeyChart EMR'
    },
    {
        'vendor': 'KeyMetric, Inc.',
        'product': 'KeyMetric'
    },
    {
        'vendor': 'Sassafras Software, Inc.',
        'product': 'KeyServer'
    },
    {
        'vendor': 'Luxion, Inc.',
        'product': 'KeyShot'
    },
    {
        'vendor': 'Flan Technologies, Ltd.',
        'product': 'KeyTiles'
    },
    {
        'vendor': 'Keycaptcha',
        'product': 'Keycaptcha'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'Keysight'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'Keysight ADS'
    },
    {
        'vendor': 'Synaptris, Inc.',
        'product': 'Kezava'
    },
    {
        'vendor': 'Khameleon Software, LLC',
        'product': 'Khameleon Software'
    },
    {
        'vendor': 'Khoros, LLC',
        'product': 'Khoros'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Kiali'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Kibana'
    },
    {
        'vendor': 'Kibo Software, Inc.',
        'product': 'Kibo Commerce'
    },
    {
        'vendor': 'Kibo Software, Inc.',
        'product': 'Kibo Unified Commerce Cloud'
    },
    {
        'vendor': 'Kibo Software, Inc.',
        'product': 'Kibo Unified Commerce Platform'
    },
    {
        'vendor': 'Piksel, Inc.',
        'product': 'KickApps'
    },
    {
        'vendor': 'KickFire',
        'product': 'KickFire'
    },
    {
        'vendor': 'Kickbox, Inc.',
        'product': 'Kickbox'
    },
    {
        'vendor': 'KickoffLabs, LLC',
        'product': 'KickoffLabs'
    },
    {
        'vendor': 'ReachLocal, Inc.',
        'product': 'Kickserv'
    },
    {
        'vendor': 'Kiip, Inc.',
        'product': 'Kiip'
    },
    {
        'vendor': 'The Kildrummy Corporation, Ltd.',
        'product': 'Kildrummy CostMANAGEMENT'
    },
    {
        'vendor': 'Kimbia, Inc.',
        'product': 'Kimbia'
    },
    {
        'vendor': 'Kinaxis, Inc.',
        'product': 'Kinaxis'
    },
    {
        'vendor': 'Kinaxis, Inc.',
        'product': 'Kinaxis RapidResponse'
    },
    {
        'vendor': 'Trail Software, Inc.',
        'product': 'Kindful'
    },
    {
        'vendor': 'Kinetica DB, Inc.',
        'product': 'Kinetica'
    },
    {
        'vendor': 'Kingdee International Software Group, Ltd.',
        'product': 'Kingdee'
    },
    {
        'vendor': 'Kingland Systems Corporation',
        'product': 'Kingland'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'Kinnser'
    },
    {
        'vendor': 'Kintivo',
        'product': 'Kintivo'
    },
    {
        'vendor': 'Kintone Corporation',
        'product': 'Kintone'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Kinvey'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'Kiodex'
    },
    {
        'vendor': 'Kiosked, Ltd.',
        'product': 'Kiosked'
    },
    {
        'vendor': 'Kissflow, Inc.',
        'product': 'Kissflow'
    },
    {
        'vendor': 'Kitewheel, LLC',
        'product': 'Kitewheel'
    },
    {
        'vendor': 'Kixie Web, Inc.',
        'product': 'Kixie'
    },
    {
        'vendor': 'Klarna, Inc.',
        'product': 'Klarna'
    },
    {
        'vendor': 'Klaviyo, Inc.',
        'product': 'Klaviyo'
    },
    {
        'vendor': 'Klear.com, Ltd.',
        'product': 'Klear'
    },
    {
        'vendor': 'Kleinschmidt, Inc.',
        'product': 'Kleinschmidt (Unspecified Product)'
    },
    {
        'vendor': 'Klevu Oy',
        'product': 'Klevu'
    },
    {
        'vendor': 'Klipfolio, Inc.',
        'product': 'Klipfolio'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Klocwork'
    },
    {
        'vendor': 'Knoa Software, Inc.',
        'product': 'Knoa'
    },
    {
        'vendor': 'Knock, Inc.',
        'product': 'Knock CRM'
    },
    {
        'vendor': 'KnowBe4, Inc.',
        'product': 'KnowBe4'
    },
    {
        'vendor': 'Knowify, LLC',
        'product': 'Knowify'
    },
    {
        'vendor': 'Consensus Point, Inc.',
        'product': 'Knowledge360'
    },
    {
        'vendor': 'KnowledgeLake, Inc.',
        'product': 'KnowledgeLake'
    },
    {
        'vendor': 'Silly Moose, LLC',
        'product': 'KnowledgeOwl'
    },
    {
        'vendor': 'Seismic Software, Inc.',
        'product': 'KnowledgeTree'
    },
    {
        'vendor': 'Knowmail S.A.L., Ltd.',
        'product': 'Knowmail (Unspecified Product)'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Knox Configure'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Knox E-FOTA'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Knox Manage'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Knox Platform for Enterprise'
    },
    {
        'vendor': 'Kobiton, Inc.',
        'product': 'Kobiton'
    },
    {
        'vendor': 'Kochava, Inc.',
        'product': 'Kochava'
    },
    {
        'vendor': 'Koerber AG',
        'product': 'Koerber'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax (Unspecified Product)'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax Capture'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax Front Office Server'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax MarkView'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax Optitrade'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax RPA'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax ReadSoft Online'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax SupplierExpress'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax TotalAgility'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Kofax VRS Elite'
    },
    {
        'vendor': 'Kognitio, Ltd.',
        'product': 'Kognitio'
    },
    {
        'vendor': 'Kolide, Inc.',
        'product': 'Kolide'
    },
    {
        'vendor': 'Kollective Technology, Inc.',
        'product': 'Kollective'
    },
    {
        'vendor': 'Komodo Health, Inc.',
        'product': 'Komodo Health'
    },
    {
        'vendor': 'Komoona, Ltd.',
        'product': 'Komoona'
    },
    {
        'vendor': 'Kompyte',
        'product': 'Kompyte'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Kona Web Application Firewall'
    },
    {
        'vendor': 'DS Data Systems UK, Ltd.',
        'product': 'KonaKart'
    },
    {
        'vendor': 'Kong, Inc.',
        'product': 'Kong'
    },
    {
        'vendor': 'Kong, Inc.',
        'product': 'Kong Gateway'
    },
    {
        'vendor': 'Konica Minolta Business Solutions U.S.A., Inc.',
        'product': 'Konica Minolta KIP'
    },
    {
        'vendor': 'Konica Minolta Business Solutions U.S.A., Inc.',
        'product': 'Konica Minolta Magicolor'
    },
    {
        'vendor': 'Konica Minolta Business Solutions U.S.A., Inc.',
        'product': 'Konica Minolta PrintGroove'
    },
    {
        'vendor': 'Konica Minolta Business Solutions U.S.A., Inc.',
        'product': 'Konica Minolta bizhub'
    },
    {
        'vendor': 'Konica Minolta Business Solutions U.S.A., Inc.',
        'product': 'Konica Minolta pagepro'
    },
    {
        'vendor': 'Konnektive, LLC',
        'product': 'Konnektive CRM'
    },
    {
        'vendor': 'Mirantis, Inc.',
        'product': 'Kontena'
    },
    {
        'vendor': 'Kony, Inc.',
        'product': 'Kony'
    },
    {
        'vendor': 'Open Source',
        'product': 'Kops'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'Kotlin'
    },
    {
        'vendor': 'Kount, Inc.',
        'product': 'Kount'
    },
    {
        'vendor': 'Kounta Pty',
        'product': 'Kounta'
    },
    {
        'vendor': 'Krible, LLC',
        'product': 'Krible'
    },
    {
        'vendor': 'Telus Health',
        'product': 'Kroll'
    },
    {
        'vendor': 'KLDiscovery, LLC',
        'product': 'Kroll Ontrack'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos (Unspecified Product)'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos EZCall'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos OptiLink'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos SaaShr'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Staffrunner'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos TimeLink'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Timekeeper Central'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Visionware'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce Central'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce Dimensions Suite'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce HR'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce Management'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce Payroll'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce Ready'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce periOp Scheduler'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos iSeries Central'
    },
    {
        'vendor': 'Kryon System, Ltd.',
        'product': 'Kryon RPA'
    },
    {
        'vendor': 'Enli Health Intelligence',
        'product': 'Kryptiq'
    },
    {
        'vendor': 'Open Source',
        'product': 'KubeVirt'
    },
    {
        'vendor': 'Open Source',
        'product': 'Kubeadm'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Kubernetes'
    },
    {
        'vendor': 'Open Source',
        'product': 'Kubespray'
    },
    {
        'vendor': 'Kudos, Inc.',
        'product': 'Kudos'
    },
    {
        'vendor': 'Kuebix, LLC',
        'product': 'Kuebix'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Kuma'
    },
    {
        'vendor': 'Kunnect, Inc.',
        'product': 'Kunnect'
    },
    {
        'vendor': 'Kustomer, Inc.',
        'product': 'Kustomer'
    },
    {
        'vendor': 'TEAM Software, Inc.',
        'product': 'Kwantek'
    },
    {
        'vendor': 'ImageTag, Inc.',
        'product': 'KwikTag'
    },
    {
        'vendor': 'Kx Systems, Inc.',
        'product': 'Kx'
    },
    {
        'vendor': 'Kyligence, Inc.',
        'product': 'Kyligence'
    },
    {
        'vendor': 'Kyocera Corporation',
        'product': 'Kyocera Ecosys'
    },
    {
        'vendor': 'Kyocera Corporation',
        'product': 'Kyocera TASKalfa'
    },
    {
        'vendor': 'Kyriba Corporation',
        'product': 'Kyriba'
    },
    {
        'vendor': 'Sandia',
        'product': 'LAMMPS'
    },
    {
        'vendor': 'LAMS Foundation, Ltd.',
        'product': 'LAMS'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'LANDesk Security Suite'
    },
    {
        'vendor': 'Boston Scientific Corporation',
        'product': 'LATITUDE NXT'
    },
    {
        'vendor': 'LDRA, Ltd.',
        'product': 'LDRA'
    },
    {
        'vendor': 'LEAP Legal Software Pty Ltd',
        'product': 'LEAP'
    },
    {
        'vendor': 'Stryker Corporation',
        'product': 'LIFEPAK'
    },
    {
        'vendor': 'ELLKAY, LLC',
        'product': 'LKArchive'
    },
    {
        'vendor': 'LLamasoft, Inc.',
        'product': 'LLamasoft'
    },
    {
        'vendor': 'LOG-NET, Inc.',
        'product': 'LOG-NET'
    },
    {
        'vendor': 'LEVI, RAY & SHOUP, Inc.',
        'product': 'LRS Enterprise Output Management'
    },
    {
        'vendor': 'Lumedx Corporation',
        'product': 'LUMEDX'
    },
    {
        'vendor': 'Canonical, Ltd.',
        'product': 'LXD'
    },
    {
        'vendor': 'National Instruments Corporation',
        'product': 'LabVIEW'
    },
    {
        'vendor': 'LabVantage Solutions, Inc.',
        'product': 'LabVantage'
    },
    {
        'vendor': 'LabWare, Inc.',
        'product': 'LabWare LIMS'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Lacerte'
    },
    {
        'vendor': 'Lacework, Inc.',
        'product': 'Lacework'
    },
    {
        'vendor': 'Laika, Inc.',
        'product': 'Laika'
    },
    {
        'vendor': 'LambdaTest, Inc.',
        'product': 'LambdaTest'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Laminas'
    },
    {
        'vendor': 'LandlordMax',
        'product': 'LandlordMax'
    },
    {
        'vendor': 'Halliburton Landmark',
        'product': 'Landmark Software'
    },
    {
        'vendor': 'Halliburton Landmark',
        'product': 'Landmark iEnergy'
    },
    {
        'vendor': 'Landport, Inc.',
        'product': 'Landport'
    },
    {
        'vendor': 'Landscape Management Network, Inc.',
        'product': 'Landscape Management Software'
    },
    {
        'vendor': 'LANSA',
        'product': 'Lansa (Unspecified Product)'
    },
    {
        'vendor': 'Lanteria',
        'product': 'Lanteria HR'
    },
    {
        'vendor': 'Laravel, LLC',
        'product': 'Laravel'
    },
    {
        'vendor': 'Open Source',
        'product': 'Lasagne'
    },
    {
        'vendor': 'Laserfiche',
        'product': 'Laserfiche'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'LastPass'
    },
    {
        'vendor': 'Latitude CG, LLC',
        'product': 'LatitudeLearning'
    },
    {
        'vendor': 'Lattice, Inc.',
        'product': 'Lattice'
    },
    {
        'vendor': 'Lattice Engines, Inc.',
        'product': 'Lattice Engines'
    },
    {
        'vendor': 'LaunchDarkly',
        'product': 'LaunchDarkly'
    },
    {
        'vendor': 'Fashion GPS, Inc.',
        'product': 'Launchmetrics'
    },
    {
        'vendor': 'Fundable, LLC',
        'product': 'Launchrock'
    },
    {
        'vendor': 'Lavu, Inc.',
        'product': 'Lavu iPad POS'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Lawson Asset Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Lawson Business Intelligence'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Lawson M3 Financial Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Lawson S3 Financial Management'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Lawson Software'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Lawson e-Sales'
    },
    {
        'vendor': 'Mitratech Holdings, Inc.',
        'product': 'Lawtrac'
    },
    {
        'vendor': 'CA, Inc.',
        'product': 'Layer 7'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 API Developer Portal'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 API Gateway'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 API Management'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 Advanced Authentication'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 Directory'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 Identity Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Layer7 SiteMinder'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Layered Tech'
    },
    {
        'vendor': 'Interactive Lion, LLC',
        'product': 'Lead Capsule'
    },
    {
        'vendor': 'Lead Forensics, Ltd.',
        'product': 'Lead Forensics'
    },
    {
        'vendor': 'Lead411 Corporation',
        'product': 'Lead411'
    },
    {
        'vendor': 'LeadByte, Ltd.',
        'product': 'LeadByte'
    },
    {
        'vendor': 'LeadDyno, LLC',
        'product': 'LeadDyno'
    },
    {
        'vendor': 'Callidus Software, Inc.',
        'product': 'LeadFormix'
    },
    {
        'vendor': 'LeadFuze',
        'product': 'LeadFuze'
    },
    {
        'vendor': 'WiredMinds GmbH',
        'product': 'LeadLab'
    },
    {
        'vendor': 'Lead Liaison, LLC',
        'product': 'LeadLiaison'
    },
    {
        'vendor': 'LeadMaster, Inc.',
        'product': 'LeadMaster'
    },
    {
        'vendor': 'SAP SE',
        'product': 'LeadRocket'
    },
    {
        'vendor': 'LeadSquared',
        'product': 'LeadSquared'
    },
    {
        'vendor': 'Leadpages (US), Inc.',
        'product': 'Leadpages'
    },
    {
        'vendor': 'Leadsius AB',
        'product': 'Leadsius'
    },
    {
        'vendor': 'Leadspace, Inc.',
        'product': 'Leadspace'
    },
    {
        'vendor': 'LeanData, Inc.',
        'product': 'LeanData'
    },
    {
        'vendor': 'LeanIX GmbH',
        'product': 'LeanIX'
    },
    {
        'vendor': 'BluJay Solutions, Ltd.',
        'product': 'LeanLogistics'
    },
    {
        'vendor': 'Leanplum, Inc.',
        'product': 'Leanplum'
    },
    {
        'vendor': 'LeapFILE, Inc.',
        'product': 'LeapFile'
    },
    {
        'vendor': 'Seequent, Ltd.',
        'product': 'Leapfrog'
    },
    {
        'vendor': 'LearnUpon, Ltd.',
        'product': 'LearnUpon'
    },
    {
        'vendor': 'Schoox, Inc.',
        'product': 'LearnerNation'
    },
    {
        'vendor': 'Learning Technologies Group PLC',
        'product': 'Learning Technologies (Unspecified Product)'
    },
    {
        'vendor': 'Big Step Consulting, Inc.',
        'product': 'LearningCart'
    },
    {
        'vendor': 'LearningStone',
        'product': 'LearningStone'
    },
    {
        'vendor': 'Lease Harbor, LLC',
        'product': 'Lease Harbor'
    },
    {
        'vendor': 'LeaseAccelerator, Inc.',
        'product': 'LeaseAccelerator'
    },
    {
        'vendor': 'LeaseHawk, LLC',
        'product': 'LeaseHawk'
    },
    {
        'vendor': 'LeaseLock, Inc.',
        'product': 'LeaseLock'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'LeaseStar'
    },
    {
        'vendor': 'Lease Term Solutions',
        'product': 'LeaseTerm'
    },
    {
        'vendor': 'Leaseweb USA, Inc.',
        'product': 'LeaseWeb'
    },
    {
        'vendor': 'Lectora',
        'product': 'Lectora'
    },
    {
        'vendor': 'GRM Information Management, Inc.',
        'product': 'Legacy EMR Data Archive'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Legal-X'
    },
    {
        'vendor': 'Legion Technologies, Inc.',
        'product': 'Legion'
    },
    {
        'vendor': 'Legwork, Inc.',
        'product': 'Legwork'
    },
    {
        'vendor': 'LemonStand eCommerce, Inc.',
        'product': 'LemonStand'
    },
    {
        'vendor': 'Lenel Systems International, Inc.',
        'product': 'Lenel'
    },
    {
        'vendor': 'Lengow',
        'product': 'Lengow'
    },
    {
        'vendor': 'Lenos Software',
        'product': 'Lenos'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo (Unspecified Product)'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo Desktop'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo Flex System Blade Servers'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo Ideapad'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo Laptop'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo System x Server'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo ThinkAgile'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo ThinkCentre'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo ThinkPad'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo ThinkStation'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo ThinkSystem'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo X3650 M5'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo XClarity'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'Lenovo Yoga'
    },
    {
        'vendor': 'Lenses.io, Ltd.',
        'product': 'Lenses.io'
    },
    {
        'vendor': 'Lepide Software Pvt Ltd',
        'product': 'Lepide'
    },
    {
        'vendor': 'Less Annoying Software, LLC',
        'product': 'Less Annoying CRM'
    },
    {
        'vendor': 'Lessonly, Inc.',
        'product': 'Lessonly'
    },
    {
        'vendor': 'LetsBuild Belgium S.A.',
        'product': 'LetsBuild'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Level 3 Communications'
    },
    {
        'vendor': 'Open Source',
        'product': 'LevelDB'
    },
    {
        'vendor': 'LevelUp',
        'product': 'LevelUp'
    },
    {
        'vendor': 'Express Lien, Inc.',
        'product': 'Levelset'
    },
    {
        'vendor': 'Lever, Inc.',
        'product': 'Lever'
    },
    {
        'vendor': 'Lexalytics, Inc.',
        'product': 'Lexalytics'
    },
    {
        'vendor': 'Themis Solutions, Inc.',
        'product': 'Lexicata'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Lexicomp Online'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'Lexis Advance'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'Lexis Practice Advisor'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis AML Insight'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Accurint'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Banko'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Bridger Insight XG'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis CaseMap'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis CounselLink'
    },
    {
        'vendor': 'LexisNexis Risk Solutions, Inc.',
        'product': 'LexisNexis Fraud & Identity Management'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis InstantID'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis InsurQuote'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis InterAction'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Juris'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis LienGuard'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis OrderPoint'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis PCLaw'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Practice Advisor'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Risk Management Solutions'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis RiskView'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis SmartLinx'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis Time Matters'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis TotalPatent One'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis WorldCompliance'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis atVantage'
    },
    {
        'vendor': 'LexisNexis Corporation',
        'product': 'LexisNexis eCrash'
    },
    {
        'vendor': 'Lexmark International, Inc.',
        'product': 'Lexmark'
    },
    {
        'vendor': 'The Document Foundation',
        'product': 'LibreOffice'
    },
    {
        'vendor': 'Liberated Syndication (Libsyn)',
        'product': 'Libsyn'
    },
    {
        'vendor': 'BeyondTrust Corporation',
        'product': 'Lieberman Software'
    },
    {
        'vendor': 'Vertiv Group Corporation',
        'product': 'Liebert'
    },
    {
        'vendor': 'ICU Medical, Inc.',
        'product': 'LifeCare PCA'
    },
    {
        'vendor': 'ExlService Holdings, Inc.',
        'product': 'LifePRO'
    },
    {
        'vendor': 'Liferay, Inc.',
        'product': 'Liferay'
    },
    {
        'vendor': 'Liferay, Inc.',
        'product': 'Liferay DXP'
    },
    {
        'vendor': 'Lifesize, Inc.',
        'product': 'Lifesize (Unspecified Product)'
    },
    {
        'vendor': 'LiftIgniter',
        'product': 'Liftigniter'
    },
    {
        'vendor': 'Outbrain, Inc.',
        'product': 'Ligatus'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'LightCMS'
    },
    {
        'vendor': 'Lighthouse S.A.',
        'product': 'LightHouse'
    },
    {
        'vendor': 'LightStep, Inc.',
        'product': 'LightStep'
    },
    {
        'vendor': 'NewTek, Inc.',
        'product': 'LightWave 3D'
    },
    {
        'vendor': 'Lightbend, Inc.',
        'product': 'Lightbend'
    },
    {
        'vendor': 'Open Source',
        'product': 'Lightbox'
    },
    {
        'vendor': 'Lighthouse 360',
        'product': 'Lighthouse 360'
    },
    {
        'vendor': 'Lightspeed POS, Inc.',
        'product': 'Lightspeed Retail'
    },
    {
        'vendor': 'Lightspeed Systems, Inc.',
        'product': 'Lightspeed Systems'
    },
    {
        'vendor': 'Lijit',
        'product': 'Lijit'
    },
    {
        'vendor': 'sticky.io, Inc.',
        'product': 'LimeLight'
    },
    {
        'vendor': 'Limeade, Inc.',
        'product': 'Limeade'
    },
    {
        'vendor': 'Limelight Networks, Inc.',
        'product': 'Limelight CDN'
    },
    {
        'vendor': 'Limelight Networks, Inc.',
        'product': 'Limelight Cloud Security'
    },
    {
        'vendor': 'Limelight Networks, Inc.',
        'product': 'Limelight Video Platform'
    },
    {
        'vendor': 'Siemens Industry Software, Inc.',
        'product': 'Line Designer'
    },
    {
        'vendor': 'Linguamatics, Ltd.',
        'product': 'Linguamatics I2E'
    },
    {
        'vendor': 'LinkConnector Corporation',
        'product': 'LinkConnector'
    },
    {
        'vendor': 'Rakuten Marketing, LLC',
        'product': 'LinkShare'
    },
    {
        'vendor': 'LinkSquares, Inc.',
        'product': 'LinkSquares'
    },
    {
        'vendor': 'LinkTrust Technologies, LLC',
        'product': 'LinkTrust'
    },
    {
        'vendor': 'Authoritas',
        'product': 'Linkdex'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'LinkedIn Ads'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'LinkedIn Learning'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'LinkedIn Marketing Solutions'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'LinkedIn Recruiter'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'LinkedIn Sales Navigator'
    },
    {
        'vendor': 'Buoyant, Inc.',
        'product': 'Linkerd'
    },
    {
        'vendor': 'Linkfluence SAS',
        'product': 'Linkfluence'
    },
    {
        'vendor': 'Linkody',
        'product': 'Linkody'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Linktivity'
    },
    {
        'vendor': 'Linkurious SAS',
        'product': 'Linkurious'
    },
    {
        'vendor': 'Linode, LLC',
        'product': 'Linode'
    },
    {
        'vendor': 'Linode, LLC',
        'product': 'Linode Hosting'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'Linoma Software'
    },
    {
        'vendor': 'Linqia, Inc.',
        'product': 'Linqia'
    },
    {
        'vendor': 'Open Source',
        'product': 'Linux'
    },
    {
        'vendor': 'Lionbridge Technologies, Inc.',
        'product': 'Lionbridge'
    },
    {
        'vendor': 'Lipperhey',
        'product': 'Lipperhey'
    },
    {
        'vendor': 'Liquibase',
        'product': 'Liquibase'
    },
    {
        'vendor': 'Liquid Web, LLC',
        'product': 'Liquid Web'
    },
    {
        'vendor': 'Liquid Web, LLC',
        'product': 'Liquid Web Hosting'
    },
    {
        'vendor': 'LiquidPlanner, Inc.',
        'product': 'LiquidPlanner'
    },
    {
        'vendor': 'Moody\'s Analytics, Inc.',
        'product': 'Liquidity Risk Management'
    },
    {
        'vendor': 'Liquidware Labs, Inc.',
        'product': 'Liquidware ProfileUnity'
    },
    {
        'vendor': 'Innovation, Inc.',
        'product': 'ListFinder'
    },
    {
        'vendor': 'Listrak, LLC',
        'product': 'Listrak'
    },
    {
        'vendor': 'Creative Development, LLC',
        'product': 'LiteCommerce'
    },
    {
        'vendor': 'Khoros, LLC',
        'product': 'Lithium'
    },
    {
        'vendor': 'Litium AB',
        'product': 'Litium'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Litmos'
    },
    {
        'vendor': 'Litmus Software, Inc.',
        'product': 'Litmus'
    },
    {
        'vendor': 'Litmus Automation, Inc.',
        'product': 'Litmus Automation'
    },
    {
        'vendor': 'Little Green Light, LLC',
        'product': 'Little Green Light'
    },
    {
        'vendor': 'Online Ventures Pty Ltd',
        'product': 'Little Hotelier'
    },
    {
        'vendor': 'Live365, Inc.',
        'product': 'Live365'
    },
    {
        'vendor': 'LiveAction, Inc.',
        'product': 'LiveAction'
    },
    {
        'vendor': 'Quality Unit s.r.o.',
        'product': 'LiveAgent'
    },
    {
        'vendor': 'LiveCall Software Sp. z o.o.',
        'product': 'LiveCall'
    },
    {
        'vendor': 'LiveChat, Inc.',
        'product': 'LiveChat'
    },
    {
        'vendor': 'LiveChat, Inc.',
        'product': 'LiveChat ChatBot'
    },
    {
        'vendor': 'LiveChat, Inc.',
        'product': 'LiveChatInc'
    },
    {
        'vendor': 'LiveEdit, LLC',
        'product': 'LiveEdit'
    },
    {
        'vendor': 'LivePerson, Inc.',
        'product': 'LiveEngage'
    },
    {
        'vendor': 'LiveHelpNow, LLC',
        'product': 'LiveHelpNow'
    },
    {
        'vendor': 'LiveHive, Inc.',
        'product': 'LiveHive'
    },
    {
        'vendor': 'LiveIntent, Inc.',
        'product': 'LiveIntent'
    },
    {
        'vendor': 'LiveInternet.ru',
        'product': 'LiveInternet'
    },
    {
        'vendor': 'LiveJournal, Inc.',
        'product': 'LiveJournal'
    },
    {
        'vendor': 'Liveops, Inc.',
        'product': 'LiveOps'
    },
    {
        'vendor': 'CSS Holdings, Inc.',
        'product': 'LivePOS'
    },
    {
        'vendor': 'LivePerson, Inc.',
        'product': 'LivePerson (Unspecified Product)'
    },
    {
        'vendor': 'LivePerson, Inc.',
        'product': 'LivePerson Automotive'
    },
    {
        'vendor': 'Palo Alto Software, Inc.',
        'product': 'LivePlan'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'LiveRail'
    },
    {
        'vendor': 'Acxiom, LLC',
        'product': 'LiveRamp'
    },
    {
        'vendor': 'InhabitIQ',
        'product': 'LiveRez'
    },
    {
        'vendor': 'LiveSafe, Inc.',
        'product': 'LiveSafe'
    },
    {
        'vendor': 'LiveSource, Inc.',
        'product': 'LiveSource'
    },
    {
        'vendor': 'Vimeo, Inc.',
        'product': 'LiveStream'
    },
    {
        'vendor': 'LiveTex, LLC',
        'product': 'LiveTex'
    },
    {
        'vendor': 'LiveTiles, Ltd.',
        'product': 'LiveTiles Intranet'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'LiveVault'
    },
    {
        'vendor': 'LiveVox, Inc.',
        'product': 'LiveVox'
    },
    {
        'vendor': 'LiveZilla GmbH',
        'product': 'LiveZilla'
    },
    {
        'vendor': 'Liveclicker, Inc.',
        'product': 'Liveclicker'
    },
    {
        'vendor': 'Livedrive Internet, Ltd.',
        'product': 'Livedrive'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Livefyre'
    },
    {
        'vendor': 'LoadTrek',
        'product': 'LoadTrek TMS'
    },
    {
        'vendor': 'Loadlink Technologies, Inc.',
        'product': 'Loadlink'
    },
    {
        'vendor': 'LoanPro Software, LLC',
        'product': 'LoanPro'
    },
    {
        'vendor': 'Optimal Blue, LLC',
        'product': 'LoanSifter'
    },
    {
        'vendor': 'Lob.com, Inc.',
        'product': 'Lob'
    },
    {
        'vendor': 'Loc8.com',
        'product': 'Loc8'
    },
    {
        'vendor': 'Locaweb Internet Services S/A',
        'product': 'LocaWeb Hosting'
    },
    {
        'vendor': 'Locaweb Internet Services S/A',
        'product': 'Locaweb'
    },
    {
        'vendor': 'LockPath, Inc.',
        'product': 'LockPath'
    },
    {
        'vendor': 'Locowise, Ltd.',
        'product': 'Locowise'
    },
    {
        'vendor': 'Locu, Inc.',
        'product': 'Locu'
    },
    {
        'vendor': 'Locus Technologies',
        'product': 'Locus Technologies'
    },
    {
        'vendor': 'Lodgify',
        'product': 'Lodgify'
    },
    {
        'vendor': 'Loftware, Inc.',
        'product': 'Loftware'
    },
    {
        'vendor': 'LogDNA, Inc.',
        'product': 'LogDNA'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'LogLogic'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'LogMeIn'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'LogMeIn Central'
    },
    {
        'vendor': 'LogMeIn, Inc.',
        'product': 'LogMeIn Rescue'
    },
    {
        'vendor': 'LogOn Business Systems',
        'product': 'LogOn ERP'
    },
    {
        'vendor': 'Logpoint A/S',
        'product': 'LogPoint'
    },
    {
        'vendor': 'LogRhythm, Inc.',
        'product': 'LogRhythm'
    },
    {
        'vendor': 'LogRhythm, Inc.',
        'product': 'LogRhythm NextGen SIEM Platform'
    },
    {
        'vendor': 'LogRocket, Inc.',
        'product': 'LogRocket'
    },
    {
        'vendor': 'Logaholic B.V.',
        'product': 'Logaholic'
    },
    {
        'vendor': 'Loggly, Inc.',
        'product': 'Loggly'
    },
    {
        'vendor': 'Logi Analytics, Inc.',
        'product': 'Logi Analytics Platform'
    },
    {
        'vendor': 'LogiCare Corporation',
        'product': 'LogiCare'
    },
    {
        'vendor': 'Logibec, Inc.',
        'product': 'Logibec'
    },
    {
        'vendor': 'Logic Software, Inc.',
        'product': 'Logic Software Easy Projects'
    },
    {
        'vendor': 'Logicbox Software, Inc.',
        'product': 'LogicBox'
    },
    {
        'vendor': 'LogicGate, Inc.',
        'product': 'LogicGate'
    },
    {
        'vendor': 'LogicManager, Inc.',
        'product': 'LogicManager'
    },
    {
        'vendor': 'LogicMonitor, Inc.',
        'product': 'LogicMonitor'
    },
    {
        'vendor': 'LogicSource, Inc.',
        'product': 'LogicSource'
    },
    {
        'vendor': 'LogicalDOC',
        'product': 'LogicalDOC'
    },
    {
        'vendor': 'Logicalis Group',
        'product': 'Logicalis'
    },
    {
        'vendor': 'Logicor, Inc.',
        'product': 'Logicor'
    },
    {
        'vendor': 'Logicube, Inc.',
        'product': 'Logicube'
    },
    {
        'vendor': 'Logicworks Corporation',
        'product': 'Logicworks'
    },
    {
        'vendor': 'Logikcull',
        'product': 'Logikcull'
    },
    {
        'vendor': 'Logility, Inc.',
        'product': 'Logility'
    },
    {
        'vendor': 'Logility, Inc.',
        'product': 'Logility Demand Planning'
    },
    {
        'vendor': 'Logility, Inc.',
        'product': 'Logility Life Cycle Planning'
    },
    {
        'vendor': 'LoginRadius, Inc.',
        'product': 'LoginRadius'
    },
    {
        'vendor': 'Logitech Europe S.A.',
        'product': 'Logitech GROUP'
    },
    {
        'vendor': 'Logo Yazilim A.S.',
        'product': 'Logo CRM'
    },
    {
        'vendor': 'Logo Yazilim A.S.',
        'product': 'Logo ERP'
    },
    {
        'vendor': 'Logo Yazilim A.S.',
        'product': 'Logo HRM'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Logstash'
    },
    {
        'vendor': 'LogsHero, Ltd.',
        'product': 'Logz.io'
    },
    {
        'vendor': 'Lomadee',
        'product': 'Lomadee'
    },
    {
        'vendor': 'London Grid for Learning (LGfL)',
        'product': 'London Grid for Learning (LGfL)'
    },
    {
        'vendor': 'Lone Wolf Real Estate Technologies, Inc.',
        'product': 'Lone Wolf Real Estate'
    },
    {
        'vendor': 'Software AG',
        'product': 'LongJump'
    },
    {
        'vendor': 'Insightsoftware, Inc.',
        'product': 'Longview CPM'
    },
    {
        'vendor': 'Longview Solutions Canada ULC',
        'product': 'Longview Plan'
    },
    {
        'vendor': 'Looker Data Sciences, Inc.',
        'product': 'Looker'
    },
    {
        'vendor': 'Looker Data Sciences, Inc.',
        'product': 'Looker Business Intelligence'
    },
    {
        'vendor': 'Lookout, Inc.',
        'product': 'Lookout'
    },
    {
        'vendor': 'Loom, Inc.',
        'product': 'Loom'
    },
    {
        'vendor': 'Salesfusin, Inc.',
        'product': 'LoopFuse'
    },
    {
        'vendor': 'Loopia AB',
        'product': 'Loopia'
    },
    {
        'vendor': 'Loopia AB',
        'product': 'Loopia Hosting'
    },
    {
        'vendor': 'Loren Data Corporation',
        'product': 'Loren Data'
    },
    {
        'vendor': 'Lorex Technology, Inc.',
        'product': 'Lorex'
    },
    {
        'vendor': 'Connectrex Corporation',
        'product': 'Loryx Systems'
    },
    {
        'vendor': 'Lotame Solutions, Inc.',
        'product': 'Lotame (Unspecified Product)'
    },
    {
        'vendor': 'Lotame Solutions, Inc.',
        'product': 'Lotame for Advertisers'
    },
    {
        'vendor': 'Lotame Solutions, Inc.',
        'product': 'Lotame for Publishers'
    },
    {
        'vendor': 'Loxogon, Inc.',
        'product': 'Loxogon'
    },
    {
        'vendor': 'Loy & Hutz Solutions GmbH',
        'product': 'Loy & Hutz'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Lucernex'
    },
    {
        'vendor': 'Lucid Software, Inc.',
        'product': 'LucidChart'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'LucidDrive'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'LucidShape'
    },
    {
        'vendor': 'Lucidworks, Inc.',
        'product': 'LucidWorks'
    },
    {
        'vendor': 'Lucidity Software',
        'product': 'Lucidity'
    },
    {
        'vendor': 'Lucidoc Corporation',
        'product': 'Lucidoc'
    },
    {
        'vendor': 'Lucky Orange, LLC',
        'product': 'Lucky Orange'
    },
    {
        'vendor': 'Open Source',
        'product': 'Luigi'
    },
    {
        'vendor': 'LumApps SAS',
        'product': 'LumApps'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Lumada'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Lumen Cloud Application Manager'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Lumen Colocation'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Lumen DDoS and Web Application Security'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Lumen Vyvx'
    },
    {
        'vendor': 'LumenVox, LLC',
        'product': 'LumenVox'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Lumension'
    },
    {
        'vendor': 'Lumeris, Inc.',
        'product': 'Lumeris'
    },
    {
        'vendor': 'Saba Software, Inc.',
        'product': 'Lumesse'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'Lumidigm'
    },
    {
        'vendor': 'Luminate Marketing',
        'product': 'Luminate'
    },
    {
        'vendor': 'Act-3D B.V.',
        'product': 'Lumion'
    },
    {
        'vendor': 'Lunarpages',
        'product': 'Lunarpages Hosting'
    },
    {
        'vendor': 'Open Source',
        'product': 'Lustre Filesystem'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Lynx Design System'
    },
    {
        'vendor': 'Lyra Health, Inc.',
        'product': 'Lyra Health'
    },
    {
        'vendor': 'Lytics, Inc.',
        'product': 'Lytics'
    },
    {
        'vendor': 'Lytx, Inc.',
        'product': 'Lytx'
    },
    {
        'vendor': 'Maincare Solutions SAS',
        'product': 'M-CrossWay'
    },
    {
        'vendor': 'M-Files, Inc.',
        'product': 'M-Files'
    },
    {
        'vendor': '3M Company',
        'product': 'M-Modal'
    },
    {
        'vendor': 'Global Voice Group Worldwide Corporation S.A.U.',
        'product': 'M3'
    },
    {
        'vendor': 'M3COM of Virginia, Inc.',
        'product': 'M3COM IaaS'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'M86 Security'
    },
    {
        'vendor': 'TASS International B.V.',
        'product': 'MADYMO'
    },
    {
        'vendor': 'Magique Galileo Software, Ltd.',
        'product': 'MAGIQUE'
    },
    {
        'vendor': 'MAPCON TECHNOLOGIES, Inc.',
        'product': 'MAPCON'
    },
    {
        'vendor': 'SalesFocus Solutions',
        'product': 'MARS CRM'
    },
    {
        'vendor': 'The MathWorks, Inc.',
        'product': 'MATLAB'
    },
    {
        'vendor': 'Cypher Learning, Inc.',
        'product': 'MATRIX LMS'
    },
    {
        'vendor': 'MBO Partners, Inc.',
        'product': 'MBO Partners'
    },
    {
        'vendor': 'MDI Solutions, Ltd.',
        'product': 'MD Link'
    },
    {
        'vendor': 'MD Logic, Inc.',
        'product': 'MD Logic'
    },
    {
        'vendor': 'ABILITY Network, Inc.',
        'product': 'MD On-Line'
    },
    {
        'vendor': 'MD Synergy Solutions, LLC',
        'product': 'MD Synergy'
    },
    {
        'vendor': 'Provation Software Group, Inc.',
        'product': 'MD-Reports'
    },
    {
        'vendor': 'Mdlive, Inc.',
        'product': 'MDLIVE'
    },
    {
        'vendor': 'MDLand International Corporation',
        'product': 'MDLand iClinic'
    },
    {
        'vendor': 'Techsoft, Inc.',
        'product': 'MDRhythm'
    },
    {
        'vendor': 'Multi Data Services Corporation',
        'product': 'MDS'
    },
    {
        'vendor': 'MDSL',
        'product': 'MDSL'
    },
    {
        'vendor': 'Health Care 2000, Inc.',
        'product': 'MDVita EHR'
    },
    {
        'vendor': 'MDaemon Technologies, Ltd.',
        'product': 'MDaemon'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'MDoffice'
    },
    {
        'vendor': 'Ferranti Computer Systems N.V.',
        'product': 'MECOMS'
    },
    {
        'vendor': 'MED2020 Health Care Software, Inc.',
        'product': 'MED2020'
    },
    {
        'vendor': 'MED3000 of the Virginias, LLC',
        'product': 'MED3000'
    },
    {
        'vendor': 'MEDHOST, Inc.',
        'product': 'MEDHOST (Unspecified Product)'
    },
    {
        'vendor': 'MEDHOST, Inc.',
        'product': 'MEDHOST eMar'
    },
    {
        'vendor': 'MEDINFO INTERNATIONAL HEMOSERVICE',
        'product': 'MEDINFO IHS'
    },
    {
        'vendor': 'Medical Information Technology, Inc.',
        'product': 'MEDITECH'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH (Unspecified Product)'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH 6.0'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH 6.1'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH ADM'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH BBK'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Client/Server'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH EHR'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Expanse'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Expanse Ambulatory'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Expanse HR Planning'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Expanse HR Planning Payroll'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Magic'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH RAD'
    },
    {
        'vendor': 'MEDITECH',
        'product': 'MEDITECH Scanning and Archiving'
    },
    {
        'vendor': 'MEDsys, Inc.',
        'product': 'MEDsys EVV'
    },
    {
        'vendor': 'Compressus, Inc.',
        'product': 'MEDxConnect'
    },
    {
        'vendor': 'MEGA International S.A.',
        'product': 'MEGA Hopex'
    },
    {
        'vendor': 'Maintenance Experts Pty Ltd',
        'product': 'MEX Maintenance'
    },
    {
        'vendor': 'Schneider Electric SE',
        'product': 'MGE UPS'
    },
    {
        'vendor': 'MGID, Inc.',
        'product': 'MGID'
    },
    {
        'vendor': 'MHR, Ltd.',
        'product': 'MHR iTrent'
    },
    {
        'vendor': 'Mie Solutions, Inc.',
        'product': 'MIE Trak Pro'
    },
    {
        'vendor': 'MIM Software, Inc.',
        'product': 'MIM Software'
    },
    {
        'vendor': 'MIND CTI, Ltd.',
        'product': 'MINDBill'
    },
    {
        'vendor': 'MINTclass',
        'product': 'MINTclass'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'MIR (Mandiant Intelligent Response)'
    },
    {
        'vendor': 'OnSolve, LLC',
        'product': 'MIR3'
    },
    {
        'vendor': 'LogRhythm, Inc.',
        'product': 'MITRE ATT&CK'
    },
    {
        'vendor': 'Management Information Tools, Inc.',
        'product': 'MITS Distributor Analytics'
    },
    {
        'vendor': 'Microfinance Information Exchange, Inc.',
        'product': 'MIXMarket'
    },
    {
        'vendor': 'Tangoe, Inc.',
        'product': 'MOBI Wireless Management'
    },
    {
        'vendor': 'MOCA Systems, Inc.',
        'product': 'MOCA Systems Touchplan'
    },
    {
        'vendor': 'Foundry Visionmongers, Ltd.',
        'product': 'MODO'
    },
    {
        'vendor': 'MoveIt Companies',
        'product': 'MOVEit'
    },
    {
        'vendor': 'Moz, Inc.',
        'product': 'MOZ SEO'
    },
    {
        'vendor': 'MPN Software Systems, Inc.',
        'product': 'MPN Eclipse'
    },
    {
        'vendor': 'Persistent Systems, LLC',
        'product': 'MPU5'
    },
    {
        'vendor': 'MPulse Software, Inc.',
        'product': 'MPulse'
    },
    {
        'vendor': 'MRI Software, LLC',
        'product': 'MRI Commercial Management'
    },
    {
        'vendor': 'MRI Software, LLC',
        'product': 'MRI Residential Management'
    },
    {
        'vendor': 'MRI Software, LLC',
        'product': 'MRI Software'
    },
    {
        'vendor': 'Market Resources Partners, LLC',
        'product': 'MRP Prelytix'
    },
    {
        'vendor': 'MSC Software Corporation',
        'product': 'MSC Adams'
    },
    {
        'vendor': 'MSC Software Corporation',
        'product': 'MSC Software (Unspecified Product)'
    },
    {
        'vendor': 'MSI Solutions',
        'product': 'MSI'
    },
    {
        'vendor': 'MURAL',
        'product': 'MURAL'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'MVISION EDR'
    },
    {
        'vendor': 'CMMS Data Group',
        'product': 'MVP Plant'
    },
    {
        'vendor': 'Chicago-Soft, Ltd.',
        'product': 'MVS/QuickRef'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'MX Logic'
    },
    {
        'vendor': 'Murex SAS',
        'product': 'MX.3'
    },
    {
        'vendor': 'MYBOS Pty Ltd',
        'product': 'MYBOS'
    },
    {
        'vendor': 'MYOB Technology Pty Ltd',
        'product': 'MYOB'
    },
    {
        'vendor': 'MYOB Technology Pty Ltd',
        'product': 'MYOB Exo'
    },
    {
        'vendor': 'ABC Fitness Solutions',
        'product': 'MYiCLUBonline'
    },
    {
        'vendor': 'Mabisy online S.L.',
        'product': 'Mabisy'
    },
    {
        'vendor': 'mabl, Inc.',
        'product': 'Mabl'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Mac OS'
    },
    {
        'vendor': 'Microspot, Ltd.',
        'product': 'MacDraft'
    },
    {
        'vendor': 'MacPractice, Inc.',
        'product': 'MacPractice'
    },
    {
        'vendor': 'Applied Informatics Software Engineering GmbH',
        'product': 'Macchina'
    },
    {
        'vendor': 'Mach7 Technologies, Ltd.',
        'product': 'Mach7'
    },
    {
        'vendor': 'GoDaddy.com, LLC',
        'product': 'Mad Mimi'
    },
    {
        'vendor': 'Mad Ads Media LP',
        'product': 'MadAdsMedia'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap (Unspecified Product)'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap Capture'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap Central'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap Contributor'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap Flare'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap Lingo'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'MadCap Mimic'
    },
    {
        'vendor': 'MadCap Software, Inc.',
        'product': 'Madcap'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'Made2Manage ERP'
    },
    {
        'vendor': 'Madison Logic, Inc.',
        'product': 'Madison Logic'
    },
    {
        'vendor': 'Adtrib, Inc.',
        'product': 'MaestroQA'
    },
    {
        'vendor': 'MagLoft Pte Ltd',
        'product': 'MagLoft'
    },
    {
        'vendor': 'MagView',
        'product': 'MagView'
    },
    {
        'vendor': 'Magento, Inc.',
        'product': 'Magento'
    },
    {
        'vendor': 'Magento, Inc.',
        'product': 'Magento (Unspecified Product)'
    },
    {
        'vendor': 'Magento, Inc.',
        'product': 'Magento 2'
    },
    {
        'vendor': 'Magento, Inc.',
        'product': 'Magento Business Intelligence Pro'
    },
    {
        'vendor': 'Magento, Inc.',
        'product': 'Magento Open Source'
    },
    {
        'vendor': 'Magnet Forensics, Inc.',
        'product': 'Magnet AXIOM'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Magnitude MDM'
    },
    {
        'vendor': 'Magnolia International, Ltd.',
        'product': 'Magnolia CMS'
    },
    {
        'vendor': 'Magzter, Inc.',
        'product': 'Magzter'
    },
    {
        'vendor': 'Mailchimp',
        'product': 'MailChimp Mandrill'
    },
    {
        'vendor': 'Mailjet, Inc.',
        'product': 'MailJet'
    },
    {
        'vendor': 'MailTag Company, LLC',
        'product': 'MailTag'
    },
    {
        'vendor': 'MailUp S.p.A.',
        'product': 'MailUp'
    },
    {
        'vendor': 'Mailchimp',
        'product': 'Mailchimp'
    },
    {
        'vendor': 'Wanadis KFT',
        'product': 'Maileon'
    },
    {
        'vendor': 'Mailgun Technologies, Inc.',
        'product': 'Mailgun'
    },
    {
        'vendor': 'Mailigen, Ltd.',
        'product': 'Mailigen'
    },
    {
        'vendor': 'Maincare Solutions SAS',
        'product': 'Maincare M-GAM'
    },
    {
        'vendor': 'Maincare Solutions SAS',
        'product': 'Maincare M-GELF'
    },
    {
        'vendor': 'Mainpac Pty Ltd',
        'product': 'Mainpac'
    },
    {
        'vendor': 'Mainsaver Corporation',
        'product': 'Mainsaver'
    },
    {
        'vendor': 'GrandRavine Software, Ltd.',
        'product': 'MaintScape'
    },
    {
        'vendor': 'MaintSmart Software, Inc.',
        'product': 'MaintSmart'
    },
    {
        'vendor': 'Maintenance Connection, LLC',
        'product': 'Maintenance Connection'
    },
    {
        'vendor': 'Ashcom Technologies',
        'product': 'MaintiMizer'
    },
    {
        'vendor': 'Posera Software',
        'product': 'Maitre\'D POS'
    },
    {
        'vendor': 'Majesco, Inc.',
        'product': 'Majesco'
    },
    {
        'vendor': 'Majestic-12, Ltd.',
        'product': 'Majestic'
    },
    {
        'vendor': 'Korea Center Company, Ltd.',
        'product': 'MakeShop'
    },
    {
        'vendor': 'MakerSights, Inc.',
        'product': 'MakerSights'
    },
    {
        'vendor': 'MALLET',
        'product': 'Mallet'
    },
    {
        'vendor': 'Maltego Technologies GmbH',
        'product': 'Maltego'
    },
    {
        'vendor': 'Malwarebytes, Inc.',
        'product': 'Malwarebytes'
    },
    {
        'vendor': 'Mambu GmbH',
        'product': 'Mambu'
    },
    {
        'vendor': 'MANEX ERP, Inc.',
        'product': 'ManEx'
    },
    {
        'vendor': 'Navaltik Management, Ltd.',
        'product': 'ManWinWin'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine ADAudit Plus'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine Desktop Central'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine EventLog Analyzer'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine Log360'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine ServiceDesk Plus'
    },
    {
        'vendor': 'Angbert Enterprises, LLC',
        'product': 'ManagePro'
    },
    {
        'vendor': 'GoDaddy.com, LLC',
        'product': 'ManageWP'
    },
    {
        'vendor': 'ManagerPlus Solutions, LLC',
        'product': 'ManagerPlus'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'Mandiant'
    },
    {
        'vendor': 'Mango, Ltd.',
        'product': 'Mango'
    },
    {
        'vendor': 'MANGOAPPS, Inc.',
        'product': 'MangoApps'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Active Omni'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Active Supply Chain'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Associates'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Associates (Unspecified Product)'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Associates WMS'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Manhattan Centerstone'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Contact Center'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Enterprise Inventory'
    },
    {
        'vendor': 'Manhattan Associates, Inc.',
        'product': 'Manhattan Order Management'
    },
    {
        'vendor': 'Manthan Software Services Pvt Ltd',
        'product': 'Manthan'
    },
    {
        'vendor': 'Open Source',
        'product': 'MantisBT'
    },
    {
        'vendor': 'ManualMaster International',
        'product': 'ManualMaster'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'MapInfo'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'MapInfo Pro'
    },
    {
        'vendor': 'MapLarge, Inc.',
        'product': 'MapLarge'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'MapMarker'
    },
    {
        'vendor': 'MapR Technologies, Inc.',
        'product': 'MapR'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'MapXtreme'
    },
    {
        'vendor': 'Mapbox, Inc.',
        'product': 'Mapbox (Unspecified Product)'
    },
    {
        'vendor': 'Mapp Digital US, LLC',
        'product': 'Mapp Cloud'
    },
    {
        'vendor': 'Maptek Pty Ltd',
        'product': 'Maptek'
    },
    {
        'vendor': 'Maptive, LLC',
        'product': 'Maptive'
    },
    {
        'vendor': 'MSC Software Corporation',
        'product': 'Marc'
    },
    {
        'vendor': 'March Networks, Inc.',
        'product': 'March Networks'
    },
    {
        'vendor': 'Marchex, Inc.',
        'product': 'Marchex'
    },
    {
        'vendor': 'MarcomCentral',
        'product': 'MarcomCentral'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Marconi OMS 1200'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Marconi OMS 1600'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Marconi SMA/MSH'
    },
    {
        'vendor': 'Foundry Visionmongers, Ltd.',
        'product': 'Mari'
    },
    {
        'vendor': 'Open Source',
        'product': 'MariaDB'
    },
    {
        'vendor': 'Marin Software, Inc.',
        'product': 'Marin Software'
    },
    {
        'vendor': 'Maritz Holdings, Inc.',
        'product': 'Maritz'
    },
    {
        'vendor': 'InMoment, Inc.',
        'product': 'MaritzCX'
    },
    {
        'vendor': 'ECi Software Solutions, Inc.',
        'product': 'Mark Systems IHMS'
    },
    {
        'vendor': 'MarkLogic Corporation',
        'product': 'MarkLogic'
    },
    {
        'vendor': 'The Daring Fireball Company, LLC',
        'product': 'Markdown'
    },
    {
        'vendor': 'Apricity Software, LLC',
        'product': 'MarkdownPad'
    },
    {
        'vendor': 'Markem-Imaje Group',
        'product': 'Markem-Imaje'
    },
    {
        'vendor': 'Market Logic Software AG',
        'product': 'Market Logic'
    },
    {
        'vendor': 'Marketing Intelligence Research Solutions, Ltd.',
        'product': 'MarketGID'
    },
    {
        'vendor': 'MetrixLab B.V.',
        'product': 'MarketTools'
    },
    {
        'vendor': 'MarketVolt',
        'product': 'MarketVolt'
    },
    {
        'vendor': 'Marketcircle, Inc.',
        'product': 'Marketcircle Daylite'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'MarketingPilot'
    },
    {
        'vendor': 'Omniconvert',
        'product': 'Marketizator'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Marketo'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Marketo Engage'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Marketo Financial Management'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Marketo Launchpoint'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Marketo Sales Connect'
    },
    {
        'vendor': 'Marketo, Inc.',
        'product': 'Marketo Spark'
    },
    {
        'vendor': 'Marketwired, Inc.',
        'product': 'Marketwire'
    },
    {
        'vendor': 'Markforged, Inc.',
        'product': 'Markforged'
    },
    {
        'vendor': 'Lexmark International, Inc.',
        'product': 'Markvision Enterprise'
    },
    {
        'vendor': 'Maropost, Inc.',
        'product': 'Maropost'
    },
    {
        'vendor': 'Marqeta, Inc.',
        'product': 'Marqeta'
    },
    {
        'vendor': 'Givex Corporation',
        'product': 'Marqui'
    },
    {
        'vendor': 'MartJack',
        'product': 'MartJack'
    },
    {
        'vendor': 'Marvell Technology Group, Ltd.',
        'product': 'Marvell QLogic'
    },
    {
        'vendor': 'Masergy Communications, Inc.',
        'product': 'Masergy (Unspecified Product)'
    },
    {
        'vendor': 'Masimo Corporation',
        'product': 'Masimo'
    },
    {
        'vendor': 'Khoros, LLC',
        'product': 'Mass Relevance'
    },
    {
        'vendor': 'Global Health, Ltd.',
        'product': 'MasterCare EMR'
    },
    {
        'vendor': 'MasterControl, Inc.',
        'product': 'MasterControl'
    },
    {
        'vendor': 'CNC Software, Inc.',
        'product': 'Mastercam'
    },
    {
        'vendor': 'Mastercard International, Inc.',
        'product': 'Mastercard Click to Pay'
    },
    {
        'vendor': 'MasteryConnect, Inc.',
        'product': 'MasteryConnect'
    },
    {
        'vendor': 'Matchcraft, LLC',
        'product': 'MatchCraft'
    },
    {
        'vendor': 'Materialise N.V.',
        'product': 'Materialise Magics'
    },
    {
        'vendor': 'MathJax',
        'product': 'MathJax'
    },
    {
        'vendor': 'The MathWorks, Inc.',
        'product': 'MathWorks (Unspecified Product)'
    },
    {
        'vendor': 'Matillion, Ltd.',
        'product': 'Matillion'
    },
    {
        'vendor': 'Matomo',
        'product': 'Matomo'
    },
    {
        'vendor': 'Dataflo Corporation',
        'product': 'Matrix Velocity'
    },
    {
        'vendor': 'Matrix42 AG',
        'product': 'Matrix42'
    },
    {
        'vendor': 'MatrixCare, Inc.',
        'product': 'MatrixCare'
    },
    {
        'vendor': 'Matrixx Software, Inc.',
        'product': 'Matrixx'
    },
    {
        'vendor': 'Matrox Electronic Systems, Ltd.',
        'product': 'Matrox'
    },
    {
        'vendor': 'Matterkind, LLC',
        'product': 'Matterkind'
    },
    {
        'vendor': 'Mattermark, Inc.',
        'product': 'Mattermark'
    },
    {
        'vendor': 'Mattermost, Inc.',
        'product': 'Mattermost'
    },
    {
        'vendor': 'Matterport, Inc.',
        'product': 'Matterport'
    },
    {
        'vendor': 'Adaptive Computing, Inc.',
        'product': 'Maui Cluster Scheduler'
    },
    {
        'vendor': 'Acquia, Inc.',
        'product': 'Mautic'
    },
    {
        'vendor': 'Maven Coalition, Inc.',
        'product': 'Maven'
    },
    {
        'vendor': 'Mavenir Systems, Inc.',
        'product': 'Mavenir'
    },
    {
        'vendor': 'Mavenlink, Inc.',
        'product': 'Mavenlink'
    },
    {
        'vendor': 'Mavrck',
        'product': 'Mavrck'
    },
    {
        'vendor': 'TOPS Engineering Corporation',
        'product': 'MaxLoad Pro'
    },
    {
        'vendor': 'MaxMind, Inc.',
        'product': 'MaxMind'
    },
    {
        'vendor': 'MaxMind, Inc.',
        'product': 'MaxMind GeoIP'
    },
    {
        'vendor': 'First Insight Corporation',
        'product': 'MaximEyes.com'
    },
    {
        'vendor': 'Maximizer Software, Inc.',
        'product': 'Maximizer Software'
    },
    {
        'vendor': 'MAXON Computer GmbH',
        'product': 'Maxon'
    },
    {
        'vendor': 'MAXON Computer GmbH',
        'product': 'Maxon BodyPaint 3D'
    },
    {
        'vendor': 'MAXON Computer GmbH',
        'product': 'Maxon Cinema 4D'
    },
    {
        'vendor': 'Maxpanda Software, Inc.',
        'product': 'Maxpanda'
    },
    {
        'vendor': 'Next Limit S.L.',
        'product': 'Maxwell Render'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee (Unspecified Product)'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Advanced Threat Defense'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Cloud Identity Manager'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Cloud Workload Security'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee DLP Discover'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee DLP Endpoint'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee DLP Monitor'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee DLP Prevent'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Deep Defender'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee E-Business Server'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee EMM'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Email Gateway'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Endpoint Protection'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Endpoint Security'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Enterprise Security Manager'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'McAfee Firewall Enterprise'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Foundstone'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Host IPS'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee IPS'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee MVISION Cloud'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee NetShield'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Network Access Control'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Network Security Platform'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Network Threat Response'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Network User Behavior Analysis'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee NitroSecurity'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Preventsys'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Risk Advisor'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee SaaS Email Protection'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee SaaS Total Protection'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Secure'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Security for Email Servers'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee SmartFilter'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Total Protection for Data Loss (DLP)'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Virtual Network Security Platform'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee VirusScan Enterprise'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Vulnerability Manager'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Web Gateway'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Web Protection'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee ePO'
    },
    {
        'vendor': 'McCormick Systems, Inc.',
        'product': 'McCormick Systems'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson Business Performance'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson InteGreat'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson Population Management'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson RelayRx'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson Value Pathways'
    },
    {
        'vendor': 'McKesson Corporation',
        'product': 'McKesson iKnowMed'
    },
    {
        'vendor': 'McKinsey & Company',
        'product': 'McKinsey Wave'
    },
    {
        'vendor': 'McObject, LLC',
        'product': 'McObject'
    },
    {
        'vendor': 'MeasureUp, Inc.',
        'product': 'MeasureUp'
    },
    {
        'vendor': 'Epicor Software Corporation',
        'product': 'MechanicNet CRM Cloud'
    },
    {
        'vendor': 'Metro Flo',
        'product': 'Med-Dispense'
    },
    {
        'vendor': 'Brightree, LLC',
        'product': 'MedAct'
    },
    {
        'vendor': 'Vizient, Inc.',
        'product': 'MedAssets'
    },
    {
        'vendor': 'Vizient, Inc.',
        'product': 'MedAssets XClaim'
    },
    {
        'vendor': 'MedCurrent Corporation',
        'product': 'MedCurrent OrderWise CDS'
    },
    {
        'vendor': 'MedEvolve, Inc.',
        'product': 'MedEvolve'
    },
    {
        'vendor': 'MedInformatix, Inc.',
        'product': 'MedInformatix'
    },
    {
        'vendor': 'Health Data Services, Inc.',
        'product': 'MedLedger'
    },
    {
        'vendor': 'Crescendo Systems Corporation',
        'product': 'MedRite'
    },
    {
        'vendor': 'Medsym, Inc.',
        'product': 'MedSym Solutions'
    },
    {
        'vendor': 'Medallia, Inc.',
        'product': 'Medallia'
    },
    {
        'vendor': 'Medallia, Inc.',
        'product': 'Medallia Digital'
    },
    {
        'vendor': 'Medallia, Inc.',
        'product': 'Medallia Experience Cloud'
    },
    {
        'vendor': 'Medaxion, Inc.',
        'product': 'Medaxion'
    },
    {
        'vendor': 'DataBank IMX, LLC',
        'product': 'Medcise'
    },
    {
        'vendor': 'Harris Computer Systems',
        'product': 'MedcomSoft Record'
    },
    {
        'vendor': 'MedeAnalytics, Inc.',
        'product': 'MedeAnalytics'
    },
    {
        'vendor': 'Medecision, Inc.',
        'product': 'Medecision'
    },
    {
        'vendor': 'Community Computer Service, Inc.',
        'product': 'Medent'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'Medflow'
    },
    {
        'vendor': 'Medfusion, Inc.',
        'product': 'Medfusion'
    },
    {
        'vendor': 'Cority Software, Inc.',
        'product': 'Medgate'
    },
    {
        'vendor': 'Comtron, Inc.',
        'product': 'Medgen EHR'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Medi-Span'
    },
    {
        'vendor': 'Lattice, Inc.',
        'product': 'MediCopia'
    },
    {
        'vendor': 'MediQuant, LLC',
        'product': 'MediQuant'
    },
    {
        'vendor': 'MediQuant, LLC',
        'product': 'MediQuant DataArk'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'MediRegs'
    },
    {
        'vendor': 'MediSYS, Inc.',
        'product': 'MediSYS'
    },
    {
        'vendor': 'Harris Computer Systems',
        'product': 'MediSolution'
    },
    {
        'vendor': 'MetiStream, Inc.',
        'product': 'MediStream Ember'
    },
    {
        'vendor': 'TractManager, Inc.',
        'product': 'MediTract'
    },
    {
        'vendor': 'Media Temple, Inc.',
        'product': 'Media Temple'
    },
    {
        'vendor': 'Media Temple, Inc.',
        'product': 'Media Temple Hosting'
    },
    {
        'vendor': 'Media Temple, Inc.',
        'product': 'Media Temple SSL'
    },
    {
        'vendor': 'Media.Net Advertising FZ, LLC',
        'product': 'Media.net'
    },
    {
        'vendor': 'MediaBeacon, Inc.',
        'product': 'MediaBeacon'
    },
    {
        'vendor': 'MediaClone, Inc.',
        'product': 'MediaClone'
    },
    {
        'vendor': 'Mediamath, Inc.',
        'product': 'MediaMath'
    },
    {
        'vendor': 'MediaPlatform, Inc.',
        'product': 'MediaPlatform'
    },
    {
        'vendor': 'Media Silo, Inc.',
        'product': 'MediaSilo'
    },
    {
        'vendor': 'NEWSCYCLE Solutions',
        'product': 'MediaSpan'
    },
    {
        'vendor': 'MediaValet, Inc.',
        'product': 'MediaValet'
    },
    {
        'vendor': 'Mediafly, Inc.',
        'product': 'Mediafly'
    },
    {
        'vendor': 'Mediaocean, LLC',
        'product': 'Mediaocean'
    },
    {
        'vendor': 'The Medibase Group, Inc.',
        'product': 'Medibase'
    },
    {
        'vendor': 'Medical Mastermind',
        'product': 'Medical Mastermind'
    },
    {
        'vendor': 'MedicalMime, Inc.',
        'product': 'MedicalMime'
    },
    {
        'vendor': 'Medicfusion, Inc.',
        'product': 'Medicfusion'
    },
    {
        'vendor': 'Medicity',
        'product': 'Medicity'
    },
    {
        'vendor': 'Advanced Data Systems Corporation',
        'product': 'MedicsCloud EHR'
    },
    {
        'vendor': 'Advanced Data Systems Corporation',
        'product': 'MedicsCloud Suite'
    },
    {
        'vendor': 'Advanced Data Systems Corporation',
        'product': 'MedicsPM'
    },
    {
        'vendor': 'Advanced Data Systems Corporation',
        'product': 'MedicsRIS'
    },
    {
        'vendor': 'Medidata Solutions, Inc.',
        'product': 'Medidata'
    },
    {
        'vendor': 'Medidata Solutions, Inc.',
        'product': 'Medidata Rave'
    },
    {
        'vendor': 'Medidata Solutions, Inc.',
        'product': 'Medidata Rave CTMS'
    },
    {
        'vendor': 'Medidata Solutions, Inc.',
        'product': 'Medidata Rave Clinical Cloud'
    },
    {
        'vendor': 'Medidata Solutions, Inc.',
        'product': 'Medidata Rave Imaging'
    },
    {
        'vendor': 'Mediscribe, Inc.',
        'product': 'Mediscribe'
    },
    {
        'vendor': 'eMDs, Inc.',
        'product': 'Medisoft'
    },
    {
        'vendor': 'Harris Computer Systems',
        'product': 'Medisolution Virtuo'
    },
    {
        'vendor': 'Medisolv, Inc.',
        'product': 'Medisolv'
    },
    {
        'vendor': 'Meditab Software, Inc.',
        'product': 'Meditab IMS EHR'
    },
    {
        'vendor': 'Mediture, LLC',
        'product': 'Mediture'
    },
    {
        'vendor': 'A Medium Corporation',
        'product': 'Medium'
    },
    {
        'vendor': 'symplr',
        'product': 'Medkinetics'
    },
    {
        'vendor': 'M-Modal, LLC',
        'product': 'Medquist'
    },
    {
        'vendor': 'Medrio, Inc.',
        'product': 'Medrio'
    },
    {
        'vendor': 'Medrio, Inc.',
        'product': 'Medrio EDC'
    },
    {
        'vendor': 'Medsphere Systems Corporation',
        'product': 'Medsphere'
    },
    {
        'vendor': 'Medstreaming, LLC',
        'product': 'Medstreaming'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'Medtronic'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'Medtronic CareLink'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'Medtronic Omnivisor Pro'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'Medtronic Paceart'
    },
    {
        'vendor': 'Medusind, Inc.',
        'product': 'Medusind'
    },
    {
        'vendor': 'System C Healthcare, Ltd.',
        'product': 'Medway PAS'
    },
    {
        'vendor': 'Medweb',
        'product': 'Medweb'
    },
    {
        'vendor': 'MedWorxs, LLC',
        'product': 'Medworxs'
    },
    {
        'vendor': 'CentralSquare Technologies',
        'product': 'Medworxx'
    },
    {
        'vendor': 'Meetris GmbH',
        'product': 'Meetrics'
    },
    {
        'vendor': 'Fusion Connect, Inc.',
        'product': 'MegaPath'
    },
    {
        'vendor': 'MegaPath Cloud Company, LLC',
        'product': 'MegaPath Cloud Hosting'
    },
    {
        'vendor': 'Ciox Health',
        'product': 'MegaWest'
    },
    {
        'vendor': 'Megamation Systems, Inc.',
        'product': 'Megamation DirectLine'
    },
    {
        'vendor': 'Vermeg N.V.',
        'product': 'Megara'
    },
    {
        'vendor': 'itdesign GmbH',
        'product': 'Meisterplan'
    },
    {
        'vendor': 'Melbourne IT, Ltd.',
        'product': 'Melbourne IT'
    },
    {
        'vendor': 'Melissa Corporation',
        'product': 'Melissa Data'
    },
    {
        'vendor': 'Mellanox Technologies, Ltd.',
        'product': 'Mellanox'
    },
    {
        'vendor': 'Meltwater US, Inc.',
        'product': 'Meltwater'
    },
    {
        'vendor': 'Meltwater US, Inc.',
        'product': 'Meltwater Buzz'
    },
    {
        'vendor': 'Pixelera',
        'product': 'Member365'
    },
    {
        'vendor': 'MemberClicks, LLC',
        'product': 'MemberClicks'
    },
    {
        'vendor': 'Vieth Consulting',
        'product': 'MemberLeap'
    },
    {
        'vendor': 'MemberMouse, LLC',
        'product': 'MemberMouse'
    },
    {
        'vendor': 'MemberPlanet, LLC',
        'product': 'MemberPlanet'
    },
    {
        'vendor': 'Memberium',
        'product': 'Memberium'
    },
    {
        'vendor': 'Upstream Business Solutions AB',
        'product': 'Membrain'
    },
    {
        'vendor': 'Open Source',
        'product': 'Memcached'
    },
    {
        'vendor': 'Men&Mice ehf.',
        'product': 'Men&Mice'
    },
    {
        'vendor': 'MenaITech',
        'product': 'MenaHR'
    },
    {
        'vendor': 'MenaITech',
        'product': 'MenaPay'
    },
    {
        'vendor': 'Mendix, Inc.',
        'product': 'Mendix'
    },
    {
        'vendor': 'Menlo Security, Inc.',
        'product': 'Menlo Security'
    },
    {
        'vendor': 'Mentimeter AB',
        'product': 'Mentimeter'
    },
    {
        'vendor': 'Mention Me, Ltd.',
        'product': 'MentionMe'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Mentor (Unspecified Product)'
    },
    {
        'vendor': 'Mentor Graphics Corporation',
        'product': 'Mentor Embedded Hypervisor'
    },
    {
        'vendor': 'Mentor Graphics Corporation',
        'product': 'Mentor Graphics'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Meraki MR Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Meraki MS Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Meraki MX Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Meraki Systems Manager'
    },
    {
        'vendor': 'Mercateo Deutschland AG',
        'product': 'Mercateo'
    },
    {
        'vendor': 'MerchantAdvantage, LLC',
        'product': 'Merchant Advantage'
    },
    {
        'vendor': 'MerchantAdvantage, LLC',
        'product': 'MerchantAdvantage'
    },
    {
        'vendor': 'City Facilities Management Holdings, Ltd.',
        'product': 'Mercury'
    },
    {
        'vendor': 'MercuryGate International, Inc.',
        'product': 'MercuryGate'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Merge AIMS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Merge Eye Care PACS'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Merge Healthcare'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Merge iConnect'
    },
    {
        'vendor': 'Meridian Loyalty',
        'product': 'Meridian Ecommerce'
    },
    {
        'vendor': 'Meridian Global Services',
        'product': 'Meridian Global Services'
    },
    {
        'vendor': 'Meridian Knowledge Systems',
        'product': 'Meridian LMS'
    },
    {
        'vendor': 'MeridianLink, Inc.',
        'product': 'MeridianLink LoansPQ'
    },
    {
        'vendor': 'Merit International, Inc.',
        'product': 'Merit'
    },
    {
        'vendor': 'MeritDirect, LLC',
        'product': 'MeritDirect (Unspecified Product)'
    },
    {
        'vendor': 'MerlinOne, Inc.',
        'product': 'MerlinOne'
    },
    {
        'vendor': 'Fortinet, Inc.',
        'product': 'Meru Networks'
    },
    {
        'vendor': 'Open Source',
        'product': 'Mesa 3D'
    },
    {
        'vendor': 'D2iQ, Inc.',
        'product': 'Mesosphere'
    },
    {
        'vendor': 'D2iQ, Inc.',
        'product': 'Mesosphere Marathon'
    },
    {
        'vendor': 'MessageBird B.V.',
        'product': 'MessageBird'
    },
    {
        'vendor': 'MessageGears, LLC',
        'product': 'MessageGears'
    },
    {
        'vendor': 'Message4u Pty Ltd',
        'product': 'Messagemedia'
    },
    {
        'vendor': 'Messagepoint, Inc.',
        'product': 'Messagepoint'
    },
    {
        'vendor': 'Meta4 Spain, S.A.',
        'product': 'Meta4'
    },
    {
        'vendor': 'MetaCommerce, Inc.',
        'product': 'MetaCommerce'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'MetaDex'
    },
    {
        'vendor': 'MetaPack, Ltd.',
        'product': 'MetaPack'
    },
    {
        'vendor': 'Metafile Information Systems, Inc.',
        'product': 'MetaViewer'
    },
    {
        'vendor': 'Metadata, Inc.',
        'product': 'Metadata.io'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Metalogix'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'Metasploit'
    },
    {
        'vendor': 'Metaswitch Networks, Ltd.',
        'product': 'Metaswitch'
    },
    {
        'vendor': 'Metatomix',
        'product': 'Metatomix'
    },
    {
        'vendor': 'Meteor Development Group, Inc.',
        'product': 'Meteor'
    },
    {
        'vendor': 'Harris Utilities',
        'product': 'MeterSense'
    },
    {
        'vendor': 'Netalytics, LLC',
        'product': 'Methasoft'
    },
    {
        'vendor': 'MetricStream, Inc.',
        'product': 'MetricStream'
    },
    {
        'vendor': 'MetricStream, Inc.',
        'product': 'MetricStream AppStudio'
    },
    {
        'vendor': 'MetricStream, Inc.',
        'product': 'MetricStream IT Risk Management App'
    },
    {
        'vendor': 'MetricStream, Inc.',
        'product': 'MetricStream M7'
    },
    {
        'vendor': 'MetrixLab B.V.',
        'product': 'MetrixLab'
    },
    {
        'vendor': 'MetrixApps, Inc.',
        'product': 'Metrixstream'
    },
    {
        'vendor': 'Mi9 Retail, Inc.',
        'product': 'Mi9 Retail'
    },
    {
        'vendor': 'Mi9 Retail, Inc.',
        'product': 'Mi9 Retail Demand Management'
    },
    {
        'vendor': 'Illumina, Inc.',
        'product': 'MiSeq'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'MiVoice MX-ONE'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'MiVoice Office 250'
    },
    {
        'vendor': 'Micrium, Inc.',
        'product': 'Micrium'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus (Unspecified Product)'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus AccuRev'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Acu4GL'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Adoption Readiness Tool'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Agile Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus AppPulse Active'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Application Lifecycle Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight Compliance'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight Connectors'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight ESM'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight Express'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight Logger'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ArcSight User Behavior Analytics'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Artix'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Asset Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus BorderManager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Business Availability Center'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Business Continuity Clustering'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Business Process Monitor'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Business Process Testing'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Business Rule Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Business Service Automation'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus COBOL Analyzer'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus CODAR'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Caliber'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ChangeMan SSM'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ChangeMan ZMF'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Cloud Service Automation'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Comparex'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Configuration Management System'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Connect-It'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Connected Backup'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Content Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ControlPoint'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Data Protector'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Databridge'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus DecisionCenter'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Deployment Automation'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus DevPartner'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Digital Safe'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Dimensions CM'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Dimensions RM'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Discovery and Dependency Mapping Advanced Edition (DDMA)'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Discovery and Dependency Mapping Inventory (DDMI)'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise Analyzer'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise Developer'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise Server'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise Server for .NET'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise Test Server'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise View'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Extra! X-treme'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus File Reporter'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Filr'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Fortify'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus GlancePlus'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus GroupWise'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus GroupWise 2012'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus GroupWise 6'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus GroupWise 7'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus GroupWise 8'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus IDOL Connectors'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Identity Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus LeanFT'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Legal Hold'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus LoadRunner'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Mainframe Solutions'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus NetIQ Change Guardian'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Network Automation'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Network Node Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Network Node Manager i'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Network Virtualization'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Open Enterprise Server'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Open Workgroup'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Operations Agent'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Operations Bridge Analytics'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Operations Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Operations Orchestration'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Orbix'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus PVCS Professional Suite'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Performance Center'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Performance Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus PlateSpin Migrate'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Project and Portfolio Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Quality Center'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Quality Center Enterprise (QC)'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus QuickTest Professional'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Real User Monitor'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Release Control'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Requirements Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Retain Archiving for Email'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Secure Messaging Gateway'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Service Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Service Management Automation X'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Service Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Service Support Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Silk'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Silk Test'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus SiteScope'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Solutions Business Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Sprinter'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus StarTeam'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Storage Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus StormRunner'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Structured Data Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Systinet'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus UFT'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Unified Functional Testing'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Vibe'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus VisiBroker'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Voltage SecureData'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks Application Virtualization'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks Asset Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks Configuration Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks Linux Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks Patch Management'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus ZENworks Service Desk'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus eDiscovery'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus iFolder'
    },
    {
        'vendor': 'MicroBiz, LLC',
        'product': 'MicroBiz POS'
    },
    {
        'vendor': 'Henry Schein, Inc.',
        'product': 'MicroMD'
    },
    {
        'vendor': 'MicroMain Corporation',
        'product': 'MicroMain'
    },
    {
        'vendor': 'MicroStrategy, Inc.',
        'product': 'MicroStrategy'
    },
    {
        'vendor': 'Microdea, Inc.',
        'product': 'Microdea'
    },
    {
        'vendor': 'Micromine, Ltd.',
        'product': 'Micromine'
    },
    {
        'vendor': 'Microsemi Corporation',
        'product': 'Microsemi Timing & Synchronization'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft 365 Business'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft 365 Defender'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft 365 E3'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft 365 Records Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Access'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Active Directory'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Active Directory Federation Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Advanced Group Policy Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Analytics Platform System'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft App-V'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Advanced Threat Protection'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Anomaly Detector'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure App Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Automation Account'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Blockchain'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Bot Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Cognitive Search'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Container Instances'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Container Registry'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Content Moderator'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure DNS Zones'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Data Catalog'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Database for MariaDB'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure DevOps Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Digital Twins'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Event Grid'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Firewall'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Form Recognizer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Front Door'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Functions'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure IoT'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure IoT Central'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure IoT Edge'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure IoT Hub'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Kinect DK'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Logic Apps'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Maps'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Media Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure NetApp Files'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Network Watcher'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Operational Insights'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Portal'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Power BI Embedded'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Relay'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Remote Rendering'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure SQL'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure SQL Data Warehouse'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure SQL Managed Instance'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Service Fabric Mesh'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure SignalR Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Spatial Anchors'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Speech to Text'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Sphere'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Spring Cloud'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Synapse'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Time Series Insights'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Azure Virtual Network'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft BPOS'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Bing'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Bitlocker'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Cloud App Security'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Cognitive Toolkit'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Commerce Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Compliance Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Customer Care Framework'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Customer Experience Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Defender ATP'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Desktop Optimization Pack'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft DirectAccess'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft DirectX'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Distributed File System (DFS)'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Docs'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 Business Central'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 Field Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 Retail'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 for Customer Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 for Finance and Operations'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 for Marketing'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 for Project Service Automation'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 for Sales'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics 365 for Talent'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics AX'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics CRM'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics CRM 2011'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics CRM 3.0'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics CRM 4.0'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics ERP'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics GP'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics NAV'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics RMS'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Dynamics SL'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft EMET'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Endpoint Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Enterprise Content Management (ECM)'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Enterprise Mobility + Security'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Enterprise Project Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Equivio'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 2000'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 2003'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 2007'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 2010'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 2013'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 2016'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange 5.0'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Online'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server 2000'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server 2003'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server 2010'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server 2013'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server 2016'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Exchange Server 2019'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft FAST ESP'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft FRx'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Forefront'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft FoxPro'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft FrontBridge'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Frontpage'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft HealthVault'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Hyper-V Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft IIS'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Identity Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Intune'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft LUIS'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Live Meeting'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Lync Enterprise Voice'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Machine Learning Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft NuGet'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office 2013'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office 365'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office 365 E3'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office 365 E5'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office 365 F1'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Office Professional Plus'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft OneDrive'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft OneNote'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Open Data Initiative'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Outlook'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Power Apps'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Power Automate'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Power BI'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft PowerPoint'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Procurement'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Project'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Project Portfolio Management'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Publisher'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Roaming User Profiles'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server 2000'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server 2005'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server 2008'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server 2012'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server 2014'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server Analysis Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server Business Intelligence'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server Integration Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server Management Studio'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SQL Server Reporting Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SharePoint'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft SharePoint Online'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Sharepoint Enterprise'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Sharepoint Foundation'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Silverlight'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Skype'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Skype GroupMe'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Skype for Business'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Skype for Business Cloud PBX'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Skype for Business Online'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Skype for Business Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft StorSimple'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Surface'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft System Center'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft System Center Configuration Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft System Center Data Protection Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft System Center Endpoint Protection'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft System Center Operations Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft System Center Virtual Machine Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft TFS'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Tablet'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Teams'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Transact-SQL'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Translator Text API'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft TypeScript'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Unity'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft VB.NET'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Virtual Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Visio'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Visual Basic'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Visual FoxPro'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Visual SourceSafe'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Visual Studio'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Visual Studio Team Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Windows 7'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Windows 8'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Windows Phone'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Windows Virtual Desktop'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Yammer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft data platform'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft.NET'
    },
    {
        'vendor': 'Conduent, Inc.',
        'product': 'Midas Care Performance Platform'
    },
    {
        'vendor': 'Conduent, Inc.',
        'product': 'Midas+ BedReady'
    },
    {
        'vendor': 'Midokura Enterprise MidoNet MEM solution',
        'product': 'Midokura'
    },
    {
        'vendor': 'MightyText',
        'product': 'MightyText'
    },
    {
        'vendor': 'Miiduu, Inc.',
        'product': 'Miiduu'
    },
    {
        'vendor': 'MyOnlineStore B.V.',
        'product': 'Mijnwebwinkel'
    },
    {
        'vendor': 'Mikogo',
        'product': 'Mikogo'
    },
    {
        'vendor': 'MikroTik SIA',
        'product': 'MikroTik'
    },
    {
        'vendor': 'Milestone Systems A/S',
        'product': 'Milestone XProtect'
    },
    {
        'vendor': 'Milonic, Ltd.',
        'product': 'Milonic'
    },
    {
        'vendor': 'Milsoft Utility Solutions, Inc.',
        'product': 'Milsoft Utility'
    },
    {
        'vendor': 'Mimaki USA, Inc.',
        'product': 'Mimaki'
    },
    {
        'vendor': 'Mimecast Services, Ltd.',
        'product': 'Mimecast'
    },
    {
        'vendor': 'Kerridge Commercial Systems, Ltd.',
        'product': 'Mincron ERP'
    },
    {
        'vendor': 'Mindgate Solutions Pvt Ltd',
        'product': 'MindGate'
    },
    {
        'vendor': 'Corel Corporation',
        'product': 'MindManager'
    },
    {
        'vendor': 'MindMatrix, Inc.',
        'product': 'MindMatrix'
    },
    {
        'vendor': 'MindTickle, Inc.',
        'product': 'MindTickle'
    },
    {
        'vendor': 'MindTouch, Inc.',
        'product': 'MindTouch'
    },
    {
        'vendor': 'Mindbody, Inc.',
        'product': 'Mindbody'
    },
    {
        'vendor': 'Mindbridge Systems, Inc.',
        'product': 'Mindbridge Systems'
    },
    {
        'vendor': 'Mindflash Technologies, Inc.',
        'product': 'Mindflash'
    },
    {
        'vendor': 'Shenzhen Mindray Bio-Medical Electronics Company, Ltd.',
        'product': 'Mindray'
    },
    {
        'vendor': 'MineRP Holding Pty Ltd',
        'product': 'MineRP'
    },
    {
        'vendor': 'MineralTree, Inc.',
        'product': 'MineralTree'
    },
    {
        'vendor': 'Minubo, Inc.',
        'product': 'Minubo'
    },
    {
        'vendor': 'Minuteman Power Technologies',
        'product': 'Minuteman Power'
    },
    {
        'vendor': 'Mirakl',
        'product': 'Mirakl'
    },
    {
        'vendor': 'Mirantis, Inc.',
        'product': 'Mirantis'
    },
    {
        'vendor': 'Miro',
        'product': 'Miro'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Mist'
    },
    {
        'vendor': 'HanseHype GmbH',
        'product': 'Mister Wong'
    },
    {
        'vendor': 'Finastra',
        'product': 'Misys'
    },
    {
        'vendor': 'Mitchell Repair Information Company, LLC',
        'product': 'Mitchell1 eCRM'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel (Unspecified Product)'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel 5300'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel Aastra'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel Aastra 6770'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel Collaboration Advanced'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel Contact Center Solutions'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel MiCollab'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel Pointspan'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Mitel Sky'
    },
    {
        'vendor': 'Mitrefinch, Ltd.',
        'product': 'Mitrefinch'
    },
    {
        'vendor': 'Miva, Inc.',
        'product': 'Miva Merchant'
    },
    {
        'vendor': 'MixMax, Inc.',
        'product': 'MixMax'
    },
    {
        'vendor': 'Mixpanel, Inc.',
        'product': 'Mixpanel'
    },
    {
        'vendor': 'Open Source',
        'product': 'MkDocs'
    },
    {
        'vendor': 'Adaptive Computing, Inc.',
        'product': 'Moab HPC Suite'
    },
    {
        'vendor': 'Moat, Inc.',
        'product': 'Moat Analytics'
    },
    {
        'vendor': 'TAGIT Pte Ltd',
        'product': 'Mobeix'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Mobify'
    },
    {
        'vendor': 'MobileIron, Inc.',
        'product': 'MobileIron'
    },
    {
        'vendor': 'MobileIron, Inc.',
        'product': 'MobileIron UEM'
    },
    {
        'vendor': 'MobileMonkey, Inc.',
        'product': 'MobileMonkey'
    },
    {
        'vendor': 'MobileXpense S.A./N.V.',
        'product': 'MobileXpense'
    },
    {
        'vendor': 'Mobivity Holdings, Inc.',
        'product': 'Mobivity'
    },
    {
        'vendor': 'Mobotix AG',
        'product': 'Mobotix (Unspecified Product)'
    },
    {
        'vendor': 'MobySoft, Ltd.',
        'product': 'MobySoft'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'Mocha'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'ModSecurity'
    },
    {
        'vendor': 'Mode Analytics, Inc.',
        'product': 'Mode'
    },
    {
        'vendor': 'Model N, Inc.',
        'product': 'Model N (Unspecified Product)'
    },
    {
        'vendor': 'Model N, Inc.',
        'product': 'Model N Revvy'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'ModelSim'
    },
    {
        'vendor': 'Modern Life, Inc.',
        'product': 'Modern Health'
    },
    {
        'vendor': 'Modernizing Medicine, Inc.',
        'product': 'Modernizing Medicine'
    },
    {
        'vendor': 'Modernizr',
        'product': 'Modernizr'
    },
    {
        'vendor': 'ModuleMD, LLC',
        'product': 'ModuleMD'
    },
    {
        'vendor': 'MoinMoin',
        'product': 'MoinMoin'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'Mojo AirTight'
    },
    {
        'vendor': 'Metadot Corporation',
        'product': 'Mojo Helpdesk'
    },
    {
        'vendor': 'Mollie B.V.',
        'product': 'Mollie'
    },
    {
        'vendor': 'MomentFeed, Inc.',
        'product': 'MomentFeed'
    },
    {
        'vendor': 'Monax',
        'product': 'Monax'
    },
    {
        'vendor': 'Moneris Solutions, Inc.',
        'product': 'Moneris'
    },
    {
        'vendor': 'Monetate, Inc.',
        'product': 'Monetate'
    },
    {
        'vendor': 'MongoDB, Inc.',
        'product': 'MongoDB'
    },
    {
        'vendor': 'MongoDB, Inc.',
        'product': 'MongoDB Atlas'
    },
    {
        'vendor': 'MongoDB, Inc.',
        'product': 'MongoDB Atlas Data Lake'
    },
    {
        'vendor': 'MongoDB, Inc.',
        'product': 'MongoDB Charts'
    },
    {
        'vendor': 'MongoDB, Inc.',
        'product': 'MongoDB Connector for BI'
    },
    {
        'vendor': 'MongoDB, Inc.',
        'product': 'MongoDB Realm'
    },
    {
        'vendor': 'Monitus, LLC',
        'product': 'Monitus'
    },
    {
        'vendor': 'Monsido, Inc.',
        'product': 'Monsido'
    },
    {
        'vendor': 'Monsoon, Inc.',
        'product': 'Monsoon Commerce'
    },
    {
        'vendor': 'Network Solutions, LLC',
        'product': 'MonsterMarketplace'
    },
    {
        'vendor': 'MooTools',
        'product': 'MooTools'
    },
    {
        'vendor': 'Moodle Pty Ltd',
        'product': 'Moodle'
    },
    {
        'vendor': 'Moody\'s Analytics, Inc.',
        'product': 'Moody\'s Analytics ALM'
    },
    {
        'vendor': 'Moogsoft, Inc.',
        'product': 'Moogsoft AIOps'
    },
    {
        'vendor': 'Moonami, LLC',
        'product': 'Moonami'
    },
    {
        'vendor': 'Moonfruit, Ltd.',
        'product': 'Moonfruit'
    },
    {
        'vendor': 'Moorepay, Ltd.',
        'product': 'Moorepay'
    },
    {
        'vendor': 'Moov Corporation',
        'product': 'Moovweb'
    },
    {
        'vendor': 'Morningstar, Inc.',
        'product': 'Morningstar Principia'
    },
    {
        'vendor': 'Morpheus Data, LLC',
        'product': 'Morpheus'
    },
    {
        'vendor': 'Morphisec, Ltd.',
        'product': 'Morphisec'
    },
    {
        'vendor': 'MCG Health, LLC',
        'product': 'Morrisey Concurrent Care Manager'
    },
    {
        'vendor': 'Welch Allyn, Inc.',
        'product': 'Mortara'
    },
    {
        'vendor': 'Altisource Portfolio Solutions S.A.',
        'product': 'Mortgage Builder'
    },
    {
        'vendor': 'MortgageFlex Systems, Inc.',
        'product': 'MortgageFlex'
    },
    {
        'vendor': 'MosaicCRM',
        'product': 'MosaicCRM'
    },
    {
        'vendor': 'Moskitos',
        'product': 'Moskitos Crosscut'
    },
    {
        'vendor': 'Mothernode, LLC',
        'product': 'Mothernode'
    },
    {
        'vendor': 'Motigo GmbH & Company KG',
        'product': 'Motigo'
    },
    {
        'vendor': 'Motigo GmbH & Company KG',
        'product': 'Motigo Webstats'
    },
    {
        'vendor': 'Motio, Inc.',
        'product': 'MotioCI'
    },
    {
        'vendor': 'Motio, Inc.',
        'product': 'MotioPI'
    },
    {
        'vendor': 'Motivosity, Inc.',
        'product': 'Motivosity'
    },
    {
        'vendor': 'Motorola Mobility, LLC',
        'product': 'Motorola'
    },
    {
        'vendor': 'Motorola Mobility, LLC',
        'product': 'Motorola AXS2200'
    },
    {
        'vendor': 'Motorola Mobility, LLC',
        'product': 'Motorola AXSvision'
    },
    {
        'vendor': 'Mouseflow, Inc.',
        'product': 'MouseFlow'
    },
    {
        'vendor': 'MouseStats Analytics, Inc.',
        'product': 'MouseStats'
    },
    {
        'vendor': 'Movable, Inc.',
        'product': 'Movable Ink'
    },
    {
        'vendor': 'Six Apart, Ltd.',
        'product': 'Movable Type'
    },
    {
        'vendor': 'Six Apart, Ltd.',
        'product': 'MovableType'
    },
    {
        'vendor': 'EWS Group',
        'product': 'MoversSuite'
    },
    {
        'vendor': 'Moveworks, Inc.',
        'product': 'Moveworks'
    },
    {
        'vendor': 'Moxa, Inc.',
        'product': 'Moxa'
    },
    {
        'vendor': 'Moxie Software, Inc.',
        'product': 'Moxie Software'
    },
    {
        'vendor': 'Carbonite, Inc.',
        'product': 'Mozy'
    },
    {
        'vendor': 'Mu Sigma, Inc.',
        'product': 'Mu Sigma'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule ESB'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 3.5'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 3.7'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 3.8'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 3.9'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 4.1'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 4.2'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'Mule runtime engine 4.3'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'MuleSoft'
    },
    {
        'vendor': 'MuleSoft, Inc.',
        'product': 'MuleSoft Anypoint'
    },
    {
        'vendor': 'Microhouse Systems, Inc.',
        'product': 'MultiFlex RMS'
    },
    {
        'vendor': 'MultiView, Inc.',
        'product': 'MultiView'
    },
    {
        'vendor': 'Multiable Company',
        'product': 'Multiable'
    },
    {
        'vendor': 'TDG Corporation',
        'product': 'Multibrowser'
    },
    {
        'vendor': 'Temenos Headquarters S.A.',
        'product': 'Multifonds'
    },
    {
        'vendor': 'Multipub',
        'product': 'Multipub'
    },
    {
        'vendor': 'Multivista Systems, LLC',
        'product': 'Multivista'
    },
    {
        'vendor': 'Mux, Inc.',
        'product': 'Mux'
    },
    {
        'vendor': 'My Counter',
        'product': 'My Counter'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'My Vision Express'
    },
    {
        'vendor': 'Evergage, Inc.',
        'product': 'MyBuys'
    },
    {
        'vendor': 'AppFolio, Inc.',
        'product': 'MyCase'
    },
    {
        'vendor': 'MyClientGlobal.com, Ltd.',
        'product': 'MyClient'
    },
    {
        'vendor': 'Digital River, Inc.',
        'product': 'MyCommerce'
    },
    {
        'vendor': 'Comodo Group, Inc.',
        'product': 'MyDLP'
    },
    {
        'vendor': 'Genuitec, LLC',
        'product': 'MyEclipse'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'MyFax'
    },
    {
        'vendor': 'West Corporation',
        'product': 'MyMediaInfo'
    },
    {
        'vendor': 'Mynewsdesk AB',
        'product': 'MyNewsDesk'
    },
    {
        'vendor': 'PIXID Group',
        'product': 'MyPIXID'
    },
    {
        'vendor': 'MyPagerank',
        'product': 'MyPagerank'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'MySQL'
    },
    {
        'vendor': 'myThings, Inc.',
        'product': 'MyThings'
    },
    {
        'vendor': 'Melian Labs, Inc.',
        'product': 'MyTime Scheduler'
    },
    {
        'vendor': 'Mycroft AI, Inc.',
        'product': 'Mycroft'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Mylyn'
    },
    {
        'vendor': 'Myriad Genetics, Inc.',
        'product': 'Myriad (Unspecified Product)'
    },
    {
        'vendor': 'Assurex Health, Inc.',
        'product': 'Myriad Neuroscience'
    },
    {
        'vendor': 'Mzinga, Inc.',
        'product': 'Mzinga OmniSocial'
    },
    {
        'vendor': 'N-Stalker',
        'product': 'N-Stalker'
    },
    {
        'vendor': 'Napa, Ltd.',
        'product': 'NAPA'
    },
    {
        'vendor': 'NAPA TRACS',
        'product': 'NAPA TRACS'
    },
    {
        'vendor': 'MSC Software Corporation',
        'product': 'NASTRAN'
    },
    {
        'vendor': 'NAVEX Global, Inc.',
        'product': 'NAVEX Global'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'NCR Connected Payments'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'NCR Counterpoint'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'NCR DI'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'NCR Retail'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'NCR Silver'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'NCR Vision'
    },
    {
        'vendor': 'Open Source',
        'product': 'ND4J'
    },
    {
        'vendor': 'Near Foundation',
        'product': 'NEAR'
    },
    {
        'vendor': 'NEC Corporation',
        'product': 'NEC (Unspecified Product)'
    },
    {
        'vendor': 'NEC Corporation',
        'product': 'NEC Express5800'
    },
    {
        'vendor': 'NEC Corporation',
        'product': 'NEC FlexProcess'
    },
    {
        'vendor': 'NEC Corporation',
        'product': 'NEC HYDRAstor'
    },
    {
        'vendor': 'NEC Corporation',
        'product': 'NEC SAN'
    },
    {
        'vendor': 'NEC Corporation',
        'product': 'NEC UNIVERGE 3C'
    },
    {
        'vendor': 'NEEVA GROUP',
        'product': 'NEEVA'
    },
    {
        'vendor': 'Cypher Learning, Inc.',
        'product': 'NEO LMS'
    },
    {
        'vendor': 'NEOGOV, Inc.',
        'product': 'NEOGOV'
    },
    {
        'vendor': 'Nest International, Inc.',
        'product': 'NEST Facilitate'
    },
    {
        'vendor': 'Paysafe Group, Ltd.',
        'product': 'NETELLER'
    },
    {
        'vendor': 'NETGEAR, Inc.',
        'product': 'NETGEAR'
    },
    {
        'vendor': 'NETGEAR, Inc.',
        'product': 'NETGEAR ProSafe'
    },
    {
        'vendor': 'NETGEAR, Inc.',
        'product': 'NETGEAR ReadyNAS'
    },
    {
        'vendor': 'Untangle, Inc.',
        'product': 'NG Firewall'
    },
    {
        'vendor': 'NGA Human Resources',
        'product': 'NGA Human Resources'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'NICE AIR & Engage'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'NICE Real-Time Impact'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'NICE inContact CXone'
    },
    {
        'vendor': 'NIKSUN, Inc.',
        'product': 'NIKSUN'
    },
    {
        'vendor': 'NIM Labs, LLC',
        'product': 'NIM'
    },
    {
        'vendor': 'National Insurance Producer Registry',
        'product': 'NIPR'
    },
    {
        'vendor': 'Open Source',
        'product': 'NLTK'
    },
    {
        'vendor': 'NM Incite, LLC',
        'product': 'NM Incite'
    },
    {
        'vendor': 'NOVAtime Technology, Inc',
        'product': 'NOVAtime'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'NOZA'
    },
    {
        'vendor': 'npm, Inc.',
        'product': 'NPM'
    },
    {
        'vendor': 'YourCause, LLC',
        'product': 'NPOconnect'
    },
    {
        'vendor': 'NSONE, Inc.',
        'product': 'NS1'
    },
    {
        'vendor': 'NS8, Inc.',
        'product': 'NS8'
    },
    {
        'vendor': 'NSFOCUS, Inc.',
        'product': 'NSFOCUS'
    },
    {
        'vendor': 'ASG Technologies Group, Inc.',
        'product': 'NTR Cloud'
    },
    {
        'vendor': 'NTT Data Corporation',
        'product': 'NTT Data (Unspecified Product)'
    },
    {
        'vendor': 'NTT Communications Corporation',
        'product': 'NTT Enterprise Cloud'
    },
    {
        'vendor': 'NTT Global Networks, Inc.',
        'product': 'NTT Global Network'
    },
    {
        'vendor': 'NUVI',
        'product': 'NUVI'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'NUnit'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA (Unspecified Product)'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA CUDA'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA DGX'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA DGX A100'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA DGX-1'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA DGX-2'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA DIGITS'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Drive'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA GeForce'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Iray'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Mental Ray'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA OptiX'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Quadro'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA TITAN'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Tesla'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Tesla P100 GPU'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Tesla V100 GPU'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVLink'
    },
    {
        'vendor': 'NWChem',
        'product': 'NWChem'
    },
    {
        'vendor': 'Nagios Enterprises',
        'product': 'Nagios'
    },
    {
        'vendor': 'Namely, Inc.',
        'product': 'Namely'
    },
    {
        'vendor': 'Nanigans, Inc.',
        'product': 'Nanigans'
    },
    {
        'vendor': 'Nanoscale Molecular Dynamics',
        'product': 'Nanoscale Molecular Dynamics'
    },
    {
        'vendor': 'Narratiive',
        'product': 'Narratiive'
    },
    {
        'vendor': 'Narrative Science, Inc.',
        'product': 'Narrative Science'
    },
    {
        'vendor': 'Narvar, Inc.',
        'product': 'Narvar'
    },
    {
        'vendor': 'Nastel Technologies',
        'product': 'Nastel'
    },
    {
        'vendor': 'Nasuni Corporation',
        'product': 'Nasuni'
    },
    {
        'vendor': 'NationBuilder',
        'product': 'NationBuilder'
    },
    {
        'vendor': 'National Instruments Corporation',
        'product': 'National Instruments'
    },
    {
        'vendor': 'National Tenant Network, Inc.',
        'product': 'National Tenant Network'
    },
    {
        'vendor': 'Nativo, Inc.',
        'product': 'Nativo'
    },
    {
        'vendor': 'Natro',
        'product': 'Natro'
    },
    {
        'vendor': 'Software AG',
        'product': 'Natural for Mainframe'
    },
    {
        'vendor': 'Software AG',
        'product': 'NaturalONE'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'Natus Camino'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'Natus EEG'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'Natus NeuroWorks'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'Natus Sleep (PSG)'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'Natus SleepWorks'
    },
    {
        'vendor': 'Navegg',
        'product': 'Navegg'
    },
    {
        'vendor': 'NaviNet',
        'product': 'NaviNet'
    },
    {
        'vendor': 'NantHealth, Inc.',
        'product': 'NaviNet Open'
    },
    {
        'vendor': 'Naviance, Inc.',
        'product': 'Naviance'
    },
    {
        'vendor': 'PremiumSoft CyberTech, Ltd.',
        'product': 'Navicat'
    },
    {
        'vendor': 'Naviga, Inc.',
        'product': 'Naviga (Unspecified Product)'
    },
    {
        'vendor': 'Naviga, Inc.',
        'product': 'Naviga Ad'
    },
    {
        'vendor': 'Navisite, LLC',
        'product': 'Navisite'
    },
    {
        'vendor': 'Navisite, LLC',
        'product': 'Navisite Disaster Recovery as a Service (DRaaS)'
    },
    {
        'vendor': 'Navisite, LLC',
        'product': 'Navisite Hosting'
    },
    {
        'vendor': 'NeTLIMS, LLC',
        'product': 'NeTLIMS'
    },
    {
        'vendor': 'Panorama Software, Ltd.',
        'product': 'Necto'
    },
    {
        'vendor': 'Needles',
        'product': 'Needles'
    },
    {
        'vendor': 'Nelnet, Inc.',
        'product': 'Nelnet'
    },
    {
        'vendor': 'Nemetschek SE',
        'product': 'Nemetschek'
    },
    {
        'vendor': 'PayPal, Inc.',
        'product': 'NemoJS'
    },
    {
        'vendor': 'Neo4j, Inc.',
        'product': 'Neo4j'
    },
    {
        'vendor': 'NeoXam Services SAS',
        'product': 'NeoXam DataHub'
    },
    {
        'vendor': 'NeoXam Services SAS',
        'product': 'NeoXam Investment Accounting'
    },
    {
        'vendor': 'NeoXam Services SAS',
        'product': 'NeoXam Manager'
    },
    {
        'vendor': 'Neocase Software SAS',
        'product': 'Neocase HR Power'
    },
    {
        'vendor': 'Neodata S.A de C.V.',
        'product': 'Neodata'
    },
    {
        'vendor': 'Neon One',
        'product': 'NeonCRM'
    },
    {
        'vendor': 'Neotys',
        'product': 'Neotys'
    },
    {
        'vendor': 'Neptune Software A/S',
        'product': 'Neptune DX Platform'
    },
    {
        'vendor': 'ECI Telecom, Ltd.',
        'product': 'Neptune NPT-1200'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'Net Optics'
    },
    {
        'vendor': 'Net-Results',
        'product': 'Net-Results'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp (Unspecified Product)'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp AFF A300'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp AFF A700'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp AFF-Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Brocade Encryption'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Cloud Backup'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Cloud Volumes'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Common Internet File System (CIFS)'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Data Infrastructure Management'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Data ONTAP'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Data Storage Systems'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp DataFort'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp E-Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp E2600'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp E2800 Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp E5400'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp EF-Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Enterprise Storage Systems'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS Series Storage Systems'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS2000'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS2200'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS2500 Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS2600 Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS3000'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS3100'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS3100 Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS3200'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS6000'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS6200'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS8000'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FAS9000'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FC SAN Storage Solution'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FilerView'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FlashRay'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FlexCache'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FlexClone'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FlexShare'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp FlexVol'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp HCI'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp MetroCluster'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Multistore'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Network Attached Storage (NAS)'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Network File System'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Open Systems SnapVault'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Raid-DP'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SAN'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SANtricity'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapDrive'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapLock'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapManager'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapMirror'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapProtect'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapRestore'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapShot'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SnapVault'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SolidFire'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SolidFire Element OS'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SolidFire Element X'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp StorageGRID Webscale'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SupportEdge'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp SyncMirror'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp Trident'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp V-Series'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp iSCSI SAN Storage Solution'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp iSCSI SAN Storage System'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'NetBackup PureDisk'
    },
    {
        'vendor': 'NetBase',
        'product': 'NetBase'
    },
    {
        'vendor': 'NetCracker Technology Corporation',
        'product': 'NetCracker'
    },
    {
        'vendor': 'NetDocuments Software, Inc.',
        'product': 'NetDocuments'
    },
    {
        'vendor': 'NetEnrich, Inc.',
        'product': 'NetEnrich'
    },
    {
        'vendor': 'NetFacilities',
        'product': 'NetFacilities'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'NetFlow Analyzer'
    },
    {
        'vendor': 'NetFortris, Inc.',
        'product': 'NetFortris Fonality'
    },
    {
        'vendor': 'ACCESS Company, Ltd.',
        'product': 'NetFront'
    },
    {
        'vendor': 'Halo Service Solutions',
        'product': 'NetHelpDesk'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ Aegis'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ AppManager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ Directory and Resource'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ Group Policy Administrator'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ Privileged Account Manager'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ Sentinel'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ VigilEnt Policy Center'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'NetIQ Vivinet Assessor'
    },
    {
        'vendor': 'NetMotion Software, Inc.',
        'product': 'NetMotion Wireless'
    },
    {
        'vendor': 'Wipro, Ltd.',
        'product': 'NetOxygen LOS'
    },
    {
        'vendor': 'Netpresenter B.V.',
        'product': 'NetPresenter'
    },
    {
        'vendor': 'NetRefer',
        'product': 'NetRefer'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout (Unspecified Product)'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout AirMagnet'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout OptiView XG'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout Spectra2'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout TruView'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout nGeniusONE'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'NetScout nGeniusPULSE'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite Bronto'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite CRM'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite ERP'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite FMS'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite Financial Management'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite OneWorld'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite OpenAir'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite QuickArrow'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite Retail'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteAnalytics'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteBuilder'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteBundler'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteCloud'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteCommerce'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteFlex'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteFlow'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuitePeople'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteScript'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'NetSuite SuiteTalk'
    },
    {
        'vendor': 'NetSupport, Inc.',
        'product': 'NetSupport (Unspecified Product)'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'NetVanta 1200'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'NetVanta 3000'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'NetVanta 4000'
    },
    {
        'vendor': 'NetXposure, Inc.',
        'product': 'NetX DAM'
    },
    {
        'vendor': 'Netbiscuits GmbH',
        'product': 'Netbiscuits'
    },
    {
        'vendor': 'Netbrain',
        'product': 'Netbrain'
    },
    {
        'vendor': 'Netchex',
        'product': 'Netchex'
    },
    {
        'vendor': 'Netdata, Inc.',
        'product': 'Netdata'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Netezza'
    },
    {
        'vendor': 'Netflix, Inc.',
        'product': 'Netflix Conductor'
    },
    {
        'vendor': 'Norsys Software Corporation',
        'product': 'Netica'
    },
    {
        'vendor': 'Netintegrity, Inc.',
        'product': 'Netintegrity'
    },
    {
        'vendor': 'Netive VMS B.V.',
        'product': 'Netive'
    },
    {
        'vendor': 'Netlify, Inc.',
        'product': 'Netlify'
    },
    {
        'vendor': 'Netmining, LLC',
        'product': 'Netmining'
    },
    {
        'vendor': 'Power Competence Oy',
        'product': 'Netmonitor'
    },
    {
        'vendor': 'Netnames',
        'product': 'Netnames Cedel'
    },
    {
        'vendor': 'Neto E-commerce Solutions Pty Ltd',
        'product': 'Neto Ecommerce'
    },
    {
        'vendor': 'Netriplex',
        'product': 'Netriplex'
    },
    {
        'vendor': 'NetroxSC',
        'product': 'Netrox SC'
    },
    {
        'vendor': 'Netskope, Inc.',
        'product': 'Netskope'
    },
    {
        'vendor': 'Netsmart Technologies, Inc.',
        'product': 'Netsmart'
    },
    {
        'vendor': 'Netsmart Technologies, Inc.',
        'product': 'Netsmart Post Acute Care'
    },
    {
        'vendor': 'Netsparker, Ltd.',
        'product': 'Netsparker'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'Netsuite Partner Relationship Management'
    },
    {
        'vendor': 'Netsweeper, Inc.',
        'product': 'Netsweeper'
    },
    {
        'vendor': 'Open Source',
        'product': 'Netty'
    },
    {
        'vendor': 'Metricly',
        'product': 'Netuitive'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Network Flow Analysis'
    },
    {
        'vendor': 'Network Solutions, LLC',
        'product': 'Network Solutions DNS'
    },
    {
        'vendor': 'Network Solutions, LLC',
        'product': 'Network Solutions Hosting'
    },
    {
        'vendor': 'Network Solutions, LLC',
        'product': 'Network Solutions Seal'
    },
    {
        'vendor': 'Network Solutions, LLC',
        'product': 'Network Solutions eCommerce'
    },
    {
        'vendor': 'Network for Good, Inc.',
        'product': 'Network for Good Donor Management'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Networkfleet'
    },
    {
        'vendor': 'Netwrix Corporation',
        'product': 'Netwrix (Unspecified Product)'
    },
    {
        'vendor': 'Netwrix Corporation',
        'product': 'Netwrix Auditor'
    },
    {
        'vendor': 'NeuLion, Inc.',
        'product': 'NeuLion'
    },
    {
        'vendor': 'NeuVector, Inc.',
        'product': 'NeuVector'
    },
    {
        'vendor': 'Artificial Intelligence Techniques, Ltd.',
        'product': 'Neural Designer'
    },
    {
        'vendor': 'NeuroLogica Corporation',
        'product': 'NeuroLogica'
    },
    {
        'vendor': 'NeuroLogica Corporation',
        'product': 'NeuroLogica BodyTom'
    },
    {
        'vendor': 'NeuroLogica Corporation',
        'product': 'NeuroLogica CereTom'
    },
    {
        'vendor': 'SourceForge',
        'product': 'Neuroph'
    },
    {
        'vendor': 'Neusoft Medical Systems',
        'product': 'Neusoft Medical Systems'
    },
    {
        'vendor': 'Neustar, Inc.',
        'product': 'Neustar'
    },
    {
        'vendor': 'Neustar, Inc.',
        'product': 'Neustar PlatformOne'
    },
    {
        'vendor': 'Neustar, Inc.',
        'product': 'Neustar SiteProtect NG'
    },
    {
        'vendor': 'Nevercode, Ltd.',
        'product': 'Nevercode'
    },
    {
        'vendor': 'Neverfail, Inc.',
        'product': 'Neverfail (Unspecified Product)'
    },
    {
        'vendor': 'Nevron Software, LLC',
        'product': 'Nevron (Unspecified Product)'
    },
    {
        'vendor': 'New Generation Software, Inc.',
        'product': 'New Generation Software'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic (Unspecified Product)'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic APM'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic Browser'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic Infrastructure'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic Insights'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic Mobile'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic One'
    },
    {
        'vendor': 'New Relic, Inc.',
        'product': 'New Relic Synthetics'
    },
    {
        'vendor': 'NewTek, Inc.',
        'product': 'NewTek (Unspecified Product)'
    },
    {
        'vendor': 'NewTek, Inc.',
        'product': 'NewTek TriCaster'
    },
    {
        'vendor': 'Vonage Holdings Corporation',
        'product': 'NewVoiceMedia'
    },
    {
        'vendor': 'Newforma, Inc.',
        'product': 'Newforma'
    },
    {
        'vendor': 'Newgen Software Technologies, Ltd.',
        'product': 'Newgen'
    },
    {
        'vendor': 'Newgen Software Technologies, Ltd.',
        'product': 'Newgen OmniDocs'
    },
    {
        'vendor': 'NewsCred, Inc.',
        'product': 'NewsCred'
    },
    {
        'vendor': 'Newsela, Inc.',
        'product': 'Newsela'
    },
    {
        'vendor': 'Newstore, Inc.',
        'product': 'Newstore'
    },
    {
        'vendor': 'Paycor, Inc.',
        'product': 'Newton Software'
    },
    {
        'vendor': 'Newtron GmbH',
        'product': 'Newtron'
    },
    {
        'vendor': 'Nexcess.Net, LLC',
        'product': 'Nexcess'
    },
    {
        'vendor': 'Nexcess.Net, LLC',
        'product': 'Nexcess Hosting'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nexidia Analytics'
    },
    {
        'vendor': 'Nexkey, Inc.',
        'product': 'Nexkey'
    },
    {
        'vendor': 'Vonage Holdings Corporation',
        'product': 'Nexmo'
    },
    {
        'vendor': 'Nexonia, Inc.',
        'product': 'Nexonia'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'Nexpose'
    },
    {
        'vendor': 'Nexsan, Inc.',
        'product': 'Nexsan'
    },
    {
        'vendor': 'Nexsan, Inc.',
        'product': 'Nexsan Beast'
    },
    {
        'vendor': 'XDimensional Technologies, Inc.',
        'product': 'Nexsure'
    },
    {
        'vendor': 'Vercel, Inc.',
        'product': 'Next.js'
    },
    {
        'vendor': 'Next Bee Corporation',
        'product': 'NextBee'
    },
    {
        'vendor': 'NextGate Solutions, Inc.',
        'product': 'NextGate Solutions'
    },
    {
        'vendor': 'NextGen Healthcare, Inc.',
        'product': 'NextGen Clearinghouse'
    },
    {
        'vendor': 'NextGen Healthcare, Inc.',
        'product': 'NextGen Connect Integration Engine'
    },
    {
        'vendor': 'NextGen Healthcare, Inc.',
        'product': 'NextGen Healthcare'
    },
    {
        'vendor': 'NextGen Healthcare, Inc.',
        'product': 'NextGen Healthcare (Unspecified Product)'
    },
    {
        'vendor': 'NextGen Healthcare, Inc.',
        'product': 'NextGen Office'
    },
    {
        'vendor': 'NextMark, Inc.',
        'product': 'NextMark'
    },
    {
        'vendor': 'NextSTAT',
        'product': 'NextSTAT'
    },
    {
        'vendor': 'Next Technik Pty Ltd',
        'product': 'NextService'
    },
    {
        'vendor': 'Nextech Systems, LLC',
        'product': 'Nextech EMR'
    },
    {
        'vendor': 'Illumina, Inc.',
        'product': 'Nextera Flex'
    },
    {
        'vendor': 'TrueCommerce, Inc.',
        'product': 'Nexternal eCommerce'
    },
    {
        'vendor': 'Nexthink S.A.',
        'product': 'Nexthink'
    },
    {
        'vendor': 'Nextiva, Inc.',
        'product': 'Nextiva'
    },
    {
        'vendor': 'Nextopia Software Corporation',
        'product': 'Nextopia'
    },
    {
        'vendor': 'Sonatype, Inc.',
        'product': 'Nexus Auditor'
    },
    {
        'vendor': 'Nexus AG',
        'product': 'Nexus KIS'
    },
    {
        'vendor': 'Sonatype, Inc.',
        'product': 'Nexus Lifecycle'
    },
    {
        'vendor': 'Sonatype, Inc.',
        'product': 'Nexus Repository Manager'
    },
    {
        'vendor': 'Nexus Systems',
        'product': 'Nexus Systems'
    },
    {
        'vendor': 'Sonatype, Inc.',
        'product': 'Nexus Vulnerability Scanner'
    },
    {
        'vendor': 'Ngenix, LLC',
        'product': 'Ngenix'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice Actimize'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice Call Recording'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice RPA'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice SmartCenter'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice Systems'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice Workforce Management'
    },
    {
        'vendor': 'NICE, Ltd.',
        'product': 'Nice inContact'
    },
    {
        'vendor': 'Nicereply s.r.o.',
        'product': 'Nicereply'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'Nicolet NicVue'
    },
    {
        'vendor': 'Natus Medical, Inc.',
        'product': 'NicoletOne EEG'
    },
    {
        'vendor': 'Nielsen Holdings PLC',
        'product': 'Nielsen Ad Intel'
    },
    {
        'vendor': 'Nielsen Holdings PLC',
        'product': 'Nielsen Data Management Platform'
    },
    {
        'vendor': 'Nielsen Holdings PLC',
        'product': 'Nielsen Digital Ad Ratings'
    },
    {
        'vendor': 'Nielsen Holdings PLC',
        'product': 'Nielsen NetRatings'
    },
    {
        'vendor': 'Telus Health',
        'product': 'Nightingale'
    },
    {
        'vendor': 'Pine View Software AS',
        'product': 'Nighwatch.js'
    },
    {
        'vendor': 'Nihon Kohden Corporation',
        'product': 'Nihon Kohden'
    },
    {
        'vendor': 'Nihon Kohden America',
        'product': 'Nihon Kohden America'
    },
    {
        'vendor': 'Open Source',
        'product': 'Nikto'
    },
    {
        'vendor': 'Nimbix, Inc.',
        'product': 'Nimbix'
    },
    {
        'vendor': 'Nimble, Inc.',
        'product': 'Nimble'
    },
    {
        'vendor': 'HPE',
        'product': 'Nimble Adaptive Flash Arrays'
    },
    {
        'vendor': 'HPE',
        'product': 'Nimble All Flash Arrays'
    },
    {
        'vendor': 'Nimbus Data, Inc.',
        'product': 'Nimbus Data'
    },
    {
        'vendor': 'NinjaCat, Inc.',
        'product': 'NinjaCat'
    },
    {
        'vendor': 'NinjaRMM, LLC',
        'product': 'NinjaRMM'
    },
    {
        'vendor': 'Nintex Global, Ltd.',
        'product': 'Nintex'
    },
    {
        'vendor': 'NinthDecimal, Inc.',
        'product': 'NinthDecimal'
    },
    {
        'vendor': 'Nitro Software, Inc.',
        'product': 'Nitro PDF'
    },
    {
        'vendor': 'Nitro Software, Inc.',
        'product': 'Nitro Pro'
    },
    {
        'vendor': 'NitroSell, Ltd.',
        'product': 'NitroSell'
    },
    {
        'vendor': 'ThemeIsle',
        'product': 'Nivo Slider'
    },
    {
        'vendor': 'Nlyte Software, Ltd.',
        'product': 'Nlyte'
    },
    {
        'vendor': 'Open Source',
        'product': 'Nmap'
    },
    {
        'vendor': 'NoMachine SARL',
        'product': 'NoMachine'
    },
    {
        'vendor': 'Noble Systems',
        'product': 'Noble Outbound'
    },
    {
        'vendor': 'Node',
        'product': 'Node'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'Node-RED'
    },
    {
        'vendor': 'Open Source',
        'product': 'Node.js'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Noetix'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Noetix Analytics'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'Noetix Generator'
    },
    {
        'vendor': 'Magnitude Software, Inc.',
        'product': 'NoetixViews'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia 7330'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia 7342'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia 7705'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia 7750'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia 7950'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia CloudBand'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia VitalQIP'
    },
    {
        'vendor': 'Nokia Corporation',
        'product': 'Nokia WING'
    },
    {
        'vendor': 'Noguska, Inc.',
        'product': 'NolaPro'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Nolio Release Automation'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'Nomad'
    },
    {
        'vendor': 'Nomalys',
        'product': 'Nomalys'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Nominum'
    },
    {
        'vendor': 'Nomitech, Ltd.',
        'product': 'Nomitech CostOS'
    },
    {
        'vendor': 'NonProfitEasy, Inc.',
        'product': 'NonProfitEasy'
    },
    {
        'vendor': 'HPE',
        'product': 'NonStop SQL'
    },
    {
        'vendor': 'Noosh, Inc.',
        'product': 'Noosh'
    },
    {
        'vendor': 'Open Source',
        'product': 'NopCommerce'
    },
    {
        'vendor': 'NopSec.com, Inc.',
        'product': 'NopSec'
    },
    {
        'vendor': 'Tefincom & Company S.A.',
        'product': 'NordVPN'
    },
    {
        'vendor': 'Nortel Networks Corporation',
        'product': 'Nortel'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Nortel Centillion'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Nortel Contivity'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Nortel DMS'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Nortel Meridian'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Nortel Norstar'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Nortel Symposium'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Nortel TN-1C'
    },
    {
        'vendor': 'Ciena Corporation',
        'product': 'Nortel TN-1X'
    },
    {
        'vendor': 'North Plains Systems Corporation',
        'product': 'North Plains'
    },
    {
        'vendor': 'Northpass, Inc.',
        'product': 'Northpass'
    },
    {
        'vendor': 'Northstar Technologies, Inc.',
        'product': 'Northstar Club'
    },
    {
        'vendor': 'NortonLifeLock, Inc.',
        'product': 'Norton Ghost'
    },
    {
        'vendor': 'NortonLifeLock, Inc.',
        'product': 'Norton Shopping Guarantee'
    },
    {
        'vendor': 'NortonLifeLock, Inc.',
        'product': 'NortonLifeLock'
    },
    {
        'vendor': 'Nosto Solutions Oy',
        'product': 'Nosto'
    },
    {
        'vendor': 'NoteVault',
        'product': 'NoteVault'
    },
    {
        'vendor': 'Notifii, LLC',
        'product': 'Notifii'
    },
    {
        'vendor': 'Notion Labs, Inc.',
        'product': 'Notion'
    },
    {
        'vendor': 'NovaMind Pty Ltd',
        'product': 'NovaMind'
    },
    {
        'vendor': 'Illumina, Inc.',
        'product': 'NovaSeq'
    },
    {
        'vendor': 'Novarad Corporation',
        'product': 'Novarad'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Novell Data Synchronizer'
    },
    {
        'vendor': 'Novo Solutions',
        'product': 'Novo Help Desk'
    },
    {
        'vendor': 'Novopath, LLC',
        'product': 'Novopath'
    },
    {
        'vendor': 'Now Commerce, LLC',
        'product': 'Now Commerce'
    },
    {
        'vendor': 'Now Interact',
        'product': 'Now Interact'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'Now Platform'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'Now Platform App Engine'
    },
    {
        'vendor': 'Nozomi Networks, Inc.',
        'product': 'Nozomi Networks'
    },
    {
        'vendor': 'Ntirety, Inc.',
        'product': 'Ntirety'
    },
    {
        'vendor': 'NuAire, Inc.',
        'product': 'NuAire AireGard'
    },
    {
        'vendor': 'NuCaptcha',
        'product': 'NuCaptcha'
    },
    {
        'vendor': 'NuORDER',
        'product': 'NuORDER'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'NuView Core HRMS'
    },
    {
        'vendor': 'Nuage Networks',
        'product': 'Nuage Networks'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Analytics'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance CDE'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Clintegrity 360'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Clintegrity 360 Quantim'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Conversational IVR'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Dictaphone'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Editscript'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance IVR Tooling Suite'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Insights'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance JA Thomas'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Nina'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance PaperPort'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance PowerScribe'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance PowerShare'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance RadWhere'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Recognizer'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance SpeechMagic'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Text to Speech'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance Transcend'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Nuance eScription'
    },
    {
        'vendor': 'AdvancedMD, Inc.',
        'product': 'NueMD'
    },
    {
        'vendor': 'Nuffnang Sdn. Bhd.',
        'product': 'Nuffnang'
    },
    {
        'vendor': 'Nuix Pty Ltd',
        'product': 'Nuix'
    },
    {
        'vendor': 'Nuix Pty Ltd',
        'product': 'Nuix Discover'
    },
    {
        'vendor': 'Foundry Visionmongers, Ltd.',
        'product': 'Nuke'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'NumPy'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'Numara'
    },
    {
        'vendor': 'Numenta, Inc.',
        'product': 'Numenta'
    },
    {
        'vendor': 'Market Track, LLC',
        'product': 'Numerator'
    },
    {
        'vendor': 'Numetric, Inc.',
        'product': 'Numetric'
    },
    {
        'vendor': 'Mozilla Corporation',
        'product': 'Nunjucks'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'NuoDB'
    },
    {
        'vendor': 'NurseGrid',
        'product': 'NurseGrid'
    },
    {
        'vendor': 'The Advisory Board Company',
        'product': 'Nursing Compass'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix AHV'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Acropolis'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Calm'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Enterprise Cloud'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Files'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Flow'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix HCI'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix HPE ProLiant DX'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Karbon'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Mine'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Move'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix NX'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Objects'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Prism'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Prism Pro'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix X-Ray'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Xi Cloud Services'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Xi Epoch'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Xi Frame'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'Nutanix Xi Leap'
    },
    {
        'vendor': 'Nutcache Technologies, Inc.',
        'product': 'Nutcache'
    },
    {
        'vendor': 'Nutshell, Inc.',
        'product': 'Nutshell CRM'
    },
    {
        'vendor': 'Nuvem Shop',
        'product': 'Nuvem Shop'
    },
    {
        'vendor': 'Nuvolo Technologies Corporation',
        'product': 'Nuvolo'
    },
    {
        'vendor': 'Nuxeo',
        'product': 'Nuxeo'
    },
    {
        'vendor': 'Nvoicepay',
        'product': 'Nvoicepay'
    },
    {
        'vendor': 'Nyansa, Inc.',
        'product': 'Nyansa'
    },
    {
        'vendor': 'Nylas, Inc.',
        'product': 'Nylas'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'O-arm Surgical Imaging System'
    },
    {
        'vendor': 'Universal Research Solutions',
        'product': 'OBERD'
    },
    {
        'vendor': 'OBIC Company, Ltd.',
        'product': 'OBIC 7'
    },
    {
        'vendor': 'Clinical Computer Systems, Inc.',
        'product': 'OBIX Perinatal Data System'
    },
    {
        'vendor': 'O. C. Tanner Company',
        'product': 'OC Tanner'
    },
    {
        'vendor': 'OCZ',
        'product': 'OCZ Vector'
    },
    {
        'vendor': 'OM Partners N.V.',
        'product': 'OM Partners'
    },
    {
        'vendor': 'ON24, Inc.',
        'product': 'ON24'
    },
    {
        'vendor': 'Bogardus Medical Systems, Inc.',
        'product': 'ONCOCHART'
    },
    {
        'vendor': 'AOL',
        'product': 'ONE by AOL'
    },
    {
        'vendor': 'ONICON, Inc.',
        'product': 'ONICON'
    },
    {
        'vendor': 'Ascensio System SIA',
        'product': 'ONLYOFFICE'
    },
    {
        'vendor': 'Open Source',
        'product': 'ONNX'
    },
    {
        'vendor': 'ONRAD, Inc.',
        'product': 'ONRAD'
    },
    {
        'vendor': 'SMA Technologies',
        'product': 'OPCon'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'OPNFV'
    },
    {
        'vendor': 'ORBCOMM, Inc.',
        'product': 'ORBCOMM'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'ORSOS'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'ORSYP'
    },
    {
        'vendor': 'ORTEC B.V.',
        'product': 'ORTEC Harmony'
    },
    {
        'vendor': 'Omnistar Interactive, LLC',
        'product': 'OSI Affiliate'
    },
    {
        'vendor': 'OSIsoft, LLC',
        'product': 'OSISoft'
    },
    {
        'vendor': 'MediaFront',
        'product': 'OSM Player'
    },
    {
        'vendor': 'OSSEC Foundation',
        'product': 'OSSEC'
    },
    {
        'vendor': 'OPTIMAL SYSTEMS GmbH',
        'product': 'OS|ECM'
    },
    {
        'vendor': 'OVH Hosting',
        'product': 'OVH'
    },
    {
        'vendor': 'OWASP Foundation, Inc.',
        'product': 'OWASP Dependency-Check'
    },
    {
        'vendor': 'OWASP Foundation, Inc.',
        'product': 'OWASP Zed Attack Proxy (ZAP)'
    },
    {
        'vendor': 'Telus Health',
        'product': 'Oacis'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'Oaisys'
    },
    {
        'vendor': 'ObjectWay S.p.A.',
        'product': 'ObjectWay'
    },
    {
        'vendor': 'Objectivity, Inc.',
        'product': 'Objectivity'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'ObserveIT'
    },
    {
        'vendor': 'Obsidian Security, Inc.',
        'product': 'Obsidian'
    },
    {
        'vendor': 'Occasion',
        'product': 'Occasion'
    },
    {
        'vendor': 'Octane AI, Inc.',
        'product': 'Octane AI'
    },
    {
        'vendor': 'Octobat',
        'product': 'Octobat'
    },
    {
        'vendor': 'Octopus Deploy Pty Ltd',
        'product': 'Octopus Deploy'
    },
    {
        'vendor': 'Qognify, Ltd.',
        'product': 'Ocularis'
    },
    {
        'vendor': 'Oculu, LLC',
        'product': 'Oculu'
    },
    {
        'vendor': 'Odaseva.com, Inc.',
        'product': 'Odaseva'
    },
    {
        'vendor': 'Odigo SAS',
        'product': 'Odigo'
    },
    {
        'vendor': 'Odoo S.A.',
        'product': 'Odoo (Unspecified Product)'
    },
    {
        'vendor': 'Odoo S.A.',
        'product': 'Odoo CRM'
    },
    {
        'vendor': 'Odoo S.A.',
        'product': 'Odoo eCommerce'
    },
    {
        'vendor': 'Office Ally, Inc.',
        'product': 'Office Ally'
    },
    {
        'vendor': 'Connexin Software, Inc.',
        'product': 'Office Practicum'
    },
    {
        'vendor': 'Officevibe, Inc.',
        'product': 'Officevibe'
    },
    {
        'vendor': 'Enverus',
        'product': 'Oildex'
    },
    {
        'vendor': 'Okera, Inc.',
        'product': 'Okera'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta (Unspecified Product)'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta API Access Management'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Access Gateway for Workforce'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Adaptive Multi-Factor Authentication'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Authentication'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Authorization'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Identity Cloud'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Lifecycle Management'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Single Sign-On'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Universal Directory'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta User Management'
    },
    {
        'vendor': 'Oktopost Technologies, Inc.',
        'product': 'Oktopost'
    },
    {
        'vendor': 'Olapic, Inc.',
        'product': 'Olapic'
    },
    {
        'vendor': 'Olark',
        'product': 'Olark'
    },
    {
        'vendor': 'Olive AI, Inc.',
        'product': 'Olive AI'
    },
    {
        'vendor': 'Olo, Inc.',
        'product': 'Olo'
    },
    {
        'vendor': 'ERI BANCAIRE S.A.',
        'product': 'Olympic Banking'
    },
    {
        'vendor': 'Olympus Corporation of the Americas',
        'product': 'Olympus EndoWorks'
    },
    {
        'vendor': 'Omada Health, Inc.',
        'product': 'Omada Health'
    },
    {
        'vendor': 'Omada A/S',
        'product': 'Omada Identity Suite'
    },
    {
        'vendor': 'Omadi',
        'product': 'Omadi'
    },
    {
        'vendor': 'Omega A/S',
        'product': 'Omega Pims'
    },
    {
        'vendor': 'Ometria, Ltd.',
        'product': 'Ometria'
    },
    {
        'vendor': 'Information Builders, Inc.',
        'product': 'Omni-Gen'
    },
    {
        'vendor': 'OmniComm Systems, Inc.',
        'product': 'OmniComm'
    },
    {
        'vendor': 'OmniComm Systems, Inc.',
        'product': 'OmniComm TrialMaster'
    },
    {
        'vendor': 'Newgen Software Technologies, Ltd.',
        'product': 'OmniFlow iBPS'
    },
    {
        'vendor': 'The Omni Group',
        'product': 'OmniFocus'
    },
    {
        'vendor': 'The Omni Group',
        'product': 'OmniGraffle'
    },
    {
        'vendor': 'OmniMD',
        'product': 'OmniMD'
    },
    {
        'vendor': 'OmniSci, Inc.',
        'product': 'OmniSci'
    },
    {
        'vendor': 'OmniSite, LLC',
        'product': 'OmniSite'
    },
    {
        'vendor': 'OmniUpdate, Inc.',
        'product': 'OmniUpdate'
    },
    {
        'vendor': 'Omnicell, Inc.',
        'product': 'Omnicell'
    },
    {
        'vendor': 'Omnicell, Inc.',
        'product': 'Omnicell IVX Workflow'
    },
    {
        'vendor': 'Omniconvert S.R.L.',
        'product': 'Omniconvert'
    },
    {
        'vendor': 'Omnilert, LLC',
        'product': 'Omnilert'
    },
    {
        'vendor': 'Omnitracs, LLC',
        'product': 'Omnitracs'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Omniture (Unspecified Product)'
    },
    {
        'vendor': 'Omnivex Corporation',
        'product': 'Omnivex'
    },
    {
        'vendor': 'On Center Software',
        'product': 'On Center Software'
    },
    {
        'vendor': 'OnApp, Ltd.',
        'product': 'OnApp'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'OnCommand Insight'
    },
    {
        'vendor': 'WorkWise, LLC',
        'product': 'OnContact CRM'
    },
    {
        'vendor': 'On Deck Capital, Inc.',
        'product': 'OnDeck Capital'
    },
    {
        'vendor': 'OnPay Solutions, LLC',
        'product': 'OnPay'
    },
    {
        'vendor': 'OnPoint Digital, Inc.',
        'product': 'OnPoint Digital'
    },
    {
        'vendor': 'Intrado Corporation',
        'product': 'OnSIP'
    },
    {
        'vendor': 'OnScale, Inc.',
        'product': 'OnScale'
    },
    {
        'vendor': 'Onapsis, Inc.',
        'product': 'Onapsis (Unspecified Product)'
    },
    {
        'vendor': 'ExactHire',
        'product': 'OnboardCentric'
    },
    {
        'vendor': 'Onclusive, Inc.',
        'product': 'Onclusive'
    },
    {
        'vendor': 'Flatiron Health, Inc.',
        'product': 'OncoEMR'
    },
    {
        'vendor': 'WorkWise, LLC',
        'product': 'Oncontact'
    },
    {
        'vendor': 'OnSolve, LLC',
        'product': 'One Call Now'
    },
    {
        'vendor': 'One Identity, LLC',
        'product': 'One Identity Defender'
    },
    {
        'vendor': 'One Identity, LLC',
        'product': 'One Identity Manager'
    },
    {
        'vendor': 'One Network Enterprises',
        'product': 'One Network TMS'
    },
    {
        'vendor': 'One2Team, Inc.',
        'product': 'One2Team'
    },
    {
        'vendor': 'OneAll',
        'product': 'OneAll'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'OneCommand'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'OneContent'
    },
    {
        'vendor': 'OneLogin, Inc.',
        'product': 'OneLogin'
    },
    {
        'vendor': 'OneNeck IT Solutions, LLC',
        'product': 'OneNeck'
    },
    {
        'vendor': 'OnePacs, LLC',
        'product': 'OnePacs'
    },
    {
        'vendor': 'OnePageCRM',
        'product': 'OnePageCRM'
    },
    {
        'vendor': 'OneShield, Inc.',
        'product': 'OneShield'
    },
    {
        'vendor': 'OneSignal, Inc.',
        'product': 'OneSignal'
    },
    {
        'vendor': 'OneSource Virtual, Inc.',
        'product': 'OneSource Virtual'
    },
    {
        'vendor': 'OneSpan, Inc.',
        'product': 'OneSpan'
    },
    {
        'vendor': 'OneStat International B.V.',
        'product': 'OneStat'
    },
    {
        'vendor': 'OneStream Software, LLC',
        'product': 'OneStream'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'OneSumX'
    },
    {
        'vendor': 'OneMarket Data, LLC',
        'product': 'OneTick'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'OneTrust'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'OneTrust DataGovernance'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'OneTrust GRC'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'OneTrust Privacy'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'OneTrust Vendorpedia'
    },
    {
        'vendor': 'Onehub, Inc.',
        'product': 'Onehub'
    },
    {
        'vendor': 'Onespot',
        'product': 'Onespot'
    },
    {
        'vendor': 'Oneview Healthcare',
        'product': 'Oneview Healthcare'
    },
    {
        'vendor': 'Onfido, Ltd.',
        'product': 'Onfido'
    },
    {
        'vendor': 'Onguard B.V.',
        'product': 'Onguard'
    },
    {
        'vendor': 'Web Stats',
        'product': 'Onlinewebstat'
    },
    {
        'vendor': 'Onna Technologies, Inc.',
        'product': 'Onna'
    },
    {
        'vendor': 'Onshape, Inc.',
        'product': 'Onshape'
    },
    {
        'vendor': 'OnShift, Inc.',
        'product': 'Onshift'
    },
    {
        'vendor': 'Onstream Media Corporation',
        'product': 'Onstream Media'
    },
    {
        'vendor': 'Onswipe',
        'product': 'Onswipe'
    },
    {
        'vendor': 'Ontario Systems, LLC',
        'product': 'Ontario Systems (Unspecified Product)'
    },
    {
        'vendor': 'Ontolo, LLC',
        'product': 'Ontolo'
    },
    {
        'vendor': 'Ontraport, Inc.',
        'product': 'Ontraport'
    },
    {
        'vendor': 'Onvia, Inc.',
        'product': 'Onvia'
    },
    {
        'vendor': 'Ooma, Inc.',
        'product': 'Ooma'
    },
    {
        'vendor': 'Ooyala, Inc.',
        'product': 'Ooyala'
    },
    {
        'vendor': 'Ooyala, Inc.',
        'product': 'Ooyala Flex Media Platform'
    },
    {
        'vendor': 'Dimension Data Holdings PLC',
        'product': 'OpSource'
    },
    {
        'vendor': 'SAP SE',
        'product': 'OpTier Always-on APM'
    },
    {
        'vendor': 'Xandr, Inc.',
        'product': 'Open AdStream'
    },
    {
        'vendor': 'The Khronos Group, Inc.',
        'product': 'Open Computing Language (OpenCL)'
    },
    {
        'vendor': 'Open Dental Software, Inc.',
        'product': 'Open Dental'
    },
    {
        'vendor': 'Open Door Logistics, Ltd.',
        'product': 'Open Door Logistics Studio'
    },
    {
        'vendor': 'The Khronos Group, Inc.',
        'product': 'Open Graphics Library (OpenGL)'
    },
    {
        'vendor': 'SourceForge',
        'product': 'Open Grid Scheduler'
    },
    {
        'vendor': 'Pegasus Solutions, Inc.',
        'product': 'Open Hospitality'
    },
    {
        'vendor': 'Learning Technologies Group PLC',
        'product': 'Open LMS'
    },
    {
        'vendor': 'OpenMP ARB',
        'product': 'Open Multi-Processing (OpenMP)'
    },
    {
        'vendor': 'Open Systems, Inc.',
        'product': 'Open Systems (Unspecified Product)'
    },
    {
        'vendor': 'Open Systems, Inc.',
        'product': 'Open Systems Accounting Software (OSAS)'
    },
    {
        'vendor': 'Open Source',
        'product': 'Open Web Analytics'
    },
    {
        'vendor': 'OpenX Software, Ltd.',
        'product': 'OpenAudience'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenBSD'
    },
    {
        'vendor': 'OpenCart',
        'product': 'OpenCart'
    },
    {
        'vendor': 'OpenClinica, LLC',
        'product': 'OpenClinica'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenConnect'
    },
    {
        'vendor': 'OpenDNS',
        'product': 'OpenDNS'
    },
    {
        'vendor': 'Modius, Inc.',
        'product': 'OpenData'
    },
    {
        'vendor': 'OpenDigits',
        'product': 'OpenDigits'
    },
    {
        'vendor': 'OpenEMR Foundation, Inc.',
        'product': 'OpenEMR'
    },
    {
        'vendor': 'Emerson Electric Company',
        'product': 'OpenEnterprise'
    },
    {
        'vendor': 'OpenFOAM Foundation, Ltd.',
        'product': 'OpenFOAM'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenFace'
    },
    {
        'vendor': 'OpenID Foundation',
        'product': 'OpenID'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'OpenJDK'
    },
    {
        'vendor': 'OpenLDAP',
        'product': 'OpenLDAP'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenLava'
    },
    {
        'vendor': 'Openlink Financial, LLC',
        'product': 'OpenLink'
    },
    {
        'vendor': 'Artificial Intelligence Techniques, Ltd.',
        'product': 'OpenNN'
    },
    {
        'vendor': 'OpenNebula Systems S.L.',
        'product': 'OpenNebula'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'OpenPBS'
    },
    {
        'vendor': 'OpenPro, Inc.',
        'product': 'OpenPro'
    },
    {
        'vendor': 'OpenProject GmbH',
        'product': 'OpenProject'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenRefine'
    },
    {
        'vendor': 'OpenResty, Inc.',
        'product': 'OpenResty'
    },
    {
        'vendor': 'Tuscows, Inc.',
        'product': 'OpenSRS'
    },
    {
        'vendor': 'Tuscows, Inc.',
        'product': 'OpenSRS Hosting'
    },
    {
        'vendor': 'OpenSSL Software Foundation',
        'product': 'OpenSSL'
    },
    {
        'vendor': 'Unify, Inc.',
        'product': 'OpenScape Business'
    },
    {
        'vendor': 'Unify, Inc.',
        'product': 'OpenScape Cloud Contact Center'
    },
    {
        'vendor': 'Unify, Inc.',
        'product': 'OpenScape Voice'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'OpenSpan'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenStack'
    },
    {
        'vendor': 'Unify, Inc.',
        'product': 'OpenStage'
    },
    {
        'vendor': 'The OpenTSDB Authors',
        'product': 'OpenTSDB'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'OpenTelemetry'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText (Unspecified Product)'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText 360 for SharePoint'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText AI and Analytics'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Active Catalogue'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Active Documents'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Alchemy'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Analytics'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Application Integrator'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText ApplicationXtender'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Archiving'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Axcelerate'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText BizConnect'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText BizLink'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText BizManager'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText BizManager400'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Brava! for Content Suite'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Business Network'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Captiva'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Communications Center Enterprise (CCE)'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Content Suite Platform'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Contivo'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Cordys'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Core'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Decisiv'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Discovery'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Documentum'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Documentum D2'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Documentum Platform'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Documentum for Life Sciences'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Documentum xCP'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText ECM in the Cloud'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Exstream'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Extended ECM Platform'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Fax2Mail'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Hightail'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText HostExplorer'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText InfoArchive'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Inovisworks'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Intelligent Capture'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Lens'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Liaison Athena'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Liaison Delta'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Liaison ECS'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Liaison EDI Notepad'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText LiquidOffice'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText MBPM'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Magellan'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Media Management'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Optimost'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText ProVision'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Process Suite Platform'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Qfiniti'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Recommind'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Records Management LegalKEY'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText RightFax'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText RightFax Connect'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText RightFax Express'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText TeamSite'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText TeleForm'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Trading Grid Analytics'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText TrustedLink'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Web Experience Management'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Web Site Management'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText eDOCS DM'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenTracing'
    },
    {
        'vendor': 'Greenbone Networks GmbH',
        'product': 'OpenVAS'
    },
    {
        'vendor': 'VMS Software, Inc.',
        'product': 'OpenVMS'
    },
    {
        'vendor': 'OpenVPN Technologies',
        'product': 'OpenVPN Access Server'
    },
    {
        'vendor': 'OpenX Software, Ltd.',
        'product': 'OpenX'
    },
    {
        'vendor': 'Openbravo S.L.U.',
        'product': 'Openbravo'
    },
    {
        'vendor': 'Opencode Systems',
        'product': 'Opencode'
    },
    {
        'vendor': 'Openet Telecom Sales, Ltd.',
        'product': 'Openet'
    },
    {
        'vendor': 'OpenMake Software, Inc.',
        'product': 'Openmake Meister'
    },
    {
        'vendor': 'Openpath, Inc.',
        'product': 'Openpath'
    },
    {
        'vendor': 'Open Source',
        'product': 'Openstat'
    },
    {
        'vendor': 'Opentable, Inc.',
        'product': 'Opentable'
    },
    {
        'vendor': 'Opentracker',
        'product': 'Opentracker'
    },
    {
        'vendor': 'Operative',
        'product': 'Operative'
    },
    {
        'vendor': 'OpiSafe, Inc.',
        'product': 'OpiSafe'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'OpinionLab'
    },
    {
        'vendor': 'OpsAnalitica, LLC',
        'product': 'OpsAnalitica'
    },
    {
        'vendor': 'Atlassian Pty Ltd',
        'product': 'OpsGenie'
    },
    {
        'vendor': 'Opsview, Ltd.',
        'product': 'Opsview'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'OptSim'
    },
    {
        'vendor': 'Allot Communications, Ltd.',
        'product': 'Optenet'
    },
    {
        'vendor': 'Optimonk International Zrt.',
        'product': 'OptiMonk'
    },
    {
        'vendor': 'EFI OptiTex',
        'product': 'OptiTex'
    },
    {
        'vendor': 'Optify',
        'product': 'Optify'
    },
    {
        'vendor': 'Optimal Blue, LLC',
        'product': 'Optimal Blue'
    },
    {
        'vendor': 'Matomy Media Group, Ltd.',
        'product': 'Optimatic'
    },
    {
        'vendor': 'Optimizely, Inc.',
        'product': 'Optimizely'
    },
    {
        'vendor': 'Optimove',
        'product': 'Optimove'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Optimum HR'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Optimum Payroll'
    },
    {
        'vendor': 'Optiv Security, Inc.',
        'product': 'Optiv Security'
    },
    {
        'vendor': 'Optiva, Inc.',
        'product': 'Optiva BSS Platform'
    },
    {
        'vendor': 'Optoro, Inc.',
        'product': 'Optoro OptiTurn'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum CDI 3D'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Care Coordination Platform'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Enterprise Computer-Assisted Coding'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Impact Intelligence'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Intelligent EDI'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum NorthStar'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Population Health Management'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Symmetry'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Web.Strat'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum360'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'OptumInsight'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'OptumRx'
    },
    {
        'vendor': 'Singtel Optus Pty Ltd',
        'product': 'Optus'
    },
    {
        'vendor': 'Optymyze, LLC',
        'product': 'Optymyze'
    },
    {
        'vendor': 'OpusCapita Solutions Oy',
        'product': 'OpusCapita'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'OrCAD Capture'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'OrCAD Library Builder'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'OrCAD PCB Designer'
    },
    {
        'vendor': 'Cadence Design Systems, Inc.',
        'product': 'OrCAD PSpice Designer'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 10g'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 10g Enterprise Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 10g Standard Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 11g Enterprise Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 12c'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 360 Contract Billing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle 8i'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle API Gateway'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle API Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle API Platform'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle ATG Web Commerce'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Access Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Aconex'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Active Data Guard'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Adaptive Access Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle AddThis'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Advanced Compression'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Advanced Inbound Telephony'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Advanced Procurement'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Advanced Security'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Agile Product Lifecycle Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Analytics Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Apiary API Flow'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Application Express (APEX)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Application Server'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Application Testing Suite'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Argus'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Artificial Intelligence'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Asset Lifecycle Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Audit Vault'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle AutoVue'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Autonomous Data Warehouse'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Autonomous Data Warehouse Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Autonomous Database'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Autonomous Transaction Processing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle BRM (Oracle Billing & Revenue Management)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Banking'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Berkeley DB'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Big Data Appliance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Big Data Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Blockchain Platform'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle BlueKai'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Bronto'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Business Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Business Intelligence Discoverer'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Business Intelligence Enterprise Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Business Intelligence Mobile'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Business Intelligence Publisher'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Business Process Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CASB'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CPQ Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CRM'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CRM On Demand'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CX Cloud Suite'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CX Commerce'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle CX Sales'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cash and Treasury Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Database Services'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud EPM Planning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Infrastructure'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Infrastructure Data Science'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Infrastructure FastConnect'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Infrastructure Key Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Platform'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Services'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Coherence'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Collective Intellect'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Commerce'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Commerce Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Communications'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Complex Maintenance Repair and Overhaul'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Configurator Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Consulting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Contact Center Anywhere'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Container Pipelines'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Contextual Intelligence'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Crystal Ball'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Customer Hub'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Customer Order Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle DIVA'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Data Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Data Integrator Enterprise Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Data Masking'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Data Mining'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Data Visualization'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Data Warehousing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle DataFox'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database 11g Enterprise Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database 18c'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database 19c'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Appliance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Exadata Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Gateways'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Security'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Standard Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Database Vault'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Datalogix'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Demantra Demand Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Directory Server Enterprise Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Directory Services'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Documaker'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle E-Business'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle E-Business Suite'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle E-Business Suite 12'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle EPM Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle ERP'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle ERP Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Eloqua'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Endeca'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Engagement Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Content Management (ECM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Data Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Data Quality'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Performance Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Performance Reporting Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise Single Sign-On'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Essbase'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Exadata'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Exalogic'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Exalytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle FLEXCUBE'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle FS1-2'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fatwire'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Field Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Financial Consolidation and Close Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Financial Services'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Financial Services Anti Money Laundering'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Financials Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Food and Beverage'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Forms'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion CRM'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Customer Hub'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Financials'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Governance, Risk, and Compliance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Human Capital Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Middleware'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Procurement'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Project Portfolio Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Supply Chain Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle GlassFish'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Global Order Promising'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Global Payroll'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle GoldenGate'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Guided Learning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle HCM Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle HR Help Desk'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle HTTP Server'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Health Sciences InForm'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality 9700 HMS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality BellaVita'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality Opera'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality POS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality RES'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality RES 3700'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality Reporting and Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality Simphony'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality Suite8'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality Torex'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality XBRi'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hospitality e7 Point of Sale (POS)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Human Capital Management (HCM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Human Capital Management (HCM) Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Human Resources'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hyperion Enterprise'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hyperion Financial Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Hyperion Planning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle IaaS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Identity Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Identity Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Identity Federation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Identity Governance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Identity Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle InQuira'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Incentive Compensation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Infinity'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Information Rights Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Instantis EnterpriseTrack'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Insurance Insbridge Enterprise Rating'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Insurance Policy Administration'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Integration Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Intelligent Track and Trace'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Interaction Center'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Internet Directory'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Internet Expenses'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Inventory Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Inventory Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle IoT'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle JDeveloper'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle JRockit'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Java Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Label Security'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Learning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Linux'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Logistics Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Logistics Inventory Visibility Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Loyalty Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle MICROS 9700 HMS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Maintenance Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Management Cloud Application Performance Monitoring'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Manufacturing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Manufacturing Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Marketing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Marketing Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Master Data Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Maxymiser'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Micros'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Micros Workstation 6'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Micros inMotion'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Mobile Authenticator (OMA)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Mobile Supply Chain'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Multitenant'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle MySQL Database Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle OLAP'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle OTP (One Time Password)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Order Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Order Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle PL/SQL'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Partner Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Passlogix'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Payroll'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle PeopleSoft'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle PeopleSoft Enterprise eDevelopment'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Phase Forward'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Pillar Axiom MaxMan'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Pillar Data'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Policy Automation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Primavera Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Primavera Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Primavera Enterprise Project Portfolio Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Primavera Submittal Exchange Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Primavera Suite'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Primavera Unifier'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Private Cloud Appliance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Privileged Account Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Procurement'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Procurement Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Procurement Contracts'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Procurement and Spend Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Product Data Hub Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Product Lifecycle Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Product Lifecycle Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Profitability and Cost Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Project Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Project Resource Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Purchasing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Quoting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Real Application Clusters'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Recovery Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Responsys'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Responsys Interact'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Advanced Inventory Planning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Allocation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Assortment and Item Planning Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Demand Forecasting Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Invoice Matching'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Merchandising System'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Sales Audit'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Trade Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Xstore'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Revenue Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Risk Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle SCM Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle SPARC M-Series Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle SPARC Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle SPARC T-Series Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sales'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sales Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sales Contracts'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sales Performance Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sales Performance Management (SPM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle SelectMinds'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Self-Service Procurement Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Service Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Services Procurement'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Campaign Management and Dialogue Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Handheld'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel HelpDesk'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Remote and Mobile Web Client'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Task Based User Interface'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Test Automation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Warranty'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Wireless'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Skire'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Social Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Solaris'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sourcing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Spatial and Graph'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Spend Classification'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Stellent'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Subscription Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sun Blade Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Sun Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle SuperCluster M7'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Supplier Hub'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Supplier Lifecycle Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Supplier Network'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Supplier Qualification Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Supply Chain Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Supply Chain Planning Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Talari'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Talent Acquisition Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Talent Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Taleo Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Taleo Learn Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Taleo Social Sourcing Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Taleo Succession Planning Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Tape Storage'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Tax Reporting'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle TeleSales'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Teleservice'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Time and Labor'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle TimesTen'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Trade Compliance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Traffic Director'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Transportation Management Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Tuxedo'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Unified Communications Suite'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Unified Content Management (UCM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Unified Directory'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Universal Content Management (UCM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Utilities'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle VM VirtualBox'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Validated Integration'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Value Chain Planning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Virtual Directory (OVD)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Vitrue'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Warehouse Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Waveset'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle WebCenter Imaging'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle WebCenter Portal'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle WebCenter Sites'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle WebLogic'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Webcenter Content Server'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Work Life Solutions Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Workforce Compensation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Workforce Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Workforce Rewards Cloud'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle XML Publisher'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle ZFS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle iProcurement'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle iStore'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle iSupplier Portal'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle9i'
    },
    {
        'vendor': 'Orange Business Services, Inc.',
        'product': 'Orange Datavenue'
    },
    {
        'vendor': 'YourCause, LLC',
        'product': 'Orange Leap'
    },
    {
        'vendor': 'OrangeHRM, Inc.',
        'product': 'OrangeHRM'
    },
    {
        'vendor': 'OrangeScape Technologies, Ltd.',
        'product': 'OrangeScape'
    },
    {
        'vendor': 'Orbcom',
        'product': 'Orbcom'
    },
    {
        'vendor': 'Orbus Software',
        'product': 'Orbus iServer'
    },
    {
        'vendor': 'Orchard Software Corporation',
        'product': 'Orchard Software'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'Orchestra Networks'
    },
    {
        'vendor': 'Orckestra Technologies, Inc.',
        'product': 'Orckestra'
    },
    {
        'vendor': 'Netsmart Technologies, Inc.',
        'product': 'OrderConnect'
    },
    {
        'vendor': 'OrderGroove, Inc.',
        'product': 'OrderGroove'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'OrderMotion'
    },
    {
        'vendor': 'Orderhive',
        'product': 'Orderhive'
    },
    {
        'vendor': 'Ordoro, Inc.',
        'product': 'Ordoro'
    },
    {
        'vendor': 'Insperity, Inc.',
        'product': 'OrgPlus'
    },
    {
        'vendor': 'PeopleFluent, Inc.',
        'product': 'OrgPublisher'
    },
    {
        'vendor': 'Orient Technologies',
        'product': 'OrientDB'
    },
    {
        'vendor': 'Orion Advisor Technology, LLC',
        'product': 'Orion Advisor Tech'
    },
    {
        'vendor': 'Orion Health',
        'product': 'Orion Health'
    },
    {
        'vendor': 'Orion Health',
        'product': 'Orion Health Consult'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'Orion Network Configuration Manager'
    },
    {
        'vendor': 'Orion Portfolio Solutions, LLC',
        'product': 'Orion Portfolio Solutions'
    },
    {
        'vendor': 'Orion Wine Software',
        'product': 'Orion Wine Software'
    },
    {
        'vendor': 'Oro, Inc.',
        'product': 'OroCRM'
    },
    {
        'vendor': 'Oro, Inc.',
        'product': 'OroCommerce'
    },
    {
        'vendor': 'Materialise N.V.',
        'product': 'OrthoView'
    },
    {
        'vendor': 'Oscar Software Oy',
        'product': 'Oscar ECommerce'
    },
    {
        'vendor': 'Othot, Inc.',
        'product': 'Othot'
    },
    {
        'vendor': 'AISense, Inc.',
        'product': 'Otter'
    },
    {
        'vendor': 'OutMatch',
        'product': 'OutMatch'
    },
    {
        'vendor': 'OutSystems Software em Rede S.A.',
        'product': 'OutSystems'
    },
    {
        'vendor': 'OutboundEngine, Inc.',
        'product': 'OutboundEngine'
    },
    {
        'vendor': 'OutboundWorks, Inc.',
        'product': 'OutboundWorks'
    },
    {
        'vendor': 'Outbrain, Inc.',
        'product': 'Outbrain'
    },
    {
        'vendor': 'Outreach Corporation',
        'product': 'Outreach.io'
    },
    {
        'vendor': 'Emerson Electric Company',
        'product': 'Ovation'
    },
    {
        'vendor': 'Overland-Tandberg',
        'product': 'Overland Storage NEO'
    },
    {
        'vendor': 'Overland-Tandberg',
        'product': 'Overland Storage REO'
    },
    {
        'vendor': 'Overland-Tandberg',
        'product': 'Overland Storage SnapSAN'
    },
    {
        'vendor': 'Overland-Tandberg',
        'product': 'Overland-Tandberg Storage'
    },
    {
        'vendor': 'Oversight Systems, Inc.',
        'product': 'Oversight (Unspecified Product)'
    },
    {
        'vendor': 'Informa PLC',
        'product': 'Ovum'
    },
    {
        'vendor': 'Owens & Minor, Inc.',
        'product': 'Owens & Minor'
    },
    {
        'vendor': 'Owner InSite, LLC',
        'product': 'Owner InSite'
    },
    {
        'vendor': 'Oxalys Technologies',
        'product': 'Oxalys'
    },
    {
        'vendor': 'New Oxatis',
        'product': 'Oxatis'
    },
    {
        'vendor': 'Oxid',
        'product': 'Oxid'
    },
    {
        'vendor': 'OXID eSales AG',
        'product': 'Oxid eShop'
    },
    {
        'vendor': 'Syncro Soft S.R.L.',
        'product': 'Oxygen XML Editor'
    },
    {
        'vendor': 'Oz Development, Inc.',
        'product': 'OzLINK'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'PADS'
    },
    {
        'vendor': 'QRS, Inc.',
        'product': 'PARADIGM EHR'
    },
    {
        'vendor': 'MSC Software Corporation',
        'product': 'PATRAN'
    },
    {
        'vendor': 'PBOmd',
        'product': 'PBOmd'
    },
    {
        'vendor': 'Passport Software',
        'product': 'PBS Manufacturing'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'PBS Professional'
    },
    {
        'vendor': 'ABILITY Network, Inc.',
        'product': 'PC-ACE'
    },
    {
        'vendor': 'Physicians Computer Company',
        'product': 'PCC EHR'
    },
    {
        'vendor': 'DHI Computing Service, Inc.',
        'product': 'PCIS GOLD'
    },
    {
        'vendor': 'Main Sequence Technology, Inc.',
        'product': 'PCRecruiter'
    },
    {
        'vendor': 'Computational Hydraulics International (CHI)',
        'product': 'PCSWMM'
    },
    {
        'vendor': 'Smart Software Testing Solutions, Inc.',
        'product': 'PCloudy'
    },
    {
        'vendor': 'PDSMED',
        'product': 'PDS MDsuite EHR'
    },
    {
        'vendor': 'PERQ Software, LLC',
        'product': 'PERQ'
    },
    {
        'vendor': 'Prepaid Expense Card Solutions, Inc.',
        'product': 'PEX'
    },
    {
        'vendor': 'PFSweb, Inc.',
        'product': 'PFSweb'
    },
    {
        'vendor': 'The Pixel Farm, Ltd.',
        'product': 'PFTrack'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'PGP Universal Server'
    },
    {
        'vendor': 'Unitrends, Inc.',
        'product': 'PHD Virtual'
    },
    {
        'vendor': 'The PHP Group',
        'product': 'PHP'
    },
    {
        'vendor': 'PHP Point Of Sale, LLC',
        'product': 'PHP Point Of Sale'
    },
    {
        'vendor': 'Open Source',
        'product': 'PHPCI'
    },
    {
        'vendor': 'Smoky Mountain Information Systems',
        'product': 'PIMSY EHR'
    },
    {
        'vendor': 'Engineered Software, Inc.',
        'product': 'PIPE-FLO'
    },
    {
        'vendor': 'PIPZ',
        'product': 'PIPZ'
    },
    {
        'vendor': 'ProfitKey International',
        'product': 'PK 8'
    },
    {
        'vendor': 'PKWARE, Inc.',
        'product': 'PKWARE'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PL/SQL'
    },
    {
        'vendor': 'PLYmedia',
        'product': 'PLYmedia'
    },
    {
        'vendor': 'PM Vitals, LLC',
        'product': 'PM Vitals'
    },
    {
        'vendor': 'Appriss, Inc.',
        'product': 'PMP Gateway'
    },
    {
        'vendor': 'Groupe PSIH',
        'product': 'PMSI PILOT'
    },
    {
        'vendor': 'PMWeb, Inc.',
        'product': 'PMWeb'
    },
    {
        'vendor': 'Genpact, Ltd.',
        'product': 'PNMsoft'
    },
    {
        'vendor': 'POSitouch',
        'product': 'POSitouch'
    },
    {
        'vendor': 'PPRO Financial, Ltd.',
        'product': 'PPRO'
    },
    {
        'vendor': 'PR Newswire Association, LLC',
        'product': 'PR Newswire'
    },
    {
        'vendor': 'Roxagi Corporation',
        'product': 'PR-Tracker'
    },
    {
        'vendor': 'PRO Unlimited, Inc.',
        'product': 'PRO Unlimited'
    },
    {
        'vendor': 'PRO Unlimited, Inc.',
        'product': 'PRO Unlimited Wand VMS'
    },
    {
        'vendor': 'PRO-WARE',
        'product': 'PRO-WARE Asset Keeper'
    },
    {
        'vendor': 'PROCAS, LLC',
        'product': 'PROCAS'
    },
    {
        'vendor': 'APLAF, Inc.',
        'product': 'PROCLASS'
    },
    {
        'vendor': 'HighJump Software, Inc.',
        'product': 'PROFITsystems'
    },
    {
        'vendor': 'PROS, Inc.',
        'product': 'PROS'
    },
    {
        'vendor': 'Paessler',
        'product': 'PRTG Network Monitor'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'PRWeb'
    },
    {
        'vendor': 'Telus Health',
        'product': 'PS Suite EMR'
    },
    {
        'vendor': 'PSIGEN Software, Inc.',
        'product': 'PSIsafe'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Arbortext'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC CoCreate'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Creo'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Creo Elements/Direct'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Creo Simulate'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC FlexPLM'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Integrity'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Mathcad'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Servigistics'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC ThingWorx'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Windchill'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'PTC Windchill PDMLink'
    },
    {
        'vendor': 'PUBLITECH',
        'product': 'PUBLITRAC'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'PV Elite'
    },
    {
        'vendor': 'Pacejet Logistics, Inc.',
        'product': 'Pacejet'
    },
    {
        'vendor': 'Pachyderm, Inc.',
        'product': 'Pachyderm'
    },
    {
        'vendor': 'Paddle.com Market, Ltd.',
        'product': 'Paddle'
    },
    {
        'vendor': 'PaddlePaddle, LLC',
        'product': 'PaddlePaddle'
    },
    {
        'vendor': 'Padlet',
        'product': 'Padlet'
    },
    {
        'vendor': 'PagSeguro Internet S.A.',
        'product': 'PagSeguro'
    },
    {
        'vendor': 'Pagar.me Pagamentos S.A.',
        'product': 'Pagar.me'
    },
    {
        'vendor': 'PageUp People, Ltd.',
        'product': 'PageUp People'
    },
    {
        'vendor': 'Pagemodo',
        'product': 'Pagemodo'
    },
    {
        'vendor': 'PagerDuty, Inc.',
        'product': 'PagerDuty'
    },
    {
        'vendor': 'PagerDuty, Inc.',
        'product': 'PagerDuty Incident Response'
    },
    {
        'vendor': 'Medical Packaging, Inc.',
        'product': 'Pak-EDGE'
    },
    {
        'vendor': 'Paladin Data Corporation',
        'product': 'Paladin POS'
    },
    {
        'vendor': 'Palantir Technologies, Inc.',
        'product': 'Palantir'
    },
    {
        'vendor': 'Palantir Technologies, Inc.',
        'product': 'Palantir Gotham'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto Aperture'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto Cortex XDR'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto GlobalProtect'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto Networks'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto Networks VM-Series'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA Series'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-200'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-3000 Series'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-3200 Series'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-3220'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-3250'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-3260'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-500'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5000 Series'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5200'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5200 Series'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5220'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5250'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5260'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-5280'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-7000'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-7050'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PA-7080'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PAN-OS'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PAN-OS 8.0'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto PAN-OS 8.1'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto Panorama'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Palo Alto Wildfire'
    },
    {
        'vendor': 'PanTerra Networks, Inc.',
        'product': 'PanTerra Streams'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Panamax'
    },
    {
        'vendor': 'Panasas, Inc.',
        'product': 'Panasas'
    },
    {
        'vendor': 'Panasas, Inc.',
        'product': 'Panasas ActiveStor'
    },
    {
        'vendor': 'Panasas, Inc.',
        'product': 'Panasas PanFS'
    },
    {
        'vendor': 'Panasas, Inc.',
        'product': 'Panasas pNFS'
    },
    {
        'vendor': 'Panasonic Corporation',
        'product': 'Panasonic IP Phones'
    },
    {
        'vendor': 'Panasonic Corporation',
        'product': 'Panasonic IP-PBX'
    },
    {
        'vendor': 'Panasonic Corporation',
        'product': 'Panasonic TOUGHBOOK'
    },
    {
        'vendor': 'Panaya, Ltd.',
        'product': 'Panaya'
    },
    {
        'vendor': 'Panda Security S.L.',
        'product': 'Panda Security'
    },
    {
        'vendor': 'PandaDoc, Inc.',
        'product': 'PandaDoc'
    },
    {
        'vendor': 'Pano Logic',
        'product': 'Pano Logic'
    },
    {
        'vendor': 'Panoply, Ltd.',
        'product': 'Panoply'
    },
    {
        'vendor': 'Panopta',
        'product': 'Panopta'
    },
    {
        'vendor': 'Panopto, Inc.',
        'product': 'Panopto'
    },
    {
        'vendor': 'Pantera Global Technology, Inc.',
        'product': 'Pantera Tools'
    },
    {
        'vendor': 'Pantheon Systems, Inc.',
        'product': 'Pantheon'
    },
    {
        'vendor': 'Panzura, Inc.',
        'product': 'Panzura'
    },
    {
        'vendor': 'Papaya Global, Ltd.',
        'product': 'Papaya'
    },
    {
        'vendor': 'The Monticello Corporation',
        'product': 'Paper Tiger'
    },
    {
        'vendor': 'Papersoft S.A.',
        'product': 'Papersoft'
    },
    {
        'vendor': 'Paperspace',
        'product': 'Paperspace'
    },
    {
        'vendor': 'Papirfly',
        'product': 'Papirfly'
    },
    {
        'vendor': 'PAR Excellence Systems, Inc.',
        'product': 'Par Excellence Systems'
    },
    {
        'vendor': 'Actian Corporation',
        'product': 'ParAccel'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'ParStream'
    },
    {
        'vendor': 'ParaView',
        'product': 'ParaView'
    },
    {
        'vendor': 'Paradigm',
        'product': 'Paradigm (Unspecified Product)'
    },
    {
        'vendor': 'Parallels International GmbH',
        'product': 'Parallels'
    },
    {
        'vendor': 'Parallels International GmbH',
        'product': 'Parallels Desktop'
    },
    {
        'vendor': 'Parallels International GmbH',
        'product': 'Parallels Plesk'
    },
    {
        'vendor': 'Parasoft Corporation',
        'product': 'Parasoft'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Parature'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Pardot'
    },
    {
        'vendor': 'PAREXEL International Corporation',
        'product': 'Parexel IMPACT'
    },
    {
        'vendor': 'PAREXEL International Corporation',
        'product': 'Parexel Informatics'
    },
    {
        'vendor': 'ParkMyCloud, Inc.',
        'product': 'ParkMyCloud'
    },
    {
        'vendor': 'ParkingCrew',
        'product': 'ParkingCrew'
    },
    {
        'vendor': 'Electronic Voice Services, Inc.',
        'product': 'Parrot Cloud Call Center'
    },
    {
        'vendor': 'Parsely, Inc.',
        'product': 'Parse.ly'
    },
    {
        'vendor': 'Particle Industries, Inc.',
        'product': 'Particle'
    },
    {
        'vendor': 'Point of Rental Software',
        'product': 'PartyCAD'
    },
    {
        'vendor': 'PartySlate, Inc.',
        'product': 'PartySlate'
    },
    {
        'vendor': 'Paskr',
        'product': 'Paskr'
    },
    {
        'vendor': 'Passepartout S.p.A.',
        'product': 'Passepartout Mexal'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'Passport Health'
    },
    {
        'vendor': 'Click Studios (SA) Pty Ltd',
        'product': 'Passwordstate'
    },
    {
        'vendor': 'PastPerfect Software',
        'product': 'PastPerfect'
    },
    {
        'vendor': 'PatSnap (UK), Ltd.',
        'product': 'PatSnap (Unspecified Product)'
    },
    {
        'vendor': 'Patagonia Health, Inc.',
        'product': 'Patagonia Health'
    },
    {
        'vendor': 'Blue Sky eLearn',
        'product': 'Path LMS'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'PathWave'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'PathWave Vector Signal Analysis (89600 VSA)'
    },
    {
        'vendor': 'Pathable, Inc.',
        'product': 'Pathable'
    },
    {
        'vendor': 'Mobify Research and Development, Inc.',
        'product': 'Pathful'
    },
    {
        'vendor': 'Pathmatics, Inc.',
        'product': 'Pathmatics'
    },
    {
        'vendor': 'Futuredontics, Inc.',
        'product': 'Patient Activator'
    },
    {
        'vendor': 'Prime Clinical Systems',
        'product': 'Patient Chart Manager EHR'
    },
    {
        'vendor': 'PatientClick, Inc.',
        'product': 'PatientClick'
    },
    {
        'vendor': 'PatientKeeper',
        'product': 'PatientKeeper'
    },
    {
        'vendor': 'PatientNOW, Inc.',
        'product': 'PatientNOW'
    },
    {
        'vendor': 'PatientSafe Solutions',
        'product': 'PatientTouch'
    },
    {
        'vendor': 'PatientWorks Corporation',
        'product': 'PatientWorks'
    },
    {
        'vendor': 'Patriot Software, LLC',
        'product': 'Patriot Accounting'
    },
    {
        'vendor': 'GlobalVision',
        'product': 'Patriot Officer'
    },
    {
        'vendor': 'Patron Technology, Inc.',
        'product': 'PatronManager'
    },
    {
        'vendor': 'Pax8, Inc.',
        'product': 'Pax8 Platform'
    },
    {
        'vendor': 'Paxata, Inc.',
        'product': 'Paxata'
    },
    {
        'vendor': 'PayDC',
        'product': 'PayDC'
    },
    {
        'vendor': 'PayFit, Ltd.',
        'product': 'PayFit'
    },
    {
        'vendor': 'Payfort International FZ, LLC',
        'product': 'PayFort'
    },
    {
        'vendor': 'PayPal, Inc.',
        'product': 'PayPal'
    },
    {
        'vendor': 'PayPro Global, Inc.',
        'product': 'PayPro Global'
    },
    {
        'vendor': 'PayScale, Inc.',
        'product': 'PayScale (Unspecified Product)'
    },
    {
        'vendor': 'PaySimple',
        'product': 'PaySimple'
    },
    {
        'vendor': 'MIH PayU B.V.',
        'product': 'PayU'
    },
    {
        'vendor': 'Paychex, Inc.',
        'product': 'Paychex'
    },
    {
        'vendor': 'Paychex, Inc.',
        'product': 'Paychex Flex'
    },
    {
        'vendor': 'Paycom Software, Inc.',
        'product': 'Paycom'
    },
    {
        'vendor': 'Paycor, Inc.',
        'product': 'Paycor'
    },
    {
        'vendor': 'First Data Corporation',
        'product': 'Payeezy'
    },
    {
        'vendor': 'PayFactors Group, LLC',
        'product': 'Payfactors (Unspecified Product)'
    },
    {
        'vendor': 'Zego',
        'product': 'Paylease'
    },
    {
        'vendor': 'Paylocity Corporation',
        'product': 'Paylocity (Unspecified Product)'
    },
    {
        'vendor': 'PaymentEvolution',
        'product': 'PaymentEvolution'
    },
    {
        'vendor': 'Paymentech, LLC',
        'product': 'Paymentech'
    },
    {
        'vendor': 'Paymetric, Inc.',
        'product': 'Paymetric'
    },
    {
        'vendor': 'Paymo, LLC',
        'product': 'Paymo'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Paymode X'
    },
    {
        'vendor': 'Payoneer, Inc.',
        'product': 'Payoneer'
    },
    {
        'vendor': 'Heartland Payment Systems, Inc.',
        'product': 'Payroll 1'
    },
    {
        'vendor': 'Real Business Solutions, Inc.',
        'product': 'Payroll Mate'
    },
    {
        'vendor': 'Payroll2U Pte Ltd',
        'product': 'Payroll2U'
    },
    {
        'vendor': 'Stone Forest Accountserve Pte Ltd',
        'product': 'PayrollServe'
    },
    {
        'vendor': 'Peak 10',
        'product': 'Peak 10'
    },
    {
        'vendor': 'Peakon ApS',
        'product': 'Peakon'
    },
    {
        'vendor': 'Pearson Education, Inc.',
        'product': 'Pearson CourseConnect'
    },
    {
        'vendor': 'Pearson Education, Inc.',
        'product': 'Pearson Learning Solutions'
    },
    {
        'vendor': 'Pearson Education, Inc.',
        'product': 'Pearson LearningStudio'
    },
    {
        'vendor': 'Pearson Education, Inc.',
        'product': 'Pearson MyMathLab'
    },
    {
        'vendor': 'Pearson Education, Inc.',
        'product': 'Pearson OpenClass'
    },
    {
        'vendor': 'Pearson Education, Inc.',
        'product': 'Pearson eCollege'
    },
    {
        'vendor': 'Scientific Software Solutions, Inc.',
        'product': 'PedCath'
    },
    {
        'vendor': 'Cogeco Peer 1',
        'product': 'Peer 1 Hosting'
    },
    {
        'vendor': 'Episerver, Inc.',
        'product': 'Peerius'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega BPM'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega CRM'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega CRM Suite'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Case Management'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Customer Decision Hub'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Customer Service'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Infinity'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega KYC'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Platform'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Robotic Process Automation'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'Pega Sales Automation'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'PegaRULES Process Commander (PRPC)'
    },
    {
        'vendor': 'Pegasus Solutions, Inc.',
        'product': 'Pegasus Solutions'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Pelion IoT Platform'
    },
    {
        'vendor': 'PenRad Technologies, Inc.',
        'product': 'PenRad'
    },
    {
        'vendor': 'Pendo.io, Inc.',
        'product': 'Pendo'
    },
    {
        'vendor': 'Penta Technologies, Inc.',
        'product': 'Penta Technologies'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Pentaho'
    },
    {
        'vendor': 'Technical Difference, Inc.',
        'product': 'People-Trak'
    },
    {
        'vendor': 'People.ai, Inc.',
        'product': 'People.ai'
    },
    {
        'vendor': 'PeopleAdmin, Inc.',
        'product': 'PeopleAdmin'
    },
    {
        'vendor': 'Asure Software, Inc.',
        'product': 'PeopleCube'
    },
    {
        'vendor': 'Ultimate Software Group, Inc.',
        'product': 'PeopleDoc'
    },
    {
        'vendor': 'People Apps, Ltd.',
        'product': 'PeopleHR'
    },
    {
        'vendor': 'Snagajob.com, Inc.',
        'product': 'PeopleMatter'
    },
    {
        'vendor': 'PeopleMetrics',
        'product': 'PeopleMetrics'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'PeopleNet'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Absence Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Academic Advisement'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Activity-Based Management (ABM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Asset Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Benefits Administration'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Billing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft CRM'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Campus Solutions'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Candidate Gateway'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Cash Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Catalog Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Deal Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Demand Planning'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Directory Interface'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Engineering'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Enterprise Learning Management (ELM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Enterprise Performance Management (EPM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Enterprise eBenefits'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Expenses'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Financial Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Global Consolidations'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft HelpDesk'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Human Capital Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Internal Controls Enforcer'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Inventory'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Manufacturing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Order Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft PeopleTools'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Product Configurator'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Program Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Purchasing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Sales'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Supply Chain Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft Talent Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft eCompensation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft ePay'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft ePerformance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'PeopleSoft eRecruiting'
    },
    {
        'vendor': 'PeopleStrategy, Inc.',
        'product': 'PeopleStrategy'
    },
    {
        'vendor': 'PeopleStrategy, Inc.',
        'product': 'PeopleStrategy eHCM'
    },
    {
        'vendor': 'Ascender Group',
        'product': 'PeopleStreme'
    },
    {
        'vendor': 'PeopleStrong HR Services Pvt Ltd',
        'product': 'PeopleStrong'
    },
    {
        'vendor': 'PeopleFluent, Inc.',
        'product': 'Peoplefluent (Unspecified Product)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Peoplesoft eProcurement'
    },
    {
        'vendor': 'Pepperi',
        'product': 'Pepperi'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'Perceptive Content'
    },
    {
        'vendor': 'Perceptyx, Inc.',
        'product': 'Perceptyx'
    },
    {
        'vendor': 'Skillsoft Corporation',
        'product': 'Percipio'
    },
    {
        'vendor': 'Percolate Industries, Inc.',
        'product': 'Percolate'
    },
    {
        'vendor': 'Percona, LLC',
        'product': 'Percona'
    },
    {
        'vendor': 'Percussion Software, Inc.',
        'product': 'Percussion CM'
    },
    {
        'vendor': 'Perfect Audience',
        'product': 'Perfect Audience'
    },
    {
        'vendor': 'NCG Medical',
        'product': 'Perfect Care EHR'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Perfect Commerce'
    },
    {
        'vendor': 'Taboola, Inc.',
        'product': 'Perfect Market'
    },
    {
        'vendor': 'Raxco Software, Inc.',
        'product': 'PerfectDisk'
    },
    {
        'vendor': 'Perfecto Mobile, Inc.',
        'product': 'Perfecto'
    },
    {
        'vendor': 'Perfion A/S',
        'product': 'Perfion PIM'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Perforce'
    },
    {
        'vendor': 'Perform[cb], LLC',
        'product': 'Perform[cb]'
    },
    {
        'vendor': 'HubSpot, Inc.',
        'product': 'Performable'
    },
    {
        'vendor': 'PeriGen, Inc.',
        'product': 'PeriGen'
    },
    {
        'vendor': 'Perkbox, Ltd.',
        'product': 'Perkbox'
    },
    {
        'vendor': 'PerkinElmer, Inc.',
        'product': 'PerkinElmer E-Notebook'
    },
    {
        'vendor': 'Perkuto',
        'product': 'Perkuto'
    },
    {
        'vendor': 'Perl',
        'product': 'Perl'
    },
    {
        'vendor': 'Persado, Inc.',
        'product': 'Persado'
    },
    {
        'vendor': 'PersistIQ, Inc.',
        'product': 'PersistIQ'
    },
    {
        'vendor': 'Persistent Systems, LLC',
        'product': 'Persistent Wave Relay'
    },
    {
        'vendor': 'Personio GmbH',
        'product': 'Personio'
    },
    {
        'vendor': 'Personyze',
        'product': 'Personyze'
    },
    {
        'vendor': 'PestRoutes OpCo, LLC',
        'product': 'PestRoutes'
    },
    {
        'vendor': 'Petuum, Inc.',
        'product': 'Petuum'
    },
    {
        'vendor': 'Pexip AS',
        'product': 'Pexip'
    },
    {
        'vendor': 'MedKeeper',
        'product': 'PharmacyKeeper'
    },
    {
        'vendor': 'PhaseWare, Inc.',
        'product': 'Phaseware'
    },
    {
        'vendor': 'Phenom People, Inc.',
        'product': 'Phenom People'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Achieva'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Allura'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Avalon CL'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Brilliance'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Brilliance 16'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Brilliance 40'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Brilliance 6'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Brilliance 64'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips CT'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips CX50'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips CompuRecord'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips EasyVision'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Esprit'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Gemini'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips HD11'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips IE33'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips IU22'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Ingenia'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Ingenuity'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips IntelliSpace'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Intera'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips JETStream Acquisition System'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips MRI'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips MX8000'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips OB TraceVue'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Pinnacle'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Population Health Management'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips QLAB'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips SpeechExec'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips SpeechMike'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Tasy'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips TraceMasterVue'
    },
    {
        'vendor': 'Carestream Dental, LLC',
        'product': 'Philips VNA'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Vereos'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Visicu'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Witt'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Xcelera'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips Xper IM'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips eICU'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips iSite PACS'
    },
    {
        'vendor': 'Phocas, Ltd.',
        'product': 'Phocas'
    },
    {
        'vendor': 'Grifols S.A.',
        'product': 'Phocus Rx'
    },
    {
        'vendor': 'Phoenix Ortho',
        'product': 'Phoenix Ortho'
    },
    {
        'vendor': 'Phonero A/S',
        'product': 'Phonero'
    },
    {
        'vendor': 'PhotoMedex',
        'product': 'PhotoMedex'
    },
    {
        'vendor': 'PhotoShelter, Inc.',
        'product': 'PhotoShelter'
    },
    {
        'vendor': 'Exit Games, Inc.',
        'product': 'Photon Engine'
    },
    {
        'vendor': 'Photoslurp S.L.',
        'product': 'Photoslurp'
    },
    {
        'vendor': 'Phusion Holding B.V.',
        'product': 'Phusion Passenger'
    },
    {
        'vendor': 'Physio-Control, Inc.',
        'product': 'Physio-Control LIFEPAK'
    },
    {
        'vendor': 'PicReel, Inc.',
        'product': 'PicReel'
    },
    {
        'vendor': 'Pica8, Inc.',
        'product': 'Pica8'
    },
    {
        'vendor': 'Picis Clinical Solutions, Inc.',
        'product': 'Picis Ambulatory EMR'
    },
    {
        'vendor': 'Pike13, Inc.',
        'product': 'Pike13'
    },
    {
        'vendor': 'Piksel, Inc.',
        'product': 'Piksel (Unspecified Product)'
    },
    {
        'vendor': 'Piksel, Inc.',
        'product': 'Piksel Digital Showcase'
    },
    {
        'vendor': 'Piktochart Sdn. Bhd.',
        'product': 'Piktochart'
    },
    {
        'vendor': 'Pilat Europe, Ltd.',
        'product': 'Pilat'
    },
    {
        'vendor': 'Pilera Software, LLC',
        'product': 'Pilera'
    },
    {
        'vendor': 'Pilgrim Quality Solutions',
        'product': 'Pilgrim Quality Solutions'
    },
    {
        'vendor': 'Pilot AI Labs, Inc.',
        'product': 'Pilot AI'
    },
    {
        'vendor': 'Pimcore GmbH',
        'product': 'Pimcore'
    },
    {
        'vendor': 'Pinestar Technology, Inc.',
        'product': 'Pinestar Technology'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'Ping Identity (Unspecified Product)'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'PingAccess'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'PingDataGovernance'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'PingDirectory'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'PingFederate'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'PingID'
    },
    {
        'vendor': 'Pingboard, Inc.',
        'product': 'Pingboard'
    },
    {
        'vendor': 'Pingdom AB',
        'product': 'Pingdom'
    },
    {
        'vendor': 'PinnacleCart, Inc.',
        'product': 'Pinnacle Cart'
    },
    {
        'vendor': 'Pinterest, Inc.',
        'product': 'Pinterest'
    },
    {
        'vendor': 'Pipedrive, Inc.',
        'product': 'Pipedrive'
    },
    {
        'vendor': 'Pipefy, Inc.',
        'product': 'Pipefy'
    },
    {
        'vendor': 'PipelineDeals, Inc.',
        'product': 'PipelineDeals'
    },
    {
        'vendor': 'Pipelinersales, Inc.',
        'product': 'Pipeliner CRM'
    },
    {
        'vendor': 'Olapic, Inc.',
        'product': 'Piqora'
    },
    {
        'vendor': 'PistolStar, Inc.',
        'product': 'Pistolstar'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'Pitney Bowes EngageOne'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'Pitney Bowes Spectrum'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'Pitney Bowes StreamWeaver'
    },
    {
        'vendor': 'Pivofy',
        'product': 'Pivofy'
    },
    {
        'vendor': 'Pivot3, Inc.',
        'product': 'Pivot3'
    },
    {
        'vendor': 'SmartFocus UK, Ltd.',
        'product': 'PivotLink'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal Data Suite'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal HAWQ'
    },
    {
        'vendor': 'Pivotal Software, Inc.',
        'product': 'Pivotal RabbitMQ'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal SQLFire'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal Software (Unspecified Product)'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal Tracker'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal Web Server'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal tc Server'
    },
    {
        'vendor': 'Pixability, Inc.',
        'product': 'Pixability'
    },
    {
        'vendor': 'Pixar',
        'product': 'Pixar RenderMan'
    },
    {
        'vendor': 'PixelSilk',
        'product': 'PixelSilk'
    },
    {
        'vendor': 'Pixeleze',
        'product': 'Pixeleze'
    },
    {
        'vendor': 'Pixeon Medical Systems S.A.',
        'product': 'Pixeon'
    },
    {
        'vendor': 'Pixieset Media, Inc.',
        'product': 'Pixieset'
    },
    {
        'vendor': 'Pixlee, Inc.',
        'product': 'Pixlee'
    },
    {
        'vendor': 'PlaceIQ, Inc.',
        'product': 'PlaceIQ'
    },
    {
        'vendor': 'Placester, Inc.',
        'product': 'Placester'
    },
    {
        'vendor': 'Plaid',
        'product': 'Plaid'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'PlanGrid Build'
    },
    {
        'vendor': 'PlanGuru, LLC',
        'product': 'PlanGuru'
    },
    {
        'vendor': 'Complete XRM, Inc.',
        'product': 'PlanPlus Online'
    },
    {
        'vendor': 'PlanSource Benefits Administration, Inc.',
        'product': 'PlanSource'
    },
    {
        'vendor': 'Smartbid',
        'product': 'PlanSwift'
    },
    {
        'vendor': 'Planbox, Inc.',
        'product': 'Planbox'
    },
    {
        'vendor': 'PlanetScale, Inc.',
        'product': 'PlanetScale'
    },
    {
        'vendor': 'Planful, Inc.',
        'product': 'Planful'
    },
    {
        'vendor': 'Planio GmbH',
        'product': 'Planio'
    },
    {
        'vendor': 'Planisware SAS',
        'product': 'Planisware'
    },
    {
        'vendor': 'Planmed Oy',
        'product': 'Planmed Verity'
    },
    {
        'vendor': 'My Wedding Workbook, LLC',
        'product': 'Planning Pod'
    },
    {
        'vendor': 'Planon International B.V.',
        'product': 'Planon Universe'
    },
    {
        'vendor': 'Planon International B.V.',
        'product': 'Planon conjectFM'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Plantronics'
    },
    {
        'vendor': 'Planview, Inc.',
        'product': 'Planview'
    },
    {
        'vendor': 'Planview, Inc.',
        'product': 'Planview Enterprise One'
    },
    {
        'vendor': 'Planview, Inc.',
        'product': 'Planview LeanKit'
    },
    {
        'vendor': 'Planview, Inc.',
        'product': 'Planview PPM Pro'
    },
    {
        'vendor': 'Codice Software S.L.',
        'product': 'Plastic SCM'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Plateau LMS'
    },
    {
        'vendor': 'Platfora',
        'product': 'Platfora'
    },
    {
        'vendor': 'Platform.sh GmbH',
        'product': 'Platform.sh'
    },
    {
        'vendor': 'Platform9 Systems, Inc.',
        'product': 'Platform9'
    },
    {
        'vendor': 'Playwire Media, LLC',
        'product': 'PlayWire'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Playwright'
    },
    {
        'vendor': 'Plesk International GmbH',
        'product': 'Plesk'
    },
    {
        'vendor': 'Plex Systems, Inc.',
        'product': 'Plex Manufacturing Cloud'
    },
    {
        'vendor': 'Plex Systems, Inc.',
        'product': 'Plex Online'
    },
    {
        'vendor': 'Plex Systems, Inc.',
        'product': 'Plex Systems (Unspecified Product)'
    },
    {
        'vendor': 'Plivo, Inc.',
        'product': 'Plivo'
    },
    {
        'vendor': 'Plone Foundation',
        'product': 'Plone'
    },
    {
        'vendor': 'Sprinklr, Inc.',
        'product': 'Pluck'
    },
    {
        'vendor': 'ICU Medical, Inc.',
        'product': 'Plum360'
    },
    {
        'vendor': 'Plume Design, Inc.',
        'product': 'Plume Design'
    },
    {
        'vendor': 'Pluralsight, LLC',
        'product': 'Pluralsight'
    },
    {
        'vendor': 'Pluribus Networks, Inc.',
        'product': 'Pluribus (Unspecified Product)'
    },
    {
        'vendor': 'Pluribus Networks, Inc.',
        'product': 'Pluribus Switches'
    },
    {
        'vendor': 'Plus & Minus Software Corporation',
        'product': 'Plus&Minus'
    },
    {
        'vendor': 'Plutora, Inc.',
        'product': 'Plutora'
    },
    {
        'vendor': 'Performancing',
        'product': 'Pmetrics'
    },
    {
        'vendor': 'Pneuron',
        'product': 'Pneuron'
    },
    {
        'vendor': 'Pobuca',
        'product': 'Pobuca'
    },
    {
        'vendor': 'Podbean Tech, LLC',
        'product': 'Podbean'
    },
    {
        'vendor': 'Podium Corporation, Inc.',
        'product': 'Podium'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Podman'
    },
    {
        'vendor': 'Point of Rental Software',
        'product': 'Point of Rental'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Point2 Property Manager'
    },
    {
        'vendor': 'PointClickCare Technologies, Inc.',
        'product': 'PointClickCare'
    },
    {
        'vendor': 'PointOS',
        'product': 'PointOS'
    },
    {
        'vendor': 'Pointillist, Inc.',
        'product': 'Pointillist'
    },
    {
        'vendor': 'Polar Mobile Group, Inc.',
        'product': 'Polar'
    },
    {
        'vendor': 'Polaris Associates, Inc.',
        'product': 'Polaris Associates'
    },
    {
        'vendor': 'Polaris Consulting & Services, Ltd.',
        'product': 'Polaris FT'
    },
    {
        'vendor': 'NAVEX Global, Inc.',
        'product': 'PolicyTech'
    },
    {
        'vendor': 'PolyOptimum, Inc.',
        'product': 'PolyOptimum'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom (Unspecified Product)'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom HDX Series'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom PVX Series'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom RMX Series'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom RealPresence'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom SoundPoint'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom SoundStation Phones'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom Trio'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Polycom Vortex'
    },
    {
        'vendor': 'Popcorn Metrics.io, Inc.',
        'product': 'Popcorn Metrics'
    },
    {
        'vendor': 'Poppulo',
        'product': 'Poppulo'
    },
    {
        'vendor': 'Populi, Inc.',
        'product': 'Populi'
    },
    {
        'vendor': 'PortSwigger, Ltd.',
        'product': 'PortSwigger'
    },
    {
        'vendor': 'Heartland Payment Systems, Inc.',
        'product': 'Portico Virtual Terminal'
    },
    {
        'vendor': 'Portworx',
        'product': 'Portworx'
    },
    {
        'vendor': 'Quality Unit s.r.o.',
        'product': 'Post Affiliate Pro'
    },
    {
        'vendor': 'Sprinklr, Inc.',
        'product': 'Postano'
    },
    {
        'vendor': 'Postcron',
        'product': 'Postcron'
    },
    {
        'vendor': 'Open Source',
        'product': 'Postfix'
    },
    {
        'vendor': 'PostgreSQL Global Development',
        'product': 'PostgreSQL'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Postini'
    },
    {
        'vendor': 'Postman, Inc.',
        'product': 'Postman'
    },
    {
        'vendor': 'Wildbit, LLC',
        'product': 'Postmark'
    },
    {
        'vendor': 'Postmates, Inc.',
        'product': 'Postmates'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Power Compiler'
    },
    {
        'vendor': 'PowerDMS, Inc.',
        'product': 'PowerDMS'
    },
    {
        'vendor': 'PowerDNS.COM B.V.',
        'product': 'PowerDNS'
    },
    {
        'vendor': 'PowerPlan, Inc.',
        'product': 'PowerPlan'
    },
    {
        'vendor': 'PowerReviews, Inc.',
        'product': 'PowerReviews'
    },
    {
        'vendor': 'PowerSchool Group, LLC',
        'product': 'PowerSchool (Unspecified Product)'
    },
    {
        'vendor': 'PowerSchool Group, LLC',
        'product': 'PowerSchool Learning'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'PowerScribe 360 Reporting'
    },
    {
        'vendor': 'Qantel Technologies, Inc.',
        'product': 'PowerShift Enterprise System'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'PowerTech'
    },
    {
        'vendor': 'Quantcast Corporation',
        'product': 'Powered by Q'
    },
    {
        'vendor': 'Eleco PLC',
        'product': 'Powerproject'
    },
    {
        'vendor': 'Eleco PLC',
        'product': 'Powerproject BIM'
    },
    {
        'vendor': 'Ametek, Inc.',
        'product': 'Powervar'
    },
    {
        'vendor': 'Practice Fusion, Inc.',
        'product': 'Practice Fusion'
    },
    {
        'vendor': 'ABB OPTICAL GROUP',
        'product': 'Practice Maximus'
    },
    {
        'vendor': 'eMDs, Inc.',
        'product': 'Practice Partner'
    },
    {
        'vendor': 'Practice Pro',
        'product': 'Practice Pro'
    },
    {
        'vendor': 'Software Technology, LLC',
        'product': 'PracticeMaster'
    },
    {
        'vendor': 'PracticeMojo',
        'product': 'PracticeMojo'
    },
    {
        'vendor': 'Panther Software, LLC',
        'product': 'PracticePanther'
    },
    {
        'vendor': 'MicroFour, Inc.',
        'product': 'PracticeStudio'
    },
    {
        'vendor': 'PracticeSuite',
        'product': 'PracticeSuite'
    },
    {
        'vendor': 'Carestream Dental, LLC',
        'product': 'PracticeWorks'
    },
    {
        'vendor': 'Practising Law Institute',
        'product': 'Practising Law Institute'
    },
    {
        'vendor': 'Base Builders, LLC',
        'product': 'Praesto AE'
    },
    {
        'vendor': 'Praxedo',
        'product': 'Praxedo'
    },
    {
        'vendor': 'Infor-Med Medical Information Systems, Inc.',
        'product': 'Praxis EMR'
    },
    {
        'vendor': 'Collective Medical Technologies, Inc.',
        'product': 'PreManage'
    },
    {
        'vendor': 'PrebuiltML',
        'product': 'PrebuiltML'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'Precisely Spectrum Spatial'
    },
    {
        'vendor': 'Meridian Medical Management',
        'product': 'PrecisionBI'
    },
    {
        'vendor': 'PPD, Inc.',
        'product': 'Preclarus'
    },
    {
        'vendor': 'Predictive Response, Inc.',
        'product': 'Predictive Response'
    },
    {
        'vendor': 'Predictive Solutions Corporation',
        'product': 'Predictive Solutions'
    },
    {
        'vendor': 'Premiere Global Services, Inc.',
        'product': 'Premiere Global Services'
    },
    {
        'vendor': 'Presagis, Inc.',
        'product': 'Presagis (Unspecified Product)'
    },
    {
        'vendor': 'Presagis, Inc.',
        'product': 'Presagis VAPS XT'
    },
    {
        'vendor': 'Press Ganey Associates, LLC',
        'product': 'Press Ganey'
    },
    {
        'vendor': 'Press Ganey Associates, LLC',
        'product': 'Press Ganey Patient Experience'
    },
    {
        'vendor': 'ePressPack SAS',
        'product': 'PressKing'
    },
    {
        'vendor': 'Presspoint, LLC',
        'product': 'PressPoint'
    },
    {
        'vendor': 'PrestaShop S.A.',
        'product': 'PrestaShop'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Presto'
    },
    {
        'vendor': 'The Presto Foundation',
        'product': 'PrestoDB'
    },
    {
        'vendor': 'Presto Software Foundation',
        'product': 'PrestoSQL'
    },
    {
        'vendor': 'Prevalent, Inc.',
        'product': 'Prevalent'
    },
    {
        'vendor': 'Previstar, Inc.',
        'product': 'Previstar'
    },
    {
        'vendor': 'Prezly B.V.',
        'product': 'Prezly'
    },
    {
        'vendor': 'WEBCENTRIC d.o.o.',
        'product': 'Price2Spy'
    },
    {
        'vendor': 'McKinsey & Company',
        'product': 'PriceMetrix'
    },
    {
        'vendor': 'PriceSpider',
        'product': 'PriceSpider'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Primavera Contract Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Primavera Enterprise Project Portfolio Management'
    },
    {
        'vendor': 'PrimePay, Inc.',
        'product': 'PrimePay'
    },
    {
        'vendor': 'Greenway Health, LLC',
        'product': 'PrimeSuite'
    },
    {
        'vendor': 'CardConnect Corporation',
        'product': 'Princeton Payment'
    },
    {
        'vendor': 'Principia Partners, LLC',
        'product': 'Principia'
    },
    {
        'vendor': 'Priority Software, Ltd.',
        'product': 'Priority ERP'
    },
    {
        'vendor': 'Appfluence, Inc.',
        'product': 'Priority Matrix'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Prisma Access'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Prisma Cloud'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'Prisma SaaS'
    },
    {
        'vendor': 'Prisync',
        'product': 'Prisync'
    },
    {
        'vendor': 'Privacera, Inc.',
        'product': 'Privacera'
    },
    {
        'vendor': 'Privitar, Ltd.',
        'product': 'Privitar'
    },
    {
        'vendor': 'Privy, Inc.',
        'product': 'Privy'
    },
    {
        'vendor': 'Pro Softnet Corporation',
        'product': 'Pro Softnet IBackup'
    },
    {
        'vendor': 'Schneider Electric Japan Holdings, Ltd.',
        'product': 'Pro-face'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'Pro/ENGINEER Wildfire'
    },
    {
        'vendor': 'Prime Technologies, Inc.',
        'product': 'ProCalV5'
    },
    {
        'vendor': 'ProChain Solutions, Inc.',
        'product': 'ProChain'
    },
    {
        'vendor': 'Viewpoint, Inc.',
        'product': 'ProContractor'
    },
    {
        'vendor': 'Puzzle Data Company, Ltd.',
        'product': 'ProDiscovery'
    },
    {
        'vendor': 'ProEst Estimating Software',
        'product': 'ProEst'
    },
    {
        'vendor': 'MRI Software, LLC',
        'product': 'ProLease'
    },
    {
        'vendor': 'Nutanix, Inc.',
        'product': 'ProLiant vSAN ReadyNodes'
    },
    {
        'vendor': 'ProProfs',
        'product': 'ProProfs'
    },
    {
        'vendor': 'ProShip, Inc.',
        'product': 'ProShip'
    },
    {
        'vendor': 'eBay, Inc.',
        'product': 'ProStores'
    },
    {
        'vendor': 'ProTexting, LLC',
        'product': 'ProTexting'
    },
    {
        'vendor': 'Provation Medical, Inc.',
        'product': 'ProVation MD'
    },
    {
        'vendor': 'Proactive Software, Ltd.',
        'product': 'ProWorkflow'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Business Network'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Content Management'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Contract Management'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Invoice'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Procurement'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Procurement Control'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis SA investors'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Sell'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Sourcing'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Supplier Management'
    },
    {
        'vendor': 'Procentive, Inc.',
        'product': 'Procentive'
    },
    {
        'vendor': 'Siemens Industry Software, Inc.',
        'product': 'Process Simulate'
    },
    {
        'vendor': 'Process Street, Inc.',
        'product': 'Process Street'
    },
    {
        'vendor': 'UiPath, Inc.',
        'product': 'ProcessGold'
    },
    {
        'vendor': 'ProcessMAP Corporation',
        'product': 'ProcessMAP'
    },
    {
        'vendor': 'ProcessWeaver, Inc.',
        'product': 'ProcessWeaver'
    },
    {
        'vendor': 'ProclivityMedia',
        'product': 'ProclivityMedia'
    },
    {
        'vendor': 'Procore Technologies, Inc.',
        'product': 'Procore'
    },
    {
        'vendor': 'Procore Technologies, Inc.',
        'product': 'Procore BIM'
    },
    {
        'vendor': 'Procore Technologies, Inc.',
        'product': 'Procore Invoice Management'
    },
    {
        'vendor': 'Procore Technologies, Inc.',
        'product': 'Procore Project Management'
    },
    {
        'vendor': 'ProctorU, Inc.',
        'product': 'ProctorU'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'Procuri'
    },
    {
        'vendor': 'CreateShift, Ltd.',
        'product': 'ProdPad'
    },
    {
        'vendor': 'ProdPerfect, Inc.',
        'product': 'ProdPerfect'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Product 360'
    },
    {
        'vendor': 'NetSource Technologies, Inc.',
        'product': 'ProductCart'
    },
    {
        'vendor': 'Jive Software, Inc.',
        'product': 'Producteev'
    },
    {
        'vendor': 'Profiles International, LLC',
        'product': 'ProfileXT'
    },
    {
        'vendor': 'Profisee Group, Inc.',
        'product': 'Profisee'
    },
    {
        'vendor': 'ProfitKey International',
        'product': 'ProfitKey'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'ProfitStars'
    },
    {
        'vendor': 'ProfitSword, LLC',
        'product': 'ProfitSword'
    },
    {
        'vendor': '200 OK, LLC',
        'product': 'ProfitWell'
    },
    {
        'vendor': 'Profitero, Inc.',
        'product': 'Profitero'
    },
    {
        'vendor': 'Profound Logic Software, Inc.',
        'product': 'Profound Logic Software'
    },
    {
        'vendor': 'Progeny Software, LLC',
        'product': 'Progeny Clinical'
    },
    {
        'vendor': 'Bizmatics, Inc.',
        'product': 'PrognoCIS'
    },
    {
        'vendor': 'Azalea Health',
        'product': 'Prognosis Innovation Healthcare'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Progress Corticon'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Progress OpenEdge'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Progress Orbacus'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Progress Software'
    },
    {
        'vendor': 'Metafuse',
        'product': 'Project Insight'
    },
    {
        'vendor': 'Experience In Software, Inc.',
        'product': 'Project KickStart'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Project Trillium'
    },
    {
        'vendor': 'ProjectManager.com, Inc.',
        'product': 'ProjectManager.com'
    },
    {
        'vendor': 'Systemates, Inc.',
        'product': 'Projectmates'
    },
    {
        'vendor': 'Projector PSA, Inc.',
        'product': 'Projector PSA'
    },
    {
        'vendor': 'Planview, Inc.',
        'product': 'Projectplace'
    },
    {
        'vendor': 'Projecturf, LLC',
        'product': 'Projecturf'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Prolexic Routed'
    },
    {
        'vendor': 'Prolifiq Software, Inc.',
        'product': 'Prolifiq'
    },
    {
        'vendor': 'Promas',
        'product': 'Promas'
    },
    {
        'vendor': 'Open Source',
        'product': 'Prometheus'
    },
    {
        'vendor': 'Promise Technology, Inc.',
        'product': 'Promise Technology'
    },
    {
        'vendor': 'Promoter.io, Inc.',
        'product': 'Promoter.io'
    },
    {
        'vendor': 'Promys, Inc.',
        'product': 'Promys PSA'
    },
    {
        'vendor': 'ACCEO Solutions, Inc.',
        'product': 'Pronotaire'
    },
    {
        'vendor': 'Pronto Software, Ltd.',
        'product': 'Pronto Software'
    },
    {
        'vendor': 'Pronto Software, Ltd.',
        'product': 'Pronto Xi ERP'
    },
    {
        'vendor': 'ProofHub, LLC',
        'product': 'ProofHub'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint CASB'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Email Encryption'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Enterprise Archive'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Enterprise Protection'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Essentials'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Targeted Attack Protection'
    },
    {
        'vendor': 'PropelPLM, Inc.',
        'product': 'Propel'
    },
    {
        'vendor': 'Property Boulevard',
        'product': 'Property Boulevard'
    },
    {
        'vendor': 'Property Genie, Inc.',
        'product': 'Property Genie'
    },
    {
        'vendor': 'Property Matrix, Inc.',
        'product': 'Property Matrix'
    },
    {
        'vendor': 'PropertyBoss Solutions, LLC',
        'product': 'PropertyBoss'
    },
    {
        'vendor': 'PropertyVista Software, Inc.',
        'product': 'PropertyVista'
    },
    {
        'vendor': 'Propertybase, Inc.',
        'product': 'Propertybase'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'Propertyware'
    },
    {
        'vendor': 'Prophix Software, Inc.',
        'product': 'Prophix'
    },
    {
        'vendor': 'Prosodie',
        'product': 'Prosodie'
    },
    {
        'vendor': 'Prospect.io SPRL',
        'product': 'Prospect.io'
    },
    {
        'vendor': 'AppsFlyer, Inc.',
        'product': 'Protect360'
    },
    {
        'vendor': 'Protegrity USA, Inc.',
        'product': 'Protegrity'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Proteus'
    },
    {
        'vendor': 'Protiviti, Inc.',
        'product': 'Protiviti'
    },
    {
        'vendor': 'Proto.io',
        'product': 'Proto.io'
    },
    {
        'vendor': 'Open Source',
        'product': 'Protractor'
    },
    {
        'vendor': 'Smart ERP Solutions, Inc.',
        'product': 'Provade VMS'
    },
    {
        'vendor': 'Provance Technologies, Inc.',
        'product': 'Provance'
    },
    {
        'vendor': 'Provenir, Inc.',
        'product': 'Provenir'
    },
    {
        'vendor': 'ProviderSoft, LLC',
        'product': 'ProviderSoft'
    },
    {
        'vendor': 'Open Source',
        'product': 'Prowler'
    },
    {
        'vendor': 'Open Source',
        'product': 'ProxySQL'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Psion Teklogix'
    },
    {
        'vendor': 'Ptmind, Inc.',
        'product': 'Ptengine'
    },
    {
        'vendor': 'PubExchange',
        'product': 'PubExchange'
    },
    {
        'vendor': 'PubMatic, Inc.',
        'product': 'PubMatic'
    },
    {
        'vendor': 'PubNub, Inc.',
        'product': 'PubNub'
    },
    {
        'vendor': 'Pulse Commerce',
        'product': 'Pulse Commerce Order and Inventory Platform'
    },
    {
        'vendor': 'Pulse Secure, LLC',
        'product': 'Pulse Connect Secure'
    },
    {
        'vendor': 'Juniper Networks, Inc.',
        'product': 'Pulse Secure'
    },
    {
        'vendor': 'Pulse Secure, LLC',
        'product': 'Pulse Secure (Unspecified Product)'
    },
    {
        'vendor': 'Pulse Secure, LLC',
        'product': 'Pulse Secure SA2500'
    },
    {
        'vendor': 'Pulse Secure, LLC',
        'product': 'Pulse Secure SA4500'
    },
    {
        'vendor': 'Pulse Secure, LLC',
        'product': 'Pulse Secure SA6500'
    },
    {
        'vendor': 'Pulse Systems, Inc.',
        'product': 'PulseEHR'
    },
    {
        'vendor': 'PulsePoint, Inc.',
        'product': 'PulsePoint'
    },
    {
        'vendor': 'Pulse Systems, Inc.',
        'product': 'PulseRCM'
    },
    {
        'vendor': 'Pulseway',
        'product': 'Pulseway'
    },
    {
        'vendor': 'Pulumi Corporation',
        'product': 'Pulumi'
    },
    {
        'vendor': 'Walmart, Inc.',
        'product': 'Punchtab'
    },
    {
        'vendor': 'Puppet, Inc.',
        'product': 'Puppet Enterprise'
    },
    {
        'vendor': 'Puppet Labs',
        'product': 'Puppet Labs'
    },
    {
        'vendor': 'Open Source',
        'product': 'Puppeteer'
    },
    {
        'vendor': 'Pure Chat, Inc.',
        'product': 'Pure Chat'
    },
    {
        'vendor': 'Pure Storage, Inc.',
        'product': 'Pure Storage (Unspecified Product)'
    },
    {
        'vendor': 'Pure Storage, Inc.',
        'product': 'Pure Storage FlashBlade'
    },
    {
        'vendor': 'Pure Storage, Inc.',
        'product': 'Pure-as-a-Service'
    },
    {
        'vendor': 'Pure360',
        'product': 'Pure360'
    },
    {
        'vendor': 'PureCars',
        'product': 'PureCars'
    },
    {
        'vendor': 'Medtronic PLC',
        'product': 'Puritan Bennett'
    },
    {
        'vendor': 'Purkinje',
        'product': 'Purkinje EMR'
    },
    {
        'vendor': 'Pushnami, LLC',
        'product': 'Pushnami'
    },
    {
        'vendor': 'Python Software Foundation',
        'product': 'PyMongo'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'PyTorch'
    },
    {
        'vendor': 'Pype, Inc.',
        'product': 'Pype'
    },
    {
        'vendor': 'SoftwareONE AG',
        'product': 'PyraCloud'
    },
    {
        'vendor': 'Pyramid Analytics B.V.',
        'product': 'Pyramid Analytics'
    },
    {
        'vendor': 'PyroCMS, Inc.',
        'product': 'PyroCMS'
    },
    {
        'vendor': 'Python Software Foundation',
        'product': 'Python'
    },
    {
        'vendor': 'Python Software Foundation',
        'product': 'Python 3.4'
    },
    {
        'vendor': 'PythonAnywhere LLP',
        'product': 'PythonAnywhere'
    },
    {
        'vendor': 'Quantcast Corporation',
        'product': 'Q for Publishers'
    },
    {
        'vendor': 'Q-Chem',
        'product': 'Q-Chem'
    },
    {
        'vendor': 'Q-Sensei Corporation',
        'product': 'Q-Sensei'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Q1 Labs'
    },
    {
        'vendor': 'Q4, Inc.',
        'product': 'Q4'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD ERP'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD Enterprise Asset Management'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD Manufacturing'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD QXtend'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD Service and Support'
    },
    {
        'vendor': 'QAD, Inc.',
        'product': 'QAD Supply Chain'
    },
    {
        'vendor': 'Open Source',
        'product': 'QEMU'
    },
    {
        'vendor': 'Marvell Technology Group, Ltd.',
        'product': 'QLogic'
    },
    {
        'vendor': 'Quantitative Medical Systems, Inc.',
        'product': 'QMS Focus'
    },
    {
        'vendor': 'QNX Software Systems',
        'product': 'QNX'
    },
    {
        'vendor': 'QPR Software PLC',
        'product': 'QPR ProcessAnalyzer'
    },
    {
        'vendor': 'Terracom S.A.',
        'product': 'QR-Patrol'
    },
    {
        'vendor': 'Quantitative Risk Management, Inc.',
        'product': 'QRM'
    },
    {
        'vendor': 'Smith Technologies, LLC',
        'product': 'QS/1'
    },
    {
        'vendor': 'QTS Realty Trust, Inc.',
        'product': 'QTS Data Center Solutions'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'QUnit'
    },
    {
        'vendor': 'Qarbon, Inc.',
        'product': 'Qarbon'
    },
    {
        'vendor': 'Qbrick AB',
        'product': 'Qbrick'
    },
    {
        'vendor': 'Qiagen N.V.',
        'product': 'Qiagen Ingenuity Pathway Analysis'
    },
    {
        'vendor': 'Qiagen N.V.',
        'product': 'Qiagen Ingenuity Variant Analysis'
    },
    {
        'vendor': 'QlikTech, Inc.',
        'product': 'Qlik Analytics Platform'
    },
    {
        'vendor': 'QlikTech, Inc.',
        'product': 'Qlik Data Integration Platform'
    },
    {
        'vendor': 'QlikTech, Inc.',
        'product': 'Qlik Replicate'
    },
    {
        'vendor': 'QlikTech, Inc.',
        'product': 'Qlik Sense'
    },
    {
        'vendor': 'QlikTech, Inc.',
        'product': 'QlikView'
    },
    {
        'vendor': 'Qmarkets',
        'product': 'Qmarkets'
    },
    {
        'vendor': 'QNAP Systems, Inc.',
        'product': 'Qnap (Unspecified Product)'
    },
    {
        'vendor': 'Qnect, LLC',
        'product': 'Qnect'
    },
    {
        'vendor': 'Qognify, Ltd.',
        'product': 'Qognify'
    },
    {
        'vendor': 'Qognify, Ltd.',
        'product': 'Qognify Situator'
    },
    {
        'vendor': 'Qstream, Inc.',
        'product': 'Qstream'
    },
    {
        'vendor': 'Quad9',
        'product': 'Quad9'
    },
    {
        'vendor': 'Quadax, Inc.',
        'product': 'Quadax'
    },
    {
        'vendor': 'Quadia S.A.',
        'product': 'Quadia'
    },
    {
        'vendor': 'Quadient Group AG',
        'product': 'Quadient Inspire'
    },
    {
        'vendor': 'Quadient Group AG',
        'product': 'Quadient Inspire Interactive'
    },
    {
        'vendor': 'Quadient Group AG',
        'product': 'Quadient Inspire Platform'
    },
    {
        'vendor': 'QuadraMed Corporation',
        'product': 'QuadraMed'
    },
    {
        'vendor': 'QuadraMed Corporation',
        'product': 'QuadraMed nCoder+'
    },
    {
        'vendor': 'Quadrant Software, LLC',
        'product': 'Quadrant Software'
    },
    {
        'vendor': 'Quadrigram S.L.',
        'product': 'Quadrigram'
    },
    {
        'vendor': 'Quadrotech Solutions AG',
        'product': 'Quadrotech'
    },
    {
        'vendor': 'Qualaroo, Inc.',
        'product': 'Qualaroo'
    },
    {
        'vendor': 'Qualcomm Technologies, Inc.',
        'product': 'Qualcomm'
    },
    {
        'vendor': 'Qualcomm Technologies, Inc.',
        'product': 'Qualcomm Quick Charge'
    },
    {
        'vendor': 'Qualcomm Technologies, Inc.',
        'product': 'Qualcomm Snapdragon'
    },
    {
        'vendor': 'Queue Services, LLC',
        'product': 'Qualedi'
    },
    {
        'vendor': 'QualiWare ApS',
        'product': 'QualiWare'
    },
    {
        'vendor': 'Qualia Labs, Inc.',
        'product': 'Qualia'
    },
    {
        'vendor': 'Quality Systems',
        'product': 'Quality Systems Mirth'
    },
    {
        'vendor': 'Qualstar Corporation',
        'product': 'Qualstar'
    },
    {
        'vendor': 'Qualtrics, LLC',
        'product': 'Qualtrics (Unspecified Product)'
    },
    {
        'vendor': 'Qualtrics, LLC',
        'product': 'Qualtrics Online Survey Software'
    },
    {
        'vendor': 'Qualtrics, LLC',
        'product': 'Qualtrics XM'
    },
    {
        'vendor': 'Qualys, Inc.',
        'product': 'Qualys Cloud Agent'
    },
    {
        'vendor': 'Qualys, Inc.',
        'product': 'Qualys Cloud Platform'
    },
    {
        'vendor': 'Qualys, Inc.',
        'product': 'Qualys Penetration Testing'
    },
    {
        'vendor': 'Qualys, Inc.',
        'product': 'Qualys VMDR'
    },
    {
        'vendor': 'Qualys, Inc.',
        'product': 'Qualys Web Application Scanning'
    },
    {
        'vendor': 'Qualys, Inc.',
        'product': 'QualysGuard'
    },
    {
        'vendor': 'Quandoo GmbH',
        'product': 'Quandoo'
    },
    {
        'vendor': 'QCT, LLC',
        'product': 'Quanta Cloud Technology'
    },
    {
        'vendor': 'Quantcast Corporation',
        'product': 'Quantcast'
    },
    {
        'vendor': 'Quantcast Corporation',
        'product': 'Quantcast (Unspecified Product)'
    },
    {
        'vendor': 'Grass Valley Canada',
        'product': 'Quantel'
    },
    {
        'vendor': 'Quantrax Corporation, Inc.',
        'product': 'Quantrax'
    },
    {
        'vendor': 'Quantrix, LLC',
        'product': 'Quantrix'
    },
    {
        'vendor': 'Quantros, Inc.',
        'product': 'Quantros'
    },
    {
        'vendor': 'Quantros, Inc.',
        'product': 'Quantros Outcomes Analytics'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Corporation (Unspecified Product)'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum DXi'
    },
    {
        'vendor': 'Quantum ESPRESSO',
        'product': 'Quantum ESPRESSO'
    },
    {
        'vendor': 'Quantum Metric, Inc.',
        'product': 'Quantum Metric'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum QXS'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Scalar 10K'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Scalar Key Manager'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Scalar i2000'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Scalar i6000'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum StorNext'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Tape Libraries'
    },
    {
        'vendor': 'Quantum Workplace, Inc.',
        'product': 'Quantum Workplace'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum Xcellis'
    },
    {
        'vendor': 'Quantum Corporation',
        'product': 'Quantum vmPRO'
    },
    {
        'vendor': 'Quest Diagnostics, Inc.',
        'product': 'Quanum EHR'
    },
    {
        'vendor': 'Quest Diagnostics, Inc.',
        'product': 'Quanum Electronic Health Record'
    },
    {
        'vendor': 'Quark Software, Inc.',
        'product': 'Quark'
    },
    {
        'vendor': 'Quark Software, Inc.',
        'product': 'QuarkXPress'
    },
    {
        'vendor': 'Software AG',
        'product': 'Quartz Scheduler'
    },
    {
        'vendor': 'QuasarDB SAS',
        'product': 'QuasarDB'
    },
    {
        'vendor': 'Qube Software',
        'product': 'Qube Software'
    },
    {
        'vendor': 'Qubit Digital, Ltd.',
        'product': 'Qubit (Unspecified Product)'
    },
    {
        'vendor': 'Qubit Digital, Ltd.',
        'product': 'Qubit Customer Influence Engine'
    },
    {
        'vendor': 'Qubit Digital, Ltd.',
        'product': 'Qubit OpenTag'
    },
    {
        'vendor': 'Qubole, Inc.',
        'product': 'Qubole'
    },
    {
        'vendor': 'QueBIT Consulting, LLC',
        'product': 'QueBIT FrameWORQ'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Active Administrator'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest ActiveRoles Server'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Archive Manager'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Benchmark Factory'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Change Auditor'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest ChangeBASE'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest DL1000'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest DL4300'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Defender'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Enterprise Reporter Suite'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Foglight'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest InTrust'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest KACE Express'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest KACE System Management Appliance'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest KACE System Management Appliances'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest KACE Systems Deployment Appliance'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest LiteSpeed for SQL Server'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest MessageStats'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Migration Manager'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Migration Manager for Active Directory'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest NetVault'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest QMX'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Rapid Recovery'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Recovery Manager'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest ScriptLogic'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Shareplex'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Software (Unspecified Product)'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Spotlight on SQL Server'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Toad'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Toad for SQL Server'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest Virtualization Management'
    },
    {
        'vendor': 'Quest Software, Inc.',
        'product': 'Quest vRanger'
    },
    {
        'vendor': 'Questback A/S',
        'product': 'Questback'
    },
    {
        'vendor': 'Questel SAS',
        'product': 'Questel'
    },
    {
        'vendor': 'Questica, Inc.',
        'product': 'Questica'
    },
    {
        'vendor': 'QuestionPro, Inc.',
        'product': 'QuestionPro'
    },
    {
        'vendor': 'Questionmark Computing, Ltd.',
        'product': 'Questionmark'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'Questra'
    },
    {
        'vendor': 'Harris Enterprise Resource Planning',
        'product': 'Questys (Unspecified Product)'
    },
    {
        'vendor': 'Quetzal POS, Ltd.',
        'product': 'Quetzal POS'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBase'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBooks'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBooks Desktop Pro'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBooks Enterprise'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBooks Online'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBooks POS'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'QuickBooks Payroll'
    },
    {
        'vendor': 'PMEase',
        'product': 'QuickBuild'
    },
    {
        'vendor': 'QuickMobile, Inc.',
        'product': 'QuickMobile'
    },
    {
        'vendor': 'BroadVision, Inc.',
        'product': 'QuickSilver'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Quickbooks Desktop'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Quickbooks Premier Plus'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Quickbooks Time'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Quicken Premier'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'Quicken Rental Property Manager'
    },
    {
        'vendor': 'Quid, Inc.',
        'product': 'Quid'
    },
    {
        'vendor': 'QuinStreet, Inc.',
        'product': 'QuinStreet'
    },
    {
        'vendor': 'Quip, LLC',
        'product': 'Quip'
    },
    {
        'vendor': 'Quiq, Inc.',
        'product': 'Quiq'
    },
    {
        'vendor': 'QUISMA GmbH',
        'product': 'Quisma'
    },
    {
        'vendor': 'Qumu Corporation',
        'product': 'Qumu'
    },
    {
        'vendor': 'Qumulo, Inc.',
        'product': 'Qumulo'
    },
    {
        'vendor': 'JPMorgan Chase & Company',
        'product': 'Quorum'
    },
    {
        'vendor': 'Quorum Analytics, Inc.',
        'product': 'Quorum Analytics'
    },
    {
        'vendor': 'QuoteSoft',
        'product': 'QuoteSoft'
    },
    {
        'vendor': 'Aspire Technology, Ltd.',
        'product': 'QuoteWerks'
    },
    {
        'vendor': 'Qventus, Inc.',
        'product': 'Qventus'
    },
    {
        'vendor': 'Qvera',
        'product': 'Qvera'
    },
    {
        'vendor': 'Qwilr',
        'product': 'Qwilr'
    },
    {
        'vendor': 'Open Source',
        'product': 'R Project'
    },
    {
        'vendor': 'Rohde & Schwarz GmbH & Company KG',
        'product': 'R&S CLIPSTER'
    },
    {
        'vendor': 'Rohde & Schwarz GmbH & Company KG',
        'product': 'R&S CLIPSTER Play'
    },
    {
        'vendor': 'Rohde & Schwarz GmbH & Company KG',
        'product': 'R&S Test and Measurement'
    },
    {
        'vendor': 'Rohde & Schwarz GmbH & Company KG',
        'product': 'R&S Wireless Communication Testing'
    },
    {
        'vendor': 'Progressive Automotive Systems, Inc.',
        'product': 'R.O. Writer'
    },
    {
        'vendor': 'R1 RCM, Inc.',
        'product': 'R1 RCM'
    },
    {
        'vendor': 'ConnectWise, LLC',
        'product': 'R1Soft'
    },
    {
        'vendor': 'ConnectWise, LLC',
        'product': 'R1Soft CDP'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'RADAN'
    },
    {
        'vendor': 'RADWIN, Ltd.',
        'product': 'RADWIN'
    },
    {
        'vendor': 'Inmar, Inc.',
        'product': 'RASMAS'
    },
    {
        'vendor': 'Manning NavComp, Inc.',
        'product': 'RASTRAC'
    },
    {
        'vendor': 'RAYNET CRM, LLC',
        'product': 'RAYNET CRM'
    },
    {
        'vendor': 'Medsphere Systems Corporation',
        'product': 'RCM Cloud'
    },
    {
        'vendor': 'RD Station, Inc.',
        'product': 'RD Station'
    },
    {
        'vendor': 'Resort Data Processing',
        'product': 'RDPWin'
    },
    {
        'vendor': 'Lombard Risk',
        'product': 'REG-Reporter'
    },
    {
        'vendor': 'RELEX Oy',
        'product': 'RELEX'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'RES Software'
    },
    {
        'vendor': 'RESUMate, Inc.',
        'product': 'RESUMate'
    },
    {
        'vendor': 'RF-SMART',
        'product': 'RF-Smart'
    },
    {
        'vendor': 'RFID Global Solution, Inc.',
        'product': 'RFID Global Solution'
    },
    {
        'vendor': 'RFPIO, Inc.',
        'product': 'RFPIO'
    },
    {
        'vendor': 'Rapid Global Business Solutions, Inc.',
        'product': 'RGBSI'
    },
    {
        'vendor': 'RIB Software SE',
        'product': 'RIB MTWO'
    },
    {
        'vendor': 'RIB Software',
        'product': 'RIB Software iTWO'
    },
    {
        'vendor': 'RICS Software',
        'product': 'RICS Software'
    },
    {
        'vendor': 'RISA Tech, Inc.',
        'product': 'RISA'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'RJS Software'
    },
    {
        'vendor': 'RL Solutions',
        'product': 'RL Solutions'
    },
    {
        'vendor': 'RLDatix, Ltd.',
        'product': 'RL Suite'
    },
    {
        'vendor': 'RLDatix, Ltd.',
        'product': 'RLDatix Infection'
    },
    {
        'vendor': 'Korbyt',
        'product': 'RMG INVIEW'
    },
    {
        'vendor': 'RMS Software',
        'product': 'RMS Hospitality Cloud'
    },
    {
        'vendor': 'ROI Solutions',
        'product': 'ROI Solutions'
    },
    {
        'vendor': 'iQmetrix Software Development Corporation',
        'product': 'RQ Retail'
    },
    {
        'vendor': 'R.R. Donnelley & Sons Company',
        'product': 'RR Donnelley CustomPoint'
    },
    {
        'vendor': 'Donnelley Financial, LLC',
        'product': 'RR Donnelley Venue'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Access Certification Manager'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Access Manager'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Adaptive Authentication'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Archer'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Archer Regulatory & Corporate Compliance Management'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Business Role Manager'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA DLP'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Data Access Governance'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Identity Governance and Lifecycle'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA NetWitness Endpoint'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA NetWitness Platform'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'RSA QDirect'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA SecurID Access'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA SecurID Suite'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA Security Analytics'
    },
    {
        'vendor': 'Rochester Software Associates, Inc.',
        'product': 'RSA WebCRD'
    },
    {
        'vendor': 'RSA Security, LLC',
        'product': 'RSA enVision'
    },
    {
        'vendor': 'Rockwell Automation, Inc.',
        'product': 'RSLogix'
    },
    {
        'vendor': 'SL Corporation',
        'product': 'RTView for TIBCO Monitoring'
    },
    {
        'vendor': 'CommScope, Inc.',
        'product': 'RUCKUS'
    },
    {
        'vendor': 'CommScope, Inc.',
        'product': 'RUCKUS Cloudpath'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'RUN Powered by ADP'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'RabbitMQ'
    },
    {
        'vendor': 'Open Source',
        'product': 'Rack Cache'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace CDN'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace DNS'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace Email'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace Hosting'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace Managed Cloud Services'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace ObjectRocket'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace Private Cloud'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace Vulnerability Assessments'
    },
    {
        'vendor': 'Rackwise, Inc.',
        'product': 'Rackwise DCiM X'
    },
    {
        'vendor': 'RadarURL',
        'product': 'RadarURL'
    },
    {
        'vendor': 'Fanestra Information Systems, Inc.',
        'product': 'Radekal Productivity Tool'
    },
    {
        'vendor': 'Accelerite',
        'product': 'Radia Client Automation'
    },
    {
        'vendor': 'Radial, Inc.',
        'product': 'Radial'
    },
    {
        'vendor': 'Radiant Logic',
        'product': 'Radiant Logic'
    },
    {
        'vendor': 'NCR Corporation',
        'product': 'Radiant Systems'
    },
    {
        'vendor': 'RhythmOne, LLC',
        'product': 'RadiumOne'
    },
    {
        'vendor': 'Radlink, Inc.',
        'product': 'Radlink'
    },
    {
        'vendor': 'Famatech Corporation',
        'product': 'Radmin'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware (Unspecified Product)'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware Alteon'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware AppWall'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware Bot Manager'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware Cloud DDoS Protection Service'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware DefensePro'
    },
    {
        'vendor': 'Visma Group',
        'product': 'Raet'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'RainStor'
    },
    {
        'vendor': 'Rainforest QA',
        'product': 'Rainforest QA'
    },
    {
        'vendor': 'Cendyn Group, LLC',
        'product': 'Rainmaker'
    },
    {
        'vendor': 'Raintree Systems',
        'product': 'Raintree Systems'
    },
    {
        'vendor': 'Raken, Inc.',
        'product': 'Raken'
    },
    {
        'vendor': 'RAKUS Company, Ltd.',
        'product': 'Raku-Raku Seisan'
    },
    {
        'vendor': 'Rakuten Advertising',
        'product': 'Rakuten Affiliate Network'
    },
    {
        'vendor': 'Rakuten Advertising',
        'product': 'Rakuten Affiliate for Advertisers'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Rally'
    },
    {
        'vendor': 'RamSoft, Inc.',
        'product': 'RamSoft'
    },
    {
        'vendor': 'Rambler Internet Holding, LLC',
        'product': 'Rambler'
    },
    {
        'vendor': 'Ramco Systems, Ltd.',
        'product': 'Ramco'
    },
    {
        'vendor': 'Rancher Labs, Inc.',
        'product': 'Rancher Labs'
    },
    {
        'vendor': 'RankAbove, Ltd.',
        'product': 'RankAbove'
    },
    {
        'vendor': 'RankRanger, LLC',
        'product': 'RankRanger'
    },
    {
        'vendor': 'Web IQ Technologies Pvt Ltd',
        'product': 'Rankwatch'
    },
    {
        'vendor': 'Ranorex GmbH',
        'product': 'Ranorex Studio'
    },
    {
        'vendor': 'Rapid Global Pty Ltd',
        'product': 'Rapid Global'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'Rapid7'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'Rapid7 AppSpider'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'Rapid7 InsightAppSec'
    },
    {
        'vendor': 'RapidAPI',
        'product': 'RapidAPI'
    },
    {
        'vendor': 'RapidDeploy, Inc.',
        'product': 'RapidDeploy'
    },
    {
        'vendor': 'RapidMiner, Inc.',
        'product': 'RapidMiner'
    },
    {
        'vendor': 'Enera International AB',
        'product': 'RapidReach'
    },
    {
        'vendor': 'Rapleaf',
        'product': 'Rapleaf'
    },
    {
        'vendor': 'Rapt Media, Inc.',
        'product': 'Rapt Media'
    },
    {
        'vendor': 'Harbinger Group',
        'product': 'Raptivity'
    },
    {
        'vendor': 'Raritan, Inc.',
        'product': 'Raritan'
    },
    {
        'vendor': 'Raritan, Inc.',
        'product': 'Raritan Inc.'
    },
    {
        'vendor': 'RateLinx',
        'product': 'RateLinx (Unspecified Product)'
    },
    {
        'vendor': 'UNICOM Systems, Inc.',
        'product': 'Rational Focal Point'
    },
    {
        'vendor': 'UNICOM Systems, Inc.',
        'product': 'Rational System Architect'
    },
    {
        'vendor': 'Stand By Soft',
        'product': 'RationalPlan'
    },
    {
        'vendor': 'Rauland-Borg Corporation',
        'product': 'Rauland'
    },
    {
        'vendor': 'Rave Mobile Safety, Inc.',
        'product': 'Rave Alert'
    },
    {
        'vendor': 'Rave Mobile Safety, Inc.',
        'product': 'Rave Guardian'
    },
    {
        'vendor': 'Rave Mobile Safety, Inc.',
        'product': 'Rave Panic Button'
    },
    {
        'vendor': 'Hibernating Rhinos, Ltd.',
        'product': 'RavenDB'
    },
    {
        'vendor': 'Mi9 Retail, Inc.',
        'product': 'Raymark'
    },
    {
        'vendor': 'Raz-Lee Security, Inc.',
        'product': 'Raz-Lee'
    },
    {
        'vendor': 'RazorSync, LLC',
        'product': 'RazorSync'
    },
    {
        'vendor': 'Razorpay Software Pvt Ltd',
        'product': 'Razorpay'
    },
    {
        'vendor': 'Razuna',
        'product': 'Razuna'
    },
    {
        'vendor': 'DrFirst.com, Inc.',
        'product': 'Rcopia 4'
    },
    {
        'vendor': 'Net Health',
        'product': 'ReDoc'
    },
    {
        'vendor': 'ReLi Med Solutions',
        'product': 'ReLi Med'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'ReServe Interactive'
    },
    {
        'vendor': 'ConversionPoint Technologies, Inc.',
        'product': 'ReTargeter'
    },
    {
        'vendor': 'ReTrans, Inc.',
        'product': 'ReTrans'
    },
    {
        'vendor': 'Levels Beyond, Inc.',
        'product': 'Reach Engine'
    },
    {
        'vendor': 'ReachLocal, Inc.',
        'product': 'ReachEdge'
    },
    {
        'vendor': 'Leadspace, Inc.',
        'product': 'ReachForce'
    },
    {
        'vendor': 'ReachLocal, Inc.',
        'product': 'ReachLocal'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'React Native'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'ReactJS'
    },
    {
        'vendor': 'ReactX, LLC',
        'product': 'ReactX'
    },
    {
        'vendor': 'Reactful, Inc.',
        'product': 'Reactful'
    },
    {
        'vendor': 'ReadMe.io',
        'product': 'ReadMe'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'ReadSoft'
    },
    {
        'vendor': 'Curriculum Associates, LLC',
        'product': 'Ready Mathematics'
    },
    {
        'vendor': 'ReadyCloud, LLC',
        'product': 'ReadyCloud'
    },
    {
        'vendor': 'ReadyGo, Inc.',
        'product': 'ReadyGo'
    },
    {
        'vendor': 'KLDiscovery, LLC',
        'product': 'ReadySuite'
    },
    {
        'vendor': 'ReadyTalk',
        'product': 'ReadyTalk'
    },
    {
        'vendor': 'Real Omni Channel Commerce, Inc.',
        'product': 'Real Omni Channel Commerce (ROC)'
    },
    {
        'vendor': 'Next Limit S.L.',
        'product': 'RealFlow'
    },
    {
        'vendor': 'Discovery, Inc.',
        'product': 'RealGravity'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage (Unspecified Product)'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Accounting'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Asset and Investment Management (AIM)'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Contact Center'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage EasyLMS'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Facilities Management'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage ILM Lead Manager'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage OneSite'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage OneSite Document Management'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Property Management'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Resident Screening'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Revenue Management'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'RealPage Utility Management'
    },
    {
        'vendor': 'RealTime Software Solutions, LLC',
        'product': 'RealTime CTMS'
    },
    {
        'vendor': 'RealVNC, Ltd.',
        'product': 'RealVNC'
    },
    {
        'vendor': 'Realeflow, LLC',
        'product': 'Realeflow'
    },
    {
        'vendor': 'Really Simple Systems, Ltd.',
        'product': 'Really Simple Systems CRM'
    },
    {
        'vendor': 'Realvolve, LLC',
        'product': 'Realvolve'
    },
    {
        'vendor': 'Reamaze',
        'product': 'Reamaze'
    },
    {
        'vendor': 'RebelMouse, Inc.',
        'product': 'RebelMouse'
    },
    {
        'vendor': 'Betsol, Inc.',
        'product': 'Rebit Personal Backup'
    },
    {
        'vendor': 'Vermont Systems, Inc.',
        'product': 'RecTrac'
    },
    {
        'vendor': 'RecVue, Inc.',
        'product': 'RecVue'
    },
    {
        'vendor': 'GhostMonitor, Inc.',
        'product': 'Recart'
    },
    {
        'vendor': 'Waystar, Inc.',
        'product': 'Recondo'
    },
    {
        'vendor': 'Recorded Future, Inc.',
        'product': 'Recorded Future'
    },
    {
        'vendor': 'RecordsOne, LLC',
        'product': 'RecordsOne CDI'
    },
    {
        'vendor': 'Recovery Point Systems, Inc.',
        'product': 'Recovery Point'
    },
    {
        'vendor': 'RecoveryPlanner.com, Inc.',
        'product': 'RecoveryPlanner'
    },
    {
        'vendor': 'Recruitee B.V.',
        'product': 'Recruitee'
    },
    {
        'vendor': 'Recruiterbox, Inc.',
        'product': 'Recruiterbox'
    },
    {
        'vendor': 'Recruitics, LLC',
        'product': 'Recruitics'
    },
    {
        'vendor': 'Recurly',
        'product': 'Recurly'
    },
    {
        'vendor': 'Red Flag Group',
        'product': 'Red Flag Group'
    },
    {
        'vendor': 'Red Giant, LLC',
        'product': 'Red Giant'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat (Unspecified Product)'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat 3Scale API Management'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat AMQ'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Ansible'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Certificate System'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Cloud Infrastructure'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Cloud Suite'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat CloudForms'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat CodeReady Studio'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Data Grid'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Decision Manager'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Directory Server'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Enterprise Linux'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Enterprise Linux Desktop'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Enterprise Linux Server'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Fuse'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat GearD'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Gluster Storage'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Hyperconverged Infrastructure (HCI)'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Insights'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat JBoss Enterprise Application Server (EAS)'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat JBoss Enterprise SOA Platform'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Network Satellite'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat OpenShift'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat OpenShift 3.x'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat OpenShift 4.x'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat OpenStack'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Process Automation Manager'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Quay'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Satellite'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'Red Hat Virtualization'
    },
    {
        'vendor': 'Red Wing Software',
        'product': 'Red Wing CenterPoint'
    },
    {
        'vendor': 'RedBrick Health',
        'product': 'RedBrick Health'
    },
    {
        'vendor': 'ETK Sp. j.',
        'product': 'RedCart'
    },
    {
        'vendor': 'RedHelper Company',
        'product': 'RedHelper'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'RedLock'
    },
    {
        'vendor': 'RedPoint Global, Inc.',
        'product': 'RedPoint Data Management'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'RedPrairie Commerce Suite'
    },
    {
        'vendor': 'RedSeal, Inc.',
        'product': 'RedSeal'
    },
    {
        'vendor': 'RedTeam Software',
        'product': 'RedTeam'
    },
    {
        'vendor': 'Redbooth, Inc.',
        'product': 'Redbooth'
    },
    {
        'vendor': 'Red Gate Software, Ltd.',
        'product': 'Redgate SQL'
    },
    {
        'vendor': 'Rediker',
        'product': 'Rediker SIS'
    },
    {
        'vendor': 'Redis Labs, Inc.',
        'product': 'Redis'
    },
    {
        'vendor': 'Redis Labs, Inc.',
        'product': 'Redis Enterprise'
    },
    {
        'vendor': 'Open Source',
        'product': 'Redmine'
    },
    {
        'vendor': 'Redox, Inc.',
        'product': 'Redox'
    },
    {
        'vendor': 'MAXON Computer GmbH',
        'product': 'Redshift'
    },
    {
        'vendor': 'Redtail Technology, Inc.',
        'product': 'Redtail CRM'
    },
    {
        'vendor': 'Redwood Software',
        'product': 'Redwood Cronacle'
    },
    {
        'vendor': 'Redwood Software',
        'product': 'Redwood Report2Web'
    },
    {
        'vendor': 'Reevoo, Ltd.',
        'product': 'Reevoo'
    },
    {
        'vendor': 'Reve Marketing, Inc.',
        'product': 'Refer-a-friend'
    },
    {
        'vendor': 'Anafore Pte Ltd',
        'product': 'ReferralCandy'
    },
    {
        'vendor': 'Refinitiv',
        'product': 'Refinitiv Connected Risk'
    },
    {
        'vendor': 'Refinitiv',
        'product': 'Refinitiv Eikon'
    },
    {
        'vendor': 'Refinitiv',
        'product': 'Refinitiv Verified Entity Data as a Service'
    },
    {
        'vendor': 'Refinitiv',
        'product': 'Refinitiv World-Check Risk Intelligence'
    },
    {
        'vendor': 'Reflektion, Inc.',
        'product': 'Reflektion'
    },
    {
        'vendor': 'Reflexis Systems, Inc.',
        'product': 'Reflexis'
    },
    {
        'vendor': 'PEP Web Solutions, LLC',
        'product': 'Reformed'
    },
    {
        'vendor': 'DialSource, Inc.',
        'product': 'Refractive Dialer'
    },
    {
        'vendor': 'RegEd, Inc.',
        'product': 'RegEd'
    },
    {
        'vendor': 'Webconnex, LLC',
        'product': 'RegFox'
    },
    {
        'vendor': 'Regpack, Inc.',
        'product': 'Regpack'
    },
    {
        'vendor': 'Rejoiner, Inc.',
        'product': 'Rejoiner'
    },
    {
        'vendor': 'Relatics',
        'product': 'Relatics'
    },
    {
        'vendor': 'Relativity ODA, LLC',
        'product': 'Relativity'
    },
    {
        'vendor': 'Relativity ODA, LLC',
        'product': 'RelativityOne'
    },
    {
        'vendor': 'Relavis',
        'product': 'Relavis'
    },
    {
        'vendor': 'Relay42 Netherlands B.V.',
        'product': 'Relay42'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'RelayHealth'
    },
    {
        'vendor': 'Relenta, Inc.',
        'product': 'Relenta CIM'
    },
    {
        'vendor': 'Reliable Softworks',
        'product': 'ReliaSale'
    },
    {
        'vendor': 'ReliaSoft Corporation',
        'product': 'ReliaSoft'
    },
    {
        'vendor': 'Relias Learning',
        'product': 'Relias Learning Management System'
    },
    {
        'vendor': 'Reltio, Inc.',
        'product': 'Reltio'
    },
    {
        'vendor': 'Remote Landlord Systems, Inc.',
        'product': 'Remote Landlord'
    },
    {
        'vendor': 'Kardex Holding AG',
        'product': 'Remstar'
    },
    {
        'vendor': 'Nelnet Business Solutions, Inc.',
        'product': 'RenWeb'
    },
    {
        'vendor': 'Renaissance Learning, Inc.',
        'product': 'Renaissance Accelerated Math'
    },
    {
        'vendor': 'Renaissance Learning, Inc.',
        'product': 'Renaissance Accelerated Reader'
    },
    {
        'vendor': 'London Computer Systems, Inc.',
        'product': 'Rent Manager'
    },
    {
        'vendor': 'YapStone, Inc.',
        'product': 'RentPayment'
    },
    {
        'vendor': 'RentPost, Inc.',
        'product': 'RentPost'
    },
    {
        'vendor': 'Wynne Systems',
        'product': 'RentalMan'
    },
    {
        'vendor': 'Wynne Systems',
        'product': 'RentalResult'
    },
    {
        'vendor': 'Rentec Direct, LLC',
        'product': 'Rentec Direct'
    },
    {
        'vendor': 'Rently, Inc.',
        'product': 'Rently'
    },
    {
        'vendor': 'Scryer, Inc.',
        'product': 'Reonomy'
    },
    {
        'vendor': 'RepairShopr',
        'product': 'RepairShopr'
    },
    {
        'vendor': 'Replit, Inc.',
        'product': 'Repl.it'
    },
    {
        'vendor': 'Replicon, Inc.',
        'product': 'Replicon'
    },
    {
        'vendor': 'ReportGarden, Inc.',
        'product': 'ReportGarden'
    },
    {
        'vendor': 'HPE',
        'product': 'Reporter'
    },
    {
        'vendor': 'ReportsNow, Inc.',
        'product': 'ReportsNow'
    },
    {
        'vendor': 'Repsly, Inc.',
        'product': 'Repsly CRM'
    },
    {
        'vendor': 'Reputation.com, Inc.',
        'product': 'Reputation.com'
    },
    {
        'vendor': 'Reputology',
        'product': 'Reputology'
    },
    {
        'vendor': 'Open Source',
        'product': 'RequireJS'
    },
    {
        'vendor': 'ResMan',
        'product': 'ResMan'
    },
    {
        'vendor': 'Kaggle, Inc.',
        'product': 'ResNet-50'
    },
    {
        'vendor': 'Reservation Nexus',
        'product': 'ResNexus'
    },
    {
        'vendor': 'Adeptive Software',
        'product': 'ResWare'
    },
    {
        'vendor': 'Rescale, Inc.',
        'product': 'Rescale'
    },
    {
        'vendor': 'Newfold Digital, Inc.',
        'product': 'ResellerClub'
    },
    {
        'vendor': 'RSR Acquisition, LLC',
        'product': 'ResellerRatings'
    },
    {
        'vendor': 'Reservit',
        'product': 'Reservit'
    },
    {
        'vendor': 'Resident360',
        'product': 'Resident360'
    },
    {
        'vendor': 'Caucho Technology, Inc.',
        'product': 'Resin'
    },
    {
        'vendor': 'Resolver, Inc.',
        'product': 'Resolver (Unspecified Product)'
    },
    {
        'vendor': 'Resolver, Inc.',
        'product': 'Resolver GRC'
    },
    {
        'vendor': 'Resource Guru, Ltd.',
        'product': 'Resource Guru'
    },
    {
        'vendor': 'Zellis UK, Ltd.',
        'product': 'ResourceLink'
    },
    {
        'vendor': 'Rauland-Borg Corporation',
        'product': 'Responder 5'
    },
    {
        'vendor': 'ResponseTap, Inc.',
        'product': 'ResponseTap'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'ResponseTek'
    },
    {
        'vendor': 'Response iQ, Ltd.',
        'product': 'ResponseiQ'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Responsys'
    },
    {
        'vendor': 'RestaurantConnect',
        'product': 'RestaurantConnect'
    },
    {
        'vendor': 'Resulticks, Inc.',
        'product': 'Resulticks'
    },
    {
        'vendor': 'Retail Pro International, LLC',
        'product': 'Retail Pro'
    },
    {
        'vendor': 'High Meadow Business Solutions',
        'product': 'RetailEdge'
    },
    {
        'vendor': 'Retail Rocket Netherlands B.V.',
        'product': 'RetailRocket'
    },
    {
        'vendor': 'Celerant Technology Corporation',
        'product': 'RetailSTAR'
    },
    {
        'vendor': 'Retarus GmbH',
        'product': 'Retarus'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Retek'
    },
    {
        'vendor': 'Retool, Inc.',
        'product': 'Retool'
    },
    {
        'vendor': 'Retrospect, Inc.',
        'product': 'Retrospect'
    },
    {
        'vendor': 'Validity, Inc.',
        'product': 'Return Path'
    },
    {
        'vendor': 'Rev.io, LLC',
        'product': 'Rev.io'
    },
    {
        'vendor': 'Longwood Software, Inc.',
        'product': 'RevBase'
    },
    {
        'vendor': 'RevSpring, Inc.',
        'product': 'RevSpring'
    },
    {
        'vendor': 'Vanco Payment Solutions, Inc.',
        'product': 'RevTrak'
    },
    {
        'vendor': 'Reval',
        'product': 'Reval'
    },
    {
        'vendor': 'TTEC Holdings, Inc.',
        'product': 'Revana'
    },
    {
        'vendor': 'Revcontent, LLC',
        'product': 'Revcontent'
    },
    {
        'vendor': 'Revegy, Inc.',
        'product': 'Revegy'
    },
    {
        'vendor': 'Revel Systems',
        'product': 'Revel iPad POS'
    },
    {
        'vendor': 'Aprimo, LLC',
        'product': 'Revenew'
    },
    {
        'vendor': 'RevenueCat, Inc.',
        'product': 'RevenueCat'
    },
    {
        'vendor': 'Revenue Well Systems, LLC',
        'product': 'RevenueWell'
    },
    {
        'vendor': 'SAP SE',
        'product': 'Review Ninja'
    },
    {
        'vendor': 'ReviewBuzz, Inc.',
        'product': 'ReviewBuzz'
    },
    {
        'vendor': 'ReviewPro, Inc.',
        'product': 'ReviewPro'
    },
    {
        'vendor': 'Revinate, Inc.',
        'product': 'Revinate'
    },
    {
        'vendor': 'Revionics, Inc.',
        'product': 'Revionics'
    },
    {
        'vendor': 'Model N, Inc.',
        'product': 'Revitas Contract Manager'
    },
    {
        'vendor': 'Vizerra S.A.',
        'product': 'Revizto'
    },
    {
        'vendor': 'RevolutionEHR',
        'product': 'RevolutionEHR'
    },
    {
        'vendor': 'Orion Health',
        'product': 'Rhapsody'
    },
    {
        'vendor': 'Techware Systems',
        'product': 'Rhevolution'
    },
    {
        'vendor': 'MecSoft Corporation',
        'product': 'RhinoCAM'
    },
    {
        'vendor': 'Robert McNeel & Associates',
        'product': 'Rhinoceros'
    },
    {
        'vendor': 'Rhombus Systems, Inc.',
        'product': 'Rhombus'
    },
    {
        'vendor': 'RhythmOne, LLC',
        'product': 'RhythmOne'
    },
    {
        'vendor': 'Riak Technologies, Inc.',
        'product': 'Riak'
    },
    {
        'vendor': 'Ribbon Communications, Inc.',
        'product': 'Ribbon Communications'
    },
    {
        'vendor': 'RichRelevance, Inc.',
        'product': 'RichRelevance'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh Aficio'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh InfoPrint 100'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh InfoPrint 4100'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh InfoPrint 5000'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh Infoprint Manager'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh Pro C651EX'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh Pro C900'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh Pro C901 Graphic Arts Edition'
    },
    {
        'vendor': 'Ricoh Americas Corporation',
        'product': 'Ricoh ProcessDirector'
    },
    {
        'vendor': 'Riemann',
        'product': 'Riemann'
    },
    {
        'vendor': 'Rigetti & Company, Inc.',
        'product': 'Rigetti Computing'
    },
    {
        'vendor': 'RightScale, Inc.',
        'product': 'RightScale'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'RightSignature'
    },
    {
        'vendor': 'Rimini Street, Inc.',
        'product': 'Rimini Street'
    },
    {
        'vendor': 'RingCentral, Inc.',
        'product': 'RingCentral'
    },
    {
        'vendor': 'RingCentral, Inc.',
        'product': 'RingCentral Contact Center'
    },
    {
        'vendor': 'RingCentral, Inc.',
        'product': 'RingCentral Glip'
    },
    {
        'vendor': 'RingCentral, Inc.',
        'product': 'RingCentral Office'
    },
    {
        'vendor': 'RingCentral, Inc.',
        'product': 'RingCentral Phone'
    },
    {
        'vendor': 'RingDNA, Inc.',
        'product': 'RingDNA'
    },
    {
        'vendor': 'RingLead, Inc.',
        'product': 'RingLead'
    },
    {
        'vendor': 'Ringba',
        'product': 'Ringba'
    },
    {
        'vendor': 'Rio SEO, Inc.',
        'product': 'Rio SEO'
    },
    {
        'vendor': 'RioRey, Inc.',
        'product': 'RioRey'
    },
    {
        'vendor': 'People Center, Inc.',
        'product': 'Rippling'
    },
    {
        'vendor': 'Rise.ai, Inc.',
        'product': 'Rise'
    },
    {
        'vendor': 'Moody\'s Analytics, Inc.',
        'product': 'RiskAuthority'
    },
    {
        'vendor': 'Moody\'s Analytics, Inc.',
        'product': 'RiskConfidence'
    },
    {
        'vendor': 'Ebix, Inc.',
        'product': 'RiskEnvision'
    },
    {
        'vendor': 'RiskIQ, Inc.',
        'product': 'RiskIQ'
    },
    {
        'vendor': 'RiskSense, Inc.',
        'product': 'RiskSense'
    },
    {
        'vendor': 'Resolver, Inc.',
        'product': 'RiskVision'
    },
    {
        'vendor': 'Riskified, Ltd.',
        'product': 'Riskified'
    },
    {
        'vendor': 'Riskonnect, Inc.',
        'product': 'Riskonnect ClearSight'
    },
    {
        'vendor': 'Rival IQ Corporation',
        'product': 'Rival IQ'
    },
    {
        'vendor': 'River Logic, Inc.',
        'product': 'River Logic (Unspecified Product)'
    },
    {
        'vendor': 'RiverMeadow Software, Inc.',
        'product': 'RiverMeadow Cloud Migration'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed AirPcap'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed Modeler'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed OPNET nCompass'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed Portal'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed Services Platform'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed SteelCentral'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed SteelConnect'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed SteelFusion'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed SteelHead'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed Stingray'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Riverbed Technology (Unspecified Product)'
    },
    {
        'vendor': 'Tangoe, Inc.',
        'product': 'Rivermine'
    },
    {
        'vendor': 'Riversand Technologies, Inc.',
        'product': 'Riversand'
    },
    {
        'vendor': 'Rivet Logic Corporation',
        'product': 'Rivet Logic'
    },
    {
        'vendor': 'RizePoint, Inc.',
        'product': 'RizePoint'
    },
    {
        'vendor': 'Roadmunk',
        'product': 'Roadmunk'
    },
    {
        'vendor': 'Robin Powered, Inc.',
        'product': 'Robin'
    },
    {
        'vendor': 'Aquent, LLC',
        'product': 'RoboHead'
    },
    {
        'vendor': 'Robocorp Technologies, Inc.',
        'product': 'Robocorp'
    },
    {
        'vendor': 'Open Source',
        'product': 'Robot Framework'
    },
    {
        'vendor': 'ECi Software Solutions, Inc.',
        'product': 'RockSolid MAX'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket BlueZone'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket CorVu'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket LegaSuite'
    },
    {
        'vendor': 'Rocket Matter',
        'product': 'Rocket Matter'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket U2'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket UniData'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket UniVerse'
    },
    {
        'vendor': 'Rocket.Chat Technologies Corporation',
        'product': 'Rocket.Chat'
    },
    {
        'vendor': 'RocketDocs, Inc.',
        'product': 'RocketDocs (Unspecified Product)'
    },
    {
        'vendor': 'Sizmek, Inc.',
        'product': 'RocketFuel'
    },
    {
        'vendor': 'Rockwell Automation, Inc.',
        'product': 'Rockwell Automation (Unspecified Product)'
    },
    {
        'vendor': 'Rockwell Automation, Inc.',
        'product': 'Rockwell Automation MES'
    },
    {
        'vendor': 'Rocscience, Inc.',
        'product': 'Rocscience'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Rogue Wave'
    },
    {
        'vendor': 'Roistat, Inc.',
        'product': 'Roistat'
    },
    {
        'vendor': 'Roland DGA Corporation',
        'product': 'Roland'
    },
    {
        'vendor': 'NextRoll, Inc.',
        'product': 'RollWorks'
    },
    {
        'vendor': 'Rollbar, Inc.',
        'product': 'Rollbar'
    },
    {
        'vendor': 'Roojoom',
        'product': 'Roojoom'
    },
    {
        'vendor': 'RSI International, Inc.',
        'product': 'RoomKeyPMS'
    },
    {
        'vendor': 'Hotel JV Services, LLC',
        'product': 'Roomkey'
    },
    {
        'vendor': 'Roomsy, Inc.',
        'product': 'Roomsy'
    },
    {
        'vendor': 'Rootstock Software',
        'product': 'Rootstock Cloud ERP'
    },
    {
        'vendor': 'Avnet, Inc.',
        'product': 'Rorke Data'
    },
    {
        'vendor': 'Rosmiman',
        'product': 'Rosmiman IWMS'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'Ross ERP'
    },
    {
        'vendor': 'RouteOne, LLC',
        'product': 'RouteOne'
    },
    {
        'vendor': 'Accelerite',
        'product': 'Rovius CP'
    },
    {
        'vendor': 'Rozo Systems, SAS',
        'product': 'RozoFS'
    },
    {
        'vendor': 'Galvanize',
        'product': 'Rsam'
    },
    {
        'vendor': 'The Rubicon Project, Inc.',
        'product': 'Rubicon Project (Unspecified Product)'
    },
    {
        'vendor': 'Rubrik, Inc.',
        'product': 'Rubrik'
    },
    {
        'vendor': 'Open Source',
        'product': 'Ruby'
    },
    {
        'vendor': 'Open Source',
        'product': 'Ruby 2.4'
    },
    {
        'vendor': 'Open Source',
        'product': 'Ruby on Rails'
    },
    {
        'vendor': 'Ruckus Networks',
        'product': 'Ruckus Wireless'
    },
    {
        'vendor': 'Runecast Solutions, Ltd.',
        'product': 'Runecast'
    },
    {
        'vendor': 'RPMGlobal Holdings, Ltd.',
        'product': 'RungePincockMinarco'
    },
    {
        'vendor': 'Runit Systems',
        'product': 'Runit Systems'
    },
    {
        'vendor': 'RxNT',
        'product': 'RxNT'
    },
    {
        'vendor': 'Evident, LLC',
        'product': 'Rycan'
    },
    {
        'vendor': 'Rydoo N.V.',
        'product': 'Rydoo'
    },
    {
        'vendor': 'Davisware, Inc.',
        'product': 'S2K Vision'
    },
    {
        'vendor': 'SAI Global Pty Ltd',
        'product': 'SAI Global'
    },
    {
        'vendor': 'SAI Global Pty Ltd',
        'product': 'SAI360'
    },
    {
        'vendor': 'Benhauer Sp. z o.o.',
        'product': 'SALESmanago'
    },
    {
        'vendor': 'Centro Software S.R.L.',
        'product': 'SAM ERP2'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP 3D Visual Enterprise'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP 4.7c'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ABAP Objects'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP AMS'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Access Control'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Account Substantiation and Automation by BlackLine'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Accounts Payable and Receivable'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Adaptive Server Enterprise'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Advanced Planning and Optimization (APO)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Advanced Track and Trace'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Afaria'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Analytics Cloud'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba (Unspecified Product)'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba APIs'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Accounts Payable Process Automation'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Buying'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Buying and Invoicing'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Catalog'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Cloud Integration Gateway'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Contract Invoicing'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Contract Management'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Contracts'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Discovery'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Dynamic Discounting and Discount Management'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Financial Supply Chain Management'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Guided Buying'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Integration'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Invoice Management'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Network'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Payables'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Platform'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Procurement'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Snap'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Solutions for Direct Spend'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Sourcing'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Spend Analysis'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Spend Management'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Spend Visibility'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Spot Buy Catalog'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Start Sourcing'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Strategic Sourcing Suite'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Supplier Enablement Service'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Supplier Lifecycle and Performance'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Supplier Management'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Supplier Risk'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Supply Chain Collaboration'
    },
    {
        'vendor': 'SAP Ariba',
        'product': 'SAP Ariba Working Capital Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Asset Accounting (AA)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Asset Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Audit Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Automotive Industry Solutions'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BW/4HANA'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Bank Analyzer'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Banking Industry Solutions'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Basis'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Billing and Revenue Innovation Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Build'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business All In One'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business ByDesign'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Objects'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business One'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Planning and Consolidation'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Role Management (BRM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Suite'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Warehouse (BW)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Workflow'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BusinessObjects BI'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BusinessObjects Business Intelligence'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BusinessObjects Dashboards'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BusinessObjects Design Studio'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BusinessObjects Explorer'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP BusinessObjects Web Intelligence'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP C/4 HANA'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP CO-PA Accelerator'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP CRM'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Carbon Impact'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cargo Transportation & Logistics'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cash Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Central Finance'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Chemicals Industry Solutions'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cloud Appliance Library'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cloud Platform'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cloud Platform Integration'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cloud for Customer (C4C)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Cloud for Travel and Expense'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Collections and Dispute Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Commerce Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Commerce Cloud Product Content Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Commercial Project Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Commodity Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Configure, Price and Quote'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Consumer Products'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Contact Center'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Contract Lifecycle Management (CLM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Controlling (CO)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Convergent Charging (CC)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Credit Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Crystal Dashboard'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Crystal Presentation Design'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Crystal Reports'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Crystal Server'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Crystal Solutions'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Customer Activity Repository (CAR)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Customer Care and Service (CCS)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Customer Checkout (POS)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Customer Data Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Customer Interaction Center (CIC)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Hub'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Intelligence'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Maintenance for ERP by Vistex'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Migration'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Quality Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Services'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Data Warehousing'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Demand Signal Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Digital Boardroom'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Digital CRM'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Direct Store Delivery'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Document Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP E-Recruiting'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ECTR'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ERP'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ERP Central Component (ECC)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ERP Central Component (ECC) 5.0'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ERP Central Component (ECC) 6.0'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ERP Financials'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP ERP Human Capital Management (HCM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Edge Services'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Emergency Access Management (EAM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Enable Now'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Enterprise Asset Management (EAM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Enterprise Inventory and Service-Level Optimization'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Enterprise Learning Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Enterprise Performance Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Enterprise Threat Detection'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Environment, Health, and Safety Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Event Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Extended ECM (xECM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Extended Warehouse Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Fashion Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Field Service'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Fieldglass'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Financial Accounting (FI)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Financial Closing Cockpit'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Financial Consolidation'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Financial Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Financial Supply Chain Management (FSCM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Fiori'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Floorplan Manager'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Fraud Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Funds Management (FM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP GRC'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP GRC Access Control (GRC-SAC)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP GUI'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Gateway'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP General Ledger Accounting (FI-GL)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Global Trade Services'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP HANA'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP HANA Enterprise Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP HANA Live'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP HANA One'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP HANA Tailored DataCenter Integration (TDI)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP High Tech Industry Solutions'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Higher Education and Research'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Hybris'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Hybris B2B Commerce'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Hybris B2C Commerce'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Hybris Cloud for Customer'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Hybris Sales Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Hybris Social Engagement Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP IQ'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP IS Media'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP IS-Banking'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Identity Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Information Steward'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Innovation Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Integrated Business Planning'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Intelligent Robotic Process Automation'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Intelligent Technologies'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Interaction Center'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Intercompany Financial Hub'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Internet Demonstration and Evaluation System'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Inventory Collaboration Hub (ICH)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Inventory Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Investment Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Invoice Management by OpenText'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Jam Collaboration'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Landscape Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Leasing'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Leonardo'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Leonardo Machine Learning Foundation'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Linear Asset Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Loans Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Logistics Execution'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Lumira'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Manager Self-Service (MSS)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Manufacturing Execution'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Manufacturing Integration and Intelligence'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Marketing Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Master Data Governance'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Material Requirement Planning (MRP)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Materials Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Mobile Platform'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP NetWeaver'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP NetWeaver Master Data Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP NetWeaver Portal'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Omnichannel Banking'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Operational Process Intelligence'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Order to Cash (OTC)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP POS Data Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP PY'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Partner Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Payment Engine'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Personnel Development'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Plan-to-Product'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Plant Connectivity'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Plant Maintenance'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Policy Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Portfolio and Project Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP PowerBuilder'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP PowerDesigner'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Predictive Analytics'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Price and Margin Management (PMM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Process Control'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Process Orchestration'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Procurement'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Product Data Management (PDM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Product Development and Manufacturing'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Product Lifecycle Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Production Planning'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Profitability Analysis (PA)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Profitability and Performance Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Project System'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Promotion Management for Retail (PMR)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Quality Issue Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Quality Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP R/2'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP R/3'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP REACH Compliance'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Rapid Marts'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Real Estate Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Recycling Administration'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Reinsurance Management (FS-RI)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Replication Server'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Revenue Accounting and Reporting (RAR)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Risk Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Roambi'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP S/4HANA'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SD'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SQL Anywhere'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sales'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sales & Distribution (SD)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sales & Operations Planning (SOP)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sales Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sales Order Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Service Cloud'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Service Parts Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Service Parts Planning (SPP)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Social Customer Engagement'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Solution Manager'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sourcing'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Strategic Enterprise Management (SEM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Strategy Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP StreamWork'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Subscription Billing'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SuccessFactors'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SuccessFactors Business Execution Suite'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SuccessFactors Employee Central'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SuccessFactors Employee Central Payroll'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SuccessFactors HXM Suite'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP SuccessFactors Recruiting'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Supplier Relationship Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Supply Chain Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Supply Network Collaboration (SNC)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Supply Network Planning (SNP)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sustainability'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sybase Datawindow.net'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sybase EAServer'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sybase InfoMaker'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sybase Mirror Activator'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sybase OpenSwitch'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Sybase RAP'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Systems Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Tax Compliance'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Test Accelerator & Optimizer (TAO)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Test Data Migration Server (TDMS)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Time and Attendance Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Trade Promotion Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Transactional Banking for SAP S/4HANA'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Transactionware General Merchandise (TGM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Transportation Management (TM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Transportation Planning/Vehicle Scheduling (TP/VS)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Travel Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Treasury and Risk Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP User Experience Monitoring (UXMon)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Utilities Industry Solution'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Utility Customer E-Services (UCES)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Variant Configuration'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Vehicle Management System'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Virsa Compliance Calibrator'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Virsa FireFighter'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Virsa Role Expert'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Vora'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Warehouse Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Warranty and Claim Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Web Application Server'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Work Clearance Management'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Work Manager'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Workforce Forecasting and Scheduling'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Workforce Management (WFM)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP eCATT'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Aerospace'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Aerospace and Defense'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Apparel & Footwear (AFS)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Engineering, Construction, and Operations'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Healthcare'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Insurance'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Media'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Mill Products'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Mining'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Oil & Gas (IS Oil & Gas)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Public Sector'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Retail (ISR)'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP for Utilities'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP liveCache'
    },
    {
        'vendor': 'Computers and Structures, Inc.',
        'product': 'SAP2000'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Analytics0-'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Anti-Money Laundering'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Business Intelligence'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Capital Planning & Management'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Customer Intelligence 360'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Data Integration Studio'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Data Loader for Hadoop'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Data Management'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Data Preparation'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Data Quality'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Data Surveyor'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS DataFlux'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS ETL'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Enterprise'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Enterprise Case Management'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Enterprise Guide'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Enterprise Miner'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Event Stream Processing'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Expected Credit Loss'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Federation Server'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Financial Crimes Suite'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Forecast Server'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Governance & Compliance Manager'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Grid Manager'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Intelligent Planning Suite'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS MDM Advanced'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Marketing Automation'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Marketing Operations Management'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Model Manager'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Model Risk Management'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Pharmaceutical Manufacturing'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Regulatory Risk Management'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Retail Analytics'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Risk & Finance Workbench'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Risk Engine'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Risk Modeling'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Scalable Performance Data Server'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Scoring Accelerator'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Solution for CECL'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Solution for IFRS 17'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Solution for IFRS 9'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Solution for Solvency II'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Solution for Stress Testing'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Visual Analytics'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Visual Data Mining and Machine Learning'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Visual Text Analytics'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Viya'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/ACCESS'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/AF'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/ASSIST'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/Connect'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/ETS'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/FSP'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/GRAPH'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/IML'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/OR'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/QC Software'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/SCL'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/SECURE'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/SHARE'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS/STAT'
    },
    {
        'vendor': 'Seismic Software, Inc.',
        'product': 'SAVO'
    },
    {
        'vendor': 'Software Business Systems',
        'product': 'SBS Financials'
    },
    {
        'vendor': 'Software Cradle Company, Ltd.',
        'product': 'SC/Tetra'
    },
    {
        'vendor': 'Schneider Electric SE',
        'product': 'SCADAPack'
    },
    {
        'vendor': 'The Software Construction Company',
        'product': 'SCC MediaServer'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC Soft Computer'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC SoftDonor'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC SoftID'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC SoftLab'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC SoftMic'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC SoftPath'
    },
    {
        'vendor': 'Soft Computer Consultants, Inc.',
        'product': 'SCC SoftWebPlus'
    },
    {
        'vendor': 'R1 RCM, Inc.',
        'product': 'SCI Solutions'
    },
    {
        'vendor': 'SCIA N.V.',
        'product': 'SCIA'
    },
    {
        'vendor': 'SD Worx Group N.V.',
        'product': 'SD Worx'
    },
    {
        'vendor': 'SDL PLC',
        'product': 'SDL BeGlobal'
    },
    {
        'vendor': 'SDL PLC',
        'product': 'SDL Contenta'
    },
    {
        'vendor': 'SDL PLC',
        'product': 'SDL Passolo'
    },
    {
        'vendor': 'SDL PLC',
        'product': 'SDL Trados'
    },
    {
        'vendor': 'SDL PLC',
        'product': 'SDL Tridion'
    },
    {
        'vendor': 'SDL PLC',
        'product': 'SDL XPP'
    },
    {
        'vendor': 'SDS/2',
        'product': 'SDS/2'
    },
    {
        'vendor': 'SE Ranking, Ltd.',
        'product': 'SE Ranking'
    },
    {
        'vendor': 'IntelliCentrics, Inc.',
        'product': 'SEC3URE'
    },
    {
        'vendor': 'SECURITI, Inc.',
        'product': 'SECURITI.ai'
    },
    {
        'vendor': 'SEI Investments Company',
        'product': 'SEI Investment Platform'
    },
    {
        'vendor': 'SEI Investments Company',
        'product': 'SEI Wealth Platform'
    },
    {
        'vendor': 'SEMrush, Inc.',
        'product': 'SEMrush'
    },
    {
        'vendor': 'Lightspeed POS, Inc.',
        'product': 'SEOshop'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'SEPATON'
    },
    {
        'vendor': 'HPE',
        'product': 'SGI ICE X'
    },
    {
        'vendor': 'HPE',
        'product': 'SGI IRIX'
    },
    {
        'vendor': 'HPE',
        'product': 'SGI Indigo'
    },
    {
        'vendor': 'HPE',
        'product': 'SGI InfiniteStorage'
    },
    {
        'vendor': 'HPE',
        'product': 'SGI Rackable Systems'
    },
    {
        'vendor': 'SHE Software, Ltd.',
        'product': 'SHE Software Assure'
    },
    {
        'vendor': 'SHL Group',
        'product': 'SHL'
    },
    {
        'vendor': 'SIAE MICROELETTRONICA S.p.A.',
        'product': 'SIAE MICROELETTRONICA'
    },
    {
        'vendor': 'Sim Partners, Inc.',
        'product': 'SIM Velocity'
    },
    {
        'vendor': 'Kornyk Computer Solutions International, Inc.',
        'product': 'SIMMS Inventory'
    },
    {
        'vendor': 'Capita Business Services, Ltd.',
        'product': 'SIMS'
    },
    {
        'vendor': 'SIMUL8 Corporation',
        'product': 'SIMUL8'
    },
    {
        'vendor': 'Surgical Information Systems, LLC',
        'product': 'SIS Anesthesia'
    },
    {
        'vendor': 'SISTRIX GmbH',
        'product': 'SISTRIX'
    },
    {
        'vendor': 'SISTRIX GmbH',
        'product': 'SISTRIX SEO'
    },
    {
        'vendor': 'SKULabs',
        'product': 'SKULabs'
    },
    {
        'vendor': 'SLI Systems, Inc.',
        'product': 'SLI Systems'
    },
    {
        'vendor': 'SchedMD, LLC',
        'product': 'SLURM Workload Manager'
    },
    {
        'vendor': 'SMART Technologies ULC',
        'product': 'SMART Board'
    },
    {
        'vendor': 'SMART Service Desk',
        'product': 'SMART Service Desk'
    },
    {
        'vendor': 'GEP',
        'product': 'SMART by GEP'
    },
    {
        'vendor': 'Service Management Group, LLC',
        'product': 'SMG'
    },
    {
        'vendor': 'SMS Assist, LLC',
        'product': 'SMS Assist'
    },
    {
        'vendor': 'SMTP.com',
        'product': 'SMTP'
    },
    {
        'vendor': 'SOAPware, Inc.',
        'product': 'SOAPware'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'SOASTA'
    },
    {
        'vendor': 'Specialists On Call, Inc.',
        'product': 'SOC Telemed'
    },
    {
        'vendor': 'SOCi, Inc.',
        'product': 'SOCi'
    },
    {
        'vendor': 'Inria',
        'product': 'SOFA'
    },
    {
        'vendor': 'Dassault Systemes SolidWorks Corporation',
        'product': 'SOLIDWORKS Flow Simulation'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'SOLIDWORKS Visualize'
    },
    {
        'vendor': 'EfficientIP SAS',
        'product': 'SOLIDserver'
    },
    {
        'vendor': 'Siemens Healthineers AG',
        'product': 'SOMATOM Emotion eco'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'SOMATOM Sensation 64 eco'
    },
    {
        'vendor': 'SONIFI Health',
        'product': 'SONIFI Health'
    },
    {
        'vendor': 'SOTI, Inc.',
        'product': 'SOTI MobiControl'
    },
    {
        'vendor': 'SPS Commerce, Inc.',
        'product': 'SPS Commerce'
    },
    {
        'vendor': 'Open Source',
        'product': 'SQL Buddy'
    },
    {
        'vendor': 'The Australian Software Company Pty Ltd',
        'product': 'SQL Delta'
    },
    {
        'vendor': 'SQLite Consortium',
        'product': 'SQLite'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'SRFax'
    },
    {
        'vendor': 'Strategic Reporting Systems, Inc.',
        'product': 'SRS ReportSmith'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Evare'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C FundRunner Marathon'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Geneva'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C HiPortfolio'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C MarginMan'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Maximis'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Salentica'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Skyline'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Syncova'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Tamale RMS'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C TimeShareWare'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C WalletShare'
    },
    {
        'vendor': 'The SSI Group, LLC',
        'product': 'SSI ClickOn'
    },
    {
        'vendor': 'Stack Construction',
        'product': 'STACK'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'STAR-CD'
    },
    {
        'vendor': 'Abbott Informatics Corporation',
        'product': 'STARLIMS'
    },
    {
        'vendor': 'STORIS',
        'product': 'STORIS'
    },
    {
        'vendor': 'PROCOS AG',
        'product': 'STRATandGO'
    },
    {
        'vendor': 'C/F Data Systems, LLC',
        'product': 'STRUCTURE'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'SUN SPARC Servers'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'SURFCAM'
    },
    {
        'vendor': 'SUSE',
        'product': 'SUSE (Unspecified Product)'
    },
    {
        'vendor': 'SUSE',
        'product': 'SUSE Linux Enterprise Server'
    },
    {
        'vendor': 'SUSE',
        'product': 'SUSE OpenStack Cloud'
    },
    {
        'vendor': 'S.W.I.F.T. SC',
        'product': 'SWIFT'
    },
    {
        'vendor': 'Roche Germany Holding GmbH',
        'product': 'SWISSLAB'
    },
    {
        'vendor': 'Synchro Software',
        'product': 'SYNCHRO Pro'
    },
    {
        'vendor': 'SYSPRO Impact Software, Inc.',
        'product': 'SYSPRO'
    },
    {
        'vendor': 'SaaSOptics, LLC',
        'product': 'SaaSOptics'
    },
    {
        'vendor': 'Saasu',
        'product': 'Saasu'
    },
    {
        'vendor': 'Saba Software, Inc.',
        'product': 'Saba'
    },
    {
        'vendor': 'Saba Software, Inc.',
        'product': 'Saba Centra'
    },
    {
        'vendor': 'Saba Software, Inc.',
        'product': 'Saba Meeting'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'SaberRD'
    },
    {
        'vendor': 'Sabio, Ltd.',
        'product': 'Sabio'
    },
    {
        'vendor': 'Sabre GLBL, Inc.',
        'product': 'Sabre Airline Solutions'
    },
    {
        'vendor': 'Sabre Hospitality Solutions',
        'product': 'Sabre Hospitality'
    },
    {
        'vendor': 'Sabre Hospitality Solutions',
        'product': 'Sabre Hospitality SynXis'
    },
    {
        'vendor': 'Sabre GLBL, Inc.',
        'product': 'Sabre Scribe'
    },
    {
        'vendor': 'BrandMuscle, Inc.',
        'product': 'Saepio'
    },
    {
        'vendor': 'Safe Software, Inc.',
        'product': 'Safe FME Platform'
    },
    {
        'vendor': 'SafeBreach, Inc.',
        'product': 'SafeBreach'
    },
    {
        'vendor': 'Thales Group',
        'product': 'SafeNet'
    },
    {
        'vendor': 'SafePaaS, Inc.',
        'product': 'SafePaaS'
    },
    {
        'vendor': 'Electrolab, Ltd.',
        'product': 'SafeStart'
    },
    {
        'vendor': 'Safeguard Global',
        'product': 'Safeguard GMP'
    },
    {
        'vendor': 'Safend, Ltd.',
        'product': 'Safend'
    },
    {
        'vendor': 'Safesite Solutions, Inc.',
        'product': 'Safesite'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'Safestone'
    },
    {
        'vendor': 'Safetica Technologies s.r.o.',
        'product': 'Safetica'
    },
    {
        'vendor': 'Premier, Inc.',
        'product': 'SafetySurveillor'
    },
    {
        'vendor': 'Safran Software Solutions A/S',
        'product': 'Safran Planner'
    },
    {
        'vendor': 'Safran Software Solutions A/S',
        'product': 'Safran Project'
    },
    {
        'vendor': 'Safran Software Solutions A/S',
        'product': 'Safran Risk'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage (Unspecified Product)'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 100 Contractor'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 100cloud'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 300 Construction and Real Estate'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 300 People'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 300cloud'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 50'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 500'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 50cloud Accounting'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Business Cloud'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Business Cloud Accounting'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Business Cloud X3'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage BusinessVision Accounting'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage BusinessWorks'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage CRM'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Construction Anywhere'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage DacEasy'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage EasyPay'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Estimating'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Fixed Assets'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage HRMS'
    },
    {
        'vendor': 'Sage Intacct, Inc.',
        'product': 'Sage Intacct'
    },
    {
        'vendor': 'Abila, Inc.',
        'product': 'Sage Nonprofit'
    },
    {
        'vendor': 'Elavon, Inc.',
        'product': 'Sage Pay'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Payroll'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage People'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage TimeSlips'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage X3'
    },
    {
        'vendor': 'Sagemcom Broadband SAS',
        'product': 'Sagemcom'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'Sagent Data Flow'
    },
    {
        'vendor': 'Tyto Software Pvt Ltd',
        'product': 'Sahi'
    },
    {
        'vendor': 'SailPoint Technologies, Inc.',
        'product': 'SailPoint (Unspecified Product)'
    },
    {
        'vendor': 'SailPoint Technologies, Inc.',
        'product': 'SailPoint IdentityIQ'
    },
    {
        'vendor': 'SailPoint Technologies, Inc.',
        'product': 'SailPoint IdentityNow'
    },
    {
        'vendor': 'SailPoint Technologies, Inc.',
        'product': 'SailPoint SecurityIQ'
    },
    {
        'vendor': 'Sailthru, Inc.',
        'product': 'Sailthru'
    },
    {
        'vendor': 'Sakai Learning Management System',
        'product': 'Sakai'
    },
    {
        'vendor': 'Sakura Internet, Inc.',
        'product': 'Sakura Internet'
    },
    {
        'vendor': 'Salary Finance, Ltd.',
        'product': 'Salary Finance'
    },
    {
        'vendor': 'Salecycle, Ltd.',
        'product': 'Salecycle'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Sales Cloud Einstein'
    },
    {
        'vendor': 'Sales Engine International, LLC',
        'product': 'Sales Engine International'
    },
    {
        'vendor': 'SalesBabu Business Solutions Pvt Ltd',
        'product': 'SalesBabu'
    },
    {
        'vendor': 'Clickpoint Software',
        'product': 'SalesExec'
    },
    {
        'vendor': 'SalesHood, Inc.',
        'product': 'SalesHood'
    },
    {
        'vendor': 'SalesJunction',
        'product': 'SalesJunction'
    },
    {
        'vendor': 'SalesLoft, Inc.',
        'product': 'SalesLoft'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'SalesLogix'
    },
    {
        'vendor': 'Interchange Solutions, Inc.',
        'product': 'SalesNOW'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'SalesNet CRM'
    },
    {
        'vendor': 'SalesNexus, LLC',
        'product': 'SalesNexus'
    },
    {
        'vendor': 'The Edge Group, LLC',
        'product': 'SalesOptima'
    },
    {
        'vendor': 'SalesOutlook, Inc.',
        'product': 'SalesOutlook CRM'
    },
    {
        'vendor': 'SalesPad, LLC',
        'product': 'SalesPad Cloud'
    },
    {
        'vendor': 'SalesPage Technologies, LLC',
        'product': 'SalesPage'
    },
    {
        'vendor': 'SalesPage Technologies, LLC',
        'product': 'SalesPage Asset Management CRM'
    },
    {
        'vendor': 'SalesSeek, Ltd.',
        'product': 'SalesSeek'
    },
    {
        'vendor': 'SalesWarp',
        'product': 'SalesWarp'
    },
    {
        'vendor': 'Salesboom',
        'product': 'Salesboom'
    },
    {
        'vendor': 'Salesbox AB',
        'product': 'Salesbox'
    },
    {
        'vendor': 'Salesfloor',
        'product': 'Salesfloor'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce (Unspecified Product)'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Audience Studio'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce B2B Commerce'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce B2C Commerce Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce CPQ'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce CRM'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Chatter'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Commerce Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Commerce Cloud Order Management'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Community Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce DMP'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Data.com'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Desk.com'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Einstein Analytics'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Email Studio'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Engage'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Field Service Lightning'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Force.com'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Health Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Heroku'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Identity'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Inbox'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Interaction Studio'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Jigsaw'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Lightning Platform'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Lightning Web Components'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Live Agent'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Maps'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Marketing Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Nonprofit Success Pack'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Remedyforce'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Rypple'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Sales Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Service Cloud'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Siteforce'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Social Studio'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Trailhead'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce WebToCase'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce WebToLead'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Work.com'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'SalesforceIQ'
    },
    {
        'vendor': 'Salesfusin, Inc.',
        'product': 'Salesfusion'
    },
    {
        'vendor': 'Salesgenie',
        'product': 'Salesgenie'
    },
    {
        'vendor': 'Salient Corporation',
        'product': 'Salient'
    },
    {
        'vendor': 'Salient Systems Corporation',
        'product': 'Salient Systems'
    },
    {
        'vendor': 'Salon Ultimate',
        'product': 'Salon Ultimate'
    },
    {
        'vendor': 'SalonBiz, Inc.',
        'product': 'SalonBiz'
    },
    {
        'vendor': 'Salsa Labs, Inc.',
        'product': 'Salsa CRM'
    },
    {
        'vendor': 'Salsify, Inc.',
        'product': 'Salsify'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Salt Open'
    },
    {
        'vendor': 'Salt Security, Inc.',
        'product': 'Salt Security'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'SaltStack'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'Samanage'
    },
    {
        'vendor': 'Samepage Labs, Inc.',
        'product': 'Samepage'
    },
    {
        'vendor': 'ICS Software, Ltd.',
        'product': 'SammyEHR'
    },
    {
        'vendor': 'Samsara Networks, Inc.',
        'product': 'Samsara'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Samsung'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Samsung Knox'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Samsung Laptop'
    },
    {
        'vendor': 'Telecommunication Software GmbH',
        'product': 'Samwin Contact Center'
    },
    {
        'vendor': 'Western Digital Corporation',
        'product': 'SanDisk'
    },
    {
        'vendor': 'SanDisk',
        'product': 'SanDisk (Unspecified Product)'
    },
    {
        'vendor': 'Sana Commerce',
        'product': 'Sana Commerce'
    },
    {
        'vendor': 'SandSIV Switzerland, Ltd.',
        'product': 'SandSIV'
    },
    {
        'vendor': 'Sandvine Corporation',
        'product': 'Sandvine'
    },
    {
        'vendor': 'Sangfor Technologies, Inc.',
        'product': 'Sangfor IAM'
    },
    {
        'vendor': 'Sangoma Technologies Corporation',
        'product': 'Sangoma'
    },
    {
        'vendor': 'Sandata Technologies, LLC',
        'product': 'Santrax Electronic Visit Verification'
    },
    {
        'vendor': 'Sapaad',
        'product': 'Sapaad'
    },
    {
        'vendor': 'Hyland Software, Inc.',
        'product': 'Saperion ECM'
    },
    {
        'vendor': 'Sapiens International Corporation',
        'product': 'Sapiens'
    },
    {
        'vendor': 'Sapiens International Corporation',
        'product': 'Sapiens Decision'
    },
    {
        'vendor': 'Sapiens International Corporation',
        'product': 'Sapiens eMerge'
    },
    {
        'vendor': 'Sapo Technology JSC',
        'product': 'Sapo'
    },
    {
        'vendor': 'Tecknodreams Software Consulting Pvt Ltd',
        'product': 'SapphireIMS'
    },
    {
        'vendor': 'Aptean, Inc.',
        'product': 'Saratoga CRM'
    },
    {
        'vendor': 'Sassafras Software, Inc.',
        'product': 'Sassafras'
    },
    {
        'vendor': 'Satismeter s.r.o.',
        'product': 'SatisMeter'
    },
    {
        'vendor': 'NICE Satmetrix',
        'product': 'Satmetrix NPX'
    },
    {
        'vendor': 'Satori Marketing, LLC',
        'product': 'Satori'
    },
    {
        'vendor': 'Sauce Labs, Inc.',
        'product': 'Sauce Labs'
    },
    {
        'vendor': 'Saviynt, Inc.',
        'product': 'Saviynt'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Savvis'
    },
    {
        'vendor': 'Lumen Technologies, Inc.',
        'product': 'Savvis Hosting'
    },
    {
        'vendor': 'Say Media, Inc.',
        'product': 'Say Media'
    },
    {
        'vendor': 'Lightbend, Inc.',
        'product': 'Scala'
    },
    {
        'vendor': 'Scale Computing',
        'product': 'Scale Computing'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'ScaleArc'
    },
    {
        'vendor': 'ScaleFactor, Inc.',
        'product': 'ScaleFactor'
    },
    {
        'vendor': 'ScaleGrid, Inc.',
        'product': 'ScaleGrid'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'ScaleXtreme'
    },
    {
        'vendor': 'Scality, Inc.',
        'product': 'Scality'
    },
    {
        'vendor': 'Scality, Inc.',
        'product': 'Scality RING'
    },
    {
        'vendor': 'Scalr, Inc.',
        'product': 'Scalr'
    },
    {
        'vendor': 'ScanFiles, Inc.',
        'product': 'ScanFiles'
    },
    {
        'vendor': 'ScanSource, Inc.',
        'product': 'ScanSource'
    },
    {
        'vendor': 'Scanco Medical AG',
        'product': 'Scanco XtremeCT'
    },
    {
        'vendor': 'Schedule360, Inc.',
        'product': 'Schedule360'
    },
    {
        'vendor': 'Indeavor',
        'product': 'ScheduleSoft'
    },
    {
        'vendor': 'Schedulicity, Inc.',
        'product': 'Schedulicity'
    },
    {
        'vendor': 'Schlumberger, Ltd.',
        'product': 'Schlumberger (Unspecified Product)'
    },
    {
        'vendor': 'Schlumberger, Ltd.',
        'product': 'Schlumberger Eclipse'
    },
    {
        'vendor': 'Schlumberger, Ltd.',
        'product': 'Schlumberger Petrel'
    },
    {
        'vendor': 'Schneider Electric SE',
        'product': 'Schneider ArcFM'
    },
    {
        'vendor': 'Schneider Electric SE',
        'product': 'Schneider Electric (Unspecified Product)'
    },
    {
        'vendor': 'KEV Group, Inc.',
        'product': 'SchoolCash'
    },
    {
        'vendor': 'Dude Solutions, Inc.',
        'product': 'SchoolDude'
    },
    {
        'vendor': 'Schoology, Inc.',
        'product': 'Schoology'
    },
    {
        'vendor': 'Renaissance Learning, Inc.',
        'product': 'Schoolzilla'
    },
    {
        'vendor': 'Schoox, Inc.',
        'product': 'Schoox'
    },
    {
        'vendor': 'Schrödinger, Inc.',
        'product': 'Schrödinger'
    },
    {
        'vendor': 'Schuyler House',
        'product': 'SchuyLab'
    },
    {
        'vendor': 'Schweitzer Engineering Laboratories',
        'product': 'Schweitzer Engineering Laboratories'
    },
    {
        'vendor': 'SciComp',
        'product': 'SciComp'
    },
    {
        'vendor': 'SciComp',
        'product': 'SciFinance'
    },
    {
        'vendor': 'Open Source',
        'product': 'SciPy'
    },
    {
        'vendor': 'ScienceLogic, Inc.',
        'product': 'ScienceLogic'
    },
    {
        'vendor': 'Scientia, Ltd.',
        'product': 'Scientia'
    },
    {
        'vendor': 'Sciforma Corporation',
        'product': 'Sciforma'
    },
    {
        'vendor': 'ScImage, Inc.',
        'product': 'Scimage'
    },
    {
        'vendor': 'Scoop.it, Inc.',
        'product': 'Scoop.it'
    },
    {
        'vendor': 'Full Circle Studies, Inc.',
        'product': 'ScorecardResearch'
    },
    {
        'vendor': 'ScottCare Corporation',
        'product': 'ScottCare'
    },
    {
        'vendor': 'Scout RFP, Inc.',
        'product': 'Scout RFP'
    },
    {
        'vendor': 'Screaming Frog',
        'product': 'Screaming Frog (Unspecified Product)'
    },
    {
        'vendor': 'Screenleap, Inc.',
        'product': 'Screenleap'
    },
    {
        'vendor': 'Rock Content Ltda.',
        'product': 'ScribbleLive'
    },
    {
        'vendor': 'Rock Content Ltda.',
        'product': 'ScribbleLive Engage'
    },
    {
        'vendor': 'Scribd, Inc.',
        'product': 'Scribd'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'Scribe Online'
    },
    {
        'vendor': 'ScriptPro, LLC',
        'product': 'ScriptPro'
    },
    {
        'vendor': 'Bravado Health, Inc.',
        'product': 'ScriptRx'
    },
    {
        'vendor': 'ScriptoPro',
        'product': 'ScriptoPro'
    },
    {
        'vendor': 'Scrumwise ApS',
        'product': 'Scrumwise'
    },
    {
        'vendor': 'Plixer, LLC',
        'product': 'Scrutinizer'
    },
    {
        'vendor': 'ScyllaDB, Ltd.',
        'product': 'Scylla'
    },
    {
        'vendor': 'Seagate Technology, LLC',
        'product': 'Seagate AssuredSAN'
    },
    {
        'vendor': 'Seal Software, Ltd.',
        'product': 'Seal Software'
    },
    {
        'vendor': 'Sealights Technologies, Ltd.',
        'product': 'Sealights'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Seapine'
    },
    {
        'vendor': 'SearchForce, Inc.',
        'product': 'SearchForce'
    },
    {
        'vendor': 'SearchSpring',
        'product': 'SearchSpring'
    },
    {
        'vendor': 'Searchify, LLC',
        'product': 'Searchify'
    },
    {
        'vendor': 'Searchmetrics',
        'product': 'Searchmetrics'
    },
    {
        'vendor': 'Software Engineering Of America',
        'product': 'Seasoft'
    },
    {
        'vendor': 'SeatGeek, Inc.',
        'product': 'SeatGeek Enterprise'
    },
    {
        'vendor': 'Sechrist Industries, Inc.',
        'product': 'Sechrist Industries'
    },
    {
        'vendor': 'Seclore Technology Pvt Ltd',
        'product': 'Seclore'
    },
    {
        'vendor': 'Secockpit',
        'product': 'Secockpit'
    },
    {
        'vendor': 'Sectra AB',
        'product': 'Sectra'
    },
    {
        'vendor': 'SecuGen Corporation',
        'product': 'SecuGen'
    },
    {
        'vendor': 'secunet Security Networks AG',
        'product': 'Secunet'
    },
    {
        'vendor': 'Secure64 Software Corporation',
        'product': 'Secure64'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'SecureAssist'
    },
    {
        'vendor': 'SecureAuth Corporation',
        'product': 'SecureAuth'
    },
    {
        'vendor': 'SecureDocs, Inc.',
        'product': 'SecureDocs'
    },
    {
        'vendor': 'AppRiver, LLC',
        'product': 'SecureTide'
    },
    {
        'vendor': 'Securitas Security Services USA, Inc.',
        'product': 'Securitas'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Security Key Enforcement'
    },
    {
        'vendor': 'Security Weaver',
        'product': 'Security Weaver'
    },
    {
        'vendor': 'SecurityMetrics, Inc.',
        'product': 'SecurityMetrics'
    },
    {
        'vendor': 'SecurityScorecard, Inc.',
        'product': 'SecurityScorecard'
    },
    {
        'vendor': 'Securonix, Inc.',
        'product': 'Securonix'
    },
    {
        'vendor': 'Securonix, Inc.',
        'product': 'Securonix Next-Gen SIEM'
    },
    {
        'vendor': 'Sedo.com, LLC',
        'product': 'Sedo Domain Parking'
    },
    {
        'vendor': 'SeeVolution',
        'product': 'SeeVolution'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SeeWhy'
    },
    {
        'vendor': 'Seeburger AG',
        'product': 'Seeburger'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Seeker'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Sefaira'
    },
    {
        'vendor': 'Segami Corporation',
        'product': 'Segami Oasis'
    },
    {
        'vendor': 'Segment.io, Inc.',
        'product': 'Segment'
    },
    {
        'vendor': 'Segment.io, Inc.',
        'product': 'Segment Analytics.js'
    },
    {
        'vendor': 'Segment.io, Inc.',
        'product': 'Segment.io'
    },
    {
        'vendor': 'Halliburton Energy Services, Inc.',
        'product': 'SeisSpace ProMAX'
    },
    {
        'vendor': 'Seismic Software, Inc.',
        'product': 'Seismic'
    },
    {
        'vendor': 'SelectHub',
        'product': 'SelectHub'
    },
    {
        'vendor': 'Determine, Inc.',
        'product': 'Selectica'
    },
    {
        'vendor': 'Selectivizr',
        'product': 'Selectivizr'
    },
    {
        'vendor': 'Codeborne OÜ',
        'product': 'Selenide'
    },
    {
        'vendor': 'Selenium',
        'product': 'Selenium (Unspecified Product)'
    },
    {
        'vendor': 'Selenium',
        'product': 'Selenium Grid'
    },
    {
        'vendor': 'Selenium',
        'product': 'Selenium IDE'
    },
    {
        'vendor': 'Selenium',
        'product': 'Selenium WebDriver'
    },
    {
        'vendor': 'SellHack',
        'product': 'SellHack'
    },
    {
        'vendor': 'GoDaddy Sellbrite, Inc.',
        'product': 'Sellbrite'
    },
    {
        'vendor': 'Selligent, Inc.',
        'product': 'Selligent'
    },
    {
        'vendor': 'Sellsy',
        'product': 'Sellsy'
    },
    {
        'vendor': 'Selz.com Pty Ltd',
        'product': 'Selz'
    },
    {
        'vendor': 'Semantix International AB',
        'product': 'Semantix'
    },
    {
        'vendor': 'Rendered Text',
        'product': 'Semaphore'
    },
    {
        'vendor': 'Semarchy, Inc.',
        'product': 'Semarchy xDM'
    },
    {
        'vendor': 'Semperis, Ltd.',
        'product': 'Semperis'
    },
    {
        'vendor': 'SenEarthCo, Inc.',
        'product': 'SenEarthCo'
    },
    {
        'vendor': 'Ignite Technologies, Inc.',
        'product': 'SenSage AP'
    },
    {
        'vendor': 'Sencha, Inc.',
        'product': 'Sencha'
    },
    {
        'vendor': 'OnSolve, LLC',
        'product': 'Send Word Now'
    },
    {
        'vendor': 'SendBird, Inc.',
        'product': 'SendBird'
    },
    {
        'vendor': 'SendGrid, Inc.',
        'product': 'SendGrid'
    },
    {
        'vendor': 'SendOwl',
        'product': 'SendOwl'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'SendPro'
    },
    {
        'vendor': 'SendPulse, Inc.',
        'product': 'SendPulse'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'SendSuite Tracking'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'Sendbloom'
    },
    {
        'vendor': 'Middleware, Inc.',
        'product': 'Sender'
    },
    {
        'vendor': 'Sendible, Ltd.',
        'product': 'Sendible'
    },
    {
        'vendor': 'Sendinblue SAS',
        'product': 'SendinBlue'
    },
    {
        'vendor': 'Sendloop',
        'product': 'Sendloop'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Sendmail Sentrion'
    },
    {
        'vendor': 'Sender, Inc.',
        'product': 'Sendoso'
    },
    {
        'vendor': 'Techdrop Labs, Inc.',
        'product': 'Sendwithus'
    },
    {
        'vendor': 'Senior Sistemas S.A.',
        'product': 'Senior Sistemas'
    },
    {
        'vendor': 'SeniorSystems, Inc.',
        'product': 'SeniorSystems'
    },
    {
        'vendor': 'SensEye',
        'product': 'SensEye'
    },
    {
        'vendor': 'Sensedia S.A.',
        'product': 'Sensedia APIs Platform'
    },
    {
        'vendor': 'Sensu, Inc.',
        'product': 'Sensu Enterprise'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Sentinel HASP'
    },
    {
        'vendor': 'Sentinel Labs, Inc.',
        'product': 'SentinelOne'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Sentri7'
    },
    {
        'vendor': 'Sentric, Inc.',
        'product': 'SentricWorkforce'
    },
    {
        'vendor': 'Sentry.io',
        'product': 'Sentry'
    },
    {
        'vendor': 'Sentry Air Systems, Inc.',
        'product': 'Sentry Air'
    },
    {
        'vendor': 'SQL Sentry, LLC',
        'product': 'SentryOne SQL Sentry'
    },
    {
        'vendor': 'SequelMed',
        'product': 'SequelMed EHR'
    },
    {
        'vendor': 'SequoiaDB Corporation',
        'product': 'SequoiaDB'
    },
    {
        'vendor': 'Serenity Software',
        'product': 'Serenity'
    },
    {
        'vendor': 'Sermicro Group',
        'product': 'Sermicro'
    },
    {
        'vendor': 'Serrala Group GmbH',
        'product': 'Serrala'
    },
    {
        'vendor': 'Service Pro .Net, Inc.',
        'product': 'ServSuite'
    },
    {
        'vendor': 'Server Technology, Inc.',
        'product': 'Server Technology'
    },
    {
        'vendor': 'Service Autopilot',
        'product': 'Service Autopilot'
    },
    {
        'vendor': 'Service Fusion',
        'product': 'Service Fusion'
    },
    {
        'vendor': 'ToolsGroup, Inc.',
        'product': 'Service Optimizer 99+'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Service Virtualization'
    },
    {
        'vendor': 'ServiceBridge',
        'product': 'ServiceBridge'
    },
    {
        'vendor': 'ServiceChannel.com, Inc.',
        'product': 'ServiceChannel'
    },
    {
        'vendor': 'ServiceM8',
        'product': 'ServiceM8'
    },
    {
        'vendor': 'ServiceMax, Inc.',
        'product': 'ServiceMax'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow (Unspecified Product)'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Agile Development'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Application Portfolio Management (APM)'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Asset Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Automated Test Framework'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow BCM'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow CMS'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Change Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Change and Release Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Configuration Management Database'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Content Management System (CMS)'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Cost Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Customer Service Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Demand Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Discovery'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Event Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Facilities Service Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Field Service Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Governance, Risk, and Compliance'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow HR Service Delivery'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Incident Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow IntegrationHub'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Mobile Studio'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Orchestration'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Problem Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Project Portfolio Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Reporting'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Request Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Resource Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Security Operations'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Service Catalog'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Service Level Management (SLM)'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Service Mapping'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Service Portal'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow ServiceWatch'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Software Asset Management'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Visual Task Boards'
    },
    {
        'vendor': 'ServiceNow, Inc.',
        'product': 'ServiceNow Vulnerability Response'
    },
    {
        'vendor': 'ServicePRO',
        'product': 'ServicePRO'
    },
    {
        'vendor': 'ServicePower, Inc.',
        'product': 'ServicePower'
    },
    {
        'vendor': 'ServiceRocket, Inc.',
        'product': 'ServiceRocket'
    },
    {
        'vendor': 'ServiceSource International, Inc.',
        'product': 'ServiceSource'
    },
    {
        'vendor': 'ServiceTitan, Inc.',
        'product': 'ServiceTitan'
    },
    {
        'vendor': 'ServiceTrade, Inc.',
        'product': 'ServiceTrade'
    },
    {
        'vendor': 'Serviceaide, Inc.',
        'product': 'Serviceaide Intelligent Service Management'
    },
    {
        'vendor': 'Servicetrace GmbH',
        'product': 'Servicetrace'
    },
    {
        'vendor': 'Serviceware SE',
        'product': 'Serviceware Processes'
    },
    {
        'vendor': 'Getinge AB',
        'product': 'Servo-i Ventilator'
    },
    {
        'vendor': 'Servoy, Inc.',
        'product': 'Servoy'
    },
    {
        'vendor': 'SessionCam, Ltd.',
        'product': 'SessionCam'
    },
    {
        'vendor': 'SevOne, Inc.',
        'product': 'SevOne'
    },
    {
        'vendor': 'Sevocity',
        'product': 'Sevocity'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'Sfax'
    },
    {
        'vendor': 'Sharablee, Inc.',
        'product': 'Sharablee'
    },
    {
        'vendor': 'ShareASale.com, Inc.',
        'product': 'ShareASale'
    },
    {
        'vendor': 'ShareThis, Inc.',
        'product': 'ShareThis'
    },
    {
        'vendor': 'ShareVault',
        'product': 'ShareVault'
    },
    {
        'vendor': 'Digital Reasoning Systems, Inc.',
        'product': 'Shareable Ink'
    },
    {
        'vendor': 'Shareaholic, Inc.',
        'product': 'Shareaholic'
    },
    {
        'vendor': 'Sharethrough, Inc.',
        'product': 'Sharethrough'
    },
    {
        'vendor': 'SharpCloud Software, Ltd.',
        'product': 'SharpCloud'
    },
    {
        'vendor': 'SharpSpring, Inc.',
        'product': 'SharpSpring'
    },
    {
        'vendor': 'SharpeSoft, Inc.',
        'product': 'SharpeSoft'
    },
    {
        'vendor': 'Sharpr',
        'product': 'Sharpr'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Shavlik'
    },
    {
        'vendor': 'Asure Software, Inc.',
        'product': 'Sheakley PaySystems'
    },
    {
        'vendor': 'Shelf Logic Software, Inc.',
        'product': 'Shelf Logic'
    },
    {
        'vendor': 'SherpaDesk.com, Inc.',
        'product': 'SherpaDesk'
    },
    {
        'vendor': 'Shift4 Payments, LLC',
        'product': 'Shift4'
    },
    {
        'vendor': 'ShiftHound, Inc.',
        'product': 'ShiftHound'
    },
    {
        'vendor': 'ShiftWise, Inc.',
        'product': 'ShiftWise'
    },
    {
        'vendor': 'ShiftWizard, Inc.',
        'product': 'ShiftWizard'
    },
    {
        'vendor': 'Shiftboard, Inc.',
        'product': 'Shiftboard'
    },
    {
        'vendor': 'ShinyStat',
        'product': 'ShinyStat'
    },
    {
        'vendor': 'UPS',
        'product': 'ShipExec'
    },
    {
        'vendor': 'V-Technologies, LLC',
        'product': 'ShipGear'
    },
    {
        'vendor': 'RateLinx',
        'product': 'ShipLinx'
    },
    {
        'vendor': 'Interapptive, Inc.',
        'product': 'ShipWorks'
    },
    {
        'vendor': 'Shippable, Inc.',
        'product': 'Shippable'
    },
    {
        'vendor': 'Shippo',
        'product': 'Shippo'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Shockwave'
    },
    {
        'vendor': 'Shogun Labs, Inc.',
        'product': 'Shogun'
    },
    {
        'vendor': 'Shop2Market',
        'product': 'Shop2Market'
    },
    {
        'vendor': 'ShopEx, Inc.',
        'product': 'ShopEx'
    },
    {
        'vendor': '3D3.COM Pty Ltd',
        'product': 'ShopFactory'
    },
    {
        'vendor': 'Shopgate, Inc.',
        'product': 'ShopGate'
    },
    {
        'vendor': 'Shoprocket, Ltd.',
        'product': 'ShopRocket'
    },
    {
        'vendor': 'ShopSite, Inc.',
        'product': 'ShopSite'
    },
    {
        'vendor': 'Aptos, Inc.',
        'product': 'ShopVisible'
    },
    {
        'vendor': 'Kibo Software, Inc.',
        'product': 'Shopatron'
    },
    {
        'vendor': 'Shopify, Inc.',
        'product': 'Shopify'
    },
    {
        'vendor': 'Shopify, Inc.',
        'product': 'Shopify POS'
    },
    {
        'vendor': 'Shopify, Inc.',
        'product': 'Shopify Plus'
    },
    {
        'vendor': 'Shopkeep',
        'product': 'Shopkeep POS'
    },
    {
        'vendor': 'Shopkick, Inc.',
        'product': 'Shopkick'
    },
    {
        'vendor': 'Shoplo Sp. z o.o.',
        'product': 'Shoplo'
    },
    {
        'vendor': 'Shoplogix',
        'product': 'Shoplogix PE'
    },
    {
        'vendor': 'Shopp',
        'product': 'Shopp'
    },
    {
        'vendor': 'Setuno, Inc.',
        'product': 'Shopping Cart Elite'
    },
    {
        'vendor': 'Connexity, Inc.',
        'product': 'Shopzilla'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'ShoreTel Sky Communicator'
    },
    {
        'vendor': 'Pancake Laboratories, Inc.',
        'product': 'ShortStack'
    },
    {
        'vendor': 'Syndigo, LLC',
        'product': 'Shotfarm'
    },
    {
        'vendor': 'Shoutcast SPRL',
        'product': 'Shoutcast'
    },
    {
        'vendor': 'Khoros, LLC',
        'product': 'Shoutlet'
    },
    {
        'vendor': 'ShowClix, Inc.',
        'product': 'ShowClix'
    },
    {
        'vendor': 'ShowMojo',
        'product': 'ShowMojo'
    },
    {
        'vendor': 'ShowMyPC.com, LLC',
        'product': 'ShowMyPC'
    },
    {
        'vendor': 'Showpad, Inc.',
        'product': 'Showpad'
    },
    {
        'vendor': 'Showpad, Inc.',
        'product': 'Showpad Coach'
    },
    {
        'vendor': 'Shutterstock, Inc.',
        'product': 'Shutterstock'
    },
    {
        'vendor': 'SiSense, Inc.',
        'product': 'SiSense'
    },
    {
        'vendor': 'Glad Cube Company, Ltd.',
        'product': 'SiTest'
    },
    {
        'vendor': 'Siav S.p.A.',
        'product': 'Siav Archiflow'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel CRM'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Clinical Trial Management System'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Contact Center'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Email Marketing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Enterprise Marketing'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Field Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Marketing Resource Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel PRM'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Quote and Order Lifecycle Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Sales'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Universal Customer Master (UCM)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Siebel Web Services'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens ACUSON'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens APOGEE'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens AXIOM Sensis'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens AngioStar'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Avanto'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Biograph'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens CATHCOR'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens CT'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Dade Behring'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Definition AS'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Desigo'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Emotion'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Espree'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens HiCom 300'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens HiPath'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens I-DEAS'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Inveon'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Kinetdx'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Lantis'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens MAGNETOM ESSENZA'
    },
    {
        'vendor': 'Siemens Healthineers AG',
        'product': 'Siemens MAGNETOM Espree eco'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens MRI'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Magnetom'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Mammomat'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens MedSeries4'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Mindsphere'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens MobileMD'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Mobilett'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens NX'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Novius'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens PLM'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Polarion ALM'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens RUGGEDCOM'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens SIMATIC Automation Designer'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens SIMATIC IT'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens SOMATOM'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Sensation 16'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Sensation 4'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Sensation 40'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Solid Edge'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Syngo Imaging'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Teamcenter'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Teamcenter Visualization'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Uroskop'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Volume Zoom'
    },
    {
        'vendor': 'Sierra Wireless S.A.',
        'product': 'Sierra Wireless AirVantage'
    },
    {
        'vendor': 'Sift Science, Inc.',
        'product': 'Sift'
    },
    {
        'vendor': 'Sift Science, Inc.',
        'product': 'Sift Science'
    },
    {
        'vendor': 'Sifter',
        'product': 'Sifter'
    },
    {
        'vendor': 'SigQuali',
        'product': 'SigQuali'
    },
    {
        'vendor': 'SightPlan, Inc.',
        'product': 'SightPlan'
    },
    {
        'vendor': 'Sigma Computing, Inc.',
        'product': 'Sigma Computing'
    },
    {
        'vendor': 'MatrixCare, Inc.',
        'product': 'SigmaCare'
    },
    {
        'vendor': 'Sigmund Software, LLC',
        'product': 'Sigmund Aura'
    },
    {
        'vendor': 'SignMeUp.com, Inc.',
        'product': 'SignMeUp'
    },
    {
        'vendor': 'airSlate, Inc.',
        'product': 'SignNow'
    },
    {
        'vendor': 'SignOnSite Pty Ltd',
        'product': 'SignOnSite'
    },
    {
        'vendor': 'SignRequest B.V.',
        'product': 'SignRequest'
    },
    {
        'vendor': 'Cvent, Inc.',
        'product': 'SignUp4'
    },
    {
        'vendor': 'Signal Digital, Inc.',
        'product': 'Signal'
    },
    {
        'vendor': 'Signal Sciences, LLC',
        'product': 'Signal Sciences (Unspecified Product)'
    },
    {
        'vendor': 'Signal Sciences, LLC',
        'product': 'Signal Sciences NextGen WAF'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'SignalFX'
    },
    {
        'vendor': 'Signavio GmbH',
        'product': 'Signavio'
    },
    {
        'vendor': 'Signifyd, Inc.',
        'product': 'Signifyd'
    },
    {
        'vendor': 'Signius Communications',
        'product': 'Signius'
    },
    {
        'vendor': 'HPE',
        'product': 'Silicon Graphics International (SGI)'
    },
    {
        'vendor': 'SilkOne',
        'product': 'SilkOne Chiropractic EHR'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad GreenLight'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad HRMS'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad Learning'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad Onboarding'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad OpenHire'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad Performance'
    },
    {
        'vendor': 'SilkRoad Technology, Inc.',
        'product': 'SilkRoad Recruiting'
    },
    {
        'vendor': 'Silvaco, Inc.',
        'product': 'Silvaco'
    },
    {
        'vendor': 'Silver Peak Systems, Inc.',
        'product': 'Silver Peak'
    },
    {
        'vendor': 'Itron, Inc.',
        'product': 'Silver Spring Networks'
    },
    {
        'vendor': 'BAE Systems PLC',
        'product': 'SilverSky'
    },
    {
        'vendor': 'SilverStripe, Ltd.',
        'product': 'SilverStripe CMS'
    },
    {
        'vendor': 'Silvon Software, Inc.',
        'product': 'Silvon'
    },
    {
        'vendor': 'SimCorp A/S',
        'product': 'SimCorp'
    },
    {
        'vendor': 'SimCorp A/S',
        'product': 'SimCorp Dimension'
    },
    {
        'vendor': 'SimCorp A/S',
        'product': 'SimCorp Gain'
    },
    {
        'vendor': 'SimScale GmbH',
        'product': 'SimScale'
    },
    {
        'vendor': 'Simerics, Inc.',
        'product': 'Simerics'
    },
    {
        'vendor': 'SimilarWeb, Ltd.',
        'product': 'SimilarWeb'
    },
    {
        'vendor': 'Simio, LLC',
        'product': 'Simio'
    },
    {
        'vendor': 'Open Source',
        'product': 'Simple Test'
    },
    {
        'vendor': 'SimpleCart',
        'product': 'SimpleCart'
    },
    {
        'vendor': 'QNT S.rl',
        'product': 'Simplebooking'
    },
    {
        'vendor': 'Simplify ASC, Inc.',
        'product': 'Simplify ASC Platform'
    },
    {
        'vendor': 'Simplify360',
        'product': 'Simplify360'
    },
    {
        'vendor': 'SimplifyEm',
        'product': 'SimplifyEm'
    },
    {
        'vendor': 'SproutSocial, Inc.',
        'product': 'Simply Measured'
    },
    {
        'vendor': 'SimplyCast Interactive Marketing, Ltd.',
        'product': 'Simplycast'
    },
    {
        'vendor': 'Simpplr, Inc.',
        'product': 'Simpplr'
    },
    {
        'vendor': 'The MathWorks, Inc.',
        'product': 'Simulink'
    },
    {
        'vendor': 'Simulmedia, Inc.',
        'product': 'Simulmedia'
    },
    {
        'vendor': 'Sinch AB',
        'product': 'Sinch'
    },
    {
        'vendor': 'MSC Software Corporation',
        'product': 'Sinda'
    },
    {
        'vendor': 'Sinequa',
        'product': 'Sinequa'
    },
    {
        'vendor': 'Vendio Services, LLC',
        'product': 'SingleFeed'
    },
    {
        'vendor': 'Internap Corporation',
        'product': 'SingleHop'
    },
    {
        'vendor': 'SingleHop, LLC',
        'product': 'SingleHop Hosting'
    },
    {
        'vendor': 'MemSQL, Inc.',
        'product': 'SingleStore'
    },
    {
        'vendor': 'Singular Labs, Inc.',
        'product': 'Singular'
    },
    {
        'vendor': 'SirionLabs, Inc.',
        'product': 'SirionLabs'
    },
    {
        'vendor': 'Sistemi S.p.A.',
        'product': 'Sistemi PROFIS'
    },
    {
        'vendor': 'Sisteplant SL',
        'product': 'Sisteplant PRISMA'
    },
    {
        'vendor': 'SiteBoss',
        'product': 'SiteBoss'
    },
    {
        'vendor': 'SiteDocs Safety Corporation',
        'product': 'SiteDocs'
    },
    {
        'vendor': 'SiteGround Hosting, Ltd.',
        'product': 'SiteGround'
    },
    {
        'vendor': 'Sphera Solutions, Inc.',
        'product': 'SiteHawk'
    },
    {
        'vendor': 'SiteHeart',
        'product': 'SiteHeart'
    },
    {
        'vendor': 'SiteLock',
        'product': 'SiteLock'
    },
    {
        'vendor': 'SiteMinder',
        'product': 'SiteMinder'
    },
    {
        'vendor': 'SitePoint Pty Ltd',
        'product': 'SitePoint'
    },
    {
        'vendor': 'Centro, Inc.',
        'product': 'SiteScout'
    },
    {
        'vendor': 'SiteSpect, Inc.',
        'product': 'SiteSpect'
    },
    {
        'vendor': 'Sitecore Corporation',
        'product': 'Sitecore'
    },
    {
        'vendor': 'Sitecore Corporation',
        'product': 'Sitecore Commerce'
    },
    {
        'vendor': 'Sitecore Corporation',
        'product': 'Sitecore Experience Commerce'
    },
    {
        'vendor': 'Sitecore Corporation',
        'product': 'Sitecore Experience Platform'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Sitefinity'
    },
    {
        'vendor': 'Siteimprove A/S',
        'product': 'Siteimprove'
    },
    {
        'vendor': 'Sitetracker, Inc.',
        'product': 'Sitetracker'
    },
    {
        'vendor': 'Sitoo AB',
        'product': 'Sitoo'
    },
    {
        'vendor': 'Siveco Group SL',
        'product': 'Siveco Coswin'
    },
    {
        'vendor': 'Amazon.com, Inc.',
        'product': 'Sizmek'
    },
    {
        'vendor': 'Sked Social',
        'product': 'Sked Social'
    },
    {
        'vendor': 'Eleven41 Software, Inc.',
        'product': 'Skeddly'
    },
    {
        'vendor': 'Sketch B.V.',
        'product': 'Sketch'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'SketchUp Pro'
    },
    {
        'vendor': 'Skill-Pill M-Learning, Ltd.',
        'product': 'Skill Pill'
    },
    {
        'vendor': 'Skilljar, Inc.',
        'product': 'Skilljar'
    },
    {
        'vendor': 'Skillshare, Inc.',
        'product': 'Skillshare'
    },
    {
        'vendor': 'Skillsoft Corporation',
        'product': 'Skillsoft'
    },
    {
        'vendor': 'SkimLinks',
        'product': 'SkimLinks'
    },
    {
        'vendor': 'Skrollr',
        'product': 'Skrollr'
    },
    {
        'vendor': 'SkuVault, Inc.',
        'product': 'SkuVault'
    },
    {
        'vendor': 'Skubana, LLC',
        'product': 'Skubana'
    },
    {
        'vendor': 'Skura Corporation',
        'product': 'Skura SFX'
    },
    {
        'vendor': 'SkyPrep',
        'product': 'SkyPrep'
    },
    {
        'vendor': 'SkyStem, LLC',
        'product': 'SkyStem ART'
    },
    {
        'vendor': 'SkyTouch Solutions, LLC',
        'product': 'SkyTouch Hotel OS'
    },
    {
        'vendor': 'SkyBitz, Inc.',
        'product': 'Skybitz'
    },
    {
        'vendor': 'Skybox Security, Inc.',
        'product': 'Skybox Security'
    },
    {
        'vendor': 'Skytron, LLC',
        'product': 'Skytron'
    },
    {
        'vendor': 'Skyward, Inc.',
        'product': 'Skyward'
    },
    {
        'vendor': 'Slaask, Inc.',
        'product': 'Slaask'
    },
    {
        'vendor': 'Slack Technologies, Inc.',
        'product': 'Slack'
    },
    {
        'vendor': 'ten24 Digital Solutions',
        'product': 'Slatwall'
    },
    {
        'vendor': 'ClearSlide, Inc.',
        'product': 'SlideRocket'
    },
    {
        'vendor': 'Slimbox',
        'product': 'Slimbox'
    },
    {
        'vendor': 'Slite, Inc.',
        'product': 'Slite'
    },
    {
        'vendor': 'Smaart Medical Systems, Inc.',
        'product': 'Smaart Medical Systems'
    },
    {
        'vendor': 'Smaato, Inc.',
        'product': 'Smaato'
    },
    {
        'vendor': 'Smarsh, Inc.',
        'product': 'Smarsh'
    },
    {
        'vendor': 'Smart ERP Solutions, Inc.',
        'product': 'Smart ERP'
    },
    {
        'vendor': 'Sensus Worldwide Holdings, Ltd.',
        'product': 'Smart Grid'
    },
    {
        'vendor': 'Smart Hotel Software',
        'product': 'Smart Hotel Software'
    },
    {
        'vendor': 'Smart Service',
        'product': 'Smart Service'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Smart Track'
    },
    {
        'vendor': 'Pegasystems, Inc.',
        'product': 'SmartBPM'
    },
    {
        'vendor': 'Smartbid',
        'product': 'SmartBid'
    },
    {
        'vendor': 'SmartComms SC, Ltd.',
        'product': 'SmartCOMM'
    },
    {
        'vendor': 'SmartCOP, Inc.',
        'product': 'SmartCOP'
    },
    {
        'vendor': 'Streamline Healthcare Solutions, LLC',
        'product': 'SmartCare'
    },
    {
        'vendor': 'SmartDraw, LLC',
        'product': 'SmartDraw'
    },
    {
        'vendor': 'Bright.MD, Inc.',
        'product': 'SmartExam'
    },
    {
        'vendor': 'Harris Local Government',
        'product': 'SmartFusion'
    },
    {
        'vendor': 'Smartsupp.com s.r.o.',
        'product': 'SmartLook'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'SmartPlant Explorer'
    },
    {
        'vendor': 'SmartRecruiters, Inc.',
        'product': 'SmartRecruiters'
    },
    {
        'vendor': 'Advanced Personnel Systems, Inc.',
        'product': 'SmartSearch'
    },
    {
        'vendor': 'Digi International, Inc.',
        'product': 'SmartSense'
    },
    {
        'vendor': 'GE Digital',
        'product': 'SmartSignal Classic'
    },
    {
        'vendor': 'Hexagon AB',
        'product': 'SmartSketch'
    },
    {
        'vendor': 'Pilgrim Quality Solutions',
        'product': 'SmartSolve'
    },
    {
        'vendor': 'SmartStore AG',
        'product': 'SmartStore.NET'
    },
    {
        'vendor': 'SmartStream Technologies, Ltd.',
        'product': 'SmartStream'
    },
    {
        'vendor': 'Safeharbor',
        'product': 'SmartSupport'
    },
    {
        'vendor': 'SmartSync Software',
        'product': 'SmartSync'
    },
    {
        'vendor': 'SmartDrive Systems, Inc.',
        'product': 'Smartdrive'
    },
    {
        'vendor': 'SmarteSoft, Inc.',
        'product': 'SmarteSoft'
    },
    {
        'vendor': 'SmarterHQ, Inc.',
        'product': 'SmarterHQ'
    },
    {
        'vendor': 'SmarterSelect',
        'product': 'SmarterSelect'
    },
    {
        'vendor': 'Neovation Corporation',
        'product': 'SmarterU'
    },
    {
        'vendor': 'Smartling, Inc.',
        'product': 'Smartling'
    },
    {
        'vendor': 'Lab Technologies S.A.',
        'product': 'Smartlis'
    },
    {
        'vendor': 'Smartly.io',
        'product': 'Smartly.io'
    },
    {
        'vendor': 'Smartronix, LLC',
        'product': 'Smartronix'
    },
    {
        'vendor': 'Smartsheet, Inc.',
        'product': 'Smartsheet'
    },
    {
        'vendor': 'Smartsupp.com s.r.o.',
        'product': 'Smartsupp'
    },
    {
        'vendor': 'Smartsurvey, Ltd.',
        'product': 'Smartsurvey'
    },
    {
        'vendor': 'Smile, Inc.',
        'product': 'Smile'
    },
    {
        'vendor': 'Smiths Medical, Inc.',
        'product': 'Smiths CADD Solis'
    },
    {
        'vendor': 'Smiths Medical, Inc.',
        'product': 'Smiths Graseby'
    },
    {
        'vendor': 'Smiths Medical, Inc.',
        'product': 'Smiths Medfusion'
    },
    {
        'vendor': 'Smiths Medical, Inc.',
        'product': 'Smiths Medical'
    },
    {
        'vendor': 'Smiths Medical, Inc.',
        'product': 'Smiths Pneupac'
    },
    {
        'vendor': 'Smokeball',
        'product': 'Smokeball'
    },
    {
        'vendor': 'SMSBump, Inc.',
        'product': 'SmsBump'
    },
    {
        'vendor': 'SmugMug, Inc.',
        'product': 'SmugMug'
    },
    {
        'vendor': 'SmugMug, Inc.',
        'product': 'SmugMug Hosting'
    },
    {
        'vendor': 'Snap Surveys, Ltd.',
        'product': 'Snap Surveys'
    },
    {
        'vendor': 'UberFlip',
        'product': 'SnapApp'
    },
    {
        'vendor': 'SnapEngage, LLC',
        'product': 'SnapEngage'
    },
    {
        'vendor': 'SnapLogic, Inc.',
        'product': 'SnapLogic'
    },
    {
        'vendor': 'HVE ConneXions, LLC',
        'product': 'SnapServer'
    },
    {
        'vendor': 'Snapforce Technologies',
        'product': 'Snapforce CRM'
    },
    {
        'vendor': 'Snappii Corporation',
        'product': 'Snappii'
    },
    {
        'vendor': 'Snipcart, Inc.',
        'product': 'Snipcart'
    },
    {
        'vendor': 'Snoobi B.V.',
        'product': 'Snoobi'
    },
    {
        'vendor': 'Open Source',
        'product': 'Snort'
    },
    {
        'vendor': 'Snow Software',
        'product': 'Snow'
    },
    {
        'vendor': 'Snowbound Software Corporation',
        'product': 'Snowbound Software'
    },
    {
        'vendor': 'Snowflake Computing, Inc.',
        'product': 'Snowflake Data Warehouse'
    },
    {
        'vendor': 'Snyk, Ltd.',
        'product': 'Snyk'
    },
    {
        'vendor': 'SoCloz Company',
        'product': 'SoCloz'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'SoapUI'
    },
    {
        'vendor': 'Socedo, Inc.',
        'product': 'Socedo'
    },
    {
        'vendor': 'Social Tables, Inc.',
        'product': 'Social Tables'
    },
    {
        'vendor': 'SocialBakers',
        'product': 'SocialBakers'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'SocialCam'
    },
    {
        'vendor': 'SocialChorus, Inc.',
        'product': 'SocialChorus'
    },
    {
        'vendor': 'SocialCode, LLC',
        'product': 'SocialCode'
    },
    {
        'vendor': 'SocialOomph',
        'product': 'SocialOomph'
    },
    {
        'vendor': 'Sociomantic Labs GmbH',
        'product': 'Sociomantic'
    },
    {
        'vendor': 'SocketLabs',
        'product': 'SocketLabs'
    },
    {
        'vendor': 'Catalyst Development Corporation',
        'product': 'SocketTools'
    },
    {
        'vendor': 'Tyler Technologies, Inc.',
        'product': 'Socrata'
    },
    {
        'vendor': 'Socure, Inc.',
        'product': 'Socure'
    },
    {
        'vendor': 'LULU Software',
        'product': 'Soda PDF Anywhere'
    },
    {
        'vendor': 'Soffront Corporation',
        'product': 'Soffront Software'
    },
    {
        'vendor': 'Sofon B.V.',
        'product': 'Sofon'
    },
    {
        'vendor': 'Soft4',
        'product': 'Soft4RealEstate'
    },
    {
        'vendor': 'JVS Group Pvt Ltd',
        'product': 'SoftClinic'
    },
    {
        'vendor': 'UNICOM Systems, Inc.',
        'product': 'SoftLanding'
    },
    {
        'vendor': 'SoftLayer Technologies, Inc.',
        'product': 'SoftLayer'
    },
    {
        'vendor': 'SoftLayer Technologies, Inc.',
        'product': 'SoftLayer DNS'
    },
    {
        'vendor': 'SoftLayer Technologies, Inc.',
        'product': 'SoftLayer Hosting'
    },
    {
        'vendor': 'SoftScript, Inc.',
        'product': 'SoftScript'
    },
    {
        'vendor': 'SoftSlate, LLC',
        'product': 'SoftSlate Commerce'
    },
    {
        'vendor': 'SoftVelocity, Inc.',
        'product': 'SoftVelocity'
    },
    {
        'vendor': 'SoftVelocity, Inc.',
        'product': 'SoftVelocity Clarion'
    },
    {
        'vendor': 'Softeon, Inc.',
        'product': 'Softeon'
    },
    {
        'vendor': 'Softerra, Inc.',
        'product': 'Softerra'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG (Unspecified Product)'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG ARIS'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Adabas'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG CentraSite'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Com-plete'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Command Central'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Entire Access'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Entire Connection'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Entire System Server'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG EntireX'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural Advanced Facilities'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural Construct'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural Engineer'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural Optimizer Compiler'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural for AJAX'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural for DB2'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Natural for VSAM'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Predict Application Control'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Terracotta'
    },
    {
        'vendor': 'Software AG',
        'product': 'Software AG Universal Messaging'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds (Unspecified Product)'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds IP Address Manager'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds Log & Event Manager'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds MSP Manager'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds NPM'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds Patch Manager'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds RMM'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds Service Desk'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds Web Help Desk'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Solaris 10'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Solaris 11'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Solaris 7'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Solaris 8'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Solaris 9'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'Solarwinds Database Performance Analyzer'
    },
    {
        'vendor': 'Quinte Computer Services, Ltd.',
        'product': 'Solentris'
    },
    {
        'vendor': 'Vermeg N.V.',
        'product': 'Soliam'
    },
    {
        'vendor': 'Solibri, Inc.',
        'product': 'Solibri'
    },
    {
        'vendor': 'SolidCAM GmbH',
        'product': 'SolidCAM'
    },
    {
        'vendor': 'Soliton IT, Ltd.',
        'product': 'Soliton IT Radiology+'
    },
    {
        'vendor': 'Solix Technologies, Inc.',
        'product': 'Solix'
    },
    {
        'vendor': 'iBASEt, Inc.',
        'product': 'Solumina'
    },
    {
        'vendor': 'Solutionreach, Inc.',
        'product': 'Solutionreach'
    },
    {
        'vendor': 'Solutionreach, Inc.',
        'product': 'Solutionreach Patient Appointment Reminders'
    },
    {
        'vendor': 'Solve Media, LLC',
        'product': 'Solve Media'
    },
    {
        'vendor': 'Solver',
        'product': 'Solver BI360'
    },
    {
        'vendor': 'Somansa',
        'product': 'Somansa'
    },
    {
        'vendor': 'Cakewalk, Inc.',
        'product': 'Sonar'
    },
    {
        'vendor': 'SonarSource S.A.',
        'product': 'SonarQube'
    },
    {
        'vendor': 'Sonatype, Inc.',
        'product': 'Sonatype Nexus Platform'
    },
    {
        'vendor': 'Sonic Foundry, Inc.',
        'product': 'Sonic Foundry'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall NSa 2650'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall Network Security appliance (NSa) Series'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall SRA'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall SuperMassive Series'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall TZ Series'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall TZ300'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall TZ400'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall TZ500'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall TZ600'
    },
    {
        'vendor': 'Sonitor Technologies, Inc.',
        'product': 'Sonitor'
    },
    {
        'vendor': 'Empower Technologies, Inc.',
        'product': 'SonoSoft EMR'
    },
    {
        'vendor': 'Sonobi, Inc.',
        'product': 'Sonobi JetStream'
    },
    {
        'vendor': 'Sonrai Security, Inc.',
        'product': 'Sonrai Security'
    },
    {
        'vendor': 'Sony Corporation',
        'product': 'Sony (Unspecified Product)'
    },
    {
        'vendor': 'Sony Corporation',
        'product': 'Sony Laptop'
    },
    {
        'vendor': 'Sooqr B.V.',
        'product': 'Sooqr'
    },
    {
        'vendor': 'Sopheon PLC',
        'product': 'Sopheon'
    },
    {
        'vendor': 'Loom Systems, Ltd.',
        'product': 'Sophie'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos (Unspecified Product)'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Central'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Cloud Optix'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Email'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Intercept X'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Intercept X Endpoint'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Mobile'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Phish Threat'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos SafeGuard Encryption'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Secure Web Gateway'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos UTM'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos Wireless'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos XG'
    },
    {
        'vendor': 'Sophus3',
        'product': 'Sophus3'
    },
    {
        'vendor': 'Sopra Banking Software',
        'product': 'Sopra Banking Software'
    },
    {
        'vendor': 'Sopra HR Software',
        'product': 'Sopra HR Software'
    },
    {
        'vendor': 'Sorenson Media',
        'product': 'Sorenson Media'
    },
    {
        'vendor': 'Magix Software GmbH',
        'product': 'Sound Forge'
    },
    {
        'vendor': 'SoundCloud, Ltd.',
        'product': 'SoundCloud'
    },
    {
        'vendor': 'SourceDay, LLC',
        'product': 'SourceDay'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'SourceFire'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'SourceFire FireAMP'
    },
    {
        'vendor': 'SourceGear, LLC',
        'product': 'Sourcegear Vault'
    },
    {
        'vendor': 'Sourcegraph, Inc.',
        'product': 'Sourcegraph'
    },
    {
        'vendor': 'Open Systems, Inc.',
        'product': 'Southware ERP'
    },
    {
        'vendor': 'Sovos Compliance, LLC',
        'product': 'Sovos'
    },
    {
        'vendor': 'Sovrn Holdings, Inc.',
        'product': 'Sovrn'
    },
    {
        'vendor': 'ExplosionAI GmbH',
        'product': 'SpaCy'
    },
    {
        'vendor': 'Spacelabs Healthcare, Inc.',
        'product': 'Spacelabs Healthcare'
    },
    {
        'vendor': 'Spacewell International',
        'product': 'Spacewell (Unspecified Product)'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'SpamAssassin'
    },
    {
        'vendor': 'TitanHQ',
        'product': 'SpamTitan'
    },
    {
        'vendor': 'Hornetsecurity GmbH',
        'product': 'Spamina'
    },
    {
        'vendor': 'Spanning Cloud Apps, LLC',
        'product': 'Spanning'
    },
    {
        'vendor': 'Sparx Systems Pty Ltd',
        'product': 'Sparx Systems'
    },
    {
        'vendor': 'Cucumber, Ltd.',
        'product': 'SpecFlow'
    },
    {
        'vendor': 'Specialist Apps, Ltd.',
        'product': 'Specialist Apps'
    },
    {
        'vendor': 'Specific Media',
        'product': 'Specific Media'
    },
    {
        'vendor': 'Hannon Hill Corporation',
        'product': 'Spectate'
    },
    {
        'vendor': 'RealPage, Inc.',
        'product': 'Spectra'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra Logic'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra T-Finity'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra T120'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra T200'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra T380'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra T50e'
    },
    {
        'vendor': 'Spectra Logic Corporation',
        'product': 'Spectra T950'
    },
    {
        'vendor': 'Spectralink Corporation',
        'product': 'SpectraLink'
    },
    {
        'vendor': 'Viewpoint, Inc.',
        'product': 'Spectrum'
    },
    {
        'vendor': 'Speechmatics',
        'product': 'Speechmatics'
    },
    {
        'vendor': 'Speed Commerce Operating Company, LLC',
        'product': 'SpeedCommerce'
    },
    {
        'vendor': 'Spendesk SAS',
        'product': 'Spendesk'
    },
    {
        'vendor': 'Spendwise',
        'product': 'Spendwise'
    },
    {
        'vendor': 'Sphera Solutions, Inc.',
        'product': 'Sphera'
    },
    {
        'vendor': 'SphereWMS',
        'product': 'SphereWMS'
    },
    {
        'vendor': 'Spiceworks, Inc.',
        'product': 'Spiceworks'
    },
    {
        'vendor': 'SpiderOak, Inc.',
        'product': 'SpiderOak'
    },
    {
        'vendor': 'SpinGo Solutions, Inc.',
        'product': 'SpinGo'
    },
    {
        'vendor': 'Armory, Inc.',
        'product': 'Spinnaker'
    },
    {
        'vendor': 'Inflectra Corporation',
        'product': 'SpiraTeam'
    },
    {
        'vendor': 'Inflectra Corporation',
        'product': 'SpiraTest'
    },
    {
        'vendor': 'Spireon, Inc.',
        'product': 'Spireon'
    },
    {
        'vendor': 'Spirion, LLC',
        'product': 'Spirion'
    },
    {
        'vendor': 'One Clipboard, Inc.',
        'product': 'Splash'
    },
    {
        'vendor': 'Split Software, Inc.',
        'product': 'Split'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk APM'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk App for Infrastructure'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Business Flow'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Cloud'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Data Stream Processor (DSP)'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Enterprise'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Enterprise Security'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk IT Service Intelligence (ITSI)'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Insights'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Phantom'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Storm'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk User Behavior Analytics'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk for Industrial IoT'
    },
    {
        'vendor': 'Spok, Inc.',
        'product': 'Spok (Unspecified Product)'
    },
    {
        'vendor': 'SportsEngine, Inc.',
        'product': 'SportNgin'
    },
    {
        'vendor': 'SpotMe S.A.',
        'product': 'SpotMe'
    },
    {
        'vendor': 'SpotX, Inc.',
        'product': 'SpotXchange'
    },
    {
        'vendor': 'SpotlerUK',
        'product': 'Spotler'
    },
    {
        'vendor': 'Insightsoftware, Inc.',
        'product': 'Spreadsheet Server'
    },
    {
        'vendor': 'Spreaker, Inc.',
        'product': 'Spreaker'
    },
    {
        'vendor': 'Khoros, LLC',
        'product': 'Spredfast'
    },
    {
        'vendor': 'Spree Commerce, Inc.',
        'product': 'Spree Commerce'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Spring'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Spring Boot'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Spring Cloud'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Spring XD'
    },
    {
        'vendor': 'SpringCM, Inc.',
        'product': 'SpringCM'
    },
    {
        'vendor': 'Spring Medical Systems, Inc.',
        'product': 'SpringCharts'
    },
    {
        'vendor': 'Heartland Payment Systems, Inc.',
        'product': 'Springboard Retail'
    },
    {
        'vendor': 'Springbot, Inc.',
        'product': 'Springbot'
    },
    {
        'vendor': 'Sprinklr, Inc.',
        'product': 'Sprinklr (Unspecified Product)'
    },
    {
        'vendor': 'Sprinklr, Inc.',
        'product': 'Sprinklr Modern Advertising'
    },
    {
        'vendor': 'Sprint Corporation',
        'product': 'Sprint Business'
    },
    {
        'vendor': 'SproutLoud Media Networks, LLC',
        'product': 'SproutLoud'
    },
    {
        'vendor': 'SproutSocial, Inc.',
        'product': 'SproutSocial'
    },
    {
        'vendor': 'Spryker Systems GmbH',
        'product': 'Spryker'
    },
    {
        'vendor': 'SpyFu, Inc.',
        'product': 'SpyFu'
    },
    {
        'vendor': 'The SpyGlass Group, Inc.',
        'product': 'SpyGlass'
    },
    {
        'vendor': 'Square, Inc.',
        'product': 'Square'
    },
    {
        'vendor': 'Square, Inc.',
        'product': 'Square Appointments'
    },
    {
        'vendor': 'Square, Inc.',
        'product': 'Square POS'
    },
    {
        'vendor': 'Square, Inc.',
        'product': 'Square Payroll'
    },
    {
        'vendor': 'Squarespace, Inc.',
        'product': 'Squarespace'
    },
    {
        'vendor': 'Squid Ink Manufacturing, Inc.',
        'product': 'Squid Ink'
    },
    {
        'vendor': 'Squire Technologies',
        'product': 'Squire'
    },
    {
        'vendor': 'Squirro AG',
        'product': 'Squirro'
    },
    {
        'vendor': 'Squiz Australia Pty Ltd',
        'product': 'Squiz'
    },
    {
        'vendor': 'FRONTLINE Selling, LLC',
        'product': 'Staccato'
    },
    {
        'vendor': 'Stack Exchange, Inc.',
        'product': 'Stack Overflow'
    },
    {
        'vendor': 'StackCommerce',
        'product': 'StackCommerce'
    },
    {
        'vendor': 'StackPath, LLC',
        'product': 'StackPath'
    },
    {
        'vendor': 'StackPath, LLC',
        'product': 'StackPath CDN'
    },
    {
        'vendor': 'StackRox, Inc.',
        'product': 'StackRox'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Stackdriver Monitoring'
    },
    {
        'vendor': 'Stackla Pty Ltd',
        'product': 'Stackla'
    },
    {
        'vendor': 'StaffReady',
        'product': 'StaffReady'
    },
    {
        'vendor': 'Stampli, Inc.',
        'product': 'Stampli'
    },
    {
        'vendor': 'Polybit, Inc.',
        'product': 'Standard Library'
    },
    {
        'vendor': 'Stanford NLP Group',
        'product': 'Stanford CoreNLP'
    },
    {
        'vendor': 'Star Analytics, Inc.',
        'product': 'Star Analytics'
    },
    {
        'vendor': 'Star2Star Communications, LLC',
        'product': 'Star2Star'
    },
    {
        'vendor': 'StarGarden Corporation',
        'product': 'StarGarden'
    },
    {
        'vendor': 'StarLeaf, Ltd.',
        'product': 'StarLeaf'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'StarRC'
    },
    {
        'vendor': 'StarRez, Inc.',
        'product': 'StarRez'
    },
    {
        'vendor': 'V-Technologies, LLC',
        'product': 'StarShip'
    },
    {
        'vendor': 'StarWind Software, Inc.',
        'product': 'StarWind (Unspecified Product)'
    },
    {
        'vendor': 'Starburst Data, Inc.',
        'product': 'Starburst Presto'
    },
    {
        'vendor': 'Starfield',
        'product': 'Starfield'
    },
    {
        'vendor': 'Starfield Technologies',
        'product': 'Starfield Technologies'
    },
    {
        'vendor': 'StatPac, Inc.',
        'product': 'StatPac'
    },
    {
        'vendor': 'StatRad, LLC',
        'product': 'StatRad'
    },
    {
        'vendor': 'StatCounter',
        'product': 'Statcounter'
    },
    {
        'vendor': 'State Street Corporation',
        'product': 'State Street (Unspecified Product)'
    },
    {
        'vendor': 'State Street Corporation',
        'product': 'State Street DataGX'
    },
    {
        'vendor': 'State Street Corporation',
        'product': 'State Street truView'
    },
    {
        'vendor': 'Stats24',
        'product': 'Stats24'
    },
    {
        'vendor': 'Statvoo',
        'product': 'Statvoo'
    },
    {
        'vendor': 'StayinFront, Inc.',
        'product': 'StayinFront'
    },
    {
        'vendor': 'Stealthbits Technologies, Inc.',
        'product': 'StealthAUDIT'
    },
    {
        'vendor': 'Stealthbits Technologies, Inc.',
        'product': 'StealthINTERCEPT'
    },
    {
        'vendor': 'Stealthbits Technologies, Inc.',
        'product': 'Stealthbits (Unspecified Product)'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral AppInternals'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral AppMapper'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral AppResponse'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral NetAuditor'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral NetIM'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral NetPlanner'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral NetProfiler'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral Transaction Analyzer'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'SteelCentral UCExpert'
    },
    {
        'vendor': 'Steel House, Inc.',
        'product': 'SteelHouse'
    },
    {
        'vendor': 'Steele Compliance Solutions, Inc.',
        'product': 'Steele Global Securimate'
    },
    {
        'vendor': 'E2open, LLC',
        'product': 'Steelwedge'
    },
    {
        'vendor': 'StellaService, Inc.',
        'product': 'Stella Connect'
    },
    {
        'vendor': 'Stellar Information Technology Pvt Ltd',
        'product': 'Stellar Information'
    },
    {
        'vendor': 'stensul, Inc.',
        'product': 'Stensul'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'StepWise'
    },
    {
        'vendor': 'Wae Pharma GmbH',
        'product': 'SteriBase'
    },
    {
        'vendor': 'Steris PLC',
        'product': 'Steris'
    },
    {
        'vendor': 'Stibo Systems',
        'product': 'Stibo MDM'
    },
    {
        'vendor': 'Stibo Systems',
        'product': 'Stibo PIM'
    },
    {
        'vendor': 'Stibo Systems',
        'product': 'Stibo Systems'
    },
    {
        'vendor': 'Stibo Systems',
        'product': 'Stibo Systems STEP'
    },
    {
        'vendor': 'BAE Systems PLC',
        'product': 'StillSecure'
    },
    {
        'vendor': 'Stitch Labs',
        'product': 'Stitch Labs'
    },
    {
        'vendor': 'Stocklin Logistik AG',
        'product': 'Stocklin'
    },
    {
        'vendor': 'StoneCo., Ltd.',
        'product': 'Stone'
    },
    {
        'vendor': 'Stone Edge Technologies, Inc.',
        'product': 'Stone Edge Order Manager'
    },
    {
        'vendor': 'Imagical S.p.A',
        'product': 'StoneFax'
    },
    {
        'vendor': 'Dynamic Network Factory, Inc.',
        'product': 'StoneFly'
    },
    {
        'vendor': 'Sapiens International Corporation',
        'product': 'StoneRiver'
    },
    {
        'vendor': 'Stonebranch GmbH',
        'product': 'Stonebranch'
    },
    {
        'vendor': 'StorMagic, Ltd.',
        'product': 'StorMagic SvSAN'
    },
    {
        'vendor': 'StorageCraft Technology Corporation',
        'product': 'StorageCraft'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek ACSLS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek Enterprise Backup'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek LTO'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek SL150'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek SL3000'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek SL48'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek SL500'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek SL8500'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek Storage Archive Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek T10000'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek Tape Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek Virtual Storage Manager'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'StorageTek VolSafe'
    },
    {
        'vendor': 'Data Dynamics, Inc.',
        'product': 'StorageX'
    },
    {
        'vendor': 'Projectmoon S.R.L.',
        'product': 'Storeden'
    },
    {
        'vendor': 'Storenvy, Inc.',
        'product': 'Storenvy'
    },
    {
        'vendor': 'Stormshield',
        'product': 'Stormshield'
    },
    {
        'vendor': 'Stottler Henke Associates, Inc.',
        'product': 'Stottler Henke'
    },
    {
        'vendor': 'Strapi Solutions SAS',
        'product': 'Strapi'
    },
    {
        'vendor': 'StratIS, Inc.',
        'product': 'StratIS'
    },
    {
        'vendor': 'Allscripts Healthcare, LLC',
        'product': 'Strata EPSi'
    },
    {
        'vendor': 'Strata Decision Technology',
        'product': 'StrataCap'
    },
    {
        'vendor': 'Strata Decision Technology',
        'product': 'StrataJazz'
    },
    {
        'vendor': 'Stratasys, Ltd.',
        'product': 'Stratasys'
    },
    {
        'vendor': 'Stratasys, Ltd.',
        'product': 'Stratasys MakerBot'
    },
    {
        'vendor': 'Strativity Group, LLC',
        'product': 'Strativity'
    },
    {
        'vendor': 'Stratix Corporation',
        'product': 'Stratix'
    },
    {
        'vendor': 'Stratoscale',
        'product': 'Stratoscale'
    },
    {
        'vendor': 'Stratus Technologies, Inc.',
        'product': 'Stratus Avance'
    },
    {
        'vendor': 'Rewardly, Inc.',
        'product': 'Streak CRM'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'StreamBase'
    },
    {
        'vendor': 'ironSource, Ltd.',
        'product': 'StreamRail'
    },
    {
        'vendor': 'StreamSets, Inc.',
        'product': 'StreamSets DataOps Platform'
    },
    {
        'vendor': 'MetaCDN Pty Ltd',
        'product': 'StreamShark'
    },
    {
        'vendor': 'Streamline Health Solutions, LLC',
        'product': 'Streamline Health'
    },
    {
        'vendor': 'StreamlineMD, LLC',
        'product': 'StreamlineMD'
    },
    {
        'vendor': 'Streamtime Software, Ltd.',
        'product': 'Streamtime'
    },
    {
        'vendor': 'Optimizer StreetCo, Inc.',
        'product': 'StreetSmart'
    },
    {
        'vendor': 'Pitney Bowes, Inc.',
        'product': 'StreetSweeper'
    },
    {
        'vendor': 'Strikingly, Inc.',
        'product': 'Strikingly'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe (Unspecified Product)'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe Atlas'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe Billing'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe Connect'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe Payments'
    },
    {
        'vendor': 'Stripe, Inc.',
        'product': 'Stripe Terminal'
    },
    {
        'vendor': 'Selligent, Inc.',
        'product': 'StrongView'
    },
    {
        'vendor': 'StructionSite, Inc.',
        'product': 'StructionSite'
    },
    {
        'vendor': 'StructuredWeb, Inc.',
        'product': 'StructuredWeb'
    },
    {
        'vendor': 'Quantcast Corporation',
        'product': 'Struq'
    },
    {
        'vendor': 'Schneider Electric SE',
        'product': 'StruxureWare'
    },
    {
        'vendor': 'Stryker Corporation',
        'product': 'Stryker'
    },
    {
        'vendor': 'Stryker Corporation',
        'product': 'Stryker Office PACS'
    },
    {
        'vendor': 'StudioPlus Software, LLC',
        'product': 'StudioPlus myStratus'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Stylus Studio'
    },
    {
        'vendor': 'Eltima IBC',
        'product': 'SublimeVideo'
    },
    {
        'vendor': 'Greenway Health, LLC',
        'product': 'SuccessEHS'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SuccessFactors'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SuccessFactors Learning'
    },
    {
        'vendor': 'SuccessWare, Inc.',
        'product': 'SuccessWare'
    },
    {
        'vendor': 'Sucuri, Inc.',
        'product': 'Sucuri'
    },
    {
        'vendor': 'Altice USA, Inc.',
        'product': 'Suddenlink'
    },
    {
        'vendor': 'SugarCRM, Inc.',
        'product': 'Sugar Sell'
    },
    {
        'vendor': 'SugarCRM, Inc.',
        'product': 'SugarCRM'
    },
    {
        'vendor': 'SugarSync, Inc.',
        'product': 'SugarSync'
    },
    {
        'vendor': 'Sugester Sp. z o.o.',
        'product': 'Sugester'
    },
    {
        'vendor': 'TeamSystem S.p.A.',
        'product': 'Suite Paghe'
    },
    {
        'vendor': 'SuiteCX, Inc.',
        'product': 'SuiteCX'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'SuiteSuccess Nonprofit'
    },
    {
        'vendor': 'SumAll, LLC',
        'product': 'SumAll'
    },
    {
        'vendor': 'SumTotal Systems, LLC',
        'product': 'SumTotal'
    },
    {
        'vendor': 'SumTotal Systems, LLC',
        'product': 'SumTotal Accero'
    },
    {
        'vendor': 'SumTotal Systems, LLC',
        'product': 'SumTotal Learn'
    },
    {
        'vendor': 'SumTotal Systems, LLC',
        'product': 'SumTotal Learning Management'
    },
    {
        'vendor': 'Softwood Technology',
        'product': 'Sumac CRM'
    },
    {
        'vendor': 'Cvent, Inc.',
        'product': 'SummitSync'
    },
    {
        'vendor': 'Sumo Logic, Inc.',
        'product': 'Sumo Logic'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Fire Server Systems'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Fire X4270'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Fire X4470'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Fire X4800'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Netra Server Systems'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun SPARC M-Series Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun SPARC T-Series Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun SeeBeyond'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Servers'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun StorEdge'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Storage 2500'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Storage 6140'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Storage 6180'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Storage 6540'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Storage 6580'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun Storage 6780'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun StorageTek 6140'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Sun x86 Server Systems'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'SunGard (Unspecified Product)'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'SunGard AdvancedRecovery'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'SunGard Global Plus'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'SunGard Investran'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'SunGard Loanet'
    },
    {
        'vendor': 'PowerSchool Group, LLC',
        'product': 'SunGard Plus 360'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'SunGard Relius'
    },
    {
        'vendor': 'SunTech Medical, Inc.',
        'product': 'SunTech Medical'
    },
    {
        'vendor': 'Sunbird',
        'product': 'Sunbird dcTrack'
    },
    {
        'vendor': 'Sungard Availability Services LP',
        'product': 'Sungard LDRPS'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'Sungard iWorks'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest (Unspecified Product)'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest Antrim'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest Blood Bank'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest FlexiRad'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest Flexilab'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest Laboratory'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest PowerPath'
    },
    {
        'vendor': 'Sunquest Information Systems, Inc.',
        'product': 'Sunquest Transfusion Manager'
    },
    {
        'vendor': 'Smooch Technologies ULC',
        'product': 'Sunshine Conversations'
    },
    {
        'vendor': 'Sunwave Health, Inc.',
        'product': 'Sunwave'
    },
    {
        'vendor': 'SupaDupa, Ltd.',
        'product': 'SupaDupa'
    },
    {
        'vendor': 'Super Micro Computer, Inc.',
        'product': 'Super Micro vSAN ReadyNodes'
    },
    {
        'vendor': 'Network Solutions, LLC',
        'product': 'SuperStats'
    },
    {
        'vendor': 'Supermetrics OY',
        'product': 'Supermetrics'
    },
    {
        'vendor': 'Super Micro Computer, Inc.',
        'product': 'Supermicro (Unspecified Product)'
    },
    {
        'vendor': 'Super Micro Computer, Inc.',
        'product': 'Supermicro Servers'
    },
    {
        'vendor': 'Super Micro Computer, Inc.',
        'product': 'Supermicro SuperBlade'
    },
    {
        'vendor': 'Super Micro Computer, Inc.',
        'product': 'Supermicro SuperServer'
    },
    {
        'vendor': 'Suplari, Inc.',
        'product': 'Suplari'
    },
    {
        'vendor': 'SupplyOn AG',
        'product': 'SupplyOn'
    },
    {
        'vendor': 'SuranceBay, LLC',
        'product': 'SuranceBay'
    },
    {
        'vendor': 'SureCloud, Ltd.',
        'product': 'SureCloud'
    },
    {
        'vendor': '42Gears Mobility Systems Pvt Ltd',
        'product': 'SureLock'
    },
    {
        'vendor': '42Gears Mobility Systems Pvt Ltd',
        'product': 'SureMDM'
    },
    {
        'vendor': 'Paychex, Inc.',
        'product': 'SurePayroll'
    },
    {
        'vendor': 'Surescripts, LLC',
        'product': 'Surescripts'
    },
    {
        'vendor': 'Change Healthcare, Inc.',
        'product': 'SurgiServer'
    },
    {
        'vendor': 'Surgical Information Systems, LLC',
        'product': 'SurgiSource'
    },
    {
        'vendor': 'Surgical Information Systems, LLC',
        'product': 'Surgical Information Systems'
    },
    {
        'vendor': 'Open Source',
        'product': 'Suricata'
    },
    {
        'vendor': 'Survalent Technology Corporation',
        'product': 'Survalent'
    },
    {
        'vendor': 'Survey Crafter, Inc.',
        'product': 'Survey Crafter'
    },
    {
        'vendor': 'SurveyGizmo, LLC',
        'product': 'SurveyGizmo'
    },
    {
        'vendor': 'Golden Hills Software, Inc.',
        'product': 'SurveyGold'
    },
    {
        'vendor': 'SurveyMonkey, Inc.',
        'product': 'SurveyMonkey'
    },
    {
        'vendor': 'Apian Software, Inc.',
        'product': 'SurveyPro'
    },
    {
        'vendor': 'Research Tools, Inc.',
        'product': 'SurveyShare'
    },
    {
        'vendor': 'SCANTRON Corporation',
        'product': 'SurveyTracker'
    },
    {
        'vendor': 'SutiSoft, Inc.',
        'product': 'SutiExpense'
    },
    {
        'vendor': 'Yotpo, Inc.',
        'product': 'Swell Rewards'
    },
    {
        'vendor': 'Rave Mobile Safety, Inc.',
        'product': 'SwiftK12'
    },
    {
        'vendor': 'SwiftReach Networks, Inc.',
        'product': 'SwiftReach'
    },
    {
        'vendor': 'SwiftStack',
        'product': 'SwiftStack'
    },
    {
        'vendor': 'Swiftpage ACT!, LLC',
        'product': 'Swiftpage'
    },
    {
        'vendor': 'Swiftpage ACT!, LLC',
        'product': 'Swiftpage ACT!'
    },
    {
        'vendor': 'Swiftype, Inc.',
        'product': 'Swiftype'
    },
    {
        'vendor': 'Swile SAS',
        'product': 'Swile'
    },
    {
        'vendor': 'Swimlane, LLC',
        'product': 'Swimlane'
    },
    {
        'vendor': 'SwipeClock, LLC',
        'product': 'SwipeClock'
    },
    {
        'vendor': 'Swisscom, Ltd.',
        'product': 'Swisscom'
    },
    {
        'vendor': 'Swisslog Holding AG',
        'product': 'Swisslog'
    },
    {
        'vendor': 'Sangoma Technologies Corporation',
        'product': 'Switchvox'
    },
    {
        'vendor': 'Swoogo, Inc.',
        'product': 'Swoogo'
    },
    {
        'vendor': 'Sword GRC Group, Ltd.',
        'product': 'Sword Active Risk Manager'
    },
    {
        'vendor': 'Sword GRC Group, Ltd.',
        'product': 'Sword GRC'
    },
    {
        'vendor': 'Swrve, Inc.',
        'product': 'Swrve'
    },
    {
        'vendor': 'DialogTech, Inc.',
        'product': 'Swydo'
    },
    {
        'vendor': 'Syflex, LLC',
        'product': 'SyFlex'
    },
    {
        'vendor': 'Syapse, Inc.',
        'product': 'Syapse'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Advanced Threat Protection'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Altiris'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Altiris Patch Management Solution'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Asset Management Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Athena'
    },
    {
        'vendor': 'Symantec Corporation',
        'product': 'Symantec Clearwell'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Client Management Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Cloud Workload Protection'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Critical System Protection'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Data Center Security'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Data Center Security: Server Advanced'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Data Loss Prevention'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Deployment Solution'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Email Security.cloud'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec End-user Endpoint Security'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Endpoint Detection & Response'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Endpoint Encryption'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Endpoint Management'
    },
    {
        'vendor': 'Symantec Corporation',
        'product': 'Symantec Endpoint Protection'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Endpoint Protection Mobile'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Endpoint Security Enterprise'
    },
    {
        'vendor': 'Symantec Corporation',
        'product': 'Symantec Enterprise Vault'
    },
    {
        'vendor': 'Symantec Corporation',
        'product': 'Symantec IT Management Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Integrated Cyber Defense'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Messaging Gateway'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Network Access Control'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec PGP'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Privileged Access Management'
    },
    {
        'vendor': 'Symantec Corporation',
        'product': 'Symantec SSL'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Secure Web Gateway'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Server Management Suite'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec ServiceDesk'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec SiteMinder'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec VIP Enterprise'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Vulnerability Response'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Web Security Service'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Symbian'
    },
    {
        'vendor': 'Symfony SAS',
        'product': 'Symfony'
    },
    {
        'vendor': 'Jack Henry & Associates, Inc.',
        'product': 'Symitar'
    },
    {
        'vendor': 'Symmetry Corporation',
        'product': 'Symmetry'
    },
    {
        'vendor': 'AMAG Technology, Inc.',
        'product': 'Symmetry Security Platform'
    },
    {
        'vendor': 'Symphony Retail Solutions',
        'product': 'Symphony RetailAI'
    },
    {
        'vendor': 'Summit Software, Inc.',
        'product': 'Symphony SummitAI'
    },
    {
        'vendor': 'Symphony Talent, LLC',
        'product': 'Symphony Talent'
    },
    {
        'vendor': 'SymphonyCare, LLC',
        'product': 'SymphonyCare Empower'
    },
    {
        'vendor': 'Sympli, LLC',
        'product': 'Sympli'
    },
    {
        'vendor': 'Symprex, Ltd.',
        'product': 'Symprex'
    },
    {
        'vendor': 'Sabre GLBL, Inc.',
        'product': 'SynXis Central Reservations'
    },
    {
        'vendor': 'Sabre GLBL, Inc.',
        'product': 'SynXis Voice Agent'
    },
    {
        'vendor': 'Synack, Inc.',
        'product': 'Synack'
    },
    {
        'vendor': 'Synapse Financial Technologies, Inc.',
        'product': 'SynapseFi'
    },
    {
        'vendor': 'Synaptica, LLC',
        'product': 'Synaptica'
    },
    {
        'vendor': 'Synaptris, Inc.',
        'product': 'Synaptris'
    },
    {
        'vendor': '2BrightSparks Pte Ltd',
        'product': 'SyncBackPro'
    },
    {
        'vendor': 'Syncfusion, Inc.',
        'product': 'Syncfusion'
    },
    {
        'vendor': 'Axway, Inc.',
        'product': 'Syncplicity Collaboration'
    },
    {
        'vendor': 'Syncron AB',
        'product': 'Syncron (Unspecified Product)'
    },
    {
        'vendor': 'Syncsort, Inc.',
        'product': 'Syncsort'
    },
    {
        'vendor': 'SynerTrade, Inc.',
        'product': 'SynerTrade'
    },
    {
        'vendor': 'SynerTrade, Inc.',
        'product': 'SynerTrade Supplier Management'
    },
    {
        'vendor': 'Syniti',
        'product': 'Syniti'
    },
    {
        'vendor': 'Syniverse Technologies, LLC',
        'product': 'Syniverse'
    },
    {
        'vendor': 'Synology, Inc.',
        'product': 'Synology (Unspecified Product)'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys (Unspecified Product)'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys Avalon'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys CATS'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys CODE V'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys CustomSim'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys FineSim'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys HAPS'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys HSPICE'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys LightTools'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys NanoTime'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys Odyssey'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys PrimePower'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys PrimeTime'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys Simpleware'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys TCAD'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys VC Formal'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys VCS'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys VIP'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys Verdi'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys Yield Explorer'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synopsys ZeBu Server'
    },
    {
        'vendor': 'Synopsys, Inc.',
        'product': 'Synplify'
    },
    {
        'vendor': 'Kaufman Hall & Associates, LLC',
        'product': 'Syntellis'
    },
    {
        'vendor': 'Syntermed, Inc.',
        'product': 'Syntermed'
    },
    {
        'vendor': 'Andersson Technologies, LLC',
        'product': 'SynthEyes'
    },
    {
        'vendor': 'Synthesio, Inc.',
        'product': 'Synthesio'
    },
    {
        'vendor': 'Synthio, Inc.',
        'product': 'Synthio'
    },
    {
        'vendor': 'Synygy, Inc.',
        'product': 'Synygy'
    },
    {
        'vendor': 'SysAid Technologies',
        'product': 'SysAid'
    },
    {
        'vendor': 'Lakeside Software, LLC',
        'product': 'SysTrack'
    },
    {
        'vendor': 'Sysdig, Inc.',
        'product': 'Sysdig'
    },
    {
        'vendor': 'Sysmex America, Inc.',
        'product': 'Sysmex'
    },
    {
        'vendor': 'Sysomos, Inc.',
        'product': 'Sysomos'
    },
    {
        'vendor': 'Keysight Technologies, Inc.',
        'product': 'SystemVue'
    },
    {
        'vendor': 'Systemedx, Inc.',
        'product': 'Systemedx'
    },
    {
        'vendor': 'Systemware, Inc.',
        'product': 'Systemware'
    },
    {
        'vendor': 'The Phoenix Partnership, Ltd.',
        'product': 'SystmOne'
    },
    {
        'vendor': 'T-System, Inc.',
        'product': 'T SystemEV'
    },
    {
        'vendor': 'Temenos Headquarters S.A.',
        'product': 'T24'
    },
    {
        'vendor': 'Global Public Safety',
        'product': 'TAC.10'
    },
    {
        'vendor': 'TALAIA OpenPPM',
        'product': 'TALAIA OpenPPM'
    },
    {
        'vendor': 'Targit',
        'product': 'TARGIT Decision Suite'
    },
    {
        'vendor': 'TC Software',
        'product': 'TC Software ConnectMate'
    },
    {
        'vendor': 'Teledata Communications, Inc.',
        'product': 'TCI DecisionLender'
    },
    {
        'vendor': 'TCPWave, Inc.',
        'product': 'TCPWave'
    },
    {
        'vendor': 'Tata Consultancy Services, Ltd.',
        'product': 'TCS BaNCS'
    },
    {
        'vendor': 'Tata Consultancy Services, Ltd.',
        'product': 'TCS MasterCraft'
    },
    {
        'vendor': 'Tata Consultancy Services, Ltd.',
        'product': 'TCS iON'
    },
    {
        'vendor': 'TELESYNERGY',
        'product': 'TELESYNERGY'
    },
    {
        'vendor': 'TENA Companies, Inc.',
        'product': 'TENA'
    },
    {
        'vendor': 'Open Source',
        'product': 'TFLearn'
    },
    {
        'vendor': 'THEO Technologies, Inc.',
        'product': 'THEOplayer'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO (Unspecified Product)'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix BusinessWorks'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix Decisions'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix Policy Director'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix Service Bus'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix Service Gateway'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveMatrix Service Grid'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveSpaces'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO ActiveSpaces Transactions'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Adapter'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Business Studio'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO BusinessConnect'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO BusinessEvents'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO BusinessWorks ProcessMonitor'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Clarity'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Cloud Nimbus'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Collaborative Information Manager'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Data Virtualization'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO DataSynapse GridServer'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Designer'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO EBX'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Enterprise Message Service'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Enterprise Message Service 8.3'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Enterprise Message Service 8.4'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO FTL'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Foresight'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Formvine'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Hawk'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Jaspersoft'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO KPSA'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Loyalty Lab'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO MDM Analytics'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Managed File Transfer'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Mashery'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Netrics'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO OpenSpirit'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Patterns'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO PortalBuilder'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Rendezvous'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Service Performance Manager'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Silver Fabric'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Slingshot'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Spotfire'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Statistica'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Substation ES'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO iProcess'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO tibbr'
    },
    {
        'vendor': 'TIE Kinetix N.V.',
        'product': 'TIE Kinetix'
    },
    {
        'vendor': 'C.H. Robinson Worldwide, Inc.',
        'product': 'TMC'
    },
    {
        'vendor': 'TMF Group B.V.',
        'product': 'TMF HR & Payroll'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'TMW TMS'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'TOA Technologies'
    },
    {
        'vendor': 'TOPS Software',
        'product': 'TOPS [ONE]'
    },
    {
        'vendor': 'TOPdesk USA, Inc.',
        'product': 'TOPdesk'
    },
    {
        'vendor': 'TOTVS S.A.',
        'product': 'TOTVS ERP'
    },
    {
        'vendor': 'TOTVS S.A.',
        'product': 'TOTVS Fluig'
    },
    {
        'vendor': 'TOTVS S.A.',
        'product': 'TOTVS HR'
    },
    {
        'vendor': 'TPx Communications',
        'product': 'TPx'
    },
    {
        'vendor': 'Transverse, LLC',
        'product': 'TRACT'
    },
    {
        'vendor': 'NEMO Health',
        'product': 'TRAKnet'
    },
    {
        'vendor': 'Open Systems, Inc.',
        'product': 'TRAVERSE ERP'
    },
    {
        'vendor': 'TRIARQ Health, LLC',
        'product': 'TRIARQ EHR/PM'
    },
    {
        'vendor': 'TRUSTe',
        'product': 'TRUSTe'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'TSheets'
    },
    {
        'vendor': 'TV Squared, Ltd.',
        'product': 'TVSquared'
    },
    {
        'vendor': 'TYPO3 Association',
        'product': 'TYPO3'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Bridge'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Desktop'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Embedded Analytics'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Online'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Prep'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Prep Conductor'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Public'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Server'
    },
    {
        'vendor': 'Taboola, Inc.',
        'product': 'Taboola'
    },
    {
        'vendor': 'EclipseSource',
        'product': 'Tabris.js'
    },
    {
        'vendor': 'Software Technology, LLC',
        'product': 'Tabs3'
    },
    {
        'vendor': 'Tacton Systems AB',
        'product': 'Tacton'
    },
    {
        'vendor': 'TagBoard, Inc.',
        'product': 'TagBoard'
    },
    {
        'vendor': 'Fjord Technologies SAS',
        'product': 'TagCommander'
    },
    {
        'vendor': 'Ensighten, Inc.',
        'product': 'TagMan'
    },
    {
        'vendor': 'Tagetik Software S.R.L.',
        'product': 'Tagetik'
    },
    {
        'vendor': 'Tagger Media, LLC',
        'product': 'Tagger'
    },
    {
        'vendor': 'Curly Technologies, LLC',
        'product': 'Tagtray'
    },
    {
        'vendor': 'Tait International, Ltd.',
        'product': 'Tait Communications'
    },
    {
        'vendor': 'Take Care Health',
        'product': 'Take Care Health'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Talari Aware'
    },
    {
        'vendor': 'Jobvite, Inc.',
        'product': 'Talemetry'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend Data Catalog'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend Data Fabric'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend Data Integration'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend Data Preparation'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend Open Studio for Data Quality'
    },
    {
        'vendor': 'CEIPAL Corporation',
        'product': 'TalentHire'
    },
    {
        'vendor': 'Epignosis, LLC',
        'product': 'TalentLMS'
    },
    {
        'vendor': 'Talentia Software Group',
        'product': 'Talentia Software'
    },
    {
        'vendor': 'Talentsoft',
        'product': 'Talentsoft'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo (Unspecified Product)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Analytics'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Applicant Tracking Systems (ATS)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Business Edition'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Cloud Service'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Compensation'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Connect'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Enterprise'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Learning Management System (LMS)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Onboard'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Onboarding'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Perform'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Performance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Recruit'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Taleo Recruiting'
    },
    {
        'vendor': 'Talisma Corporation Pvt Ltd',
        'product': 'Talisma'
    },
    {
        'vendor': 'Talisma Corporation Pvt Ltd',
        'product': 'Talisma CRM'
    },
    {
        'vendor': 'Talisma Corporation Pvt Ltd',
        'product': 'Talisma Fundraising'
    },
    {
        'vendor': 'Talk Technologies, Inc.',
        'product': 'Talk Technologies'
    },
    {
        'vendor': 'Talkable, Inc.',
        'product': 'Talkable'
    },
    {
        'vendor': 'Talkdesk, Inc.',
        'product': 'Talkdesk'
    },
    {
        'vendor': 'Beijing Tendcloud Tianxia Technology Company, Ltd.',
        'product': 'TalkingData'
    },
    {
        'vendor': 'Talkwalker, Inc.',
        'product': 'Talkwalker'
    },
    {
        'vendor': 'Tally Solutions Pvt Ltd',
        'product': 'Tally.ERP 9'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'Talon FAST'
    },
    {
        'vendor': 'Swisslog Healthcare AG',
        'product': 'Talyst'
    },
    {
        'vendor': 'Tamarac, Inc.',
        'product': 'Tamarac'
    },
    {
        'vendor': 'Tandberg Data',
        'product': 'Tandberg Data'
    },
    {
        'vendor': 'Tango Card, Inc.',
        'product': 'Tango Card'
    },
    {
        'vendor': 'Tangoe, Inc.',
        'product': 'Tangoe (Unspecified Product)'
    },
    {
        'vendor': 'Tangoe, Inc.',
        'product': 'Tangoe Expense Management'
    },
    {
        'vendor': 'Tanium, Inc.',
        'product': 'Tanium'
    },
    {
        'vendor': 'Tanium, Inc.',
        'product': 'Tanium Protect'
    },
    {
        'vendor': 'Tantalus Systems Corporation',
        'product': 'Tantalus Systems'
    },
    {
        'vendor': 'TapClicks, Inc.',
        'product': 'TapClicks'
    },
    {
        'vendor': 'TapInfluence',
        'product': 'TapInfluence'
    },
    {
        'vendor': 'Tapjoy, Inc.',
        'product': 'Tapjoy'
    },
    {
        'vendor': 'Taplytics, Inc.',
        'product': 'Taplytics'
    },
    {
        'vendor': 'Tapsense',
        'product': 'Tapsense'
    },
    {
        'vendor': 'Target2Sell',
        'product': 'Target2Sell'
    },
    {
        'vendor': 'Targetbase',
        'product': 'TargetBase'
    },
    {
        'vendor': 'Targetprocess Cyprus, Ltd.',
        'product': 'TargetProcess'
    },
    {
        'vendor': 'TargetRecruit, LLC',
        'product': 'TargetRecruit'
    },
    {
        'vendor': 'TargetX, LLC',
        'product': 'TargetX'
    },
    {
        'vendor': 'Tasktop Technologies, Inc.',
        'product': 'Tasktop'
    },
    {
        'vendor': 'Taskworld, Inc.',
        'product': 'Taskworld'
    },
    {
        'vendor': 'tastyworks, Inc.',
        'product': 'Tastyworks'
    },
    {
        'vendor': 'Tata Communications, Ltd.',
        'product': 'Tata Communications (Unspecified Product)'
    },
    {
        'vendor': 'Tatvic Analytics Pvt Ltd',
        'product': 'Tatvic'
    },
    {
        'vendor': 'Taulia, Inc.',
        'product': 'Taulia'
    },
    {
        'vendor': 'TPS Unlimited, Inc.',
        'product': 'TaxJar'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'TaxWise'
    },
    {
        'vendor': 'Taxamo',
        'product': 'Taxamo'
    },
    {
        'vendor': 'Taxdoo GmbH',
        'product': 'Taxdoo'
    },
    {
        'vendor': 'Tealium, Inc.',
        'product': 'Tealium'
    },
    {
        'vendor': 'Ulrich Medical Concepts',
        'product': 'Team Chart Concept'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'TeamCity'
    },
    {
        'vendor': 'Mitratech Holdings, Inc.',
        'product': 'TeamConnect'
    },
    {
        'vendor': 'TeamDynamix',
        'product': 'TeamDynamix'
    },
    {
        'vendor': 'TeamGantt, LLC',
        'product': 'TeamGantt'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'TeamMate Audit'
    },
    {
        'vendor': 'TeamSupport, LLC',
        'product': 'TeamSupport'
    },
    {
        'vendor': 'TeamViewer GmbH',
        'product': 'TeamViewer'
    },
    {
        'vendor': 'TeamWox',
        'product': 'TeamWox'
    },
    {
        'vendor': 'Teamgate, Ltd.',
        'product': 'Teamgate CRM'
    },
    {
        'vendor': 'Team Labs, Inc.',
        'product': 'Teampay'
    },
    {
        'vendor': 'Teamwork.com, Ltd.',
        'product': 'Teamwork Desk'
    },
    {
        'vendor': 'Teamwork.com, Ltd.',
        'product': 'Teamwork.com (Unspecified Product)'
    },
    {
        'vendor': 'Teapplix, Inc.',
        'product': 'Teapplix'
    },
    {
        'vendor': 'Tebis Technische Informationssysteme AG',
        'product': 'Tebis'
    },
    {
        'vendor': 'TechExcel, Inc.',
        'product': 'TechExcel'
    },
    {
        'vendor': 'TechRadium, Inc.',
        'product': 'TechRadium'
    },
    {
        'vendor': 'TechSmith Corporation',
        'product': 'TechSmith Camtasia'
    },
    {
        'vendor': 'TechTarget, Inc.',
        'product': 'TechTarget Priority Engine'
    },
    {
        'vendor': 'TechnologyOne, Ltd.',
        'product': 'TechnologyOne'
    },
    {
        'vendor': 'Technolutions',
        'product': 'Technolutions Slate'
    },
    {
        'vendor': 'Synacor, Inc.',
        'product': 'Technorati'
    },
    {
        'vendor': 'Siemens Industry Software, Inc.',
        'product': 'Tecnomatix'
    },
    {
        'vendor': 'Tecsys, Inc.',
        'product': 'Tecsys'
    },
    {
        'vendor': 'Tecsys, Inc.',
        'product': 'Tecsys Warehouse Management'
    },
    {
        'vendor': 'TekTone Sound & Signal Manufacturing, Inc.',
        'product': 'TekTone'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Tekla'
    },
    {
        'vendor': 'TelVue Corporation',
        'product': 'TelVue'
    },
    {
        'vendor': 'Teladoc Health, Inc.',
        'product': 'Teladoc'
    },
    {
        'vendor': 'Teladoc Health, Inc.',
        'product': 'Teladoc Health'
    },
    {
        'vendor': 'TELCOR, Inc.',
        'product': 'Telcor'
    },
    {
        'vendor': 'Resource Dynamics',
        'product': 'Tele-Support HelpDesk'
    },
    {
        'vendor': 'TelePayroll, Inc.',
        'product': 'TelePayroll'
    },
    {
        'vendor': 'TeleSign Corporation',
        'product': 'TeleSign'
    },
    {
        'vendor': 'TeleTracking Technologies, Inc.',
        'product': 'TeleTracking'
    },
    {
        'vendor': 'Intrado Corporation',
        'product': 'TeleVox'
    },
    {
        'vendor': 'Telecor, Inc.',
        'product': 'Telecor (Unspecified Product)'
    },
    {
        'vendor': 'Teleflex, Inc.',
        'product': 'Teleflex Voldyne'
    },
    {
        'vendor': 'Telefonica S.A.',
        'product': 'Telefonica IoT'
    },
    {
        'vendor': 'InfluxData, Inc.',
        'product': 'Telegraf'
    },
    {
        'vendor': 'AMD Global Telemedicine, Inc.',
        'product': 'Telemedicine Encounter Management Software'
    },
    {
        'vendor': 'Telemis S.A.',
        'product': 'Telemis PACS'
    },
    {
        'vendor': 'Telenor Connexion AB',
        'product': 'Telenor Connexion (IoT)'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'Telerik'
    },
    {
        'vendor': 'MDSL',
        'product': 'Telesoft'
    },
    {
        'vendor': 'Teletrac Navman US, Ltd.',
        'product': 'Teletrac Navman'
    },
    {
        'vendor': 'Telia Company AB',
        'product': 'TeliaSonera'
    },
    {
        'vendor': 'Tellabs',
        'product': 'Tellabs'
    },
    {
        'vendor': 'Telligent, Inc.',
        'product': 'Telligent Community'
    },
    {
        'vendor': 'Tellius, Inc.',
        'product': 'Tellius'
    },
    {
        'vendor': '24/7 Customer, Inc.',
        'product': 'Tellme Networks'
    },
    {
        'vendor': 'Telmetrics Corporation',
        'product': 'Telmetrics'
    },
    {
        'vendor': 'Telnyx, LLC',
        'product': 'Telnyx (Unspecified Product)'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Telogis'
    },
    {
        'vendor': 'Arreva, LLC',
        'product': 'Telosa'
    },
    {
        'vendor': 'Telstar S.L.',
        'product': 'Telstar Aeolus'
    },
    {
        'vendor': 'Telstra Corporation, Ltd.',
        'product': 'Telstra'
    },
    {
        'vendor': 'Telstra Corporation, Ltd.',
        'product': 'Telstra with nbn'
    },
    {
        'vendor': 'Quadient Group AG',
        'product': 'Temando'
    },
    {
        'vendor': 'Temenos Headquarters S.A.',
        'product': 'Temenos'
    },
    {
        'vendor': 'Temenos Headquarters S.A.',
        'product': 'Temenos Quantum'
    },
    {
        'vendor': 'Temenos Headquarters S.A.',
        'product': 'Temenos Transact'
    },
    {
        'vendor': 'Templafy ApS',
        'product': 'Templafy'
    },
    {
        'vendor': 'Temporal Technologies, Inc.',
        'product': 'Temporal'
    },
    {
        'vendor': 'Tenable, Inc.',
        'product': 'Tenable Nessus'
    },
    {
        'vendor': 'Tenable Network Security, Inc.',
        'product': 'Tenable Network Security'
    },
    {
        'vendor': 'Tenable, Inc.',
        'product': 'Tenable.io'
    },
    {
        'vendor': 'Tenable, Inc.',
        'product': 'Tenable.ot'
    },
    {
        'vendor': 'Tenable, Inc.',
        'product': 'Tenable.sc'
    },
    {
        'vendor': 'Tenant File',
        'product': 'Tenant File'
    },
    {
        'vendor': 'Tenant Turner, Inc.',
        'product': 'Tenant Turner'
    },
    {
        'vendor': 'TenantCloud',
        'product': 'TenantCloud'
    },
    {
        'vendor': 'Tencent Holdings, Ltd.',
        'product': 'Tencent Cloud'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'TensorFlow'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'TensorFlow on AWS'
    },
    {
        'vendor': 'FUJIFILM Corporation',
        'product': 'TeraMedica'
    },
    {
        'vendor': 'TeraRecon, Inc',
        'product': 'TeraRecon'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Aster'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata CDM'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata CRM'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Data Appliance'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Database'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Decision Experts'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Dual Active'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Integrated Data Warehouses'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Marketing'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Unity'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Value Analyzer'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Vantage'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Vantage for VMware'
    },
    {
        'vendor': 'Teradata Corporation',
        'product': 'Teradata Viewpoint'
    },
    {
        'vendor': 'Teradici Corporation',
        'product': 'Teradici'
    },
    {
        'vendor': 'Teramind, Inc.',
        'product': 'Teramind'
    },
    {
        'vendor': 'eBay, Inc.',
        'product': 'Terapeak'
    },
    {
        'vendor': 'Terminalfour Solutions, Ltd.',
        'product': 'Terminalfour'
    },
    {
        'vendor': 'Terminus Software, Inc.',
        'product': 'Terminus'
    },
    {
        'vendor': 'Terminus Software, Inc.',
        'product': 'Terminus Account Hub'
    },
    {
        'vendor': 'TerraSky, Inc.',
        'product': 'TerraSky'
    },
    {
        'vendor': 'Software AG',
        'product': 'Terracotta BigMemory'
    },
    {
        'vendor': 'Software AG',
        'product': 'Terracotta Ehcache'
    },
    {
        'vendor': 'Gruntwork, Inc.',
        'product': 'Terragrunt'
    },
    {
        'vendor': 'Equinix, Inc.',
        'product': 'Terremark'
    },
    {
        'vendor': 'Terumo Medical Corporation',
        'product': 'Terumo'
    },
    {
        'vendor': 'Tesia Clearinghouse, LLC',
        'product': 'Tesia'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Test Data Manager'
    },
    {
        'vendor': 'Developer Express, Inc.',
        'product': 'TestCafe'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'TestComplete'
    },
    {
        'vendor': 'Open Source',
        'product': 'TestNG'
    },
    {
        'vendor': 'Gurock Software GmbH',
        'product': 'TestRail'
    },
    {
        'vendor': 'Testbirds GmbH',
        'product': 'Testbirds'
    },
    {
        'vendor': 'Testingbot',
        'product': 'Testingbot'
    },
    {
        'vendor': 'Tethr',
        'product': 'Tethr'
    },
    {
        'vendor': 'Tevron, LLC',
        'product': 'Tevron'
    },
    {
        'vendor': 'Texada Software, Inc.',
        'product': 'Texada'
    },
    {
        'vendor': 'Text IQ, Inc.',
        'product': 'Text IQ'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Textura'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Thales'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Thales HSM'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Thales payShield'
    },
    {
        'vendor': 'Thawte',
        'product': 'Thawte'
    },
    {
        'vendor': 'The HR Manager, LLC',
        'product': 'The Applicant Manager'
    },
    {
        'vendor': 'The Bug Genie',
        'product': 'The Bug Genie'
    },
    {
        'vendor': 'TPG Software, Inc.',
        'product': 'The Portfolio Genius'
    },
    {
        'vendor': 'The Trade Desk',
        'product': 'The Trade Desk'
    },
    {
        'vendor': 'Equifax, Inc.',
        'product': 'The Work Number'
    },
    {
        'vendor': 'Comcast Cable Communications Management',
        'product': 'ThePlatform'
    },
    {
        'vendor': 'Open Source',
        'product': 'Theano'
    },
    {
        'vendor': 'Trisoft, Ltd.',
        'product': 'TheatreMan'
    },
    {
        'vendor': 'Thecus Technology Corporation',
        'product': 'Thecus'
    },
    {
        'vendor': 'TherAssist',
        'product': 'TherAssist'
    },
    {
        'vendor': 'Premier, Inc.',
        'product': 'TheraDoc'
    },
    {
        'vendor': 'TheraManager, LLC',
        'product': 'TheraManager'
    },
    {
        'vendor': 'TheraNest, LLC',
        'product': 'TheraNest'
    },
    {
        'vendor': 'Hands On Technology, Inc.',
        'product': 'TheraOffice'
    },
    {
        'vendor': 'WebPT, Inc.',
        'product': 'Therabill'
    },
    {
        'vendor': 'TherapyNotes, LLC',
        'product': 'TherapyNotes'
    },
    {
        'vendor': 'Thermoflow, Inc.',
        'product': 'Thermoflow'
    },
    {
        'vendor': 'Theronyx',
        'product': 'Theronyx'
    },
    {
        'vendor': 'Cody Lindley',
        'product': 'ThickBox'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'ThingSpace'
    },
    {
        'vendor': 'The MathWorks, Inc.',
        'product': 'ThingSpeak'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'ThinkAgile HX-Series'
    },
    {
        'vendor': 'Lenovo Group, Ltd.',
        'product': 'ThinkAgile VX-Series'
    },
    {
        'vendor': 'Group Systems Corporation',
        'product': 'ThinkTank'
    },
    {
        'vendor': 'ThinkTime, LLC',
        'product': 'ThinkTime'
    },
    {
        'vendor': 'Colt Technology Services Group, Ltd.',
        'product': 'Thinkgrid'
    },
    {
        'vendor': 'Thinkific, Inc.',
        'product': 'Thinkific'
    },
    {
        'vendor': 'Cortado Mobile Solutions GmbH',
        'product': 'Thinprint'
    },
    {
        'vendor': 'Third Light, Ltd.',
        'product': 'Third Light'
    },
    {
        'vendor': 'Thismoment, Inc.',
        'product': 'Thismoment'
    },
    {
        'vendor': 'Thomas Publishing Company',
        'product': 'Thomas WebTrax'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson MarkMonitor'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters (Unspecified Product)'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters Case Logistix'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters Elite'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters Firm Central'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters GoFileRoom'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters Legal Tracker'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters LiveNote Stream'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters ONESOURCE'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters ONESOURCE Certificate Manager'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters OneSource Determination'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters OneSource Indirect Tax Compliance'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters ProLaw'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters Westlaw'
    },
    {
        'vendor': 'Thought Industries, Inc.',
        'product': 'Thought Industries Learning Business Platform'
    },
    {
        'vendor': 'ThoughtSpot, Inc.',
        'product': 'ThoughtSpot'
    },
    {
        'vendor': 'ThousandEyes, Inc.',
        'product': 'ThousandEyes'
    },
    {
        'vendor': 'Denim Group, Ltd.',
        'product': 'ThreadFix'
    },
    {
        'vendor': 'Threat Stack, Inc.',
        'product': 'Threat Stack'
    },
    {
        'vendor': 'ThreatConnect, Inc.',
        'product': 'ThreatConnect'
    },
    {
        'vendor': 'LexisNexis Risk Solutions, Inc.',
        'product': 'ThreatMetrix'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'ThreatSim'
    },
    {
        'vendor': 'Evident, LLC',
        'product': 'Thrive EHR'
    },
    {
        'vendor': 'ThriveHive, Inc.',
        'product': 'ThriveHive'
    },
    {
        'vendor': 'Thryv, Inc.',
        'product': 'Thryv'
    },
    {
        'vendor': 'Hitachi Vantara, LLC',
        'product': 'Thunder 9500 V Series Storage System'
    },
    {
        'vendor': 'ThunderCat Technologies',
        'product': 'ThunderCat Technologies'
    },
    {
        'vendor': 'Thunderhead, Ltd.',
        'product': 'Thunderhead'
    },
    {
        'vendor': 'Thycotic Software, LLC',
        'product': 'Thycotic Secret Server'
    },
    {
        'vendor': 'InfluxData, Inc.',
        'product': 'Tick Stack'
    },
    {
        'vendor': 'TicketLeap',
        'product': 'TicketLeap'
    },
    {
        'vendor': 'TicketWeb, LLC',
        'product': 'TicketWeb'
    },
    {
        'vendor': 'Shopify, Inc.',
        'product': 'Tictail'
    },
    {
        'vendor': 'Aspiro AB',
        'product': 'Tidal'
    },
    {
        'vendor': 'Tidal Software, LLC',
        'product': 'Tidal Automation'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Tidal Software'
    },
    {
        'vendor': 'Insightsoftware, Inc.',
        'product': 'Tidemark'
    },
    {
        'vendor': 'Tidio, LLC',
        'product': 'Tidio'
    },
    {
        'vendor': 'LinkedStore Argentina S.R.L.',
        'product': 'Tiendanube'
    },
    {
        'vendor': 'TierPoint, LLC',
        'product': 'TierPoint (Unspecified Product)'
    },
    {
        'vendor': 'Tiger Analytics, LLC',
        'product': 'Tiger Analytics'
    },
    {
        'vendor': 'Tiger Technology',
        'product': 'Tiger Technology metaSAN'
    },
    {
        'vendor': 'TigerGraph, Inc.',
        'product': 'TigerGraph'
    },
    {
        'vendor': 'TigerConnect, Inc.',
        'product': 'TigerText'
    },
    {
        'vendor': 'Tigerpaw Software, Inc.',
        'product': 'Tigerpaw Software'
    },
    {
        'vendor': 'Tilkee',
        'product': 'Tilkee'
    },
    {
        'vendor': 'Timber, Inc.',
        'product': 'Timber.io Vector'
    },
    {
        'vendor': 'TimeCamp, Inc.',
        'product': 'TimeCamp'
    },
    {
        'vendor': 'TimeCenter AB',
        'product': 'TimeCentre'
    },
    {
        'vendor': 'TimeClock Plus, LLC',
        'product': 'TimeClock Plus'
    },
    {
        'vendor': 'Heuristic Management Systems, Inc.',
        'product': 'TimeControl'
    },
    {
        'vendor': 'TimeIPS, Inc.',
        'product': 'TimeIPS'
    },
    {
        'vendor': 'TimeTrak Systems, Inc.',
        'product': 'TimeTrak'
    },
    {
        'vendor': 'Blue Yonder, Inc.',
        'product': 'Timera'
    },
    {
        'vendor': 'Times Software Pte Ltd',
        'product': 'Times Software'
    },
    {
        'vendor': 'Timescale, Inc.',
        'product': 'Timescale'
    },
    {
        'vendor': 'Timeware',
        'product': 'Timeware Primetime'
    },
    {
        'vendor': 'Tint',
        'product': 'Tint'
    },
    {
        'vendor': 'Tintri, Inc.',
        'product': 'Tintri'
    },
    {
        'vendor': 'Century Software, Inc.',
        'product': 'TinyTERM Plus'
    },
    {
        'vendor': 'Tipalti',
        'product': 'Tipalti'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'TippingPoint'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'TippingPoint S5100N'
    },
    {
        'vendor': 'ASA Automotive Systems, Inc.',
        'product': 'TireMaster'
    },
    {
        'vendor': 'Northwoods Software, Inc.',
        'product': 'Titan CMS'
    },
    {
        'vendor': 'Team Tito, Ltd.',
        'product': 'Tito'
    },
    {
        'vendor': 'Titus, Inc.',
        'product': 'Titus'
    },
    {
        'vendor': 'TmaxSoft, Inc.',
        'product': 'Tmax'
    },
    {
        'vendor': 'Toast, Inc.',
        'product': 'Toast'
    },
    {
        'vendor': 'Doist, Inc.',
        'product': 'Todoist'
    },
    {
        'vendor': 'Tofino Software',
        'product': 'Tofino'
    },
    {
        'vendor': 'Toggle, Inc.',
        'product': 'Toggl'
    },
    {
        'vendor': 'TomTec Imaging',
        'product': 'TomTec Imaging'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Tomax'
    },
    {
        'vendor': 'Toon Boom',
        'product': 'Toon Boom Harmony'
    },
    {
        'vendor': 'Top Producer Systems Company ULC',
        'product': 'TopProducer'
    },
    {
        'vendor': 'Missler Software S.A.',
        'product': 'TopSolid\'Cam'
    },
    {
        'vendor': 'Topaz Labs, LLC',
        'product': 'Topaz Labs'
    },
    {
        'vendor': 'Wipro, Ltd.',
        'product': 'Topcoder'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Topsy'
    },
    {
        'vendor': 'Prometheus',
        'product': 'Torch LMS'
    },
    {
        'vendor': 'Torch7',
        'product': 'Torch7'
    },
    {
        'vendor': 'Adaptive Computing, Inc.',
        'product': 'Torque'
    },
    {
        'vendor': 'Open Source',
        'product': 'TortoiseSVN'
    },
    {
        'vendor': 'Toshiba',
        'product': 'Toshiba SurePOS'
    },
    {
        'vendor': 'Toshiba',
        'product': 'Toshiba VIPedge'
    },
    {
        'vendor': 'Toshiba',
        'product': 'Toshiba eStudio'
    },
    {
        'vendor': 'ADTRAN, Inc.',
        'product': 'Total Access 5000'
    },
    {
        'vendor': 'Total Management',
        'product': 'Total Management'
    },
    {
        'vendor': 'Total System Services, Inc.',
        'product': 'Total System Services (TSYS)'
    },
    {
        'vendor': 'TotalMD, Inc.',
        'product': 'TotalMD'
    },
    {
        'vendor': 'Totango, Inc.',
        'product': 'Totango'
    },
    {
        'vendor': 'Totara Learning Solutions, Ltd.',
        'product': 'Totara'
    },
    {
        'vendor': 'TouchBistro, Inc.',
        'product': 'TouchBistro'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'TouchCommerce'
    },
    {
        'vendor': 'TouchNet Information Systems, Inc.',
        'product': 'TouchNet'
    },
    {
        'vendor': 'Tour de Force, Inc.',
        'product': 'Tour de Force CRM'
    },
    {
        'vendor': 'Tout Advertising, LLC',
        'product': 'Tout'
    },
    {
        'vendor': 'ToutApp, Inc.',
        'product': 'ToutApp'
    },
    {
        'vendor': 'TowerData, Inc.',
        'product': 'TowerData'
    },
    {
        'vendor': 'SocialCondo USA Holdings, LLC',
        'product': 'TownSq'
    },
    {
        'vendor': 'Traackr, Inc.',
        'product': 'Traackr'
    },
    {
        'vendor': 'Macro 4, Ltd.',
        'product': 'TraceMaster'
    },
    {
        'vendor': 'TraceMyIP, LLC',
        'product': 'TraceMyIP'
    },
    {
        'vendor': 'Lambda Research Corporation',
        'product': 'TracePro'
    },
    {
        'vendor': 'TrackAbout',
        'product': 'TrackAbout'
    },
    {
        'vendor': 'Valiant Solutions, LLC',
        'product': 'TrackForce Valiant'
    },
    {
        'vendor': 'TrackMaven, Inc.',
        'product': 'TrackMaven'
    },
    {
        'vendor': 'TrackTik Software, Inc.',
        'product': 'TrackTik'
    },
    {
        'vendor': 'Sparta Systems, Inc.',
        'product': 'TrackWise'
    },
    {
        'vendor': 'TrackerRMS',
        'product': 'TrackerRMS'
    },
    {
        'vendor': 'Trackmax Solutions, Inc.',
        'product': 'Trackmax'
    },
    {
        'vendor': 'Trackplan Software, Ltd.',
        'product': 'Trackplan'
    },
    {
        'vendor': 'Traction Software, Inc.',
        'product': 'Traction TeamPage'
    },
    {
        'vendor': 'Tradedoubler AB',
        'product': 'TradeDoubler'
    },
    {
        'vendor': 'TradeTracker International B.V.',
        'product': 'TradeTracker'
    },
    {
        'vendor': 'Tradeshift',
        'product': 'Tradeshift'
    },
    {
        'vendor': 'Tradier Brokerage, Inc.',
        'product': 'Tradier'
    },
    {
        'vendor': 'Tradify',
        'product': 'Tradify'
    },
    {
        'vendor': 'TradingScreen, Inc.',
        'product': 'TradingScreen'
    },
    {
        'vendor': 'ActiveSoft S.R.L.',
        'product': 'Trafic'
    },
    {
        'vendor': 'Traiana, Inc.',
        'product': 'Traiana'
    },
    {
        'vendor': 'Trail Blazer Campaign Services, Inc.',
        'product': 'Trail Blazer Non-Profit Manager'
    },
    {
        'vendor': 'TSR Gym Technik, Ltd.',
        'product': 'Trainerize'
    },
    {
        'vendor': 'Traitify',
        'product': 'Traitify'
    },
    {
        'vendor': 'Trakm8, Ltd.',
        'product': 'Trakm8'
    },
    {
        'vendor': 'Trane Technologies PLC',
        'product': 'Trane TRACE'
    },
    {
        'vendor': 'TransPerfect Global, Inc.',
        'product': 'TransPerfect'
    },
    {
        'vendor': 'TransUnion, LLC',
        'product': 'TransUnion TLOxp'
    },
    {
        'vendor': 'TransVoyant, Inc.',
        'product': 'TransVoyant'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Transact'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Transact-SQL'
    },
    {
        'vendor': 'Transcepta, LLC',
        'product': 'Transcepta'
    },
    {
        'vendor': 'Transifex, Ltd.',
        'product': 'Transifex'
    },
    {
        'vendor': 'TransitScreen, Inc.',
        'product': 'TransitScreen'
    },
    {
        'vendor': 'Transpara',
        'product': 'Transpara'
    },
    {
        'vendor': 'DAC Group',
        'product': 'TransparenSEE'
    },
    {
        'vendor': 'Transplace, Inc.',
        'product': 'Transplace TMS'
    },
    {
        'vendor': 'Transporeon GmbH',
        'product': 'Transporeon'
    },
    {
        'vendor': 'Travelator, Inc',
        'product': 'TravelBank'
    },
    {
        'vendor': 'TravelClick, Inc.',
        'product': 'TravelClick'
    },
    {
        'vendor': 'TravelPerk S.L.',
        'product': 'TravelPerk'
    },
    {
        'vendor': 'Traveldoo SAS',
        'product': 'Traveldoo'
    },
    {
        'vendor': 'Travelport Worldwide, Ltd.',
        'product': 'Travelport GDS'
    },
    {
        'vendor': 'Travelport Worldwide, Ltd.',
        'product': 'Travelport SmartPoint'
    },
    {
        'vendor': 'Travis CI GmbH',
        'product': 'Travis CI'
    },
    {
        'vendor': 'Tray.io, Inc.',
        'product': 'Tray.io'
    },
    {
        'vendor': 'Arm, Ltd.',
        'product': 'Treasure Data'
    },
    {
        'vendor': 'Treasury Intelligence Solutions GmbH',
        'product': 'Treasury Intelligence Solutions (TIS)'
    },
    {
        'vendor': 'TreeAge Software, Inc.',
        'product': 'TreeAge'
    },
    {
        'vendor': 'Treepodia, Ltd.',
        'product': 'Treepodia'
    },
    {
        'vendor': 'TrekkSoft AG',
        'product': 'TrekkSoft'
    },
    {
        'vendor': 'Vertiv Group Corporation',
        'product': 'Trellis'
    },
    {
        'vendor': 'Web.com Group, Inc.',
        'product': 'Trellix'
    },
    {
        'vendor': 'Fog Creek Software, Inc.',
        'product': 'Trello'
    },
    {
        'vendor': 'Tremor Video DSP, Inc.',
        'product': 'Tremor Video DSP'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro Apex One'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro Deep Security'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro OfficeScan'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro SafeSync'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro ServerProtect for Linux'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro Worry-Free'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'TrendKite'
    },
    {
        'vendor': 'Software AG',
        'product': 'TrendMiner'
    },
    {
        'vendor': 'Trengo B.V.',
        'product': 'Trengo'
    },
    {
        'vendor': 'Tresorit AG',
        'product': 'Tresorit'
    },
    {
        'vendor': 'Tri-Technical Systems',
        'product': 'Tri-Technical AIMsi'
    },
    {
        'vendor': 'TriMed Technologies',
        'product': 'TriMed EHR'
    },
    {
        'vendor': 'TriNet Group, Inc.',
        'product': 'TriNet'
    },
    {
        'vendor': 'Cognizant Technology Solutions Corporation',
        'product': 'TriZetto Facets'
    },
    {
        'vendor': 'Cognizant Technology Solutions Corporation',
        'product': 'TriZetto QNXT Claims Workflow'
    },
    {
        'vendor': 'Cognizant Technology Solutions Corporation',
        'product': 'TriZetto Trading Partner Service (TTPS)'
    },
    {
        'vendor': 'Signant Health',
        'product': 'TrialMax eCOA/ePRO'
    },
    {
        'vendor': 'TrialStat Corporation',
        'product': 'TrialStat'
    },
    {
        'vendor': 'Trialfire, Inc.',
        'product': 'Trialfire'
    },
    {
        'vendor': 'Triax Technologies, Inc.',
        'product': 'Triax'
    },
    {
        'vendor': 'Tribal Group PLC',
        'product': 'Tribal'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'TribeHR'
    },
    {
        'vendor': 'Triberr, Inc.',
        'product': 'Triberr'
    },
    {
        'vendor': 'Triblio, Inc.',
        'product': 'Triblio'
    },
    {
        'vendor': 'Tricentis GmbH',
        'product': 'Tricentis'
    },
    {
        'vendor': 'Tricentis GmbH',
        'product': 'Tricentis Tosca'
    },
    {
        'vendor': 'Tricentis GmbH',
        'product': 'Tricentis qTest'
    },
    {
        'vendor': 'Trifacta, Inc.',
        'product': 'Trifacta'
    },
    {
        'vendor': 'Red Lotus',
        'product': 'Triggit'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'Trillium DQ'
    },
    {
        'vendor': 'Precisely Holdings, LLC',
        'product': 'Trillium Quality'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble (Unspecified Product)'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble Accubid'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble Connect'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble DuctDesigner 3D'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble EC-CAD'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble PipeDesigner 3D'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble Prolog'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble TerraModel'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Trimble WinEst'
    },
    {
        'vendor': 'Trinisys, LLC',
        'product': 'Trinisys Convergence'
    },
    {
        'vendor': 'Trinity Software, Inc.',
        'product': 'Trinity Software'
    },
    {
        'vendor': 'Trinity Management Systems GmbH',
        'product': 'Trinity TMS'
    },
    {
        'vendor': 'Trintech, Inc.',
        'product': 'Trintech'
    },
    {
        'vendor': 'Trintech, Inc.',
        'product': 'Trintech Cadency Compliance'
    },
    {
        'vendor': 'TripActions, Inc.',
        'product': 'TripActions'
    },
    {
        'vendor': 'Triple Point Technology',
        'product': 'Triple Point Technology'
    },
    {
        'vendor': 'Triple Lift, Inc.',
        'product': 'TripleLift'
    },
    {
        'vendor': 'Triplebyte, Inc.',
        'product': 'Triplebyte'
    },
    {
        'vendor': 'Tripp Lite',
        'product': 'Tripp Lite'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire CCM'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire Enterprise'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire File Integrity Manager'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire IP360'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire Log Center'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'Tripwire Via'
    },
    {
        'vendor': 'Tritek Case Management, LLC',
        'product': 'Tritek'
    },
    {
        'vendor': 'Trium Analysis Online GmbH',
        'product': 'Trium CTG'
    },
    {
        'vendor': 'Trivago N.V.',
        'product': 'Trivago'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Tropo'
    },
    {
        'vendor': 'TruCode',
        'product': 'TruCode'
    },
    {
        'vendor': 'TruPay Corporation',
        'product': 'TruPay'
    },
    {
        'vendor': 'Illumina, Inc.',
        'product': 'TruSeq'
    },
    {
        'vendor': 'True Fit Corporation',
        'product': 'True Fit'
    },
    {
        'vendor': 'TrueCommerce, Inc.',
        'product': 'TrueCommerce'
    },
    {
        'vendor': 'TrueCrypt Foundation',
        'product': 'TrueCrypt'
    },
    {
        'vendor': 'Zethos, Inc.',
        'product': 'Truework'
    },
    {
        'vendor': 'Trulioo Information Services, Inc.',
        'product': 'Trulioo'
    },
    {
        'vendor': 'Trumba Corporation',
        'product': 'Trumba'
    },
    {
        'vendor': 'Trumpia',
        'product': 'Trumpia'
    },
    {
        'vendor': 'Trust Guard, LLC',
        'product': 'Trust Guard'
    },
    {
        'vendor': 'TrustArc, Inc.',
        'product': 'TrustArc'
    },
    {
        'vendor': 'TrustYou GmbH',
        'product': 'TrustYou'
    },
    {
        'vendor': 'Trusted Shops GmbH',
        'product': 'TrustedShops'
    },
    {
        'vendor': 'Trustpilot, Inc.',
        'product': 'Trustpilot'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave (Unspecified Product)'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave App Scanner'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave AppDetectivePRO'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave SIEM'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave SSL'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave Secure Email Gateway (SEG)'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave TrustKeeper'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave WebMarshal'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'Truven Health Analytics'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'TubeMogul'
    },
    {
        'vendor': 'Tufin Software Technologies, Ltd.',
        'product': 'Tufin'
    },
    {
        'vendor': 'Tulip Retail',
        'product': 'Tulip'
    },
    {
        'vendor': 'Tumblr',
        'product': 'Tumblr'
    },
    {
        'vendor': 'TuneIn, Inc.',
        'product': 'TuneIn'
    },
    {
        'vendor': 'Tungsten Network, Ltd.',
        'product': 'Tungsten Network'
    },
    {
        'vendor': 'Tungsten Network, Ltd.',
        'product': 'Tungsten Network Workflow'
    },
    {
        'vendor': 'IMSI Design, LLC',
        'product': 'TurboCAD'
    },
    {
        'vendor': 'Intresys, Inc.',
        'product': 'TurboCourt'
    },
    {
        'vendor': 'Promethean Software Corporation',
        'product': 'TurboLaw'
    },
    {
        'vendor': 'TurboSMTP',
        'product': 'TurboSMTP'
    },
    {
        'vendor': 'TurboTenant, Inc.',
        'product': 'TurboTenant'
    },
    {
        'vendor': 'Turbonomic, Inc.',
        'product': 'Turbonomic'
    },
    {
        'vendor': 'Turbot HQ, Inc.',
        'product': 'Turbot'
    },
    {
        'vendor': 'TurnTo Networks, Inc.',
        'product': 'TurnTo'
    },
    {
        'vendor': 'Turning Technologies, LLC',
        'product': 'Turning Technologies WorkSpace'
    },
    {
        'vendor': 'Tweriod',
        'product': 'Tweriod'
    },
    {
        'vendor': 'Expat Software',
        'product': 'Twiddla'
    },
    {
        'vendor': 'Twilert',
        'product': 'Twilert'
    },
    {
        'vendor': 'Twilio, Inc.',
        'product': 'Twilio'
    },
    {
        'vendor': 'Twilio, Inc.',
        'product': 'Twilio Flex'
    },
    {
        'vendor': 'Twilio, Inc.',
        'product': 'Twilio Messaging'
    },
    {
        'vendor': 'Twilio, Inc.',
        'product': 'Twilio Voice'
    },
    {
        'vendor': 'Kofax, Ltd.',
        'product': 'Twistage'
    },
    {
        'vendor': 'Twistlock, Ltd.',
        'product': 'Twistlock'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitter'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitter Analytics'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitter Bootstrap'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitter Cards'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitter Timeline'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitter Tweet Button'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'Twitterfall'
    },
    {
        'vendor': 'Txt2Give, Ltd.',
        'product': 'Txt2Give'
    },
    {
        'vendor': 'Tyk Technologies, Ltd.',
        'product': 'Tyk API Gateway'
    },
    {
        'vendor': 'Tyler Technologies, Inc.',
        'product': 'Tyler Technologies'
    },
    {
        'vendor': 'Typemock, Ltd.',
        'product': 'TypeMock'
    },
    {
        'vendor': 'Typeform S.L.',
        'product': 'Typeform'
    },
    {
        'vendor': 'Advice Local',
        'product': 'UBL Interactive'
    },
    {
        'vendor': 'UDA Technologies, Inc.',
        'product': 'UDA ConstructionOnline'
    },
    {
        'vendor': 'UDA Technologies, Inc.',
        'product': 'UDA ConstructionSuite'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'UIMA'
    },
    {
        'vendor': 'UJET, Inc.',
        'product': 'UJET'
    },
    {
        'vendor': 'UL EHS Sustainability',
        'product': 'UL OHM'
    },
    {
        'vendor': 'UNICOM Systems, Inc.',
        'product': 'UNICOM Intelligence'
    },
    {
        'vendor': 'UNIGLOBE Travel International LP',
        'product': 'UNIGLOBE Travel'
    },
    {
        'vendor': 'UPS',
        'product': 'UPS Supply Chain Solutions'
    },
    {
        'vendor': 'USATestprep, LLC',
        'product': 'USATestprep'
    },
    {
        'vendor': 'US POSTAL SERVICE',
        'product': 'USPS'
    },
    {
        'vendor': 'UXPressia, Inc.',
        'product': 'UXPressia'
    },
    {
        'vendor': 'Uber Technologies, Inc.',
        'product': 'Uber Cadence'
    },
    {
        'vendor': 'Uber Technologies, Inc.',
        'product': 'Uber Freight'
    },
    {
        'vendor': 'Dialpad, Inc.',
        'product': 'UberConference'
    },
    {
        'vendor': 'UberFlip',
        'product': 'UberFlip'
    },
    {
        'vendor': 'Open Source',
        'product': 'Ubercart'
    },
    {
        'vendor': 'Ubiquiti, Inc.',
        'product': 'Ubiquiti (Unspecified Product)'
    },
    {
        'vendor': 'Ubiquiti Networks, Inc.',
        'product': 'Ubiquiti Networks'
    },
    {
        'vendor': 'Canonical, Ltd.',
        'product': 'Ubuntu'
    },
    {
        'vendor': 'Ubports Commerce',
        'product': 'Ubuntu Touch'
    },
    {
        'vendor': 'Udemy, Inc.',
        'product': 'Udemy'
    },
    {
        'vendor': 'Udemy, Inc.',
        'product': 'Udemy for Business'
    },
    {
        'vendor': 'Beijing Wofeng Times Data Technology Co, Ltd.',
        'product': 'Udesk'
    },
    {
        'vendor': 'Udutu Learning Systems, Inc.',
        'product': 'Udutu LMS'
    },
    {
        'vendor': 'UiPath, Inc.',
        'product': 'UiPath'
    },
    {
        'vendor': 'Ultimate Software Group, Inc.',
        'product': 'UltiPro'
    },
    {
        'vendor': 'Ultimate Software Group, Inc.',
        'product': 'Ultimate Software'
    },
    {
        'vendor': 'Ultra Electronics Communication & Integrated Systems',
        'product': 'Ultra CIS'
    },
    {
        'vendor': 'UltraBac Software, Inc.',
        'product': 'UltraBac'
    },
    {
        'vendor': 'Neustar, Inc.',
        'product': 'UltraDns'
    },
    {
        'vendor': 'IDM Computer Solutions, Inc.',
        'product': 'UltraEdit'
    },
    {
        'vendor': 'UltraLinq Healthcare Solutions, Inc.',
        'product': 'UltraLinq'
    },
    {
        'vendor': 'UltraRAD Corporation',
        'product': 'UltraRAD'
    },
    {
        'vendor': 'UltraVNC',
        'product': 'UltraVNC'
    },
    {
        'vendor': 'Ultracart',
        'product': 'Ultracart'
    },
    {
        'vendor': 'Umbraco HQ',
        'product': 'Umbraco'
    },
    {
        'vendor': 'Positionly, Inc.',
        'product': 'Unamo'
    },
    {
        'vendor': 'Unanet Technologies, Inc.',
        'product': 'Unanet (Unspecified Product)'
    },
    {
        'vendor': 'Unanet Technologies, Inc.',
        'product': 'Unanet A/E'
    },
    {
        'vendor': 'Unbabel, Inc.',
        'product': 'Unbabel'
    },
    {
        'vendor': 'Unbounce Marketing Solutions, Inc,',
        'product': 'Unbounce'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'UnboundID'
    },
    {
        'vendor': 'Unbxd, Inc.',
        'product': 'Unbxd'
    },
    {
        'vendor': 'Undertone',
        'product': 'Undertone'
    },
    {
        'vendor': 'UnisonCare Corporation',
        'product': 'UniCharts'
    },
    {
        'vendor': 'Ubiquiti, Inc.',
        'product': 'UniFi SDN'
    },
    {
        'vendor': 'Ubiquiti, Inc.',
        'product': 'UniFi Security Gateway'
    },
    {
        'vendor': 'Open Source',
        'product': 'Unicorn'
    },
    {
        'vendor': 'Unicorn HRO, LLC',
        'product': 'Unicorn HRO'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Unidesk'
    },
    {
        'vendor': 'Uniface B.V.',
        'product': 'Uniface'
    },
    {
        'vendor': 'Unilog Content Solutions Pvt Ltd',
        'product': 'Unilog'
    },
    {
        'vendor': 'Unily',
        'product': 'Unily'
    },
    {
        'vendor': 'Uniphore Software Systems Pvt Ltd',
        'product': 'Uniphore'
    },
    {
        'vendor': 'Unirisx, LLC',
        'product': 'Unirisx'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys (Unspecified Product)'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys ClearPath Dorado'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys ClearPath Forward'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys ClearPath Libra'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys ClearPath MCP'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys InfoImage'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys OS 2200'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Unit4 Business World'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Unit4 CAMS Enterprise'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Unit4 Financials'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Unit4 HCM'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Unit4 Prevero'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Unit4 Prosoft HRMS'
    },
    {
        'vendor': 'Unitas Global, LLC',
        'product': 'Unitas Global'
    },
    {
        'vendor': 'VTEX Commerce Cloud Solutions, LLC',
        'product': 'UniteU'
    },
    {
        'vendor': 'Unito, Inc.',
        'product': 'Unito'
    },
    {
        'vendor': 'Unitrends, Inc.',
        'product': 'Unitrends (Unspecified Product)'
    },
    {
        'vendor': 'Unity Technologies ApS',
        'product': 'Unity'
    },
    {
        'vendor': 'Silver Peak Systems, Inc.',
        'product': 'Unity EdgeConnect SD-WAN Edge Platform'
    },
    {
        'vendor': 'Univa Corporation',
        'product': 'Univa Grid Engine'
    },
    {
        'vendor': 'Universal Accounting Software, Inc.',
        'product': 'Universal Accounting Software'
    },
    {
        'vendor': 'Universal Robots A/S',
        'product': 'Universal Robots'
    },
    {
        'vendor': 'Universal Service Administrative Company',
        'product': 'Universal Service Administrative Company'
    },
    {
        'vendor': 'The Open Group',
        'product': 'Unix'
    },
    {
        'vendor': 'Unleashed Software, Ltd.',
        'product': 'Unleashed'
    },
    {
        'vendor': 'Unmind, Ltd.',
        'product': 'Unmind'
    },
    {
        'vendor': 'Unomaly AB',
        'product': 'Unomaly'
    },
    {
        'vendor': 'Unqork, Inc.',
        'product': 'Unqork'
    },
    {
        'vendor': 'Unravel Data Systems, Inc.',
        'product': 'Unravel'
    },
    {
        'vendor': 'Unruly Group, Ltd.',
        'product': 'Unruly'
    },
    {
        'vendor': 'Unruly Media, Inc.',
        'product': 'Unruly Media'
    },
    {
        'vendor': 'Untangle, Inc.',
        'product': 'Untangle'
    },
    {
        'vendor': 'UpClick, Inc.',
        'product': 'UpClick'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'UpToDate'
    },
    {
        'vendor': 'Upaknee, Inc.',
        'product': 'Upaknee'
    },
    {
        'vendor': 'Upchain, Inc.',
        'product': 'Upchain'
    },
    {
        'vendor': 'Upfluence, Inc.',
        'product': 'Upfluence'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland AccuRoute'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Adestra'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Altify'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Clickability'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Kapost'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland LeadLander'
    },
    {
        'vendor': 'Localytics',
        'product': 'Upland Localytics'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Mobile Messaging'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland PSA'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland PowerSteering'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Qvidian'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland RightAnswers'
    },
    {
        'vendor': 'Upland Software, Inc.',
        'product': 'Upland Software (Unspecified Product)'
    },
    {
        'vendor': 'Uplevl, Inc.',
        'product': 'Uplevl'
    },
    {
        'vendor': 'Upsellit',
        'product': 'Upsellit'
    },
    {
        'vendor': 'Upsight, Inc.',
        'product': 'Upsight'
    },
    {
        'vendor': 'Upstream Works Software, Ltd.',
        'product': 'Upstream Works'
    },
    {
        'vendor': 'Uptrends, LLC',
        'product': 'Uptrends'
    },
    {
        'vendor': 'Uptycs, Inc.',
        'product': 'Uptycs'
    },
    {
        'vendor': 'Upwork Global, Inc.',
        'product': 'Upwork'
    },
    {
        'vendor': 'Airship Group, Inc.',
        'product': 'Urban Airship'
    },
    {
        'vendor': 'Urjanet, Inc.',
        'product': 'Urjanet'
    },
    {
        'vendor': 'IntrinsiQ Specialty Solutions',
        'product': 'UroChartEHR'
    },
    {
        'vendor': 'Usabilla B.V.',
        'product': 'Usabilla'
    },
    {
        'vendor': 'UsableNet, Inc.',
        'product': 'UsableNet'
    },
    {
        'vendor': 'User Local, Inc.',
        'product': 'User Insight'
    },
    {
        'vendor': 'User Local, Inc.',
        'product': 'User Insight Advertising Effectiveness'
    },
    {
        'vendor': 'User.com Sp. z o.o.',
        'product': 'User.com'
    },
    {
        'vendor': 'Userecho, LLC',
        'product': 'UserEcho'
    },
    {
        'vendor': 'UserIQ, Inc.',
        'product': 'UserIQ'
    },
    {
        'vendor': 'UserReplay, Ltd.',
        'product': 'UserReplay'
    },
    {
        'vendor': 'UserTesting',
        'product': 'UserTesting'
    },
    {
        'vendor': 'UserVoice, Inc.',
        'product': 'UserVoice'
    },
    {
        'vendor': 'UserZoom',
        'product': 'UserZoom'
    },
    {
        'vendor': 'Userlike UG',
        'product': 'Userlike'
    },
    {
        'vendor': 'Usersnap GmbH',
        'product': 'Usersnap'
    },
    {
        'vendor': 'Ustream',
        'product': 'Ustream'
    },
    {
        'vendor': 'Chaos Software, Ltd.',
        'product': 'V-Ray'
    },
    {
        'vendor': 'Vitech Systems Sub, LLC',
        'product': 'V3locity'
    },
    {
        'vendor': 'VARCommerce, Inc.',
        'product': 'VARCommerce'
    },
    {
        'vendor': 'Vienna Ab initio Simulation Package',
        'product': 'VASP'
    },
    {
        'vendor': 'VBrick Systems, Inc.',
        'product': 'VBrick'
    },
    {
        'vendor': 'Dell EMC',
        'product': 'VCE'
    },
    {
        'vendor': 'VDIworks',
        'product': 'VDIworks'
    },
    {
        'vendor': 'Ricardo PLC',
        'product': 'VECTIS'
    },
    {
        'vendor': 'General Technology',
        'product': 'VHSIC Hardware Description Language (VHDL)'
    },
    {
        'vendor': 'Vicidial Group',
        'product': 'VICIdial'
    },
    {
        'vendor': 'VIDIZMO, LLC',
        'product': 'VIDIZMO'
    },
    {
        'vendor': 'Zudy Software',
        'product': 'VINYL'
    },
    {
        'vendor': 'VIPRE',
        'product': 'VIPRE'
    },
    {
        'vendor': 'VIPRE',
        'product': 'VIPRE Threat Intelligence'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'VISI'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'VITAE Suite'
    },
    {
        'vendor': 'Biomerieux, Inc.',
        'product': 'VITEK 2 (Unspecified Product)'
    },
    {
        'vendor': 'StudioCoast Pty Ltd',
        'product': 'VMIX'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMWare CloudHealth'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware (Unspecified Product)'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ACE'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware AirWatch'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware AppDefense'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Capacity Planner'
    },
    {
        'vendor': 'Carbon Black, Inc.',
        'product': 'VMware Carbon Black'
    },
    {
        'vendor': 'Carbon Black, Inc.',
        'product': 'VMware Carbon Black Cloud Endpoint Standard'
    },
    {
        'vendor': 'Carbon Black, Inc.',
        'product': 'VMware Carbon Black EDR'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Cloud Director'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Cloud Foundation'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'VMware Cloud on AWS'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Cloud on Dell EMC'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Data Recovery'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Distributed Power Management (DPM)'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Distributed Resource Scheduler (DRS)'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESX'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESX 3.0'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESX 3.5'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESX 4.0'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESXi'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESXi 4.0'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESXi 4.1'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ESXi 5.0'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Enterprise PKS'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Fusion'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware GSX Server'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware HCI'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware HCX'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Harbor'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Horizon'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Horizon Client'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware IT Business Management'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware NSX'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware NSX Cloud'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware NSX Data Center'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware NSX Data Center for vSphere'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware NSX-T Data Center'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Nicira'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware PLUMgrid'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Photon OS'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware SD-WAN by VeloCloud'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Server'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Service Manager'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Site Recovery Manager'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Socialcast'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware SpringSource'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Storage vMotion'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Studio'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Tanzu'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Tanzu Application Service'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Tanzu GemFire'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware ThinApp'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware VMmark'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware View'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Virtual Desktop Infrastructure'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Virtual Infrastructure'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Virtual SAN'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Volume Purchasing Program'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Wanova'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Workspace ONE'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Workstation Player'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Workstation Pro'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter AppSpeed'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Application Discovery Manager'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter CapacityIQ'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Chargeback'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Converter'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Lab Manager'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Operations'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Protect Update Catalog'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Server'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCenter Server Heartbeat'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCloud'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCloud Air'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCloud Director'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vCloud Express'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vFabric'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vFabric Application Director'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vFabric Application Performance Manager'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vFabric Data Director'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vFabric Hyperic'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize Automation'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize Configuration Manager'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize Hyperic'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize Log Insight'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize Network Insight'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vRealize Orchestrator'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vSAN'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vSAN ReadyNode'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vShield'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vShield App'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vShield Edge'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vShield Endpoint'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vSphere'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vSphere Enterprise Plus'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware vSphere Hypervisor'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'VSS Monitoring'
    },
    {
        'vendor': 'Atlas Business Solutions, Inc.',
        'product': 'VSS Pro'
    },
    {
        'vendor': 'VTEX Commerce Cloud Solutions, LLC',
        'product': 'VTEX'
    },
    {
        'vendor': 'VUEWorks, LLC',
        'product': 'VUEworks'
    },
    {
        'vendor': 'Vaadin, Ltd.',
        'product': 'Vaadin'
    },
    {
        'vendor': 'Vacancy Filler, Ltd.',
        'product': 'Vacancy Filler Recruitment'
    },
    {
        'vendor': 'Vagaro, Inc.',
        'product': 'Vagaro'
    },
    {
        'vendor': 'HashiCorp, Inc.',
        'product': 'Vagrant'
    },
    {
        'vendor': 'ValGenesis, Inc.',
        'product': 'ValGenesis Validation Lifecycle Management System'
    },
    {
        'vendor': 'Valant, Inc.',
        'product': 'Valant'
    },
    {
        'vendor': 'Valimail, Inc.',
        'product': 'Valimail'
    },
    {
        'vendor': 'Valogix, LLC',
        'product': 'Valogix'
    },
    {
        'vendor': 'GMO DigiRock, Inc.',
        'product': 'Value Domain'
    },
    {
        'vendor': 'USU GmbH',
        'product': 'Valuemation'
    },
    {
        'vendor': 'Vanguard Integrity Professionals',
        'product': 'Vanguard Administrator'
    },
    {
        'vendor': 'Vanguard Integrity Professionals',
        'product': 'Vanguard Analyzer'
    },
    {
        'vendor': 'Vanguard Systems, Inc.',
        'product': 'Vanguard ECM'
    },
    {
        'vendor': 'Vanilla Forums, Inc.',
        'product': 'Vanilla Forums'
    },
    {
        'vendor': 'VanillaSoft, Inc.',
        'product': 'VanillaSoft'
    },
    {
        'vendor': 'Vanta, Inc.',
        'product': 'Vanta'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'Vantiv'
    },
    {
        'vendor': 'Varian',
        'product': 'Varian ARIA'
    },
    {
        'vendor': 'Varian',
        'product': 'Varian VARiS Vision'
    },
    {
        'vendor': 'Varicent US OpCo Corporation',
        'product': 'Varicent'
    },
    {
        'vendor': 'Varnish',
        'product': 'Varnish'
    },
    {
        'vendor': 'Varonis Systems, Inc.',
        'product': 'Varonis'
    },
    {
        'vendor': 'Olympus Europa SE & Company KG',
        'product': 'VaultStream'
    },
    {
        'vendor': 'CyberArk Software, Ltd.',
        'product': 'Vaultive'
    },
    {
        'vendor': 'Vecna',
        'product': 'Vecna Pathfinder'
    },
    {
        'vendor': 'Vecna Robotics, Inc.',
        'product': 'Vecna Robotics'
    },
    {
        'vendor': 'VectorVMS',
        'product': 'VectorVMS'
    },
    {
        'vendor': 'Vectorworks, Inc.',
        'product': 'Vectorworks'
    },
    {
        'vendor': 'Vectra AI, Inc.',
        'product': 'Vectra AI'
    },
    {
        'vendor': 'Vee24 UK, Ltd.',
        'product': 'Vee24 Platform'
    },
    {
        'vendor': 'Veeam',
        'product': 'Veeam'
    },
    {
        'vendor': 'Veeam Software AG',
        'product': 'Veeam Availability Suite'
    },
    {
        'vendor': 'Veeam',
        'product': 'Veeam Backup & Replication'
    },
    {
        'vendor': 'Veeam Software AG',
        'product': 'Veeam Backup Essentials'
    },
    {
        'vendor': 'Veeqo',
        'product': 'Veeqo'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva CRM'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Network'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva OpenData'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Systems'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Vault'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Vault CTMS'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Vault eTMF'
    },
    {
        'vendor': 'Sony Corporation',
        'product': 'Vegas Pro'
    },
    {
        'vendor': 'EMRgence, LLC',
        'product': 'VeinSpec EMR'
    },
    {
        'vendor': 'Velaro, Inc.',
        'product': 'Velaro'
    },
    {
        'vendor': 'ICE Mortgage Technology',
        'product': 'Velocify'
    },
    {
        'vendor': 'Velocify, Inc.',
        'product': 'Velocify (Unspecified Product)'
    },
    {
        'vendor': 'VelocityEHS',
        'product': 'VelocityEHS'
    },
    {
        'vendor': 'Velocix',
        'product': 'Velocix'
    },
    {
        'vendor': 'VeloCloud Networks, Inc.',
        'product': 'Velocloud'
    },
    {
        'vendor': 'Velpic, Ltd.',
        'product': 'Velpic'
    },
    {
        'vendor': 'Vembu Technologies, Inc.',
        'product': 'Vembu StoreGrid'
    },
    {
        'vendor': 'Vena Solutions, Inc.',
        'product': 'Vena'
    },
    {
        'vendor': 'Venafi, Inc.',
        'product': 'Venafi'
    },
    {
        'vendor': 'Vend',
        'product': 'Vend POS'
    },
    {
        'vendor': 'Oracle NetSuite',
        'product': 'Venda'
    },
    {
        'vendor': 'Vendasta Technologies, Inc.',
        'product': 'Vendasta'
    },
    {
        'vendor': 'Vendavo, Inc.',
        'product': 'Vendavo'
    },
    {
        'vendor': 'Vendini, Inc.',
        'product': 'Vendini'
    },
    {
        'vendor': 'ProTech Compliance, Inc.',
        'product': 'VendorStat'
    },
    {
        'vendor': 'Venminder, Inc.',
        'product': 'Venminder'
    },
    {
        'vendor': 'Venngage, Inc.',
        'product': 'Venngage'
    },
    {
        'vendor': 'Ventuno Technologies Pvt Ltd',
        'product': 'Ventuno'
    },
    {
        'vendor': 'Venzee Technologies, Inc.',
        'product': 'Venzee'
    },
    {
        'vendor': 'Veoci, Inc.',
        'product': 'Veoci'
    },
    {
        'vendor': 'Vera Security, Inc.',
        'product': 'Vera'
    },
    {
        'vendor': 'Veracode, Inc.',
        'product': 'Veracode'
    },
    {
        'vendor': 'Veracross, LLC',
        'product': 'Veracross'
    },
    {
        'vendor': 'Verafin',
        'product': 'Verafin FRAML'
    },
    {
        'vendor': 'Calero-MDSL Group',
        'product': 'Veramark'
    },
    {
        'vendor': 'Verbit Software, Ltd.',
        'product': 'Verbit'
    },
    {
        'vendor': 'Avolin, Inc.',
        'product': 'Verdiem'
    },
    {
        'vendor': 'Veriforce, LLC',
        'product': 'VeriSource'
    },
    {
        'vendor': 'Veriato, Inc.',
        'product': 'Veriato'
    },
    {
        'vendor': 'Vericle, Inc.',
        'product': 'Vericle'
    },
    {
        'vendor': 'Verifone, Inc.',
        'product': 'Verifone Point to Point Encryption (P2PE)'
    },
    {
        'vendor': 'Verifone, Inc.',
        'product': 'Verifone VX 520'
    },
    {
        'vendor': 'Verifone, Inc.',
        'product': 'Verifone VX 820'
    },
    {
        'vendor': 'Communications Test Design, Inc.',
        'product': 'Verilink (Unspecified Product)'
    },
    {
        'vendor': 'General Technology',
        'product': 'Verilog'
    },
    {
        'vendor': 'General Technology',
        'product': 'Verilog-A'
    },
    {
        'vendor': 'General Technology',
        'product': 'Verilog-AMS'
    },
    {
        'vendor': 'General Technology',
        'product': 'Verilog-RTL'
    },
    {
        'vendor': 'Verimatrix, Inc.',
        'product': 'Verimatrix'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint Community'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint Customer Analytics'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint EdgeVMS'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint Recording for Public Safety'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint Unified VOC'
    },
    {
        'vendor': 'Verio',
        'product': 'Verio'
    },
    {
        'vendor': 'Verio',
        'product': 'Verio DNS'
    },
    {
        'vendor': 'Verio',
        'product': 'Verio SSL'
    },
    {
        'vendor': 'Accruent, LLC',
        'product': 'Verisae'
    },
    {
        'vendor': 'Verisign, Inc.',
        'product': 'Verisign (Unspecified Product)'
    },
    {
        'vendor': 'Verisign, Inc.',
        'product': 'Verisign EV'
    },
    {
        'vendor': 'Verisign, Inc.',
        'product': 'Verisign Public DNS'
    },
    {
        'vendor': 'NortonLifeLock, Inc.',
        'product': 'Verisign Trust Seal'
    },
    {
        'vendor': 'Verisk 3E',
        'product': 'Verisk 3E'
    },
    {
        'vendor': 'Verisma Systems, Inc.',
        'product': 'Verisma'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas (Unspecified Product)'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas APTARE IT Analytics'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas ApplicationHA'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Backup Exec'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Data Insight'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Desktop and Laptop Option'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Disaster Recovery Orchestrator'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Enterprise Vault'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Enterprise Vault.cloud'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas InfoScale Availability'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas InfoScale Enterprise'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas InfoScale Operations Manager'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas InfoScale Storage'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas NetBackup'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Resiliency Platform'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Risk Advisor'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas System Recovery'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas Volume Replicator'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas eDiscovery'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas eDiscovery Platform'
    },
    {
        'vendor': 'VerityStream',
        'product': 'Verity Echo'
    },
    {
        'vendor': 'Exadel, Inc.',
        'product': 'Verivo'
    },
    {
        'vendor': 'Verizon',
        'product': 'Verizon'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon (Unspecified Product)'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon Cloud'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon Conferencing'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon Connect'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon Cybertrust'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon DNS'
    },
    {
        'vendor': 'Verizon Media',
        'product': 'Verizon Encode'
    },
    {
        'vendor': 'Verizon',
        'product': 'Verizon FIOS'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon Hosting'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon IoT'
    },
    {
        'vendor': 'Verizon Media',
        'product': 'Verizon Media'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon VoIP'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon Volicon'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Verizon XO'
    },
    {
        'vendor': 'Verkada, Inc.',
        'product': 'Verkada'
    },
    {
        'vendor': 'FactSet Research Systems, Inc.',
        'product': 'Vermilion Software'
    },
    {
        'vendor': 'Vero Holdings Australia Pty Ltd',
        'product': 'Vero'
    },
    {
        'vendor': 'Versa Networks',
        'product': 'Versa Networks'
    },
    {
        'vendor': 'VersaForm Systems Corporation',
        'product': 'VersaForm'
    },
    {
        'vendor': 'VersaIMAGE Software Corporation',
        'product': 'VersaIMAGE'
    },
    {
        'vendor': 'VersaPay Corporation',
        'product': 'VersaPay'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'VersaStack'
    },
    {
        'vendor': 'Universal Software Solutions, Inc.',
        'product': 'VersaSuite'
    },
    {
        'vendor': 'CollabNet, Inc.',
        'product': 'VersionOne'
    },
    {
        'vendor': 'Versium Analytics, Inc.',
        'product': 'Versium'
    },
    {
        'vendor': 'Vertafore, Inc.',
        'product': 'Vertafore'
    },
    {
        'vendor': 'Vertafore, Inc.',
        'product': 'Vertafore ImageRight'
    },
    {
        'vendor': 'Vertex, Inc.',
        'product': 'Vertex'
    },
    {
        'vendor': 'Vertex, Inc.',
        'product': 'Vertex L Series'
    },
    {
        'vendor': 'Vertex, Inc.',
        'product': 'Vertex O Series'
    },
    {
        'vendor': 'Vertex, Inc.',
        'product': 'Vertex Q Series'
    },
    {
        'vendor': 'Meridian Medical Management',
        'product': 'VertexDr'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Vertica'
    },
    {
        'vendor': 'VerticalResponse, Inc.',
        'product': 'VerticalResponse'
    },
    {
        'vendor': 'Verve Wireless, Inc.',
        'product': 'Verve Wireless'
    },
    {
        'vendor': 'Ververica GmbH',
        'product': 'Ververica'
    },
    {
        'vendor': 'Very Good Security, Inc.',
        'product': 'Very Good Security'
    },
    {
        'vendor': 'DataLogic Software, Inc.',
        'product': 'Vesta EVV'
    },
    {
        'vendor': 'VestServe',
        'product': 'Vestserve'
    },
    {
        'vendor': 'Vetstreet',
        'product': 'Vetstreet'
    },
    {
        'vendor': 'Viafoura',
        'product': 'Viafoura'
    },
    {
        'vendor': 'Viamedici Software GmbH',
        'product': 'Viamedici'
    },
    {
        'vendor': 'Viatronix, Inc.',
        'product': 'Viatronix'
    },
    {
        'vendor': 'Viavi Solutions, Inc.',
        'product': 'Viavi Solutions'
    },
    {
        'vendor': 'Vibes Media',
        'product': 'Vibes'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'VictorOps'
    },
    {
        'vendor': 'Encoding.com, Inc.',
        'product': 'Vid.ly'
    },
    {
        'vendor': 'VidCruiter, Inc.',
        'product': 'VidCruiter'
    },
    {
        'vendor': 'Viddler, Inc.',
        'product': 'Viddler'
    },
    {
        'vendor': 'Brightcove, Inc.',
        'product': 'Video.js'
    },
    {
        'vendor': 'VideoAmp, Inc.',
        'product': 'VideoAmp'
    },
    {
        'vendor': 'VideoBloom, Inc.',
        'product': 'VideoBloom'
    },
    {
        'vendor': 'Panasonic Corporation',
        'product': 'VideoInsight'
    },
    {
        'vendor': 'Videogenie',
        'product': 'Videogenie'
    },
    {
        'vendor': 'Videojet Technologies, Inc.',
        'product': 'Videojet (Unspecified Product)'
    },
    {
        'vendor': 'Amobee, Inc.',
        'product': 'Videology'
    },
    {
        'vendor': 'Vidyard',
        'product': 'Vidyard'
    },
    {
        'vendor': 'Vidyo, Inc.',
        'product': 'Vidyo'
    },
    {
        'vendor': 'Vienna Advantage',
        'product': 'Vienna Advantage'
    },
    {
        'vendor': 'Qarbon, Inc.',
        'product': 'Viewlet'
    },
    {
        'vendor': 'Viewpoint, Inc.',
        'product': 'Viewpoint'
    },
    {
        'vendor': 'Viewpoint, Inc.',
        'product': 'Viewpoint For Estimating'
    },
    {
        'vendor': 'Viewpoint, Inc.',
        'product': 'Viewpoint Vista'
    },
    {
        'vendor': 'Viewpoint, Inc.',
        'product': 'ViewpointOne'
    },
    {
        'vendor': 'VigiLanz Corporation',
        'product': 'VigiLanz'
    },
    {
        'vendor': 'VigLink, Inc.',
        'product': 'Viglink'
    },
    {
        'vendor': 'Village Management Software',
        'product': 'Village Management Software (VMS)'
    },
    {
        'vendor': 'Vimeo, Inc.',
        'product': 'Vimeo'
    },
    {
        'vendor': 'Vimeo, Inc.',
        'product': 'Vimeo OTT'
    },
    {
        'vendor': 'Vinculum Group',
        'product': 'Vin eRetail'
    },
    {
        'vendor': 'VinSolutions, Inc.',
        'product': 'VinSolutions'
    },
    {
        'vendor': 'Vincari, Inc.',
        'product': 'Vincari'
    },
    {
        'vendor': 'Vincere',
        'product': 'Vincere'
    },
    {
        'vendor': 'VinciWorks, Ltd.',
        'product': 'VinciWorks'
    },
    {
        'vendor': 'Vindicia, Inc.',
        'product': 'Vindicia'
    },
    {
        'vendor': 'Vinzant Software, Inc.',
        'product': 'Vinzant'
    },
    {
        'vendor': 'Violin Memory',
        'product': 'Violin'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Viptela'
    },
    {
        'vendor': 'Viraltag, Inc.',
        'product': 'Viraltag'
    },
    {
        'vendor': 'Virence Health Technologies',
        'product': 'Virence Health Centricity'
    },
    {
        'vendor': 'Virool',
        'product': 'Virool'
    },
    {
        'vendor': 'Virtacore Systems, Inc.',
        'product': 'Virtacore'
    },
    {
        'vendor': 'Virto Commerce',
        'product': 'Virto Commerce'
    },
    {
        'vendor': 'Onapsis, Inc.',
        'product': 'Virtual Forge'
    },
    {
        'vendor': 'Virtual Radiologic Corporation',
        'product': 'Virtual Radiologic'
    },
    {
        'vendor': 'vSpirits Technologies, Ltd.',
        'product': 'Virtual Spirits'
    },
    {
        'vendor': 'VirtueMart',
        'product': 'VirtueMart'
    },
    {
        'vendor': 'Virtuous Software, LLC',
        'product': 'Virtuous CRM'
    },
    {
        'vendor': 'Virtuozzo International GmbH',
        'product': 'Virtuozzo Containers'
    },
    {
        'vendor': 'Virtusales.com, Ltd.',
        'product': 'Virtusales'
    },
    {
        'vendor': 'Virtusize',
        'product': 'Virtusize'
    },
    {
        'vendor': 'Virtustream, Inc.',
        'product': 'Virtustream'
    },
    {
        'vendor': 'Visa, Inc.',
        'product': 'Visa'
    },
    {
        'vendor': 'Visa, Inc.',
        'product': 'Visa Checkout'
    },
    {
        'vendor': 'Visage Imaging',
        'product': 'Visage 7'
    },
    {
        'vendor': 'KickFire',
        'product': 'VisiStat'
    },
    {
        'vendor': 'Visibility Corporation',
        'product': 'Visibility ERP'
    },
    {
        'vendor': 'nCino, Inc.',
        'product': 'Visible Equity'
    },
    {
        'vendor': 'Visier, Inc.',
        'product': 'Visier People'
    },
    {
        'vendor': 'Alida, Inc.',
        'product': 'Vision Critical'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'Vision FI'
    },
    {
        'vendor': 'Vision Helpdesk',
        'product': 'Vision Helpdesk'
    },
    {
        'vendor': 'Vision InfoSoft',
        'product': 'Vision InfoSoft'
    },
    {
        'vendor': 'Vision Solutions',
        'product': 'Vision Solutions Double-Take'
    },
    {
        'vendor': 'Vision Solutions',
        'product': 'Vision Solutions MIMIX'
    },
    {
        'vendor': 'Vision6 Pty Ltd',
        'product': 'Vision6'
    },
    {
        'vendor': 'Cognex Corporation',
        'product': 'VisionPro'
    },
    {
        'vendor': 'VisionTree Software, Inc.',
        'product': 'VisionTree'
    },
    {
        'vendor': 'netFactor Corporation',
        'product': 'VisitorTrack'
    },
    {
        'vendor': 'Visma Group',
        'product': 'Visma.net'
    },
    {
        'vendor': 'Visme',
        'product': 'Visme'
    },
    {
        'vendor': 'Visonex',
        'product': 'Visonex Clarity'
    },
    {
        'vendor': 'Personnel Data Systems, Inc.',
        'product': 'Vista'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Visual Basic.NET'
    },
    {
        'vendor': 'Visual Components Oy',
        'product': 'Visual Components'
    },
    {
        'vendor': 'Visual Retail Plus',
        'product': 'Visual Retail Plus'
    },
    {
        'vendor': 'Outbrain, Inc.',
        'product': 'Visual Revenue'
    },
    {
        'vendor': 'GTreasury SS, LLC',
        'product': 'Visual Risk'
    },
    {
        'vendor': 'Visual Visitor, LLC',
        'product': 'Visual Visitor'
    },
    {
        'vendor': 'Wingify Software Pvt Ltd',
        'product': 'Visual Website Optimizer'
    },
    {
        'vendor': 'Visualsoft, Ltd.',
        'product': 'Visualsoft'
    },
    {
        'vendor': 'Visualutions, Inc.',
        'product': 'Visualutions'
    },
    {
        'vendor': 'Visualutions, Inc.',
        'product': 'Visualutions VisDental'
    },
    {
        'vendor': 'Visualutions, Inc.',
        'product': 'Visualutions VisDoc'
    },
    {
        'vendor': 'Visualware, Inc.',
        'product': 'Visualware'
    },
    {
        'vendor': 'Greenway Health, LLC',
        'product': 'Vitera Healthcare'
    },
    {
        'vendor': 'Vitria Technology, Inc.',
        'product': 'Vitria'
    },
    {
        'vendor': 'HelpSystems, LLC',
        'product': 'Vityl Capacity Management'
    },
    {
        'vendor': 'Viva Payments Services S.A.',
        'product': 'Viva Wallet'
    },
    {
        'vendor': 'Vivantio, Ltd.',
        'product': 'Vivantio'
    },
    {
        'vendor': 'Vivial, Inc.',
        'product': 'Vivial'
    },
    {
        'vendor': 'Vivid Seats, LLC',
        'product': 'Vivid Seats'
    },
    {
        'vendor': 'Vizergy',
        'product': 'Vizergy'
    },
    {
        'vendor': 'Vizient, Inc.',
        'product': 'Vizient'
    },
    {
        'vendor': 'Vizrt',
        'product': 'Vizrt'
    },
    {
        'vendor': 'Vizury',
        'product': 'Vizury'
    },
    {
        'vendor': 'Vizzit International AB',
        'product': 'Vizzit'
    },
    {
        'vendor': 'Vlocity, Inc.',
        'product': 'Vlocity'
    },
    {
        'vendor': 'Vndly, Inc.',
        'product': 'Vndly'
    },
    {
        'vendor': 'Voalte, Inc.',
        'product': 'Voalte'
    },
    {
        'vendor': 'Voalte, Inc.',
        'product': 'Voalte One'
    },
    {
        'vendor': 'Vocalcom',
        'product': 'Vocalcom'
    },
    {
        'vendor': 'Vocera',
        'product': 'Vocera Communications'
    },
    {
        'vendor': 'Voci Technologies, Inc.',
        'product': 'Voci'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Vocollect Voice DC'
    },
    {
        'vendor': 'Cision, Ltd.',
        'product': 'Vocus'
    },
    {
        'vendor': 'Vodafone Group PLC',
        'product': 'Vodafone IoT'
    },
    {
        'vendor': 'VodafoneZiggo Group Holding B.V.',
        'product': 'Vodafone Ziggo'
    },
    {
        'vendor': 'VoiceBase, Inc.',
        'product': 'VoiceBase'
    },
    {
        'vendor': 'VoiceFive, Inc.',
        'product': 'VoiceFive'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'VoiceVault'
    },
    {
        'vendor': 'World Wide Web Consortium',
        'product': 'VoiceXML'
    },
    {
        'vendor': 'Voicebrook, Inc.',
        'product': 'Voicebrook'
    },
    {
        'vendor': 'LinkedIn Corporation',
        'product': 'Voldemort'
    },
    {
        'vendor': 'VoltDB, Inc.',
        'product': 'VoltDB'
    },
    {
        'vendor': 'Volusion, LLC',
        'product': 'Volusion'
    },
    {
        'vendor': 'Volusion, LLC',
        'product': 'Volusion DNS'
    },
    {
        'vendor': 'Volusion, LLC',
        'product': 'Volusion LiveChat'
    },
    {
        'vendor': 'Volusion, LLC',
        'product': 'Volusion SSL'
    },
    {
        'vendor': 'Codewise Sp. z o.o.',
        'product': 'Voluum'
    },
    {
        'vendor': 'Vonage Holdings Corporation',
        'product': 'Vonage (Unspecified Product)'
    },
    {
        'vendor': 'Vonage Holdings Corporation',
        'product': 'Vonage Integration Suite'
    },
    {
        'vendor': 'Vonigo',
        'product': 'Vonigo'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Vormetric'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Vormetric DSM'
    },
    {
        'vendor': 'Thales Group',
        'product': 'Vormetric Transparent Encryption'
    },
    {
        'vendor': 'Votigo, Inc.',
        'product': 'Votigo'
    },
    {
        'vendor': 'Paradigm',
        'product': 'VoxelGeo'
    },
    {
        'vendor': 'Voxer, Inc.',
        'product': 'Voxer'
    },
    {
        'vendor': '24/7 Customer, Inc.',
        'product': 'Voxify'
    },
    {
        'vendor': 'Voxware, Inc.',
        'product': 'Voxware'
    },
    {
        'vendor': 'Brainlab AG',
        'product': 'Voyant TraumaCad'
    },
    {
        'vendor': 'Vtiger Systems Pvt Ltd',
        'product': 'Vtiger'
    },
    {
        'vendor': 'VUble',
        'product': 'Vuble'
    },
    {
        'vendor': 'Open Source',
        'product': 'Vue.js'
    },
    {
        'vendor': 'Vuelio',
        'product': 'Vuelio'
    },
    {
        'vendor': 'The Khronos Group, Inc.',
        'product': 'Vulkan'
    },
    {
        'vendor': 'Vuture, Ltd.',
        'product': 'Vuture'
    },
    {
        'vendor': 'Vyaire Medical, Inc.',
        'product': 'Vyaire AVEA'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'Vyatta'
    },
    {
        'vendor': 'Vymo, Inc.',
        'product': 'Vymo'
    },
    {
        'vendor': 'Golden Frog GmbH',
        'product': 'VyprVPN'
    },
    {
        'vendor': 'Awio Web Services, LLC',
        'product': 'W3Counter'
    },
    {
        'vendor': 'WANdisco, Inc.',
        'product': 'WANdisco'
    },
    {
        'vendor': 'Western Digital Corporation',
        'product': 'WD Arkeia'
    },
    {
        'vendor': 'Western Digital Corporation',
        'product': 'WD Red'
    },
    {
        'vendor': 'WEBeDoctor, Inc.',
        'product': 'WEBeDoctor'
    },
    {
        'vendor': 'WHMCS, Ltd.',
        'product': 'WHMCS'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'WINASAP'
    },
    {
        'vendor': 'Lanner Group, Ltd.',
        'product': 'WITNESS Horizon'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'WORKNC'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'WORKPLAN'
    },
    {
        'vendor': 'WORKetc Pty Ltd',
        'product': 'WORKetc'
    },
    {
        'vendor': 'WPEngine, Inc.',
        'product': 'WP Engine'
    },
    {
        'vendor': 'Automattic, Inc.',
        'product': 'WP Job Manager'
    },
    {
        'vendor': 'OnTheGoSystems, Ltd.',
        'product': 'WPML'
    },
    {
        'vendor': 'WRS Health',
        'product': 'WRS Health'
    },
    {
        'vendor': 'WSO2, Inc.',
        'product': 'WSO2 API Manager'
    },
    {
        'vendor': 'Wacom',
        'product': 'Wacom Tablet'
    },
    {
        'vendor': 'WageWorks, Inc.',
        'product': 'WageWorks'
    },
    {
        'vendor': 'Wagepoint, Inc.',
        'product': 'Wagepoint'
    },
    {
        'vendor': 'Wagestream, Ltd.',
        'product': 'Wagestream'
    },
    {
        'vendor': 'Wagtail',
        'product': 'Wagtail CMS'
    },
    {
        'vendor': 'Walkme, Ltd.',
        'product': 'WalkMe'
    },
    {
        'vendor': 'Wallarm, Inc.',
        'product': 'Wallarm'
    },
    {
        'vendor': 'Wallix Group',
        'product': 'Wallix'
    },
    {
        'vendor': 'ION Investment Group, Ltd.',
        'product': 'Wallstreet Suite'
    },
    {
        'vendor': 'Walmart, Inc.',
        'product': 'WalmartLabs'
    },
    {
        'vendor': 'Walmeric Soluciones S.L.',
        'product': 'Walmeric'
    },
    {
        'vendor': 'Wandera, Inc.',
        'product': 'Wandera'
    },
    {
        'vendor': 'SenX SAS',
        'product': 'Warp 10'
    },
    {
        'vendor': 'Wasabi Technologies, Inc.',
        'product': 'Wasabi'
    },
    {
        'vendor': 'Wasp Barcode Technologies, Inc.',
        'product': 'Wasp Barcode'
    },
    {
        'vendor': 'Wasp Barcode Technologies, Inc.',
        'product': 'Wasp Inventory Control'
    },
    {
        'vendor': 'WatchGuard Technologies, Inc.',
        'product': 'WatchGuard (Unspecified Product)'
    },
    {
        'vendor': 'WatchGuard Technologies, Inc.',
        'product': 'WatchGuard Firebox'
    },
    {
        'vendor': 'WatchGuard Technologies, Inc.',
        'product': 'WatchGuard XCS'
    },
    {
        'vendor': 'WatchGuard Technologies, Inc.',
        'product': 'WatchGuard XTM'
    },
    {
        'vendor': 'Educate 360, LLC',
        'product': 'Watermark'
    },
    {
        'vendor': 'Open Source',
        'product': 'Watir'
    },
    {
        'vendor': 'Wave HQ, Inc.',
        'product': 'Wave Accounting'
    },
    {
        'vendor': 'Wave HQ, Inc.',
        'product': 'Wave Payroll'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Wavefront'
    },
    {
        'vendor': 'Waypoint Software',
        'product': 'Waypoint Software'
    },
    {
        'vendor': 'Waystar, Inc.',
        'product': 'Waystar (Unspecified Product)'
    },
    {
        'vendor': 'Wazoku, Ltd.',
        'product': 'Wazoku'
    },
    {
        'vendor': 'Tencent Holdings, Ltd.',
        'product': 'WeChat Work'
    },
    {
        'vendor': 'WePay, Inc.',
        'product': 'WePay'
    },
    {
        'vendor': 'WeSuite',
        'product': 'WeSuite'
    },
    {
        'vendor': 'Weave Communications, Inc.',
        'product': 'Weave'
    },
    {
        'vendor': 'Weaveworks, Inc.',
        'product': 'Weaveworks'
    },
    {
        'vendor': 'Web CEO, LLC',
        'product': 'Web CEO'
    },
    {
        'vendor': 'Web Service Award AB',
        'product': 'Web Service Award'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'WebCT'
    },
    {
        'vendor': 'Medical Informatics Engineering, Inc.',
        'product': 'WebChart'
    },
    {
        'vendor': 'Syndigo, LLC',
        'product': 'WebCollage'
    },
    {
        'vendor': 'Bynder B.V.',
        'product': 'WebDAM'
    },
    {
        'vendor': 'South River Technologies, Inc.',
        'product': 'WebDrive'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'WebDriverIO'
    },
    {
        'vendor': 'Juvare, LLC',
        'product': 'WebEOC'
    },
    {
        'vendor': 'Webklipper Technologies Pvt Ltd',
        'product': 'WebEngage'
    },
    {
        'vendor': 'Information Builders, Inc.',
        'product': 'WebFOCUS'
    },
    {
        'vendor': 'WebGozar.com',
        'product': 'WebGozar'
    },
    {
        'vendor': 'Verge, Inc.',
        'product': 'WebHR'
    },
    {
        'vendor': 'Open Source',
        'product': 'WebIssues'
    },
    {
        'vendor': 'Advanced E Media, Inc.',
        'product': 'WebJaguar'
    },
    {
        'vendor': 'WebMD, LLC',
        'product': 'WebMD'
    },
    {
        'vendor': 'Software AG',
        'product': 'WebMethods'
    },
    {
        'vendor': 'CAI Networks, Inc.',
        'product': 'WebMux'
    },
    {
        'vendor': 'LG Electronics, Inc.',
        'product': 'WebOS'
    },
    {
        'vendor': 'WebPT, Inc.',
        'product': 'WebPT'
    },
    {
        'vendor': 'Paylocity Corporation',
        'product': 'WebPay'
    },
    {
        'vendor': 'WebProspector GmbH',
        'product': 'WebProspector'
    },
    {
        'vendor': 'World Web Technologies, Inc.',
        'product': 'WebRezPro'
    },
    {
        'vendor': 'GoDaddy.com, LLC',
        'product': 'WebSite Tonight'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'WebSphere Portal Server'
    },
    {
        'vendor': 'TitanHQ',
        'product': 'WebTitan'
    },
    {
        'vendor': 'Yandex, LLC',
        'product': 'WebVisor'
    },
    {
        'vendor': 'Webasyst, LLC',
        'product': 'Webasyst'
    },
    {
        'vendor': 'Webflow, Inc.',
        'product': 'Webflow'
    },
    {
        'vendor': 'Scholl Communications AG',
        'product': 'Weblication'
    },
    {
        'vendor': 'WebLinc Corporation',
        'product': 'Weblinc'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Webmedx'
    },
    {
        'vendor': 'IP WEB SERVICES S.L.U.',
        'product': 'Webphone'
    },
    {
        'vendor': 'Webroot, Inc.',
        'product': 'Webroot (Unspecified Product)'
    },
    {
        'vendor': 'Webroot, Inc.',
        'product': 'Webroot Business Endpoint Protection'
    },
    {
        'vendor': 'Webroot, Inc.',
        'product': 'Webroot DNS Protection'
    },
    {
        'vendor': 'WebsPlanet, Ltd.',
        'product': 'WebsPlanet'
    },
    {
        'vendor': 'WebsPlanet, Ltd.',
        'product': 'WebsPlanet Cosmos'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Websense'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Websense SurfControl'
    },
    {
        'vendor': 'WebsiteAlive',
        'product': 'WebsiteAlive'
    },
    {
        'vendor': 'Webtrekk GmbH',
        'product': 'Webtrekk'
    },
    {
        'vendor': 'Webtrends, Inc.',
        'product': 'Webtrends'
    },
    {
        'vendor': 'Xfive.co Pty Ltd',
        'product': 'Webvanta Cloud CMS'
    },
    {
        'vendor': 'Webware.io',
        'product': 'Webware.io'
    },
    {
        'vendor': 'Wedia',
        'product': 'Wedia'
    },
    {
        'vendor': 'Square, Inc.',
        'product': 'Weebly'
    },
    {
        'vendor': 'Weights & Biases, Inc.',
        'product': 'Weights & Biases'
    },
    {
        'vendor': 'Fiserv, Inc.',
        'product': 'Weiland BRMedge'
    },
    {
        'vendor': 'Open Source',
        'product': 'Weka'
    },
    {
        'vendor': 'Welch Allyn, Inc.',
        'product': 'Welch Allyn'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'WellSky'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'WellSky (Unspecified Product)'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'WellSky Blood Center'
    },
    {
        'vendor': 'Health Care Software, Inc.',
        'product': 'WellSky LTACH'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'WellSky Scheduling'
    },
    {
        'vendor': 'Welligent, Inc.',
        'product': 'Welligent'
    },
    {
        'vendor': 'WellnessLiving Systems, Inc.',
        'product': 'WellnessLiving'
    },
    {
        'vendor': 'WellSky Corporation',
        'product': 'Wellsky Transfusion'
    },
    {
        'vendor': 'Medsphere Systems Corporation',
        'product': 'Wellsoft'
    },
    {
        'vendor': 'Welltok, Inc.',
        'product': 'Welltok'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Wercker'
    },
    {
        'vendor': 'West Corporation',
        'product': 'West Corporation (Unspecified Product)'
    },
    {
        'vendor': 'West-Com Nurse Call System, Inc.',
        'product': 'West-Com'
    },
    {
        'vendor': 'Western Digital Corporation',
        'product': 'Western Digital Data Center Drives'
    },
    {
        'vendor': 'WEX, Inc.',
        'product': 'Wex'
    },
    {
        'vendor': 'WhatCounts, Inc.',
        'product': 'WhatCounts'
    },
    {
        'vendor': 'WhatRunsWhere',
        'product': 'WhatRunsWhere'
    },
    {
        'vendor': 'Whatfix',
        'product': 'Whatfix'
    },
    {
        'vendor': 'WhatsApp, Inc.',
        'product': 'WhatsApp'
    },
    {
        'vendor': 'WhatsApp, Inc.',
        'product': 'WhatsApp Share'
    },
    {
        'vendor': 'WhereScape Software, Ltd.',
        'product': 'WhereScape'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Whipple Hill'
    },
    {
        'vendor': 'WhirlWind Software, LLC',
        'product': 'WhirlWind'
    },
    {
        'vendor': 'Whisbi Technologies S.L.',
        'product': 'Whisbi'
    },
    {
        'vendor': 'Whispir.com, Inc.',
        'product': 'Whispir'
    },
    {
        'vendor': 'White Fluffy Cloud, Ltd.',
        'product': 'White Fluffy Cloud'
    },
    {
        'vendor': 'WhiteHat Security, Inc.',
        'product': 'WhiteHat Security'
    },
    {
        'vendor': 'WhiteHat Security, Inc.',
        'product': 'WhiteHat Sentinel Dynamic'
    },
    {
        'vendor': 'WhiteHat Security, Inc.',
        'product': 'WhiteHat Sentinel Mobile'
    },
    {
        'vendor': 'WhiteHat Security, Inc.',
        'product': 'WhiteHat Sentinel Source'
    },
    {
        'vendor': 'WhiteHat Security, Inc.',
        'product': 'WhiteHat eLearning'
    },
    {
        'vendor': 'White Source, Ltd.',
        'product': 'WhiteSource'
    },
    {
        'vendor': 'Whitespark, Inc.',
        'product': 'Whitespark'
    },
    {
        'vendor': 'Parker Software, Inc.',
        'product': 'WhosOn'
    },
    {
        'vendor': 'Whova, Inc.',
        'product': 'Whova'
    },
    {
        'vendor': 'Wibbitz, Ltd.',
        'product': 'Wibbitz'
    },
    {
        'vendor': 'WideOrbit, Inc.',
        'product': 'WideOrbit'
    },
    {
        'vendor': 'Widen Enterprises, Inc.',
        'product': 'Widen Collective'
    },
    {
        'vendor': 'Wild Apricot, Inc.',
        'product': 'Wild Apricot'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'WildFly'
    },
    {
        'vendor': 'Willis Towers Watson PLC',
        'product': 'Willis Towers Watson'
    },
    {
        'vendor': 'Willis Towers Watson PLC',
        'product': 'Willis Towers Watson Radar'
    },
    {
        'vendor': 'NTT Advanced Technology Corporation',
        'product': 'WinActor'
    },
    {
        'vendor': 'Softomotive',
        'product': 'WinAutomation'
    },
    {
        'vendor': 'Ebix, Inc.',
        'product': 'WinBEAT'
    },
    {
        'vendor': 'WinMagic, Inc.',
        'product': 'WinMagic'
    },
    {
        'vendor': 'Interactive Business Systems, Inc.',
        'product': 'WinPharm'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'WinRunner'
    },
    {
        'vendor': 'Computer Trust Corporation',
        'product': 'WinSURGE'
    },
    {
        'vendor': 'TEAM Software, Inc.',
        'product': 'WinTeam'
    },
    {
        'vendor': 'Wind River Systems, Inc.',
        'product': 'Wind River'
    },
    {
        'vendor': 'Wind River Systems, Inc.',
        'product': 'Wind River VxWorks'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'Windchill Product Analytics'
    },
    {
        'vendor': 'Psyche Systems Corporation',
        'product': 'WindoPath E.ssential'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows 10'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows 7'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Azure Pack'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Defender Antivirus'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Embedded Compact'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Live Writer'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Server 2000'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Server 2003'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Server 2008'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Server 2012'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Server 2016'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Storage Spaces Direct'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Vista'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows Workflow Foundation'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Windows XP'
    },
    {
        'vendor': 'Windream GmbH',
        'product': 'Windream'
    },
    {
        'vendor': 'Windstream Services, LLC',
        'product': 'Windstream'
    },
    {
        'vendor': 'Windstream Services, LLC',
        'product': 'Windstream Hosting'
    },
    {
        'vendor': 'Sceptre Hospitality Resources, LLC',
        'product': 'Windsurfer CRS'
    },
    {
        'vendor': 'Windward Studios, Inc.',
        'product': 'Windward'
    },
    {
        'vendor': 'Windward Software',
        'product': 'Windward System Five'
    },
    {
        'vendor': 'Wingspan Technology, Inc.',
        'product': 'Wingspan eTMF'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'Winscribe'
    },
    {
        'vendor': 'Winshuttle, LLC',
        'product': 'Winshuttle'
    },
    {
        'vendor': 'Intac International, LLC',
        'product': 'Wintac'
    },
    {
        'vendor': 'Wintertree Software, Inc.',
        'product': 'Wintertree'
    },
    {
        'vendor': 'Wipro, Ltd.',
        'product': 'Wipro Gallagher'
    },
    {
        'vendor': 'Wipro Gallagher Solutions, LLC',
        'product': 'Wipro Gallagher NetOxygen LOS'
    },
    {
        'vendor': 'Wipro, Ltd.',
        'product': 'Wipro Holmes'
    },
    {
        'vendor': 'WireWheel, Inc.',
        'product': 'WireWheel'
    },
    {
        'vendor': 'Wirecard AG',
        'product': 'Wirecard'
    },
    {
        'vendor': 'Brother International Corporation',
        'product': 'WiredRed'
    },
    {
        'vendor': 'Shift Media Holdings, Inc.',
        'product': 'Wiredrive'
    },
    {
        'vendor': 'CalAmp Corporation',
        'product': 'Wireless Matrix FleetOutlook'
    },
    {
        'vendor': 'B2B Soft, Inc.',
        'product': 'Wireless Standard POS'
    },
    {
        'vendor': 'Open Source',
        'product': 'Wireshark'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'Wisely Pay'
    },
    {
        'vendor': 'Wisetail',
        'product': 'Wisetail LMS'
    },
    {
        'vendor': 'Wishpond Technologies, Ltd.',
        'product': 'Wishpond'
    },
    {
        'vendor': 'Wistia, Inc.',
        'product': 'Wistia'
    },
    {
        'vendor': 'WITRON Logistik + Informatik GmbH',
        'product': 'Witron'
    },
    {
        'vendor': 'WittyParrot',
        'product': 'WittyParrot'
    },
    {
        'vendor': 'Wix.com, Inc.',
        'product': 'Wix Editor'
    },
    {
        'vendor': 'Wix.com, Inc.',
        'product': 'Wix Stores'
    },
    {
        'vendor': 'Wix.com, Inc.',
        'product': 'Wix.com'
    },
    {
        'vendor': 'WizIQ',
        'product': 'WizIQ LMS'
    },
    {
        'vendor': 'Wizeline, Inc.',
        'product': 'Wizeline'
    },
    {
        'vendor': 'Wodify Technologies, Ltd.',
        'product': 'Wodify (Unspecified Product)'
    },
    {
        'vendor': 'Telus Health',
        'product': 'Wolf EMR'
    },
    {
        'vendor': 'Wolfram Research, Inc.',
        'product': 'Wolfram Mathematica'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer (Unspecified Product)'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer ATX'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer CCH'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer Commerce Clearing House (CCH)'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer ComplianceOne'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer Passport'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer Twinfield'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'Wolters Kluwer hCue'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Wombat Security'
    },
    {
        'vendor': 'Wonder',
        'product': 'Wonder'
    },
    {
        'vendor': 'Automattic, Inc.',
        'product': 'WooCommerce'
    },
    {
        'vendor': 'Woobox, LLC',
        'product': 'Woobox'
    },
    {
        'vendor': 'WoodWing Software B.V.',
        'product': 'WoodWing'
    },
    {
        'vendor': 'Woopra, Inc.',
        'product': 'Woopra'
    },
    {
        'vendor': 'WOAS Technology Pvt Ltd',
        'product': 'Wooqer'
    },
    {
        'vendor': 'WooRank sprl',
        'product': 'Woorank'
    },
    {
        'vendor': 'Wootric',
        'product': 'Wootric'
    },
    {
        'vendor': 'Automattic, Inc.',
        'product': 'WordPress'
    },
    {
        'vendor': 'Defiant, Inc.',
        'product': 'Wordfence'
    },
    {
        'vendor': 'WordPress.com',
        'product': 'Wordpress SSL'
    },
    {
        'vendor': 'Automated Insights, Inc.',
        'product': 'Wordsmith'
    },
    {
        'vendor': 'WordStream, Inc.',
        'product': 'Wordstream'
    },
    {
        'vendor': 'Wordtracker LLP',
        'product': 'Wordtracker'
    },
    {
        'vendor': 'WorkBoard, Inc.',
        'product': 'WorkBoard'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'WorkBook'
    },
    {
        'vendor': 'WorkBright',
        'product': 'WorkBright'
    },
    {
        'vendor': 'WorkFusion, Inc.',
        'product': 'WorkFusion'
    },
    {
        'vendor': 'WorkMarket, Inc.',
        'product': 'WorkMarket'
    },
    {
        'vendor': 'WorkOtter',
        'product': 'WorkOtter'
    },
    {
        'vendor': 'WorkRamp, Inc.',
        'product': 'WorkRamp'
    },
    {
        'vendor': 'Telus Health',
        'product': 'WorkSafeBC'
    },
    {
        'vendor': 'WorkWave, LLC',
        'product': 'WorkWave PestPac'
    },
    {
        'vendor': 'WorkWave, LLC',
        'product': 'WorkWave ServMan'
    },
    {
        'vendor': 'WorkWise, LLC',
        'product': 'WorkWise ERP'
    },
    {
        'vendor': 'WorkZone, LLC',
        'product': 'WorkZone'
    },
    {
        'vendor': 'Workable Software, Ltd.',
        'product': 'Workable'
    },
    {
        'vendor': 'Workamajig',
        'product': 'Workamajig'
    },
    {
        'vendor': 'WebLinc Corporation',
        'product': 'Workarea'
    },
    {
        'vendor': 'Workato, Inc.',
        'product': 'Workato'
    },
    {
        'vendor': 'Workbooks Online, Ltd.',
        'product': 'Workbooks'
    },
    {
        'vendor': 'Workbooks Online, Ltd.',
        'product': 'Workbooks CRM'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Absence Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Academic Advising'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Academic Foundation'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Accounting Center'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Accounting and Finance'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Adaptive Planning'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Benefits'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Business Planning'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Cloud Platform'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Compensation'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Curriculum Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Data-as-a-Service'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Expenses'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Financial Aid'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Financial Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Financial Planning'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Financial Reporting and Analytics'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Grants Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday HCM Reporting and Analytics'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Human Capital Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Human Resource Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Integration Cloud'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Inventory'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Launch'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Learning'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Payroll'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday People Analytics'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Prism Analytics'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Procurement'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Professional Services Automation'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Projects'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Recruiting'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Revenue Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Student'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Student Admissions'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Student Financials'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Student Records'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Student Recruiting'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Talent Management'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Talent and Performance'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Time Tracking'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Time and Absence'
    },
    {
        'vendor': 'Workday, Inc.',
        'product': 'Workday Workforce Planning'
    },
    {
        'vendor': 'Advantys Solutions, Ltd.',
        'product': 'WorkflowGen'
    },
    {
        'vendor': 'Xero, Ltd.',
        'product': 'WorkflowMax'
    },
    {
        'vendor': 'WorkForce Software, LLC',
        'product': 'Workforce Software'
    },
    {
        'vendor': 'Workfront, Inc.',
        'product': 'Workfront (Unspecified Product)'
    },
    {
        'vendor': 'Workhuman',
        'product': 'Workhuman'
    },
    {
        'vendor': 'Workiva, Inc.',
        'product': 'Workiva'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Workplace by Facebook'
    },
    {
        'vendor': 'Workpop, Inc.',
        'product': 'Workpop'
    },
    {
        'vendor': 'Worksoft, Inc.',
        'product': 'Worksoft'
    },
    {
        'vendor': 'Worksoft, Inc.',
        'product': 'Worksoft Certify'
    },
    {
        'vendor': 'Worksoft, Inc.',
        'product': 'Worksoft Execution Manager'
    },
    {
        'vendor': 'Workspot, Inc.',
        'product': 'Workspot (Unspecified Product)'
    },
    {
        'vendor': 'Workstream Technologies, Inc.',
        'product': 'Workstream'
    },
    {
        'vendor': 'Workvivo, Ltd.',
        'product': 'Workvivo'
    },
    {
        'vendor': 'WorldAware, Inc.',
        'product': 'WorldAware'
    },
    {
        'vendor': 'World Software Corporation',
        'product': 'Worldox'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'Worldpay'
    },
    {
        'vendor': 'WorldwideDNS',
        'product': 'WorldwideDNS'
    },
    {
        'vendor': 'Net Health',
        'product': 'WoundExpert'
    },
    {
        'vendor': 'Wowza Media Systems, LLC',
        'product': 'Wowza'
    },
    {
        'vendor': 'Wrike, Inc.',
        'product': 'Wrike'
    },
    {
        'vendor': 'Addison Health Systems, Inc.',
        'product': 'WritePad'
    },
    {
        'vendor': 'WriterAccess.com, Inc.',
        'product': 'WriterAccess'
    },
    {
        'vendor': 'SurveyMonkey, Inc.',
        'product': 'Wufoo'
    },
    {
        'vendor': 'TWC Product and Technology, LLC',
        'product': 'Wunderground'
    },
    {
        'vendor': 'Wunderkind Corporation',
        'product': 'Wunderkind'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Wunderlist'
    },
    {
        'vendor': 'Wyng, Inc.',
        'product': 'Wyng'
    },
    {
        'vendor': 'IDFR SARL',
        'product': 'WysiStat'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'X by Invincea'
    },
    {
        'vendor': 'Seller Labs, LLC',
        'product': 'X-Cart'
    },
    {
        'vendor': 'X-Ways Software Technology AG',
        'product': 'X-Ways'
    },
    {
        'vendor': 'X1 DISCOVERY, Inc.',
        'product': 'X1 (Unspecified Product)'
    },
    {
        'vendor': 'XANT, Inc.',
        'product': 'XANT Cloud'
    },
    {
        'vendor': 'XANT, Inc.',
        'product': 'XANT Playbooks'
    },
    {
        'vendor': 'Xenialab S.R.L.',
        'product': 'XCALLY'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'XCUITest'
    },
    {
        'vendor': 'XDimensional Technologies, Inc.',
        'product': 'XDimensional'
    },
    {
        'vendor': 'Open Source',
        'product': 'XGBoost'
    },
    {
        'vendor': 'XIFIN, Inc.',
        'product': 'XIFIN RPM'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'XMPie'
    },
    {
        'vendor': 'XMedius Solutions, Inc.',
        'product': 'XMedius (Unspecified Product)'
    },
    {
        'vendor': 'XO Communications, LLC',
        'product': 'XO Communications'
    },
    {
        'vendor': 'XO Communications, LLC',
        'product': 'XO Communications Hosting'
    },
    {
        'vendor': 'XPS Parcel',
        'product': 'XPS Parcel'
    },
    {
        'vendor': 'World Wide Web Consortium',
        'product': 'XPath'
    },
    {
        'vendor': 'Omnitracs, LLC',
        'product': 'XRS Platform'
    },
    {
        'vendor': 'XSOLIS',
        'product': 'XSOLIS'
    },
    {
        'vendor': 'Xserver, Inc.',
        'product': 'XServer'
    },
    {
        'vendor': 'XTools Pro, Inc.',
        'product': 'XTools Pro'
    },
    {
        'vendor': 'DataEnter GmbH',
        'product': 'XWall'
    },
    {
        'vendor': 'XWiki',
        'product': 'XWiki'
    },
    {
        'vendor': 'Xactly Corporation',
        'product': 'Xactly (Unspecified Product)'
    },
    {
        'vendor': 'Xactly Corporation',
        'product': 'Xactly AlignStar'
    },
    {
        'vendor': 'Xactly Corporation',
        'product': 'Xactly Connect'
    },
    {
        'vendor': 'Verisk Analytics, Inc.',
        'product': 'Xactware (Unspecified Product)'
    },
    {
        'vendor': 'Xait',
        'product': 'XaitPorter'
    },
    {
        'vendor': 'Xajax',
        'product': 'Xajax'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Xamarin'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Xamarin Calabash'
    },
    {
        'vendor': 'TierPoint, LLC',
        'product': 'Xand'
    },
    {
        'vendor': 'Xandr, Inc.',
        'product': 'Xandr'
    },
    {
        'vendor': 'Xandr, Inc.',
        'product': 'Xandr Monetize'
    },
    {
        'vendor': 'Virtana',
        'product': 'Xangati'
    },
    {
        'vendor': 'Xara',
        'product': 'Xara'
    },
    {
        'vendor': 'Xaxis, LLC',
        'product': 'Xaxis'
    },
    {
        'vendor': 'Resolution Software, Ltd.',
        'product': 'Xcase'
    },
    {
        'vendor': 'Digital.ai Software, Inc.',
        'product': 'XebiaLabs'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Xen Project'
    },
    {
        'vendor': 'Xenialab S.R.L.',
        'product': 'Xenialab'
    },
    {
        'vendor': 'Profidata Group AG',
        'product': 'Xentis'
    },
    {
        'vendor': 'Xero, Ltd.',
        'product': 'Xero'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox (Unspecified Product)'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox 495'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox 550'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox 560'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox 6622'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox 700'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox 770'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox CentreWare'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox CiPress'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox Color 1000'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox Color 800'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox ColorQube'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox D110'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox D125'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox D136'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox D95'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuColor'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuColor 12'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuColor 5000'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuPrint'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuSP'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuShare'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuTech'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuTech 180 HLC'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox DocuTech 6180'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox FreeFlow Core'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox Managed Print Services'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox Nuvera'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox OmniX'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox Phaser'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox WorkCentre'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox XTCM'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox iGen 150'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox iGen4'
    },
    {
        'vendor': 'Xerox Corporation',
        'product': 'Xerox iGen5'
    },
    {
        'vendor': 'AT Internet, Ltd.',
        'product': 'XiTi'
    },
    {
        'vendor': 'Xilinx, Inc.',
        'product': 'Xilinx (Unspecified Product)'
    },
    {
        'vendor': 'Xilinx, Inc.',
        'product': 'Xilinx ISE'
    },
    {
        'vendor': 'Xilinx, Inc.',
        'product': 'Xilinx Vivado'
    },
    {
        'vendor': 'Xima, LLC',
        'product': 'Xima Software'
    },
    {
        'vendor': 'BigTinCan Mobile Pty Ltd',
        'product': 'Xinnovation'
    },
    {
        'vendor': 'Violin Systems, LLC',
        'product': 'Xiotech'
    },
    {
        'vendor': 'XipLink, Inc.',
        'product': 'XipLink'
    },
    {
        'vendor': 'Riverbed Technology, Inc.',
        'product': 'Xirrus'
    },
    {
        'vendor': 'Google Cloud Platform',
        'product': 'Xively'
    },
    {
        'vendor': 'Xledger, Inc.',
        'product': 'Xledger'
    },
    {
        'vendor': 'Xoran Technologies, LLC',
        'product': 'Xoran MiniCAT'
    },
    {
        'vendor': 'Xpandion, Inc.',
        'product': 'Xpandion ProfileTailor'
    },
    {
        'vendor': 'Mentor Graphics Corporation',
        'product': 'Xpedition'
    },
    {
        'vendor': 'GX Software B.V.',
        'product': 'XperienCentral'
    },
    {
        'vendor': 'Xperthis S.A.',
        'product': 'Xperthis'
    },
    {
        'vendor': 'Xplenty, Ltd.',
        'product': 'Xplenty'
    },
    {
        'vendor': 'Xpand IT Solutions Lda.',
        'product': 'Xray'
    },
    {
        'vendor': 'xt: Commerce GmbH',
        'product': 'Xt-commerce'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Xtraction'
    },
    {
        'vendor': 'XtremeData, Inc.',
        'product': 'XtremeData'
    },
    {
        'vendor': 'Ensure Technologies, Inc.',
        'product': 'Xyloc'
    },
    {
        'vendor': 'Xymon',
        'product': 'Xymon'
    },
    {
        'vendor': 'Blackboard, Inc.',
        'product': 'Xythos'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'YES Energy Management'
    },
    {
        'vendor': 'Yoobic, Ltd.',
        'product': 'YOOBIC'
    },
    {
        'vendor': 'YOOtheme GmbH',
        'product': 'YOOtheme'
    },
    {
        'vendor': 'YPrime, LLC',
        'product': 'YPrime IRT+'
    },
    {
        'vendor': 'Y Soft Corporation A/S',
        'product': 'YSoft'
    },
    {
        'vendor': 'Yahoo!',
        'product': 'Yahoo Image CDN'
    },
    {
        'vendor': 'Yahoo!',
        'product': 'Yahoo Mail'
    },
    {
        'vendor': 'Yahoo! CV, LLC',
        'product': 'Yahoo Store'
    },
    {
        'vendor': 'Yahoo! CV, LLC',
        'product': 'Yahoo Tag Manager'
    },
    {
        'vendor': 'Yahoo!',
        'product': 'Yahoo User Interface'
    },
    {
        'vendor': 'Yahoo Japan Corporation',
        'product': 'Yahoo! Japan Promotional Ads'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Yahoo! Small Business'
    },
    {
        'vendor': 'Verizon Media',
        'product': 'Yahoo! Web Analytics'
    },
    {
        'vendor': 'Yandex, LLC',
        'product': 'Yandex (Unspecified Product)'
    },
    {
        'vendor': 'Yandex, LLC',
        'product': 'Yandex ClickHouse'
    },
    {
        'vendor': 'Yandex, LLC',
        'product': 'Yandex Direct'
    },
    {
        'vendor': 'Yandex, LLC',
        'product': 'Yandex Metrica'
    },
    {
        'vendor': 'Yandex, LLC',
        'product': 'Yandex Metrika'
    },
    {
        'vendor': 'YapStone, Inc.',
        'product': 'YapStone'
    },
    {
        'vendor': 'YB Media, LLC',
        'product': 'Yardbarker'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi (Unspecified Product)'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Advanced Budgeting & Forecasting (ABF)'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Affordable Housing Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Commercial Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi EHR'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Genesis2'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Investment Management'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Military Housing Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Multifamily Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Orion Business Intelligence'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi PAYscan'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Procure to Pay Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi RentCafe'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Single Family Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Voyager'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi eMAR'
    },
    {
        'vendor': 'YayPay, Inc.',
        'product': 'YayPay'
    },
    {
        'vendor': 'Yealink, Inc.',
        'product': 'Yealink'
    },
    {
        'vendor': 'Yellow Dog Software, LLC',
        'product': 'Yellow Dog'
    },
    {
        'vendor': 'Bitonic Labs, Ltd.',
        'product': 'Yellow Messenger'
    },
    {
        'vendor': 'Yellowbrick Data, Inc.',
        'product': 'Yellowbrick Data'
    },
    {
        'vendor': 'Yellowfin International Pty Ltd',
        'product': 'Yellowfin'
    },
    {
        'vendor': 'Yes Marketing',
        'product': 'Yesmail360i'
    },
    {
        'vendor': 'Yesware, Inc.',
        'product': 'Yesware'
    },
    {
        'vendor': 'YetiForce Sp. z o.o.',
        'product': 'YetiForce'
    },
    {
        'vendor': 'Yext, Inc.',
        'product': 'Yext'
    },
    {
        'vendor': 'Yieldbot, Inc.',
        'product': 'Yieldbot'
    },
    {
        'vendor': 'Yieldify',
        'product': 'Yieldify'
    },
    {
        'vendor': 'Yieldmo, Inc.',
        'product': 'Yieldmo'
    },
    {
        'vendor': 'Yii Software, LLC',
        'product': 'Yii Framework'
    },
    {
        'vendor': 'Yoast B.V.',
        'product': 'Yoast'
    },
    {
        'vendor': 'VizTrend Oy',
        'product': 'Yodiz'
    },
    {
        'vendor': 'Yodle Web.com, Inc.',
        'product': 'Yodle'
    },
    {
        'vendor': 'Yodlee, Inc.',
        'product': 'Yodlee'
    },
    {
        'vendor': 'Yonyou Network Company, Ltd.',
        'product': 'Yonyou'
    },
    {
        'vendor': 'Yonyx, Inc.',
        'product': 'Yonyx'
    },
    {
        'vendor': 'Yooz',
        'product': 'Yooz'
    },
    {
        'vendor': 'Yotpo, Inc.',
        'product': 'Yotpo'
    },
    {
        'vendor': 'Yottaa, Inc.',
        'product': 'Yottaa'
    },
    {
        'vendor': 'Youmeng Tongxin (Beijing) Technology Company, Ltd.',
        'product': 'Youmeng +'
    },
    {
        'vendor': 'YourAmigo',
        'product': 'YourAmigo'
    },
    {
        'vendor': 'YourCause, LLC',
        'product': 'YourCause'
    },
    {
        'vendor': 'YourMembership',
        'product': 'YourMembership'
    },
    {
        'vendor': 'Cegid Group',
        'product': 'Yourcegid Retail'
    },
    {
        'vendor': 'Youtube, LLC',
        'product': 'Youtube'
    },
    {
        'vendor': 'RhythmOne, LLC',
        'product': 'YuMe'
    },
    {
        'vendor': 'Yubico AB',
        'product': 'YubiKey'
    },
    {
        'vendor': 'YugaByte, Inc.',
        'product': 'YugaByteDB'
    },
    {
        'vendor': 'Yummly, Inc.',
        'product': 'Yummly'
    },
    {
        'vendor': 'Pixologic, Inc.',
        'product': 'ZBrush'
    },
    {
        'vendor': 'ZINFI Technologies, Inc.',
        'product': 'ZINFI'
    },
    {
        'vendor': 'ZIVVER B.V.',
        'product': 'ZIVVER'
    },
    {
        'vendor': 'ZL Technologies, Inc.',
        'product': 'ZL Technologies'
    },
    {
        'vendor': 'ZOLL Data Systems, Inc.',
        'product': 'ZOLL Data'
    },
    {
        'vendor': 'ZTE Corporation',
        'product': 'ZTE'
    },
    {
        'vendor': 'Zabbix, LLC',
        'product': 'Zabbix'
    },
    {
        'vendor': 'Zadara Storage, Inc.',
        'product': 'Zadara'
    },
    {
        'vendor': 'Zadarma Corporate Group',
        'product': 'Zadarma'
    },
    {
        'vendor': 'Zaloni, Inc.',
        'product': 'Zaloni Arena'
    },
    {
        'vendor': 'Zapier, Inc.',
        'product': 'Zapier'
    },
    {
        'vendor': 'Zapproved, LLC',
        'product': 'Zapproved'
    },
    {
        'vendor': 'Zayo Group Holdings, Inc.',
        'product': 'Zayo'
    },
    {
        'vendor': 'Zazzle, Inc.',
        'product': 'Zazzle'
    },
    {
        'vendor': 'ZeOmega, Inc.',
        'product': 'ZeOmega'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra 105SL'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra 2844'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra S4M'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra Symbol'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra Technologies'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra Xi4'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra Z4M'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra ZM400'
    },
    {
        'vendor': 'Zebra Technologies Corporation',
        'product': 'Zebra ZM600'
    },
    {
        'vendor': 'ZEDO, Inc.',
        'product': 'Zedo'
    },
    {
        'vendor': 'The Zeek Project',
        'product': 'Zeek'
    },
    {
        'vendor': 'Zellis UK, Ltd.',
        'product': 'Zellis'
    },
    {
        'vendor': 'Zemanta, Inc.',
        'product': 'Zemanta'
    },
    {
        'vendor': 'Zemax, LLC',
        'product': 'Zemax OpticStudio'
    },
    {
        'vendor': 'Zen Ventures, LLC',
        'product': 'Zen Cart'
    },
    {
        'vendor': 'Zen Planner, LLC',
        'product': 'Zen Planner'
    },
    {
        'vendor': 'ZenCharts, LLC',
        'product': 'ZenCharts'
    },
    {
        'vendor': 'ZenLeads, Inc.',
        'product': 'ZenProspect'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Zend Framework'
    },
    {
        'vendor': 'Perforce Software, Inc.',
        'product': 'Zend Server'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Chat'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Connect'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Explore'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Guide'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Sell'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Sunshine'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Support'
    },
    {
        'vendor': 'Zendesk, Inc.',
        'product': 'Zendesk Talk'
    },
    {
        'vendor': 'Zenefits',
        'product': 'Zenefits'
    },
    {
        'vendor': 'Zenfolio, Inc.',
        'product': 'Zenfolio'
    },
    {
        'vendor': 'Zenidoc S.A.',
        'product': 'Zenidoc'
    },
    {
        'vendor': 'Zenith Infotech Pte Ltd',
        'product': 'Zenith ARCA'
    },
    {
        'vendor': 'Serko, Ltd.',
        'product': 'Zeno'
    },
    {
        'vendor': 'Zenoss, Inc.',
        'product': 'Zenoss'
    },
    {
        'vendor': 'Zenoti',
        'product': 'Zenoti'
    },
    {
        'vendor': 'Citrix Systems, Inc.',
        'product': 'Zenprise'
    },
    {
        'vendor': 'Zenput, Inc.',
        'product': 'Zenput'
    },
    {
        'vendor': 'Zenvia',
        'product': 'Zenvia'
    },
    {
        'vendor': 'Dr. Heni SOFTWARE GmbH',
        'product': 'Zenzy'
    },
    {
        'vendor': 'SmartBear Software, Inc.',
        'product': 'Zephyr Capture for Jira'
    },
    {
        'vendor': 'Zergnet',
        'product': 'Zergnet'
    },
    {
        'vendor': 'Simpleview, LLC',
        'product': 'Zerista'
    },
    {
        'vendor': 'ZeroFOX, Inc.',
        'product': 'ZeroFOX'
    },
    {
        'vendor': 'Open Source',
        'product': 'ZeroMQ'
    },
    {
        'vendor': 'ZeroLag Communications, Inc.',
        'product': 'Zerolag'
    },
    {
        'vendor': 'Zerto, Ltd.',
        'product': 'Zerto'
    },
    {
        'vendor': 'Zerys',
        'product': 'Zerys'
    },
    {
        'vendor': 'Zeta Interactive Corporation',
        'product': 'Zeta'
    },
    {
        'vendor': 'Equisys, Ltd.',
        'product': 'Zetadocs'
    },
    {
        'vendor': 'Equisys, Ltd.',
        'product': 'Zetafax'
    },
    {
        'vendor': 'Pulse Secure, LLC',
        'product': 'Zeus Extensible Traffic Manager'
    },
    {
        'vendor': 'DASAN Zhone Solutions, Inc.',
        'product': 'Zhone'
    },
    {
        'vendor': 'DASAN Zhone Solutions, Inc.',
        'product': 'Zhone MXK 819'
    },
    {
        'vendor': 'Zift Solutions, Inc.',
        'product': 'Zift PRM'
    },
    {
        'vendor': 'Zift Solutions, Inc.',
        'product': 'Zift Solutions'
    },
    {
        'vendor': 'Ziften Technologies, Inc.',
        'product': 'Ziften'
    },
    {
        'vendor': 'Zigbee Alliance',
        'product': 'Zigbee (Unspecified Product)'
    },
    {
        'vendor': 'Zigbee Alliance',
        'product': 'Zigbee Alliance (Unspecified Product)'
    },
    {
        'vendor': 'Zignal Labs, Inc.',
        'product': 'Zignal Labs'
    },
    {
        'vendor': 'Ziiva',
        'product': 'Ziiva'
    },
    {
        'vendor': 'Zilliant, Inc.',
        'product': 'Zilliant'
    },
    {
        'vendor': 'Synacor, Inc.',
        'product': 'Zimbra'
    },
    {
        'vendor': 'Zimperium, Inc.',
        'product': 'Zimperium'
    },
    {
        'vendor': 'ZineOne, Inc.',
        'product': 'ZineOne'
    },
    {
        'vendor': 'Cnergyis Infotech India Pvt Ltd',
        'product': 'ZingHR'
    },
    {
        'vendor': 'Zinio, LLC',
        'product': 'Zinio'
    },
    {
        'vendor': 'Zinrelo',
        'product': 'Zinrelo'
    },
    {
        'vendor': 'ZipRecruiter, Inc.',
        'product': 'ZipRecruiter'
    },
    {
        'vendor': 'Open Source',
        'product': 'Zipkin'
    },
    {
        'vendor': 'Zipnosis, Inc.',
        'product': 'Zipnosis'
    },
    {
        'vendor': 'Waystar, Inc.',
        'product': 'ZirMed'
    },
    {
        'vendor': 'Zix Corporation',
        'product': 'Zix (Unspecified Product)'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'ZixGateway'
    },
    {
        'vendor': 'Zix Corporation',
        'product': 'ZixMail'
    },
    {
        'vendor': 'Zix Corporation',
        'product': 'ZixOne'
    },
    {
        'vendor': 'zkipster AG',
        'product': 'Zkipster'
    },
    {
        'vendor': 'Zmags, Inc.',
        'product': 'Zmags'
    },
    {
        'vendor': 'Betsol, Inc.',
        'product': 'Zmanda Enterprise Backup'
    },
    {
        'vendor': 'Znode, LLC',
        'product': 'Znode'
    },
    {
        'vendor': 'Znode, LLC',
        'product': 'Znode Multi-Store'
    },
    {
        'vendor': 'Zoey, Inc.',
        'product': 'Zoey'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Analytics'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Books'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho CRM'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho CRM Plus'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Campaigns'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Creator'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Desk'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Docs'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Expense'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Forms'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Inventory'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Invoice'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Mail'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Office Suite'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho One'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho People'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Projects'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Recruit'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Reports'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho SalesIQ'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Social'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Sprints'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Survey'
    },
    {
        'vendor': 'Zola Media, LLC',
        'product': 'Zola Suite'
    },
    {
        'vendor': 'Zombaio',
        'product': 'Zombaio'
    },
    {
        'vendor': 'Zonar Systems, Inc.',
        'product': 'Zonar Systems'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'ZoneAlarm'
    },
    {
        'vendor': 'ZoneEdit',
        'product': 'ZoneEdit'
    },
    {
        'vendor': 'Zoom Video Communications, Inc',
        'product': 'Zoom'
    },
    {
        'vendor': 'Zoom Analytics, Ltd.',
        'product': 'Zoom Analytics'
    },
    {
        'vendor': 'Zoom Video Communications, Inc',
        'product': 'Zoom Meetings'
    },
    {
        'vendor': 'Zoom Video Communications, Inc',
        'product': 'Zoom Phone'
    },
    {
        'vendor': 'Zoom Video Communications, Inc',
        'product': 'Zoom Rooms'
    },
    {
        'vendor': 'ZoomInfo Technologies, LLC',
        'product': 'ZoomInfo'
    },
    {
        'vendor': 'Zoomd, Ltd.',
        'product': 'Zoomd'
    },
    {
        'vendor': 'Zoomdata, Inc.',
        'product': 'Zoomdata'
    },
    {
        'vendor': 'Zoomin Software, Ltd.',
        'product': 'Zoomin'
    },
    {
        'vendor': 'Zoomph, Inc.',
        'product': 'Zoomph'
    },
    {
        'vendor': 'ZOOZ Mobile, Ltd.',
        'product': 'Zooz'
    },
    {
        'vendor': 'Zope Community',
        'product': 'Zope'
    },
    {
        'vendor': 'Zotabox',
        'product': 'Zotabox'
    },
    {
        'vendor': 'Open Source',
        'product': 'Zowe'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler CASB'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler Client Connector'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler Cloud Firewall'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler DLP'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler IPS'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler Internet Access'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler Private Access'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler SSL'
    },
    {
        'vendor': 'Zscaler, Inc.',
        'product': 'Zscaler Web Security'
    },
    {
        'vendor': 'Zuberance, Inc.',
        'product': 'Zuberance'
    },
    {
        'vendor': 'Zucchetti S.p.A.',
        'product': 'Zucchetti'
    },
    {
        'vendor': 'Zuken UK, Ltd.',
        'product': 'Zuken'
    },
    {
        'vendor': 'Formisimo, Ltd.',
        'product': 'Zuko'
    },
    {
        'vendor': 'Zuora, Inc.',
        'product': 'Zuora'
    },
    {
        'vendor': 'Zuora, Inc.',
        'product': 'Zuora Billing'
    },
    {
        'vendor': 'Zuora, Inc.',
        'product': 'Zuora CPQ'
    },
    {
        'vendor': 'Zuora, Inc.',
        'product': 'Zuora RevPRO'
    },
    {
        'vendor': 'Zurple, Inc.',
        'product': 'Zurple'
    },
    {
        'vendor': 'Zwayam Digital',
        'product': 'Zwayam'
    },
    {
        'vendor': 'ZyLAB, Inc.',
        'product': 'ZyLAB'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Contract Management Software - iContract'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Financial Savings Management Software - iSave'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Procure-to-Pay Software'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Project Management Software - iManage'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Purchase Order Management Software'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Request Management Software - iRequest'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Source to Pay'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Spend Analysis Software'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus Supplier Management Software'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus eInvoicing Software'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus eProcurement Software'
    },
    {
        'vendor': 'Zycus, Inc.',
        'product': 'Zycus eSourcing Software - iSource'
    },
    {
        'vendor': 'Zylo, Inc.',
        'product': 'Zylo'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Zync Render'
    },
    {
        'vendor': 'Zynx Health, Inc.',
        'product': 'Zynx'
    },
    {
        'vendor': 'Zynx Health, Inc.',
        'product': 'ZynxCare'
    },
    {
        'vendor': 'Zynx Health, Inc.',
        'product': 'ZynxOrder'
    },
    {
        'vendor': 'Zywave, Inc.',
        'product': 'Zywave (Unspecified Product)'
    },
    {
        'vendor': 'Zyxel',
        'product': 'Zyxel (Unspecified Product)'
    },
    {
        'vendor': '[24]7.ai, Inc.',
        'product': '[24]7.ai'
    },
    {
        'vendor': 'Beta Systems Software AG',
        'product': '_beta log|z'
    },
    {
        'vendor': 'aACE Software',
        'product': 'aACE Business Suite'
    },
    {
        'vendor': 'aXigate SAS',
        'product': 'aXigate'
    },
    {
        'vendor': 'abas Software GmbH',
        'product': 'abas ERP'
    },
    {
        'vendor': 'Actimind, Inc.',
        'product': 'actiTIME'
    },
    {
        'vendor': 'Ubiquiti, Inc.',
        'product': 'airFiber'
    },
    {
        'vendor': 'Ubiquiti, Inc.',
        'product': 'airMAX'
    },
    {
        'vendor': 'amCharts',
        'product': 'amCharts'
    },
    {
        'vendor': 'QSOFT, LLC',
        'product': 'amoCRM'
    },
    {
        'vendor': 'Appfigures, Inc.',
        'product': 'appFigures'
    },
    {
        'vendor': 'Insightsoftware, Inc.',
        'product': 'arcplan'
    },
    {
        'vendor': 'Aspen Technology, Inc.',
        'product': 'aspenONE Process Explorer'
    },
    {
        'vendor': 'Cognizant Technology Solutions Corporation',
        'product': 'assetSERV'
    },
    {
        'vendor': 'atSpoke, Inc.',
        'product': 'atSpoke'
    },
    {
        'vendor': 'athenahealth, Inc.',
        'product': 'athenaClinicals'
    },
    {
        'vendor': 'athenahealth, Inc.',
        'product': 'athenaCollector'
    },
    {
        'vendor': 'athenahealth, Inc.',
        'product': 'athenaCommunicator'
    },
    {
        'vendor': 'athenahealth, Inc.',
        'product': 'athenaOne'
    },
    {
        'vendor': 'automotiveMastermind, Inc.',
        'product': 'automotiveMastermind'
    },
    {
        'vendor': 'ayfie Group AS',
        'product': 'ayfie (Unspecified Product)'
    },
    {
        'vendor': 'baramundi software AG',
        'product': 'baramundi Management Suite'
    },
    {
        'vendor': 'OppScience S.A.',
        'product': 'bee4sense Information Insight'
    },
    {
        'vendor': 'bintec elmeg GmbH',
        'product': 'bintec'
    },
    {
        'vendor': 'Hibob, Inc.',
        'product': 'bob'
    },
    {
        'vendor': 'bswift, LLC',
        'product': 'bswift'
    },
    {
        'vendor': 'censhare GmbH',
        'product': 'censhare'
    },
    {
        'vendor': 'Vistex, Inc.',
        'product': 'channelConduit Suite'
    },
    {
        'vendor': 'cielo24, Inc.',
        'product': 'cielo24'
    },
    {
        'vendor': 'Collective Data, Inc.',
        'product': 'collectiveFleet'
    },
    {
        'vendor': 'commercetools GmbH',
        'product': 'commercetools'
    },
    {
        'vendor': 'Concrete5',
        'product': 'concrete5'
    },
    {
        'vendor': 'Structura Biotechnology, Inc.',
        'product': 'cryoSPARC'
    },
    {
        'vendor': 'Cybernius Medical, Ltd.',
        'product': 'cyberREN'
    },
    {
        'vendor': 'dLocal LLP',
        'product': 'dLocal'
    },
    {
        'vendor': 'dRofus A/S',
        'product': 'dRofus'
    },
    {
        'vendor': 'DuraSpace',
        'product': 'dSPACE'
    },
    {
        'vendor': 'Intuitive Surgical, Inc.',
        'product': 'da Vinci Surgical System'
    },
    {
        'vendor': 'data.world, Inc.',
        'product': 'data.world'
    },
    {
        'vendor': 'datapine GmbH',
        'product': 'datapine'
    },
    {
        'vendor': 'Fishtown Analytics, Inc.',
        'product': 'dbt'
    },
    {
        'vendor': 'Open Source',
        'product': 'dcm4che'
    },
    {
        'vendor': 'deepwatch, Inc.',
        'product': 'deepwatch'
    },
    {
        'vendor': 'devZing, LLC',
        'product': 'devZing'
    },
    {
        'vendor': 'dmarcian, Inc.',
        'product': 'dmarcian'
    },
    {
        'vendor': 'DocStar, Inc.',
        'product': 'docSTAR'
    },
    {
        'vendor': 'dotmailer, Ltd.',
        'product': 'dotMailer'
    },
    {
        'vendor': 'dotdigital EMEA, Ltd.',
        'product': 'dotdigital'
    },
    {
        'vendor': 'drchrono, Inc.',
        'product': 'drchrono'
    },
    {
        'vendor': 'dtSearch Corporation',
        'product': 'dtSearch'
    },
    {
        'vendor': 'dunnhumby, Ltd.',
        'product': 'dunnhumby'
    },
    {
        'vendor': 'FRONTSTEPS',
        'product': 'dwellingLIVE'
    },
    {
        'vendor': 'E-Builder, Inc.',
        'product': 'e-Builder Enterprise'
    },
    {
        'vendor': 'e-Con Solutions B.V.',
        'product': 'e-Con Solutions'
    },
    {
        'vendor': 'Hemasoft Software S.L.',
        'product': 'e-Delphyn'
    },
    {
        'vendor': 'eMDs, Inc.',
        'product': 'e-MDs'
    },
    {
        'vendor': 'eBRP Solutions Network, Inc.',
        'product': 'eBRP Solutions'
    },
    {
        'vendor': 'Radial, Inc.',
        'product': 'eBay Enterprise'
    },
    {
        'vendor': 'eBay, Inc.',
        'product': 'eBay Promotions Manager'
    },
    {
        'vendor': 'eBay, Inc.',
        'product': 'eBay Selling Manager'
    },
    {
        'vendor': 'eBay, Inc.',
        'product': 'eBay Selling Manager Pro'
    },
    {
        'vendor': '7Hills Global Consulting Pvt Ltd',
        'product': 'eBizNET'
    },
    {
        'vendor': 'F24 AG',
        'product': 'eCall'
    },
    {
        'vendor': 'DSG, Inc.',
        'product': 'eCaseLink'
    },
    {
        'vendor': 'eClinicalWorks, LLC',
        'product': 'eClinicalWorks'
    },
    {
        'vendor': 'eClinicalWorks, LLC',
        'product': 'eClinicalWorks CCMR'
    },
    {
        'vendor': 'eClinicalWorks, LLC',
        'product': 'eClinicalWorks healow'
    },
    {
        'vendor': 'Mitratech Holdings, Inc.',
        'product': 'eCounsel'
    },
    {
        'vendor': 'Descartes Visual Compliance, LLC',
        'product': 'eCustoms'
    },
    {
        'vendor': 'eDerm Systems, LLC',
        'product': 'eDerm EHR'
    },
    {
        'vendor': 'BeyondTrust Corporation',
        'product': 'eEye Digital Security'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'eFax'
    },
    {
        'vendor': 'J2 Global, Inc.',
        'product': 'eFax Corporate'
    },
    {
        'vendor': 'eFront SAS',
        'product': 'eFront'
    },
    {
        'vendor': 'eG Innovations, Inc.',
        'product': 'eG Enterprise'
    },
    {
        'vendor': 'eGain Corporation',
        'product': 'eGain (Unspecified Product)'
    },
    {
        'vendor': 'eKomi, Inc.',
        'product': 'eKomi'
    },
    {
        'vendor': 'Data Software Services, LLC',
        'product': 'eLead'
    },
    {
        'vendor': 'eLeap',
        'product': 'eLeap LMS'
    },
    {
        'vendor': 'eLumen, Inc.',
        'product': 'eLumen'
    },
    {
        'vendor': 'eMarketeer AB',
        'product': 'eMarketeer'
    },
    {
        'vendor': 'Holt Systems, Inc.',
        'product': 'eMedRec'
    },
    {
        'vendor': 'Axiom Software, Ltd.',
        'product': 'ePDS'
    },
    {
        'vendor': 'MAK-SYSTEM International Group',
        'product': 'ePROGESA'
    },
    {
        'vendor': 'ePROMIS Solutions, Inc.',
        'product': 'ePROMIS'
    },
    {
        'vendor': 'ePages Software, Ltd.',
        'product': 'ePages'
    },
    {
        'vendor': 'EdgeWave, Inc.',
        'product': 'ePrism Email Security'
    },
    {
        'vendor': 'eRAD, Inc.',
        'product': 'eRAD RIS'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'eReportal'
    },
    {
        'vendor': 'eResearchTechnology, Inc.',
        'product': 'eResearch Technology'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'eSMART'
    },
    {
        'vendor': 'Cool Solutions Group',
        'product': 'eSPACE CMMS'
    },
    {
        'vendor': 'eLogic Learning, LLC',
        'product': 'eSSential LMS'
    },
    {
        'vendor': 'eSUB, Inc.',
        'product': 'eSUB'
    },
    {
        'vendor': 'PowerSchool Group, LLC',
        'product': 'eSchoolPLUS'
    },
    {
        'vendor': 'Nuance Communications, Inc.',
        'product': 'eScription One'
    },
    {
        'vendor': 'Nodus Technologies, Inc.',
        'product': 'eStore Solution Stack'
    },
    {
        'vendor': 'eTakeoff, LLC',
        'product': 'eTakeoff'
    },
    {
        'vendor': 'eTrigue Corporation',
        'product': 'eTrigue'
    },
    {
        'vendor': 'Harris School Solutions',
        'product': 'eTrition'
    },
    {
        'vendor': 'eTurns, Inc.',
        'product': 'eTurns'
    },
    {
        'vendor': 'eUnify, Inc.',
        'product': 'eUnify'
    },
    {
        'vendor': 'GumshoeKI, Inc.',
        'product': 'eVSM'
    },
    {
        'vendor': 'eVestment, LLC',
        'product': 'eVestment'
    },
    {
        'vendor': 'eWayDirect, Inc.',
        'product': 'eWayDirect'
    },
    {
        'vendor': 'AssetMark, Inc.',
        'product': 'eWealthManager'
    },
    {
        'vendor': 'Information Professionals, Inc.',
        'product': 'eWorkOrders'
    },
    {
        'vendor': 'eXTReMe digital',
        'product': 'eXTReMe Tracker'
    },
    {
        'vendor': 'eXo Platform SAS',
        'product': 'eXo Platform'
    },
    {
        'vendor': 'McObject, LLC',
        'product': 'eXtremeDB'
    },
    {
        'vendor': 'eZCom Software, Inc.',
        'product': 'eZCom'
    },
    {
        'vendor': 'eZee Technosys Pvt, Ltd.',
        'product': 'eZee Absolute'
    },
    {
        'vendor': 'eZee Technosys Pvt, Ltd.',
        'product': 'eZee FrontDesk'
    },
    {
        'vendor': 'Jorsek, Inc.',
        'product': 'easyDITA'
    },
    {
        'vendor': 'easyDNS Technologies, Inc.',
        'product': 'easyDNS'
    },
    {
        'vendor': 'Genius Solution, Inc.',
        'product': 'ehrTHOMAS'
    },
    {
        'vendor': 'elastic.io GmbH',
        'product': 'elastic.io'
    },
    {
        'vendor': 'emetriq GmbH',
        'product': 'emetriq'
    },
    {
        'vendor': 'erwin, Inc.',
        'product': 'erwin Data Modeler'
    },
    {
        'vendor': 'etherFAX, LLC',
        'product': 'etherFAX'
    },
    {
        'vendor': 'apilayer GmbH',
        'product': 'everSign'
    },
    {
        'vendor': 'eviivo, Ltd.',
        'product': 'eviivo'
    },
    {
        'vendor': 'Evolve24, LLC',
        'product': 'evolve24'
    },
    {
        'vendor': 'Exacq Technologies',
        'product': 'exacqVision'
    },
    {
        'vendor': 'expo-Max, Inc.',
        'product': 'expo-MAX'
    },
    {
        'vendor': 'ezDI, Inc.',
        'product': 'ezCDI'
    },
    {
        'vendor': 'ezDI, Inc.',
        'product': 'ezCDI Essentials'
    },
    {
        'vendor': 'ezEMRx, Inc.',
        'product': 'ezEMRx'
    },
    {
        'vendor': 'AutoDesSys, Inc.',
        'product': 'form-Z'
    },
    {
        'vendor': 'Bug Labs, Inc.',
        'product': 'freeboard'
    },
    {
        'vendor': 'Modernizing Medicine, Inc.',
        'product': 'gGastro'
    },
    {
        'vendor': 'Gandi SAS',
        'product': 'gandi.net'
    },
    {
        'vendor': 'Granicus, Inc.',
        'product': 'govService'
    },
    {
        'vendor': 'Greater Giving, Inc.',
        'product': 'greatergiving'
    },
    {
        'vendor': 'OPEN MIND Technologies AG',
        'product': 'hyperMILL'
    },
    {
        'vendor': 'Curriculum Associates, LLC',
        'product': 'i-Ready'
    },
    {
        'vendor': 'Curriculum Associates, LLC',
        'product': 'i-Ready Assessments'
    },
    {
        'vendor': 'i-Sight Company',
        'product': 'i-Sight'
    },
    {
        'vendor': 'i-nexus Global PLC',
        'product': 'i-nexus'
    },
    {
        'vendor': 'i2b2',
        'product': 'i2b2'
    },
    {
        'vendor': 'i2i Population Health',
        'product': 'i2iTracks'
    },
    {
        'vendor': 'i2x GmbH',
        'product': 'i2x'
    },
    {
        'vendor': 'iAdvize SAS',
        'product': 'iAdvize'
    },
    {
        'vendor': 'SafetyCulture Pty Ltd',
        'product': 'iAuditor'
    },
    {
        'vendor': 'iCIMS, Inc.',
        'product': 'iCIMS'
    },
    {
        'vendor': 'iCIMS, Inc.',
        'product': 'iCIMS Recruit'
    },
    {
        'vendor': 'iCarol',
        'product': 'iCarol'
    },
    {
        'vendor': 'iCohere, Inc.',
        'product': 'iCohere Unified Learning'
    },
    {
        'vendor': 'Franpos, Inc.',
        'product': 'iConnect POS'
    },
    {
        'vendor': 'iContact Marketing Corporation',
        'product': 'iContact'
    },
    {
        'vendor': 'iDashboards',
        'product': 'iDashboards'
    },
    {
        'vendor': 'iDempiere',
        'product': 'iDempiere Business Suite'
    },
    {
        'vendor': 'iDevDirect, LLC',
        'product': 'iDevAffiliate'
    },
    {
        'vendor': 'iGrafx, LLC',
        'product': 'iGrafx'
    },
    {
        'vendor': 'iHASCO, Ltd.',
        'product': 'iHASCO'
    },
    {
        'vendor': 'Sajix Corporation',
        'product': 'iHelix Hospital'
    },
    {
        'vendor': 'iMDsoft, Ltd.',
        'product': 'iMDsoft MetaVision'
    },
    {
        'vendor': 'Advanced Solutions International, Inc.',
        'product': 'iMIS'
    },
    {
        'vendor': 'iMagic Software',
        'product': 'iMagic Inventory'
    },
    {
        'vendor': 'iManage',
        'product': 'iManage'
    },
    {
        'vendor': 'iMed Software Corporation',
        'product': 'iMed EMR'
    },
    {
        'vendor': 'Taylor Communications, Inc.',
        'product': 'iMedConsent'
    },
    {
        'vendor': 'iNTERFACEWARE, Inc.',
        'product': 'iNTERFACEWARE'
    },
    {
        'vendor': 'iOFFICE LP',
        'product': 'iOFFICE'
    },
    {
        'vendor': 'iPR Software, Inc.',
        'product': 'iPR Software'
    },
    {
        'vendor': 'Newfold Digital, Inc.',
        'product': 'iPage'
    },
    {
        'vendor': 'iPatientCare, Inc.',
        'product': 'iPatientCare'
    },
    {
        'vendor': 'Astute, Inc.',
        'product': 'iPerceptions'
    },
    {
        'vendor': 'iPinYou',
        'product': 'iPinYou'
    },
    {
        'vendor': 'iPipeline, Inc.',
        'product': 'iPipeline'
    },
    {
        'vendor': 'iPresso',
        'product': 'iPresso'
    },
    {
        'vendor': 'iProspect GmbH',
        'product': 'iProspect'
    },
    {
        'vendor': 'Baidu, Inc.',
        'product': 'iQiyi'
    },
    {
        'vendor': 'iQmetrix Software Development Corporation',
        'product': 'iQmetrix'
    },
    {
        'vendor': 'iRise Corporation',
        'product': 'iRise'
    },
    {
        'vendor': 'iSalus Healthcare, LLC',
        'product': 'iSALUS'
    },
    {
        'vendor': 'iSky, Inc.',
        'product': 'iSKY'
    },
    {
        'vendor': 'iSolved HCM',
        'product': 'iSolved HCM'
    },
    {
        'vendor': 'iSpring Solutions, Inc.',
        'product': 'iSpring Learn LMS'
    },
    {
        'vendor': 'iSpring Solutions, Inc.',
        'product': 'iSpring Suite'
    },
    {
        'vendor': 'Smartbid',
        'product': 'iSqFt'
    },
    {
        'vendor': 'Boinx Software, Ltd.',
        'product': 'iStopMotion'
    },
    {
        'vendor': 'iSupport Software',
        'product': 'iSupport Software'
    },
    {
        'vendor': 'RIB Software International, Ltd.',
        'product': 'iTWO CostX'
    },
    {
        'vendor': 'itelligence, Inc.',
        'product': 'iTelligence'
    },
    {
        'vendor': 'iTradeNetwork, Inc.',
        'product': 'iTradeNetwork'
    },
    {
        'vendor': 'CitiXsys Holdings Inc.',
        'product': 'iVend Retail'
    },
    {
        'vendor': 'iVvy Pty Ltd',
        'product': 'iVvy'
    },
    {
        'vendor': 'Information Builders, Inc.',
        'product': 'iWay'
    },
    {
        'vendor': 'Iatric Systems, Inc.',
        'product': 'iatricSystems'
    },
    {
        'vendor': 'iboss, Inc.',
        'product': 'iboss'
    },
    {
        'vendor': 'icrunchdata',
        'product': 'icrunchdata'
    },
    {
        'vendor': 'Americaneagle.com, Inc.',
        'product': 'idev Ecommerce'
    },
    {
        'vendor': 'IDU Software, Ltd.',
        'product': 'idu-Concept'
    },
    {
        'vendor': 'ifa united i-tech',
        'product': 'ifa Practice Management'
    },
    {
        'vendor': 'iland Internet Solutions',
        'product': 'iland (Unspecified Product)'
    },
    {
        'vendor': 'iland Internet Solutions',
        'product': 'iland Secure Cloud Backup'
    },
    {
        'vendor': 'iland Internet Solutions',
        'product': 'iland Secure Cloud Hosting'
    },
    {
        'vendor': 'iland Internet Solutions',
        'product': 'iland Secure DRaaS'
    },
    {
        'vendor': 'Open Source',
        'product': 'illumos'
    },
    {
        'vendor': 'DataResolve Technologies Pvt Ltd',
        'product': 'inDefend'
    },
    {
        'vendor': 'Archon Systems, Inc.',
        'product': 'inFlow Inventory'
    },
    {
        'vendor': 'inMotionNow, Inc.',
        'product': 'inMotionNow'
    },
    {
        'vendor': 'inQuba Customer Intelligence Pty Ltd',
        'product': 'inQuba'
    },
    {
        'vendor': 'inRiver AB',
        'product': 'inRiver'
    },
    {
        'vendor': 'Active Innovations, Inc.',
        'product': 'infoRouter'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'infor BPCS/LX'
    },
    {
        'vendor': 'InnRoad, Inc.',
        'product': 'innRoad'
    },
    {
        'vendor': 'Itslearning AS',
        'product': 'itslearning LMS'
    },
    {
        'vendor': 'iubenda S.rl',
        'product': 'iubenda'
    },
    {
        'vendor': 'ixmid Software Technology GmbH',
        'product': 'ixmid ixserv'
    },
    {
        'vendor': 'Happyworm, Ltd.',
        'product': 'jPlayer'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'jQuery'
    },
    {
        'vendor': 'edgeNEXUS, Ltd.',
        'product': 'jetNEXUS'
    },
    {
        'vendor': 'k-eCommerce',
        'product': 'k-eCommerce'
    },
    {
        'vendor': 'Karma Software, Inc.',
        'product': 'karmaCRM'
    },
    {
        'vendor': 'Open Source',
        'product': 'libvirt'
    },
    {
        'vendor': 'mHelpDesk, Inc.',
        'product': 'mHelpDesk'
    },
    {
        'vendor': 'mJobTime Corporation',
        'product': 'mJobTime'
    },
    {
        'vendor': 'Asseco Poland S.A.',
        'product': 'mMedica'
    },
    {
        'vendor': 'mParticle, Inc.',
        'product': 'mParticle'
    },
    {
        'vendor': 'Machineering GmbH & Company KG',
        'product': 'machineering'
    },
    {
        'vendor': 'MPS North America, LLC',
        'product': 'mag+'
    },
    {
        'vendor': 'marketingQED, Ltd.',
        'product': 'marketingQED'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'matplotlib'
    },
    {
        'vendor': 'medCPU, Inc.',
        'product': 'medCPU'
    },
    {
        'vendor': 'medavis GmbH',
        'product': 'medavis RIS'
    },
    {
        'vendor': 'Agilent Technologies, Inc.',
        'product': 'miRNA Microarray Platform'
    },
    {
        'vendor': 'Mindscope, Inc.',
        'product': 'mindSCOPE CURA'
    },
    {
        'vendor': 'mindSHIFT Technologies, Inc.',
        'product': 'mindSHIFT'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'mod_pagespeed'
    },
    {
        'vendor': 'Monday.com, Ltd.',
        'product': 'monday.com'
    },
    {
        'vendor': 'Netsmart Technologies, Inc.',
        'product': 'myAvatar'
    },
    {
        'vendor': 'CWT Global B.V.',
        'product': 'myCWT'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'myCare Integrity EMR'
    },
    {
        'vendor': 'Eye Care Leaders, LLC',
        'product': 'myCare iMedicWare EHR'
    },
    {
        'vendor': 'Netsmart Technologies, Inc.',
        'product': 'myEvolv'
    },
    {
        'vendor': 'SAP SE',
        'product': 'mySAP ERP'
    },
    {
        'vendor': 'Paychex, Inc.',
        'product': 'myStaffingPro'
    },
    {
        'vendor': 'Netsmart Technologies, Inc.',
        'product': 'myUnity'
    },
    {
        'vendor': 'myosh',
        'product': 'myosh'
    },
    {
        'vendor': 'nCino, Inc.',
        'product': 'nCino'
    },
    {
        'vendor': 'Tripwire, Inc.',
        'product': 'nCircle'
    },
    {
        'vendor': 'NeuroDimension',
        'product': 'nDimensional'
    },
    {
        'vendor': 'Open Source',
        'product': 'nGraph'
    },
    {
        'vendor': 'Ask Media Group, LLC',
        'product': 'nRelate'
    },
    {
        'vendor': 'nThrive, Inc.',
        'product': 'nThrive CDI'
    },
    {
        'vendor': 'nThrive, Inc.',
        'product': 'nThrive Patient-to-Payment'
    },
    {
        'vendor': 'Intel Corporation',
        'product': 'neon'
    },
    {
        'vendor': 'NETtime Solutions, LLC',
        'product': 'nettime solutions'
    },
    {
        'vendor': 'Nginx Software, Inc.',
        'product': 'nginx'
    },
    {
        'vendor': 'S.C. Softland S.R.L.',
        'product': 'novaPDF'
    },
    {
        'vendor': 'o9 Solutions, Inc.',
        'product': 'o9'
    },
    {
        'vendor': 'openFrameworks',
        'product': 'openFrameworks'
    },
    {
        'vendor': 'openHAB Foundation e.V.',
        'product': 'openHAB'
    },
    {
        'vendor': 'osCommerce',
        'product': 'osCommerce Online Merchant'
    },
    {
        'vendor': 'Enhancesoft, LLC',
        'product': 'osTicket'
    },
    {
        'vendor': 'ownCloud GmbH',
        'product': 'ownCloud'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'pandas'
    },
    {
        'vendor': 'Paygate Solutions, Ltd.',
        'product': 'paygate'
    },
    {
        'vendor': 'Heartland Payment Systems, Inc.',
        'product': 'pcAmerica'
    },
    {
        'vendor': 'NortonLifeLock, Inc.',
        'product': 'pcAnywhere'
    },
    {
        'vendor': 'phoenixNAP, LLC',
        'product': 'phoenix NAP'
    },
    {
        'vendor': 'phoenixNAP, LLC',
        'product': 'phoenixNAP'
    },
    {
        'vendor': 'plentymarkets, Ltd.',
        'product': 'plentymarkets'
    },
    {
        'vendor': 'popIn Company, Ltd.',
        'product': 'popIn Discovery for Publisher'
    },
    {
        'vendor': 'Mitel Networks Corporation',
        'product': 'prairieFyre'
    },
    {
        'vendor': 'proALPHA Business Solutions GmbH',
        'product': 'proALPHA'
    },
    {
        'vendor': 'ProductBoard, Inc.',
        'product': 'productboard'
    },
    {
        'vendor': 'Project44, Inc.',
        'product': 'project44'
    },
    {
        'vendor': 'pymetrics, Inc.',
        'product': 'pymetrics'
    },
    {
        'vendor': 'QASymphony, Inc.',
        'product': 'qTest'
    },
    {
        'vendor': 'quintly, Inc.',
        'product': 'quintly'
    },
    {
        'vendor': 'Agilysys, Inc.',
        'product': 'rGuest Seat'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'reCAPTCHA'
    },
    {
        'vendor': 'redIQ, LLC',
        'product': 'redIQ'
    },
    {
        'vendor': 'retailcloud',
        'product': 'retailcloud'
    },
    {
        'vendor': 'rezora, LLC',
        'product': 'rezora'
    },
    {
        'vendor': 'Open Source',
        'product': 'scikit-learn'
    },
    {
        'vendor': 'seoClarity',
        'product': 'seoClarity'
    },
    {
        'vendor': 'Estore Corporation',
        'product': 'shopserve'
    },
    {
        'vendor': 'shopware AG',
        'product': 'shopware'
    },
    {
        'vendor': 'UNICOM Systems, Inc.',
        'product': 'solidDB'
    },
    {
        'vendor': 'WEBmedia',
        'product': 'stat4u'
    },
    {
        'vendor': 'symplr',
        'product': 'symplr'
    },
    {
        'vendor': 'talech',
        'product': 'talech POS'
    },
    {
        'vendor': 'talentReef, Inc.',
        'product': 'talentReef'
    },
    {
        'vendor': 'Talkspirit SAS',
        'product': 'talkspirit'
    },
    {
        'vendor': 'tawk.to, Inc.',
        'product': 'tawk.to'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'theFind.com'
    },
    {
        'vendor': 'thedatabank, gbc',
        'product': 'thedatabank'
    },
    {
        'vendor': 'IHS Markit, Ltd.',
        'product': 'thinkFolio'
    },
    {
        'vendor': 'tracx',
        'product': 'tracx'
    },
    {
        'vendor': 'Tricerat, Inc.',
        'product': 'triCerat'
    },
    {
        'vendor': 'uCoz Company',
        'product': 'uCoz'
    },
    {
        'vendor': 'Hootsuite Media, Inc.',
        'product': 'uberVU'
    },
    {
        'vendor': 'vBulletin',
        'product': 'vBulletin'
    },
    {
        'vendor': 'vCita',
        'product': 'vCita'
    },
    {
        'vendor': 'vFairs, LLC',
        'product': 'vFairs'
    },
    {
        'vendor': 'Alemba, Ltd.',
        'product': 'vFire'
    },
    {
        'vendor': 'Virtual Radiologic Corporation',
        'product': 'vRad Connect'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'vSphere Fault Tolerance (FT)'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'vSphere High Availability (HA)'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'vSphere vMotion'
    },
    {
        'vendor': 'veEDIS Clinical Systems, LLC',
        'product': 'veEDIS'
    },
    {
        'vendor': 'viGlobal, Inc.',
        'product': 'viDesktop'
    },
    {
        'vendor': 'Open Source',
        'product': 'web2py'
    },
    {
        'vendor': 'Wax Digital, Ltd.',
        'product': 'web3'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods API Gateway'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods API Portal'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods ActiveTransfer'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Adapters'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods AgileApps'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods ApplinX'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Broker'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Business Process Management Suite (BPMS)'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Business Rules'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods CloudStreams'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Insight'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Integration Server'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods OneData'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Optimize for Infrastructure'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Optimize for Process'
    },
    {
        'vendor': 'Software AG',
        'product': 'webMethods Trading Networks'
    },
    {
        'vendor': 'Whos.amung.us, Inc.',
        'product': 'whos.amung.us'
    },
    {
        'vendor': 'xMatters',
        'product': 'xMatters'
    },
    {
        'vendor': 'xTuple',
        'product': 'xTuple'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'ABB Enterprise Software (Unspecified Product)'
    },
    {
        'vendor': 'Bloomberg LP',
        'product': 'Bloomberg (Unspecified Product'
    },
    {
        'vendor': 'Clinisys Group',
        'product': 'Winpath Enterprise'
    },
    {
        'vendor': 'Canfield Scientific',
        'product': 'OMNIA Imaging System'
    },
    {
        'vendor': 'Workwise',
        'product': 'Workwise'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'VMware Mobile Virtualization Platform'
    },
    {
        'vendor': '3M Company',
        'product': '3M Medicode'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Acrobat Standard 2017'
    },
    {
        'vendor': 'Aescudata GmbH',
        'product': 'Aescudata'
    },
    {
        'vendor': 'AGFA HealthCare N.V.',
        'product': 'AGFA Heartlab'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Managed Apache Cassandra Service'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Android SDK'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache BVal'
    },
    {
        'vendor': 'ApexSQL, LLC',
        'product': 'APEXSQL Complete'
    },
    {
        'vendor': 'Arrowhead Software',
        'product': 'ArrowHead CRM'
    },
    {
        'vendor': 'Medical Communications GmbH',
        'product': 'Ashvins PACS'
    },
    {
        'vendor': 'athenahealth, Inc.',
        'product': 'athenaNet'
    },
    {
        'vendor': 'Auslogics Labs Pty Ltd',
        'product': 'Auslogics Disk Defrag'
    },
    {
        'vendor': 'Benson Software',
        'product': 'Benson'
    },
    {
        'vendor': 'Cambio Healthcare Systems AB',
        'product': 'Cambio CIS'
    },
    {
        'vendor': 'Cardiobase Pty Ltd',
        'product': 'Cardiobase'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point Capsule Workspace'
    },
    {
        'vendor': 'Clarity Ventures',
        'product': 'Clarity eCommerce'
    },
    {
        'vendor': 'Clinisys Group',
        'product': 'Clinisys Labcentre'
    },
    {
        'vendor': 'CloudIM OOO',
        'product': 'CloudIM'
    },
    {
        'vendor': 'Cohesity, Inc.',
        'product': 'Cohesity DataPlatform'
    },
    {
        'vendor': 'Color Genomics',
        'product': 'Color Genomics'
    },
    {
        'vendor': 'Dacima Software',
        'product': 'Dacima Clinical Suite'
    },
    {
        'vendor': 'Decooda International',
        'product': 'Decooda'
    },
    {
        'vendor': 'DigitalShipper',
        'product': 'DigitalShipper'
    },
    {
        'vendor': 'Nuverb Systems',
        'product': 'Donarius'
    },
    {
        'vendor': 'Dotnext bvba',
        'product': 'Dotnext QBloc'
    },
    {
        'vendor': 'EDL',
        'product': 'EDL Xplore'
    },
    {
        'vendor': 'FocalScope',
        'product': 'FocalScope'
    },
    {
        'vendor': 'Global Intelligent Technologies S.A.',
        'product': 'Glintt HS'
    },
    {
        'vendor': 'Grundig Business Systems GmbH',
        'product': 'Grundig Digtasoft'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Storage Insights'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Key Lifecycle Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Tivoli Workload Scheduler'
    },
    {
        'vendor': 'Iskratel d.o.o',
        'product': 'Iskratel'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'JBoss Enterprise Portal Platform'
    },
    {
        'vendor': 'KSYOS TeleMedisch Centrum B.V.',
        'product': 'KSYOS'
    },
    {
        'vendor': 'Lynkos',
        'product': 'Lynkos'
    },
    {
        'vendor': 'Maincare Solutions SAS',
        'product': 'Maincare RH'
    },
    {
        'vendor': 'medatixx GmbH & Company KG',
        'product': 'Medatixx'
    },
    {
        'vendor': 'ICU Medical, Inc.',
        'product': 'MedNet'
    },
    {
        'vendor': 'Megaventory',
        'product': 'Megaventory'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus AcuToWeb'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Database Connectors'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Enterprise Messaging'
    },
    {
        'vendor': 'MiPih',
        'product': 'MiPih AGIRH'
    },
    {
        'vendor': 'MyPayrollHR',
        'product': 'MyPayrollHR'
    },
    {
        'vendor': 'Orgavision GmbH',
        'product': 'Orgavision'
    },
    {
        'vendor': 'Hurra Communications GmbH',
        'product': 'OWAPro'
    },
    {
        'vendor': 'Performation HOTflo',
        'product': 'Performation HOTflo'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips LABOSYS'
    },
    {
        'vendor': 'S.C. Pleisty s.r.l.',
        'product': 'Pleisty'
    },
    {
        'vendor': 'Quaderno',
        'product': 'Quaderno'
    },
    {
        'vendor': 'Tally Systems',
        'product': 'QuickMeasure OnScreen'
    },
    {
        'vendor': 'Radware, Ltd.',
        'product': 'Radware DefenseFlow'
    },
    {
        'vendor': 'Revindex',
        'product': 'Revindex Storefront'
    },
    {
        'vendor': 'Rocket Software, Inc.',
        'product': 'Rocket EOS 360'
    },
    {
        'vendor': 'RVC Medical IT B.V.',
        'product': 'RVC Clinical Assistant'
    },
    {
        'vendor': 'SafetyTek Software',
        'product': 'SafetyTek'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage Logic Class'
    },
    {
        'vendor': 'Sargon Capital Pty. Ltd.',
        'product': 'Sargon Decimal'
    },
    {
        'vendor': 'Sistemi S.p.A.',
        'product': 'Sistemi eSolver'
    },
    {
        'vendor': 'SlickPie',
        'product': 'SlickPie'
    },
    {
        'vendor': 'Froiden Technologies Pvt Ltd',
        'product': 'SnapHRM'
    },
    {
        'vendor': 'SS&C Technologies, Inc.',
        'product': 'SS&C Antares'
    },
    {
        'vendor': 'Synthego Corporation',
        'product': 'Synthego'
    },
    {
        'vendor': 'TCMAN',
        'product': 'TCMAN Gim'
    },
    {
        'vendor': 'TrueERP',
        'product': 'TrueERP'
    },
    {
        'vendor': 'UltraGenda B.V.',
        'product': 'UltraGenda'
    },
    {
        'vendor': 'Maincare Solutions SAS',
        'product': 'UrQual'
    },
    {
        'vendor': 'Works Applications Company',
        'product': 'Works Applications'
    },
    {
        'vendor': 'HI-Systems B.V.',
        'product': 'Zamicom'
    },
    {
        'vendor': 'ZorgDomein Nederland B.V.',
        'product': 'ZorgDomein'
    },
    {
        'vendor': 'Altametrics, LLC',
        'product': 'Altametrics'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Automation Account'
    },
    {
        'vendor': 'Validity, Inc.',
        'product': 'GridBuddy'
    },
    {
        'vendor': 'Sequoia Benefits and Insurance Services, LLC',
        'product': 'Sequoia'
    },
    {
        'vendor': 'Tekion Corporation',
        'product': 'Tekion'
    },
    {
        'vendor': 'Byte Software, LLC',
        'product': 'BytePro'
    },
    {
        'vendor': 'Flexe, Inc.',
        'product': 'Flexe'
    },
    {
        'vendor': 'Ivalua, Inc.',
        'product': 'Ivalua eInvoicing'
    },
    {
        'vendor': 'LeafLink, Inc.',
        'product': 'LeafLink'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Retail Brand Compliance Management'
    },
    {
        'vendor': 'Products Up GmbH',
        'product': 'Productsup'
    },
    {
        'vendor': 'Sellercloud',
        'product': 'Sellercloud'
    },
    {
        'vendor': 'ShipBob, Inc.',
        'product': 'ShipBob'
    },
    {
        'vendor': 'Shopify, Inc.',
        'product': 'Shopify Fulfillment'
    },
    {
        'vendor': 'Skava',
        'product': 'Skava'
    },
    {
        'vendor': 'SPS Commerce, Inc.',
        'product': 'SPS Analytics'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'ABB Ability System 800xA'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure IoT Central'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Kinect DK'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Spatial Anchors'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Sphere'
    },
    {
        'vendor': 'Citcon, Inc.',
        'product': 'Citcon'
    },
    {
        'vendor': 'DIMO Software',
        'product': 'DIMO'
    },
    {
        'vendor': 'ABB, Ltd.',
        'product': 'Freelance Distributed Control System (DCS)'
    },
    {
        'vendor': 'Ingentis Softwareentwicklung GmbH',
        'product': 'Ingentis'
    },
    {
        'vendor': 'Adjetter Media Network Pvt Ltd',
        'product': 'Kapture CRM'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft 365 E5'
    },
    {
        'vendor': 'Mindbreeze GmbH',
        'product': 'Mindbreeze InSpire'
    },
    {
        'vendor': 'Minit B.V.',
        'product': 'Minit'
    },
    {
        'vendor': 'Modyo S.p.A.',
        'product': 'Modyo Platform'
    },
    {
        'vendor': 'Nakisa, Inc.',
        'product': 'Nakisa Hanelly'
    },
    {
        'vendor': 'PHC Software',
        'product': 'PHC CS'
    },
    {
        'vendor': 'powercloud GmbH',
        'product': 'powercloud'
    },
    {
        'vendor': 'Riversand Technologies, Inc.',
        'product': 'Riversand PIM'
    },
    {
        'vendor': 'TrustQuay, Ltd.',
        'product': 'TrustQuay NavOne'
    },
    {
        'vendor': 'Visma Group',
        'product': 'Visma Enterprise Suite'
    },
    {
        'vendor': 'Vendor Information Verification Experts, LLC',
        'product': 'VIVE'
    },
    {
        'vendor': 'Honeywell International, Inc.',
        'product': 'Honeywell Forge'
    },
    {
        'vendor': 'Leonardo247, LLC',
        'product': 'Leonardo247'
    },
    {
        'vendor': 'Integrated Research, Ltd.',
        'product': 'Prognosis Platform'
    },
    {
        'vendor': 'Workiva, Inc.',
        'product': 'Workiva (Unspecified Product)'
    },
    {
        'vendor': 'Unit4 N.V.',
        'product': 'Agresso'
    },
    {
        'vendor': 'Asseco Poland S.A.',
        'product': 'APplus'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Vantagepoint'
    },
    {
        'vendor': 'Encompass Technologies',
        'product': 'Encompass Cloud'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor System21'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor SyteLine'
    },
    {
        'vendor': 'o9 Solutions, Inc.',
        'product': 'o9 Digital Brain'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Cloud ERP'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 100'
    },
    {
        'vendor': 'Softland Inversiones S.L.',
        'product': 'Softland ERP'
    },
    {
        'vendor': 'AchieveIt Online, LLC',
        'product': 'AchieveIt'
    },
    {
        'vendor': 'FMR, LLC',
        'product': 'Active Trader Pro'
    },
    {
        'vendor': 'Accelerated Data Systems',
        'product': 'ADS /Accelerated Data Systems'
    },
    {
        'vendor': 'Applied Innovation, Inc.',
        'product': 'Applied Innovations'
    },
    {
        'vendor': 'Argyle Systems, Inc.',
        'product': 'Argyle'
    },
    {
        'vendor': 'northteq.com, Inc.',
        'product': 'aurora'
    },
    {
        'vendor': 'Backstop Solutions Group, LLC',
        'product': 'Backstop CRM'
    },
    {
        'vendor': 'Backstop Solutions Group, LLC',
        'product': 'Backstop Solutions'
    },
    {
        'vendor': 'BANKVOD',
        'product': 'BankVOD'
    },
    {
        'vendor': 'BillingTree',
        'product': 'BillingTree'
    },
    {
        'vendor': 'Blend Labs, Inc.',
        'product': 'Blend'
    },
    {
        'vendor': 'Blue Sage Solutions, LLC',
        'product': 'Blue Sage Solutions'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline WebSeries'
    },
    {
        'vendor': 'BQE Software, Inc.',
        'product': 'BQE CORE'
    },
    {
        'vendor': 'Advanced Technology Group, Inc.',
        'product': 'C3 (Complete Control for Communities)'
    },
    {
        'vendor': 'CBIZ, Inc.',
        'product': 'CBiz'
    },
    {
        'vendor': 'Wolters Kluwer N.V.',
        'product': 'CCH ProSystem fx Suite'
    },
    {
        'vendor': 'Charles River Systems, Inc.',
        'product': 'Charles River IMS'
    },
    {
        'vendor': 'Checkbook, Inc.',
        'product': 'Checkbook'
    },
    {
        'vendor': 'ClearPoint Strategy',
        'product': 'ClearPoint Strategy'
    },
    {
        'vendor': 'Comtech Systems Inc.',
        'product': 'Collect'
    },
    {
        'vendor': 'CDS Software',
        'product': 'Collect One'
    },
    {
        'vendor': 'Compleat Software, Ltd.',
        'product': 'Compleat'
    },
    {
        'vendor': 'SAP Concur',
        'product': 'Concur Analytics'
    },
    {
        'vendor': 'The Computer Manager, Inc.',
        'product': 'Debt$Net'
    },
    {
        'vendor': 'The Computer Manager',
        'product': 'DebtNet/Debt$Net'
    },
    {
        'vendor': 'DecisionLogic',
        'product': 'DecisionLogic'
    },
    {
        'vendor': 'eToro (Europe), Ltd.',
        'product': 'eToro'
    },
    {
        'vendor': 'ezyCollect Pty Ltd',
        'product': 'ezyCollect'
    },
    {
        'vendor': 'Featurespace, Ltd.',
        'product': 'Featurespace ARIC'
    },
    {
        'vendor': 'FinancialForce.com, Inc.',
        'product': 'FinancialForce (Unspecified Product)'
    },
    {
        'vendor': 'Fidelity National Information Services, Inc.',
        'product': 'FIS EAS'
    },
    {
        'vendor': 'Floify, LLC',
        'product': 'Floify'
    },
    {
        'vendor': 'Fyle, Inc.',
        'product': 'Fyle'
    },
    {
        'vendor': 'G5, Inc.',
        'product': 'G5 Marketing'
    },
    {
        'vendor': 'GDS, Inc.',
        'product': 'GDS Link'
    },
    {
        'vendor': 'Sabre GLBL, Inc.',
        'product': 'GetThere'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'GoSystem Tax RS'
    },
    {
        'vendor': 'Green Shades Software, Inc.',
        'product': 'Greenshades'
    },
    {
        'vendor': 'GruntWorx, LLC',
        'product': 'GruntWorx'
    },
    {
        'vendor': 'Global Voice Group Worldwide Corporation S.A.U.',
        'product': 'GVG M3'
    },
    {
        'vendor': 'HoneyBook, Inc.',
        'product': 'HoneyBook'
    },
    {
        'vendor': 'i2c, Inc.',
        'product': 'i2c'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor F9'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor Infinium'
    },
    {
        'vendor': 'The InterProse Corporation',
        'product': 'Interprose'
    },
    {
        'vendor': 'Invoice2go, Inc.',
        'product': 'Invoice2go'
    },
    {
        'vendor': 'IRIS Software Group, Ltd.',
        'product': 'IRIS Payroll Professional'
    },
    {
        'vendor': 'Jirav, Inc.',
        'product': 'Jirav'
    },
    {
        'vendor': 'KATABAT',
        'product': 'Katabat'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'Latitude by Genesys'
    },
    {
        'vendor': 'Cre8tech Labs, Inc.',
        'product': 'Lender Price'
    },
    {
        'vendor': 'LucaNet AG',
        'product': 'LucaNet'
    },
    {
        'vendor': 'Mazooma, Inc.',
        'product': 'Mazooma'
    },
    {
        'vendor': 'ICE Mortgage Technology, Inc.',
        'product': 'MortgageCEO'
    },
    {
        'vendor': 'American Express Global Business Travel',
        'product': 'Neo'
    },
    {
        'vendor': 'OpenClose',
        'product': 'OpenClose LenderAssist'
    },
    {
        'vendor': 'Paysafe Group, Ltd.',
        'product': 'PaySafe'
    },
    {
        'vendor': 'Payscout LLC.',
        'product': 'Payscout'
    },
    {
        'vendor': 'Pleo Technologies, Ltd.',
        'product': 'Pleo'
    },
    {
        'vendor': 'PRGX Global, Inc.',
        'product': 'PRGX'
    },
    {
        'vendor': 'ProPay, Inc.',
        'product': 'ProPay'
    },
    {
        'vendor': 'Q2 Software, Inc.',
        'product': 'Q2 Fintech'
    },
    {
        'vendor': 'Qvinci Software, LLC',
        'product': 'Qvinci'
    },
    {
        'vendor': 'ReconArt, Inc.',
        'product': 'ReconArt'
    },
    {
        'vendor': 'SafeSend',
        'product': 'SafeSend'
    },
    {
        'vendor': 'Sage Group PLC',
        'product': 'Sage 200'
    },
    {
        'vendor': 'Tier1 Financial Solutions, Inc.',
        'product': 'SatuitCRM'
    },
    {
        'vendor': 'Morgan Stanley',
        'product': 'Shareworks'
    },
    {
        'vendor': 'Sidetrade',
        'product': 'Sidetrade'
    },
    {
        'vendor': 'SeikoSoft Inc.',
        'product': 'Simplicity'
    },
    {
        'vendor': 'Suralink, Inc.',
        'product': 'Suralink'
    },
    {
        'vendor': 'IRIS Software Group, Ltd.',
        'product': 'Taxfiler'
    },
    {
        'vendor': 'Telrock Systems',
        'product': 'Telrock'
    },
    {
        'vendor': 'Tesorio, Inc.',
        'product': 'Tesorio'
    },
    {
        'vendor': 'TD Ameritrade, Inc.',
        'product': 'thinkorswim'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters CS Professional Suite'
    },
    {
        'vendor': 'Trustly Group AB',
        'product': 'Trustly'
    },
    {
        'vendor': 'Intuit, Inc.',
        'product': 'TurboTax'
    },
    {
        'vendor': 'TurnKey Lender, Inc.',
        'product': 'Turnkey Lender'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'UltraTax CS'
    },
    {
        'vendor': 'Visual Lease, LLC',
        'product': 'Visual Lease'
    },
    {
        'vendor': '7Shifts Employee Scheduling Software, Inc.',
        'product': '7Shifts'
    },
    {
        'vendor': 'SD Worx Group N.V.',
        'product': 'ACCURAT HCM'
    },
    {
        'vendor': 'ADP, Inc.',
        'product': 'ADP GlobalView Payroll'
    },
    {
        'vendor': 'The Ahola Corporation',
        'product': 'Ahola'
    },
    {
        'vendor': 'Alliance Payroll Services, Inc.',
        'product': 'Alliance HCM'
    },
    {
        'vendor': 'Arcoro, Inc.',
        'product': 'Arcoro'
    },
    {
        'vendor': 'Aspect Software, Inc.',
        'product': 'Aspect Workforce Optimization'
    },
    {
        'vendor': 'AspireHR, Inc.',
        'product': 'AspireHR'
    },
    {
        'vendor': 'Attendance on Demand, Inc.',
        'product': 'Attendance On Demand'
    },
    {
        'vendor': 'Bullhorn, Inc.',
        'product': 'Bullhorn for Salesforce'
    },
    {
        'vendor': 'Centrical',
        'product': 'Centrical'
    },
    {
        'vendor': 'CoAdvantage',
        'product': 'CoAdvantage'
    },
    {
        'vendor': 'SD Worx Group N.V.',
        'product': 'Cobra HRM'
    },
    {
        'vendor': 'CoderPad, Inc.',
        'product': 'CoderPad'
    },
    {
        'vendor': 'Collage Technologies, Inc.',
        'product': 'Collage'
    },
    {
        'vendor': 'Crelate',
        'product': 'Crelate'
    },
    {
        'vendor': 'CrunchTime! Information Systems, Inc.',
        'product': 'CrunchTime'
    },
    {
        'vendor': 'Defense Finance and Accounting Service',
        'product': 'DFAS myPay'
    },
    {
        'vendor': 'National Payment Corporation',
        'product': 'Doculivery'
    },
    {
        'vendor': 'EasyWorkforce Software, Inc.',
        'product': 'Easyclocking'
    },
    {
        'vendor': 'Edenred SE',
        'product': 'Edenred'
    },
    {
        'vendor': 'Adams Keegan, Inc.',
        'product': 'Efficenter'
    },
    {
        'vendor': 'ELMO Software, Ltd.',
        'product': 'ELMO'
    },
    {
        'vendor': 'Emplicity',
        'product': 'Emplicity'
    },
    {
        'vendor': 'U.S. Office of Personnel Management',
        'product': 'Employee Express'
    },
    {
        'vendor': 'Marvel Internet Group Pty Ltd',
        'product': 'Ento'
    },
    {
        'vendor': 'E-pay, Inc.',
        'product': 'EPAY'
    },
    {
        'vendor': 'Exact Holding B.V.',
        'product': 'Exact for HRM'
    },
    {
        'vendor': 'Extensis Group, LLC',
        'product': 'ExtensisHR'
    },
    {
        'vendor': 'HackerRank',
        'product': 'HackerRank'
    },
    {
        'vendor': 'TimeTarget Pty Ltd',
        'product': 'Humanforce'
    },
    {
        'vendor': 'Humi, Inc.',
        'product': 'Humi'
    },
    {
        'vendor': 'ImagineTime, Inc.',
        'product': 'ImagineTime'
    },
    {
        'vendor': 'IRIS Software Group, Ltd.',
        'product': 'IRIS Earnie IQ'
    },
    {
        'vendor': 'isolved HCM, LLC',
        'product': 'iSolved People Cloud'
    },
    {
        'vendor': 'Keka Technologies Pvt Ltd',
        'product': 'Keka'
    },
    {
        'vendor': 'Kronos, Inc.',
        'product': 'Kronos Workforce Timekeeper'
    },
    {
        'vendor': 'Leapsome GmbH',
        'product': 'Leapsome'
    },
    {
        'vendor': 'US Department of Agriculture',
        'product': 'myEPP'
    },
    {
        'vendor': 'NGA Human Resources',
        'product': 'NGA HR'
    },
    {
        'vendor': 'Paradox, Inc.',
        'product': 'Olivia AI'
    },
    {
        'vendor': 'Patriot Software, LLC',
        'product': 'Patriot Software (Unspecified Product)'
    },
    {
        'vendor': 'Plum.io, Inc.',
        'product': 'Plum'
    },
    {
        'vendor': 'PrismHR, Inc.',
        'product': 'PrismHR'
    },
    {
        'vendor': 'Rizing Holdings, LLC',
        'product': 'Rizing HCM'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Rypple'
    },
    {
        'vendor': 'Tanda',
        'product': 'Tanda'
    },
    {
        'vendor': 'Time Doctor, LLC',
        'product': 'Time Doctor'
    },
    {
        'vendor': 'Timeco Systems, Inc.',
        'product': 'TIMECO'
    },
    {
        'vendor': 'TimeForge',
        'product': 'TimeForge'
    },
    {
        'vendor': 'Timerack',
        'product': 'Timerack'
    },
    {
        'vendor': 'Workwell Technologies, Inc.',
        'product': 'uAttend'
    },
    {
        'vendor': 'UKG, Inc.',
        'product': 'UKG (Unspecified Product)'
    },
    {
        'vendor': 'UKG, Inc.',
        'product': 'UKG Dimensions'
    },
    {
        'vendor': 'UKG, Inc.',
        'product': 'UKG Pro'
    },
    {
        'vendor': 'UKG, Inc.',
        'product': 'UKG Ready'
    },
    {
        'vendor': 'Verint Systems, Inc.',
        'product': 'Verint Workforce Engagement'
    },
    {
        'vendor': 'Vibe HCM, Inc.',
        'product': 'Vibe HCM'
    },
    {
        'vendor': 'Visma Group',
        'product': 'Visma HRM & Payroll'
    },
    {
        'vendor': 'Visma Group',
        'product': 'Visma Salaris'
    },
    {
        'vendor': 'Viventium Software, Inc.',
        'product': 'Viventium'
    },
    {
        'vendor': 'When I Work, Inc.',
        'product': 'When I Work'
    },
    {
        'vendor': 'UPS',
        'product': 'Connectship'
    },
    {
        'vendor': 'Easyship',
        'product': 'Easyship'
    },
    {
        'vendor': 'ERP Gold',
        'product': 'ERP Gold'
    },
    {
        'vendor': 'Exact Holding B.V.',
        'product': 'Exact Online'
    },
    {
        'vendor': 'Malvern Systems, Inc.',
        'product': 'Malvern Manifest System'
    },
    {
        'vendor': 'Mecalux S.A.',
        'product': 'Mecalux WMS'
    },
    {
        'vendor': 'OSM Worldwide',
        'product': 'OSMART'
    },
    {
        'vendor': 'ShippingEasy',
        'product': 'ShippingEasy'
    },
    {
        'vendor': 'ShipStation',
        'product': 'ShipStation'
    },
    {
        'vendor': 'Slimstock GmbH',
        'product': 'Slim4'
    },
    {
        'vendor': 'Coupa Software, Inc.',
        'product': 'Coupa Procure-to-Pay'
    },
    {
        'vendor': 'GEP',
        'product': 'GEP SMART'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Hubwoo'
    },
    {
        'vendor': 'Twilio, Inc.',
        'product': 'Electric Imp'
    },
    {
        'vendor': 'E*TRADE Financial Holdings, LLC',
        'product': 'Equity Edge Online'
    },
    {
        'vendor': 'AIMMS B.V.',
        'product': 'AIMMS'
    },
    {
        'vendor': 'Arkieva, Inc.',
        'product': 'Arkieva'
    },
    {
        'vendor': 'Barrett Distribution Centers, Inc.',
        'product': 'Barrett Distribution Centers'
    },
    {
        'vendor': 'BlueJay Solutions, Ltd.',
        'product': 'BlueJay'
    },
    {
        'vendor': 'Blume Global, Inc.',
        'product': 'Blume'
    },
    {
        'vendor': 'DCL, Inc.',
        'product': 'DCL Logistics'
    },
    {
        'vendor': 'Demand Management, Inc.',
        'product': 'Demand Solutions'
    },
    {
        'vendor': 'Expeditors International of Washington, Inc.',
        'product': 'Expeditors'
    },
    {
        'vendor': 'RoboticWares Pvt Ltd',
        'product': 'FarEye IDM Platform'
    },
    {
        'vendor': 'Kibo Software, Inc.',
        'product': 'Kibo OM'
    },
    {
        'vendor': 'Softlink Global Pvt. Ltd.',
        'product': 'Logi-Sys'
    },
    {
        'vendor': 'Magaya Corporation',
        'product': 'Magaya'
    },
    {
        'vendor': 'Medius Sverige AB',
        'product': 'Medius'
    },
    {
        'vendor': 'MP Objects B.V.',
        'product': 'MPO'
    },
    {
        'vendor': 'C.H. Robinson Worldwide, Inc.',
        'product': 'Navisphere Vision'
    },
    {
        'vendor': 'Optel Group',
        'product': 'OPTEL'
    },
    {
        'vendor': 'Proximis',
        'product': 'Proximis'
    },
    {
        'vendor': 'QAD DynaSys SAS',
        'product': 'QAD DynaSys'
    },
    {
        'vendor': 'Quiet Logistics',
        'product': 'Quiet Logistics'
    },
    {
        'vendor': 'Saddle Creek Logistic Services',
        'product': 'Saddle Creek Logistics'
    },
    {
        'vendor': 'ShipHero, LLC',
        'product': 'ShipHero'
    },
    {
        'vendor': 'Shippeo',
        'product': 'Shippeo'
    },
    {
        'vendor': 'Softeon, Inc.',
        'product': 'Softeon Warehouse Management System'
    },
    {
        'vendor': 'TraceLink, Inc.',
        'product': 'TraceLink'
    },
    {
        'vendor': 'Abacus Labs, Inc.',
        'product': 'Abacus360 Banking'
    },
    {
        'vendor': 'AmTrav',
        'product': 'AmTrav'
    },
    {
        'vendor': 'ATPI, Ltd.',
        'product': 'ATPI Corporate Travel'
    },
    {
        'vendor': 'CarData Consultants, Inc.',
        'product': 'Cardata'
    },
    {
        'vendor': 'Dext Software, Ltd.',
        'product': 'Dext Prepare'
    },
    {
        'vendor': 'Emburse',
        'product': 'Emburse Tallie'
    },
    {
        'vendor': 'TripLog, Inc.',
        'product': 'TripLog'
    },
    {
        'vendor': 'Webexpenses Pty Ltd',
        'product': 'Webexpenses'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Accenture Kubernetes Certified Service Provider'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Cloudlets'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Akraino Edge Stack'
    },
    {
        'vendor': 'Algorithmia, Inc.',
        'product': 'Algorithmia'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Corretto'
    },
    {
        'vendor': 'Open Source',
        'product': 'AngelScript'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Ambari'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache APISIX'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Beam'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache CarbonData'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Dubbo'
    },
    {
        'vendor': 'Adobe Systems, Inc.',
        'product': 'Apache Flex'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Thrift'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Zeppelin'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple ARKit'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Core ML'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple RealityKit'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Swift'
    },
    {
        'vendor': 'Unity Technology Solutions, Ltd.',
        'product': 'AR Foundation'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'ARCore'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'Aspen Mesh'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AutoGluon'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Blockchain'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Cognitive Search'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Container Instances'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Content Moderator'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure DevOps Server'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Event Grid'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Front Door'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Kubernetes Service Engine (AKS Engine)'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Maps'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Spring Cloud'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Backstage'
    },
    {
        'vendor': 'BigchainDB GmbH',
        'product': 'BigchainDB'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Blockly'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Compuware Strobe'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Compuware Xpediter'
    },
    {
        'vendor': 'Cloud Foundry, Inc.',
        'product': 'BOSH'
    },
    {
        'vendor': 'Legion of the Bouncy Castle, Inc.',
        'product': 'Bouncy Castle'
    },
    {
        'vendor': 'Cloud Native Computing Foundation',
        'product': 'Brigade'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Broadcom Test Data Manager'
    },
    {
        'vendor': 'AppOnboard, Inc.',
        'product': 'BuildBox'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Buildpacks.io'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Business Rules Environment (BRE)'
    },
    {
        'vendor': 'Allegro Artificial Intelligence, Ltd.',
        'product': 'ClearML'
    },
    {
        'vendor': 'Clever Cloud SAS',
        'product': 'Clever Cloud'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'CLion'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Co>Operating System'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Cocos Creator'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Cocos2d'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Cocos2d-JS'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Cocos2d-x'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Colab'
    },
    {
        'vendor': 'Comet ML, Inc.',
        'product': 'Comet'
    },
    {
        'vendor': 'Open Source',
        'product': 'Concourse'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Conduct>It'
    },
    {
        'vendor': 'Confluent, Inc.',
        'product': 'Confluent Platform'
    },
    {
        'vendor': 'Scirra, Ltd.',
        'product': 'Construct'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Continuous>Flows'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Control>Center'
    },
    {
        'vendor': 'Cloud Native Computing Foundation',
        'product': 'CRI-O'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Crossplane'
    },
    {
        'vendor': 'Crownpeak Technology, Inc.',
        'product': 'Crownpeak DQM'
    },
    {
        'vendor': 'Crunchy Data Solutions, Inc.',
        'product': 'Crunchy Data'
    },
    {
        'vendor': 'CrypKey, Inc.',
        'product': 'CrypKey'
    },
    {
        'vendor': 'Cryptshare AG',
        'product': 'Cryptshare'
    },
    {
        'vendor': 'D2iQ, Inc.',
        'product': 'D2iQ Konvoy'
    },
    {
        'vendor': 'Datica, Inc.',
        'product': 'Datica'
    },
    {
        'vendor': 'Deque Systems, Inc.',
        'product': 'Deque axe'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Detectron'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Detectron2'
    },
    {
        'vendor': 'Devo, Inc.',
        'product': 'Devo'
    },
    {
        'vendor': 'DevSpace Technologies, Inc.',
        'product': 'DevSpace'
    },
    {
        'vendor': 'RackN',
        'product': 'Digital Rebar'
    },
    {
        'vendor': 'Docker, Inc.',
        'product': 'Docker Compose'
    },
    {
        'vendor': 'Open Source',
        'product': 'Dogtag Certificate System'
    },
    {
        'vendor': 'dotCMS, LLC',
        'product': 'dotCMS'
    },
    {
        'vendor': 'Harness, Inc.',
        'product': 'Drone'
    },
    {
        'vendor': 'Open Source',
        'product': 'DropWizard'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse Jersey'
    },
    {
        'vendor': 'Eclipse Foundation, Inc.',
        'product': 'Eclipse Vert.x'
    },
    {
        'vendor': 'Elasticsearch B.V.',
        'product': 'Elastic APM'
    },
    {
        'vendor': 'EsperTech, Inc.',
        'product': 'Esper'
    },
    {
        'vendor': 'Esper Enterprises, Inc.',
        'product': 'Esper.io'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Express>It'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'FileVault'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Flutter'
    },
    {
        'vendor': 'Electronic Arts, Inc.',
        'product': 'Frostbite'
    },
    {
        'vendor': 'YoYo Games, Ltd.',
        'product': 'GameMaker'
    },
    {
        'vendor': 'Open Source',
        'product': 'Gameplay'
    },
    {
        'vendor': 'GameSalad, Inc.',
        'product': 'GameSalad'
    },
    {
        'vendor': 'Open Source',
        'product': 'GDevelop'
    },
    {
        'vendor': 'Solo.io, Inc.',
        'product': 'Gloo'
    },
    {
        'vendor': 'Solo.io, Inc.',
        'product': 'Gloo Edge'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Godot Engine'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google gRPC'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Guava'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Guice'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Stadia'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'GraalVM'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Graphical Development Environment (GDE)'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'Grunt'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Gulp'
    },
    {
        'vendor': 'HCL Technologies, Ltd.',
        'product': 'HCL Leap'
    },
    {
        'vendor': 'Idea Fabrik PLC',
        'product': 'HeroEngine'
    },
    {
        'vendor': 'Logical Clocks AB',
        'product': 'Hopsworks'
    },
    {
        'vendor': 'Hugging Face, Inc.',
        'product': 'Hugging Face'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Cloud Automation Manager'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Streams'
    },
    {
        'vendor': 'Open Source',
        'product': 'jMonkeyEngine'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'Jupyter'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'Jupyter Notebook'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'JupyterHub'
    },
    {
        'vendor': 'NumFOCUS, Inc.',
        'product': 'JupyterLab'
    },
    {
        'vendor': 'Open Source',
        'product': 'Kivy'
    },
    {
        'vendor': 'Databricks, Inc.',
        'product': 'Koalas'
    },
    {
        'vendor': 'Stackwatch, Inc.',
        'product': 'Kubecost'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'KubeEdge'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Kubeflow'
    },
    {
        'vendor': 'Labelbox, Inc.',
        'product': 'Labelbox'
    },
    {
        'vendor': 'Open Source',
        'product': 'Lagom'
    },
    {
        'vendor': 'LayaBox, Inc.',
        'product': 'LayaBox'
    },
    {
        'vendor': 'Level Access',
        'product': 'Level Access'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Lua'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'ManageEngine Applications Manager'
    },
    {
        'vendor': 'Marmalade Game Studio, Ltd.',
        'product': 'Marmalade'
    },
    {
        'vendor': 'Open Source',
        'product': 'MetalLB'
    },
    {
        'vendor': 'LF Projects, LLC',
        'product': 'MLflow'
    },
    {
        'vendor': 'Open Source',
        'product': 'MonoGame'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'MRTK'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'NodeJs'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Cumulus Linux'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Objective-C'
    },
    {
        'vendor': 'OpenAI, LLC',
        'product': 'OpenAI'
    },
    {
        'vendor': 'Open Source Vision Foundation',
        'product': 'OpenCV'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenJDK Loom'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Application Response Management'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Stream Analytics'
    },
    {
        'vendor': 'ATIX Informationstechnologie und Consulting AG',
        'product': 'Orcharhino'
    },
    {
        'vendor': 'Open Source',
        'product': 'Oryx 2'
    },
    {
        'vendor': 'Python Software Foundation',
        'product': 'pandasql'
    },
    {
        'vendor': 'Photon Storm, Ltd.',
        'product': 'Phaser'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'PixiJS'
    },
    {
        'vendor': 'PlayCanvas, Ltd.',
        'product': 'PlayCanvas'
    },
    {
        'vendor': 'Prismic.io, Inc.',
        'product': 'Prismic'
    },
    {
        'vendor': 'Grid.ai, Inc.',
        'product': 'PyTorch Lightning'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Rake'
    },
    {
        'vendor': 'Rancher Labs, Inc.',
        'product': 'Rancher K3s'
    },
    {
        'vendor': 'Rancher Labs, Inc.',
        'product': 'Rancher Longhorn'
    },
    {
        'vendor': 'Rancher Labs, Inc.',
        'product': 'Rancher RKE'
    },
    {
        'vendor': 'Open Source',
        'product': 'Ren\'Py'
    },
    {
        'vendor': 'DEGICA Company, Ltd.',
        'product': 'RPG Maker'
    },
    {
        'vendor': 'RStudio, PBC',
        'product': 'RStudio'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Lightning Platform'
    },
    {
        'vendor': 'Sanity A/S',
        'product': 'Sanity.io'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Extension Suite'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Integration Suite'
    },
    {
        'vendor': 'Seldon Technologies, Ltd.',
        'product': 'Seldon'
    },
    {
        'vendor': 'Seven Bridges Bridges Genomics, Inc.',
        'product': 'SevenBridges'
    },
    {
        'vendor': 'RStudio, PBC',
        'product': 'Shiny'
    },
    {
        'vendor': 'ShiVa Technologies SAS',
        'product': 'ShiVa Engine'
    },
    {
        'vendor': 'Skytap, Inc.',
        'product': 'Skytap'
    },
    {
        'vendor': 'Ubisoft Entertainment S.A.',
        'product': 'Snowdrop'
    },
    {
        'vendor': 'StackShare, Inc.',
        'product': 'StackShare'
    },
    {
        'vendor': 'Stencyl, LLC',
        'product': 'Stencyl'
    },
    {
        'vendor': 'Streamlit, Inc.',
        'product': 'Streamlit'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Svelte'
    },
    {
        'vendor': 'Open Source',
        'product': 'Tailwind CSS'
    },
    {
        'vendor': 'Tecton, Inc.',
        'product': 'Tecton'
    },
    {
        'vendor': 'Gravitational, Inc.',
        'product': 'Teleport'
    },
    {
        'vendor': 'Tenon, LLC',
        'product': 'Tenon.io'
    },
    {
        'vendor': 'Thinkwise',
        'product': 'Thinkwise'
    },
    {
        'vendor': 'Massachusetts Institute of Technology',
        'product': 'Three.js'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'TIBCO Data Science'
    },
    {
        'vendor': 'Open Source',
        'product': 'Twine'
    },
    {
        'vendor': 'UNIGINE Holding SARL',
        'product': 'UNIGINE'
    },
    {
        'vendor': 'Open Source',
        'product': 'Vaex'
    },
    {
        'vendor': 'Valohai Oy',
        'product': 'Valohai'
    },
    {
        'vendor': 'Datadog, Inc.',
        'product': 'Vector'
    },
    {
        'vendor': 'OpenJS Foundation',
        'product': 'webpack'
    },
    {
        'vendor': 'Jetbrains s.r.o.',
        'product': 'Webstorm'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Yocto'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai API Accelerator'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Image & Video Manager'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Data Catalog'
    },
    {
        'vendor': 'Infor, Inc.',
        'product': 'Infor EAM'
    },
    {
        'vendor': 'Test JG',
        'product': 'MantTest'
    },
    {
        'vendor': 'Openprise, Inc.',
        'product': 'Openprise'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Elevate'
    },
    {
        'vendor': 'Equifax, Inc.',
        'product': 'Equifax Business Reports'
    },
    {
        'vendor': 'Ethyca, Inc.',
        'product': 'Ethyca'
    },
    {
        'vendor': 'Interos, Inc.',
        'product': 'Interos'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Advanced Server Access'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'OneTrust (Unspecified Product)'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle AML Transaction Monitoring'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Fusion Governance, Risk and Compliance'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Mantas AML'
    },
    {
        'vendor': 'Proactis Holdings PLC',
        'product': 'Proactis Compliance Controls'
    },
    {
        'vendor': 'Red Flag Group',
        'product': 'Red Flag'
    },
    {
        'vendor': 'Remediant, Inc.',
        'product': 'Remediant SecureONE'
    },
    {
        'vendor': 'Security Weaver',
        'product': 'Security Weaver Separations Enforcer'
    },
    {
        'vendor': 'SecZetta, Inc.',
        'product': 'SecZetta'
    },
    {
        'vendor': 'Sourcepoint Technologies, Inc.',
        'product': 'Sourcepoint'
    },
    {
        'vendor': 'Reciprocity, Inc.',
        'product': 'ZenGRC'
    },
    {
        'vendor': 'Babtec Informationssysteme GmbH',
        'product': 'BabtecQ'
    },
    {
        'vendor': 'Pathlock',
        'product': 'Pathlock'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Compuware ISPW'
    },
    {
        'vendor': 'Appsian Security',
        'product': 'ProfileTailor GRC'
    },
    {
        'vendor': 'Conviva, Inc.',
        'product': 'Conviva'
    },
    {
        'vendor': 'Panopto, Inc.',
        'product': 'Ensemble Video'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly RMX Series'
    },
    {
        'vendor': 'VideoJS',
        'product': 'VideoJS'
    },
    {
        'vendor': 'YuJa, Inc.',
        'product': 'YuJa'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Fiber'
    },
    {
        'vendor': 'Twitter, Inc.',
        'product': 'TweetDeck'
    },
    {
        'vendor': 'Badger Mapping',
        'product': 'Badger Maps'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Daydream'
    },
    {
        'vendor': 'HTC Corporation',
        'product': 'HTC VIVE'
    },
    {
        'vendor': 'Magic Leap, Inc.',
        'product': 'Magic Leap'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Hololens'
    },
    {
        'vendor': 'Mursion, Inc.',
        'product': 'Mursion'
    },
    {
        'vendor': 'Facebook, Inc.',
        'product': 'Oculus'
    },
    {
        'vendor': 'Samsung Electronics Company, Ltd.',
        'product': 'Samsung Gear VR'
    },
    {
        'vendor': 'Strivr Labs, Inc.',
        'product': 'Strivr'
    },
    {
        'vendor': 'Epic Games, Inc.',
        'product': 'Unreal Engine'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA E3D Design'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'AVEVA PDMS'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Firepower NGFW Virtual Appliance'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'NetApp ONTAP'
    },
    {
        'vendor': 'Schrodinger, Inc.',
        'product': 'Schrodinger Glide'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC PowerScale'
    },
    {
        'vendor': 'Artica Tech SARL',
        'product': 'Artica Proxy'
    },
    {
        'vendor': 'Geopointe LLC',
        'product': 'Geopointe'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Siteforce'
    },
    {
        'vendor': 'RWS Holdings PLC',
        'product': 'Tridion'
    },
    {
        'vendor': 'Verizon Communications, Inc.',
        'product': 'Yahoo Small Business'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai CDN Solutions'
    },
    {
        'vendor': 'Apptio, Inc.',
        'product': 'Apptio Cloudability'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure IoT'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure IoT Edge'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure IoT Hub'
    },
    {
        'vendor': 'Digital Realty Trust, Inc.',
        'product': 'Digital Realty'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Heroku'
    },
    {
        'vendor': 'Applozic, Inc.',
        'product': 'Applozic'
    },
    {
        'vendor': 'Avaya, Inc.',
        'product': 'Avaya Spaces'
    },
    {
        'vendor': 'Inscripts (I) Pvt Ltd',
        'product': 'CometChat'
    },
    {
        'vendor': 'Logitech Europe S.A.',
        'product': 'Logitech Video Conferencing'
    },
    {
        'vendor': 'PagerDuty, Inc.',
        'product': 'PagerDuty On-Call Management'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly (Unspecified Product)'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly HDX Series'
    },
    {
        'vendor': 'TrueConf, LLC',
        'product': 'TrueConf'
    },
    {
        'vendor': 'FrontApp, Inc.',
        'product': 'Front'
    },
    {
        'vendor': 'Enreach',
        'product': 'Centile Istra'
    },
    {
        'vendor': 'Granite Telecommunications, LLC',
        'product': 'Granite Merged Voice'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly PVX Series'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly RealPresence'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly SoundPoint'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly SoundStation Phones'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly Vortex'
    },
    {
        'vendor': 'Alive Technologies, Inc.',
        'product': 'Alive5'
    },
    {
        'vendor': 'Genesys Telecommunications Laboratories, Inc.',
        'product': 'BoldChat'
    },
    {
        'vendor': 'BT Global Services',
        'product': 'BT Contact'
    },
    {
        'vendor': 'CafeX Communications, Inc.',
        'product': 'CafeX'
    },
    {
        'vendor': 'Clickatell Group',
        'product': 'Clickatell'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Contact Lens for Amazon Connect'
    },
    {
        'vendor': 'Eckoh PLC',
        'product': 'Eckoh'
    },
    {
        'vendor': 'Formilla, LLC',
        'product': 'Formilla'
    },
    {
        'vendor': 'Intentive technologies India Pvt Ltd',
        'product': 'Kommunicate Live Chat'
    },
    {
        'vendor': 'HELLO UMI S.L.',
        'product': 'Landbot'
    },
    {
        'vendor': 'Lifesize, Inc.',
        'product': 'Lifesize CxEngage'
    },
    {
        'vendor': 'ManyChat, Inc.',
        'product': 'ManyChat'
    },
    {
        'vendor': 'Zingle, Inc.',
        'product': 'Medallia Zingle'
    },
    {
        'vendor': 'CuteSoft Components, Inc.',
        'product': 'My LiveChat'
    },
    {
        'vendor': 'ObserveAI',
        'product': 'Observe.AI'
    },
    {
        'vendor': 'Parsable, Inc.',
        'product': 'Parsable Connected Worker'
    },
    {
        'vendor': 'Pindrop Security, Inc.',
        'product': 'Pindrop'
    },
    {
        'vendor': 'Playvox, Inc.',
        'product': 'Playvox'
    },
    {
        'vendor': 'Pubble SaaS Ireland, Ltd.',
        'product': 'Pubble'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Service Cloud'
    },
    {
        'vendor': 'Lifesize, Inc.',
        'product': 'Serenova'
    },
    {
        'vendor': 'Vivocha S.p.A.',
        'product': 'Vivocha'
    },
    {
        'vendor': 'Wix.com, Inc.',
        'product': 'Wix Answers'
    },
    {
        'vendor': 'Cliengo',
        'product': 'Cliengo'
    },
    {
        'vendor': 'CloudCC, Inc.',
        'product': 'CloudCC CRM'
    },
    {
        'vendor': 'Connectwise, Inc.',
        'product': 'Connectwise Manage'
    },
    {
        'vendor': 'Deltek, Inc.',
        'product': 'Deltek Vantagepoint CRM'
    },
    {
        'vendor': 'eGain Corporation',
        'product': 'eGain Chat'
    },
    {
        'vendor': 'EngageBay, Inc.',
        'product': 'EngageBay'
    },
    {
        'vendor': 'Folloze, Inc.',
        'product': 'Folloze'
    },
    {
        'vendor': 'Freshworks, Inc.',
        'product': 'Freshsales'
    },
    {
        'vendor': 'LeadSimple, Inc.',
        'product': 'LeadSimple'
    },
    {
        'vendor': 'Chengdu Golden Armor Technology Company, Ltd.',
        'product': 'Live800'
    },
    {
        'vendor': 'Mainstay',
        'product': 'Mainstay'
    },
    {
        'vendor': 'MoEngage, Inc.',
        'product': 'MoEngage'
    },
    {
        'vendor': 'PatientPop',
        'product': 'PatientPop'
    },
    {
        'vendor': 'Avolin, Inc.',
        'product': 'Pivotal CRM'
    },
    {
        'vendor': 'InsideSales',
        'product': 'Playbooks'
    },
    {
        'vendor': 'Rasa Technologies, Inc.',
        'product': 'Rasa'
    },
    {
        'vendor': 'Restaurant365, LLC',
        'product': 'Restaurant365'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Essentials'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com (Unspecified Product)'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com CRM'
    },
    {
        'vendor': 'SalesRabbit',
        'product': 'SalesRabbit'
    },
    {
        'vendor': 'Hootsuite Media, Inc.',
        'product': 'Sparkcentral'
    },
    {
        'vendor': 'Strikedeck, Inc.',
        'product': 'Strikedeck'
    },
    {
        'vendor': 'Tact.ai Technologies, Inc.',
        'product': 'Tact.ai'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Desk.com'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Remedyforce'
    },
    {
        'vendor': 'Utilibill Pty Ltd',
        'product': 'Utilibill'
    },
    {
        'vendor': 'PhoneBurner',
        'product': 'Phone Burner'
    },
    {
        'vendor': 'TCN',
        'product': 'TCN'
    },
    {
        'vendor': 'Fujitsu, Ltd.',
        'product': 'Fujitsu Stylistic'
    },
    {
        'vendor': 'Accu Time, Inc.',
        'product': 'AccuTime'
    },
    {
        'vendor': 'Crestron Electronics, Inc.',
        'product': 'AirMedia'
    },
    {
        'vendor': 'ATTO Technology, Inc.',
        'product': 'ATTO Celerity'
    },
    {
        'vendor': 'Barco N.V.',
        'product': 'Barco ClickShare'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EMC IDPA'
    },
    {
        'vendor': 'DrayTek Corporation',
        'product': 'DrayTek DSL Routers'
    },
    {
        'vendor': 'DrayTek Corporation',
        'product': 'DrayTek VigorACS'
    },
    {
        'vendor': 'DrayTek Corporation',
        'product': 'DrayTek VPN Routers'
    },
    {
        'vendor': 'Graphcore, Ltd.',
        'product': 'Graphcore'
    },
    {
        'vendor': 'Groq, Inc.',
        'product': 'Groq'
    },
    {
        'vendor': 'H3C Technologies Company, Ltd.',
        'product': 'H3C'
    },
    {
        'vendor': 'AJA Video Systems, Inc.',
        'product': 'KONA'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall Soho 250'
    },
    {
        'vendor': 'Veritas Technologies, LLC',
        'product': 'Veritas NetBackup Flex'
    },
    {
        'vendor': 'Yamaha Corporation',
        'product': 'Yamaha Audio and Visual'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UCS B Series'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco UCS C Series'
    },
    {
        'vendor': 'Aayu Technologies, LLC',
        'product': 'AS2 Gateway'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Power BI Embedded'
    },
    {
        'vendor': 'Brightmetrics, Inc.',
        'product': 'Brightmetrics'
    },
    {
        'vendor': 'Open Source',
        'product': 'Chart.js'
    },
    {
        'vendor': 'LexisNexis Risk Solutions, Inc.',
        'product': 'Cirium'
    },
    {
        'vendor': 'Highsoft AS',
        'product': 'Highcharts'
    },
    {
        'vendor': 'Prezi, Inc.',
        'product': 'Infogram'
    },
    {
        'vendor': 'InsideSales',
        'product': 'InsideSales C9'
    },
    {
        'vendor': 'H4Technologies, LLC',
        'product': 'Jumplead'
    },
    {
        'vendor': 'Caliper Corporation',
        'product': 'Maptitude'
    },
    {
        'vendor': 'MetaQuotes, Ltd.',
        'product': 'MetaTrader 5'
    },
    {
        'vendor': 'Phone2Action',
        'product': 'Phone2Action'
    },
    {
        'vendor': 'Quorum Analytics, Inc.',
        'product': 'Quorum Public Affairs Software'
    },
    {
        'vendor': 'Toucan Toco SAS',
        'product': 'Toucan Toco'
    },
    {
        'vendor': 'Whatagraph B.V.',
        'product': 'Whatagraph'
    },
    {
        'vendor': 'Clarabridge, Inc.',
        'product': 'Clarabridge Engage'
    },
    {
        'vendor': 'Content Square, Inc.',
        'product': 'Contentsquare'
    },
    {
        'vendor': 'InfoSum, Ltd.',
        'product': 'InfoSum'
    },
    {
        'vendor': 'Kevel',
        'product': 'Kevel'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Siebel Loyalty Manager'
    },
    {
        'vendor': 'Squiz Australia Pty. Ltd.',
        'product': 'Squiz (Unspecified Product)'
    },
    {
        'vendor': 'Textio, Inc.',
        'product': 'Textio'
    },
    {
        'vendor': 'Welcome, Inc.',
        'product': 'Welcome'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Marketing Automation'
    },
    {
        'vendor': 'Alchemer',
        'product': 'Alchemer LLC'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Forms'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Surveys'
    },
    {
        'vendor': 'SurveySparrow Inc.',
        'product': 'SurveySparrow'
    },
    {
        'vendor': 'Thematic Analysis Inc.',
        'product': 'Thematic'
    },
    {
        'vendor': 'Open Source',
        'product': 'Knet'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC TrueSight Middleware and Transaction Monitor'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco 3750X'
    },
    {
        'vendor': 'Ericsson AB',
        'product': 'Ericsson OMS 800'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei S9700'
    },
    {
        'vendor': 'Arista Networks, Inc.',
        'product': 'CloudVision'
    },
    {
        'vendor': 'Okta, Inc.',
        'product': 'Okta Access Gateway'
    },
    {
        'vendor': 'Traefik Labs SAS',
        'product': 'Traefik'
    },
    {
        'vendor': 'WHOIS API, Inc.',
        'product': 'WHOIS API'
    },
    {
        'vendor': 'Foundry Visionmongers, Ltd.',
        'product': 'Hiero'
    },
    {
        'vendor': 'Crowdicity, Ltd.',
        'product': 'Medallia Crowdicity'
    },
    {
        'vendor': 'Mersive Technologies, Inc.',
        'product': 'Mersive Solstice'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft 365 Apps & Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Teams Rooms'
    },
    {
        'vendor': 'Poly, Inc.',
        'product': 'Poly Trio'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce.com Chatter'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Assist'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Zoho Connect'
    },
    {
        'vendor': 'Atypon Systems, LLC',
        'product': 'Atypon'
    },
    {
        'vendor': 'RWS Holdings PLC',
        'product': 'Contenta Publishing Suite'
    },
    {
        'vendor': 'RWS Holdings PLC',
        'product': 'Passolo'
    },
    {
        'vendor': 'Silverchair Science+Communications, LLC',
        'product': 'Silverchair'
    },
    {
        'vendor': 'RWS Holdings PLC',
        'product': 'XPP'
    },
    {
        'vendor': 'Anthology, Inc.',
        'product': 'Anthology'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple School Manager'
    },
    {
        'vendor': 'Axonify, Inc.',
        'product': 'Axonify'
    },
    {
        'vendor': 'Cornerstone OnDemand, Inc.',
        'product': 'Cornerstone Extended Enterprise'
    },
    {
        'vendor': 'CrossKnowledge, Inc.',
        'product': 'CrossKnowledge Learning Suite'
    },
    {
        'vendor': 'Go1 Pty Ltd',
        'product': 'Go1'
    },
    {
        'vendor': 'Turnitin, LLC',
        'product': 'Gradescope'
    },
    {
        'vendor': 'ServiceRocket, Inc.',
        'product': 'Learndot'
    },
    {
        'vendor': 'LearningMate Solutions, Inc.',
        'product': 'LearningMate'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft Viva'
    },
    {
        'vendor': 'Rustici Software, LLC',
        'product': 'Rustici'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Adobe Fonts'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Arrow'
    },
    {
        'vendor': 'Cerebras Systems, Inc.',
        'product': 'Cerebras'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'CloudEvents'
    },
    {
        'vendor': 'Condeco Group, Ltd.',
        'product': 'Condeco'
    },
    {
        'vendor': 'Diffbot Technologies Corporation',
        'product': 'Diffbot'
    },
    {
        'vendor': 'Tata Consultancy Services, Ltd.',
        'product': 'Jile'
    },
    {
        'vendor': 'RWS Holdings PLC',
        'product': 'Language Weaver'
    },
    {
        'vendor': 'Mobile Data Labs, Inc.',
        'product': 'MileIQ'
    },
    {
        'vendor': 'Motus, LLC',
        'product': 'Motus Mobile'
    },
    {
        'vendor': 'Resolve Software Group Pty Ltd',
        'product': 'Resolve Software'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Ruum'
    },
    {
        'vendor': 'SpaceIQ',
        'product': 'Serraview'
    },
    {
        'vendor': 'Silktide, Ltd.',
        'product': 'Silktide'
    },
    {
        'vendor': 'Synthetix, Ltd.',
        'product': 'Synthetix'
    },
    {
        'vendor': 'Talon Aerolytics, Inc.',
        'product': 'Talonview'
    },
    {
        'vendor': 'RWS Holdings PLC',
        'product': 'Trados Studio'
    },
    {
        'vendor': 'WebAIM',
        'product': 'WAVE'
    },
    {
        'vendor': '3D-Coat',
        'product': '3DCoat'
    },
    {
        'vendor': 'ALLPLAN Deutschland GmbH',
        'product': 'ALLPLAN'
    },
    {
        'vendor': 'ANSYS, Inc.',
        'product': 'ANSYS Discovery Live'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS CityEngine'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Drone2Map'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Navigator'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Pro'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS QuickCapture'
    },
    {
        'vendor': 'Esri Global, Inc.',
        'product': 'ArcGIS Workforce'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'AutoCAD LT'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk Civil 3D'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk InfraWorks'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk ReCAP'
    },
    {
        'vendor': 'Autodesk, Inc.',
        'product': 'Autodesk VRED'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Remote Rendering'
    },
    {
        'vendor': 'simcon kunststofftechnische Software GmbH',
        'product': 'CADMOULD'
    },
    {
        'vendor': 'Open Source',
        'product': 'cdk8s'
    },
    {
        'vendor': 'Centreon SAS',
        'product': 'Centreon'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'cert-manager'
    },
    {
        'vendor': 'Open Source',
        'product': 'Chaos Toolkit'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'ContextCapture'
    },
    {
        'vendor': 'Energy Toolbase Software, Inc.',
        'product': 'Energy Toolbase'
    },
    {
        'vendor': 'AVEVA Group PLC',
        'product': 'FabTrol'
    },
    {
        'vendor': 'FARO Technologies, Inc.',
        'product': 'FARO SCENE'
    },
    {
        'vendor': 'FilmLight, Ltd.',
        'product': 'FilmLight Baselight'
    },
    {
        'vendor': 'Folsom Labs, Inc.',
        'product': 'HelioScope'
    },
    {
        'vendor': 'IHS Markit, Ltd.',
        'product': 'IHS Markit Kingdom'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'InRoads'
    },
    {
        'vendor': 'Leica Geosystems AG',
        'product': 'Leica Cyclone'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'LumenRT'
    },
    {
        'vendor': 'CoreTech System Company, Ltd.',
        'product': 'Moldex3D'
    },
    {
        'vendor': 'Nearmap US, Inc.',
        'product': 'Nearmap on OpenSolar'
    },
    {
        'vendor': 'NVIDIA Corporation',
        'product': 'NVIDIA Omniverse'
    },
    {
        'vendor': 'Pilot.com, Inc.',
        'product': 'Pilot'
    },
    {
        'vendor': 'PVsyst SA',
        'product': 'PVsyst'
    },
    {
        'vendor': 'RED Digital Cinema, LLC',
        'product': 'Redcine-X Pro'
    },
    {
        'vendor': 'Robert McNeel & Associates',
        'product': 'Rhino Grasshopper'
    },
    {
        'vendor': 'Schrodinger, Inc.',
        'product': 'Schrodinger'
    },
    {
        'vendor': 'Sighten, Inc.',
        'product': 'Sighten'
    },
    {
        'vendor': 'SIGMA Engineering GmbH',
        'product': 'Sigmasoft'
    },
    {
        'vendor': 'Bentley Systems, Inc.',
        'product': 'SignCAD'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'SOLIDWORKS Plastics'
    },
    {
        'vendor': 'STRUMIS, Ltd.',
        'product': 'STRUMIS'
    },
    {
        'vendor': 'Tableau Software, Inc.',
        'product': 'Tableau Mobile'
    },
    {
        'vendor': 'Trimble, Inc.',
        'product': 'Tekla Structural Designer'
    },
    {
        'vendor': 'VITAC Corporation',
        'product': 'VITAC'
    },
    {
        'vendor': 'Vizrt',
        'product': 'Viz Virtual Studio'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'Vuforia'
    },
    {
        'vendor': 'UMT 360, LLC',
        'product': 'UMT360'
    },
    {
        'vendor': 'Charles River Systems, Inc.',
        'product': 'Charles River (Unspecified Product)'
    },
    {
        'vendor': 'ObjectWay S.p.A.',
        'product': 'eXimius'
    },
    {
        'vendor': 'RIB Software SE',
        'product': 'RIB Project'
    },
    {
        'vendor': 'Veritec Pty Ltd',
        'product': 'Capabiliti'
    },
    {
        'vendor': 'Berger Levrault S.A.',
        'product': 'Infosilem'
    },
    {
        'vendor': 'EagleView Technologies, Inc.',
        'product': 'EagleView Property Reports'
    },
    {
        'vendor': 'EagleView Technologies, Inc.',
        'product': 'EagleView Reveal'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Equipment & Tools Management'
    },
    {
        'vendor': 'Litify, Inc.',
        'product': 'Litify'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Microsoft eDiscovery'
    },
    {
        'vendor': 'Thomson Reuters Corporation',
        'product': 'Thomson Reuters FindLaw'
    },
    {
        'vendor': 'Reply S.p.A.',
        'product': 'Click Reply'
    },
    {
        'vendor': 'CRITICAL Manufacturing S.A.',
        'product': 'Critical Manufacturing'
    },
    {
        'vendor': 'Deck Commerce',
        'product': 'Deck Commerce'
    },
    {
        'vendor': 'Open Source',
        'product': 'eQuest'
    },
    {
        'vendor': 'Fluent Retail Pty Ltd',
        'product': 'Fluent Commerce'
    },
    {
        'vendor': 'Generix Group',
        'product': 'Generix Supply Chain Hub'
    },
    {
        'vendor': 'Hexagon Manufacturing Intelligence',
        'product': 'Hexagon Manufacturing Intelligence (Unspecified Product)'
    },
    {
        'vendor': 'Carrier Global Corporation',
        'product': 'Hourly Analysis Program (HAP)'
    },
    {
        'vendor': 'MPDV Mikrolab GmbH',
        'product': 'HYDRA Industry Solutions'
    },
    {
        'vendor': 'iBASEt, Inc.',
        'product': 'iBASEt'
    },
    {
        'vendor': 'iTAC Software AG',
        'product': 'iTAC.MES.Suite'
    },
    {
        'vendor': 'Made4net',
        'product': 'Made4net (Unspecified Product)'
    },
    {
        'vendor': 'Mantis Informatics S.A.',
        'product': 'Mantis Logistics Vision Suite'
    },
    {
        'vendor': 'Microlistics',
        'product': 'Microlistics'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Opcenter'
    },
    {
        'vendor': 'Optel Group',
        'product': 'OPTEL Vision System'
    },
    {
        'vendor': 'SAP SE',
        'product': 'RISE with SAP'
    },
    {
        'vendor': 'Synergy Logistics, Ltd.',
        'product': 'SnapFulfil'
    },
    {
        'vendor': 'Emerson Electric Company',
        'product': 'Syncade MES'
    },
    {
        'vendor': 'Parsec Automation Corporation',
        'product': 'TrakSYS'
    },
    {
        'vendor': 'Trane Technologies PLC',
        'product': 'Trane TRACE 3D'
    },
    {
        'vendor': 'Trane Technologies PLC',
        'product': 'Trane TRACE 700'
    },
    {
        'vendor': 'Werum IT Solutions GmbH',
        'product': 'Werum PAS-X'
    },
    {
        'vendor': 'Open Source',
        'product': 'Audacity'
    },
    {
        'vendor': 'Open Source',
        'product': 'GIMP'
    },
    {
        'vendor': 'Open Source',
        'product': 'Shotcut'
    },
    {
        'vendor': '3M Company',
        'product': '3M 360 Encompass for CDI'
    },
    {
        'vendor': 'AbacusRx, Inc.',
        'product': 'Abacus Rx'
    },
    {
        'vendor': 'American HealthTech, Inc.',
        'product': 'American HealthTech'
    },
    {
        'vendor': 'Ascom, Inc.',
        'product': 'Ascom'
    },
    {
        'vendor': 'Dassault Systemes SE',
        'product': 'BIOVIA Discovery Studio'
    },
    {
        'vendor': 'CACI, Ltd.',
        'product': 'CACI InView'
    },
    {
        'vendor': 'Calm.com, Inc.',
        'product': 'Calm'
    },
    {
        'vendor': 'Advanced Computer Software Group, Ltd.',
        'product': 'Caresys'
    },
    {
        'vendor': 'Cerner Corporation',
        'product': 'Cerner Unite'
    },
    {
        'vendor': 'Chemical Computing Group ULC',
        'product': 'ChemComp MOE'
    },
    {
        'vendor': 'ChipSoft B.V.',
        'product': 'ChipSoft Apotheek'
    },
    {
        'vendor': 'Clarify Health Solutions',
        'product': 'Clarify Health'
    },
    {
        'vendor': 'Cerberus Healthcare, LLC',
        'product': 'Clicktate'
    },
    {
        'vendor': 'Clinisys Group',
        'product': 'Clinisys WinPath'
    },
    {
        'vendor': 'CyberCube Analytics, Inc.',
        'product': 'Cyber Cube'
    },
    {
        'vendor': 'DBSoft',
        'product': 'DBSoft SGLAC'
    },
    {
        'vendor': 'DXC Technology Company',
        'product': 'DXC Care Suite'
    },
    {
        'vendor': 'Informatica Medico Farmaceutica',
        'product': 'Farmis Oncofarm'
    },
    {
        'vendor': 'G2 Speech UK, Ltd.',
        'product': 'G2 SpeechReport'
    },
    {
        'vendor': 'Gaussian, Inc.',
        'product': 'Gaussian 16'
    },
    {
        'vendor': 'Headspace, Inc.',
        'product': 'Headspace'
    },
    {
        'vendor': 'ID GmbH & Company KGaA',
        'product': 'ID EFIX'
    },
    {
        'vendor': 'Oxford Instruments PLC',
        'product': 'Imaris'
    },
    {
        'vendor': 'IRIS Software Group, Ltd.',
        'product': 'IRIS Practice Engine'
    },
    {
        'vendor': 'Kestral Computing Pty Ltd',
        'product': 'Kestral PLS'
    },
    {
        'vendor': 'KMS AG',
        'product': 'KMS eisTIK'
    },
    {
        'vendor': 'Inte:Ligand GmbH',
        'product': 'LigandScout'
    },
    {
        'vendor': 'LocalMed, LLC',
        'product': 'LocalMed'
    },
    {
        'vendor': 'MEDarchiver S.R.L.',
        'product': 'MEDarchiver'
    },
    {
        'vendor': 'Dedalus HealthCare GmbH',
        'product': 'Medasys DxCare'
    },
    {
        'vendor': 'Modento by Dental Intelligence',
        'product': 'Modento'
    },
    {
        'vendor': 'NextGate Solutions, Inc.',
        'product': 'NextGate'
    },
    {
        'vendor': 'NextGen Healthcare, Inc.',
        'product': 'NextGen RCM'
    },
    {
        'vendor': 'Optum, Inc.',
        'product': 'Optum Webstrat'
    },
    {
        'vendor': 'Koninklijke Philips N.V.',
        'product': 'Philips HealthSuite Digital Platform'
    },
    {
        'vendor': 'PwC',
        'product': 'PwC SMART'
    },
    {
        'vendor': 'ACOM Solutions, Inc.',
        'product': 'Rapid'
    },
    {
        'vendor': 'Schrodinger, Inc.',
        'product': 'Schrodinger Desmond'
    },
    {
        'vendor': 'Schrodinger, Inc.',
        'product': 'Schrodinger Maestro'
    },
    {
        'vendor': 'Schrodinger, Inc.',
        'product': 'Schrodinger PyMol'
    },
    {
        'vendor': 'Talkspace',
        'product': 'Talkspace'
    },
    {
        'vendor': 'PetaChem, LLC',
        'product': 'TeraChem'
    },
    {
        'vendor': 'Trella Health',
        'product': 'Trella Health'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Vault EDC'
    },
    {
        'vendor': 'Veeva Systems, Inc.',
        'product': 'Veeva Vault RIM Suite'
    },
    {
        'vendor': 'Vital Images, Inc.',
        'product': 'Vitrea Enterprise Imaging'
    },
    {
        'vendor': 'YAPI Inc.',
        'product': 'YAPI'
    },
    {
        'vendor': 'Backstop Solutions Group, LLC',
        'product': 'Backstop Portfolio Management'
    },
    {
        'vendor': 'Blackbaud, Inc.',
        'product': 'Blackbaud Raisers Edge NXT'
    },
    {
        'vendor': 'Boardable',
        'product': 'Boardable'
    },
    {
        'vendor': 'MobileCause, Inc.',
        'product': 'MobileCause'
    },
    {
        'vendor': 'Aptexx, Inc.',
        'product': 'Aptexx'
    },
    {
        'vendor': 'Altus Group, Ltd.',
        'product': 'ARGUS'
    },
    {
        'vendor': 'Mews Systems, Ltd.',
        'product': 'Base7booking'
    },
    {
        'vendor': 'CondoCerts',
        'product': 'CondoCerts'
    },
    {
        'vendor': 'Vestibule Marketing',
        'product': 'Elina PMS'
    },
    {
        'vendor': 'HomeWiseDocs.com',
        'product': 'HomeWiseDocs'
    },
    {
        'vendor': 'Lodgix.com',
        'product': 'Lodgix'
    },
    {
        'vendor': 'NetVendor, Inc.',
        'product': 'NetVendor'
    },
    {
        'vendor': 'PayProp, LLC',
        'product': 'PayProp'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'PropertyShark'
    },
    {
        'vendor': 'AssociationREADY, LLC',
        'product': 'ReadyCOLLECT'
    },
    {
        'vendor': 'RIB Software SE',
        'product': 'RIB iTWOfm'
    },
    {
        'vendor': 'Smartwebs, Inc.',
        'product': 'Smartwebs'
    },
    {
        'vendor': 'Storage Commander Software, LLC',
        'product': 'Storage Commander'
    },
    {
        'vendor': 'Domin-8 Enterprise Solutions, Inc.',
        'product': 'Tenant Pro'
    },
    {
        'vendor': 'Domin-8 Enterprise Solutions, Inc.',
        'product': 'Tenant Pro 7'
    },
    {
        'vendor': 'Tenant Technologies, Inc.',
        'product': 'TenantTech'
    },
    {
        'vendor': 'View the Space, Inc.',
        'product': 'VTS Platform'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Social Housing Suite'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Voyager S'
    },
    {
        'vendor': 'Paylease, LLC',
        'product': 'Zego'
    },
    {
        'vendor': 'CerTek Software Designs, Inc.',
        'product': 'CerTek Artisan'
    },
    {
        'vendor': 'Lightspeed POS, Inc.',
        'product': 'ShopKeep by Lightspeed'
    },
    {
        'vendor': 'Tulip.io, Inc.',
        'product': 'Tulip Mobile Platform'
    },
    {
        'vendor': 'Vinculum Solutions Pvt Ltd',
        'product': 'Vinculum'
    },
    {
        'vendor': 'ENGIE Insight Services, Inc.',
        'product': 'ENGIE Impact'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM Spectrum Protect Plus'
    },
    {
        'vendor': 'Micro Focus International PLC',
        'product': 'Micro Focus Backup Navigator'
    },
    {
        'vendor': 'Veeam Software AG',
        'product': 'Veeam Backup for Microsoft Office 365'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Active>Data'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon SageMaker Ground Truth'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Data Quality Environment (DQE)'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell EqualLogic PS4110X'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Enterprise Meta>Environment (EME)'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Metadata Hub'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Cloud Storage'
    },
    {
        'vendor': 'Pavilion Data Systems, Inc.',
        'product': 'Pavilion'
    },
    {
        'vendor': 'OSIsoft, LLC',
        'product': 'PI'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Query>It'
    },
    {
        'vendor': 'Talend, Inc.',
        'product': 'Talend Stitch'
    },
    {
        'vendor': 'Ab Initio Software, LLC',
        'product': 'Test Data Management (TDM)'
    },
    {
        'vendor': 'Ataccama Corporation',
        'product': 'Ataccama ONE'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Database for MariaDB'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure SQL Managed Instance'
    },
    {
        'vendor': 'Cloudera, Inc.',
        'product': 'Cloudera (Unspecified Product)'
    },
    {
        'vendor': 'Adobe, Inc.',
        'product': 'Magento Business Intelligence'
    },
    {
        'vendor': 'Red Hat, Inc.',
        'product': 'NooBaa'
    },
    {
        'vendor': 'VMware, Inc.',
        'product': 'Pivotal Software'
    },
    {
        'vendor': 'TIBCO Software, Inc.',
        'product': 'SnappyData'
    },
    {
        'vendor': 'WekaIO, Inc.',
        'product': 'Weka.io'
    },
    {
        'vendor': 'Castellan Solutions',
        'product': 'Castellan'
    },
    {
        'vendor': 'Commvault Systems, Inc.',
        'product': 'Commvault Hyperscale X'
    },
    {
        'vendor': '1E, Ltd.',
        'product': '1E (Unspecified Product)'
    },
    {
        'vendor': '1E, Ltd.',
        'product': '1E Tachyon'
    },
    {
        'vendor': 'Accenture PLC',
        'product': 'Accenture Infrastructure Services'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Active Directory Certificate Services'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Global Traffic Manager'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai Media Services Live'
    },
    {
        'vendor': 'Altair Engineering, Inc.',
        'product': 'Altair Grid Engine'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Business Manager'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple Device Enrollment Program'
    },
    {
        'vendor': 'Armory, Inc.',
        'product': 'Armory'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Cloud?Formation'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure App Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure DNS Zones'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure NetApp Files'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Operational Insights'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Relay'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Service Fabric Mesh'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure SignalR Service'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Speech to Text'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Time Series Insights'
    },
    {
        'vendor': 'Barracuda Networks, Inc.',
        'product': 'Barracuda Sentinel'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'BMC Compuware Abend-AID'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'BMC Compuware File-AID'
    },
    {
        'vendor': 'Compuware Corporation',
        'product': 'BMC Compuware Hiperstation'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'CA Explore Performance Management'
    },
    {
        'vendor': 'Canonical, Ltd.',
        'product': 'Canonical Kubernetes'
    },
    {
        'vendor': 'CAST SA',
        'product': 'CAST'
    },
    {
        'vendor': 'tribe29 GmbH',
        'product': 'Checkmk'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Container Platform'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Software-Defined Access'
    },
    {
        'vendor': 'CloudBlue Technologies, Inc.',
        'product': 'CloudBlue'
    },
    {
        'vendor': 'Cloudify Platform, Ltd.',
        'product': 'Cloudify'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'CloudIQ'
    },
    {
        'vendor': 'Neverware, Inc.',
        'product': 'CloudReady'
    },
    {
        'vendor': 'BMC Software, Inc.',
        'product': 'Compuware'
    },
    {
        'vendor': 'Confluent, Inc.',
        'product': 'Confluent Cloud'
    },
    {
        'vendor': 'Cloud Native Computing Foundation',
        'product': 'Container Network Interface (CNI)'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'containerd'
    },
    {
        'vendor': 'Open Source',
        'product': 'Contiv'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'CoreDNS'
    },
    {
        'vendor': 'Open Source',
        'product': 'Cortex'
    },
    {
        'vendor': 'Elementl, Inc.',
        'product': 'Dagster'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'EdgeX Foundry'
    },
    {
        'vendor': 'Ensighten, Inc.',
        'product': 'Ensighten Manage'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'EVE-OS'
    },
    {
        'vendor': 'Flexera Software, LLC',
        'product': 'Flexera One'
    },
    {
        'vendor': 'FM:Systems Group, LLC',
        'product': 'FMS:Workplace'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint TRITON'
    },
    {
        'vendor': 'Global Switch, Ltd.',
        'product': 'Global Switch'
    },
    {
        'vendor': 'Google Cloud',
        'product': 'Google Cloud Memorystore'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Identity'
    },
    {
        'vendor': 'NetScout Systems, Inc.',
        'product': 'InfiniStreamNG'
    },
    {
        'vendor': 'PTC, Inc.',
        'product': 'KEPServerEX'
    },
    {
        'vendor': 'Lynx Software Technologies',
        'product': 'LynxOS-178'
    },
    {
        'vendor': 'Huayun Data Holding Group Company, Ltd.',
        'product': 'Maxta'
    },
    {
        'vendor': 'MinIO, Inc.',
        'product': 'MinIO'
    },
    {
        'vendor': 'TeamViewer GmbH',
        'product': 'Monitis'
    },
    {
        'vendor': 'Progress Software Corporation',
        'product': 'MOVEit Managed File Transfer (MFT)'
    },
    {
        'vendor': 'MxToolbox, Inc.',
        'product': 'MxToolbox Delivery Center'
    },
    {
        'vendor': 'Airspan Networks, Inc.',
        'product': 'Netspan'
    },
    {
        'vendor': 'Next4biz, Inc.',
        'product': 'Next4biz'
    },
    {
        'vendor': 'Open Source',
        'product': 'OllyDbg'
    },
    {
        'vendor': 'Open Source',
        'product': 'Open Application Model'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Covisint Connect'
    },
    {
        'vendor': 'OpenText Corporation',
        'product': 'OpenText Experience Platform'
    },
    {
        'vendor': 'Oracle Corporation',
        'product': 'Oracle Enterprise GRC'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Project Contour'
    },
    {
        'vendor': 'Rackspace US, Inc.',
        'product': 'Rackspace Data Center Colocation'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Business Technology Platform'
    },
    {
        'vendor': 'SAP SE',
        'product': 'SAP Conversational AI'
    },
    {
        'vendor': '\/n software, Inc.',
        'product': 'SecureBlackbox'
    },
    {
        'vendor': 'MT4 Technologia Ltda.',
        'product': 'senhasegura'
    },
    {
        'vendor': 'SOTI, Inc.',
        'product': 'SOTI (Unspecified Product)'
    },
    {
        'vendor': 'Planview, Inc.',
        'product': 'Spigit'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk On-Call'
    },
    {
        'vendor': 'NetApp, Inc.',
        'product': 'Spot.io'
    },
    {
        'vendor': 'Tenjin, Inc.',
        'product': 'Tenjin'
    },
    {
        'vendor': 'Thycotic Software, LLC',
        'product': 'Thycotic Privilege Manager'
    },
    {
        'vendor': 'Tor Project, Inc.',
        'product': 'Tor'
    },
    {
        'vendor': 'Virtana Corporation',
        'product': 'Virtana'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'WinDbg'
    },
    {
        'vendor': 'Shanghai ZStack Information Technology Company, Ltd.',
        'product': 'ZStack'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple macOS Big Sur'
    },
    {
        'vendor': 'Apple, Inc.',
        'product': 'Apple tvOS'
    },
    {
        'vendor': 'Open Source',
        'product': 'C'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'C# (C Sharp)'
    },
    {
        'vendor': 'F5 Networks, Inc.',
        'product': 'F5 TMOS'
    },
    {
        'vendor': 'The Apache Software Foundation',
        'product': 'Apache Atlas'
    },
    {
        'vendor': 'iManage, LLC',
        'product': 'iManage Records Manager'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Dynamic Data Masking'
    },
    {
        'vendor': 'Informatica, LLC',
        'product': 'Informatica Test Data Management'
    },
    {
        'vendor': 'Syrenis, Ltd.',
        'product': 'Cassie'
    },
    {
        'vendor': 'Cisco Systems, Inc.',
        'product': 'Cisco Talos'
    },
    {
        'vendor': 'Varonis Systems, Inc.',
        'product': 'DatAlert'
    },
    {
        'vendor': 'NETMONASTERY Network Security Pvt Ltd',
        'product': 'DNIF'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'Dotfuscator'
    },
    {
        'vendor': 'NETIKUS.NET, Ltd.',
        'product': 'EventSentry'
    },
    {
        'vendor': 'Forcepoint, LLC',
        'product': 'Forcepoint Email Security'
    },
    {
        'vendor': 'Imperva, Inc.',
        'product': 'Imperva SecureSphere Database Audit and Protection'
    },
    {
        'vendor': 'JSC Positive Technologies',
        'product': 'MaxPatrol SIEM'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Threat Intelligence Exchange'
    },
    {
        'vendor': 'OPSWAT, Inc.',
        'product': 'MetaDefender Core'
    },
    {
        'vendor': 'Palo Alto Networks, Inc.',
        'product': 'MineMeld'
    },
    {
        'vendor': 'Panaseer, Ltd.',
        'product': 'Panaseer Platform'
    },
    {
        'vendor': 'RiskRecon, Inc.',
        'product': 'RiskRecon'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Shield'
    },
    {
        'vendor': 'Security Compass Technologies, Ltd.',
        'product': 'SD Elements'
    },
    {
        'vendor': 'Siemplify',
        'product': 'Siemplify'
    },
    {
        'vendor': 'Silobreaker, Ltd.',
        'product': 'Silobreaker'
    },
    {
        'vendor': 'SolarWinds Worldwide, LLC',
        'product': 'SolarWinds Security Event Manager'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk (Unspecified Product)'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk SOAR'
    },
    {
        'vendor': 'ThreatModeler Software, Inc.',
        'product': 'ThreatModeler'
    },
    {
        'vendor': 'ThreatQuotient, Inc.',
        'product': 'ThreatQ'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Firewall'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Network Watcher'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike Falcon Prevent'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'DBArtisan'
    },
    {
        'vendor': 'Open Source',
        'product': 'GnuPG'
    },
    {
        'vendor': 'Intevation GmbH',
        'product': 'Gpg4win'
    },
    {
        'vendor': 'Webyog, Inc.',
        'product': 'Monyog'
    },
    {
        'vendor': 'SAS Institute, Inc.',
        'product': 'SAS Analytics'
    },
    {
        'vendor': 'Zoho Corporation Pvt Ltd',
        'product': 'Site24x7'
    },
    {
        'vendor': 'Splunk, Inc.',
        'product': 'Splunk Observability'
    },
    {
        'vendor': 'Open Source',
        'product': 'Stunnel'
    },
    {
        'vendor': 'Open Source',
        'product': 'VeraCrypt'
    },
    {
        'vendor': 'Wazuh, Inc.',
        'product': 'Wazuh'
    },
    {
        'vendor': 'Agent Video Intelligence, Ltd.',
        'product': 'Agent Vi'
    },
    {
        'vendor': 'AhnLab, Inc.',
        'product': 'AhnLab TrusGuard'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'Amazon Guard?Duty'
    },
    {
        'vendor': 'ANY.RUN, LLC',
        'product': 'ANY.RUN'
    },
    {
        'vendor': 'Atomist, Inc.',
        'product': 'Atomist'
    },
    {
        'vendor': 'Authentic8, Inc.',
        'product': 'Authentic8 Silo'
    },
    {
        'vendor': 'Basis Technology Corporation',
        'product': 'Autopsy'
    },
    {
        'vendor': 'Avalance Global Solutions',
        'product': 'Avalance'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Advanced Threat Protection'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Virtual Network'
    },
    {
        'vendor': 'Blueliv',
        'product': 'Blueliv'
    },
    {
        'vendor': 'Attivo Networks, Inc.',
        'product': 'BOTsink'
    },
    {
        'vendor': 'Bricata, Inc.',
        'product': 'Bricata'
    },
    {
        'vendor': 'Check Point Software Technologies, Ltd.',
        'product': 'Check Point DLP'
    },
    {
        'vendor': 'Open Source',
        'product': 'Clair'
    },
    {
        'vendor': 'The Linux Foundation',
        'product': 'Cloud Custodian'
    },
    {
        'vendor': 'Cofense, Inc.',
        'product': 'Cofense Triage'
    },
    {
        'vendor': 'Comodo Group, Inc.',
        'product': 'Comodo Antivirus'
    },
    {
        'vendor': 'Comodo Group, Inc.',
        'product': 'Comodo Certificate Manager'
    },
    {
        'vendor': 'Comodo Group, Inc.',
        'product': 'Comodo Endpoint Security Manager'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike (Unspecified Product)'
    },
    {
        'vendor': 'CrowdStrike, Inc.',
        'product': 'CrowdStrike Falcon Insight'
    },
    {
        'vendor': 'Cyberint Technologies, Ltd.',
        'product': 'Cyberint'
    },
    {
        'vendor': 'D3 Security Management Systems, Inc.',
        'product': 'D3 SOAR'
    },
    {
        'vendor': 'Dashlane SAS',
        'product': 'Dashlane'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Deep Discovery Inspector'
    },
    {
        'vendor': 'Dell Technologies, Inc.',
        'product': 'Dell Data Protection Encryption'
    },
    {
        'vendor': 'Early Warning Services, LLC',
        'product': 'Early Warning'
    },
    {
        'vendor': 'Echosec Systems, Ltd.',
        'product': 'Echosec'
    },
    {
        'vendor': 'PrimeKey Solutions AB',
        'product': 'EJBCA'
    },
    {
        'vendor': 'empow Cyber Security, Inc.',
        'product': 'empow'
    },
    {
        'vendor': 'Entrust Corporation',
        'product': 'Entrust (Unspecified Product)'
    },
    {
        'vendor': 'eSentire, Inc.',
        'product': 'eSentire'
    },
    {
        'vendor': 'Falcongaze',
        'product': 'Falcongaze'
    },
    {
        'vendor': 'FireEye, Inc.',
        'product': 'FireEye Redline'
    },
    {
        'vendor': 'Fortanix, Inc.',
        'product': 'Fortanix'
    },
    {
        'vendor': 'G Data Software, Inc.',
        'product': 'G Data Software'
    },
    {
        'vendor': 'GIACT Systems, LLC',
        'product': 'GIACT'
    },
    {
        'vendor': 'Google Cloud',
        'product': 'Google Cloud DLP'
    },
    {
        'vendor': 'Google, LLC',
        'product': 'Google Sign-In'
    },
    {
        'vendor': 'Hdiv Security S.L.',
        'product': 'Hdiv'
    },
    {
        'vendor': 'Hex-Rays SA',
        'product': 'Hex-Rays'
    },
    {
        'vendor': 'HID Global Corporation',
        'product': 'HID ActivID'
    },
    {
        'vendor': 'Hybrid Analysis GmbH',
        'product': 'Hybrid Analysis'
    },
    {
        'vendor': 'HYPR Corporation',
        'product': 'HYPR'
    },
    {
        'vendor': 'IBM Corporation',
        'product': 'IBM X-Force Exchange'
    },
    {
        'vendor': 'ILANTUS Technologies Pvt Ltd',
        'product': 'Ilantus'
    },
    {
        'vendor': 'Immunity, Inc.',
        'product': 'Immunity Debugger'
    },
    {
        'vendor': 'Imprivata, Inc.',
        'product': 'Imprivata FairWarning'
    },
    {
        'vendor': 'Imprivata, Inc.',
        'product': 'Imprivata OneSign'
    },
    {
        'vendor': 'InfoWatch Group',
        'product': 'InfoWatch Traffic Monitor'
    },
    {
        'vendor': 'OneTrust, LLC',
        'product': 'Integris'
    },
    {
        'vendor': 'Rapid7, LLC',
        'product': 'IntSights'
    },
    {
        'vendor': 'IRONSCALES, Ltd.',
        'product': 'IRONSCALES'
    },
    {
        'vendor': 'Ivanti Software, Inc.',
        'product': 'Ivanti Device Control'
    },
    {
        'vendor': 'Open Source',
        'product': 'KeePass'
    },
    {
        'vendor': 'Keeper Security, Inc.',
        'product': 'Keeper Security'
    },
    {
        'vendor': 'Keybase',
        'product': 'Keybase'
    },
    {
        'vendor': 'Keyfactor, Inc.',
        'product': 'Keyfactor'
    },
    {
        'vendor': 'Idera, Inc.',
        'product': 'Kiuwan'
    },
    {
        'vendor': 'Magnet Forensics, Inc.',
        'product': 'Magnet IEF'
    },
    {
        'vendor': 'Mailinblack, LLC',
        'product': 'Mailinblack'
    },
    {
        'vendor': 'JSC Positive Technologies',
        'product': 'MaxPatrol 8'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Active Response'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Embedded Control'
    },
    {
        'vendor': 'McAfee, LLC',
        'product': 'McAfee Global Threat Intelligence (GTI)'
    },
    {
        'vendor': 'Mocana Corporation',
        'product': 'Mocana'
    },
    {
        'vendor': 'NetSPI, LLC',
        'product': 'NetSPI'
    },
    {
        'vendor': 'NowSecure, Inc.',
        'product': 'NowSecure'
    },
    {
        'vendor': 'Open Source',
        'product': 'OpenSSH'
    },
    {
        'vendor': 'Orca Security, Ltd.',
        'product': 'Orca Security Platform'
    },
    {
        'vendor': 'PacketViper, LLC',
        'product': 'PacketViper'
    },
    {
        'vendor': 'WatchGuard Technologies, Inc.',
        'product': 'Panda Adaptive Defense 360'
    },
    {
        'vendor': 'WatchGuard Technologies, Inc.',
        'product': 'Panda Endpoint Protection'
    },
    {
        'vendor': 'Parrot Security CIC',
        'product': 'Parrot OS'
    },
    {
        'vendor': 'BeyondTrust Corporation',
        'product': 'Password Safe'
    },
    {
        'vendor': 'Ping Identity Corporation',
        'product': 'PingOne'
    },
    {
        'vendor': 'BIO-key International, Inc.',
        'product': 'PortalGuard'
    },
    {
        'vendor': 'JSC Positive Technologies',
        'product': 'Positive Technologies (Unspecified Product)'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Email Protection'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Threat Response'
    },
    {
        'vendor': 'Proofpoint, Inc.',
        'product': 'Proofpoint Threat Response Auto-Pull'
    },
    {
        'vendor': 'Zeltser Security Corporation',
        'product': 'REMnux'
    },
    {
        'vendor': 'RiskLens, Inc.',
        'product': 'RiskLens'
    },
    {
        'vendor': 'SCYTHE, Inc.',
        'product': 'SCYTHE'
    },
    {
        'vendor': 'Sectigo, Ltd.',
        'product': 'Sectigo'
    },
    {
        'vendor': 'Security Onion Solutions, LLC',
        'product': 'Security Onion'
    },
    {
        'vendor': 'ShiftLeft, Inc.',
        'product': 'ShiftLeft'
    },
    {
        'vendor': 'Smoothwall, Ltd.',
        'product': 'Smoothwall'
    },
    {
        'vendor': 'SonicWall, Inc.',
        'product': 'SonicWall Email Security'
    },
    {
        'vendor': 'Sophos, Ltd.',
        'product': 'Sophos MTR'
    },
    {
        'vendor': 'Veracode, Inc.',
        'product': 'SourceClear'
    },
    {
        'vendor': 'SpyCloud, Inc.',
        'product': 'SpyCloud'
    },
    {
        'vendor': 'Datadog, Inc.',
        'product': 'Sqreen'
    },
    {
        'vendor': 'Broadcom, Inc.',
        'product': 'Symantec Endpoint Security'
    },
    {
        'vendor': 'Thycotic Software, LLC',
        'product': 'Thycotic (Unspecified Product)'
    },
    {
        'vendor': 'TokenEx, Inc.',
        'product': 'TokenEx'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro Email Security'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro Endpoint Encryption'
    },
    {
        'vendor': 'Trend Micro, Inc.',
        'product': 'Trend Micro InterScan Messaging Security'
    },
    {
        'vendor': 'Trustwave Holdings, Inc.',
        'product': 'Trustwave DbProtect'
    },
    {
        'vendor': 'Unisys Corporation',
        'product': 'Unisys Stealth'
    },
    {
        'vendor': 'AT&T, Inc.',
        'product': 'USM Anywhere'
    },
    {
        'vendor': 'Virtru Corporation',
        'product': 'Virtru'
    },
    {
        'vendor': 'Google Cloud',
        'product': 'VPC Service Controls'
    },
    {
        'vendor': 'Waratek, Ltd.',
        'product': 'Waratek'
    },
    {
        'vendor': 'Wiz, Inc.',
        'product': 'Wiz'
    },
    {
        'vendor': 'Open Source',
        'product': 'Xplico'
    },
    {
        'vendor': 'JSC Positive Technologies',
        'product': 'XSpider'
    },
    {
        'vendor': 'Accela, Inc.',
        'product': 'Accela Civic Platform'
    },
    {
        'vendor': 'Casepoint, LLC',
        'product': 'Casepoint'
    },
    {
        'vendor': 'Onit, Inc.',
        'product': 'Onit'
    },
    {
        'vendor': 'Avalara, Inc.',
        'product': 'Avalara CertCapture'
    },
    {
        'vendor': 'Bottomline Technologies (de), Inc.',
        'product': 'Bottomline Transform Suite'
    },
    {
        'vendor': 'Workiva, Inc.',
        'product': 'Workiva Wdesk'
    },
    {
        'vendor': 'Akamai Technologies, Inc.',
        'product': 'Akamai NetStorage'
    },
    {
        'vendor': 'Microsoft Corporation',
        'product': 'Azure Media Services'
    },
    {
        'vendor': 'Box, Inc.',
        'product': 'Box Platform'
    },
    {
        'vendor': 'Box, Inc.',
        'product': 'Box Relay'
    },
    {
        'vendor': 'Broadly, Inc.',
        'product': 'Broadly'
    },
    {
        'vendor': 'Comscore, Inc.',
        'product': 'Comscore MMX'
    },
    {
        'vendor': 'Episerver, Inc.',
        'product': 'Episerver DXP'
    },
    {
        'vendor': 'Kentico Software s.r.o.',
        'product': 'Kentico Xperience'
    },
    {
        'vendor': 'Objective Corporation, Ltd.',
        'product': 'Objective (Unspecified Product)'
    },
    {
        'vendor': 'Objective Corporation, Ltd.',
        'product': 'Objective ECM'
    },
    {
        'vendor': 'Salesforce.com, Inc.',
        'product': 'Salesforce Experience Cloud'
    },
    {
        'vendor': 'Squiz Australia Pty. Ltd.',
        'product': 'Squiz Matrix'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Calibre'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Calibre nmDRC'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Calibre nmLVS'
    },
    {
        'vendor': 'Siemens AG',
        'product': 'Siemens Calibre xRC'
    },
    {
        'vendor': 'Amazon Web Services, Inc.',
        'product': 'AWS Resource Access Manager'
    },
    {
        'vendor': 'Guidewire Software, Inc.',
        'product': 'BillingCenter'
    },
    {
        'vendor': 'Guidewire Software, Inc.',
        'product': 'ClaimCenter'
    },
    {
        'vendor': 'Configit A/S',
        'product': 'Configit'
    },
    {
        'vendor': 'DBS, Inc.',
        'product': 'Digital Dining'
    },
    {
        'vendor': 'FiscalNote, Inc.',
        'product': 'FiscalNote CQ'
    },
    {
        'vendor': 'GE Digital',
        'product': 'GE Digital ADMS'
    },
    {
        'vendor': 'Huawei Technologies Company, Ltd.',
        'product': 'Huawei Convergent Billing System'
    },
    {
        'vendor': 'Guidewire Software, Inc.',
        'product': 'PolicyCenter'
    },
    {
        'vendor': 'Experian Information Solutions, Inc.',
        'product': 'QuickAddress Pro'
    },
    {
        'vendor': 'Rev.com, Inc.',
        'product': 'Rev Pro'
    },
    {
        'vendor': 'Spring Care, Inc.',
        'product': 'Spring Health'
    },
    {
        'vendor': 'Syscon Justice Systems, Ltd.',
        'product': 'Syscon'
    },
    {
        'vendor': 'Tulip Interfaces, Inc.',
        'product': 'Tulip Operations Platform'
    },
    {
        'vendor': 'Yardi Systems, Inc.',
        'product': 'Yardi Energy Suite'
    },
    {
        'vendor': 'Early Warning Services, LLC',
        'product': 'Zelle'
    }
];

@Injectable({
    providedIn: 'root'
})
export class TechIntelVendorProductDataService {
    constructor(private baseApiService: BaseApiService) {}

    getTechIntelVendorProductData(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/techno/products', { showError: true });
    }
}
